export const Learnsets: {[k: string]: ModdedLearnsetData} = {
	bulbasaur: {
		inherit: true,
		learnset: {
			amnesia: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			block: ["5S3"],
			bodyslam: ["7V", "3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			celebrate: ["6S5"],
			charm: ["7E", "6E", "5E", "4E", "3E"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["7L27", "7V", "6L27", "5L27", "4L27", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["5S3"],
			flash: ["6M", "5M", "4M", "3M"],
			frenzyplant: ["5S3"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			grasswhistle: ["7E", "6E", "5E", "4E", "3E"],
			grassyterrain: ["7E", "6E"],
			growl: ["7L3", "7V", "6L3", "6S4", "6S5", "5L3", "5S2", "4L3", "3L4", "3S1"],
			growth: ["7L25", "7V", "6L25", "5L25", "4L25", "3L32", "3S0"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			ingrain: ["7E", "6E", "5E", "4E"],
			knockoff: ["6T", "5T", "4T"],
			leafstorm: ["7E", "6E", "5E", "4E"],
			leechseed: ["7V", "6L7", "6S4", "5L7", "5S2", "4L7", "3L7", "3S1"],
			lightscreen: ["7M", "6M", "5M", "4E", "3E"],
			magicalleaf: ["7E", "6E", "5E", "4E", "3E"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "7E", "6M", "6E", "5E", "4E"],
			petaldance: ["7E", "6E", "5E", "4E", "3E"],
			poisonpowder: ["7L13", "7V", "6L13", "6S4", "5L13", "4L13", "3L15"],
			powerwhip: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			razorleaf: ["7L19", "7V", "6L19", "5L19", "4L19", "3L20"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["7L37", "6T", "6L37", "5T", "5L37", "4T", "4L37"],
			skullbash: ["7E", "6E", "5E", "4E", "3E"],
			sleeppowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L15"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludge: ["7E", "6E", "5E", "4E"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M", "3L46", "3S0"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L21", "6L21", "5L21", "4L21", "3L25", "3S0"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["7L33", "6T", "6L33", "5T", "5L33", "4T", "4L33", "3L39", "3S0"],
			tackle: ["7L1", "7V", "6L1", "6S5", "5L1", "5S2", "4L1", "3L1", "3S1"],
			takedown: ["7L15", "7V", "6L15", "5L15", "4L15"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			vinewhip: ["7L9", "7L7", "7V", "6L9", "6S4", "5L9", "5S2", "4L9", "3L10", "3S1"],
			weatherball: ["5S3"],
			workup: ["7M"],
			worryseed: ["7L31", "6T", "6L31", "5T", "5L31", "4T", "4L31"],
		},
	},
	ivysaur: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			bodyslam: ["7V", "3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["7L31", "7V", "6L31", "5L31", "4L31", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			growl: ["7L3", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			growth: ["7L28", "7V", "6L28", "5L28", "4L28", "3L38"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			leechseed: ["7L7", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			poisonpowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L15"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			razorleaf: ["7L20", "7V", "6L20", "5L20", "4L20", "3L22"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeppowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L15"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L44", "7V", "6M", "6L44", "5M", "5L44", "4M", "4L44", "3M", "3L56"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L23", "6L23", "5L23", "4L23", "3L29"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["7L39", "6T", "6L39", "5T", "5L39", "4T", "4L39", "3L47"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L15", "7V", "6L15", "5L15", "4L15"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			vinewhip: ["7L9", "7V", "6L9", "5L9", "4L9", "3L10"],
			workup: ["7M"],
			worryseed: ["7L36", "6T", "6L36", "5T", "5L36", "4T", "4L36"],
		},
	},
	venusaur: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7V", "3T"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["7L31", "7V", "6L31", "5L31", "4L31", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frenzyplant: ["7T", "6T", "6S0", "5T", "4T", "3T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "6S0", "5T"],
			growl: ["7L3", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			growth: ["7L28", "7V", "6L28", "5L28", "4L28", "3L41"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			leechseed: ["7L7", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			outrage: ["6T", "5T", "4T"],
			petalblizzard: ["7L50", "6L50"],
			petaldance: ["7L1", "6L32", "5L32", "4L32"],
			poisonpowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L15"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			razorleaf: ["7L20", "7V", "6L20", "5L20", "4L20", "3L22"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeppowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L15"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L53", "7V", "6M", "6L53", "6S0", "5M", "5L53", "4M", "4L53", "3M", "3L65"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L23", "6L23", "5L23", "4L23", "3L29"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["7L45", "6T", "6L45", "6S0", "5T", "5L45", "4T", "4L45", "3L53"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L15", "7V", "6L15", "5L15", "4L15"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			vinewhip: ["7L9", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			workup: ["7M"],
			worryseed: ["7L39", "6T", "6L39", "5T", "5L39", "4T", "4L39"],
		},
	},
	charmander: {
		inherit: true,
		learnset: {
			acrobatics: ["5S6"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["7E", "6E"],
			ancientpower: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			beatup: ["7E", "6E", "5E", "4E", "3E"],
			bellydrum: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7V"],
			bite: ["7E", "6E", "5E", "4E", "3E"],
			blastburn: ["5S6"],
			block: ["5S6"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			celebrate: ["6S8"],
			confide: ["7M", "6M"],
			counter: ["7E", "7V", "6E", "5E", "4E", "3T"],
			crunch: ["7E", "6E", "5E", "4E"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragondance: ["7E", "6E", "5E", "4E", "3E"],
			dragonpulse: ["7E", "6T", "6E", "5E"],
			dragonrage: ["7L16", "7V", "6L16", "6S7", "5L16", "4L16", "3L43"],
			dragonrush: ["7E", "6E", "5E", "4E"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L7", "7V", "6L7", "6S7", "5L7", "5S4", "4L7", "3L7", "3S0"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["5S6"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firefang: ["7L25", "6L25", "5L25", "4L25"],
			firepledge: ["7T", "6T", "5T"],
			firepunch: ["6T", "5T", "4T", "3T"],
			firespin: ["7L43", "7V", "6L43", "5L43", "4L37", "3L49"],
			flameburst: ["7L28", "6L28", "5L28"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L37", "7V", "6M", "6L37", "5M", "5L37", "4M", "4L34", "3M", "3L31"],
			flareblitz: ["7E", "6E", "5E", "4E"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["7E", "6T", "6E", "5E", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["7L1", "7V", "6L1", "6S7", "6S8", "5L1", "5S4", "4L1", "3L1", "3S0"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "4S1", "4S2", "4S3", "4S5", "3M"],
			honeclaws: ["6M", "5M"],
			howl: ["4S1", "4S2", "4S3", "4S5"],
			incinerate: ["6M", "5M"],
			inferno: ["7L46", "6L46", "5L46"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7V"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metalclaw: ["7E", "6E", "5E", "4E", "3L13"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["7E", "6E", "5T", "5E", "4E", "3E"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["4S1", "4S2", "4S3", "4S5"],
			rage: ["7V", "3L19"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "4S1", "4S2", "4S3", "4S5", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L19", "6L19", "5L19", "4L19", "3L25"],
			scratch: ["7L1", "7V", "6L1", "6S8", "5L1", "5S4", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			skullbash: ["7V"],
			slash: ["7L34", "7V", "6L34", "5L34", "4L28", "3L37"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smokescreen: ["7L10", "6L10", "6S7", "5L10", "5S4", "4L10", "3L13"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			takedown: ["7V"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M"],
		},
	},
	charmeleon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T"],
			dragonrage: ["7L17", "7V", "6L17", "5L17", "4L17", "3L48"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L7", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firefang: ["7L28", "6L28", "5L28", "4L28"],
			firepledge: ["7T", "6T", "5T"],
			firepunch: ["6T", "5T", "4T", "3T"],
			firespin: ["7L50", "7V", "6L50", "5L50", "4L43", "3L55"],
			flameburst: ["7L32", "6L32", "5L32"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L43", "7V", "6M", "6L43", "5M", "5L43", "4M", "4L39", "3M", "3L34"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			inferno: ["7L54", "6L54", "5L54"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7V"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metalclaw: ["3L13"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5T"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V", "3L20"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L21", "6L21", "5L21", "4L21", "3L27"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			skullbash: ["7V"],
			slash: ["7L39", "7V", "6L39", "5L39", "4L32", "3L41"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smokescreen: ["7L10", "6L10", "5L10", "4L10", "3L13"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M"],
		},
	},
	charizard: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["7L1", "6L1", "6S1", "6S2", "5L1", "4L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blastburn: ["7T", "6T", "6S4", "5T", "4T", "3T"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "7L1", "7S5", "6M", "6L1", "6S2", "5M", "5L1", "4M", "4L1", "3M"],
			dragondance: ["7S7"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrage: ["7L17", "7V", "7S5", "7S6", "6L17", "6S2", "5L17", "4L17", "3L54", "3S0"],
			dragontail: ["7M", "6M", "5M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "7V", "7S7", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L7", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firefang: ["7L28", "6L28", "6S1", "6S2", "5L28", "4L28"],
			firepledge: ["7T", "6T", "6S4", "5T"],
			firepunch: ["6T", "5T", "4T", "3T"],
			firespin: ["7L56", "7V", "6L56", "5L56", "4L49", "3L64", "3S0"],
			fissure: ["7V"],
			flameburst: ["7L32", "6L32", "6S1", "5L32"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L47", "7V", "7S6", "6M", "6L47", "5M", "5L47", "4M", "4L42", "3M", "3L34"],
			flareblitz: ["7L77", "7L1", "7S5", "7S7", "6L1", "6S4", "5L77", "4L66"],
			fling: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "7V", "7S5", "7S7", "6M", "5M", "4M", "3M"],
			focusblast: ["7M", "6M", "6S3", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["7L71", "7L1", "6T", "6L1", "5T", "5L71", "4T", "4L59", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			holdhands: ["6S3"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			inferno: ["7L62", "6L62", "6S1", "5L62"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7V"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metalclaw: ["3L1"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["6T", "5T", "4T"],
			overheat: ["7M", "6M", "6S3", "5M", "4M", "3M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V", "3L20"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L21", "6L21", "6S4", "5L21", "4L21", "3L27"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "7S6", "3T"],
			shadowclaw: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			skullbash: ["7V"],
			skydrop: ["7M", "6M", "5M"],
			slash: ["7L41", "7V", "7S6", "6L41", "5L41", "4L32", "3L44", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smokescreen: ["7L10", "6L1", "5L1", "4L1", "3L1"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "6S3", "5M", "4M"],
			steelwing: ["7M", "6M", "4M", "3M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
			wingattack: ["7L1", "6L36", "5L36", "4L36", "3L36", "3S0"],
			workup: ["7M"],
		},
	},
	squirtle: {
		inherit: true,
		learnset: {
			aquajet: ["7E", "6E", "5E", "4E"],
			aquaring: ["7E", "6E", "5E", "4E"],
			aquatail: ["7L28", "6T", "6L28", "5T", "5L28", "4T", "4L28"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurasphere: ["7E", "6E"],
			bide: ["7V"],
			bite: ["7L16", "7V", "6L16", "5L16", "4L16", "3L18"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			block: ["5S2"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["7E", "6E", "5E", "4M"],
			bubble: ["7L13", "7V", "6L13", "6S3", "5L7", "5S1", "4L7", "3L7", "3S0"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			celebrate: ["6S4"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			defensecurl: ["3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonpulse: ["7E", "6T", "6E"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "4E"],
			falseswipe: ["5S2"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			followme: ["5S2"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydrocannon: ["5S2"],
			hydropump: ["7L40", "7V", "6L40", "5L40", "4L37", "3L47"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["7L34", "6T", "6L34", "5T", "5L34", "4T", "4L34"],
			irontail: ["6T", "5T", "4M", "3M"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mirrorcoat: ["7E", "6E", "5E", "4E", "3E"],
			mist: ["7E", "6E", "5E", "4E", "3E"],
			muddywater: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "7L22", "6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L28"],
			rage: ["7V"],
			raindance: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L34", "3M", "3L33"],
			rapidspin: ["7L19", "6L19", "5L19", "4L19", "3L23"],
			reflect: ["7V"],
			refresh: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			skullbash: ["7L31", "7V", "6L31", "5L31", "4L31", "3L40"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "7V", "6L1", "6S4", "5L1", "5S1", "4L1", "3L1", "3S0"],
			tailwhip: ["7L4", "7V", "6L4", "6S3", "6S4", "5L4", "5S1", "4L4", "3L4", "3S0"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L7", "7V", "6L7", "6S3", "5L13", "4L13", "3L13"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["7L25", "6T", "6L25", "5L25", "4M", "4L25", "3M"],
			waterspout: ["7E", "6E", "5E", "4E"],
			whirlpool: ["4M"],
			withdraw: ["7L10", "7V", "6L10", "6S3", "5L10", "5S1", "4L10", "3L10", "3S0"],
			workup: ["7M"],
			yawn: ["7E", "6E", "5E", "4E", "3E"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	wartortle: {
		inherit: true,
		learnset: {
			aquatail: ["7L33", "6T", "6L32", "5T", "5L32", "4T", "4L32"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L17", "7V", "6L16", "5L16", "4L16", "3L19"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bubble: ["7L13", "7V", "6L13", "5L1", "4L1", "3L1"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			defensecurl: ["3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L49", "7V", "6L48", "5L48", "4L44", "3L53"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["7L41", "6T", "6L40", "5T", "5L40", "4T", "4L40"],
			irontail: ["6T", "5T", "4M", "3M"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "7L25", "6M", "6L24", "5M", "5L24", "4M", "4L24", "3M", "3L31"],
			rage: ["7V"],
			raindance: ["7M", "7L45", "6M", "6L44", "5M", "5L44", "4M", "4L40", "3M", "3L37"],
			rapidspin: ["7L21", "6L20", "5L20", "4L20", "3L25"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			skullbash: ["7L37", "7V", "6L36", "5L36", "4L36", "3L45"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L7", "7L1", "7V", "6L1", "5L13", "4L13", "3L13"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["7L29", "6T", "6L28", "5L28", "4M", "4L28", "3M"],
			whirlpool: ["4M"],
			withdraw: ["7L10", "7V", "6L10", "5L10", "4L10", "3L10"],
			workup: ["7M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	blastoise: {
		inherit: true,
		learnset: {
			aquatail: ["7L33", "6T", "6L32", "5T", "5L32", "4T", "4L32"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bide: ["7V"],
			bite: ["7L17", "7V", "6L16", "5L16", "4L16", "3L19"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bubble: ["7L13", "7V", "6L13", "5L1", "4L1", "3L1"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			darkpulse: ["7M", "6M"],
			defensecurl: ["3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T"],
			dragontail: ["7M", "6M", "5M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7V"],
			flashcannon: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydrocannon: ["7T", "6T", "6S1", "5T", "4T", "3T"],
			hydropump: ["7L60", "7V", "6L60", "6S1", "5L60", "4L53", "3L68", "3S0"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["7L47", "6T", "6L46", "6S1", "5T", "5L46", "4T", "4L46"],
			irontail: ["6T", "5T", "4M", "3M"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["7M", "7L25", "6M", "6L24", "5M", "5L24", "4M", "4L24", "3M", "3L31", "3S0"],
			rage: ["7V"],
			raindance: ["7M", "7L54", "6M", "6L53", "5M", "5L53", "4M", "4L46", "3M", "3L42", "3S0"],
			rapidspin: ["7L21", "6L20", "5L20", "4L20", "3L25"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			signalbeam: ["6T", "5T", "4T"],
			skullbash: ["7L40", "7V", "6L39", "5L39", "4L39", "3L55", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L7", "7L1", "7V", "6L1", "5L13", "4L13", "3L13"],
			waterpledge: ["7T", "6T", "6S1", "5T"],
			waterpulse: ["7L29", "6T", "6L28", "5L28", "4M", "4L28", "3M"],
			whirlpool: ["4M"],
			withdraw: ["7L10", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			workup: ["7M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	caterpie: {
		inherit: true,
		learnset: {
			bugbite: ["7L9", "6T", "6L15", "5T", "5L15", "4T", "4L15"],
			electroweb: ["6T", "5T"],
			snore: ["6T", "5T", "4T"],
			stringshot: ["7L1", "7V", "6L1", "5L1", "4T", "4L1", "3L1"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	metapod: {
		inherit: true,
		learnset: {
			bugbite: ["6T", "5T", "4T"],
			electroweb: ["6T", "5T"],
			harden: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			irondefense: ["6T", "5T", "4T"],
			stringshot: ["4T"],
		},
	},
	butterfree: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			aircutter: ["5D", "4T"],
			airslash: ["7L43"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L31", "6L42", "5L42", "4L40"],
			captivate: ["7L37", "6L40", "5L40", "4M", "4L36"],
			confide: ["7M", "6M"],
			confusion: ["7L11", "7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			electroweb: ["6T", "5T"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L1", "7V", "6L16", "5L16", "4L16", "3L28"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			morningsun: ["3S0"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			poisonpowder: ["7L13", "7V", "6L12", "5L12", "4L12", "3L13"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L17", "7V", "6L24", "5L24", "4L24", "3L34"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M", "3S0"],
			psychup: ["7M", "6M", "5M", "4M"],
			psywave: ["7V"],
			quiverdance: ["7L47", "6L46", "5L46"],
			rage: ["7V"],
			ragepowder: ["7L35", "6L34", "5L34"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "5D", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L25", "6M", "6L36", "5M", "5L36", "4M", "4L34", "3M", "3L40"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["7L19", "6L28", "5L28", "4M", "4L28", "3L47"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeppowder: ["7L13", "7V", "6L12", "5L12", "4L12", "3L15", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["7L13", "7V", "6L12", "5L12", "4L12", "3L14"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L23", "7V", "6L18", "5L18", "4L18", "3L18"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwind: ["7L41", "6T", "6L30", "5T", "5L30", "4T", "4L30"],
			takedown: ["7V"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			venoshock: ["7M", "6M", "5M"],
			whirlwind: ["7L29", "7V", "6L22", "5L22", "4L22", "3L23"],
		},
	},
	weedle: {
		inherit: true,
		learnset: {
			bugbite: ["7L9", "6T", "6L15", "5T", "5L15", "4T", "4L15"],
			electroweb: ["6T", "5T"],
			poisonsting: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			stringshot: ["7L1", "7V", "6L1", "5L1", "4T", "4L1", "3L1"],
		},
	},
	kakuna: {
		inherit: true,
		learnset: {
			bugbite: ["6T", "5T", "4T"],
			electroweb: ["6T", "5T"],
			harden: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			irondefense: ["6T", "5T", "4T"],
			stringshot: ["4T"],
		},
	},
	beedrill: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L38", "7V", "6L31", "5L31", "4L31", "3L40"],
			aircutter: ["5D", "4T"],
			assurance: ["7L26", "6L34", "5L34", "4L34"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			bide: ["7V"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bugbite: ["6T", "5T", "4T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillrun: ["6T", "5T"],
			electroweb: ["6T", "5T"],
			endeavor: ["7L41", "6T", "6L40", "5T", "5L40", "4T", "4L40", "3L45"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			fellstinger: ["7L44", "6L45"],
			flash: ["6M", "5M", "4M"],
			focusenergy: ["7L20", "7V", "6L13", "5L13", "4L13", "3L15"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L11", "7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			furycutter: ["5D", "4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			knockoff: ["6T", "5T", "4T"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			pinmissile: ["7L32", "7V", "6L28", "5L28", "4L28", "3L35"],
			poisonjab: ["7M", "7L35", "6M", "6L37", "5M", "5L37", "4M", "4L37"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L17", "6L22", "5L22", "4L22", "3L30"],
			rage: ["7L14", "7V", "6L19", "5L19", "4L19", "3L25"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			silverwind: ["4M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T", "3S0"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7L29", "6L25", "5L25", "4L25"],
			twineedle: ["7L1", "7V", "6L16", "5L16", "4L16", "3L20", "3S0"],
			uturn: ["7M", "6M", "5M", "4M"],
			venoshock: ["7M", "7L23", "6M", "5M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	pidgey: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L29", "7V", "6L29", "5L29", "4L29", "3L39"],
			aircutter: ["7E", "6E", "5E", "4T", "4E", "3E"],
			airslash: ["7L49", "7E", "6L49", "6E", "5L49", "5E", "4L49", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bravebird: ["7E", "6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["7E", "6E", "5E", "4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			featherdance: ["7L25", "6L25", "5L25", "4L25", "3L31"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gust: ["7L9", "7V", "6L9", "5L9", "5D", "4L9", "3L9"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7L53", "6L53", "5L53"],
			mimic: ["7V", "3T"],
			mirrormove: ["7L45", "7V", "6L45", "5L45", "4L45", "3L47"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			quickattack: ["7L13", "7V", "6L13", "5L13", "4L13", "3L13"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7L37", "6M", "6L37", "5T", "5L37", "4M", "4L37"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "7V", "6L5", "5L5", "4L5", "3L5"],
			secretpower: ["6M", "5D", "4M", "3M"],
			skyattack: ["7V", "6T", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "5D", "4M", "4E", "3M", "3E"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwind: ["7L41", "6T", "6L41", "5T", "5L41", "4T", "4L41"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["7L21", "6L21", "5L21", "4T", "4L21"],
			uproar: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7L17", "7V", "6L17", "5L17", "4L17", "3L19"],
			wingattack: ["7L33", "7V", "6L33", "5L33", "4L33", "3L25"],
			workup: ["7M", "5M"],
		},
	},
	pidgeotto: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L32", "7V", "6L32", "5L32", "4L32", "3L43"],
			aircutter: ["4T"],
			airslash: ["7L57", "6L57", "5L57", "4L57"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			featherdance: ["7L27", "6L27", "5L27", "4L27", "3L34", "3S0"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gust: ["7L9", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7L62", "6L62", "5L62"],
			mimic: ["7V", "3T"],
			mirrormove: ["7L52", "7V", "6L52", "5L52", "4L52", "3L52"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L13", "7V", "6L13", "5L13", "4L13", "3L13"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			reflect: ["7V"],
			refresh: ["3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7L42", "6M", "6L42", "5T", "5L42", "4M", "4L42"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["7V", "6T", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M", "3S0"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwind: ["7L47", "6T", "6L47", "5T", "5L47", "4T", "4L47"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["7L22", "6L22", "5L22", "4T", "4L22"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7L17", "7V", "6L17", "5L17", "4L17", "3L20"],
			wingattack: ["7L37", "7V", "6L37", "5L37", "4L37", "3L27", "3S0"],
			workup: ["7M", "5M"],
		},
	},
	pidgeot: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L32", "7V", "6L32", "5L32", "4L32", "3L48"],
			aircutter: ["4T"],
			airslash: ["7L62", "6L62", "5L62", "4L62"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			featherdance: ["7L27", "6L27", "5L27", "4L27", "3L34"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L9", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7L68", "7L1", "6L1", "5L68"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			mimic: ["7V", "3T"],
			mirrormove: ["7L56", "7V", "6L56", "5L56", "5S0", "4L56", "3L62"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L13", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7L44", "6M", "6L44", "5T", "5L44", "4M", "4L44"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["7V", "6T", "5T", "5S0", "4T", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwind: ["7L50", "6T", "6L50", "5T", "5L50", "4T", "4L50"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["7L22", "6L22", "5L22", "4T", "4L22"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7L17", "7V", "6L17", "5L17", "5S0", "4L17", "3L20"],
			wingattack: ["7L38", "7V", "6L38", "5L38", "5S0", "4L38", "3L27"],
			workup: ["7M", "5M"],
		},
	},
	rattata: {
		inherit: true,
		learnset: {
			assurance: ["7L19", "6L25", "5L25", "4L25"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L10", "7E", "6L10", "6E", "5L10", "5E", "4L10", "4E", "3E"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			covet: ["6T", "5T"],
			crunch: ["7L22", "6L22", "5L22", "4L22"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7L31", "7V", "6L31", "5L31", "4L31", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endeavor: ["7L34", "6T", "6L34", "5T", "5L34", "4T", "4L34", "3L41"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			finalgambit: ["7E", "6E", "5E"],
			flamewheel: ["7E", "6E", "5E", "4E", "3E"],
			focusenergy: ["7L7", "7V", "6L7", "5L7", "4L7", "3L20"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7E", "6E", "5E", "4E", "3E"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperfang: ["7L16", "7V", "6L16", "5L16", "4L16", "3L13"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "5D", "4M", "3M"],
			lastresort: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			mefirst: ["7E", "6E", "5E", "5D", "4E"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L13", "6L13", "5L13", "4L13", "3L27"],
			quickattack: ["7L4", "7V", "6L4", "5L4", "5D", "4L4", "3L7"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7E", "6E", "5E"],
			reversal: ["7E", "6E", "5E", "4E", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L25", "6L19", "5L19", "4T", "4L19"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["7L28", "7V", "6T", "6L28", "5T", "5L28", "4T", "4L28", "3L34"],
			swagger: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["7E", "6T", "6E", "5T", "5E", "4E", "3E"],
			uturn: ["7M", "6M", "5M", "4M"],
			watergun: ["7V"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	rattataalola: {
		inherit: true,
		learnset: {
			assurance: ["7L19"],
			attract: ["7M"],
			bite: ["7L10"],
			blizzard: ["7M"],
			confide: ["7M"],
			counter: ["7E"],
			crunch: ["7L22"],
			darkpulse: ["7M"],
			doubleedge: ["7L31"],
			doubleteam: ["7M"],
			embargo: ["7M"],
			endeavor: ["7L34"],
			facade: ["7M"],
			finalgambit: ["7E"],
			focusenergy: ["7L7"],
			frustration: ["7M"],
			furyswipes: ["7E"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			hyperfang: ["7L16"],
			icebeam: ["7M"],
			mefirst: ["7E"],
			protect: ["7M"],
			pursuit: ["7L13"],
			quash: ["7M"],
			quickattack: ["7L4"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			revenge: ["7E"],
			reversal: ["7E"],
			round: ["7M"],
			shadowball: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			snarl: ["7M"],
			snatch: ["7E"],
			stockpile: ["7E"],
			substitute: ["7M"],
			suckerpunch: ["7L25"],
			sunnyday: ["7M"],
			superfang: ["7L28"],
			swagger: ["7M"],
			swallow: ["7E"],
			switcheroo: ["7E"],
			tackle: ["7L1"],
			tailwhip: ["7L1"],
			taunt: ["7M"],
			thief: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			uproar: ["7E"],
			uturn: ["7M"],
		},
	},
	raticate: {
		inherit: true,
		learnset: {
			assurance: ["7L19", "6L29", "5L29", "4L29"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L10", "6L10", "5L10", "4L10"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			bubblebeam: ["7V"],
			bulkup: ["7M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			crunch: ["7L24", "6L24", "5L24", "4L24"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M"],
			defensecurl: ["3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7L39", "7V", "6L39", "5L39", "4L39", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			embargo: ["7M"],
			endeavor: ["7L44", "6T", "6L44", "5T", "5L44", "4T", "4L44", "3L50"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			focusenergy: ["7L7", "7L1", "7V", "6L1", "5L1", "4L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hyperfang: ["7L16", "7V", "6L16", "5L16", "4L16", "3L13", "3S0"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L13", "6L13", "5L13", "4L13", "3L30"],
			quash: ["7M"],
			quickattack: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L1", "6L20", "5L20", "4L20", "3L20", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			snarl: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L29", "6L19", "5L19", "4T", "4L19"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["7L34", "7V", "6T", "6L34", "5T", "5L34", "4T", "4L34", "3L40", "3S0"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			swordsdance: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M", "4M"],
			venoshock: ["7M"],
			watergun: ["7V"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	raticatealola: {
		inherit: true,
		learnset: {
			assurance: ["7L19"],
			attract: ["7M"],
			bite: ["7L10"],
			blizzard: ["7M"],
			bulkup: ["7M"],
			confide: ["7M"],
			crunch: ["7L24"],
			darkpulse: ["7M"],
			doubleedge: ["7L39"],
			doubleteam: ["7M"],
			embargo: ["7M"],
			endeavor: ["7L44"],
			facade: ["7M"],
			focusenergy: ["7L7", "7L1"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			hyperfang: ["7L16"],
			icebeam: ["7M"],
			protect: ["7M"],
			pursuit: ["7L13"],
			quash: ["7M"],
			quickattack: ["7L4", "7L1"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			round: ["7M"],
			scaryface: ["7L1"],
			shadowball: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			snarl: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L29"],
			sunnyday: ["7M"],
			superfang: ["7L34"],
			swagger: ["7M"],
			swordsdance: ["7M", "7L1"],
			tackle: ["7L1"],
			tailwhip: ["7L1"],
			taunt: ["7M"],
			thief: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			venoshock: ["7M"],
		},
	},
	spearow: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L15", "6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L25", "3S0"],
			agility: ["7L25", "7V", "6L25", "5L25", "4L25", "3L43"],
			aircutter: ["4T"],
			assurance: ["7L22", "6L29", "5L29", "4L29"],
			astonish: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			bide: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillpeck: ["7L36", "7V", "6L37", "5L37", "4L37", "3L37"],
			drillrun: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4E", "3E", "3S0"],
			featherdance: ["7E", "6E", "5E", "4E"],
			feintattack: ["7E", "6E", "5E", "5D", "4E", "3E"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			focusenergy: ["7L29"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L11", "7V", "6L9", "5L9", "4L9", "3L13"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			leer: ["7L4", "7V", "6L5", "5L5", "4L5", "3L7", "3S0"],
			mimic: ["7V", "3T"],
			mirrormove: ["7L18", "7V", "6L21", "5L21", "4L21", "3L31"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L8", "6L13", "5L13", "4L13", "3L19"],
			quickattack: ["7E", "6E", "5E", "4E", "3E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7E", "7V", "6E", "5E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7L32", "6M", "6L33", "5T", "5L33", "4M", "4L33"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["7E", "7V", "6T", "6E", "5T", "5E", "4E", "3T", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "5D", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7E", "6E", "5E", "4E", "3E"],
			twister: ["4T"],
			uproar: ["7E", "6T", "6E", "5T", "5E", "4E"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7E", "7V", "6E", "5E", "4E"],
			workup: ["7M", "5M"],
		},
	},
	fearow: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L15", "6M", "6L17", "5M", "5L17", "4M", "4L17", "3M"],
			agility: ["7L27", "7V", "6L29", "5L29", "4L29", "3L47"],
			aircutter: ["4T"],
			assurance: ["7L23", "6L35", "5L35", "4L35"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillpeck: ["7L41", "7V", "6L47", "5L47", "4L47", "3L40"],
			drillrun: ["7L45", "7L1", "6T", "6L1", "5T", "5L53"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			focusenergy: ["7L32"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L11", "7V", "6L1", "5L1", "4L1", "3L1"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			leer: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["7V", "3T"],
			mirrormove: ["7L18", "7V", "6L23", "5L23", "4L23", "3L32"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			pluck: ["7L1", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L8", "7L1", "6L13", "5L13", "4L13", "3L26"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7L36", "6M", "6L41", "5T", "5L41", "4M", "4L41"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["7V", "6T", "5T", "4T", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7V"],
			workup: ["7M", "5M"],
		},
	},
	ekans: {
		inherit: true,
		learnset: {
			acid: ["7L20", "7V", "6L20", "5L20", "4L20", "3L32"],
			acidspray: ["7L28", "6L28", "5L28"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			beatup: ["7E", "6E", "5E", "5D", "4E", "3E"],
			belch: ["7L38", "6L38"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			bite: ["7L9", "7V", "6L9", "5L9", "4L9", "3L13", "3S0"],
			bodyslam: ["7V", "3T"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			coil: ["7L44", "6L44", "5L44"],
			confide: ["7M", "6M"],
			darkpulse: ["7M", "6M", "5T", "5D", "4M"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			disable: ["7E", "6E", "5E", "4E"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7V"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["7L36", "6T", "6L36", "5T", "5L36", "4T", "4L33"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			glare: ["7L12", "7V", "6L12", "5L12", "4L12", "3L20"],
			gunkshot: ["7L49", "6T", "6L49", "5T", "5L49", "4T", "4L41"],
			haze: ["7L41", "6L41", "5L41", "4L36", "3L44"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			mudbomb: ["7L33", "6L33", "5L33", "4L28"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonfang: ["7E", "6E", "5E", "4E", "3E"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L4", "7V", "6L4", "5L4", "5D", "4L4", "3L8", "3S0", "3S1"],
			poisontail: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7E", "6E", "5E", "4E"],
			screech: ["7L17", "7V", "6L17", "5L17", "4L17", "3L25"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			slam: ["7E", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			snatch: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			spitup: ["7L25", "6L25", "5L25", "4L25", "3L37"],
			stockpile: ["7L25", "6L25", "5L25", "4L25", "3L37"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7E", "6E", "5E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L25", "6L25", "5L25", "4L25", "3L37"],
			switcheroo: ["7E", "6E", "5E", "4E"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			wrap: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
		},
	},
	arbok: {
		inherit: true,
		learnset: {
			acid: ["7L20", "7V", "6L20", "5L20", "4L20", "3L38"],
			acidspray: ["7L32", "6L32", "5L32"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7L48", "6L48"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			bite: ["7L9", "7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0"],
			bodyslam: ["7V", "3T"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			coil: ["7L56", "6L56", "5L56"],
			confide: ["7M", "6M"],
			crunch: ["7L1", "6L22", "5L22", "4L22"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragontail: ["7M", "6M", "5M"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			fissure: ["7V"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["7L44", "6T", "6L44", "5T", "5L44", "4T", "4L42"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			glare: ["7L12", "7V", "6L12", "5L12", "4L12", "3L20", "3S0"],
			gunkshot: ["7L63", "6T", "6L63", "5T", "5L63", "4T", "4L56"],
			haze: ["7L51", "6L51", "5L51", "4L48", "3L56"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icefang: ["7L1", "6L1", "5L1", "4L1"],
			infestation: ["7M", "6M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			mudbomb: ["7L39", "6L39", "5L39", "4L34"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			screech: ["7L17", "7V", "6L17", "5L17", "4L17", "3L28"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			sludgewave: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			spitup: ["7L27", "6L27", "5L27", "4L28", "3L46"],
			stockpile: ["7L27", "6L27", "5L27", "4L28", "3L46"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L27", "6L27", "5L27", "4L28", "3L46"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			wrap: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	pichu: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bestow: ["7E", "6E", "5E"],
			bide: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["7E", "6E", "5E", "4E", "4S5", "3E"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1", "3S2", "3S3"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			defensecurl: ["3T"],
			disarmingvoice: ["7E", "6E"],
			doubleedge: ["3T"],
			doubleslap: ["7E", "6E", "5E", "4E", "3E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			electricterrain: ["7E"],
			electroweb: ["6T"],
			encore: ["7E", "6E", "5E", "4E", "3E"],
			endeavor: ["4S5"],
			endure: ["7E", "6E", "5E", "4M", "4S5", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "4E"],
			flail: ["7E", "6E", "5E", "4E"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			followme: ["3S3"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M", "4S4"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7E", "6E", "5E"],
			magnetrise: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L13", "6L13", "5L18", "4L18"],
			naturalgift: ["4M"],
			present: ["7E", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "4S4", "3M"],
			reversal: ["7E", "6E", "5E", "4E", "3E"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["3S0"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["7L10", "6L10", "5L13", "4L13", "3L11"],
			swift: ["4T", "3T"],
			tailwhip: ["7L5", "6L5", "5L5", "4L5", "3L6"],
			teeterdance: ["3S2"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "4S4", "3M"],
			thunderpunch: ["7E", "6T", "6E", "5E", "4E"],
			thundershock: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1", "3S2", "3S3"],
			thunderwave: ["7M", "7L18", "6M", "6L13", "5M", "5L10", "4M", "4L10", "3T", "3L8"],
			tickle: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			voltswitch: ["7M", "6M", "5M"],
			volttackle: ["6E", "5E", "4E", "4S4", "4S5", "3E"],
			wildcharge: ["7M", "6M", "5M"],
			wish: ["7E", "6E", "5E", "4E", "3E", "3S1"],
		},
	},
	pichuspikyeared: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L1"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			grassknot: ["4M"],
			headbutt: ["4T"],
			helpinghand: ["4T", "4S0"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			nastyplot: ["4L18"],
			naturalgift: ["4M"],
			painsplit: ["4S0"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			swagger: ["4M", "4S0"],
			sweetkiss: ["4L13"],
			swift: ["4T"],
			tailwhip: ["4L5"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thundershock: ["4L1"],
			thunderwave: ["4M", "4L10"],
			toxic: ["4M"],
			uproar: ["4T"],
			volttackle: ["4S0"],
		},
	},
	pikachu: {
		inherit: true,
		learnset: {
			agility: ["7L45", "7V", "6L37", "6S41", "5L37", "4L34", "3L33", "3S0", "3S8"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bestow: ["7E", "7S44", "6S42"],
			bide: ["7E", "7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "5S26", "4M", "3M"],
			captivate: ["4M"],
			celebrate: ["7S43", "6S31", "6S41"],
			charge: ["7E"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["6S36"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disarmingvoice: ["7E"],
			discharge: ["7L34", "6L34", "5L42", "4L37"],
			doubleedge: ["7V", "3T"],
			doubleslap: ["7E"],
			doubleteam: ["7M", "7L23", "7V", "6M", "6L21", "6S32", "5M", "5L21", "4M", "4L18", "4S13", "3M", "3L15"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			electricterrain: ["7E"],
			electroball: ["7L13", "6L13", "6S32", "6S37", "5L18", "5S23", "5S24", "5S30"],
			electroweb: ["6T"],
			encore: ["7E", "6S39", "5S23"],
			endeavor: ["6S39"],
			endure: ["7E", "4M", "3T"],
			extremespeed: ["5S26"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6S39"],
			feint: ["7L21", "6L21", "5L34", "5S29", "4L29"],
			flail: ["7E"],
			flash: ["7V", "6M", "6S40", "5M", "4M", "4S13", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			fly: ["6S41", "5S24", "5S27", "3S2", "3S4", "3S6"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "5S25", "5S26", "5S27", "4M", "4S13"],
			growl: ["7L5", "7V", "7S43", "7S46", "6L5", "6S31", "5L1", "4L1", "3L1", "3S1", "3S2", "3S3", "3S4", "3S5", "3S10"],
			happyhour: ["7S45", "7S46", "6S40"],
			headbutt: ["5S28", "4T"],
			heartstamp: ["6S34"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			holdhands: ["7S44", "7S45", "6S33", "6S34", "6S35", "6S40", "6S42"],
			irontail: ["6T", "6S37", "5T", "5S24", "5S30", "4M", "4S21", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["4S18"],
			lightscreen: ["7M", "7L53", "7V", "6M", "6L45", "5M", "5L45", "4M", "4L42", "4S11", "3M", "3L50", "3S0", "3S6", "3S7", "3S8"],
			luckychant: ["7E"],
			magnetrise: ["6T", "5T", "4T"],
			megakick: ["7V", "6S32", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nuzzle: ["7L29", "6L23", "6S36", "6S38"],
			payday: ["7V"],
			playnice: ["7L7", "7S43", "7S44", "7S45", "6L7", "6S31", "6S35", "6S36", "6S38", "6S40", "6S42"],
			present: ["7E", "4S12", "4S15", "4S17", "4S18", "4S20", "4S22"],
			protect: ["7M", "6M", "5M", "5S27", "4M", "4S14", "4S16", "3M"],
			quickattack: ["7L10", "7V", "7S43", "7S46", "6L10", "6S31", "6S32", "6S33", "6S34", "6S37", "5L13", "5S24", "5S25", "5S29", "5S30", "4L13", "4S11", "4S12", "4S15", "4S17", "4S18", "4S20", "4S21", "4S22", "3L11"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "4S19", "3M"],
			return: ["7M", "7S44", "6M", "6S42", "5M", "4M", "3M"],
			reversal: ["7E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sing: ["5S23"],
			skullbash: ["7V"],
			slam: ["7L37", "7V", "6L26", "5L26", "4L21", "3L20"],
			sleeptalk: ["7M", "6M", "5T", "4M", "4S19", "3T"],
			snore: ["6T", "5T", "4T", "4S19", "3T"],
			spark: ["7L26", "6L26"],
			strength: ["6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "6S35", "5M", "4M", "3T"],
			surf: ["6S33", "6S41", "4S9", "4S11", "4S14", "4S16", "3S3", "3S5", "3S7"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["6S36"],
			swift: ["7V", "4T", "3T"],
			tailwhip: ["7L1", "7V", "6L1", "6S38", "5L5", "5S28", "4L5", "4S9", "4S12", "4S15", "4S17", "4S20", "4S22", "3L6", "3S1", "3S2", "3S3", "3S4", "3S10"],
			takedown: ["7V"],
			teeterdance: ["7S45", "6S38", "5S23"],
			thunder: ["7M", "7L58", "7V", "6M", "6L50", "6S35", "5M", "5L50", "5S25", "4M", "4L45", "4S14", "4S16", "3M", "3L41", "3S0", "3S6", "3S7", "3S8"],
			thunderbolt: ["7M", "7L42", "7V", "6M", "6L29", "6S33", "6S34", "6S37", "5M", "5L29", "5S26", "5S27", "5S30", "4M", "4L26", "4S11", "4S13", "4S18", "4S21", "3M", "3L26", "3S0", "3S6", "3S7", "3S8"],
			thunderpunch: ["7E", "6T", "5T", "4T", "3T"],
			thundershock: ["7L1", "7V", "7S46", "6L1", "5L1", "5S28", "4L1", "4S12", "4S15", "4S20", "4S22", "3L1", "3S1", "3S5", "3S10"],
			thunderwave: ["7M", "7L18", "7V", "6M", "6L13", "5M", "5L10", "5S28", "4M", "4L10", "4S9", "4S17", "3T", "3L8", "3S1", "3S2", "3S3", "3S4", "3S5", "3S10"],
			tickle: ["7E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M", "5S29"],
			volttackle: ["7T", "6S39", "5S25", "5S29", "4S9", "4S21"],
			wildcharge: ["7M", "7L50", "6M", "6L50", "5M"],
			wish: ["7E"],
			yawn: ["4S19"],
		},
	},
	pikachucosplay: {
		inherit: true,
		learnset: {
			agility: ["6L45"],
			attract: ["6M"],
			brickbreak: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			covet: ["6T"],
			dig: ["6M"],
			discharge: ["6L34"],
			doubleteam: ["6M", "6L23"],
			echoedvoice: ["6M"],
			electroball: ["6L13", "6S0"],
			electroweb: ["6T"],
			facade: ["6M"],
			feint: ["6L21"],
			flash: ["6M"],
			fling: ["6M"],
			focuspunch: ["6T"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growl: ["6L5"],
			helpinghand: ["6T"],
			hiddenpower: ["6M"],
			irontail: ["6T"],
			knockoff: ["6T"],
			lightscreen: ["6M", "6L53"],
			magnetrise: ["6T"],
			nuzzle: ["6L29"],
			playnice: ["6L7"],
			protect: ["6M"],
			quickattack: ["6L10", "6S0"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			slam: ["6L37"],
			sleeptalk: ["6M"],
			snore: ["6T"],
			spark: ["6L26"],
			strength: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			tailwhip: ["6L1"],
			thunder: ["6M", "6L58"],
			thunderbolt: ["6M", "6L42"],
			thunderpunch: ["6T"],
			thundershock: ["6L1", "6S0"],
			thunderwave: ["6M", "6L18", "6S0"],
			toxic: ["6M"],
			voltswitch: ["6M"],
			wildcharge: ["6M", "6L50"],
		},
	},
	pikachurockstar: {
		inherit: true,
		learnset: {
			agility: ["6L45"],
			attract: ["6M"],
			brickbreak: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			covet: ["6T"],
			dig: ["6M"],
			discharge: ["6L34"],
			doubleteam: ["6M", "6L23"],
			echoedvoice: ["6M"],
			electroball: ["6L13", "6S0"],
			electroweb: ["6T"],
			facade: ["6M"],
			feint: ["6L21"],
			flash: ["6M"],
			fling: ["6M"],
			focuspunch: ["6T"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growl: ["6L5"],
			helpinghand: ["6T"],
			hiddenpower: ["6M"],
			irontail: ["6T"],
			knockoff: ["6T"],
			lightscreen: ["6M", "6L53"],
			magnetrise: ["6T"],
			meteormash: ["6S0"],
			nuzzle: ["6L29"],
			playnice: ["6L7"],
			protect: ["6M"],
			quickattack: ["6L10", "6S0"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			slam: ["6L37"],
			sleeptalk: ["6M"],
			snore: ["6T"],
			spark: ["6L26"],
			strength: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			tailwhip: ["6L1"],
			thunder: ["6M", "6L58"],
			thunderbolt: ["6M", "6L42"],
			thunderpunch: ["6T"],
			thundershock: ["6L1"],
			thunderwave: ["6M", "6L18", "6S0"],
			toxic: ["6M"],
			voltswitch: ["6M"],
			wildcharge: ["6M", "6L50"],
		},
	},
	pikachubelle: {
		inherit: true,
		learnset: {
			agility: ["6L45"],
			attract: ["6M"],
			brickbreak: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			covet: ["6T"],
			dig: ["6M"],
			discharge: ["6L34"],
			doubleteam: ["6M", "6L23"],
			echoedvoice: ["6M"],
			electroball: ["6L13", "6S0"],
			electroweb: ["6T"],
			facade: ["6M"],
			feint: ["6L21"],
			flash: ["6M"],
			fling: ["6M"],
			focuspunch: ["6T"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growl: ["6L5"],
			helpinghand: ["6T"],
			hiddenpower: ["6M"],
			iciclecrash: ["6S0"],
			irontail: ["6T"],
			knockoff: ["6T"],
			lightscreen: ["6M", "6L53"],
			magnetrise: ["6T"],
			nuzzle: ["6L29"],
			playnice: ["6L7"],
			protect: ["6M"],
			quickattack: ["6L10", "6S0"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			slam: ["6L37"],
			sleeptalk: ["6M"],
			snore: ["6T"],
			spark: ["6L26"],
			strength: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			tailwhip: ["6L1"],
			thunder: ["6M", "6L58"],
			thunderbolt: ["6M", "6L42"],
			thunderpunch: ["6T"],
			thundershock: ["6L1"],
			thunderwave: ["6M", "6L18", "6S0"],
			toxic: ["6M"],
			voltswitch: ["6M"],
			wildcharge: ["6M", "6L50"],
		},
	},
	pikachupopstar: {
		inherit: true,
		learnset: {
			agility: ["6L45"],
			attract: ["6M"],
			brickbreak: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			covet: ["6T"],
			dig: ["6M"],
			discharge: ["6L34"],
			doubleteam: ["6M", "6L23"],
			drainingkiss: ["6S0"],
			echoedvoice: ["6M"],
			electroball: ["6L13", "6S0"],
			electroweb: ["6T"],
			facade: ["6M"],
			feint: ["6L21"],
			flash: ["6M"],
			fling: ["6M"],
			focuspunch: ["6T"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growl: ["6L5"],
			helpinghand: ["6T"],
			hiddenpower: ["6M"],
			irontail: ["6T"],
			knockoff: ["6T"],
			lightscreen: ["6M", "6L53"],
			magnetrise: ["6T"],
			nuzzle: ["6L29"],
			playnice: ["6L7"],
			protect: ["6M"],
			quickattack: ["6L10", "6S0"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			slam: ["6L37"],
			sleeptalk: ["6M"],
			snore: ["6T"],
			spark: ["6L26"],
			strength: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			tailwhip: ["6L1"],
			thunder: ["6M", "6L58"],
			thunderbolt: ["6M", "6L42"],
			thunderpunch: ["6T"],
			thundershock: ["6L1"],
			thunderwave: ["6M", "6L18", "6S0"],
			toxic: ["6M"],
			voltswitch: ["6M"],
			wildcharge: ["6M", "6L50"],
		},
	},
	pikachuphd: {
		inherit: true,
		learnset: {
			agility: ["6L45"],
			attract: ["6M"],
			brickbreak: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			covet: ["6T"],
			dig: ["6M"],
			discharge: ["6L34"],
			doubleteam: ["6M", "6L23"],
			echoedvoice: ["6M"],
			electricterrain: ["6S0"],
			electroball: ["6L13", "6S0"],
			electroweb: ["6T"],
			facade: ["6M"],
			feint: ["6L21"],
			flash: ["6M"],
			fling: ["6M"],
			focuspunch: ["6T"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growl: ["6L5"],
			helpinghand: ["6T"],
			hiddenpower: ["6M"],
			irontail: ["6T"],
			knockoff: ["6T"],
			lightscreen: ["6M", "6L53"],
			magnetrise: ["6T"],
			nuzzle: ["6L29"],
			playnice: ["6L7"],
			protect: ["6M"],
			quickattack: ["6L10", "6S0"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			slam: ["6L37"],
			sleeptalk: ["6M"],
			snore: ["6T"],
			spark: ["6L26"],
			strength: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			tailwhip: ["6L1"],
			thunder: ["6M", "6L58"],
			thunderbolt: ["6M", "6L42"],
			thunderpunch: ["6T"],
			thundershock: ["6L1"],
			thunderwave: ["6M", "6L18", "6S0"],
			toxic: ["6M"],
			voltswitch: ["6M"],
			wildcharge: ["6M", "6L50"],
		},
	},
	pikachulibre: {
		inherit: true,
		learnset: {
			agility: ["6L45"],
			attract: ["6M"],
			brickbreak: ["6M"],
			chargebeam: ["6M"],
			confide: ["6M"],
			covet: ["6T"],
			dig: ["6M"],
			discharge: ["6L34"],
			doubleteam: ["6M", "6L23"],
			echoedvoice: ["6M"],
			electroball: ["6L13", "6S0"],
			electroweb: ["6T"],
			facade: ["6M"],
			feint: ["6L21"],
			flash: ["6M"],
			fling: ["6M"],
			flyingpress: ["6S0"],
			focuspunch: ["6T"],
			frustration: ["6M"],
			grassknot: ["6M"],
			growl: ["6L5"],
			helpinghand: ["6T"],
			hiddenpower: ["6M"],
			irontail: ["6T"],
			knockoff: ["6T"],
			lightscreen: ["6M", "6L53"],
			magnetrise: ["6T"],
			nuzzle: ["6L29"],
			playnice: ["6L7"],
			protect: ["6M"],
			quickattack: ["6L10", "6S0"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			rocksmash: ["6M"],
			round: ["6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			slam: ["6L37"],
			sleeptalk: ["6M"],
			snore: ["6T"],
			spark: ["6L26"],
			strength: ["6M"],
			substitute: ["6M"],
			swagger: ["6M"],
			tailwhip: ["6L1"],
			thunder: ["6M", "6L58"],
			thunderbolt: ["6M", "6L42"],
			thunderpunch: ["6T"],
			thundershock: ["6L1"],
			thunderwave: ["6M", "6L18", "6S0"],
			toxic: ["6M"],
			voltswitch: ["6M"],
			wildcharge: ["6M", "6L50"],
		},
	},
	pikachuoriginal: {
		inherit: true,
		learnset: {
			agility: ["7L45", "7S0"],
			attract: ["7M"],
			brickbreak: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			discharge: ["7L34"],
			doubleteam: ["7M", "7L23"],
			echoedvoice: ["7M"],
			electroball: ["7L13"],
			facade: ["7M"],
			feint: ["7L21"],
			fling: ["7M"],
			frustration: ["7M"],
			grassknot: ["7M"],
			growl: ["7L5"],
			hiddenpower: ["7M"],
			lightscreen: ["7M", "7L53"],
			nuzzle: ["7L29"],
			playnice: ["7L7"],
			protect: ["7M"],
			quickattack: ["7L10", "7S0"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			slam: ["7L37"],
			sleeptalk: ["7M"],
			spark: ["7L26"],
			substitute: ["7M"],
			swagger: ["7M"],
			tailwhip: ["7L1"],
			thunder: ["7M", "7L58", "7S0"],
			thunderbolt: ["7M", "7L42", "7S0"],
			thundershock: ["7L1"],
			thunderwave: ["7M", "7L18"],
			toxic: ["7M"],
			voltswitch: ["7M"],
			volttackle: ["7T"],
			wildcharge: ["7M", "7L50"],
		},
	},
	pikachuhoenn: {
		inherit: true,
		learnset: {
			agility: ["7L45"],
			attract: ["7M"],
			brickbreak: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			discharge: ["7L34"],
			doubleteam: ["7M", "7L23"],
			echoedvoice: ["7M"],
			electroball: ["7L13"],
			facade: ["7M"],
			feint: ["7L21"],
			fling: ["7M"],
			frustration: ["7M"],
			grassknot: ["7M"],
			growl: ["7L5"],
			hiddenpower: ["7M"],
			irontail: ["7S0"],
			lightscreen: ["7M", "7L53"],
			nuzzle: ["7L29"],
			playnice: ["7L7"],
			protect: ["7M"],
			quickattack: ["7L10", "7S0"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			slam: ["7L37"],
			sleeptalk: ["7M"],
			spark: ["7L26"],
			substitute: ["7M"],
			swagger: ["7M"],
			tailwhip: ["7L1"],
			thunder: ["7M", "7L58", "7S0"],
			thunderbolt: ["7M", "7L42", "7S0"],
			thundershock: ["7L1"],
			thunderwave: ["7M", "7L18"],
			toxic: ["7M"],
			voltswitch: ["7M"],
			volttackle: ["7T"],
			wildcharge: ["7M", "7L50"],
		},
	},
	pikachusinnoh: {
		inherit: true,
		learnset: {
			agility: ["7L45"],
			attract: ["7M"],
			brickbreak: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			discharge: ["7L34"],
			doubleteam: ["7M", "7L23"],
			echoedvoice: ["7M"],
			electroball: ["7L13"],
			facade: ["7M"],
			feint: ["7L21"],
			fling: ["7M"],
			frustration: ["7M"],
			grassknot: ["7M"],
			growl: ["7L5"],
			hiddenpower: ["7M"],
			irontail: ["7S0"],
			lightscreen: ["7M", "7L53"],
			nuzzle: ["7L29"],
			playnice: ["7L7"],
			protect: ["7M"],
			quickattack: ["7L10", "7S0"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			slam: ["7L37"],
			sleeptalk: ["7M"],
			spark: ["7L26"],
			substitute: ["7M"],
			swagger: ["7M"],
			tailwhip: ["7L1"],
			thunder: ["7M", "7L58"],
			thunderbolt: ["7M", "7L42", "7S0"],
			thundershock: ["7L1"],
			thunderwave: ["7M", "7L18"],
			toxic: ["7M"],
			voltswitch: ["7M"],
			volttackle: ["7T", "7S0"],
			wildcharge: ["7M", "7L50"],
		},
	},
	pikachuunova: {
		inherit: true,
		learnset: {
			agility: ["7L45"],
			attract: ["7M"],
			brickbreak: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			discharge: ["7L34"],
			doubleteam: ["7M", "7L23"],
			echoedvoice: ["7M"],
			electroball: ["7L13"],
			facade: ["7M"],
			feint: ["7L21"],
			fling: ["7M"],
			frustration: ["7M"],
			grassknot: ["7M"],
			growl: ["7L5"],
			hiddenpower: ["7M"],
			irontail: ["7S0"],
			lightscreen: ["7M", "7L53"],
			nuzzle: ["7L29"],
			playnice: ["7L7"],
			protect: ["7M"],
			quickattack: ["7L10", "7S0"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			slam: ["7L37"],
			sleeptalk: ["7M"],
			spark: ["7L26"],
			substitute: ["7M"],
			swagger: ["7M"],
			tailwhip: ["7L1"],
			thunder: ["7M", "7L58"],
			thunderbolt: ["7M", "7L42", "7S0"],
			thundershock: ["7L1"],
			thunderwave: ["7M", "7L18"],
			toxic: ["7M"],
			voltswitch: ["7M"],
			volttackle: ["7T", "7S0"],
			wildcharge: ["7M", "7L50"],
		},
	},
	pikachukalos: {
		inherit: true,
		learnset: {
			agility: ["7L45"],
			attract: ["7M"],
			brickbreak: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			discharge: ["7L34"],
			doubleteam: ["7M", "7L23"],
			echoedvoice: ["7M"],
			electroball: ["7L13", "7S0"],
			facade: ["7M"],
			feint: ["7L21"],
			fling: ["7M"],
			frustration: ["7M"],
			grassknot: ["7M"],
			growl: ["7L5"],
			hiddenpower: ["7M"],
			irontail: ["7S0"],
			lightscreen: ["7M", "7L53"],
			nuzzle: ["7L29"],
			playnice: ["7L7"],
			protect: ["7M"],
			quickattack: ["7L10", "7S0"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			slam: ["7L37"],
			sleeptalk: ["7M"],
			spark: ["7L26"],
			substitute: ["7M"],
			swagger: ["7M"],
			tailwhip: ["7L1"],
			thunder: ["7M", "7L58"],
			thunderbolt: ["7M", "7L42", "7S0"],
			thundershock: ["7L1"],
			thunderwave: ["7M", "7L18"],
			toxic: ["7M"],
			voltswitch: ["7M"],
			volttackle: ["7T"],
			wildcharge: ["7M", "7L50"],
		},
	},
	pikachualola: {
		inherit: true,
		learnset: {
			agility: ["7L45"],
			attract: ["7M"],
			brickbreak: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			discharge: ["7L34"],
			doubleteam: ["7M", "7L23"],
			echoedvoice: ["7M"],
			electroball: ["7L13", "7S0"],
			facade: ["7M"],
			feint: ["7L21"],
			fling: ["7M"],
			frustration: ["7M"],
			grassknot: ["7M"],
			growl: ["7L5"],
			hiddenpower: ["7M"],
			irontail: ["7S0"],
			lightscreen: ["7M", "7L53"],
			nuzzle: ["7L29"],
			playnice: ["7L7"],
			protect: ["7M"],
			quickattack: ["7L10", "7S0"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			slam: ["7L37"],
			sleeptalk: ["7M"],
			spark: ["7L26"],
			substitute: ["7M"],
			swagger: ["7M"],
			tailwhip: ["7L1"],
			thunder: ["7M", "7L58"],
			thunderbolt: ["7M", "7L42", "7S0"],
			thundershock: ["7L1"],
			thunderwave: ["7M", "7L18"],
			toxic: ["7M"],
			voltswitch: ["7M"],
			volttackle: ["7T"],
			wildcharge: ["7M", "7L50"],
		},
	},
	raichu: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			electroweb: ["6T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7V"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magnetrise: ["6T", "5T", "4T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payday: ["7V"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwhip: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7L1", "7V", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thundershock: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	raichualola: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			lightscreen: ["7M"],
			protect: ["7M"],
			psychic: ["7M", "7L1"],
			psyshock: ["7M"],
			quickattack: ["7L1"],
			raindance: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sleeptalk: ["7M"],
			speedswap: ["7L1"],
			substitute: ["7M"],
			swagger: ["7M"],
			tailwhip: ["7L1"],
			thief: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M", "7L1"],
			thundershock: ["7L1"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			voltswitch: ["7M"],
			wildcharge: ["7M"],
		},
	},
	sandshrew: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "5D", "4E", "3T", "3E"],
			covet: ["6T", "5T"],
			crushclaw: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defensecurl: ["7L1", "6L1", "5L3", "4L3", "3T", "3L6", "3S0"],
			dig: ["7L30", "7V", "6M", "6L30", "5M", "5L30", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L46", "7V", "6M", "6L46", "5M", "5L46", "4M", "3M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7V"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L11", "6L11", "5L25", "4T", "4L25", "3T"],
			furyswipes: ["7L20", "7V", "6L20", "5L19", "4L19", "3L37"],
			gyroball: ["7M", "7L34", "6M", "6L34", "5M", "5L33", "4M", "4L33"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			magnitude: ["7L14", "6L14", "5L17"],
			metalclaw: ["7E", "6E", "5E", "4E", "3E"],
			mimic: ["7V", "3T"],
			mudshot: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["7E", "6E", "5E", "4E"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L5", "7V", "6L5", "5L9", "4L9", "3L17", "3S0"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			rapidspin: ["7L9", "7E", "6L9", "6E", "5L13", "5E", "4L13", "4E", "3E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["7E", "6E", "5E", "4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L7", "6L7", "5L21", "4T", "4L21", "3T"],
			rototiller: ["7E", "6E"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4E", "3E"],
			sandattack: ["7L3", "7V", "6L3", "5L7", "5D", "4L7", "3L11", "3S0"],
			sandstorm: ["7M", "7L42", "6M", "6L42", "5M", "5L37", "4M", "4L37", "3M", "3L53"],
			sandtomb: ["7L23", "6L23", "5L27", "4L27", "3L45"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			skullbash: ["7V"],
			slash: ["7L26", "7V", "6L26", "5L31", "4L31", "3L23"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "5D", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L17", "7V", "6L11", "5L15", "4T", "4L15", "3T", "3L30"],
			swordsdance: ["7M", "7L38", "7V", "6M", "6L38", "5M", "5L38", "4M", "4E", "3T", "3E"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	sandshrewalola: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			amnesia: ["7E"],
			attract: ["7M"],
			auroraveil: ["7M"],
			bide: ["7L3", "7S0"],
			blizzard: ["7M", "7L46"],
			brickbreak: ["7M"],
			bulldoze: ["7M"],
			chipaway: ["7E"],
			confide: ["7M"],
			counter: ["7E"],
			crushclaw: ["7E"],
			curse: ["7E"],
			defensecurl: ["7L1"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			endure: ["7E"],
			facade: ["7M"],
			flail: ["7E"],
			fling: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			furycutter: ["7L11"],
			furyswipes: ["7L20"],
			gyroball: ["7M", "7L34"],
			hail: ["7M", "7L42"],
			hiddenpower: ["7M"],
			iceball: ["7L7", "7S0"],
			iciclecrash: ["7E"],
			iciclespear: ["7E"],
			irondefense: ["7L23"],
			ironhead: ["7L30"],
			leechlife: ["7M"],
			metalclaw: ["7L14", "7E"],
			nightslash: ["7E"],
			poisonjab: ["7M"],
			powdersnow: ["7L5", "7S0"],
			protect: ["7M"],
			rapidspin: ["7L9", "7S0"],
			rest: ["7M"],
			return: ["7M"],
			rockslide: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			scratch: ["7L1"],
			shadowclaw: ["7M"],
			slash: ["7L26"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swift: ["7L17"],
			swordsdance: ["7M", "7L38"],
			thief: ["7M"],
			toxic: ["7M"],
			workup: ["7M"],
			xscissor: ["7M"],
		},
	},
	sandslash: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			crushclaw: ["7L1", "6L22", "5L22", "4L22"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defensecurl: ["7L1", "6L1", "5L1", "4L1", "3T", "3L1"],
			dig: ["7L33", "7V", "6M", "6L30", "5M", "5L30", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L53", "7V", "6M", "6L46", "5M", "5L46", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7V"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L11", "6L11", "5L28", "4T", "4L28", "3T"],
			furyswipes: ["7L20", "7V", "6L20", "5L19", "4L19", "3L42"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "7L38", "6M", "6L34", "5M", "5L45", "4M", "4L45"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			magnitude: ["7L14", "6L14", "5L17"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L5", "7L1", "7V", "6L1", "5L9", "4L9", "3L17"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			rapidspin: ["7L9", "6L9", "5L13", "4L13"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L7", "6L7", "5L21", "4T", "4L21", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			sandattack: ["7L3", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			sandstorm: ["7M", "7L48", "6M", "6L42", "5M", "5L52", "4M", "4L52", "3M", "3L62"],
			sandtomb: ["7L24", "6L23", "5L33", "4L33", "3L52"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			skullbash: ["7V"],
			slash: ["7L28", "7V", "6L26", "5L40", "4L40", "3L24"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L17", "7V", "6L11", "5L15", "4T", "4L15", "3T", "3L33"],
			swordsdance: ["7M", "7L43", "7V", "6M", "6L38", "5M", "5L38", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	sandslashalola: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			auroraveil: ["7M"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			bulldoze: ["7M"],
			confide: ["7M"],
			defensecurl: ["7L1"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			focusblast: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			gyroball: ["7M"],
			hail: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			iceball: ["7L1"],
			iciclecrash: ["7L1"],
			iciclespear: ["7L1"],
			leechlife: ["7M"],
			metalburst: ["7L1"],
			metalclaw: ["7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockslide: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			shadowclaw: ["7M"],
			slash: ["7L1"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			thief: ["7M"],
			toxic: ["7M"],
			workup: ["7M"],
			xscissor: ["7M"],
		},
	},
	nidoranf: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			beatup: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7V"],
			bite: ["7L21", "7V", "6L21", "5L21", "4L21", "3L20"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			captivate: ["7L43", "6L43", "5L43", "4M", "4L43"],
			charm: ["7E", "6E", "5E", "4E", "3E"],
			chipaway: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			crunch: ["7L37", "6L37", "5L37", "4L37", "3L47"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			doubleedge: ["7V", "3T"],
			doublekick: ["7L9", "7V", "6L9", "5L9", "4L9", "3L12"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flatter: ["7L33", "6L33", "5L33", "4L33", "3L38"],
			focusenergy: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7L19", "7V", "6L19", "5L19", "4L19", "3L30"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			helpinghand: ["7L25", "6T", "6L25", "5T", "5L25", "4T", "4L25", "3L23"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonfang: ["7L45", "6L45", "5L45", "4L45"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L13", "7V", "6L13", "5L13", "4L13", "3L17"],
			poisontail: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7E", "7V", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["5D"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "5D", "4T"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7V"],
			tailwhip: ["7L7", "7V", "6L7", "5L7", "4L7", "3L8"],
			takedown: ["7E", "7V", "6E", "5E", "4E", "3E"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7L31", "6L31", "5L31", "4L31"],
			venomdrench: ["7E", "6E"],
			venoshock: ["7M", "6M", "5M"],
			waterpulse: ["6T", "4M", "3M"],
		},
	},
	nidorina: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L23", "7V", "6L23", "5L23", "4L23", "3L22"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			bubblebeam: ["7V"],
			captivate: ["7L50", "6L50", "5L50", "4M", "4L50"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crunch: ["7L43", "6L43", "5L43", "4L43", "3L53"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doublekick: ["7L9", "7V", "6L9", "5L9", "4L9", "3L12"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flatter: ["7L38", "6L38", "5L38", "4L38", "3L43"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7L20", "7V", "6L20", "5L20", "4L20", "3L34"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			helpinghand: ["7L28", "6T", "6L28", "5T", "5L28", "4T", "4L28", "3L26"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			horndrill: ["7V"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonfang: ["7L58", "6L58", "5L58", "4L58"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L13", "7V", "6L13", "5L13", "4L13", "3L18"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7V"],
			tailwhip: ["7L7", "7V", "6L7", "5L7", "4L7", "3L8"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7L35", "6L35", "5L35", "4L35"],
			venoshock: ["7M", "6M", "5M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
		},
	},
	nidoqueen: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L35", "7V", "6L35", "6S0", "5L35", "4L23", "3T", "3L22"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L23", "6L23", "5L23"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doublekick: ["7L1", "7V", "6L1", "6S0", "5L1", "4L1", "3L1"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			drillrun: ["6T"],
			dynamicpunch: ["3T"],
			earthpower: ["7L43", "6T", "6L43", "5T", "5L43", "4T", "4L43"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			horndrill: ["7V"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			payday: ["7V"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L1", "7V", "6L1", "6S0", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quash: ["7M", "6M", "5M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			superpower: ["7L58", "7L1", "6T", "6L1", "5T", "5L58", "4T", "4L58", "3L43"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7V"],
			tailwhip: ["7L1", "7V", "6L1", "6S0", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	nidoranm: {
		inherit: true,
		learnset: {
			amnesia: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			beatup: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			captivate: ["7L43", "6L43", "5L43", "4M", "4L43"],
			chipaway: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			confusion: ["7E", "6E", "5E", "4E", "3E"],
			counter: ["7E", "6E", "5E", "5D", "4E", "3T", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			doubleedge: ["7V", "3T"],
			doublekick: ["7L9", "7V", "6L9", "5L9", "4L9", "3L12"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillrun: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flatter: ["7L33", "6L33", "5L33", "4L33", "3L38"],
			focusenergy: ["7L7", "7V", "6L7", "5L7", "4L7", "3L8"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L19", "7V", "6L19", "5L19", "4L19", "3L30"],
			headbutt: ["4T"],
			headsmash: ["7E", "6E", "5E", "4E"],
			helpinghand: ["7L25", "6T", "6L25", "5T", "5L25", "4T", "4L25", "3L23"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hornattack: ["7L21", "7V", "6L21", "5L21", "4L21", "3L20"],
			horndrill: ["7L45", "7V", "6L45", "5L45", "4L45", "3L47"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			peck: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			poisonjab: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L37"],
			poisonsting: ["7L13", "7V", "6L13", "5L13", "4L13", "3L17"],
			poisontail: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7E", "6E", "5E", "4T", "4E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "5D", "4T"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7V"],
			takedown: ["7E", "7V", "6E", "5E", "4E", "3E"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7L31", "6L31", "5L31", "4L31"],
			venomdrench: ["7E", "6E"],
			venoshock: ["7M", "6M", "5M"],
			waterpulse: ["6T", "4M", "3M"],
		},
	},
	nidorino: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			bubblebeam: ["7V"],
			captivate: ["7L50", "6L50", "5L50", "4M", "4L50"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doublekick: ["7L9", "7V", "6L9", "5L9", "4L9", "3L12"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillrun: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flatter: ["7L38", "6L38", "5L38", "4L38", "3L43"],
			focusenergy: ["7L7", "7V", "6L7", "5L7", "4L7", "3L8"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L20", "7V", "6L20", "5L20", "4L20", "3L34"],
			headbutt: ["4T"],
			helpinghand: ["7L28", "6T", "6L28", "5T", "5L28", "4T", "4L28", "3L26"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hornattack: ["7L23", "7V", "6L23", "5L23", "4L23", "3L22"],
			horndrill: ["7L58", "7V", "6L58", "5L58", "4L58", "3L53"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			peck: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			poisonjab: ["7M", "7L43", "6M", "6L43", "5M", "5L43", "4M", "4L43"],
			poisonsting: ["7L13", "7V", "6L13", "5L13", "4L13", "3L18"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7V"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7L35", "6L35", "5L35", "4L35"],
			venoshock: ["7M", "6M", "5M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
		},
	},
	nidoking: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L23", "6L23", "5L23"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doublekick: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			drillrun: ["6T", "5T"],
			dynamicpunch: ["3T"],
			earthpower: ["7L43", "6T", "6L43", "5T", "5L43", "4T", "4L43"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hornattack: ["7V"],
			horndrill: ["7V"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			megahorn: ["7L58", "7L1", "6L1", "5L58", "4L58", "3L43"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			payday: ["7V"],
			peck: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quash: ["7M", "6M", "5M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7V"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L35", "7V", "6L35", "5L35", "4L23", "3L22"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	cleffa: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			amnesia: ["7E", "6E", "5E", "4E", "3E"],
			aromatherapy: ["7E", "6E", "5E", "5D", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bellydrum: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			confide: ["7M", "6M"],
			copycat: ["7L13", "6L13", "5L13", "4L13"],
			counter: ["3T"],
			covet: ["7E", "6T", "6E", "5T", "5E", "4E"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7L4", "6L4", "5L4", "5D", "4L4", "3L4"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6E", "5E", "4E"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			healpulse: ["7E", "6E"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magicalleaf: ["7L16", "6L16", "5L16", "4L16", "3L17"],
			magiccoat: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["7E", "6E", "5E", "4E", "3T", "3E"],
			mimic: ["7E", "6E", "5E", "4E", "3T", "3E"],
			mistyterrain: ["7E", "6E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			present: ["7E", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sing: ["7L7", "6L7", "5L7", "4L7", "3L8"],
			sleeptalk: ["7M", "6M", "5T", "5D", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			splash: ["7E", "6E", "5E", "4E", "3E"],
			storedpower: ["7E", "6E", "5E"],
			substitute: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["7L10", "6L10", "5L10", "4L10", "3L13"],
			telekinesis: ["5M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			tickle: ["7E", "6E", "5E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M", "3M"],
			wish: ["7E", "6E", "5E", "4E", "3E"],
			wonderroom: ["6T", "5T"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	clefairy: {
		inherit: true,
		learnset: {
			afteryou: ["7L58", "6T", "6L1", "5T", "5L52"],
			amnesia: ["7E"],
			aromatherapy: ["7E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bellydrum: ["7E"],
			bestow: ["7L19", "6L19", "5L25"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L40", "7V", "6L40", "5L40", "3T"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7V"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			cosmicpower: ["7L34", "6L34", "5L28", "4L25", "3L33"],
			counter: ["7V", "3T"],
			covet: ["7E", "6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["7L13", "7V", "6L13", "5L13", "4L13", "3T", "3L25"],
			dig: ["6M", "5M", "4M", "3M"],
			disarmingvoice: ["7L1", "6L1"],
			doubleedge: ["7V", "3T"],
			doubleslap: ["7L10", "7V", "6L10", "5L10", "4L10", "3L13"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7L1", "6L1", "5L4", "4L4", "3L5"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			followme: ["7L16", "6L16", "5L16", "4L16", "3L17"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["7L49", "6T", "6L49", "5T", "5L37", "4T", "4L34"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			healingwish: ["7L55", "6L1", "5L49", "4L46"],
			healpulse: ["7E"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "7V", "6M", "5M", "5L46", "4M", "4L40", "3M", "3L41"],
			luckychant: ["7L37", "6L37", "5L31", "4L28"],
			magiccoat: ["6T", "5T", "4T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			meteormash: ["7L50", "6L50", "5L55", "4L43", "3L45"],
			metronome: ["7L31", "7E", "7V", "6L31", "5L34", "4L31", "3T", "3L29"],
			mimic: ["7E", "7V", "3T"],
			minimize: ["7L25", "7V", "6L25", "5L19", "4L19", "3L21"],
			mistyterrain: ["7E"],
			moonblast: ["7L46", "6L46"],
			moonlight: ["7L43", "6L43", "5L40", "4L37", "3L37"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			pound: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			present: ["7E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sing: ["7L7", "7V", "6L7", "5L7", "4L7", "3L9"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			splash: ["7E"],
			spotlight: ["7L1"],
			stealthrock: ["6T", "5T", "4M"],
			storedpower: ["7L28", "7E", "6L28", "5L43"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			tickle: ["7E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["6T", "5T", "4T"],
			wakeupslap: ["7L22", "6L22", "5L22", "4L22"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			wish: ["7E"],
			wonderroom: ["6T", "5T"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	clefable: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7V"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disarmingvoice: ["7L1", "6L1"],
			doubleedge: ["7V", "3T"],
			doubleslap: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7L1", "7V", "6L1", "5L1", "4L1", "3T", "3L1"],
			mimic: ["7V", "3T"],
			minimize: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sing: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			spotlight: ["7L1"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["6T", "5T", "4T"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			wonderroom: ["6T", "5T"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	vulpix: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			babydolleyes: ["7L9", "6L9"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			captivate: ["7L47", "7E", "6L47", "6E", "5L41", "4M", "4L37"],
			charm: ["3S1"],
			confide: ["7M", "6M"],
			confuseray: ["7L12", "7V", "6L12", "5L17", "4L17", "3L21"],
			covet: ["6T", "5T"],
			darkpulse: ["7M", "6M", "5T", "5D", "4M"],
			dig: ["7V", "6M", "5M", "4M", "3M", "3S1"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			ember: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S1"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4E"],
			extrasensory: ["7L31", "7E", "6L31", "6E", "5L51", "5E", "4L44", "4E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L23", "7E", "6L20", "6E", "5L20", "5E", "4E", "3E"],
			fireblast: ["7M", "7L42", "7V", "6M", "6L42", "5M", "5L54", "4M", "4L47", "3M"],
			firespin: ["7L15", "7V", "6L12", "5L14", "4L34", "3L41"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			flameburst: ["7L28", "6L23", "5L24"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L36", "7V", "6M", "6L34", "5M", "5L37", "4M", "4L24", "3M", "3L29"],
			flareblitz: ["7E", "6E", "5E", "4E"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grudge: ["7L44", "6L44", "5L47", "4L41", "3L37"],
			headbutt: ["4T"],
			heatwave: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3E", "3S1"],
			hex: ["7L26", "7E", "6L26", "6E", "5L28", "5E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7E", "6E", "5E", "4E", "3E"],
			hypnosis: ["7E", "6E", "5E", "4E", "3E"],
			imprison: ["7L39", "6L18", "5L21", "4L21", "3L25"],
			incinerate: ["6M", "5M"],
			inferno: ["7L50", "6L50", "5L44"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "7L18", "6M", "6L18", "5M", "5L34", "4M", "4L31"],
			powerswap: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3E"],
			quickattack: ["7L10", "7V", "6L10", "5L11", "4L11", "3L13", "3S0"],
			rage: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L7", "7V", "6M", "6L7", "5M", "5L7", "5D", "4M", "4L7", "3M", "3L9", "3S0"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L34", "6M", "6L34", "5M", "5L27", "4M", "4L27", "3M", "3L33"],
			secretpower: ["7E", "6M", "6E", "5E", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailslap: ["7E", "6E", "5E"],
			tailwhip: ["7L4", "7V", "6L4", "5L4", "4L4", "3L5", "3S0"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "7L20", "6M", "6L20", "5M", "5L31", "4M", "4L14", "3L17", "3S0"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	vulpixalola: {
		inherit: true,
		learnset: {
			agility: ["7E"],
			attract: ["7M"],
			aurorabeam: ["7L28"],
			auroraveil: ["7M"],
			babydolleyes: ["7L9", "7S0"],
			blizzard: ["7M", "7L42"],
			captivate: ["7L47"],
			celebrate: ["7S0"],
			charm: ["7E"],
			confide: ["7M"],
			confuseray: ["7L12"],
			darkpulse: ["7M"],
			disable: ["7E"],
			doubleteam: ["7M"],
			encore: ["7E"],
			extrasensory: ["7L31", "7E"],
			facade: ["7M"],
			feintattack: ["7L23"],
			flail: ["7E"],
			freezedry: ["7E"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			grudge: ["7L44"],
			hail: ["7M"],
			hex: ["7L26"],
			hiddenpower: ["7M"],
			howl: ["7E"],
			hypnosis: ["7E"],
			icebeam: ["7M", "7L36"],
			iceshard: ["7L10", "7S0"],
			icywind: ["7L15"],
			imprison: ["7L39"],
			mist: ["7L20"],
			moonblast: ["7E"],
			payback: ["7M", "7L18"],
			powdersnow: ["7L1", "7S1"],
			powerswap: ["7E"],
			protect: ["7M"],
			psychup: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M", "7L7"],
			round: ["7M"],
			safeguard: ["7M", "7L34"],
			secretpower: ["7E"],
			sheercold: ["7L50"],
			sleeptalk: ["7M"],
			spite: ["7E"],
			substitute: ["7M"],
			swagger: ["7M"],
			tailslap: ["7E"],
			tailwhip: ["7L4", "7S0"],
			toxic: ["7M"],
		},
	},
	ninetales: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			covet: ["6T", "5T"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			ember: ["7V", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firespin: ["3L45"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L1", "6M", "6L1", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "5S0", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			imprison: ["7L1", "6L1"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["7V", "3T"],
			nastyplot: ["7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M", "5S0"],
			quickattack: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			rage: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7V", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "5S0", "4M"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwhip: ["7V"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "5S0", "4M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	ninetalesalola: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			auroraveil: ["7M"],
			blizzard: ["7M"],
			calmmind: ["7M"],
			confide: ["7M"],
			confuseray: ["7L1"],
			darkpulse: ["7M"],
			dazzlinggleam: ["7M", "7L1"],
			doubleteam: ["7M"],
			dreameater: ["7M"],
			facade: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			hail: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M", "7L1"],
			iceshard: ["7L1"],
			imprison: ["7L1"],
			nastyplot: ["7L1"],
			payback: ["7M"],
			protect: ["7M"],
			psychup: ["7M"],
			psyshock: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			round: ["7M"],
			safeguard: ["7M", "7L1"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			toxic: ["7M"],
		},
	},
	igglybuff: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			captivate: ["7E", "6E", "5E", "4M"],
			charm: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			confide: ["7M", "6M"],
			copycat: ["7L11", "6L11", "5L17", "4L17"],
			counter: ["3T"],
			covet: ["7E", "6T", "6E", "5T", "5E", "4E"],
			defensecurl: ["7L3", "6L3", "5L5", "4L5", "3T", "3L4", "3S0"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6E", "5E", "5D", "4E", "3E"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			healpulse: ["7E", "6E"],
			helpinghand: ["6T", "5T", "5D", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lastresort: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mistyterrain: ["7E", "6E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			perishsong: ["7E", "6E", "5E", "4E", "3E"],
			pound: ["7L5", "6L5", "5L9", "4L9", "3L9"],
			present: ["7E", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			punishment: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sing: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["7L9", "6L9", "5L13", "4L13", "3L14"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			tickle: ["3S0"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			wish: ["7E", "6E", "5E", "4E", "3E"],
			workup: ["7M", "5M"],
		},
	},
	jigglypuff: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L32", "7V", "6L33", "5L33", "4L29", "3T", "3L34"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7V"],
			captivate: ["7E", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			covet: ["7E", "6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["7L3", "7V", "6L3", "5L5", "4L5", "3T", "3L4"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7L14", "7V", "6L13", "5L13", "4L13", "3L14"],
			disarmingvoice: ["7L11", "6L11"],
			doubleedge: ["7L45", "7V", "6L49", "5L53", "4L49", "3T", "3L49"],
			doubleslap: ["7L17", "7V", "6L18", "5L25", "4L21", "3L24"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E"],
			feintattack: ["7E"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["7E", "6T", "5T", "4T"],
			gyroball: ["7M", "7L35", "6M", "6L37", "5M", "5L37", "4M", "4L33"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			healpulse: ["7E"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["7L41", "6T", "6L44", "5T", "5L49", "4L45", "3L44"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["7E", "6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7L38", "7V", "6L37", "5L45", "4L41", "3T", "3L39"],
			mistyterrain: ["7E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			perishsong: ["7E"],
			playnice: ["7L9", "6L8"],
			pound: ["7L5", "7V", "6L5", "5L9", "4L9", "3L9"],
			poweruppunch: ["6M"],
			present: ["7E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psywave: ["7V"],
			punishment: ["7E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L30", "7V", "6M", "6L29", "5M", "5L29", "4M", "4L25", "3M", "3L29"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["7L20", "6L21", "5L21", "4T", "4L17", "3T", "3L19"],
			round: ["7M", "7L22", "6M", "6L17", "5M", "5L17"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sing: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "7E", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			spitup: ["7L25"],
			stealthrock: ["6T", "5T", "4M"],
			stockpile: ["7L25"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L25"],
			takedown: ["7V"],
			teleport: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			wakeupslap: ["7L27", "6L28", "5L41", "4L37"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			wish: ["7E"],
			workup: ["7M", "5M"],
		},
	},
	wigglytuff: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["7L1", "7V", "6L1", "5L1", "4L1", "3T", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["7L1", "7V", "6L1", "3T"],
			doubleslap: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			playrough: ["7L1", "6L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sing: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			teleport: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
		},
	},
	zubat: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			acrobatics: ["7M", "6M", "6L30", "5M", "5L33"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["7L19", "6L19", "5L25", "4T", "4L25", "3L31"],
			airslash: ["7L41", "6L41", "5L45", "4L41"],
			astonish: ["7L7", "6L7", "5L9", "4L9", "3L6"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L11", "7V", "6L11", "5L13", "4L13", "3L16"],
			bravebird: ["7E", "6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L17", "7V", "6L17", "5L21", "4L21", "3L26"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			defog: ["7E", "6E", "5E", "4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			fly: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			gust: ["7E", "6E", "5E", "4E", "3E"],
			haze: ["7L35", "7V", "6L35", "5L41", "4L37", "3L46"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypnosis: ["7E", "6E", "5E", "5D", "4E"],
			leechlife: ["7M", "7L31", "7V", "6L1", "5L1", "4L1", "3L1"],
			meanlook: ["7L29", "6L29", "5L29", "4L29", "3L36"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			nastyplot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			pluck: ["5M", "4M"],
			poisonfang: ["7L25", "6L25", "5L37", "4L33", "3L41"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			quickattack: ["7E", "6E", "5E", "4E", "3E"],
			quickguard: ["7L43", "6L43"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "5D", "4T"],
			supersonic: ["7L5", "7V", "6L4", "5L5", "5D", "4L5", "3L6"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L23", "7V", "6L23", "5L24", "4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			venomdrench: ["7E", "6E"],
			venoshock: ["7M", "7L37", "6M", "6L37", "5M"],
			whirlwind: ["7E", "7V", "6E", "5E", "4E", "3E"],
			wingattack: ["7L13", "7V", "6L13", "5L17", "4L17", "3L21"],
			zenheadbutt: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
		},
	},
	golbat: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			acrobatics: ["7M", "6M", "6L33", "5M", "5L39"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["7L19", "6L19", "5L27", "4T", "4L27", "3L35"],
			airslash: ["7L48", "6L48", "5L57", "4L51"],
			astonish: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L11", "7L1", "7V", "6L1", "5L13", "4L13", "3L16"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L17", "7V", "6L17", "5L21", "4L21", "3L28"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fly: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			haze: ["7L40", "7V", "6L40", "5L51", "4L45", "3L56"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			leechlife: ["7M", "7L35", "7V", "6L1", "5L1", "4L1", "3L1"],
			meanlook: ["7L32", "6L32", "5L33", "4L33", "3L42"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			pluck: ["5M", "4M"],
			poisonfang: ["7L27", "6L27", "5L45", "4L39", "3L49"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickguard: ["7L51", "6L51"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			screech: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			supersonic: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L24", "7V", "6L24", "5L24", "4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			venoshock: ["7M", "7L43", "6M", "6L43", "5M"],
			whirlwind: ["7V"],
			wingattack: ["7L13", "7V", "6L13", "5L17", "4L17", "3L21"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	crobat: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			acrobatics: ["7M", "6M", "6L33", "5M", "5L39"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["7L19", "6L19", "5L27", "4T", "4L27", "3L35"],
			airslash: ["7L48", "6L48", "5L57", "4L51", "4S0"],
			astonish: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L11", "7L1", "6L1", "5L13", "4L13", "3L16"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L17", "6L17", "5L21", "4L21", "3L28"],
			crosspoison: ["7L1", "6L1", "5L1", "4L1"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			haze: ["7L40", "6L40", "5L51", "4L45", "3L56"],
			heatwave: ["6T", "5T", "4T", "4S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			leechlife: ["7M", "7L35", "6L1", "5L1", "4L1", "3L1"],
			meanlook: ["7L32", "6L32", "5L33", "4L33", "3L42"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			pluck: ["5M", "4M"],
			poisonfang: ["7L27", "6L27", "5L45", "4L39", "3L49"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickguard: ["7L51", "6L51"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			screech: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			skyattack: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "4S0", "3M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T", "4S0"],
			supersonic: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L24", "6L24", "5L24", "4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			venoshock: ["7M", "7L43", "6M", "6L43", "5M"],
			wingattack: ["7L13", "6L13", "5L17", "4L17", "3L21"],
			xscissor: ["7M", "6M", "5M", "4M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	oddish: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S1"],
			acid: ["7L9", "7V", "6L9", "5L9", "4L9", "3L23", "3S0"],
			afteryou: ["7E", "6T", "6E", "5T", "5E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["7E", "6E", "5E", "4E", "3E"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["6T", "5T", "4T"],
			gigadrain: ["7L31", "6T", "6L31", "5T", "5L37", "5D", "4M", "4L37", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grassyterrain: ["7L47", "6L45"],
			growth: ["7L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			ingrain: ["7E", "6E", "5E", "4E", "3E"],
			leechseed: ["3S1"],
			luckychant: ["7L23", "6L23", "5L25", "4L25"],
			megadrain: ["7L19", "7V", "6L19", "5L21", "4L21"],
			mimic: ["7V", "3T"],
			moonblast: ["7L43", "6L43"],
			moonlight: ["7L27", "6L27", "5L33", "4L33", "3L32"],
			naturalgift: ["7L39", "6L29", "5L29", "4M", "4L29"],
			naturepower: ["7M", "7E", "6M", "6E", "5E"],
			petaldance: ["7L51", "7V", "6L41", "5L41", "4L41", "3L39"],
			poisonpowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L14", "3S0"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			razorleaf: ["7E", "6E", "5E", "4E", "3E"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["7E", "6M", "6E", "5E", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeppowder: ["7L15", "7V", "6L15", "5L17", "4L17", "3L18", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stunspore: ["7L14", "7V", "6L14", "5L15", "4L15", "3L16", "3S0"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L5", "6L5", "5L5", "5D", "4L5", "3L7"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			synthesis: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			takedown: ["7V"],
			teeterdance: ["7E", "6E", "5E", "5D", "4E"],
			tickle: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "7L35", "7V", "6M", "6L35", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	gloom: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			acid: ["7L9", "7L1", "7V", "6L1", "5L1", "4L1", "3L24", "3S0"],
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["6T", "5T", "4T"],
			gigadrain: ["7L34", "6T", "6L34", "5T", "5L47", "4M", "4L47", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grassyterrain: ["7L54", "6L54"],
			growth: ["7L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			luckychant: ["7L24", "6L24", "5L29", "4L29"],
			megadrain: ["7L19", "7V", "6L19", "5L23", "4L23"],
			mimic: ["7V", "3T"],
			moonlight: ["7L29", "6L29", "5L41", "4L41", "3L35", "3S0"],
			naturalgift: ["7L44", "6L35", "5L35", "4M", "4L35"],
			naturepower: ["7M", "6M"],
			petalblizzard: ["7L49", "6L49"],
			petaldance: ["7L59", "7V", "6L53", "5L53", "4L53", "3L44", "3S0"],
			poisonpowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeppowder: ["7L15", "7V", "6L15", "5L17", "4L17", "3L18", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stunspore: ["7L14", "7V", "6L14", "5L15", "4L15", "3L16"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			takedown: ["7V"],
			toxic: ["7M", "7L39", "7V", "6M", "6L39", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	vileplume: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			acid: ["7V"],
			afteryou: ["6T", "5T"],
			aromatherapy: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["6T", "5T", "4T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			megadrain: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			petalblizzard: ["7L49", "6L49"],
			petaldance: ["7L59", "7V", "6L53", "5L53", "4L53", "3L44"],
			poisonpowder: ["7L1", "7V", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeppowder: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L69", "7V", "6M", "6L64", "5M", "5L65", "4M", "4L65", "3M"],
			stunspore: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	bellossom: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["6T", "5T", "4T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			leafblade: ["7L1", "6L1", "5L1", "4L1"],
			leafstorm: ["7L69", "7L1", "6L1", "5L53", "4L53"],
			magicalleaf: ["7L1", "6L23", "5L23", "4L23", "3L1"],
			megadrain: ["7L1", "6L1", "5L1", "4L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			petalblizzard: ["7L49", "6L49"],
			petaldance: ["7L59", "3L44"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quiverdance: ["7L39"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M", "3L55"],
			stunspore: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	paras: {
		inherit: true,
		learnset: {
			absorb: ["7L11"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			afteryou: ["6T", "5T"],
			agility: ["7E", "6E", "5E", "4E"],
			aromatherapy: ["7L43", "6L43", "5L43", "4L38", "3L49"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bugbite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			crosspoison: ["7E", "6E", "5E", "5D", "4E"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M", "4E", "3E", "3S0"],
			fellstinger: ["7E", "6E"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L17", "6L17", "5L17", "4T", "3T"],
			gigadrain: ["7L38", "6T", "6L38", "5T", "5L38", "4M", "4L33", "3M", "3L43"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["7L33", "7V", "6L33", "5L33", "4L27", "3L37"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			knockoff: ["6T", "5T", "4T"],
			leechlife: ["7M", "7V", "6L11", "5L11", "4L11", "3L19"],
			leechseed: ["7E", "6E", "5E"],
			lightscreen: ["7M", "6M", "5M", "4E", "3E"],
			megadrain: ["7V"],
			metalclaw: ["7E", "6E", "5E", "4E"],
			mimic: ["7V", "3T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			naturepower: ["7M", "6M"],
			poisonpowder: ["7L6", "6L6", "5L6", "4L6", "3L13"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7E", "6E", "5E", "4E", "3E"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			rage: ["7V"],
			ragepowder: ["7L49", "6L49", "5L49"],
			reflect: ["7V"],
			refresh: ["3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rototiller: ["7E", "6E"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			slash: ["7L27", "7V", "6L27", "5L27", "4L22", "3L31", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			spore: ["7L22", "7V", "6L22", "5L22", "4L17", "3L25", "3S0"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["7L6", "7V", "6L6", "5L6", "5D", "4L6", "3L7"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7E", "6E", "5E", "4E", "3E"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "5D", "4T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			wideguard: ["7E", "6E"],
			worryseed: ["6T", "5T", "4T"],
			xscissor: ["7M", "7L54", "6M", "6L54", "5M", "5L54", "4M", "4L43"],
		},
	},
	parasect: {
		inherit: true,
		learnset: {
			absorb: ["7L11", "7L1"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			afteryou: ["6T", "5T"],
			aromatherapy: ["7L51", "6L51", "5L51", "4L47", "3L59"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bugbite: ["6T", "5T", "4T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crosspoison: ["7L1", "6L1", "5L1", "4L1"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L17", "6L17", "5L17", "4T", "3T"],
			gigadrain: ["7L44", "6T", "6L44", "5T", "5L44", "4M", "4L39", "3M", "3L51"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["7L37", "7V", "6L37", "5L37", "4L30", "3L43"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			leechlife: ["7M", "7V", "6L1", "5L1", "4L1", "3L19"],
			lightscreen: ["7M", "6M", "5M"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			poisonpowder: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			ragepowder: ["7L59", "6L59", "5L59"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			slash: ["7L29", "7V", "6L29", "5L29", "4L22", "3L35"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			spore: ["7L22", "7V", "6L22", "5L22", "4L17", "3L27"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["7L6", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T", "4T"],
			xscissor: ["7M", "7L66", "6M", "6L66", "5M", "5L66", "4M", "4L55"],
		},
	},
	venonat: {
		inherit: true,
		learnset: {
			agility: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7E", "6E", "5E", "5D", "4E", "3E"],
			bide: ["7V"],
			bugbite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L11", "7V", "6L11", "5L11", "4L11", "3L17"],
			disable: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			foresight: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7E", "6T", "6E", "5T", "5E", "4M", "4E", "3M", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			leechlife: ["7M", "7L35", "7V", "6L17", "5L17", "4L17", "3L25"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			morningsun: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			poisonfang: ["7L41", "6L41", "5L41", "4L41"],
			poisonpowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L20"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L17", "7V", "6L25", "5L25", "4L25", "3L33"],
			psychic: ["7M", "7L47", "7V", "6M", "6L47", "5M", "5L47", "4M", "4L47", "3M", "3L41"],
			psywave: ["7V"],
			rage: ["7V"],
			ragepowder: ["7E", "6E", "5E"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["7E", "6M", "6E", "5E", "4M", "3M"],
			signalbeam: ["7L25", "7E", "6T", "6L35", "6E", "5T", "5L35", "5E", "4T", "4L35", "4E", "3E"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "5D", "4M", "3M"],
			sleeppowder: ["7L29", "7V", "6L29", "5L29", "4L29", "3L36"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["7L23", "7V", "6L23", "5L23", "4L23", "3L28"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L5", "7V", "6L5", "5L5", "4L5", "3L9"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7E", "6E", "5E", "4E"],
			venoshock: ["7M", "6M", "5M"],
			zenheadbutt: ["7L37", "6T", "6L37", "5T", "5L37", "4T", "4L37"],
		},
	},
	venomoth: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L59", "7L1", "6L1", "5L59", "4L59"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L11", "7V", "6L11", "5L11", "4L11", "3L17"],
			defog: ["4M"],
			disable: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			foresight: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L1", "6L31", "5L31", "4L31", "3L31"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			leechlife: ["7M", "7L37", "7V", "6L17", "5L17", "4L17", "3L25"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonfang: ["7L47", "6L47", "5L47", "4L47"],
			poisonpowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L20"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L17", "7V", "6L25", "5L25", "4L25", "3L36"],
			psychic: ["7M", "7L55", "7V", "6M", "6L55", "5M", "5L55", "4M", "4L55", "3M", "3L52", "3S0"],
			psywave: ["7V"],
			quiverdance: ["7L63", "7L1", "6L1", "5L63"],
			rage: ["7V"],
			razorwind: ["7V"],
			reflect: ["7V"],
			refresh: ["3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["7L25", "6T", "6L37", "5T", "5L37", "4T", "4L37"],
			silverwind: ["7L1", "6L1", "5L1", "4M", "4L1", "3L1", "3S0"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeppowder: ["7L29", "7V", "6L29", "5L29", "4L29", "3L42"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["7L23", "7V", "6L23", "5L23", "4L23", "3L28"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T", "3S0"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			venoshock: ["7M", "6M", "5M"],
			whirlwind: ["7V"],
			zenheadbutt: ["7L41", "6T", "6L41", "5T", "5L41", "4T", "4L41"],
		},
	},
	diglett: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["7E", "6E", "5E", "4E", "3E"],
			astonish: ["7L7", "7E", "6L7", "6E", "5L7", "5E", "4L7", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			beatup: ["7E", "6E", "5E", "5D", "4E", "3E"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			bulldoze: ["7M", "7L18", "6M", "6L18", "5M", "5L18"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dig: ["7L31", "7V", "6M", "6L34", "5M", "5L34", "4M", "4L18", "3M", "3L17"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthpower: ["7L28", "6T", "6L29", "5T", "5L29", "4T", "4L26"],
			earthquake: ["7M", "7L39", "7V", "6M", "6L40", "5M", "5L40", "4M", "4L37", "3M", "3L41"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			finalgambit: ["7E", "6E", "5E"],
			fissure: ["7L43", "7V", "6L45", "5L45", "4L40", "3L49"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["3L21"],
			growl: ["7L4", "7V", "6L4", "5L4", "4L4", "3L5"],
			headbutt: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			magnitude: ["7L14", "6L15", "5L15", "4L12", "3L9"],
			memento: ["7E", "6E", "5E"],
			mimic: ["7V", "3T"],
			mudbomb: ["7L25", "7E", "6L26", "6E", "5L26", "5E", "4L29", "4E"],
			mudslap: ["7L10", "6L12", "5L12", "4T", "4L15", "3T", "3L25"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			rage: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7E", "6E", "5E", "4E"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L35", "7V", "6L37", "5L37", "4L34", "3L33"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "5D", "4M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L22", "6L23", "5L23", "4T", "4L23"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["7E", "6E", "5T", "5E", "4E", "3E"],
		},
	},
	diglettalola: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			ancientpower: ["7E"],
			astonish: ["7L7", "7S0"],
			attract: ["7M"],
			beatup: ["7E"],
			bulldoze: ["7M", "7L18"],
			confide: ["7M"],
			dig: ["7L31"],
			doubleteam: ["7M"],
			earthpower: ["7L28"],
			earthquake: ["7M", "7L39"],
			echoedvoice: ["7M"],
			endure: ["7E"],
			facade: ["7M"],
			feintattack: ["7E"],
			finalgambit: ["7E"],
			fissure: ["7L43"],
			flashcannon: ["7M"],
			frustration: ["7M"],
			growl: ["7L4", "7S0"],
			headbutt: ["7E"],
			hiddenpower: ["7M"],
			ironhead: ["7L35"],
			magnitude: ["7L14"],
			memento: ["7E"],
			metalclaw: ["7L1", "7S0"],
			metalsound: ["7E"],
			mudbomb: ["7L25"],
			mudslap: ["7L10", "7S0"],
			protect: ["7M"],
			pursuit: ["7E"],
			rest: ["7M"],
			return: ["7M"],
			reversal: ["7E"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			sandattack: ["7L1"],
			sandstorm: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L22"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			thief: ["7M"],
			thrash: ["7E"],
			toxic: ["7M"],
			workup: ["7M"],
		},
	},
	dugtrio: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			astonish: ["7L7", "6L7", "5L7", "4L7"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			bulldoze: ["7M", "7L18", "6M", "6L18", "5M", "5L18"],
			captivate: ["4M"],
			charm: ["3S0"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dig: ["7L35", "7V", "6M", "6L40", "5M", "5L40", "4M", "4L18", "3M", "3L17"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthpower: ["7L30", "6T", "6L33", "5T", "5L33", "4T", "4L28"],
			earthquake: ["7M", "7L47", "7V", "6M", "6L50", "5M", "5L50", "4M", "4L45", "3M", "3L51", "3S0"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7L53", "7V", "6L57", "5L57", "4L50", "3L64"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["3L21"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			magnitude: ["7L14", "6L15", "5L15", "4L12", "3L9"],
			mimic: ["7V", "3T"],
			mudbomb: ["7L25", "6L28", "5L28", "4L33"],
			mudslap: ["7L10", "6L12", "5L12", "4T", "4L15", "3T", "3L25"],
			naturalgift: ["4M"],
			nightslash: ["7L1", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rototiller: ["7L1", "6L1"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			sandstorm: ["7M", "6M", "5M", "4M", "3S0"],
			sandtomb: ["7L1", "6L26", "5L26", "4L26", "3L26"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L41", "7V", "6L45", "5L45", "4L40", "3L38"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L22", "6L23", "5L23", "4T", "4L23"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			uproar: ["5T"],
		},
	},
	dugtrioalola: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			astonish: ["7L7"],
			attract: ["7M"],
			bulldoze: ["7M", "7L18"],
			confide: ["7M"],
			dig: ["7L35"],
			doubleteam: ["7M"],
			earthpower: ["7L30"],
			earthquake: ["7M", "7L47"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			fissure: ["7L53"],
			flashcannon: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			growl: ["7L4", "7L1"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			ironhead: ["7L41"],
			magnitude: ["7L14"],
			metalclaw: ["7L1"],
			mudbomb: ["7L25"],
			mudslap: ["7L10"],
			nightslash: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			rototiller: ["7L1"],
			round: ["7M"],
			sandattack: ["7L1"],
			sandstorm: ["7M"],
			sandtomb: ["7L1"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L22"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			thief: ["7M"],
			toxic: ["7M"],
			triattack: ["7L1"],
			workup: ["7M"],
		},
	},
	meowth: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			amnesia: ["7E", "6E", "5E", "4E", "3E"],
			assist: ["7E", "6E", "5E", "4E", "4S5", "3E"],
			assurance: ["7L41", "6L41", "5L41", "4L41"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L6", "7V", "6L6", "6S7", "5L6", "4L6", "4S4", "3L10", "3S2", "3S3"],
			bodyslam: ["7V", "3T"],
			bubblebeam: ["7V"],
			captivate: ["7L46", "6L46", "5L46", "4M", "4L46"],
			charm: ["7E", "6E", "5E", "4E", "3E"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L9", "6L9", "6S7", "5L9", "4L9", "4S4", "4S5", "3L43"],
			feint: ["7L50", "6L50", "5L54", "4L54"],
			feintattack: ["7L22", "6L22", "5L22", "4L22", "3L25"],
			flail: ["7E", "6E", "5E", "4E"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["7E", "6T", "6E", "5T", "5E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7L14", "7V", "6L14", "5L14", "5S6", "4L14", "4S4", "3L36"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1", "3S2"],
			gunkshot: ["6T", "5T", "4T"],
			happyhour: ["6S7"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["7E", "6E", "5E", "5D", "4E", "3E"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L38", "6L38", "5L38", "5S6", "4L38"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["7L49", "6L49", "5L49", "4L49"],
			odorsleuth: ["7E", "6E", "5E", "4E"],
			payback: ["7M", "6M", "5M", "4M"],
			payday: ["7L30", "7V", "6L30", "5L30", "4L30", "4S5", "3L18", "3S3"],
			petaldance: ["3S0"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			punishment: ["7E", "6E", "5E", "4E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "4S5", "3L1", "3S0", "3S1", "3S2"],
			screech: ["7L17", "7V", "6L17", "6S7", "5L17", "4L17", "4S4", "3L31"],
			secretpower: ["6M", "5D", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			sing: ["5S6", "3S3"],
			skullbash: ["7V"],
			slash: ["7L33", "7V", "6L33", "5L33", "4L33", "3L40", "3S3"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["7E", "6T", "6E", "5T", "5E", "5S6", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T", "3L45"],
			swift: ["7V", "4T", "3T"],
			tailwhip: ["7E", "6E", "5E", "4E"],
			takedown: ["7V"],
			taunt: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "4M", "4L25", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			workup: ["7M", "5M"],
		},
	},
	meowthalola: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			amnesia: ["7E"],
			assist: ["7E"],
			assurance: ["7L41"],
			attract: ["7M"],
			bite: ["7L6"],
			captivate: ["7L46"],
			charm: ["7E"],
			confide: ["7M"],
			covet: ["7E"],
			darkpulse: ["7M", "7L55"],
			doubleteam: ["7M"],
			dreameater: ["7M"],
			echoedvoice: ["7M"],
			embargo: ["7M"],
			facade: ["7M"],
			fakeout: ["7L9"],
			feint: ["7L50"],
			feintattack: ["7L22"],
			flail: ["7E"],
			flatter: ["7E"],
			foulplay: ["7E"],
			frustration: ["7M"],
			furyswipes: ["7L14"],
			growl: ["7L1"],
			hiddenpower: ["7M"],
			hypnosis: ["7E"],
			nastyplot: ["7L38"],
			nightslash: ["7L49"],
			partingshot: ["7E"],
			payback: ["7M"],
			payday: ["7L30"],
			protect: ["7M"],
			psychup: ["7M"],
			punishment: ["7E"],
			quash: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			scratch: ["7L1"],
			screech: ["7L17"],
			shadowball: ["7M"],
			shadowclaw: ["7M"],
			slash: ["7L33"],
			sleeptalk: ["7M"],
			snatch: ["7E"],
			spite: ["7E"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			taunt: ["7M", "7L25"],
			thief: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			workup: ["7M"],
		},
	},
	persian: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			assurance: ["7L49", "6L49", "5L49", "4L49"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L6", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["7V", "3T"],
			bubblebeam: ["7V"],
			captivate: ["7L56", "6L56", "5L56", "4M", "4L56"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L55"],
			feint: ["7L65", "6L65", "5L68", "4L68"],
			feintattack: ["7L22", "6L22", "5L22", "4L22", "3L25"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7L14", "7V", "6L14", "5L14", "4L14", "3L42"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L44", "6L44", "5L44", "4L44"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["7L61", "6L61", "5L61", "4L61"],
			payback: ["7M", "6M", "5M", "4M"],
			payday: ["7V", "3L18"],
			playrough: ["7L1", "6L1"],
			powergem: ["7L32", "6L32", "5L32", "4L32"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7L17", "7V", "6L17", "5L17", "4L17", "3L34"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			slash: ["7L37", "7V", "6L37", "5L37", "4L37", "3L49"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T", "3L61"],
			swift: ["7L1", "7V", "6L28", "5L28", "4T", "3T"],
			switcheroo: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7V"],
			taunt: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "4M", "4L25", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			workup: ["7M", "5M"],
		},
	},
	persianalola: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			assurance: ["7L49"],
			attract: ["7M"],
			bite: ["7L6", "7L1"],
			captivate: ["7L56"],
			confide: ["7M"],
			darkpulse: ["7M", "7L69"],
			doubleteam: ["7M"],
			dreameater: ["7M"],
			echoedvoice: ["7M"],
			embargo: ["7M"],
			facade: ["7M"],
			fakeout: ["7L9", "7L1"],
			feint: ["7L65"],
			feintattack: ["7L22"],
			frustration: ["7M"],
			furyswipes: ["7L14"],
			gigaimpact: ["7M"],
			growl: ["7L1"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			nastyplot: ["7L44"],
			nightslash: ["7L61"],
			payback: ["7M"],
			playrough: ["7L1"],
			powergem: ["7L32"],
			protect: ["7M"],
			psychup: ["7M"],
			quash: ["7M", "7L1"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			round: ["7M"],
			scratch: ["7L1"],
			screech: ["7L17"],
			shadowball: ["7M"],
			shadowclaw: ["7M"],
			slash: ["7L37"],
			sleeptalk: ["7M"],
			snarl: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swift: ["7L1"],
			switcheroo: ["7L1"],
			taunt: ["7M", "7L25"],
			thief: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			workup: ["7M"],
		},
	},
	psyduck: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			amnesia: ["7L37", "6L43", "5L48", "4L44"],
			aquatail: ["7L28", "6T", "6L29", "5T", "5L32", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["5D", "4M"],
			bubblebeam: ["7V"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["7E", "6E"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "4E"],
			confusion: ["7L10", "7V", "6L11", "5L18", "4L18", "3L16", "3S0"],
			counter: ["7V", "3T"],
			crosschop: ["7E", "6E", "5E", "4E", "3E"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			disable: ["7L19", "7V", "6L11", "5L14", "4L14", "3L10", "3S0"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["7E", "6E", "5E", "5D", "4E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7L13", "7V", "6L15", "5L27", "4L27", "3L40"],
			futuresight: ["7E", "6E", "5E", "4E", "3E"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["7L40", "7V", "6L46", "5L53", "4L48", "3L50"],
			hypnosis: ["7E", "6E", "5E", "4E", "3E"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M", "4E", "3E"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudbomb: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S1"],
			naturalgift: ["4M"],
			payday: ["7V"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7E", "6E", "5E", "4E", "3E"],
			psychic: ["7M", "6M", "5M", "4M", "4E", "3E"],
			psychup: ["7M", "7L34", "6M", "6L39", "5M", "5L40", "4M", "4L35", "3T", "3L31"],
			psyshock: ["7M", "6M", "5M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S1"],
			screech: ["7L22", "6L25", "5L31", "4L31", "3L23", "3S0"],
			secretpower: ["7E", "6M", "6E", "5E", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			simplebeam: ["7E", "6E"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7L31", "6L36", "5L35"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			synchronoise: ["7E", "6E", "5E"],
			tailwhip: ["7L4", "7V", "6L4", "5L5", "4L5", "3L5", "3S0", "3S1"],
			takedown: ["7V"],
			telekinesis: ["5M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L7", "7V", "6L8", "5L9", "4L9"],
			waterpulse: ["7L16", "6T", "6L18", "5L22", "4M", "4L22", "3M"],
			watersport: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S1"],
			whirlpool: ["4M"],
			wonderroom: ["7L43", "6T", "6L50", "5T", "5L57"],
			worryseed: ["6T", "5T", "4T"],
			yawn: ["7E", "6E", "5E", "4E"],
			zenheadbutt: ["7L25", "6T", "6L29", "5T", "5L44", "4T", "4L40"],
		},
	},
	golduck: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			amnesia: ["7L41", "6L49", "5L56", "4L50"],
			aquajet: ["7L1", "6L1", "5L1", "4L1"],
			aquatail: ["7L28", "6T", "6L32", "5T", "5L32", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			brine: ["4M"],
			bubblebeam: ["7V"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			charm: ["3S0"],
			confide: ["7M", "6M"],
			confusion: ["7L10", "7V", "6L11", "5L18", "4L18", "3L16"],
			counter: ["7V", "3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			disable: ["7L19", "7V", "6L11", "5L14", "4L14", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L13", "7V", "6L15", "5L27", "4L27", "3L44"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["7L46", "7V", "6L54", "5L63", "4L56", "3L58"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			mefirst: ["7L1"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payday: ["7V"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "7L36", "6M", "6L43", "5M", "5L44", "4M", "4L37", "3T", "3L31", "3S0"],
			psyshock: ["7M", "6M", "5M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7L22", "6L25", "5L31", "4L31", "3L23"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7L31", "6L38", "5L37"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwhip: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			telekinesis: ["5M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			watergun: ["7L7", "7L1", "7V", "6L1", "5L1", "4L1"],
			waterpulse: ["7L16", "6T", "6L18", "5L22", "4M", "4L22", "3M"],
			watersport: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
			wonderroom: ["7L51", "6T", "6L60", "5T", "5L69"],
			worryseed: ["6T", "5T", "4T"],
			zenheadbutt: ["7L25", "6T", "6L25", "5T", "5L50", "4T", "4L44"],
		},
	},
	mankey: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			assurance: ["7L26", "6L25", "5L25", "4L25"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			beatup: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			closecombat: ["7L36", "7E", "6L49", "6E", "5L49", "5E", "4L49", "4E"],
			confide: ["7M", "6M"],
			counter: ["7E", "7V", "6E", "5E", "4E", "3T", "3E"],
			covet: ["7L1", "6T", "6L1", "5T", "5L1", "4L1"],
			crosschop: ["7L22", "6L37", "5L37", "4L37", "3L31"],
			defensecurl: ["3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dualchop: ["6T", "5T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			encore: ["7E", "6E", "5E", "4E"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			finalgambit: ["7L50", "6L53", "5L53"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L1", "7V", "6L1", "5L1", "4L1", "3L21"],
			focuspunch: ["7E", "6T", "6E", "5E", "4M", "3M"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7L5", "7V", "6L9", "5L9", "4L9", "3L16"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			karatechop: ["7L8", "7V", "6L13", "5L13", "4L13", "3L11"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["7L1", "7V", "6T", "6L1", "5T", "5L1", "5D", "4T", "4L1", "3L6"],
			lowsweep: ["7M", "6M", "5M"],
			meditate: ["7E", "6E", "5E", "4E", "3E"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["7E", "6E"],
			outrage: ["7L47", "6T", "5T", "4T"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			payback: ["7M", "6M", "5M", "4M"],
			payday: ["7V"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			powertrip: ["7E"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			punishment: ["7L29", "6L45", "5L45", "4L45"],
			pursuit: ["7L12"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7E", "6E", "5E", "4E", "3E"],
			reversal: ["7E", "6E", "5E", "5D", "4E", "3E"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7L40", "7V", "6L21", "5L21", "4L21", "3L41"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["7L15", "7V", "6L17", "5L17", "4L17", "3T", "3L26"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			smellingsalts: ["7E", "6E", "5E", "4E", "3E"],
			snore: ["6T", "3T"],
			spite: ["6T", "5T", "4T"],
			stompingtantrum: ["7L43"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L19", "6M", "6L33", "5M", "5L33", "4M", "4L33", "3T", "3L36"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L33", "7V", "6L41", "5L41", "4L41", "3L46"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "5D", "4T", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["4T"],
			workup: ["7M", "5M"],
		},
	},
	primeape: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			assurance: ["7L26", "6L25", "5L25", "4L25"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			closecombat: ["7L39", "6L59", "5L59", "4L59"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			covet: ["6T", "5T"],
			crosschop: ["7L22", "6L41", "5L41", "4L41", "3L35", "3S0"],
			defensecurl: ["3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dualchop: ["6T", "5T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			finalgambit: ["7L57", "7L1", "6L1", "5L63"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fling: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L1", "7V", "6L1", "5L1", "4L1", "3L21", "3S0"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7L5", "7V", "6L9", "5L9", "4L9", "3L16"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T", "3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			karatechop: ["7L8", "7V", "6L13", "5L13", "4L13", "3L11"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["7L1", "7V", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["7L53", "6T", "5T", "4T"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			payback: ["7M", "6M", "5M", "4M"],
			payday: ["7V"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			punishment: ["7L30", "6L53", "5L53", "4L53"],
			pursuit: ["7L12"],
			rage: ["7L1", "7V", "6L28", "5L28", "4L28", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["3S0"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7L44", "7V", "6L21", "5L21", "4L21", "3L53"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["7L15", "7V", "6L17", "5L17", "4L17", "3T", "3L26"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "3T"],
			spite: ["6T", "5T", "4T"],
			stompingtantrum: ["7L48"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L19", "6M", "6L35", "5M", "5L35", "4M", "4L35", "3T", "3L44"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L35", "7V", "6L47", "5L47", "4L47", "3L62"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["4T"],
			workup: ["7M", "5M"],
		},
	},
	growlithe: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L30", "7V", "6L30", "5L42", "4L39", "3L43"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1", "3S1", "3S2"],
			bodyslam: ["7E", "7V", "6E", "5E", "5D", "4E", "3T", "3E"],
			burnup: ["7E"],
			captivate: ["4M"],
			charm: ["3S2"],
			closecombat: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E", "5T", "5E"],
			crunch: ["7L39", "7E", "6L39", "6E", "5L45", "5E", "4L42", "4E", "3E"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7E", "7V", "6E", "5E", "4E", "3T"],
			doublekick: ["7E", "6E", "5E"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonrage: ["7V"],
			ember: ["7L6", "7V", "6L6", "5L6", "4L6", "3L7", "3S1"],
			endure: ["5D", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firefang: ["7L21", "6L21", "5L28", "4L28"],
			firespin: ["7E", "6E", "5E", "4E", "3E"],
			flameburst: ["7L28", "6L28", "5L31"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L34", "7V", "6M", "6L34", "5M", "5L39", "4M", "4L34", "3M", "3L49", "3S2"],
			flamewheel: ["7L17", "6L17", "5L20", "4L20", "3L31", "3S0"],
			flareblitz: ["7L45", "7E", "6L45", "6E", "5L56", "5E", "4L48", "4E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["7L41", "7E", "6T", "6L41", "6E", "5T", "5L51", "5E", "4T", "4L45", "4E", "3E"],
			helpinghand: ["7L12", "6T", "6L12", "5T", "5L17", "4T", "4L17", "3L37"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7E", "6E", "5E", "4E", "3E"],
			incinerate: ["6M", "5M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			leer: ["7L8", "7V", "6L8", "5L9", "4L9", "3L13", "3S0"],
			mimic: ["7V", "3T"],
			morningsun: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["7L10", "6L10", "5L14", "4L14", "3L19", "3S0"],
			outrage: ["7L43", "6T", "6L43", "5T", "5L43"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["7L32", "6M", "6L32", "5M", "5L48"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7L19", "6L19", "5L25", "4L25"],
			roar: ["7M", "7L1", "7V", "6M", "6L1", "5M", "5L1", "5D", "4M", "4L1", "3M", "3L1", "3S1"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7L23", "7V", "6L23", "5L34", "4L31", "3L25", "3S0", "3S2"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	arcanine: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["7V", "3T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			crunch: ["4S0"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrage: ["7V"],
			ember: ["7V", "3L1"],
			endure: ["4M", "3T"],
			extremespeed: ["7L34", "7S1", "6L34", "5L39", "4L39", "4S0", "3L49"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flareblitz: ["7S1", "4S0"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7V"],
			mimic: ["7V", "3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			outrage: ["6T", "5T"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			protect: ["7M", "7S1", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L1", "7V", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7V"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1", "4S0"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "7S1", "6M", "5M", "4M"],
		},
	},
	poliwag: {
		inherit: true,
		learnset: {
			amnesia: ["7V"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bellydrum: ["7L31", "6L31", "5L31", "4L31", "3L37"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L21", "7V", "6L21", "5L21", "4L21", "3T", "3L31"],
			bubble: ["7L11", "7V", "6L11", "5L5", "4L5", "3L1", "3S0"],
			bubblebeam: ["7L25", "7E", "7V", "6L25", "6E", "5L25", "5E", "4L25", "4E", "3E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleslap: ["7L15", "7V", "6L15", "5L15", "4L15", "3L19"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			encore: ["7E", "6E", "5E", "4E"],
			endeavor: ["7E", "6T", "6E", "5T", "5E", "4E"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L38", "7V", "6L38", "5L38", "4L38", "3L43"],
			hypnosis: ["7L8", "7V", "6L8", "5L8", "5D", "4L8", "3L7"],
			iceball: ["7E", "6E", "5E", "4E", "3E"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			mimic: ["7V", "3T"],
			mindreader: ["7E", "6E", "5E", "4E", "3E"],
			mist: ["7E", "6E", "5E", "5D", "4E", "3E"],
			mudbomb: ["7L41", "6L41", "5L41", "4L41"],
			mudshot: ["7L28", "7E", "6L28", "6E", "5L28", "5E", "4L28", "4E"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "7L18", "6M", "6L18", "5M", "5L18", "4M", "4L18", "3M", "3L25"],
			refresh: ["7E", "6E", "5E", "4E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "5D", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			splash: ["7E", "6E", "5E", "4E", "3E"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["3S0"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			wakeupslap: ["7L35", "6L35", "5L35", "4L35"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L5", "7V", "6L5", "5L11", "4L11", "3L13"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			watersport: ["7L1", "7E", "6L1", "6E", "5L1", "5E", "4L1", "4E", "3E"],
			whirlpool: ["4M"],
		},
	},
	poliwhirl: {
		inherit: true,
		learnset: {
			amnesia: ["7V"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bellydrum: ["7L37", "6L37", "5L37", "4L37", "3L43"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L21", "7V", "6L21", "5L21", "4L21", "3T", "3L35"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubble: ["7L11", "7V", "6L11", "5L1", "4L1", "3L1"],
			bubblebeam: ["7L27", "7V", "6L27", "5L27", "4L27"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleslap: ["7L15", "7V", "6L15", "5L15", "4L15", "3L19"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endeavor: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7V"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L48", "7V", "6L48", "5L48", "4L48", "3L51"],
			hypnosis: ["7L8", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudbomb: ["7L53", "6L53", "5L53", "4L53"],
			mudshot: ["7L32", "6L32", "5L32", "4L32"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "7L18", "6M", "6L18", "5M", "5L18", "4M", "4L18", "3M", "3L27"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			wakeupslap: ["7L43", "6L43", "5L43", "4L43"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L5", "7L1", "7V", "6L1", "5L11", "4L11", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			watersport: ["7L1", "6L1", "5L1", "4L1"],
			whirlpool: ["4M"],
		},
	},
	poliwrath: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			bubblebeam: ["7L1", "7V", "6L1", "5L1", "4L1"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			circlethrow: ["7L53", "7L1", "6L1", "5L53"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleslap: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["7L32", "6L32", "5L32", "4L43", "3T"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endeavor: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7V"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T", "3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["3S0"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypnosis: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mindreader: ["7L43", "6L43", "5L43", "4L53", "3L51"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
		},
	},
	politoed: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["7L37", "6T", "6L37", "5T", "5L37", "4T", "4L37"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7L1", "6L1", "5L1", "4L1"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["7L48", "6T", "6L48", "5T", "5L48", "4L48"],
			hypnosis: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			icebeam: ["7M", "6M", "5M", "5S0", "4M", "3M"],
			icepunch: ["6T", "5T"],
			icywind: ["6T", "5T", "4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			perishsong: ["7L1", "6L1", "5L1", "5S0", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "5S0", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M", "5S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L27", "6M", "6L27", "5M", "5L27", "4M", "4L27", "3T", "3L51"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["3L1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	abra: {
		inherit: true,
		learnset: {
			allyswitch: ["7E", "6E", "5M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["7M", "6M", "5M", "4M"],
			encore: ["7E", "6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "5D", "4T"],
			guardsplit: ["7E", "6E", "5E"],
			guardswap: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powertrick: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychoshift: ["7E", "6E"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "5D", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	kadabra: {
		inherit: true,
		learnset: {
			allyswitch: ["7L36", "6L24", "5M", "5L24"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L16", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			counter: ["7V", "3T"],
			dazzlinggleam: ["7M", "6M"],
			dig: ["7V"],
			disable: ["7L18", "7V", "6L18", "5L18", "4L18", "3L18"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L43", "6L43", "5L48", "4L42", "3L30"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			kinesis: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			knockoff: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			miracleeye: ["7L23", "6L22", "5L22", "4L22"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L21", "7V", "6L21", "5L28", "4L24", "3L21"],
			psychic: ["7M", "7L38", "7V", "6M", "6L38", "5M", "5L46", "4M", "4L40", "3M", "3L36"],
			psychocut: ["7L28", "6L28", "5L40", "4L34"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L31", "7V", "6L31", "5L36", "4L30", "3L25"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7L26", "7V", "6M", "6L26", "5M", "5L30", "4M", "4L28", "3M", "3L23"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["7L41", "6T", "6L41", "5T", "5L42", "4T", "4L36", "3L33"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["7L33", "6L33", "5M", "5L34"],
			teleport: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["7L46", "6T", "6L46", "5T", "5L52", "4T", "4L46", "3L43"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	alakazam: {
		inherit: true,
		learnset: {
			allyswitch: ["7L36", "6L24", "5M", "5L24"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			calmmind: ["7M", "7L41", "6M", "6L41", "5M", "5L42", "4M", "4L36", "3M", "3L33", "3S0"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L16", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			counter: ["7V", "3T"],
			dazzlinggleam: ["7M", "6M"],
			dig: ["7V"],
			disable: ["7L18", "7V", "6L18", "5L18", "4L18", "3L18"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L43", "6L43", "5L48", "4L42", "3L30", "3S0"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			kinesis: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			knockoff: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			miracleeye: ["7L23", "6L22", "5L22", "4L22"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L21", "7V", "6L21", "5L28", "4L24", "3L21"],
			psychic: ["7M", "7L38", "7V", "6M", "6L38", "5M", "5L46", "4M", "4L40", "3M", "3L36", "3S0"],
			psychocut: ["7L28", "6L28", "5L40", "4L34"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L31", "7V", "6L31", "5L36", "4L30", "3L25"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7L26", "7V", "6M", "6L26", "5M", "5L30", "4M", "4L28", "3M", "3L23"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["7L33", "6L33", "5M", "5L34"],
			teleport: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["7L46", "6T", "6L46", "5T", "5L52", "4T", "4L46", "3L43", "3S0"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	machop: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "7L37", "6M", "6L37", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7E", "6E", "5E", "5D", "4E"],
			captivate: ["4M"],
			closecombat: ["7E", "6E", "5E", "4E"],
			confide: ["7M", "6M"],
			counter: ["7E", "7V", "6E", "5E", "4E", "3T", "3E"],
			crosschop: ["7L39", "6L39", "5L43", "4L37", "3L40"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dualchop: ["7L31", "6T", "6L31", "5T"],
			dynamicpunch: ["7L45", "6L45", "5L49", "4L46", "3T", "3L49"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			encore: ["7E", "6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L3", "7V", "6L3", "5L7", "4L7", "3L7"],
			focuspunch: ["6T", "4M", "3M"],
			foresight: ["7L9", "6L9", "5L19", "4L13", "3L22"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["7E", "6E", "5E"],
			helpinghand: ["6T", "5T", "5D", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T"],
			incinerate: ["6M", "5M"],
			karatechop: ["7L7", "7V", "6L7", "5L10", "4L10", "3L13"],
			knockoff: ["7L21", "7E", "6T", "6L21", "6E", "5T", "5E"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4E", "3E"],
			lowkick: ["7L1", "7V", "6T", "6L1", "5T", "5L1", "5D", "4T", "4L1", "3L1"],
			lowsweep: ["7M", "7L13", "6M", "6L13", "5M", "5L13"],
			meditate: ["7E", "6E", "5E", "4E", "3E"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			powertrick: ["7E", "6E", "5E", "4E"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickguard: ["7E", "6E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7L19", "6L19", "5L25", "4L22", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			rollingkick: ["7E", "6E", "5E", "4E", "3E"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L43", "6L43", "5L46", "4L43", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7L15", "7V", "6L15", "5L22", "4L19", "3T", "3L19"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			smellingsalts: ["7E", "6E", "5E", "4E", "3E"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7L33", "7V", "6L33", "5L34", "4L31", "3L37"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T"],
			tickle: ["7E", "6E", "5E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["7L25", "6L25", "5L31", "4L25", "3L31"],
			wakeupslap: ["7L27", "6L27", "5L37", "4L34"],
			workup: ["7M", "5M"],
		},
	},
	machoke: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "7L43", "6M", "6L43", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			crosschop: ["7L47", "6L44", "5L44", "4L40", "3L46"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dualchop: ["7L33", "6T", "6L33", "5T"],
			dynamicpunch: ["7L57", "6L55", "5L55", "4L51", "3T", "3L59"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L3", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["6T", "4M", "3M"],
			foresight: ["7L9", "6L9", "5L19", "5S0", "4L13", "3L22"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			karatechop: ["7L7", "7L1", "7V", "6L1", "5L1", "4L10", "3L13"],
			knockoff: ["7L21", "6T", "6L21", "5T"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M"],
			lowkick: ["7L1", "7V", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			lowsweep: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "5S0"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7L19", "6L19", "5L25", "5S0", "4L22", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L53", "6L51", "5L51", "4L44", "3L51"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7L15", "7V", "6L15", "5L22", "5S0", "4L19", "3T", "3L19"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7L37", "7V", "6L36", "5L36", "4L32", "3L41"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["7L25", "6L25", "5L32", "4L25", "3L33"],
			wakeupslap: ["7L27", "6L27", "5L40", "4L36"],
			workup: ["7M", "5M"],
		},
	},
	machamp: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "7L43", "7S2", "6M", "6L43", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["4C"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			crosschop: ["7L47", "6L44", "5L44", "4L40", "3L46"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7S2", "7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dualchop: ["7L33", "6T", "6L33", "5T"],
			dynamicpunch: ["7L57", "6L55", "6S1", "5L55", "4L51", "3T", "3L59"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L3", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["6T", "4M", "3M"],
			foresight: ["7L9", "6L9", "5L19", "4L13", "3L22", "3S0"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			karatechop: ["7L7", "7L1", "7V", "6L1", "5L1", "4L10", "3L13"],
			knockoff: ["7L21", "6T", "6L21", "6S1", "5T"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M"],
			lowkick: ["7L1", "7V", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			lowsweep: ["7M", "7L13", "6M", "6L13", "5M", "5L13"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickguard: ["7S2"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7L19", "6L19", "5L25", "4L22", "3L25", "3S0"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L53", "6L51", "5L51", "4L44", "3L51"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7L15", "7V", "6L15", "5L22", "4L19", "3T", "3L19", "3S0"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stoneedge: ["7M", "6M", "6S1", "5M", "4M"],
			strength: ["7L1", "7S2", "7V", "6M", "5M", "4M", "3M"],
			submission: ["7L37", "7V", "6L36", "5L36", "4L32", "3L41"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["7L25", "6L25", "5L32", "4L25", "3L33", "3S0"],
			wakeupslap: ["7L27", "6L27", "5L40", "4L36"],
			wideguard: ["7L1", "6L1", "6S1", "5L1"],
			workup: ["7M", "5M"],
		},
	},
	bellsprout: {
		inherit: true,
		learnset: {
			acid: ["7L23", "7V", "6L23", "5L23", "4L23", "3L23"],
			acidspray: ["7E", "6E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7E", "6E"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			bulletseed: ["7E", "6E", "5E", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			encore: ["7E", "6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["7L35", "6T", "6L35", "5T", "5L35", "4T", "4L35"],
			gigadrain: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["7L7", "7V", "6L7", "5L7", "4L7", "3L6", "3S1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			ingrain: ["7E", "6E", "5E", "4E", "3E"],
			knockoff: ["7L27", "6T", "6L27", "5T", "5L27", "4T", "4L27"],
			leechlife: ["7E", "6E", "5E", "4E", "3E"],
			magicalleaf: ["7E", "6E", "5E", "4E", "3E"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			naturepower: ["7M", "6M"],
			poisonjab: ["7M", "7L41"],
			poisonpowder: ["7L15", "7V", "6L15", "5L15", "4L15", "3L17"],
			powerwhip: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			razorleaf: ["7L39", "7V", "6L39", "5L39", "4L39", "3L37"],
			reflect: ["7M", "7V", "6M", "5M", "4E", "3E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "5D", "4T"],
			slam: ["7L47", "7V", "6L41", "5L41", "4L41", "3L45"],
			sleeppowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L15"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stunspore: ["7L17", "7V", "6L17", "5L17", "4L17", "3L19"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L29", "6L29", "5L29", "4L29", "3L30"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			synthesis: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			takedown: ["7V"],
			teeterdance: ["3S0"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			tickle: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			vinewhip: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			weatherball: ["7E", "6E", "5E", "4E"],
			worryseed: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			wrap: ["7L11", "7V", "6L11", "5L11", "4L11", "3L11"],
			wringout: ["7L50", "6L47", "5L47", "4L47"],
		},
	},
	weepinbell: {
		inherit: true,
		learnset: {
			acid: ["7L24", "7V", "6L23", "5L23", "4L23", "3L24"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			bugbite: ["5T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["7L39", "6T", "6L35", "5T", "5L35", "4T", "4L35"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["7L7", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			knockoff: ["7L29", "6T", "6L27", "5T", "5L27", "4T", "4L27"],
			magicalleaf: ["3S0"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			morningsun: ["3S0"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			poisonjab: ["7M", "7L47"],
			poisonpowder: ["7L15", "7V", "6L15", "5L15", "4L15", "3L17"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			razorleaf: ["7L44", "7V", "6L39", "5L39", "4L39", "3L42"],
			reflect: ["7M", "7V", "6M", "5M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			slam: ["7L54", "7V", "6L41", "5L41", "4L41", "3L54"],
			sleeppowder: ["7L13", "7V", "6L13", "5L13", "4L13", "3L15"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stunspore: ["7L17", "7V", "6L17", "5L17", "4L17", "3L19"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L32", "6L29", "5L29", "4L29", "3L33", "3S0"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			vinewhip: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			worryseed: ["6T", "5T", "4T"],
			wrap: ["7L11", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			wringout: ["7L58", "6L47", "5L47", "4L47"],
		},
	},
	victreebel: {
		inherit: true,
		learnset: {
			acid: ["7V"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			bodyslam: ["7V", "3T"],
			bugbite: ["5T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["6T", "5T", "4T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			knockoff: ["6T", "5T", "4T"],
			leafblade: ["7L44", "6L47", "5L47", "4L47"],
			leafstorm: ["7L32", "6L47", "5L47", "4L47"],
			leaftornado: ["7L1", "6L27", "5L27"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			poisonjab: ["7M"],
			poisonpowder: ["7V"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			razorleaf: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			reflect: ["7M", "7V", "6M", "5M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeppowder: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			spitup: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			stockpile: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			stunspore: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			sweetscent: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			vinewhip: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			worryseed: ["6T", "5T", "4T"],
			wrap: ["7V"],
		},
	},
	tentacool: {
		inherit: true,
		learnset: {
			acid: ["7L10", "7V", "6L10", "5L12", "4L12", "3L19"],
			acidspray: ["7L22", "6L22", "5L26"],
			acupressure: ["7E", "6E", "5E", "5D", "4E"],
			aquaring: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7E", "6E", "5E", "4E", "3E"],
			barrier: ["7L28", "7V", "6L28", "5L29", "4L26", "3L36"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			brine: ["7L34", "6L34", "4M"],
			bubble: ["7E", "6E", "5E"],
			bubblebeam: ["7L25", "7V", "6L19", "5L19", "4L19", "3L25"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "4E", "3E"],
			constrict: ["7L7", "7V", "6L7", "5L8", "4L8", "3L12"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dazzlinggleam: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "5D", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			hex: ["7L40", "6L40", "5L43"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L46", "7V", "6L46", "5L47", "4L40", "3L49"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			knockoff: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			magiccoat: ["6T", "5T", "4T"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			mirrorcoat: ["7E", "6E", "5E", "4E", "3E"],
			muddywater: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "7L31", "6M", "6L31", "5M", "5L36", "4M", "4L33"],
			poisonsting: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7E", "6E", "5E", "4E", "3E"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4E", "3E"],
			scald: ["7M", "6M", "5M"],
			screech: ["7L37", "7V", "6L37", "5L40", "4L36", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "7L43", "6M", "6L43", "5M", "5L50"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			supersonic: ["7L4", "7V", "6L4", "5L5", "5D", "4L5", "3L6"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			tickle: ["7E", "6E", "5E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7L13", "6L13", "5L15", "4L15"],
			venoshock: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["7L16", "6T", "6L16", "5L33", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wrap: ["7L19", "7V", "6L19", "5L22", "4L22", "3L30"],
			wringout: ["7L49", "6L49", "5L54", "4L43"],
		},
	},
	tentacruel: {
		inherit: true,
		learnset: {
			acid: ["7L10", "7L1", "7V", "6L1", "5L12", "4L12", "3L19"],
			acidspray: ["7L22", "6L22", "5L26"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7L28", "7V", "6L28", "5L29", "4L26", "3L38"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			brine: ["7L36", "6L36", "4M"],
			bubblebeam: ["7L25", "7V", "6L19", "5L19", "4L19", "3L25"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			constrict: ["7L7", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dazzlinggleam: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hex: ["7L44", "6L44", "5L47"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L52", "7V", "6L52", "5L52", "4L49", "3L55"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			knockoff: ["6T", "5T", "4T"],
			magiccoat: ["6T", "5T", "4T"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "7L32", "6M", "6L32", "5M", "5L38", "4M", "4L36"],
			poisonsting: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			reflecttype: ["7L1", "6L1"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			screech: ["7L40", "7V", "6L40", "5L43", "4L42", "3L47"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "7L48", "6M", "6L48", "5M", "5L56"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			supersonic: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7L13", "6L13", "5L15", "4L15"],
			venoshock: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["7L16", "6T", "6L16", "5L34", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wrap: ["7L19", "7V", "6L19", "5L22", "4L22", "3L30"],
			wringout: ["7L56", "7L1", "6L1", "5L61", "4L55"],
		},
	},
	geodude: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			autotomize: ["7E", "6E", "5E"],
			bide: ["7V"],
			block: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "7L22", "6M", "6L22", "5M", "5L32"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			curse: ["7E", "6E", "5E", "4E"],
			defensecurl: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3T", "3L1"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7L40", "7V", "6L40", "5L46", "4L36", "3T", "3L46"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L34", "7V", "6M", "6L34", "5M", "5L39", "4M", "4L29", "3M", "3L36"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			explosion: ["7M", "7L36", "7V", "6M", "6L36", "5M", "5L43", "4M", "4L32", "3T", "3L41"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flail: ["7E", "6E", "5E", "4E"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["7E", "6T", "6E", "5E", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hammerarm: ["7E", "6E", "5E", "4E"],
			harden: ["7V"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T"],
			magnitude: ["7L12", "6L12", "5L15", "4L15", "3L16"],
			megapunch: ["7E", "7V", "6E", "5E", "4E", "3T", "3E"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L4", "6L4", "5L4", "4L4", "3L6"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L30", "6L22", "5L22", "4L25", "3L31"],
			rockclimb: ["7E", "6E", "5E", "5D", "4M"],
			rockpolish: ["7M", "7L6", "6M", "6L6", "5M", "5L8", "4M", "4L8"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L16", "7V", "6L16", "5L11", "4L11", "3L11"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L10", "6L10", "5L18", "4T", "4L22", "3T", "3L26"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			selfdestruct: ["7L24", "7V", "6L24", "5L29", "4L18", "3T", "3L21"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "7L18", "6M", "6L18", "5M", "5L25"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["7L28", "6T", "6L28", "5T", "5L36", "5D", "4M"],
			stoneedge: ["7M", "7L42", "6M", "6L42", "5M", "5L50", "4M", "4L39"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			wideguard: ["7E", "6E"],
		},
	},
	geodudealola: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			autotomize: ["7E"],
			block: ["7E"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulldoze: ["7M"],
			charge: ["7L4"],
			chargebeam: ["7M"],
			confide: ["7M"],
			counter: ["7E"],
			curse: ["7E"],
			defensecurl: ["7L1"],
			discharge: ["7L34"],
			doubleedge: ["7L40"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			endure: ["7E"],
			explosion: ["7M", "7L36"],
			facade: ["7M"],
			fireblast: ["7M"],
			flail: ["7E"],
			flamethrower: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			gyroball: ["7M"],
			hiddenpower: ["7M"],
			magnetrise: ["7E"],
			naturepower: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockblast: ["7L30"],
			rockclimb: ["7E"],
			rockpolish: ["7M", "7L6"],
			rockslide: ["7M"],
			rockthrow: ["7L16"],
			rocktomb: ["7M"],
			rollout: ["7L10"],
			round: ["7M"],
			sandstorm: ["7M"],
			screech: ["7E"],
			selfdestruct: ["7L24"],
			sleeptalk: ["7M"],
			smackdown: ["7M", "7L18"],
			spark: ["7L12"],
			stealthrock: ["7L28"],
			stoneedge: ["7M", "7L42"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			tackle: ["7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7L22"],
			toxic: ["7M"],
			voltswitch: ["7M"],
			wideguard: ["7E"],
		},
	},
	graveler: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "7L22", "6M", "6L22", "5M", "5L36"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			defensecurl: ["7L1", "7V", "6L1", "5L1", "4L1", "3T", "3L1"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7L50", "7V", "6L50", "5L58", "4L44", "3T", "3L62"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L40", "7V", "6M", "6L40", "5M", "5L47", "4M", "4L33", "3M", "3L45"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L44", "7V", "6M", "6L44", "5M", "5L53", "4M", "4L38", "3T", "3L53"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			harden: ["7V"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T"],
			magnitude: ["7L12", "6L12", "5L15", "4L15", "3L16"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L34", "6L22", "5L22", "4L27", "3L37"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "7L6", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L16", "7V", "6L16", "5L11", "4L11", "3L1"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L10", "6L10", "5L18", "4T", "4L22", "3T", "3L29"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			selfdestruct: ["7L24", "7V", "6L24", "5L31", "4L18", "3T", "3L21"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "7L18", "6M", "6L18", "5M", "5L27"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["7L30", "6T", "6L30", "5T", "5L42", "4M"],
			stoneedge: ["7M", "7L54", "6M", "6L54", "5M", "5L64", "4M", "4L49"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
		},
	},
	graveleralola: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulldoze: ["7M"],
			charge: ["7L4", "7L1"],
			chargebeam: ["7M"],
			confide: ["7M"],
			defensecurl: ["7L1"],
			discharge: ["7L40"],
			doubleedge: ["7L50"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			explosion: ["7M", "7L44"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			gyroball: ["7M"],
			hiddenpower: ["7M"],
			naturepower: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockblast: ["7L34"],
			rockpolish: ["7M", "7L6", "7L1"],
			rockslide: ["7M"],
			rockthrow: ["7L16"],
			rocktomb: ["7M"],
			rollout: ["7L10"],
			round: ["7M"],
			sandstorm: ["7M"],
			selfdestruct: ["7L24"],
			sleeptalk: ["7M"],
			smackdown: ["7M", "7L18"],
			spark: ["7L12"],
			stealthrock: ["7L30"],
			stoneedge: ["7M", "7L54"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			tackle: ["7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7L22"],
			toxic: ["7M"],
			voltswitch: ["7M"],
		},
	},
	golem: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "7L22", "6M", "6L22", "5M", "5L36"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			defensecurl: ["7L1", "7V", "6L1", "5L1", "4L1", "3T", "3L1"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7L50", "7V", "6L50", "5L58", "4L44", "3T", "3L62"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L40", "7V", "6M", "6L40", "5M", "5L47", "4M", "4L33", "3M", "3L45"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L44", "7V", "6M", "6L44", "5M", "5L53", "4M", "4L38", "3T", "3L53"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			harden: ["7V"],
			headbutt: ["4T"],
			heavyslam: ["7L60", "7L1", "6L1", "5L69"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T"],
			ironhead: ["6T", "5T", "4T"],
			magnitude: ["7L12", "6L12", "5L15", "4L15", "3L16"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L34", "6L22", "5L22", "4L27", "3L37"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "7L6", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L16", "7V", "6L16", "5L11", "4L11", "3L1"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "4L22", "3T", "3L29"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			selfdestruct: ["7L24", "7V", "6L24", "5L31", "4L18", "3T", "3L21"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "7L18", "6M", "6L18", "5M", "5L27"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["7L30", "6T", "6L30", "5T", "5L42", "4M"],
			steamroller: ["7L10", "6L10", "5L18"],
			stoneedge: ["7M", "7L54", "6M", "6L54", "5M", "5L64", "4M", "4L49"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
		},
	},
	golemalola: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulldoze: ["7M"],
			charge: ["7L4", "7L1"],
			chargebeam: ["7M"],
			confide: ["7M"],
			defensecurl: ["7L1"],
			discharge: ["7L40"],
			doubleedge: ["7L50"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			echoedvoice: ["7M"],
			explosion: ["7M", "7L44"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			fling: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			gyroball: ["7M"],
			heavyslam: ["7L60", "7L1"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			naturepower: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockblast: ["7L34"],
			rockpolish: ["7M", "7L6", "7L1"],
			rockslide: ["7M"],
			rockthrow: ["7L16"],
			rocktomb: ["7M"],
			round: ["7M"],
			sandstorm: ["7M"],
			selfdestruct: ["7L24"],
			sleeptalk: ["7M"],
			smackdown: ["7M", "7L18"],
			spark: ["7L12"],
			stealthrock: ["7L30"],
			steamroller: ["7L10"],
			stoneedge: ["7M", "7L54"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			tackle: ["7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderpunch: ["7L22"],
			toxic: ["7M"],
			voltswitch: ["7M"],
			wildcharge: ["7M"],
		},
	},
	ponyta: {
		inherit: true,
		learnset: {
			agility: ["7L37", "7V", "6L37", "5L37", "4L33", "3L38"],
			allyswitch: ["7E", "6E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			bounce: ["7L45", "6T", "6L45", "5T", "5L45", "4T", "4L42", "3L45"],
			captivate: ["7E", "6E", "5E", "4M"],
			charm: ["7E", "6E", "5E", "4E", "3E"],
			confide: ["7M", "6M"],
			doubleedge: ["7E", "7V", "6E", "5E", "4E", "3T", "3E"],
			doublekick: ["7E", "6E", "5E", "4E", "3E"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L9", "7V", "6L9", "5L9", "4L10", "3L14"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7L41", "7V", "6M", "6L41", "5M", "5L41", "4M", "4L37", "3M", "3L53"],
			firespin: ["7L25", "7V", "6L25", "5L25", "4L24", "3L25"],
			flamecharge: ["7M", "7L21", "6M", "6L21", "5M", "5L21"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flamewheel: ["7L13", "7E", "6L13", "6E", "5L13", "5E", "4L15", "4E", "3E"],
			flareblitz: ["7L49", "6L49", "5L49", "4L46"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L5"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "5D", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			horndrill: ["7E", "7V", "6E", "5E", "4E"],
			hypnosis: ["7E", "6E", "5E", "4E", "3E"],
			incinerate: ["6M", "5M"],
			inferno: ["7L33", "6L33", "5L33"],
			irontail: ["6T", "5T", "4M", "3M"],
			lowkick: ["7E", "6T", "6E", "5T", "5E"],
			mimic: ["7V", "3T"],
			morningsun: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["3L1"],
			rage: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stomp: ["7L17", "7V", "6L17", "5L17", "4L19", "3L19"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			tailwhip: ["7L4", "7V", "6L4", "5L4", "4L6", "3L9"],
			takedown: ["7L29", "7V", "6L29", "5L29", "4L28", "3L31"],
			thrash: ["7E", "6E", "5E", "5D", "4E", "3E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	rapidash: {
		inherit: true,
		learnset: {
			agility: ["7L37", "7V", "6L37", "5L37", "4L33", "3L38"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			bounce: ["7L45", "6T", "6L45", "5T", "5L45", "4T", "4L47", "3L50"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillrun: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L9", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7L41", "7V", "6M", "6L41", "5M", "5L41", "4M", "4L37", "3M", "3L63"],
			firespin: ["7L25", "7V", "6L25", "5L25", "4L24", "3L25"],
			flamecharge: ["7M", "7L21", "6M", "6L21", "5M", "5L21"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			flamewheel: ["7L13", "6L13", "5L13", "4L15"],
			flareblitz: ["7L49", "6L49", "5L49", "4L56"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L1", "6L40", "5L40", "4L40", "3L40"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			horndrill: ["7V"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			inferno: ["7L33", "6L33", "5L33"],
			irontail: ["6T", "5T", "4M", "3M"],
			lowkick: ["6T", "5T"],
			megahorn: ["7L1", "6L1", "5L1", "4L1"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			poisonjab: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			rage: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			stomp: ["7L17", "7V", "6L17", "5L17", "4L19", "3L19"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["3L1"],
			tailwhip: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L29", "7V", "6L29", "5L29", "4L28", "3L31"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	slowpoke: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			amnesia: ["7L41", "7V", "6L41", "5L41", "4L43", "3L36"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7E", "6E"],
			bellydrum: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			block: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E"],
			bodyslam: ["7V", "3T"],
			brine: ["5D", "4M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L14", "7V", "6L14", "5L14", "5S2", "4L15", "3L17", "3S0"],
			curse: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S1"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			disable: ["7L19", "7V", "6L19", "5L19", "5S2", "4L20", "3L24", "3S0"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E", "6E", "5E", "4E", "3E"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L5", "7V", "6L5", "5L5", "4L6", "3L6", "3S1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["7L23", "7V", "6L23", "5L23", "5S2", "4T", "4L25", "3L29", "3S0"],
			healpulse: ["7L58", "6L58", "5L58"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magiccoat: ["6T", "5T", "4T"],
			mefirst: ["7E", "6E", "5E", "4E"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payday: ["7V"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L45", "7V", "6M", "6L45", "5M", "5L45", "4M", "4L48", "3M", "3L40"],
			psychup: ["7M", "7L54", "6M", "6L54", "5M", "5L54", "4M", "4L57", "3T", "3L47"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "7L49", "6M", "6L49", "5M", "5L49", "4M", "4L53", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "4E", "3M", "3E"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skullbash: ["7V"],
			slackoff: ["7L36", "6L36", "5L36", "4L39"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			stomp: ["7E", "6E", "5E", "4E", "3E"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S1"],
			takedown: ["7V"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			watergun: ["7L9", "7V", "6L9", "5L9", "4L11", "3L13", "3S0"],
			waterpulse: ["7L28", "6T", "6L28", "5L28", "5S2", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wonderroom: ["7E", "6T", "6E", "5T", "5E"],
			yawn: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S1"],
			zenheadbutt: ["7L32", "7E", "6T", "6L32", "6E", "5T", "5L32", "5E", "4T", "4L34", "4E"],
		},
	},
	slowbro: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			afteryou: ["6T", "5T"],
			amnesia: ["7L43", "7V", "6L43", "5L43", "4L47", "3L36"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L14", "7V", "6L14", "5L14", "4L15", "3L17"],
			counter: ["7V", "3T"],
			curse: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			disable: ["7L19", "7V", "6L19", "5L19", "4L20", "3L24"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["7L23", "7V", "6L23", "5L23", "4T", "4L25", "3L29"],
			healpulse: ["7L68", "7L1", "6L1", "5L68"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T", "4T"],
			irontail: ["6T", "6S0", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magiccoat: ["6T", "5T", "4T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payday: ["7V"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L49", "7V", "6M", "6L49", "5M", "5L49", "4M", "4L54", "3M", "3L44"],
			psychup: ["7M", "7L62", "6M", "6L62", "5M", "5L62", "4M", "4L67", "3T", "3L55"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "7L55", "6M", "6L55", "5M", "5L55", "4M", "4L61", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "6S0", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skullbash: ["7V"],
			slackoff: ["7L36", "6L36", "6S0", "5L36", "4L41"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "6S0", "5M", "4M"],
			watergun: ["7L9", "7V", "6L9", "5L9", "4L11", "3L13"],
			waterpulse: ["7L28", "6T", "6L28", "5L28", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			withdraw: ["7L1", "7V", "6L37", "5L37", "4L37", "3L37"],
			wonderroom: ["6T", "5T"],
			yawn: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			zenheadbutt: ["7L32", "6T", "6L32", "5T", "5L32", "4T", "4L34"],
		},
	},
	slowking: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L14", "6L14", "5L14", "4L15", "3L17"],
			counter: ["3T"],
			curse: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7L19", "6L19", "5L19", "4L20", "3L24"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragontail: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L5", "6L5", "5L5", "4L6", "3L6"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["7L23", "6L23", "5L23", "4T", "4L25", "3L29"],
			healpulse: ["7L58", "7L1", "6L1", "5L58"],
			hiddenpower: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magiccoat: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L36", "6L36", "5L36", "4L39"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powergem: ["7L1", "6L1", "5L1", "4L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L45", "6M", "6L45", "5M", "5L45", "4M", "4L48", "3M", "3L40"],
			psychup: ["7M", "7L54", "6M", "6L54", "5M", "5L54", "4M", "4L57", "3T", "3L47"],
			psyshock: ["7M", "6M", "5M"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L43", "3T", "3L36"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			telekinesis: ["5M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			trumpcard: ["7L49", "6L49", "5L49", "4L53"],
			watergun: ["7L9", "6L9", "5L9", "4L11", "3L13"],
			waterpulse: ["7L28", "6T", "6L28", "5L28", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wonderroom: ["6T", "5T"],
			yawn: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			zenheadbutt: ["7L32", "6T", "6L32", "5T", "5L32", "4T", "4L34"],
		},
	},
	magnemite: {
		inherit: true,
		learnset: {
			bide: ["7V"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			discharge: ["7L37", "6L37", "5L43", "4L38"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			electroball: ["7L29", "6L29", "5L27"],
			electroweb: ["6T", "5T"],
			endure: ["4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "7L31", "6M", "6L31", "5M", "5L35", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gravity: ["6T", "5T", "5D", "4T"],
			gyroball: ["7M", "7L47", "6M", "6L47", "5M", "5L54", "4M", "4L49"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			irondefense: ["6T", "5T", "4T"],
			lightscreen: ["7M", "7L13", "6M", "5M", "4M"],
			lockon: ["7L41", "6L41", "5L30", "4L27", "3L32"],
			magiccoat: ["6T", "5T", "4T"],
			magnetbomb: ["7L7", "6L17", "5L33", "4L30"],
			magnetrise: ["7L43", "6T", "6L43", "5T", "5L49", "4T", "4L46"],
			metalsound: ["7L25", "6L25", "5L1", "5D", "4L1", "3L1"],
			mimic: ["7V", "3T"],
			mirrorshot: ["7L23", "6L23", "5L46", "4L43"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "5D", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			screech: ["7L35", "7V", "6L35", "5L38", "4L33", "3L44"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			sonicboom: ["7L17", "7V", "6L11", "5L14", "4L14", "3L16"],
			spark: ["7L19", "6L19", "5L22", "4L22", "3L26"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L1", "7V", "6L4", "5L11", "4L11", "3L11"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T", "3L38"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			teleport: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thundershock: ["7L5", "7V", "6L7", "5L6", "5D", "4L6", "3L6"],
			thunderwave: ["7M", "7L11", "7V", "6M", "6L13", "5M", "5L17", "4M", "4L17", "3T", "3L21"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			zapcannon: ["7L49", "6L49", "5L59", "4L54", "3L50"],
		},
	},
	magneton: {
		inherit: true,
		learnset: {
			bide: ["7V"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			discharge: ["7L43", "6L43", "5L46", "4L40"],
			doubleedge: ["7V", "3T", "3S0"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			electricterrain: ["7L1", "6L1"],
			electroball: ["7L29", "6L29", "5L27"],
			electroweb: ["6T", "5T"],
			endure: ["4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "7L33", "6M", "6L33", "5M", "5L39", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "7L59", "6M", "6L59", "5M", "5L60", "4M", "4L54"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			irondefense: ["6T", "5T", "4T"],
			lightscreen: ["7M", "7L13", "6M", "5M", "4M"],
			lockon: ["7L49", "6L49", "5L30", "4L27", "3L35"],
			magiccoat: ["6T", "5T", "4T"],
			magnetbomb: ["7L7", "7L1", "6L17", "5L34", "4L30"],
			magnetrise: ["7L53", "6T", "6L53", "5T", "5L54", "4T", "4L50"],
			metalsound: ["7L25", "6L25", "5L1", "4L1", "3L1"],
			mimic: ["7V", "3T"],
			mirrorshot: ["7L23", "6L23", "5L50", "4L46"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			screech: ["7L39", "7V", "6L39", "5L40", "4L34", "3L53"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			sonicboom: ["7L17", "7V", "6L1", "5L14", "4L14", "3L16"],
			spark: ["7L19", "6L19", "5L22", "4L22", "3L26"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			teleport: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M", "3S0"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thundershock: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			thunderwave: ["7M", "7L11", "7V", "6M", "6L13", "5M", "5L17", "4M", "4L17", "3T", "3L21"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7L1", "6L1", "5L1", "4L1", "3L44"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			zapcannon: ["7L63", "7L1", "6L1", "5L66", "4L60", "3L62"],
		},
	},
	magnezone: {
		inherit: true,
		learnset: {
			barrier: ["7L1", "6L1", "5L1", "4L1"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			discharge: ["7L43", "6L43", "5L46", "4L40"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			electricterrain: ["7L1", "6L1"],
			electroball: ["7L29", "6L29", "5L27"],
			electroweb: ["6T", "5T"],
			endure: ["4M"],
			explosion: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["7M", "7L33", "6M", "6L33", "5M", "5L39", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "7L59", "6M", "6L59", "5M", "5L60", "4M", "4L54"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["6T", "5T", "4T"],
			lightscreen: ["7M", "7L13", "6M", "5M", "4M"],
			lockon: ["7L49", "6L49", "5L30", "4L27"],
			magiccoat: ["6T", "5T", "4T"],
			magnetbomb: ["7L7", "7L1", "6L17", "5L34", "4L30"],
			magneticflux: ["7L1", "6L1"],
			magnetrise: ["7L53", "6T", "6L53", "5T", "5L54", "4T", "4L50"],
			metalsound: ["7L25", "6L25", "5L1", "4L1"],
			mirrorcoat: ["7L1", "6L1", "5L1", "4L1"],
			mirrorshot: ["7L23", "6L23", "5L50", "4L46"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			screech: ["7L39", "6L39", "5L40", "4L34"],
			secretpower: ["6M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			sonicboom: ["7L17", "6L1", "5L14", "4L14"],
			spark: ["7L19", "6L19", "5L22", "4L22"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			supersonic: ["7L1", "6L1", "5L1", "4L1"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thundershock: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			thunderwave: ["7M", "7L11", "6M", "6L13", "5M", "5L17", "4M", "4L17"],
			toxic: ["7M", "6M", "5M", "4M"],
			triattack: ["7L1"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			zapcannon: ["7L63", "7L1", "6L1", "5L66", "4L60"],
		},
	},
	farfetchd: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L37", "6M", "6L37", "5M", "5L37"],
			aerialace: ["7M", "7L9", "6M", "6L9", "5M", "5L13", "4M", "4L13", "3M", "3S0"],
			agility: ["7L31", "7V", "6L31", "5L31", "4L31", "3L36"],
			aircutter: ["7L21", "6L21", "5L21", "4T", "4L21"],
			airslash: ["7L49", "6L49", "5L49", "4L37"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			bravebird: ["7L55", "7L1", "6L1", "5L55"],
			brutalswing: ["7M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E", "5T", "5E", "4E"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "7L45", "6M", "6L45", "5M", "5L45", "4M", "4L43", "3L46"],
			featherdance: ["7E", "6E", "5E", "4E", "3E"],
			feint: ["7L43", "6L43", "5L43", "4L43"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L7", "7V", "6L7", "5L7", "4L7", "3L16"],
			furycutter: ["7L1", "6L1", "5L1", "5D", "4T", "4L1", "3L26"],
			gust: ["7E", "6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["7L13", "6T", "6L13", "5T", "5L9", "4T", "4L9", "3L21"],
			lastresort: ["6T", "5T", "4T"],
			leafblade: ["7E", "6E", "5E", "5D", "4E"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L11"],
			mimic: ["7V", "3T"],
			mirrormove: ["7E", "6E", "5E", "4E", "3E"],
			mudslap: ["7E", "6E", "5E", "4T", "4E", "3T"],
			naturalgift: ["4M"],
			nightslash: ["7L33", "7E", "6L33", "6E", "5L33", "5E", "4L33", "4E"],
			ominouswind: ["4T"],
			peck: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			poisonjab: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			quickattack: ["7E", "6E", "5E", "4E", "3E"],
			rage: ["7V"],
			razorwind: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7E", "6E", "5E"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E", "5D", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L1", "7V", "6L1", "5L1", "4L1", "3L6"],
			secretpower: ["6M", "4M", "3M"],
			simplebeam: ["7E", "6E"],
			skullbash: ["7V"],
			skyattack: ["6T", "5T"],
			slash: ["7L19", "7V", "6L19", "5L19", "4L19", "3L41", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "4M", "4E", "3M", "3E"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			swordsdance: ["7M", "7L25", "7V", "6M", "6L25", "5M", "5L25", "4M", "4L25", "3T", "3L31", "3S0"],
			tailwind: ["6T", "5T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			trumpcard: ["7E", "6E", "5E"],
			twister: ["4T"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7V"],
			wish: ["3S0"],
			workup: ["7M", "5M"],
			yawn: ["3S0"],
		},
	},
	doduo: {
		inherit: true,
		learnset: {
			acupressure: ["7L33", "6L28", "5L28", "4L28"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L26", "7V", "6L33", "5L37", "4L37", "3L45"],
			aircutter: ["4T"],
			assurance: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			bravebird: ["7E", "6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doublehit: ["7L22", "6L25", "5L32", "4L32"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillpeck: ["7L43", "7V", "6L37", "5L41", "4L41", "3L37"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L47", "7E", "6T", "6L45", "6E", "5T", "5L46", "5E", "4T", "4L46", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			flail: ["7E", "6E", "5E", "5D", "4E", "3E"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L12", "7V", "6L13", "5L14", "4L14", "3L13"],
			growl: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			jumpkick: ["7L40"],
			knockoff: ["6T", "5T", "4T"],
			mimic: ["7V", "3T"],
			mirrormove: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			peck: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			pluck: ["7L19", "6L21", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L15", "6L17", "5L19", "4L19", "3L9"],
			quickattack: ["7L5", "7E", "6L5", "6E", "5L5", "5E", "4L5", "4E", "3E"],
			rage: ["7L8", "7V", "6L9", "5L10", "4L10", "3L25"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "5D", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			skyattack: ["7V", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "7L36"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L50", "6L49", "5L50"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V", "3L21"],
			uproar: ["7L29", "6T", "6L23", "5T", "5L23", "4T", "4L23", "3L33"],
			whirlwind: ["7V"],
			workup: ["7M", "5M"],
		},
	},
	dodrio: {
		inherit: true,
		learnset: {
			acupressure: ["7L34", "6L28", "5L28", "4L28"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L26", "7V", "6L35", "5L41", "4L41", "3L60", "3S0"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doublehit: ["7L22"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillpeck: ["7L47", "7V", "6L41", "5L47", "4L47", "3L47", "3S0"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L52", "6T", "6L53", "5T", "5L54", "4T", "4L54"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L12", "7V", "6L13", "5L14", "4L14", "3L1"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			jumpkick: ["7L43"],
			knockoff: ["6T", "5T", "4T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			peck: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			pluck: ["7L19", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L15", "6L17", "5L19", "4L19", "3L1"],
			quickattack: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			rage: ["7L8", "7L1", "7V", "6L1", "5L1", "4L1", "3L25"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			skyattack: ["7V", "6T", "5T", "4T", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "7L38"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L56", "6L59", "5L60"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7L1", "7V", "6L25", "5L34", "4L34", "3L21", "3S0"],
			uproar: ["7L29", "6T", "6L23", "5T", "5L23", "4T", "4L23", "3L38"],
			whirlwind: ["7V"],
			workup: ["7M", "5M"],
		},
	},
	seel: {
		inherit: true,
		learnset: {
			aquajet: ["7L31", "6L31", "5L31", "4L31"],
			aquaring: ["7L23", "6L23", "5L23", "4L23"],
			aquatail: ["7L43", "6T", "6L43", "5T", "5L43", "4T", "4L43"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7L27", "7V", "6L27", "5L27", "4L27", "3L21"],
			belch: ["7E", "6E"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brine: ["7L33", "6L33", "5L33", "4M", "4L33"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			dive: ["7L41", "6M", "6L41", "5M", "5L41", "4T", "4L41", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillrun: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7L13", "7E", "6L13", "6E", "5L13", "5E", "4L13", "4E", "3E"],
			endure: ["4M", "3T"],
			entrainment: ["7E", "6E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "4E", "3E"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L3", "7V", "6L3", "5L3", "4L3", "3L9"],
			hail: ["7M", "7L53", "6M", "6L53", "5M", "5L53", "4M", "3M"],
			headbutt: ["7L1", "7V", "6L1", "5L1", "5D", "4T", "4L1", "3L1"],
			helpinghand: ["3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			horndrill: ["7E", "7V", "6E", "5E", "4E", "3E"],
			icebeam: ["7M", "7L47", "7V", "6M", "6L47", "5M", "5L47", "4M", "4L47", "3M", "3L41", "3S0"],
			iceshard: ["7L17", "6L17", "5L17", "4L17"],
			iciclespear: ["7E", "6E", "5E", "5D", "4E", "3E"],
			icywind: ["7L11", "6T", "6L11", "5T", "5L11", "4T", "4L11", "3T", "3L17"],
			irontail: ["7E", "6T", "6E", "5T", "5E"],
			lick: ["7E", "6E", "5E", "4E", "3E"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			payday: ["7V"],
			perishsong: ["7E", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L21", "7V", "6M", "6L21", "5M", "5L21", "4M", "4L21", "3M", "3L29"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L51", "6M", "6L51", "5M", "5L51", "4M", "4L51", "3M", "3L49", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			skullbash: ["7V"],
			slam: ["7E", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "5D", "4M", "3T"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			spitup: ["7E", "6E", "5E", "4E"],
			stockpile: ["7E", "6E", "5E", "4E"],
			strength: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M", "3S0"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7E", "6E", "5E", "4E"],
			takedown: ["7L37", "7V", "6L37", "5L37", "4L37", "3L37"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			watersport: ["7L7", "6L7", "5L7", "4L7"],
			whirlpool: ["4M"],
		},
	},
	dewgong: {
		inherit: true,
		learnset: {
			aquajet: ["7L31", "6L31", "5L31", "4L31"],
			aquaring: ["7L23", "6L23", "5L23", "4L23"],
			aquatail: ["7L49", "6T", "6L49", "5T", "5L49", "4T", "4L43"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7L27", "7V", "6L27", "5L27", "4L27", "3L1"],
			avalanche: ["4M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brine: ["7L33", "6L33", "5L33", "4M", "4L33"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dive: ["7L45", "6M", "6L45", "5M", "5L45", "4T", "4L41", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillrun: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7L13", "6L13", "5L13", "4L13"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L3", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "7L65", "6M", "6L65", "5M", "5L65", "4M", "3M"],
			headbutt: ["7L1", "7V", "6L1", "5L1", "4T", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			horndrill: ["7V"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7L55", "7V", "6M", "6L55", "5M", "5L55", "4M", "4L47", "3M", "3L51"],
			iceshard: ["7L17", "6L17", "5L17", "4L17"],
			icywind: ["7L11", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3T", "3L1"],
			irontail: ["6T", "5T"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			payday: ["7V"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L21", "7V", "6M", "6L21", "5M", "5L21", "4M", "4L21", "3M", "3L29"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L61", "6M", "6L61", "5M", "5L61", "4M", "4L51", "3M", "3L64"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["7L1", "6L34", "5L34", "4L34", "3L34"],
			signalbeam: ["7L7", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7L39", "7V", "6L39", "5L39", "4L37", "3L42"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	grimer: {
		inherit: true,
		learnset: {
			acidarmor: ["7L43", "7V", "6L40", "5L39", "4L39", "3L34"],
			acidspray: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7L46", "6L46"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7L12", "7V", "6L12", "5L12", "4L12", "3L8"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "7L26", "6M", "6L26", "5M", "5L28", "4M", "4L28"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gunkshot: ["7L40", "6T", "6L40", "5T", "5L49", "4T", "4L44"],
			harden: ["7L4", "7V", "6L4", "5L4", "4L4", "3L4"],
			haze: ["7E", "6E", "5E", "5D", "4E", "3E"],
			helpinghand: ["3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			imprison: ["7E", "6E", "5E", "4E", "3E"],
			incinerate: ["6M", "5M"],
			infestation: ["7M", "6M"],
			lick: ["7E", "6E", "5E", "4E", "3E"],
			meanlook: ["7E", "6E", "5E", "4E", "3E"],
			megadrain: ["7V"],
			memento: ["7L48", "6L48", "5L52", "4L49", "3L53"],
			mimic: ["7V", "3T"],
			minimize: ["7L21", "7V", "6L18", "5L17", "4L17", "3L19", "3S0"],
			mudbomb: ["7L18", "6L18", "5L23", "4L23"],
			mudslap: ["7L7", "6L7", "5L7", "4T", "4L7", "3T"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			poisongas: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			pound: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7E", "6E", "5E"],
			screech: ["7L37", "7V", "6L32", "5L33", "4L33", "3L26"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowpunch: ["7E", "6E", "5E", "4E", "3E", "3S0"],
			shadowsneak: ["7E", "6E", "5E", "5D", "4E"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludge: ["7L15", "7V", "6L15", "5L20", "4L20", "3L13"],
			sludgebomb: ["7M", "7L29", "6M", "6L26", "5M", "5L36", "4M", "4L36", "3M", "3L43", "3S0"],
			sludgewave: ["7M", "7L32", "6M", "6L32", "5M", "5L44"],
			snore: ["6T", "5T", "4T", "3T"],
			spitup: ["7E", "6E", "5E", "4E"],
			stockpile: ["7E", "6E", "5E", "4E"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7E", "6E", "5E", "4E"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
		},
	},
	grimeralola: {
		inherit: true,
		learnset: {
			acidarmor: ["7L43"],
			acidspray: ["7L15"],
			assurance: ["7E"],
			attract: ["7M"],
			belch: ["7L46"],
			bite: ["7L7", "7S0"],
			brutalswing: ["7M"],
			clearsmog: ["7E"],
			confide: ["7M"],
			crunch: ["7L32"],
			curse: ["7E"],
			disable: ["7L12"],
			doubleteam: ["7M"],
			embargo: ["7M"],
			explosion: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			fling: ["7M", "7L26"],
			frustration: ["7M"],
			gunkshot: ["7L40"],
			harden: ["7L4", "7S0"],
			hiddenpower: ["7M"],
			imprison: ["7E"],
			infestation: ["7M"],
			knockoff: ["7L29"],
			meanlook: ["7E"],
			memento: ["7L48"],
			minimize: ["7L21"],
			payback: ["7M"],
			poisonfang: ["7L18"],
			poisongas: ["7L1", "7S0"],
			poisonjab: ["7M"],
			pound: ["7L1", "7S0"],
			protect: ["7M"],
			pursuit: ["7E"],
			quash: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockpolish: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			scaryface: ["7E"],
			screech: ["7L37"],
			shadowball: ["7M"],
			shadowsneak: ["7E"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			snarl: ["7M"],
			spite: ["7E"],
			spitup: ["7E"],
			stockpile: ["7E"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swallow: ["7E"],
			taunt: ["7M"],
			thief: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			venoshock: ["7M"],
		},
	},
	muk: {
		inherit: true,
		learnset: {
			acidarmor: ["7L46", "7V", "6L43", "5L42", "4L44", "3L34"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7L52", "6L52"],
			bide: ["7V"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7L12", "7V", "6L12", "5L12", "4L12", "3L8"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "7L26", "6M", "6L26", "5M", "5L28", "4M", "4L28"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gunkshot: ["7L40", "6T", "6L40", "5T", "5L58", "4T", "4L54"],
			harden: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			infestation: ["7M", "6M"],
			megadrain: ["7V"],
			memento: ["7L57", "6L57", "5L64", "4L65", "3L61"],
			mimic: ["7V", "3T"],
			minimize: ["7L21", "7V", "6L18", "5L17", "4L17", "3L19"],
			mudbomb: ["7L18", "6L18", "5L23", "4L23"],
			mudslap: ["7L7", "7L1", "6L1", "5L1", "4T", "4L1", "3T"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			poisongas: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			pound: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			screech: ["7L37", "7V", "6L32", "5L33", "4L33", "3L26"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludge: ["7L15", "7V", "6L15", "5L20", "4L20", "3L13"],
			sludgebomb: ["7M", "7L29", "6M", "6L26", "5M", "5L36", "4M", "4L36", "3M", "3L47"],
			sludgewave: ["7M", "7L32", "6M", "6L32", "5M", "5L50"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			venomdrench: ["7L1", "6L38"],
			venoshock: ["7M", "6M", "5M"],
		},
	},
	mukalola: {
		inherit: true,
		learnset: {
			acidarmor: ["7L46"],
			acidspray: ["7L15"],
			attract: ["7M"],
			belch: ["7L52"],
			bite: ["7L7", "7L1"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			confide: ["7M"],
			crunch: ["7L32"],
			darkpulse: ["7M"],
			disable: ["7L12"],
			doubleteam: ["7M"],
			embargo: ["7M"],
			explosion: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			fling: ["7M", "7L26"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			gunkshot: ["7L40"],
			harden: ["7L4", "7L1"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			infestation: ["7M"],
			knockoff: ["7L29"],
			memento: ["7L57"],
			minimize: ["7L21"],
			payback: ["7M"],
			poisonfang: ["7L18"],
			poisongas: ["7L1"],
			poisonjab: ["7M"],
			pound: ["7L1"],
			protect: ["7M"],
			quash: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockpolish: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			screech: ["7L37"],
			shadowball: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			snarl: ["7M"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			taunt: ["7M"],
			thief: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			venomdrench: ["7L1"],
			venoshock: ["7M"],
		},
	},
	shellder: {
		inherit: true,
		learnset: {
			aquaring: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7L37", "7V", "6L37", "5L37", "4L32", "3L17", "3S0", "3S2"],
			avalanche: ["7E", "6E", "5E"],
			barrier: ["7E", "6E", "5E", "5D", "4E", "3E"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			brine: ["7L44", "6L44", "5L44", "4M", "4L44"],
			bubblebeam: ["7E", "7V", "6E", "5E", "4E", "3E"],
			captivate: ["4M"],
			clamp: ["7L25", "7V", "6L25", "5L25", "4L25", "3L41"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L61", "6L61", "5L61"],
			icebeam: ["7M", "7L52", "7V", "6M", "6L52", "5M", "5L52", "4M", "4L49", "3M", "3L49"],
			iceshard: ["7L28", "6L28", "5L28", "4L28"],
			iciclespear: ["7L13", "7E", "6L13", "6E", "5L13", "5E", "4L13", "4E", "3L8", "3E", "3S0", "3S1"],
			icywind: ["6T", "5T", "5D", "4T", "3T"],
			irondefense: ["7L49", "6T", "6L49", "5T", "5L49", "4T", "4L40"],
			leer: ["7L20", "7V", "6L20", "5L20", "4L20", "3L33"],
			mimic: ["7V", "3T"],
			mudshot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "7L16", "6M", "6L16", "5M", "5L16", "4M", "4L16", "3M", "3L25"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7E", "6E", "5E", "4E", "3E"],
			razorshell: ["7L32", "6L32", "5L32"],
			reflect: ["7V"],
			refresh: ["3S2"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7E", "6E", "5E", "4E"],
			round: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7V", "3T"],
			shellsmash: ["7L56", "6L56", "5L56"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			supersonic: ["7L8", "7V", "6L8", "5L8", "4L8", "3L9", "3S0"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M", "3S2"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S1"],
			takedown: ["7E", "7V", "6E", "5E", "4E", "3E", "3S2"],
			teleport: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			twineedle: ["7E", "6E", "5E"],
			watergun: ["7L1", "7V"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			whirlpool: ["7L40", "6L40", "5L40", "4M", "4L37"],
			withdraw: ["7L4", "7V", "6L4", "5L4", "5D", "4L4", "3L1", "3S0", "3S1"],
		},
	},
	cloyster: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			avalanche: ["4M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			clamp: ["7V"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "5S0", "4M", "3M"],
			hydropump: ["7L1", "6L1"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			iciclecrash: ["7L50", "6L50", "5L52"],
			iciclespear: ["5S0"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["6T", "5T", "4T"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["3C"],
			razorshell: ["5S0"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["5S0"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7V", "3T"],
			shellsmash: ["7L1", "6L1"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			spikecannon: ["7L13", "7V", "6L13", "5L13", "4L40", "3L41"],
			spikes: ["7L28", "6L28", "5L28", "4L28", "3L33"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			supersonic: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7V"],
			teleport: ["7V"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7L1", "6L1", "5L1", "4L1"],
			triattack: ["7V"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			withdraw: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	gastly: {
		inherit: true,
		learnset: {
			astonish: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			captivate: ["4M"],
			clearsmog: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			confuseray: ["7L19", "7V", "6L19", "5L19", "4L19", "3L21"],
			curse: ["7L12", "6L12", "5L12", "4L12", "3L13"],
			darkpulse: ["7M", "7L36", "6M", "6L36", "5T", "5L36", "4M", "4L36"],
			dazzlinggleam: ["7M", "6M"],
			destinybond: ["7L40", "6L40", "5L40", "4L40", "3L33"],
			disable: ["7E", "6E", "5E", "5D", "4E"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "7L33", "7V", "6M", "6L33", "5M", "5L33", "4M", "4L33", "3T", "3L28"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			grudge: ["7E", "6E", "5E", "4E", "3E"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			hex: ["7L43", "6L43", "5L43"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypnosis: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			icywind: ["6T", "5T", "4T"],
			infestation: ["7M", "6M"],
			knockoff: ["6T", "5T", "4T"],
			lick: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			meanlook: ["7L8", "6L8", "5L8", "4L8", "3L13"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			nightmare: ["7L47", "6L47", "5L47", "4L43", "3T", "3L41"],
			nightshade: ["7L15", "7V", "6L15", "5L15", "4L15", "3L16"],
			ominouswind: ["4T"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "7L26", "6M", "6L26", "5M", "5L26", "4M", "4L26"],
			perishsong: ["7E", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psywave: ["7E", "7V", "6E", "5E", "4E", "3E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflecttype: ["7E", "6E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7E", "6E", "5E"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7V", "3T"],
			shadowball: ["7M", "7L29", "6M", "6L29", "5M", "5L29", "4M", "4L29", "3M", "3L36"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["5D"],
			smog: ["7E", "6E", "5E"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["7L5", "6T", "6L5", "5T", "5L5", "4T", "4L5", "3L8"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L22", "6L22", "5L22", "4T", "4L22"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7V"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M", "4E", "3E"],
			wonderroom: ["6T", "5T"],
		},
	},
	haunter: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L19", "7V", "6L19", "5L19", "5S0", "4L19", "3L21"],
			curse: ["7L12", "6L12", "5L12", "4L12", "3L13"],
			darkpulse: ["7M", "7L44", "6M", "6L44", "5T", "5L44", "4M", "4L44"],
			dazzlinggleam: ["7M", "6M"],
			destinybond: ["7L50", "6L50", "5L50", "4L50", "3L39"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "7L39", "7V", "6M", "6L39", "5M", "5L39", "4M", "4L39", "3T", "3L31"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T"],
			fling: ["7M", "6M", "5M", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			hex: ["7L55", "6L55", "5L55"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypnosis: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T"],
			infestation: ["7M", "6M"],
			knockoff: ["6T", "5T", "4T"],
			lick: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			meanlook: ["7L8", "6L8", "5L8", "4L8", "3L13"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			nightmare: ["7L61", "6L61", "5L61", "4L55", "3T", "3L53"],
			nightshade: ["7L15", "7V", "6L15", "5L15", "4L15", "3L16"],
			ominouswind: ["4T"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "5S0", "4M", "4L28"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7V", "3T"],
			shadowball: ["7M", "7L33", "6M", "6L33", "5M", "5L33", "4M", "4L33", "3M", "3L45"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shadowpunch: ["7L1", "6L25", "5L25", "5S0", "4L25", "3L25"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["7L5", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L22", "6L22", "5L22", "5S0", "4T", "4L22"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7V"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
		},
	},
	gengar: {
		inherit: true,
		learnset: {
			astonish: ["6S4"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L19", "7V", "6L19", "6S1", "6S2", "6S4", "5L19", "4L19", "3L21", "3S0"],
			counter: ["7V", "3T"],
			curse: ["7L12", "6L12", "5L12", "4L12", "3L13", "3S0"],
			darkpulse: ["7M", "7L44", "6M", "6L44", "5T", "5L44", "4M", "4L44"],
			dazzlinggleam: ["7M", "6M"],
			destinybond: ["7L50", "6L50", "6S3", "5L50", "4L50", "3L39"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "7L39", "7V", "6M", "6L39", "5M", "5L39", "4M", "4L39", "3T", "3L31"],
			dynamicpunch: ["3T"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hex: ["7L55", "6L55", "5L55"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "6S5", "6S6", "5M", "4M", "3M"],
			hypnosis: ["7L1", "7V", "6L1", "6S5", "6S6", "5L1", "4L1", "3L1"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T"],
			infestation: ["7M", "6M"],
			knockoff: ["6T", "5T", "4T"],
			lick: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			meanlook: ["7L8", "6L8", "6S5", "6S6", "5L8", "4L8", "3L13"],
			megadrain: ["7V"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			nightmare: ["7L61", "6L61", "5L61", "4L55", "3T", "3L53"],
			nightshade: ["7L15", "7V", "6L15", "6S2", "5L15", "4L15", "3L16", "3S0"],
			ominouswind: ["4T"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "4M", "4L28"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "6S1", "6S5", "6S6", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			selfdestruct: ["7V", "3T"],
			shadowball: ["7M", "7L33", "6M", "6L33", "6S3", "6S4", "5M", "5L33", "4M", "4L33", "3M", "3L45"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shadowpunch: ["7L1", "6L25", "6S1", "6S2", "5L25", "4L25", "3L25"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "6S3", "5M", "4M", "3M"],
			sludgewave: ["6S4"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["7L5", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1", "3S0"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L22", "6L22", "6S1", "6S2", "5L22", "4T", "4L22"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "6S3", "5M", "4M"],
			wonderroom: ["6T", "5T"],
		},
	},
	onix: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["7L1", "7V", "6T", "6L1", "5T", "5L1", "5D", "4L1", "3L8"],
			block: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			bodyslam: ["7V", "3T"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			curse: ["7L4", "6L4", "5L46", "4L38"],
			defensecurl: ["7E", "6E", "5E", "4E"],
			dig: ["7L43", "7V", "6M", "6L43", "5M", "5L43", "4M", "3M"],
			doubleedge: ["7L49", "7V", "6L49", "5L57", "4L46", "3T", "3L56"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonbreath: ["7L25", "6L25", "5L41", "4L33", "3L30"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7V"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gyroball: ["7M", "7L20", "6M", "6L20", "5M", "4M"],
			harden: ["7L1", "7V", "6L1", "5L1", "4L1", "3L19"],
			headbutt: ["4T"],
			heavyslam: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["7L40", "6T", "6L40", "5T", "5L49", "4M", "4L38", "3M", "3L45"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			rage: ["7L13", "7V", "6L13", "5L14", "4L14", "3L23"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7E", "6E", "5E", "4E"],
			rockclimb: ["7E", "6E", "5E", "5D", "4M"],
			rockpolish: ["7M", "7L19", "6M", "6L19", "5M", "5L30", "4M", "4L30"],
			rockslide: ["7M", "7L34", "7V", "6M", "6L34", "5M", "5L34", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L7", "7V", "6L7", "5L9", "4L9", "3L12"],
			rocktomb: ["7M", "7L10", "6M", "6L10", "5M", "5L17", "4M", "4L17", "3M"],
			rollout: ["7E", "6E", "5E", "4T", "4E"],
			rototiller: ["7E", "6E"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "7L52", "6M", "6L52", "5M", "5L25", "4M", "4L22", "3M", "3L33"],
			sandtomb: ["7L37", "6L37", "5L54", "4L41", "3L49"],
			screech: ["7L31", "7V", "6L31", "5L6", "4L6", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7V", "3T"],
			skullbash: ["7V"],
			slam: ["7L28", "7V", "6L28", "5L33", "4L25", "3L37"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["7L16", "7E", "6T", "6L16", "6E", "5T", "5L38", "5E", "5D", "4M"],
			stoneedge: ["7M", "7L46", "6M", "6L46", "5M", "5L62", "4M", "4L49"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
		},
	},
	steelix: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			autotomize: ["7L19", "6L19", "5L30"],
			bind: ["7L1", "6T", "6L1", "5T", "5L1", "4L1", "3L8"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L37", "6L37", "5L54", "4L41", "3L49"],
			curse: ["7L4", "6L4", "5L46", "4L38"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["7L43", "6M", "6L43", "5M", "5L43", "4M", "3M"],
			doubleedge: ["7L49", "6L49", "5L57", "4L46", "3T", "3L56"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonbreath: ["7L25", "6L25", "5L41", "4L33", "3L30"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "7L20", "6M", "6L20", "5M", "4M"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L19"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7L1", "6L1", "5L1", "4L1"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["7L40", "6T", "6L40", "5T", "5L49", "4M", "4L38", "3M", "3L45"],
			magnetrise: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M"],
			rage: ["7L13", "6L13", "5L14", "4L14", "3L23"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M", "4L30"],
			rockslide: ["7M", "7L34", "6M", "6L34", "5M", "5L34", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L7", "6L7", "5L9", "4L9", "3L12"],
			rocktomb: ["7M", "7L10", "6M", "6L10", "5M", "5L17", "4M", "4L17", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "7L52", "6M", "6L52", "5M", "5L25", "4M", "4L22", "3M", "3L33"],
			screech: ["7L31", "6L31", "5L6", "4L6", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			slam: ["7L28", "6L28", "5L33", "4L25", "3L37"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["7L16", "6T", "6L16", "5T", "5L38", "4M"],
			stoneedge: ["7M", "7L46", "6M", "6L46", "5M", "5L62", "4M", "4L49"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
		},
	},
	drowzee: {
		inherit: true,
		learnset: {
			assist: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7E", "6E", "5E", "4E", "3E"],
			bellydrum: ["3S0"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L9", "7V", "6L9", "5L9", "4L9", "3L11"],
			counter: ["7V", "3T"],
			dazzlinggleam: ["7M", "6M"],
			disable: ["7L5", "7V", "6L5", "5L5", "4L7", "3L7"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "5D", "4M"],
			dreameater: ["7M", "7V", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			flatter: ["7E", "6E", "5E", "4E"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L61", "6L61", "5L61", "4L53", "3L45"],
			grassknot: ["7M", "6M", "5M", "4M"],
			guardswap: ["7E", "6E", "5E", "4E"],
			headbutt: ["7L29", "7L13", "7V", "6L13", "5L13", "4T", "4L15", "3L17"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypnosis: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			meditate: ["7L21", "7V", "6L21", "5L21", "4L21", "3L27"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			nastyplot: ["7L53", "7E", "6L53", "6E", "5L53", "5E", "4L43", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poisongas: ["7L17", "7V", "6L17", "5L17", "4L18", "3L21"],
			pound: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L25", "6L25", "5L25", "4L26"],
			psychic: ["7M", "7L49", "7V", "6M", "6L49", "5M", "5L49", "4M", "4L40", "3M", "3L31"],
			psychocut: ["7E", "6E", "5E", "5D", "4E"],
			psychup: ["7M", "7L33", "6M", "6L33", "5M", "5L33", "4M", "4L29", "3T", "3L37"],
			psyshock: ["7M", "7L57", "6M", "6L57", "5M", "5L57"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["7E", "6M", "6E", "5E", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "3T"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L45", "6M", "6L45", "5M", "5L45", "4M", "4L37", "3T", "3L41"],
			synchronoise: ["7L37", "6L37", "5L37"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wish: ["3S0"],
			zenheadbutt: ["7L41", "6T", "6L41", "5T", "5L41", "4T", "4L50"],
		},
	},
	hypno: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L9", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			counter: ["7V", "3T"],
			dazzlinggleam: ["7M", "6M"],
			disable: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "7V", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L61", "7L1", "6L1", "5L61", "4L69", "3L57"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["7L29", "7L13", "7V", "6L13", "5L13", "4T", "4L15", "3L17"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypnosis: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			icepunch: ["6T", "5T", "4T", "3T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			meditate: ["7L21", "7V", "6L21", "5L21", "4L21", "3L29", "3S0"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			nastyplot: ["7L53", "7L1", "6L1", "5L53", "4L55"],
			naturalgift: ["4M"],
			nightmare: ["7L1", "6L1", "5L1", "4L1", "3T", "3L1"],
			poisongas: ["7L17", "7V", "6L17", "5L17", "4L18", "3L21"],
			pound: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L25", "6L25", "5L25", "4L28"],
			psychic: ["7M", "7L49", "7V", "6M", "6L49", "5M", "5L49", "4M", "4L50", "3M", "3L35", "3S0"],
			psychup: ["7M", "7L33", "6M", "6L33", "5M", "5L33", "4M", "4L33", "3T", "3L43"],
			psyshock: ["7M", "7L57", "6M", "6L57", "5M", "5L57"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "3T"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L45", "6M", "6L45", "5M", "5L45", "4M", "4L45", "3T", "3L49"],
			switcheroo: ["7L1", "6L1", "5L1", "4L1"],
			synchronoise: ["7L37", "6L37", "5L37"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			zenheadbutt: ["7L41", "6T", "6L41", "5T", "5L41", "4T", "4L64"],
		},
	},
	krabby: {
		inherit: true,
		learnset: {
			agility: ["7E", "6E", "5E", "4E"],
			allyswitch: ["7E", "6E"],
			amnesia: ["7E", "6E", "5E", "5D", "4E", "3E"],
			ancientpower: ["7E", "6E", "5E", "4T", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7E", "7V", "6E", "5E"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brine: ["7L39", "6L39", "5L39", "4M", "4L39"],
			bubble: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["7L15", "7V", "6L15", "5L15", "4L15"],
			captivate: ["4M"],
			chipaway: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			crabhammer: ["7L41", "7V", "6L41", "5L41", "4L41", "3L45"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "4E", "3M", "3E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			flail: ["7L45", "7E", "6L45", "6E", "5L45", "5E", "4L45", "4E", "3L49", "3E"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			guillotine: ["7L31", "7V", "6L31", "5L31", "4L31", "3L34"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7L11", "7V", "6L11", "5L11", "4L11", "3L16"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			leer: ["7L9", "7V", "6L9", "5L9", "4L9", "3L5"],
			metalclaw: ["7L21", "6L21", "5L21", "4L21"],
			mimic: ["7V", "3T"],
			mudshot: ["7L19", "6L19", "5L19", "4L19", "3L23"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			protect: ["7M", "7L29", "6M", "6L29", "5M", "5L29", "4M", "4L29", "3M", "3L38"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "5D", "4M", "3M"],
			slam: ["7L35", "7E", "6L35", "6E", "5L35", "5E", "4L35", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stomp: ["7L25", "7V", "6L25", "5L25", "4L25", "3L27"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			tickle: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			visegrip: ["7L5", "7V", "6L5", "5L5", "5D", "4L5", "3L12"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	kingler: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brine: ["7L51", "6L51", "5L51", "4M", "4L51"],
			bubble: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["7L15", "7V", "6L15", "5L15", "4L15"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crabhammer: ["7L56", "7V", "6L56", "5L56", "4L56", "3L57"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			flail: ["7L63", "6L63", "5L63", "4L63", "3L65"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			guillotine: ["7L37", "7V", "6L37", "5L37", "4L37", "3L38"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7L11", "7V", "6L11", "5L11", "4L11", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L9", "7L1", "7V", "6L1", "5L1", "4L9", "3L1"],
			metalclaw: ["7L21", "6L21", "5L21", "4L21", "3L1"],
			mimic: ["7V", "3T"],
			mudshot: ["7L19", "6L19", "5L19", "4L19", "3L23"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			protect: ["7M", "7L32", "6M", "6L32", "5M", "5L32", "4M", "4L32", "3M", "3L42"],
			quash: ["7M", "6M", "5M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			slam: ["7L44", "6L44", "5L44", "4L44"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stomp: ["7L25", "7V", "6L25", "5L25", "4L25", "3L27"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			visegrip: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wideguard: ["7L1", "6L1", "5L1"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	voltorb: {
		inherit: true,
		learnset: {
			bide: ["7V"],
			charge: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			chargebeam: ["7M", "7L16", "6M", "6L16", "5M", "5L22", "4M", "4L26"],
			confide: ["7M", "6M"],
			discharge: ["7L37", "6L37"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			eerieimpulse: ["7L6", "6L6"],
			electroball: ["7L22", "6L22", "5L29"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L41", "7V", "6M", "6L41", "5M", "5L47", "4M", "4L43", "3T", "3L46"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gyroball: ["7M", "7L46", "6M", "6L43", "5M", "5L43", "4M", "4L40"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			lightscreen: ["7M", "7L29", "7V", "6M", "6L26", "5M", "5L26", "4M", "4L22", "3M", "3L37"],
			magiccoat: ["6T", "5T", "4T"],
			magnetrise: ["7L34", "6T", "6L34", "5T", "5L40", "4T", "4L36"],
			mimic: ["7V", "3T"],
			mirrorcoat: ["7L48", "6L48", "5L50", "4L47", "3L49", "3S0"],
			naturalgift: ["5D", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			refresh: ["3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L11", "6L11", "5L15", "4T", "4L15", "3T", "3L32"],
			round: ["7M", "6M", "5M"],
			screech: ["7L13", "7V", "6L13", "5L19", "4L19", "3L8"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7L26", "7V", "6L26", "5L33", "4L29", "3T", "3L27"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "5D", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			sonicboom: ["7L4", "7V", "6L4", "5L8", "4L8", "3L15"],
			spark: ["7L9", "6L9", "5L12", "4L12", "3L21", "3S0"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L20", "7V", "6L20", "5L36", "4T", "4L33", "3T", "3L42", "3S0"],
			tackle: ["7L1", "7V", "6L1", "5L5", "4L5", "3L1"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	electrode: {
		inherit: true,
		learnset: {
			bide: ["7V"],
			charge: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			chargebeam: ["7M", "7L16", "6M", "6L16", "5M", "5L22", "4M", "4L26"],
			confide: ["7M", "6M"],
			discharge: ["7L41", "6L41"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			eerieimpulse: ["7L6", "7L1", "6L6"],
			electroball: ["7L22", "6L22", "5L29"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L47", "7V", "6M", "6L47", "5M", "5L57", "4M", "4L51", "3T", "3L54"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "7L54", "6M", "6L51", "5M", "5L51", "4M", "4L46"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			lightscreen: ["7M", "7L29", "7V", "6M", "6L26", "5M", "5L26", "4M", "4L22", "3M", "3L41"],
			magiccoat: ["6T", "5T", "4T"],
			magneticflux: ["7L1", "6L1"],
			magnetrise: ["7L36", "6T", "6L36", "5T", "5L46", "4T", "4L40"],
			mimic: ["7V", "3T"],
			mirrorcoat: ["7L58", "6L58", "5L62", "4L57", "3L59"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L11", "6L11", "5L15", "4T", "4L15", "3T", "3L34"],
			round: ["7M", "6M", "5M"],
			screech: ["7L13", "7V", "6L13", "5L19", "4L19", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7L26", "7V", "6L26", "5L35", "4L29", "3T", "3L27"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			sonicboom: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			spark: ["7L9", "6L1", "5L1", "4L1", "3L21"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L20", "7V", "6L20", "5L40", "4T", "4L35", "3T", "3L48"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	exeggcute: {
		inherit: true,
		learnset: {
			ancientpower: ["7E", "6E", "5E", "4T", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrage: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			bestow: ["7L50", "6L50", "5L53"],
			bide: ["7V"],
			block: ["7E", "6T", "6E", "5T", "5E"],
			bulletseed: ["7L17", "6L17", "5L17", "4M", "4L17", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L27", "6L27", "5L27", "4L27", "3L19"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			eggbomb: ["7V"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "3T"],
			extrasensory: ["7L47", "6L47", "5L47"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7E", "6T", "6E", "5T", "5E", "5D", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grassyterrain: ["7E", "6E"],
			gravity: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypnosis: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			infestation: ["7M", "6M"],
			ingrain: ["7E", "6E", "5E", "4E", "3E"],
			leafstorm: ["7E", "6E", "5E", "4E"],
			leechseed: ["7L11", "7V", "6L11", "5L11", "4L11", "3L13"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7E", "6E", "5E", "4E"],
			mimic: ["7V", "3T"],
			moonlight: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["7L37", "7E", "6L37", "6E", "5L37", "5E", "4M", "4L37"],
			naturepower: ["7M", "7E", "6M", "6E", "5E", "4E"],
			nightmare: ["3T"],
			poisonpowder: ["7L21", "7V", "6L21", "5L21", "4L21", "3L31"],
			powerswap: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "5L47", "4M", "4L47", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			psywave: ["7V"],
			rage: ["7V"],
			reflect: ["7M", "7L7", "7V", "6M", "6L7", "5M", "5L7", "4M", "4L7", "4E", "3M", "3L7", "3E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			selfdestruct: ["7V", "3T"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			sleeppowder: ["7L23", "7V", "6L23", "5L23", "4L23", "3L37"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L43", "7V", "6M", "6L43", "5M", "5L43", "4M", "4L43", "3M", "3L43"],
			strength: ["6M", "5M", "4M", "3M"],
			stunspore: ["7L19", "7V", "6L19", "5L19", "4L19", "3L25"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["3S0"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			takedown: ["7V"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			wish: ["3S0"],
			worryseed: ["7L33", "6T", "6L33", "5T", "5L33", "4T", "4L33"],
		},
	},
	exeggutor: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "3S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrage: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			bide: ["7V"],
			block: ["6T", "5T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			eggbomb: ["7L27", "7V", "6L27", "5L27", "4L27", "3L31"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypnosis: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0"],
			infestation: ["7M", "6M"],
			leafstorm: ["7L47", "6L47", "5L47", "4L47"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			megadrain: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			nightmare: ["3T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M", "3S0"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "7L17", "6M", "6L17", "5M", "5L17"],
			psywave: ["7V"],
			rage: ["7V"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			selfdestruct: ["7V", "3T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stomp: ["7L1", "7V", "6L1", "5L1", "4L1", "3L19"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["6T", "5T", "4T"],
			takedown: ["7V"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			trickroom: ["7M", "6M", "5M", "4M"],
			woodhammer: ["7L37", "6L37", "5L37", "4L37"],
			worryseed: ["6T", "5T", "4T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	exeggutoralola: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			barrage: ["7L1"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulldoze: ["7M"],
			celebrate: ["7S0"],
			confide: ["7M"],
			confusion: ["7L1"],
			doubleteam: ["7M"],
			dracometeor: ["7T", "7S0"],
			dragonhammer: ["7L1"],
			dragontail: ["7M"],
			dreameater: ["7M"],
			earthquake: ["7M"],
			eggbomb: ["7L27"],
			energyball: ["7M"],
			explosion: ["7M"],
			facade: ["7M"],
			flamethrower: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			hypnosis: ["7L1"],
			infestation: ["7M"],
			leafstorm: ["7L47", "7S0"],
			lightscreen: ["7M"],
			naturepower: ["7M"],
			powerswap: ["7S0"],
			protect: ["7M"],
			psychic: ["7M"],
			psychup: ["7M"],
			psyshock: ["7M", "7L17"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			seedbomb: ["7L1"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			thief: ["7M"],
			toxic: ["7M"],
			trickroom: ["7M"],
			woodhammer: ["7L37"],
		},
	},
	cubone: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bellydrum: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			boneclub: ["7L7", "7V", "6L7", "5L7", "5D", "4L7", "3L9"],
			bonemerang: ["7L21", "7V", "6L21", "5L21", "4L21", "3L25"],
			bonerush: ["7L51", "6L37", "5L37", "4L37", "3L41"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			detect: ["7E", "6E", "5E", "4E"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7L43", "7V", "6L43", "5L43", "4L43", "3T", "3L45"],
			doublekick: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L41", "6T", "6L41", "5T", "5L41", "4T", "4L41"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "7L27", "6M", "6L27", "5M", "5L27", "4M", "4L27", "3L33"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "7L33", "6M", "6L33", "5M", "5L33", "4M", "4L33"],
			focusenergy: ["7L17", "7V", "6L17", "5L17", "4L17", "3L21"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["7L11", "7V", "6L11", "5L11", "4T", "4L11", "3L13"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["7E", "6T", "6E", "5T", "5E", "4E"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L13", "7V", "6L13", "5L13", "4L13", "3L17"],
			lowkick: ["6T", "5T", "5D", "4T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			perishsong: ["7E", "6E", "5E", "5D", "4E", "3E"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7L23", "7V", "6L23", "5L23", "4L23", "3L29"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["7L47", "6M", "6L47", "5M", "5L47"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			skullbash: ["7E", "7V", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stompingtantrum: ["7L37"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			tailwhip: ["7L3", "7V", "6L3", "5L3", "4L3", "3L5"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L31", "7V", "6L31", "5L31", "4L31", "3L37"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			watergun: ["7V"],
		},
	},
	marowak: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			boneclub: ["7L7", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			bonemerang: ["7L21", "7V", "6L21", "5L21", "4L21", "3L25"],
			bonerush: ["7L65", "6L43", "5L43", "4L43", "3L53"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7L53", "7V", "6L53", "5L53", "4L53", "3T", "3L61"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M", "3S0"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L49", "6T", "6L49", "5T", "5L49", "4T", "4L49"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "7L27", "6M", "6L27", "5M", "5L27", "4M", "4L27", "3L39"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L37"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L17", "7V", "6L17", "5L17", "4L17", "3L21"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["7L11", "7L1", "7V", "6L1", "5L1", "4T", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["6T", "5T"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L13", "7V", "6L13", "5L13", "4L13", "3L17"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7L23", "7V", "6L23", "5L23", "4L23", "3L32"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["7L59", "6M", "6L59", "5M", "5L59"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T", "3S0"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			sing: ["3S0"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stompingtantrum: ["7L43"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T", "3S0"],
			tailwhip: ["7L3", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L33", "7V", "6L33", "5L33", "4L33", "3L46"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			watergun: ["7V"],
		},
	},
	marowakalola: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			blizzard: ["7M"],
			boneclub: ["7L7", "7L1"],
			bonemerang: ["7L21"],
			bonerush: ["7L65"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulldoze: ["7M"],
			confide: ["7M"],
			darkpulse: ["7M"],
			doubleteam: ["7M"],
			dreameater: ["7M"],
			earthquake: ["7M"],
			echoedvoice: ["7M"],
			endeavor: ["7L49"],
			facade: ["7M"],
			falseswipe: ["7M"],
			fireblast: ["7M"],
			flamecharge: ["7M"],
			flamethrower: ["7M"],
			flamewheel: ["7L11", "7L1"],
			flareblitz: ["7L53"],
			fling: ["7M", "7L37"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			growl: ["7L1"],
			hex: ["7L17"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			leer: ["7L13"],
			protect: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			retaliate: ["7L59"],
			return: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			sandstorm: ["7M"],
			shadowball: ["7M"],
			shadowbone: ["7L27"],
			sleeptalk: ["7M"],
			smackdown: ["7M"],
			stompingtantrum: ["7L43"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tailwhip: ["7L3", "7L1"],
			thief: ["7M"],
			thrash: ["7L33"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M"],
			willowisp: ["7M", "7L23"],
		},
	},
	tyrogue: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7E", "6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T"],
			covet: ["6T", "5T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L1", "6L1", "5L1", "5D", "4L1"],
			feint: ["7E", "6E", "5E", "5D"],
			foresight: ["7L1", "6L1", "5L1", "4L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["7L1", "7E", "6T", "6L1", "6E", "5T", "5L1", "5E", "4T", "4L1", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			highjumpkick: ["7E", "6E", "5E", "4E", "3E"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			machpunch: ["7E", "6E", "5E", "5D", "4E", "3E"],
			megakick: ["3T"],
			mimic: ["3T"],
			mindreader: ["7E", "6E", "5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			vacuumwave: ["7E", "6E", "5E", "4T", "4E"],
			workup: ["7M", "5M"],
		},
	},
	hitmonlee: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blazekick: ["7L45", "6L45", "5L45", "4L41"],
			bodyslam: ["7V", "3T"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "7L17", "6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L20"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7E"],
			captivate: ["4M"],
			closecombat: ["7L57", "7L1", "6L1", "5L57", "4L53"],
			confide: ["7M", "6M"],
			counter: ["7E", "7V", "3T"],
			covet: ["6T", "5T"],
			doubleedge: ["7V", "3T"],
			doublekick: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7L49", "7E", "6L49", "5L49", "4M", "4L45", "3T", "3L41"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7L25", "7E", "6L25", "5L25", "4L25"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L21", "7V", "6L21", "5L21", "4L21", "3L21"],
			focuspunch: ["6T", "4M", "3M"],
			foresight: ["7L37", "6L37", "5L37", "4L37", "3L36"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["7E", "6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			highjumpkick: ["7L29", "7E", "7V", "6L29", "5L29", "4L29", "3L26", "3S0"],
			jumpkick: ["7L13", "7L1", "7V", "6L13", "5L13", "4L13", "3L16"],
			knockoff: ["6T", "5T", "4T"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			machpunch: ["7E"],
			meditate: ["7L5", "7L1", "7V", "6L5", "5L5", "4L5", "3L6"],
			megakick: ["7L53", "7L1", "7V", "6L1", "5L53", "4L49", "3T", "3L46", "3S0"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mindreader: ["7L33", "7E", "6L33", "5L33", "4L33", "3L31", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7E"],
			refresh: ["3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			reversal: ["7L61", "7L1", "6L1", "5L61", "4L57", "3L51"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			rollingkick: ["7L9", "7L1", "7V", "6L9", "5L9", "4L9", "3L11"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			vacuumwave: ["7E", "4T"],
			wideguard: ["7L41", "6L41", "5L41"],
			workup: ["7M", "5M"],
		},
	},
	hitmonchan: {
		inherit: true,
		learnset: {
			agility: ["7L6", "7L1", "7V", "6L6", "5L6", "4L6", "3L7"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7L16", "7E", "6L16", "5L16", "4L16"],
			captivate: ["4M"],
			closecombat: ["7L66", "7L1", "6L1", "5L66", "4L56"],
			cometpunch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			confide: ["7M", "6M"],
			counter: ["7L61", "7E", "7L1", "7V", "6L1", "5L61", "4L51", "3T", "3L50"],
			covet: ["6T", "5T"],
			detect: ["7L50", "6L50", "5L51", "4L46", "3L44"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7L21", "7E", "6L21", "5L21", "4L21"],
			firepunch: ["7L36", "7V", "6T", "6L36", "5T", "5L36", "4T", "4L31", "3T", "3L26"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["7L56", "7L1", "6T", "6L1", "5L56", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["7E", "6T", "5T", "4T", "3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			highjumpkick: ["7E"],
			icepunch: ["7L36", "7V", "6T", "6L36", "5T", "5L36", "4T", "4L31", "3T", "3L26"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			machpunch: ["7L16", "7E", "7L1", "6L16", "5L16", "4L16", "3L20"],
			megakick: ["7V", "3T"],
			megapunch: ["7L46", "7V", "6L46", "5L46", "4L41", "3T", "3L38", "3S0"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mindreader: ["7E", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L11", "7E", "7L1", "6L11", "5L11", "4L11", "3L13"],
			quickguard: ["7L31", "6L31", "5L31"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			skullbash: ["7V"],
			skyuppercut: ["7L41", "6L41", "5L41", "4L36", "3L32", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["7L36", "7V", "6T", "6L36", "5T", "5L36", "4T", "4L31", "3T", "3L26"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			vacuumwave: ["7L26", "7E", "6L26", "5L26", "4T", "4L26"],
			workup: ["7M", "5M"],
		},
	},
	hitmontop: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			agility: ["7L37", "6L37", "5L37", "4L37", "3L37"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7E"],
			captivate: ["4M"],
			closecombat: ["7L55", "7L1", "6L1", "5L55", "5S0", "4L51"],
			confide: ["7M", "6M"],
			counter: ["7L28", "7E", "6L28", "5L28", "4L28", "3T", "3L31"],
			covet: ["6T", "5T"],
			detect: ["7L50", "7L1", "6L50", "5L51", "4L46", "3L43"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drillrun: ["5T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endeavor: ["7L60", "7L1", "6T", "6L1", "5T", "5L60", "4T", "4L55", "3L49"],
			endure: ["7E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["5S0"],
			feint: ["7L24", "7E", "6L33", "5L33", "4L33"],
			focusenergy: ["7L6", "7L1", "6L6", "5L6", "4L6", "3L7"],
			foresight: ["4C"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gyroball: ["7M", "7L42", "6M", "6L42", "5M", "5L42", "4M", "4L42"],
			headbutt: ["4T"],
			helpinghand: ["7E", "6T", "5T", "5S0", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			highjumpkick: ["7E"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			machpunch: ["7E", "3C"],
			megakick: ["3T"],
			mimic: ["3T"],
			mindreader: ["7E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L10", "7E", "7L1", "6L10", "5L10", "4L10", "3L13"],
			quickattack: ["7L15", "7L1", "6L15", "5L15", "4L15", "3L19"],
			quickguard: ["7L46", "6L46", "5L46"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7L19", "7E", "6L24", "5L24", "4L24", "3L25"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			rollingkick: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["5S0", "4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			triplekick: ["7L33", "6L19", "5L19", "4L19", "3L20"],
			twister: ["4T"],
			vacuumwave: ["7E", "4T"],
			wideguard: ["7L46", "6L46", "5L46"],
			workup: ["7M", "5M"],
		},
	},
	lickitung: {
		inherit: true,
		learnset: {
			amnesia: ["7E", "6E", "5E", "4E"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7E", "6E"],
			bellydrum: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "7V", "6E", "5E", "4E", "3T", "3E"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L37", "6L37", "5L37"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defensecurl: ["7L9", "7V", "6L9", "5L9", "4L9", "3T", "3L12", "3S1"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7L25", "7V", "6L25", "5L25", "4L25", "3L34"],
			doubleedge: ["7V", "3T", "3S1"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragontail: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hammerarm: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			healbell: ["3S0"],
			helpinghand: ["3S1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["7L13", "6T", "6L13", "5T", "5L13", "4T", "4L13", "3L18"],
			lick: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			magnitude: ["7E", "6E", "5E", "4E", "3E"],
			mefirst: ["7L41", "6L41", "5L41", "4L37"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			muddywater: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poweruppunch: ["6M"],
			powerwhip: ["7L53", "6L53", "5L53", "4L49"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7L45", "6L45", "5L45", "4L41", "3L51"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["5D", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L33", "6L33", "5L33", "4T", "4L33", "3T", "3S1"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			screech: ["7L49", "7V", "6L49", "5L49", "4L45", "3L45"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			slam: ["7L29", "7V", "6L29", "5L29", "4L29", "3L40"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "5D", "4M", "4E", "3T", "3E"],
			smellingsalts: ["7E", "6E", "5E", "4E", "3E"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stomp: ["7L21", "7V", "6L21", "5L21", "4L21", "3L23"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L5", "7V", "6L5", "5L5", "4L5", "3L7"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wish: ["3S0"],
			workup: ["7M", "5M"],
			wrap: ["7L17", "7V", "6L17", "5L17", "4L17", "3L29"],
			wringout: ["7L57", "6L57", "5L57", "4L53"],
			zenheadbutt: ["7E", "6T", "6E", "5T", "5E", "4T"],
		},
	},
	lickilicky: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "6M", "5M", "4M"],
			block: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L37", "6L37", "5L37"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["7L9", "6L9", "5L9", "4L9"],
			dig: ["6M", "5M", "4M"],
			disable: ["7L25", "6L25", "5L25", "4L25"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dragontail: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "4T"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "7L61", "6M", "6L61", "5M", "5L61", "4M", "4L57"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["7L13", "6T", "6L13", "5T", "5L13", "4T", "4L13"],
			lick: ["7L1", "6L1", "5L1", "4L1"],
			mefirst: ["7L41", "6L41", "5L41", "4L37"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			powerwhip: ["7L53", "7L1", "6L1", "5L53", "4L49"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			refresh: ["7L45", "6L45", "5L45", "4L41"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["7L33", "6L33", "5L33", "4T", "4L33"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			screech: ["7L49", "6L49", "5L49", "4L45"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			slam: ["7L29", "6L29", "5L29", "4L29"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stomp: ["7L21", "6L21", "5L21", "4L21"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			supersonic: ["7L5", "6L5", "5L5", "4L5"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
			wrap: ["7L17", "6L17", "5L17", "4L17"],
			wringout: ["7L57", "7L1", "6L1", "5L57", "4L53"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	koffing: {
		inherit: true,
		learnset: {
			assurance: ["7L12", "6L12", "5L15", "4L15"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7L42", "6L42"],
			bide: ["7V"],
			captivate: ["4M"],
			clearsmog: ["7L15", "6L15", "5L19"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "4E"],
			darkpulse: ["7M", "6M", "5T", "5D", "4M"],
			destinybond: ["7L40", "7E", "6L40", "6E", "5L51", "5E", "4L46", "4E", "3L45", "3E"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L37", "7V", "6M", "6L37", "5M", "5L42", "4M", "4L37", "3T", "3L41"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grudge: ["7E", "6E", "5E", "4E"],
			gyroball: ["7M", "7L29", "6M", "6L29", "5M", "5L37", "4M", "4L33"],
			haze: ["7L26", "7V", "6L26", "5L33", "4L28", "3L33"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			infestation: ["7M", "6M"],
			memento: ["7L45", "6L45", "5L55", "4L51", "3L49"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			painsplit: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			payback: ["7M", "6M", "5M", "4M"],
			poisongas: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7E", "6E", "5E", "4E", "3E"],
			psywave: ["7E", "6E", "5E", "4E", "3E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7L23", "7V", "6L23", "5L24", "4L19", "3T", "3L17"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludge: ["7L18", "7V", "6L18", "5L28", "4L24", "3L21"],
			sludgebomb: ["7M", "7L34", "6M", "6L34", "5M", "5L46", "4M", "4L42", "3M"],
			sludgewave: ["5D"],
			smog: ["7L4", "7V", "6L4", "5L6", "5D", "4L6", "3L9"],
			smokescreen: ["7L7", "7V", "6L7", "5L10", "4L10", "3L25"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			spitup: ["7E", "6E", "5E"],
			stockpile: ["7E", "6E", "5E"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7E", "6E", "5E"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7E", "6E"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M", "4E", "3E"],
		},
	},
	weezing: {
		inherit: true,
		learnset: {
			assurance: ["7L12", "6L12", "5L15", "4L15"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7L51", "6L50"],
			bide: ["7V"],
			captivate: ["4M"],
			clearsmog: ["7L15", "6L15", "5L19"],
			confide: ["7M", "6M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			destinybond: ["7L46", "6L46", "5L59", "4L55", "3L51"],
			doublehit: ["7L1", "6L29", "5L39", "4L33"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L40", "7V", "6M", "6L40", "5M", "5L46", "4M", "4L40", "3T", "3L44"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "7L29", "6M", "5M", "4M"],
			haze: ["7L26", "7V", "6L26", "5L33", "4L28", "3L33"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			infestation: ["7M", "6M"],
			memento: ["7L57", "6L54", "5L65", "4L63", "3L58"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			poisongas: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7L23", "7V", "6L23", "5L24", "4L19", "3T", "3L1"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludge: ["7L18", "7V", "6L18", "5L28", "4L24", "3L21"],
			sludgebomb: ["7M", "7L34", "6M", "6L34", "5M", "5L52", "4M", "4L48", "3M"],
			smog: ["7L4", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			smokescreen: ["7L7", "7L1", "7V", "6L1", "5L1", "4L1", "3L25"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	rhyhorn: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			bulldoze: ["7M", "7L21", "6M", "6L21", "5M", "5L30"],
			captivate: ["4M"],
			chipaway: ["7L25", "6L25", "5L34"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "5D", "4E", "3T", "3E"],
			crunch: ["7E", "6E", "5E", "4E", "3E"],
			crushclaw: ["7E", "6E", "5E", "4E", "3E"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "5D", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrush: ["7E", "6E", "5E", "4E"],
			drillrun: ["7L33", "6T", "6L33", "5T", "5L45"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L45", "7V", "6M", "6L45", "5M", "5L56", "4M", "4L49", "3M", "3L52"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firefang: ["7E", "6E", "5E", "4E"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L5", "7V", "6L5", "5L12", "4L13", "3L15"],
			guardsplit: ["7E", "6E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hornattack: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			horndrill: ["7L53", "7V", "6L53", "5L63", "4L37", "3L38"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7E", "6E", "5E", "4E"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			leer: ["7V"],
			magnitude: ["7E", "6E", "5E", "4E", "3E"],
			megahorn: ["7L49", "6L49", "5L67", "4L57", "3L57"],
			metalburst: ["7E", "6E"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7E", "6E", "5E", "4E", "3E"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L29", "6L23", "5L23", "4L25", "3L29"],
			rockclimb: ["7E", "6E", "5E", "4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			rototiller: ["7E", "6E"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scaryface: ["7L9", "6L9", "5L19", "4L21", "3L24"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7E", "7V", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "7L13", "6M", "6L13"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stomp: ["7L17", "7V", "6L8", "5L8", "4L9", "3L10"],
			stoneedge: ["7M", "7L41", "6M", "6L41", "5M", "5L52", "4M", "4L45"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			tailwhip: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L37", "7V", "6L37", "5L41", "4L33", "3L43"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderfang: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
		},
	},
	rhydon: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "7L21", "6M", "6L21", "5M", "5L30"],
			captivate: ["4M"],
			chipaway: ["7L25", "6L25", "5L34"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			drillrun: ["7L33", "6T", "6L33", "5T", "5L47"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L48", "7V", "6M", "6L48", "5M", "5L62", "4M", "4L49", "3M", "3L58", "3S0"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hammerarm: ["7L1", "6L42", "5L42", "4L42"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hornattack: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			horndrill: ["7L62", "7L1", "7V", "6L1", "5L71", "4L37", "3L38"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7V"],
			megahorn: ["7L55", "6L1", "5L77", "4L57", "3L66", "3S0"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			payday: ["7V"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L29", "6L23", "5L23", "4L25", "3L29"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scaryface: ["7L9", "7L1", "6L1", "5L19", "4L21", "3L24", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "7L13", "6M", "6L13", "5M"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stomp: ["7L17", "7V", "6L1", "5L1", "4L1", "3L1"],
			stoneedge: ["7M", "7L41", "6M", "6L41", "5M", "5L56", "4M", "4L45"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			tailwhip: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L37", "7V", "6L37", "5L41", "4L33", "3L46"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			watergun: ["7V"],
			whirlpool: ["4M"],
		},
	},
	rhyperior: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			block: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "7L21", "6M", "6L21", "5M"],
			captivate: ["4M"],
			chipaway: ["7L25", "6L25", "5L30"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			drillrun: ["7L33", "6T", "6L33", "5T", "5L47"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L48", "6M", "6L48", "5M", "5L62", "4M", "4L49"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "4T"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furyattack: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hammerarm: ["7L1", "6L42", "5L42", "4L42"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hornattack: ["7L1", "6L1", "5L1", "4L1"],
			horndrill: ["7L62", "7L1", "6L1", "5L71", "4L37"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			megahorn: ["7L55", "6L1", "5L77", "4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockblast: ["7L29", "6L23", "5L23", "4L25"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rockwrecker: ["7L69", "7L1", "6L1", "5L86", "4L61"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			scaryface: ["7L9", "7L1", "6L1", "5L19", "4L21"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			smackdown: ["7M", "7L13", "6M", "6L13", "5M"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stomp: ["7L17", "6L1", "5L1", "4L1"],
			stoneedge: ["7M", "7L41", "6M", "6L41", "5M", "5L56", "4M", "4L45"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			tailwhip: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L37", "6L37", "5L41", "4L33"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			whirlpool: ["4M"],
		},
	},
	happiny: {
		inherit: true,
		learnset: {
			aromatherapy: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			charm: ["7L1", "6L1", "5L1", "4L1"],
			confide: ["7M", "6M"],
			copycat: ["7L5", "6L5", "5L5", "4L5"],
			counter: ["7E", "6E", "5E", "4E"],
			covet: ["6T", "5T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["7E", "6E", "5E", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			lastresort: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			metronome: ["7E", "6E", "5E", "4E"],
			mudbomb: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			pound: ["7L1", "6L1", "5L1", "4L1"],
			present: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["6T", "5T", "4M"],
			refresh: ["7L9", "6L9", "5L9", "4L9"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M", "4E"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			sweetkiss: ["7L12", "6L12", "5L12", "4L12"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	chansey: {
		inherit: true,
		learnset: {
			aromatherapy: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bestow: ["7L20", "6L20", "5L20"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "7V", "6E", "5E", "5D", "4E", "3T"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["7L1", "7V", "6L1", "5L1", "4L31", "3T", "3L41"],
			doubleedge: ["7L54", "7L1", "7V", "6L1", "5L54", "4L46", "3T", "3L57"],
			doubleslap: ["7L12", "7V", "6L12", "5L12", "4L16", "3L17"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			eggbomb: ["7L42", "7V", "6L42", "5L42", "4L38", "3L35"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "7L34", "6M", "6L34", "5M", "5L34", "4M", "4L27"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			growl: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1", "3S1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			healingwish: ["7L50", "6L50", "5L50", "4L42"],
			healpulse: ["7L38", "6L38", "5L38"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "7L46", "7V", "6M", "6L46", "5M", "5L46", "4M", "4L34", "3M", "3L49"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7E", "7V", "6E", "5E", "4E", "3T", "3E"],
			mimic: ["7V", "3T"],
			minimize: ["7L23", "7V", "6L23", "5L23", "4L20", "3L23"],
			mudbomb: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			pound: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S1"],
			poweruppunch: ["6M"],
			present: ["7E", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7V"],
			refresh: ["7L9", "6L9", "5L9", "4L9", "3L9", "3S1"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7E", "7V", "6E", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sing: ["7L31", "7V", "6L31", "5L31", "4L23", "3L29"],
			skillswap: ["6T", "5T", "4M", "3M", "3S2"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			softboiled: ["7L16", "7V", "6L16", "5L16", "4L12", "3T", "3L13", "3S2"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["3S2"],
			sweetscent: ["3S0"],
			tailwhip: ["7L5", "7V", "6L5", "5L5", "4L5", "3L5", "3S1"],
			takedown: ["7L27", "7V", "6L27", "5L27"],
			teleport: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M", "3S2"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			wish: ["3S0"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	blissey: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bestow: ["7L20", "6L20", "5L20"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["7L1", "6L1", "5L1", "4L31", "3T", "3L33"],
			doubleedge: ["7L54", "7L1", "6L1", "5L54", "4L46", "3T", "3L47"],
			doubleslap: ["7L12", "6L12", "5L12", "4L16", "3L13"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			eggbomb: ["7L42", "6L42", "5L42", "4L38", "3L28"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "7L34", "6M", "6L34", "5M", "5L34", "4M", "4L27"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			growl: ["7L1", "6L1", "5L1", "5S0", "4L1", "3L1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			healingwish: ["7L50", "6L50", "5L50", "4L42"],
			healpulse: ["7L38", "6L38", "5L38"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "7L46", "6M", "6L46", "5M", "5L46", "4M", "4L34", "3M", "3L40"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			minimize: ["7L23", "6L23", "5L23", "4L20", "3L18"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["7L1", "6L1", "5L1", "5S0", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			refresh: ["7L9", "6L9", "5L9", "5S0", "4L9", "3L7"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sing: ["7L31", "6L31", "5L31", "4L23", "3L23"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			softboiled: ["7L16", "6L16", "5L16", "4L12", "3T", "3L10"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tailwhip: ["7L5", "6L5", "5L5", "5S0", "4L5", "3L4"],
			takedown: ["7L27", "6L27", "5L27"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	tangela: {
		inherit: true,
		learnset: {
			absorb: ["7L10", "7V", "6L10", "5L8", "4L8", "3L10"],
			amnesia: ["7E", "6E", "5E", "4E", "3E"],
			ancientpower: ["7L38", "6L38", "5L36", "4T", "4L33"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["7L17", "7V", "6T", "6L17", "5T", "5L22", "4L22", "3L28"],
			bodyslam: ["7V", "3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7E", "6E", "5E", "4E", "3E"],
			constrict: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endeavor: ["7E", "6T", "6E", "5T", "5E", "4E"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7L36", "7E", "6T", "6L36", "6E", "5T", "5L36", "5E", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grassyterrain: ["7L48", "6L48"],
			growth: ["7L20", "7V", "6L20", "5L12", "4L12", "3L13"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			ingrain: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			knockoff: ["7L27", "6T", "6L27", "5T", "5L33", "4T", "4L36"],
			leafstorm: ["7E", "6E", "5E", "4E"],
			leechseed: ["7E", "6E", "5E", "5D", "4E", "3E"],
			megadrain: ["7L23", "7E", "7V", "6L23", "6E", "5L26", "5E", "4L26", "4E", "3L31", "3E"],
			mimic: ["7V", "3T"],
			morningsun: ["3S0"],
			naturalgift: ["7L33", "7E", "6L33", "6E", "5L40", "5E", "4M", "4L40"],
			naturepower: ["7M", "7E", "6E", "5E", "4E", "3E"],
			painsplit: ["6T", "5T", "4T"],
			poisonpowder: ["7L14", "7V", "6L14", "5L15", "4L15", "3L19"],
			powerswap: ["7E", "6E", "5E", "4E"],
			powerwhip: ["7L50", "6L50", "5L54", "4L54"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			rage: ["7V"],
			ragepowder: ["7E", "6E", "5E"],
			reflect: ["7M", "6M", "5M", "4M", "4E", "3E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "5D", "4T"],
			shockwave: ["6T", "4M"],
			skullbash: ["7V"],
			slam: ["7L41", "7V", "6L41", "5L43", "4L43", "3L40"],
			sleeppowder: ["7L4", "7V", "6L4", "5L5", "5D", "4L5", "3L4"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M", "3S0"],
			stunspore: ["7L30", "7V", "6L30", "5L29", "4L29", "3L37"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			tickle: ["7L44", "6L44", "5L47", "4L47", "3L46"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			vinewhip: ["7L7", "7V", "6L7", "5L19", "4L19", "3L22"],
			worryseed: ["6T", "5T", "4T"],
			wringout: ["7L46", "6L46", "5L50", "4L50"],
		},
	},
	tangrowth: {
		inherit: true,
		learnset: {
			absorb: ["7L10", "6L10", "5L8", "4L8"],
			aerialace: ["7M", "6M", "5M", "4M"],
			ancientpower: ["7L40", "6L40", "5L36", "4T", "4L33", "4S0"],
			attract: ["7M", "6M", "5M", "4M"],
			bind: ["7L17", "6T", "6L17", "5T", "5L22", "4L22"],
			block: ["7L56", "7L1", "6T", "6L1", "5T", "5L57", "4T", "4L57"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			constrict: ["7L1", "6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endeavor: ["6T", "5T"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["7L36", "6T", "6L36", "5T", "5L36", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grassyterrain: ["7L50", "6L50"],
			growth: ["7L20", "6L20", "5L12", "4L12"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			infestation: ["7M", "6M"],
			ingrain: ["7L1", "6L1", "5L1", "4L1"],
			knockoff: ["7L27", "6T", "6L27", "5T", "5L33", "4T", "4L36"],
			megadrain: ["7L23", "6L23", "5L26", "4L26"],
			morningsun: ["4S0"],
			mudslap: ["4T"],
			naturalgift: ["7L33", "6L33", "5L40", "4M", "4L40", "4S0"],
			naturepower: ["7M", "6M"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonpowder: ["7L14", "6L14", "5L15", "4L15"],
			powerwhip: ["7L53", "6L53", "5L54", "4L54"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			shockwave: ["6T", "4M"],
			slam: ["7L43", "6L43", "5L43", "4L43"],
			sleeppowder: ["7L4", "6L4", "5L5", "4L5"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			stunspore: ["7L30", "6L30", "5L29", "4L29"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M", "4S0"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M"],
			tickle: ["7L46", "6L46", "5L47", "4L47"],
			toxic: ["7M", "6M", "5M", "4M"],
			vinewhip: ["7L7", "6L7", "5L19", "4L19"],
			worryseed: ["6T", "5T", "4T"],
			wringout: ["7L49", "6L49", "5L50", "4L50"],
		},
	},
	kangaskhan: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bide: ["7V"],
			bite: ["7L13", "7V", "6L13", "5L13", "4L13", "3L7", "3S1"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L31", "6L31", "5L31"],
			circlethrow: ["7E", "6E", "5E"],
			cometpunch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S1"],
			confide: ["7M", "6M"],
			counter: ["7E", "7V", "6E", "5E", "5D", "4E", "3T", "3E"],
			covet: ["6T", "5T"],
			crunch: ["7L37", "6L37", "5L37", "4L31"],
			crushclaw: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			dizzypunch: ["7L34", "7V", "6L34", "5L34", "4L25", "3L43", "3S2"],
			doubleedge: ["7E", "7V", "6E", "5E", "4E", "3T"],
			doublehit: ["7L19", "6L19", "5L19", "4L43"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "5D", "4M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "7V", "6M", "6S3", "5M", "4M", "3M", "3S2"],
			endeavor: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			endure: ["7L43", "6L43", "5L43", "4M", "4L34", "3T", "3L37"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L7", "6L7", "6S3", "5L7", "5D", "4L7", "3L19"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7E", "6E", "5E", "4E", "3E"],
			focuspunch: ["7E", "6T", "6E", "5E", "4M", "3M"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hammerarm: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S1"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["7V", "3T"],
			megapunch: ["7L25", "7V", "6L25", "5L25", "4L19", "3T", "3L25"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["7L46", "6T", "6L46", "5T", "5L46", "4T", "4L37"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7L22", "7V", "6L22", "5L22", "4L22", "3L31"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "6S3", "5M", "4M", "3M"],
			reversal: ["7L50", "6L50", "5L55", "4L49", "3L49"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4E", "3E"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			sing: ["3S2"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["6T", "5T", "4T"],
			stomp: ["7E", "6E", "5E", "4E", "3E"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["7L49", "6L49", "6S3", "5L49", "4T", "4L46"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tailwhip: ["7L10", "7V", "6L10", "5L10", "4L10", "3L13", "3S2"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			trumpcard: ["7E", "6E", "5E"],
			uproar: ["7E", "6T", "6E", "5T", "5E", "4T"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wish: ["3S0"],
			workup: ["7M", "5M"],
			yawn: ["3S0"],
		},
	},
	horsea: {
		inherit: true,
		learnset: {
			agility: ["7L36", "7V", "6L23", "5L23", "4L23", "3L36"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["7L31", "6L30", "5L30", "5D", "4M", "4L30"],
			bubble: ["7L1", "7V", "6L1", "5L1", "5S0", "5D", "4L1", "3L1"],
			bubblebeam: ["7L21", "7V", "6L18", "5L18", "4L18"],
			captivate: ["4M"],
			clearsmog: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonbreath: ["7E", "6E", "5E", "4E", "3E"],
			dragondance: ["7L46", "6L38", "5L38", "4L38", "3L50"],
			dragonpulse: ["7L41", "6T", "6L41", "5T", "5L42", "4M", "4L42"],
			dragonrage: ["7E", "6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L26", "6L14", "5L14", "4L14"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L52", "7V", "6L35", "5L35", "4L35", "3L43"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			leer: ["7L9", "7V", "6L8", "5L8", "4L8", "3L15"],
			mimic: ["7V", "3T"],
			muddywater: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			octazooka: ["7E", "6E", "5E", "5D", "4E", "3E"],
			outrage: ["7E", "6T", "6E", "5T", "5E", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7E", "6E", "5E", "4E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smokescreen: ["7L5", "7V", "6L4", "5L4", "4L4", "3L8"],
			snore: ["6T", "5T", "4T", "3T"],
			splash: ["7E", "6E", "5E", "4E", "3E"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["7L17", "6L17", "5L26", "4T", "4L26", "3L29"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L13", "7V", "6L1", "5L11", "4L11", "3L22"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	seadra: {
		inherit: true,
		learnset: {
			agility: ["7L38", "7V", "6L23", "5L23", "4L23", "3L40", "3S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["7L31", "6L30", "5L30", "4M", "4L30"],
			bubble: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["7L21", "7V", "6L18", "5L18", "4L18"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragondance: ["7L52", "6L48", "5L48", "4L48", "3L62"],
			dragonpulse: ["7L45", "6T", "6L45", "5T", "5L57", "4M", "4L57"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L26", "6L14", "5L14", "4L14"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L60", "7L1", "7V", "6L1", "5L40", "4L40", "3L51"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			leer: ["7L9", "7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smokescreen: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["7L17", "6L17", "5L26", "4T", "4L26", "3L29", "3S0"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L13", "7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	kingdra: {
		inherit: true,
		learnset: {
			agility: ["7L38", "6L23", "5L23", "4L23", "3L40", "3S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			brine: ["7L31", "6L30", "5L30", "4M", "4L30"],
			bubble: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["7L21", "6L18", "5L18", "4L18"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "5S1", "4T"],
			dragondance: ["7L52", "6L48", "5L48", "4L48", "3L62"],
			dragonpulse: ["7L45", "6T", "6L1", "5T", "5L57", "5S1", "4M", "4L57"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L26", "6L14", "5L14", "4L14"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L60", "7L1", "6L1", "5L40", "4L40", "3L51"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			ironhead: ["6T", "5T", "4T"],
			leer: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			mimic: ["3T"],
			muddywater: ["5S1"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "5S1", "4M", "3M"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smokescreen: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["7L17", "6L17", "5L26", "4T", "4L26", "3L29", "3S0"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L13", "7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			yawn: ["7L1", "6L1", "5L1", "4L1"],
		},
	},
	goldeen: {
		inherit: true,
		learnset: {
			agility: ["7L29", "7V", "6L29", "5L47", "4L47", "3L52"],
			aquaring: ["7L21", "6L21", "5L27", "4L27"],
			aquatail: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "4E"],
			bounce: ["6T", "5T", "4T"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillrun: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L13", "6L13", "5L21", "4L21", "3L24"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L24", "7V", "6L24", "5L31", "4L31", "3L29"],
			furycutter: ["4T"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hornattack: ["7L8", "7V", "6L8", "5L11", "4L11", "3L15"],
			horndrill: ["7L37", "7V", "6L37", "5L41", "4L41", "3L43"],
			hydropump: ["7E", "6E", "5E", "4E", "3E"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			knockoff: ["6T", "5T", "4T"],
			megahorn: ["7L45", "6L45", "5L57", "4L51", "3L57"],
			mimic: ["7V", "3T"],
			mudshot: ["7E", "6E", "5E"],
			mudslap: ["7E", "6E", "5E", "4T", "4E"],
			mudsport: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			peck: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7E", "6E", "5E", "5D", "4E", "3E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E"],
			skullbash: ["7E", "7V", "6E", "5E"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7L40", "6L40", "5L51"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			supersonic: ["7L5", "7V", "6L5", "5L7", "4L7", "3L10"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwhip: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "7L32", "7V", "6M", "6L32", "5M", "5L37", "4M", "4L37", "3M", "3L38"],
			watergun: ["7V"],
			waterpulse: ["7L16", "6T", "6L16", "5L17", "5D", "4M", "4L17", "3M"],
			watersport: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
		},
	},
	seaking: {
		inherit: true,
		learnset: {
			agility: ["7L29", "7V", "6L29", "5L56", "4L56", "3L61"],
			aquaring: ["7L21", "6L21", "5L27", "4L27"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillrun: ["6T", "5T"],
			endure: ["5D", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L13", "6L13", "5L21", "4L21", "3L24"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L24", "7V", "6L24", "5L31", "4L31", "3L29"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hornattack: ["7L8", "7V", "6L8", "5L11", "4L11", "3L15"],
			horndrill: ["7L40", "7V", "6L40", "5L47", "4L47", "3L49"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			knockoff: ["6T", "5T", "4T"],
			megahorn: ["7L54", "7L1", "6L1", "5L72", "4L63", "3L69"],
			mimic: ["7V", "3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			poisonjab: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6T", "5T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "5D", "4M", "3T"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7L46", "6L46", "5L63"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			supersonic: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwhip: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "7L32", "7V", "6M", "6L32", "5M", "5L40", "4M", "4L40", "3M", "3L41"],
			watergun: ["7V"],
			waterpulse: ["7L16", "6T", "6L16", "5L17", "5D", "4M", "4L17", "3M"],
			watersport: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
		},
	},
	staryu: {
		inherit: true,
		learnset: {
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			brine: ["7L28", "6L28", "5L36", "4M"],
			bubblebeam: ["7L18", "7V", "6L18", "5L28", "4L28", "3L28"],
			camouflage: ["7L22", "6L15", "5L19", "4L19", "3L19"],
			confide: ["7M", "6M"],
			confuseray: ["7L40", "6L40"],
			cosmicpower: ["7L49", "6L48", "5L55", "4L51", "3L42", "3S0"],
			dazzlinggleam: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "7L24", "6M", "6L24", "5M", "5L37", "4M", "4L37"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L53", "7V", "6L52", "5L60", "4L55", "3L46", "3S0"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "5D", "4T", "3T"],
			lightscreen: ["7M", "7L46", "7V", "6M", "6L33", "5M", "5L42", "4M", "4L42", "3M", "3L37", "3S0"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["7V", "3T"],
			minimize: ["7L31", "7V", "6L25", "5L33", "4L33", "3L33", "3S0"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			powergem: ["7L37", "6L37", "5L51", "4L46"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L42", "7V", "6M", "6L42", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psywave: ["7L13", "7V", "6L13"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7L7", "6L7", "5L10", "4L10", "3L10", "3S1"],
			recover: ["7L10", "7V", "6L10", "5L15", "4L15", "3L15", "3S1"],
			recycle: ["6T", "5T", "5D", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			reflecttype: ["7L35", "6L35", "5L46"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L16", "7V", "6L16", "5L24", "4T", "4L24", "3T", "3L24"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			teleport: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			twister: ["4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L4", "7V", "6L4", "5L6", "5D", "4L6", "3L6", "3S1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	starmie: {
		inherit: true,
		learnset: {
			avalanche: ["4M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bubblebeam: ["7V"],
			confide: ["7M", "6M"],
			confuseray: ["7L40", "6L22", "5L28", "4L28", "3L33"],
			dazzlinggleam: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7V"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L1", "6L1"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M", "3S0"],
			icywind: ["6T", "5T", "4T", "3T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			recover: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spotlight: ["7L1"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L1", "7V", "6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			tackle: ["7V"],
			takedown: ["7V"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			watergun: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wonderroom: ["6T", "5T"],
		},
	},
	mimejr: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			barrier: ["7L1", "6L1", "5L1", "4L1"],
			batonpass: ["7L46", "6L46", "5L46", "4L46"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7E", "6E", "5E", "4E"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "4E"],
			confusion: ["7L1", "6L1", "5L1", "4L1"],
			copycat: ["7L4", "6L4", "5L4", "4L4"],
			covet: ["6T", "5T"],
			doubleslap: ["7L11", "6L11", "5L15", "4L15"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			encore: ["7L18", "6L18", "5L11", "4L11"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fakeout: ["7E", "6E", "5E", "4E"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			futuresight: ["7E", "6E", "5E", "4E"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healingwish: ["7E", "6E", "5E", "4E"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hypnosis: ["7E", "6E", "5E", "4E"],
			icywind: ["7E", "6T", "6E", "5T", "5E"],
			infestation: ["7M", "6M"],
			lightscreen: ["7M", "7L22", "6M", "6L22", "5M", "5L22", "4M", "4L22"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["7E", "6T", "6E", "5T", "5E"],
			meditate: ["7L8", "6L8", "5L8", "4L8"],
			mimic: ["7L15", "7E", "6L15", "6E", "5L18", "5E", "4L18", "4E"],
			mudslap: ["4T"],
			nastyplot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			powersplit: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M", "4M"],
			psybeam: ["7L25", "6L25", "5L25", "4L25"],
			psychic: ["7M", "7L39", "6M", "6L39", "5M", "5L39", "4M", "4L39"],
			psychup: ["7M", "6M", "5M", "4M", "4E"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["7L32", "6T", "6L32", "5T", "5L32", "4M", "4L32"],
			reflect: ["7M", "7L22", "6M", "6L22", "5M", "5L22", "4M", "4L22"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roleplay: ["7L43", "6T", "6L43", "5T", "5L43", "4T", "4L43"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L50", "6M", "6L50", "5M", "5L50", "4M", "4L50"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			substitute: ["7M", "7L29", "6M", "6L29", "5M", "5L29", "4M", "4L29"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "6M", "5M", "4M"],
			teeterdance: ["7E", "6E", "5E", "4E"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			tickle: ["7L1", "6L1", "5L1", "4L1"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["7L36", "7E", "6T", "6L36", "6E", "5T", "5L36", "5E", "4T", "4L36", "4E"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			wakeupslap: ["7E", "6E", "5E", "4E"],
			wonderroom: ["6T", "5T"],
		},
	},
	mrmime: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			batonpass: ["7L46", "6L46", "5L46", "4L46", "3L47"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "4E"],
			confusion: ["7L1", "7V", "6L1", "5L1", "4L1", "3L5"],
			copycat: ["7L4", "6L4", "5L4", "4L4"],
			counter: ["7V", "3T"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doubleslap: ["7L11", "7V", "6L11", "5L15", "4L15", "3L15"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			encore: ["7L18", "6L18", "5L11", "4L11", "3L25", "3S0"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "4E", "3E"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			followme: ["3S0"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E", "6E", "5E", "4E", "3E"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			guardswap: ["7L1", "6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypnosis: ["7E", "6E", "5E", "4E", "3E"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["7E", "6T", "6E", "5T", "5E"],
			infestation: ["7M", "6M"],
			irondefense: ["6T", "5T", "4T"],
			lightscreen: ["7M", "7L22", "7V", "6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L19"],
			magicalleaf: ["7L1", "6L1", "5L1", "4L1", "3L22"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["7E", "6T", "6E", "5T", "5E"],
			meditate: ["7L8", "7V", "6L8", "5L8", "4L8", "3L12"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7L15", "7E", "7V", "6L15", "6E", "5L18", "5E", "4L18", "4E", "3T", "3E"],
			mistyterrain: ["7L1", "6L1"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["7M", "6M", "5M", "4M"],
			powersplit: ["7E", "6E", "5E"],
			powerswap: ["7L1", "6L1", "5L1", "4L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L25", "6L25", "5L25", "4L25", "3L29"],
			psychic: ["7M", "7L39", "7V", "6M", "6L39", "5M", "5L39", "4M", "4L39", "3M", "3L43", "3S0"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7L15", "7V", "6L15", "5L15"],
			quickguard: ["7L1", "6L1", "5L1"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["7L32", "6T", "6L32", "5T", "5L32", "4M", "4L32", "3L33"],
			reflect: ["7M", "7L22", "7V", "6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L19"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["7L43", "6T", "6L43", "5T", "5L43", "4T", "4L43", "3L40"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L50", "6M", "6L50", "5M", "5L50", "4M", "4L50", "3M", "3L50"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "5D", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7L29", "7V", "6M", "6L29", "5M", "5L29", "4M", "4L29", "3T", "3L8"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			teeterdance: ["7E", "6E", "5E", "5D", "4E"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T", "3S0"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			trick: ["7L36", "7E", "6T", "6L36", "6E", "5T", "5L36", "5E", "4T", "4L36", "4E", "3L36", "3E"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wakeupslap: ["7E", "6E", "5E", "4E"],
			wideguard: ["7L1", "6L1", "5L1"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	scyther: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L17", "7V", "6L17", "5L17", "5S2", "4L17", "3L21"],
			airslash: ["7L50", "6L50", "5L53", "4L53"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7E", "6E", "5E", "5D", "4E", "3E"],
			bide: ["7V"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brutalswing: ["7M"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7E", "6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			defog: ["7E", "6E", "5E", "4M"],
			doubleedge: ["7V", "3T"],
			doublehit: ["7L49", "6L49", "5L49", "4L49"],
			doubleteam: ["7M", "7L37", "7V", "6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L41"],
			endure: ["7E", "6E", "5E", "4M", "4E", "3T", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "4M", "4L13", "3L16"],
			feint: ["7L61", "6L61", "5L61", "4L61"],
			focusenergy: ["7L5", "7V", "6L5", "5L5", "4L5", "3L6", "3S0"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L25", "6L25", "5L25", "5S2", "4T", "4L25", "3T", "3L46"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0"],
			lightscreen: ["7M", "6M", "5M", "4E", "3E"],
			mimic: ["7V", "3T"],
			morningsun: ["3S1"],
			naturalgift: ["4M"],
			nightslash: ["7L45", "7E", "6L45", "6E", "5L45", "5E", "4L45", "4E"],
			ominouswind: ["4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L9", "6L9", "5L9", "4L9", "3L11"],
			quickattack: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			quickguard: ["7E", "6E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7L33", "7E", "6L33", "6E", "5L33", "5E", "4L33", "4E", "3E", "3S1"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7E", "6E", "5E", "4E", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			silverwind: ["7E", "6E", "5E", "4M", "4E", "3E", "3S1"],
			skullbash: ["7V"],
			slash: ["7L29", "7V", "6L29", "5L29", "5S2", "4L29", "3L31", "3S1"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			swordsdance: ["7M", "7L57", "7V", "6M", "6L57", "5M", "5L57", "4M", "4L57", "3T", "3L36"],
			tailwind: ["6T", "5T", "5D", "4T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uturn: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["7L1", "6L1", "5L1", "4L1"],
			wingattack: ["7L21", "7V", "6L21", "5L21", "5S2", "4L21", "3L26"],
			xscissor: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L41"],
		},
	},
	scizor: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "6S5", "5M", "4M", "3M"],
			agility: ["7L17", "6L17", "6S5", "6S6", "5L17", "4L17", "4S1", "3L21"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brutalswing: ["7M"],
			bugbite: ["6T", "5T", "5S2", "4T"],
			bulletpunch: ["7L1", "6L1", "6S7", "5L1", "5S2", "4L1"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doublehit: ["7L49", "6L49", "6S4", "5L49", "4L49"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M", "3L41"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "7L13", "6M", "6L13", "6S5", "6S6", "5M", "5L13", "4M", "4L13", "3L16"],
			feint: ["7L61", "7L1", "6L1", "5L61", "4L61"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L5", "6L5", "5L5", "5S3", "4L5", "3L6"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L25", "6L25", "6S5", "6S6", "5L25", "4T", "4L25", "3T", "3L46", "3S0"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			irondefense: ["7L37", "6T", "6L37", "5T", "5L37", "4T", "4L37", "4S1", "3L41"],
			ironhead: ["7L50", "6T", "6L50", "6S4", "5T", "5L53", "4T", "4L53"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L1", "6L1", "5L1", "5S3", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M"],
			metalclaw: ["7L21", "6L21", "6S6", "5L21", "4L21", "3L26", "3S0"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["7L45", "6L45", "6S4", "5L45", "4L45"],
			ominouswind: ["4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L9", "6L9", "5L9", "5S3", "4L9", "3L11"],
			quickattack: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7L33", "6L33", "5L33", "4L33"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "6S7", "5T", "5S2", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			silverwind: ["4M"],
			slash: ["7L29", "6L29", "5L29", "4L29", "3L31", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "5S3", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "7L57", "6M", "6L57", "6S7", "5M", "5L57", "5S2", "4M", "4L57", "4S1", "3T", "3L36", "3S0"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uturn: ["7M", "6M", "6S7", "5M", "4M"],
			venoshock: ["7M", "6M", "5M"],
			xscissor: ["7M", "7L41", "6M", "6L41", "6S4", "5M", "5L41", "4M", "4L41", "4S1"],
		},
	},
	smoochum: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			auroraveil: ["7M"],
			avalanche: ["7L35", "6L35", "5L35", "4M", "4L31"],
			blizzard: ["7M", "7L48", "6M", "6L48", "5M", "5L48", "4M", "4L45", "3M", "3L57"],
			bodyslam: ["3T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["7E", "6E", "5E", "5D", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L15", "6L15", "5L15", "4L15", "3L21"],
			copycat: ["7L41", "6L41", "5L41", "4L38"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "4E", "3E"],
			faketears: ["7L28", "6L28", "5L28", "4L25", "3L37"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			healbell: ["6T", "5T", "4T"],
			heartstamp: ["7L21", "6L21", "5L21"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			icywind: ["6T", "5T", "4T", "3T"],
			lick: ["7L5", "6L5", "5L5", "4L5", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7L31", "6L31", "5L31", "4L28"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			meanlook: ["7L25", "6L25", "5L25", "4L21", "3L33"],
			meditate: ["7E", "6E", "5E", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["7M", "6M", "5M", "4M"],
			perishsong: ["7L45", "6L45", "5L45", "4L41", "3L49"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			powdersnow: ["7L11", "6L11", "5L11", "4L11", "3L13"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L38", "6M", "6L38", "5M", "5L38", "4M", "4L35", "3M", "3L45"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sing: ["7L18", "6L18", "5L18", "4L18", "3L25"],
			skillswap: ["6T", "5T", "5D", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["7L8", "6L8", "5L8", "5D", "4L8", "3L9"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			wakeupslap: ["7E", "6E", "5E"],
			waterpulse: ["6T", "4M", "3M"],
			wish: ["7E", "6E", "5E", "4E", "3E"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	jynx: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			auroraveil: ["7M"],
			avalanche: ["7L39", "6L39", "5L39", "4M", "4L33"],
			bide: ["7V"],
			blizzard: ["7M", "7L60", "7V", "6M", "6L60", "5M", "5L60", "4M", "4L55", "3M", "3L67"],
			bodyslam: ["7L44", "7V", "6L44", "5L44", "4L39", "3T", "3L51"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7V"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["7E", "4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			covet: ["6T", "5T"],
			doubleedge: ["7V", "3T"],
			doubleslap: ["7L15", "7V", "6L15", "5L15", "4L15", "3L21"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainingkiss: ["7L1", "6L1"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E"],
			faketears: ["7L28", "6L28", "5L28", "4L25", "3L41"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			heartstamp: ["7L21", "6L21", "5L21"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["7L18", "7E", "7V", "6T", "6L18", "5T", "5L18", "4T", "4L18", "3T", "3L25"],
			icywind: ["6T", "5T", "4T", "3T"],
			lick: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			lovelykiss: ["7L8", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			meanlook: ["7L25", "6L25", "5L25", "4L21", "3L35"],
			meditate: ["7E"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			miracleeye: ["7E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["7M", "6M", "5M", "4M"],
			perishsong: ["7L55", "7L1", "6L1", "5L55", "4L49", "3L57"],
			pound: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			powdersnow: ["7L11", "7L1", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7V"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wakeupslap: ["7L33", "7E", "6L33", "5L33", "4L28"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			wish: ["7E"],
			wringout: ["7L49", "6L49", "5L49", "4L44"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	elekid: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			crosschop: ["7E", "6E", "5E", "5D", "4E", "3E", "3S0"],
			discharge: ["7L33", "6L33", "5L41", "4L34"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dualchop: ["6T", "5T"],
			dynamicpunch: ["7E", "6E", "5E", "4E", "3T"],
			electroball: ["7L22", "6L22", "5L31"],
			electroweb: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7E", "6E", "5E", "4E"],
			firepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["7E", "6T", "6E", "5E", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hammerarm: ["7E", "6E", "5E"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E", "3S0"],
			karatechop: ["7E", "6E", "5E", "4E", "3E"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "7L26", "6M", "6L26", "5M", "5L26", "4M", "4L25", "3M", "3L17"],
			lowkick: ["7L8", "6T", "6L8", "5T", "5L11", "4T", "4L10"],
			magnetrise: ["6T", "5T", "5D", "4T"],
			meditate: ["7E", "6E", "5E", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollingkick: ["7E", "6E", "5E", "4E", "3E"],
			round: ["7M", "6M", "5M"],
			screech: ["7L36", "6L36", "5L51", "4L43", "3L33"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["7L15", "6T", "6L15", "5L21", "4M", "4L19", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L12", "6L12", "5L16", "4T", "4L16", "3T", "3L25"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7L43", "6M", "6L43", "5M", "5L56", "4M", "4L46", "3M", "3L49"],
			thunderbolt: ["7M", "7L40", "6M", "6L40", "5M", "5L46", "4M", "4L37", "3M", "3L41"],
			thunderpunch: ["7L29", "6T", "6L29", "5T", "5L36", "4T", "4L28", "3T", "3L9", "3S0"],
			thundershock: ["7L5", "6L5", "5L6", "5D", "4L7"],
			thunderwave: ["7M", "7L19", "6M", "6L19", "5M", "5L19", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	electabuzz: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7E"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			covet: ["6T", "5T"],
			crosschop: ["7E", "3S1"],
			discharge: ["7L36", "6L36", "5L44", "4L37"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dualchop: ["6T", "5T"],
			dynamicpunch: ["7E", "3T"],
			electroball: ["7L22", "6L22", "5L32"],
			electroweb: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7E"],
			firepunch: ["7E", "6T", "5T", "4T", "3T"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["7E", "6T", "4M", "3M"],
			followme: ["3S1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hammerarm: ["7E"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["7E", "6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			karatechop: ["7E"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0"],
			lightscreen: ["7M", "7L26", "7V", "6M", "6L26", "6S4", "5M", "5L26", "5S3", "4M", "4L25", "4S2", "3M", "3L17"],
			lowkick: ["7L8", "6T", "6L8", "6S4", "5T", "5L11", "5S3", "4T", "4L10", "4S2"],
			lowsweep: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T", "4T"],
			meditate: ["7E"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psywave: ["7V"],
			quickattack: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollingkick: ["7E"],
			round: ["7M", "6M", "5M"],
			screech: ["7L42", "7V", "6L42", "5L56", "4L52", "3L36"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shockwave: ["7L15", "6T", "6L15", "6S4", "5L21", "5S3", "4M", "4L19", "4S2", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L12", "7V", "6L12", "5L16", "5S3", "4T", "4L16", "3T", "3L25"],
			takedown: ["7V"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7L55", "7V", "6M", "6L55", "5M", "5L62", "4M", "4L58", "3M", "3L58"],
			thunderbolt: ["7M", "7L49", "7V", "6M", "6L49", "5M", "5L50", "4M", "4L43", "3M", "3L47", "3S1"],
			thunderpunch: ["7L29", "7V", "6T", "6L29", "6S4", "5T", "5L38", "4T", "4L28", "4S2", "3T", "3L1", "3S0"],
			thundershock: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1"],
			thunderwave: ["7M", "7L19", "7V", "6M", "6L19", "5M", "5L19", "4M", "3T", "3S1"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	electivire: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			crosschop: ["4S0"],
			dig: ["6M", "5M", "4M"],
			discharge: ["7L36", "6L36", "5L44", "4L37", "4S1"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dualchop: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M", "4M", "4S0"],
			electricterrain: ["7L65", "7L1", "6L1"],
			electroball: ["7L22", "6L22", "5L32"],
			electroweb: ["6T", "5T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			firepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "7L62", "6M", "6L62", "5M", "5L68", "4M", "4L67"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T", "4S0"],
			iondeluge: ["7L1", "6L1"],
			irontail: ["6T", "5T", "4M"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			lightscreen: ["7M", "7L26", "6M", "6L26", "5M", "5L26", "4M", "4L25", "4S1"],
			lowkick: ["7L8", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			lowsweep: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			quickattack: ["7L1", "6L1", "5L1", "4L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			screech: ["7L42", "6L42", "5L56", "4L52"],
			secretpower: ["6M", "4M"],
			shockwave: ["7L15", "6T", "6L15", "5L21", "4M", "4L19"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["7L12", "6L12", "5L16", "4T", "4L16"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "7L55", "6M", "6L55", "5M", "5L62", "4M", "4L58"],
			thunderbolt: ["7M", "7L49", "6M", "6L49", "5M", "5L50", "4M", "4L43", "4S1"],
			thunderpunch: ["7L29", "6T", "6L29", "5T", "5L38", "4T", "4L28", "4S0", "4S1"],
			thundershock: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			thunderwave: ["7M", "7L19", "6M", "6L19", "5M", "5L19", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	magby: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7E", "6E", "5E", "4E", "3E"],
			belch: ["7E", "6E"],
			bellydrum: ["7E", "6E", "5E", "4E"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["7L19", "6L19", "5L19"],
			confide: ["7M", "6M"],
			confuseray: ["7L26", "6L26", "5L25", "4L25", "3L43"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			crosschop: ["7E", "6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dualchop: ["6T", "5T"],
			dynamicpunch: ["7E", "6E", "5E", "4E", "3T"],
			ember: ["7L5", "6L5", "5L7", "5D", "4L7", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L12", "6L12", "5L16", "4L16"],
			fireblast: ["7M", "7L43", "6M", "6L43", "5M", "5L49", "4M", "4L46", "3M", "3L49"],
			firepunch: ["7L29", "6T", "6L29", "5T", "5L34", "4T", "4L28", "3T", "3L19"],
			firespin: ["7L15", "6L15", "5L19", "4L19"],
			flameburst: ["7L22", "6L22", "5L28"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L40", "6M", "6L40", "5M", "5L43", "4M", "4L37", "3M", "3L37"],
			flareblitz: ["7E", "6E", "5E", "4E"],
			fling: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7E", "6E", "5E"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "5D", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			karatechop: ["7E", "6E", "5E", "4E", "3E"],
			lavaplume: ["7L33", "6L33", "5L37", "4L34"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L7"],
			machpunch: ["7E", "6E", "5E", "4E"],
			megakick: ["3T"],
			megapunch: ["7E", "6E", "5E", "4E", "3T", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M"],
			powerswap: ["7E", "6E"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smog: ["7L1", "6L1", "5L1", "4L1", "3L13"],
			smokescreen: ["7L8", "6L8", "5L10", "4L10", "3L25"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "7L36", "6M", "6L36", "5M", "5L46", "4M", "4L43", "3M", "3L31"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3T", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	magmar: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7E"],
			belch: ["7E"],
			bellydrum: ["7E"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["7L19", "6L19", "5L19"],
			confide: ["7M", "6M"],
			confuseray: ["7L26", "7V", "6L26", "6S4", "5L26", "5S3", "4L25", "4S2", "3L49"],
			counter: ["7V", "3T"],
			covet: ["6T", "5T"],
			crosschop: ["7E", "3S1"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dualchop: ["6T", "5T"],
			dynamicpunch: ["7E", "3T"],
			ember: ["7L5", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L12", "6L12", "5L16", "5S3", "4L16"],
			fireblast: ["7M", "7L55", "7V", "6M", "6L55", "5M", "5L62", "4M", "4L54", "3M", "3L57", "3S1"],
			firepunch: ["7L29", "7V", "6T", "6L29", "6S4", "5T", "5L38", "4T", "4L28", "4S2", "3T", "3L1", "3S0"],
			firespin: ["7L15", "6L15", "6S4", "5L21", "5S3", "4L19", "4S2"],
			flameburst: ["7L22", "6L22", "5L32"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L49", "7V", "6M", "6L49", "5M", "5L50", "4M", "4L41", "3M", "3L41"],
			flareblitz: ["7E"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7E"],
			focuspunch: ["6T", "4M", "3M"],
			followme: ["3S1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irontail: ["7E", "6T", "5T", "4M", "3M"],
			karatechop: ["7E"],
			lavaplume: ["7L36", "6L36", "5L44", "4L36"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			machpunch: ["7E"],
			megakick: ["7V", "3T"],
			megapunch: ["7E", "7V", "3T"],
			metronome: ["7V"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M"],
			powerswap: ["7E"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psywave: ["7V"],
			rage: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			screech: ["7E"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smog: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S0"],
			smokescreen: ["7L8", "7V", "6L8", "6S4", "5L11", "5S3", "4L10", "4S2", "3L25"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "7L42", "6M", "6L42", "5M", "5L56", "4M", "4L49", "3M", "3L33"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["7E", "6T", "5T", "4T", "3T", "3S1"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	magmortar: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			clearsmog: ["7L19", "6L19", "5L19"],
			confide: ["7M", "6M"],
			confuseray: ["7L26", "6L26", "5L26", "4L25", "4S1"],
			covet: ["6T", "5T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dualchop: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			ember: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			feintattack: ["7L12", "6L12", "5L16", "4L16"],
			fireblast: ["7M", "7L55", "6M", "6L55", "5M", "5L62", "4M", "4L58"],
			firepunch: ["7L29", "6T", "6L29", "5T", "5L38", "4T", "4L28", "4S1"],
			firespin: ["7L15", "6L15", "5L21", "4L19"],
			flameburst: ["7L22", "6L22", "5L32"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L49", "6M", "6L49", "5M", "5L50", "4M", "4L43", "4S0", "4S1"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "7L62", "6M", "6L62", "5M", "5L68", "4M", "4L67", "4S0"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M"],
			lavaplume: ["7L36", "6L36", "5L44", "4L37", "4S1"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M", "4S0"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			smog: ["7L1", "6L1", "5L1", "4L1"],
			smokescreen: ["7L8", "7L1", "6L1", "5L1", "4L1"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M", "4S0"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "7L42", "6M", "6L42", "5M", "5L56", "4M", "4L52"],
			swagger: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	pinsir: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["7L4", "7V", "6T", "6L4", "5T", "5L4", "4L4", "3L7"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "7L26", "6M", "6L18", "5M", "5L21", "4M", "4L21", "3M", "3L31"],
			brutalswing: ["7M"],
			bugbite: ["7E", "6T", "6E", "5T", "5E"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			closecombat: ["7E", "6E", "5E", "5D", "4E"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doublehit: ["7L22", "6L22"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "6S1", "6S2", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M", "4E", "3E", "3S0"],
			feint: ["7E", "6E", "6S2", "5E", "4E"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7E", "6E", "5E", "4E", "3E"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			guillotine: ["7L50", "7V", "6L47", "5L47", "4L47", "3L37", "3S0"],
			harden: ["7L11", "7V", "6L11", "5L13", "4L13", "3L19"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			mefirst: ["7E", "6E", "5E", "5D"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7E", "6E", "6S2", "5E", "4E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "6S1", "5M", "4M", "3M"],
			revenge: ["7L15", "6L15", "5L18", "4L18", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7L8", "7V", "6L8", "5L8", "4L8", "3T", "3L13"],
			slash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "6S1", "5M", "4M"],
			stormthrow: ["7L36", "6L33", "5L33"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			submission: ["7L33", "7V", "6L26", "5L42", "4L42", "3L43", "3S0"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["7L47", "7E", "6T", "6L43", "6E", "5T", "5L52", "5E", "4T", "4L52"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7L40", "7V", "6M", "6L40", "6S2", "5M", "5L38", "4M", "4L38", "3T", "3L49"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L43", "6L36", "5L35", "4L35"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			visegrip: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L1"],
			vitalthrow: ["7L18", "6L18", "5L25", "4L25"],
			xscissor: ["7M", "7L29", "6M", "6L29", "6S1", "5M", "5L30", "4M", "4L30"],
		},
	},
	tauros: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T", "3S2"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M", "3S2"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			fissure: ["7V"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "7L63", "6M", "6L63", "5M", "5L63", "4M", "4L55"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hornattack: ["7L8", "6L8", "5L8", "4L8", "3L8", "3S0", "3S1"],
			horndrill: ["7V"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "5D", "4M", "3M"],
			leer: ["7V"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			payback: ["7M", "7L24", "6M", "6L24", "5M", "5L24", "4M", "4L24"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L15", "6L15", "5L15", "4L15", "3L19", "3S0"],
			rage: ["7L5", "7V", "6L5", "5L5", "5D", "4L5", "3L4", "3S0", "3S1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S2"],
			rest: ["7M", "7L19", "7V", "6M", "6L19", "5M", "5L19", "4M", "4L19", "3M", "3L34"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["5D", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scaryface: ["7L11", "6L11", "5L11", "4L11", "3L13", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["6T", "5T", "4T"],
			stomp: ["7V"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L48", "6M", "6L48", "5M", "5L48", "4M", "4L41", "3T", "3L26"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1", "3S1"],
			tailwhip: ["7L3", "7V", "6L3", "5L3", "4L3", "3L1", "3S1", "3S2"],
			takedown: ["7L41", "7V", "6L41", "5L41", "4L35", "3L53"],
			thrash: ["7L50", "6L50", "5L55", "4L48", "3L43"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "7L29", "6L29", "5M", "5L29"],
			zenheadbutt: ["7L35", "6T", "6L35", "5T", "5L35", "4T", "4L29"],
		},
	},
	magikarp: {
		inherit: true,
		learnset: {
			bounce: ["7S7", "6T", "5T", "5S5", "5D", "4T"],
			celebrate: ["6S6"],
			flail: ["7L30", "6L30", "5L30", "5S5", "4L30", "3L30"],
			happyhour: ["6S6"],
			hydropump: ["5S5"],
			splash: ["7L1", "7S7", "7V", "6L1", "6S6", "5L1", "5S5", "5D", "4L1", "4S0", "4S1", "4S2", "4S3", "4S4", "3L1"],
			tackle: ["7L15", "7V", "6L15", "5L15", "4L15", "3L15"],
		},
	},
	gyarados: {
		inherit: true,
		learnset: {
			aquatail: ["7L30", "6T", "6L35", "5T", "5L35", "4T", "4L35"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bide: ["7V"],
			bite: ["7L1", "7V", "6L20", "6S1", "5L20", "4L20", "3L20"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			bounce: ["6T", "5T", "4T"],
			brine: ["4M"],
			brutalswing: ["7M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L39", "6L41"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragondance: ["7L45", "6L44", "6S0", "5L44", "4L44", "3L50"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrage: ["7L36", "7V", "6L23", "5L23", "4L23", "3L25"],
			dragontail: ["7M", "6M", "5M"],
			earthquake: ["7M", "6M", "6S0", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7L48"],
			hydropump: ["7L42", "7V", "6L41", "5L41", "4L41", "3L40"],
			hyperbeam: ["7M", "7L54", "7V", "6M", "6L47", "5M", "5L47", "4M", "4L47", "3M", "3L55"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icefang: ["7L27", "6L32", "6S0", "6S1", "5L32", "4L32"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "6S1", "5T", "4T"],
			irontail: ["6T", "5T"],
			leer: ["7L21", "7V", "6L26", "5L26", "4L26", "3L30"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "7L51", "6M", "6L38", "5M", "5L38", "4M", "4L38", "3M", "3L45"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			scaryface: ["7L33"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7V"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["7L24", "6L29", "5L29", "4T", "4L29", "3L35"],
			uproar: ["6T", "5T", "4T"],
			waterfall: ["7M", "6M", "6S0", "6S1", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	lapras: {
		inherit: true,
		learnset: {
			ancientpower: ["7E", "6E", "5E", "4T", "4E"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["7E", "6E", "5E", "4M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M", "3S0"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7L18", "7V", "6L18", "5L18", "4L18", "3T", "3L13"],
			brine: ["7L37", "6L37", "5L37", "4M", "4L37"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L7", "7V", "6L7", "5L7", "5D", "4L7", "3L19"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragondance: ["7E", "6E", "5E", "4E", "3E"],
			dragonpulse: ["7E", "6T", "6E", "5T", "5E", "4M"],
			dragonrage: ["7V"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			drillrun: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7E", "6E", "5E", "4E"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			freezedry: ["7E", "6E"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E", "6E", "5E"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T", "3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			horndrill: ["7E", "7V", "6E", "5E", "5D", "4E", "3E"],
			hydropump: ["7L47", "7V", "6L47", "5L49", "4L49", "3L49", "3S0"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "7L32", "7V", "6M", "6L32", "5M", "5L32", "4M", "4L32", "3M", "3L31"],
			iceshard: ["7L10", "6L10", "5L10", "4L10"],
			icywind: ["6T", "5T", "5D", "4T", "3T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["7V", "3T"],
			mist: ["7L4", "7V", "6L4", "5L4", "4L4", "3L7"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			outrage: ["6T", "5T", "4T"],
			perishsong: ["7L27", "6L27", "5L27", "4L27", "3L25"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "7L22", "6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L37", "3S0"],
			reflect: ["7V"],
			refresh: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L43", "6M", "6L43", "5M", "5L43", "4M", "4L43", "3M", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["7L50", "6L50", "5L55", "4L55", "3L55"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sing: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7V"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			tickle: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["7L14", "6T", "6L14", "5L14", "4M", "4L14", "3M"],
			whirlpool: ["7E", "6E", "5E", "4M", "4E"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	ditto: {
		inherit: true,
		learnset: {
			transform: ["7L1", "7V", "7S0", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	eevee: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "5S2", "4M", "4S0", "3M"],
			babydolleyes: ["7L9", "7S5", "6L9", "6S3", "6S4"],
			batonpass: ["7L33", "6L33", "5L36", "4L36", "3L36"],
			bide: ["7V"],
			bite: ["7L17", "7V", "6L17", "5L29", "4L29", "4S0", "3L30"],
			bodyslam: ["7V", "3T"],
			captivate: ["7E", "6E", "4M"],
			celebrate: ["7S5", "6S3"],
			charm: ["7L29", "7E", "6L29", "6E", "5L29", "5E", "5D", "4E", "3E"],
			confide: ["7M", "6M"],
			covet: ["7L1", "7E", "6T", "6L23", "6E", "5T", "5L21", "5E", "4E", "4S0"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			detect: ["7E", "6E", "5E", "4E"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L37", "7V", "6L37", "5L37", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M", "5S2"],
			endure: ["7E", "6E", "5E", "4M", "4E", "3T", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6E", "5E", "4E"],
			flail: ["7E", "6E", "5E", "4E", "4S1", "3E"],
			focusenergy: ["7V"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "7V", "6L1", "5L15", "4L15", "3L16"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["7L1", "6T", "6L1", "6S4", "5T", "5L1", "4T", "4L1", "4S0", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			irontail: ["6T", "5T", "4M", "4S1", "3M"],
			lastresort: ["7L41", "6T", "6L41", "5T", "5L50", "4T", "4L50"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L13", "7V", "6L13", "6S4", "5L22", "4L22", "4S1", "3L23"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			refresh: ["7L20", "6L20"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "5S2", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "7S5", "7V", "6L5", "6S3", "5L8", "5D", "4L8", "3L8"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sing: ["5S2"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			storedpower: ["7E", "6E", "5E"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L17", "7V", "6L10", "6S3", "6S4", "5D", "4T", "3T"],
			synchronoise: ["7E", "6E", "5E"],
			tackle: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L25", "7V", "6L25", "5L43", "4L43", "3L42"],
			tickle: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			trumpcard: ["7L45", "6L45", "5L57", "4L57", "4S1"],
			wish: ["7E", "6E", "5E", "4E", "3E"],
			workup: ["7M", "5M"],
			yawn: ["7E", "6E", "5E", "4E"],
		},
	},
	vaporeon: {
		inherit: true,
		learnset: {
			acidarmor: ["7L29", "7V", "6L29", "5L64", "4L64", "3L47"],
			aquaring: ["7L25", "6L25", "5L43", "4L43"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7L20", "7V", "6L20", "5L36", "4L36", "3L36"],
			babydolleyes: ["7L9"],
			bide: ["7V"],
			bite: ["7V", "5L29", "4L29", "3L30"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brine: ["4M"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			celebrate: ["6S1"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7L33", "7V", "6L33", "5L57", "4L57", "3L42"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L1", "5S0", "4T", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L45", "7V", "6L45", "5L71", "4L71", "3L52"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "7V", "7S2", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["7L41", "6T", "6L41", "5T", "5L50", "4T", "4L50"],
			mimic: ["7V", "3T"],
			mist: ["7V"],
			muddywater: ["7L37", "6L37", "5L78", "4L78"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L13", "7V", "6L13", "5L22", "4L22", "3L23"],
			rage: ["7V"],
			raindance: ["7M", "7S2", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "7S2", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "7V", "6L5", "6S1", "5L8", "5S0", "4L8", "3L8"],
			scald: ["7M", "7S2", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "5S0", "4L1", "3L1"],
			tailwhip: ["7L1", "7V", "6L1", "6S1", "5L1", "5S0", "4L1", "3L1"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "7V", "6L9", "6S1", "5L15", "4L15", "3L16"],
			waterpulse: ["7L17", "6T", "6L17", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
		},
	},
	jolteon: {
		inherit: true,
		learnset: {
			agility: ["7L29", "7V", "6L29", "5L64", "4L64", "3L47"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			babydolleyes: ["7L9"],
			bide: ["7V"],
			bodyslam: ["7V", "3T"],
			captivate: ["4M"],
			celebrate: ["6S1"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dig: ["6M", "5M", "4M", "3M"],
			discharge: ["7L37", "6L37", "5L78", "4L78"],
			doubleedge: ["7V", "3T"],
			doublekick: ["7L17", "7V", "6L17", "5L29", "4L29", "3L30"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L1", "5S0", "4T", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["7L41", "6T", "6L41", "5T", "5L50", "4T", "4L50"],
			lightscreen: ["7M", "7S2", "6M", "5M", "4M"],
			magnetrise: ["6T", "5T", "4T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pinmissile: ["7L25", "7V", "6L25", "5L36", "4L36", "3L36"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L13", "7V", "6L13", "5L22", "4L22", "3L23"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "7V", "6L5", "6S1", "5L8", "5S0", "4L8", "3L8"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "7S2", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "5S0", "4L1", "3L1"],
			tailwhip: ["7L1", "7V", "6L1", "6S1", "5L1", "5S0", "4L1", "3L1"],
			takedown: ["7V"],
			thunder: ["7M", "7L45", "7V", "6M", "6L45", "5M", "5L71", "4M", "4L71", "3M", "3L52"],
			thunderbolt: ["7M", "7V", "7S2", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L20", "6L20", "5L43", "4L43"],
			thundershock: ["7L1", "7V", "6L9", "6S1", "5L15", "4L15", "3L16"],
			thunderwave: ["7M", "7L33", "7V", "6M", "6L33", "5M", "5L57", "4M", "4L57", "3T", "3L42"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "7S2", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
		},
	},
	flareon: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			babydolleyes: ["7L9"],
			bide: ["7V"],
			bite: ["7L17", "7V", "6L17", "5L29", "4L29", "3L30"],
			bodyslam: ["7V", "3T"],
			captivate: ["4M"],
			celebrate: ["6S1"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L1", "7V", "6L9", "6S1", "5L15", "4L15", "3L16"],
			endure: ["4M", "3T"],
			facade: ["7M", "7S2", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "5L71", "4M", "4L71", "3M"],
			firefang: ["7L20", "6L20", "5L43", "4L43"],
			firespin: ["7L25", "7V", "6L25", "5L36", "4L36", "3L36"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7V", "6M", "5M", "4M", "3M", "3L52"],
			flareblitz: ["7L45", "7S2", "6L45"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L1", "5S0", "4T", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["7L41", "6T", "6L41", "5T", "5L50", "4T", "4L50"],
			lavaplume: ["7L37", "6L37", "5L78", "4L78"],
			leer: ["7V", "3L47"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L13", "7V", "7S2", "6L13", "5L22", "4L22", "3L23"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "7V", "6L5", "6S1", "5L8", "5S0", "4L8", "3L8"],
			scaryface: ["7L29", "6L29", "5L64", "4L64"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smog: ["7L33", "7V", "6L33", "5L57", "4L57", "3L42"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "5S0", "4L1", "3L1"],
			tailwhip: ["7L1", "7V", "6L1", "6S1", "5L1", "5S0", "4L1", "3L1"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "7S2", "6M", "5M", "4M"],
			workup: ["7M", "5M"],
		},
	},
	espeon: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			babydolleyes: ["7L9"],
			bodyslam: ["3T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			celebrate: ["6S2"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L9", "6S2", "5L15", "4L15", "3L16"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["7M", "7S3", "6M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L25", "6L25", "5L43", "4L43"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L1", "5S1", "4T", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["7L41", "6T", "6L41", "5T", "5L50", "4T", "4L50"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mimic: ["3T"],
			morningsun: ["7L33", "6L33", "5L71", "4L71", "3L52", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powerswap: ["7L45", "6L45", "5L78", "4L78"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L20", "6L20", "5L36", "4L36", "3L36", "3S0"],
			psychic: ["7M", "7L37", "7S3", "6M", "6L37", "5M", "5L64", "4M", "4L64", "3M", "3L47", "3S0"],
			psychup: ["7M", "7L29", "6M", "6L29", "5M", "5L57", "4M", "4L57", "3T", "3L42", "3S0"],
			psyshock: ["7M", "6M", "5M"],
			quickattack: ["7L13", "6L13", "5L22", "4L22", "3L23"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "7S3", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "6L5", "6S2", "5L8", "5S1", "4L8", "3L8"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "7S3", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L17", "6L17", "5L29", "4T", "4L29", "3T", "3L30"],
			tackle: ["7L1", "6L1", "5L1", "5S1", "4L1", "3L1"],
			tailwhip: ["7L1", "6L1", "6S2", "5L1", "5S1", "4L1", "3L1"],
			telekinesis: ["5M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	umbreon: {
		inherit: true,
		learnset: {
			assurance: ["7L25", "6L25", "5L43", "4L43"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			babydolleyes: ["7L9"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			celebrate: ["6S2"],
			confide: ["7M", "6M"],
			confuseray: ["7L17", "6L17", "5L29", "4L29", "3L30"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L20", "6L20", "5L36", "4L36", "3L36", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			guardswap: ["7L45", "6L45", "5L78", "4L78"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L1", "5S1", "4T", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["7L41", "6T", "6L41", "5T", "5L50", "4T", "4L50"],
			meanlook: ["7L37", "6L37", "5L57", "4L57", "3L42", "3S0"],
			mimic: ["3T"],
			moonlight: ["7L33", "7S3", "6L33", "5L71", "4L71", "3L52", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "7S3", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			pursuit: ["7L1", "6L9", "6S2", "5L15", "4L15", "3L16"],
			quickattack: ["7L13", "6L13", "5L22", "4L22", "3L23"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "6L5", "6S2", "5L8", "5S1", "4L8", "3L8"],
			screech: ["7L29", "6L29", "5L64", "4L64", "3L47", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "7S3", "6M", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "5S1", "4L1", "3L1"],
			tailwhip: ["7L1", "6L1", "6S2", "5L1", "5S1", "4L1", "3L1"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7S3", "6M", "5M", "4M", "3M"],
			wonderroom: ["6T", "5T"],
			workup: ["7M", "5M"],
		},
	},
	leafeon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			attract: ["7M", "6M", "5M", "4M"],
			babydolleyes: ["7L9"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			celebrate: ["6S1"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigadrain: ["7L25", "6T", "6L25", "5T", "5L43", "4M", "4L43"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["7L17", "6L17", "5L57", "4L57"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L1", "5S0", "4T", "4L1"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["7L41", "6T", "6L41", "5T", "5L50", "4T", "4L50"],
			leafblade: ["7L45", "7S2", "6L45", "5L71", "4L71"],
			magicalleaf: ["7L20", "6L20", "5L36", "4L36"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			protect: ["7M", "6M", "5M", "4M"],
			quickattack: ["7L13", "6L13", "5L22", "4L22"],
			raindance: ["7M", "6M", "5M", "4M"],
			razorleaf: ["7L1", "6L9", "6S1", "5L15", "4L15"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "6L5", "6S1", "5L8", "5S0", "4L8"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "7L37", "7S2", "6M", "6L37", "5M", "5L64", "4M", "4L64"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "7L29", "7S2", "6M", "6L29", "5M", "5L78", "4M", "4L78"],
			synthesis: ["7L33", "7S2", "6T", "6L33", "5T", "5L29", "4T", "4L29"],
			tackle: ["7L1", "6L1", "5L1", "5S0", "4L1"],
			tailwhip: ["7L1", "6L1", "6S1", "5L1", "5S0", "4L1"],
			toxic: ["7M", "6M", "5M", "4M"],
			workup: ["7M", "5M"],
			worryseed: ["6T", "5T", "4T"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	glaceon: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M"],
			auroraveil: ["7M", "7S2"],
			avalanche: ["4M"],
			babydolleyes: ["7L9"],
			barrier: ["7L29", "6L29", "5L78", "4L78"],
			bite: ["7L17", "6L17", "5L29", "4L29"],
			blizzard: ["7M", "7L45", "7S2", "6M", "6L45", "5M", "5L71", "4M", "4L71"],
			captivate: ["4M"],
			celebrate: ["6S1"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "7L37", "7S2", "6M", "6L37", "5M", "5L64", "4M", "4L64"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L1", "5S0", "4T", "4L1"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icefang: ["7L20", "6L20", "5L43", "4L43"],
			iceshard: ["7L25", "6L25", "5L36", "4L36"],
			icywind: ["7L1", "6T", "6L9", "6S1", "5T", "5L15", "4T", "4L15"],
			irontail: ["6T", "5T", "4M"],
			lastresort: ["7L41", "6T", "6L41", "5T", "5L50", "4T", "4L50"],
			mirrorcoat: ["7L33", "6L33", "5L57", "4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			quickattack: ["7L13", "6L13", "5L22", "4L22"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "6L5", "6S1", "5L8", "5S0", "4L8"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "7S2", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "5S0", "4L1"],
			tailwhip: ["7L1", "6L1", "6S1", "5L1", "5S0", "4L1"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			workup: ["7M", "5M"],
		},
	},
	porygon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L12", "7V", "6L12", "5L12", "4L12", "3L9"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			conversion: ["7L1", "7V", "6L1", "5L1", "5S0", "4L1", "3L1"],
			conversion2: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			discharge: ["7L40", "6L40", "5L40", "4L40"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			electroweb: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			lockon: ["7L45", "6L45", "5L45", "4L45", "3L32"],
			magiccoat: ["7L56", "6T", "6L56", "5T", "5L56", "4T", "4L56"],
			magnetrise: ["7L23", "6T", "6L23", "5T", "5L23", "4L23"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L7", "7V", "6L7", "5L7", "5S0", "4L7", "3L12"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L18", "7V", "6L18", "5L18", "4L18", "3L20"],
			recycle: ["7L34", "6T", "6L34", "5T", "5L34", "4M", "4L34", "3L44"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sharpen: ["7L1", "7V", "6L1", "5L1", "5S0", "4L1", "3L24"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["7L29", "6T", "6L29", "5T", "5L29", "4T", "4L29"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tackle: ["7L1", "7V", "6L1", "5L1", "5S0", "4L1", "3L1"],
			takedown: ["7V"],
			teleport: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7L50", "7V", "6L50", "5L51", "4L51", "3L36"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			zapcannon: ["7L62", "6L62", "5L62", "4L62", "3L48"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	porygon2: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L12", "6L12", "5L12", "4L12", "3L9"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			conversion: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			conversion2: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			defensecurl: ["7L1", "6L1", "5L1", "4L1", "3T", "3L24"],
			discharge: ["7L40", "6L40", "5L40", "4L40"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			electroweb: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7L67", "6M", "6L67", "5M", "5L67", "4M", "4L67", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			lockon: ["7L45", "6L45", "5L45", "4L45", "3L32"],
			magiccoat: ["7L56", "7L1", "6T", "6L1", "5T", "5L56", "4T", "4L56"],
			magnetrise: ["7L23", "6T", "6L23", "5T", "5L23", "4L23"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L7", "6L7", "5L7", "4L7", "3L12"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L18", "6L18", "5L18", "4L18", "3L20"],
			recycle: ["7L34", "6T", "6L34", "5T", "5L34", "4M", "4L34", "3L44"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["7L29", "6T", "6L29", "5T", "5L29", "4T", "4L29"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			triattack: ["7L50", "6L50", "5L51", "4L51", "3L36"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			zapcannon: ["7L62", "7L1", "6L1", "5L62", "4L62", "3L48"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	porygonz: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			agility: ["7L12", "6L12", "5L12", "4L12"],
			blizzard: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			conversion: ["7L1", "6L1", "5L1", "4L1"],
			conversion2: ["7L1", "6L1", "5L1", "4L1"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			discharge: ["7L40", "6L40", "5L40", "4L40"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			electroweb: ["6T", "5T"],
			embargo: ["7M", "7L34", "6M", "6L34", "5M", "5L34", "4M", "4L34"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "7L67", "6M", "6L67", "5M", "5L67", "4M", "4L67"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			lastresort: ["6T", "5T", "4T"],
			lockon: ["7L45", "6L45", "5L45", "4L45"],
			magiccoat: ["7L56", "7L1", "6T", "6L1", "5T", "5L56", "4T", "4L56"],
			magnetrise: ["7L23", "6T", "6L23", "5T", "5L23", "4L23"],
			nastyplot: ["7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M"],
			psybeam: ["7L7", "6L7", "5L7", "4L7"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recover: ["7L18", "6L18", "5L18", "4L18"],
			recycle: ["6T", "5T", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["7L29", "6T", "6L29", "5T", "5L29", "4T", "4L29"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			triattack: ["7L50", "6L50", "5L51", "4L51"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			uproar: ["6T", "5T", "4T"],
			wonderroom: ["5T"],
			zapcannon: ["7L62", "7L1", "6L1", "5L62", "4L62"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	omanyte: {
		inherit: true,
		learnset: {
			ancientpower: ["7L37", "6L37", "5L37", "4T", "4L37", "3L49"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7E", "7V", "6E", "5E"],
			bind: ["6T", "5T"],
			bite: ["7L7", "6L7", "5L7", "5S0", "5D", "4L7", "3L13"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brine: ["7L28", "6L28", "5L28", "4M", "4L28"],
			bubblebeam: ["7E", "7V", "6E", "5E", "5S0", "4E", "3E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			constrict: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hornattack: ["7V"],
			hydropump: ["7L55", "7V", "6L55", "5L55", "4L52", "3L55"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "5D", "4T", "3T"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			leer: ["7L19", "7V", "6L19", "5L19", "4L19", "3L31"],
			mimic: ["7V", "3T"],
			muddywater: ["7E", "6E", "5E", "5D", "4E"],
			mudshot: ["7L25", "6L25", "5L25", "4L25", "3L25"],
			naturalgift: ["4M"],
			protect: ["7M", "7L34", "6M", "6L34", "5M", "5L34", "4M", "4L34", "3M", "3L37"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			reflecttype: ["7E", "6E"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L46", "6L46", "5L46", "4L46"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L16", "6L16", "5L16", "4T", "4L16", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shellsmash: ["7L50", "6L50", "5L52"],
			slam: ["7E", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spikecannon: ["7V"],
			spikes: ["7E", "6E", "5E", "4E", "3E"],
			stealthrock: ["6T", "5T", "4M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			supersonic: ["7E", "6E", "5E", "5S0", "4E", "3E"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			tickle: ["7L43", "6L43", "5L43", "4L43", "3L43"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7E", "6E", "5E", "4E"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L10", "7V", "6L10", "5L10", "4L10", "3L19"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			whirlpool: ["7E", "6E", "5E", "4M"],
			withdraw: ["7L1", "7V", "6L1", "5L1", "5S0", "4L1", "3L1"],
			wringout: ["7E", "6E", "5E", "4E"],
		},
	},
	omastar: {
		inherit: true,
		learnset: {
			ancientpower: ["7L37", "6L37", "5L37", "4T", "4L37", "3L55"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			bite: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brine: ["7L28", "6L28", "5L28", "4M", "4L28"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			constrict: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hornattack: ["7V"],
			horndrill: ["7V"],
			hydropump: ["7L75", "7L1", "7V", "6L1", "5L75", "4L67", "3L65"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L19", "7V", "6L19", "5L19", "4L19", "3L31"],
			mimic: ["7V", "3T"],
			mudshot: ["7L25", "6L25", "5L25", "4L25", "3L25"],
			naturalgift: ["4M"],
			protect: ["7M", "7L34", "6M", "6L34", "5M", "5L34", "4M", "4L34", "3M", "3L37"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L56", "6L56", "5L56", "4L56"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L16", "6L16", "5L16", "4T", "4L16", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			shellsmash: ["7L67", "6L67", "5L67"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spikecannon: ["7L1", "7V", "6L40", "5L40", "4L40", "3L40"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			tickle: ["7L48", "6L48", "5L48", "4L48", "3L46"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L10", "7V", "6L10", "5L10", "4L10", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			withdraw: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	kabuto: {
		inherit: true,
		learnset: {
			absorb: ["7L6", "7V", "6L6", "5L6", "5D", "4L6", "3L13"],
			aerialace: ["7M", "3M"],
			ancientpower: ["7L46", "6L46", "5L46", "4T", "4L46", "3L55"],
			aquajet: ["7L31", "6L31", "5L31", "4L31"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brine: ["4M"],
			bubblebeam: ["7E", "7V", "6E", "5E", "4E", "3E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "5S0", "4E", "3E"],
			dig: ["6M", "5M", "5S0", "4M", "4E", "3M", "3E"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			endure: ["7L26", "6L26", "5L26", "4M", "4L26", "3T", "3L37"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7E", "6E", "5E", "5D", "4E", "3E"],
			foresight: ["7E", "6E", "5E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7L1", "7V", "6L1", "5L1", "5S0", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["7V"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			leer: ["7L11", "7V", "6L11", "5L11", "4L11", "3L19"],
			megadrain: ["7L36", "6L36", "5L36", "4L36", "3L49"],
			metalsound: ["7L41", "6L41", "5L41", "4L41", "3L43"],
			mimic: ["7V", "3T"],
			mudshot: ["7L16", "7E", "6L16", "6E", "5L16", "5E", "4L16", "4E", "3L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7E", "6E", "5E", "4E", "3E"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L21", "6L21", "5L21", "4L21", "3L31"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "5S0", "4L1", "3L1"],
			screech: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			slash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "5D", "4M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7E", "7V", "6E"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wringout: ["7L50", "6L50", "5L51", "4L51"],
		},
	},
	kabutops: {
		inherit: true,
		learnset: {
			absorb: ["7L6", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["7L54", "6L54", "5L54", "4T", "4L54", "3L65"],
			aquajet: ["7L31", "6L31", "5L31", "4L31"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			endure: ["7L26", "6L26", "5L26", "4M", "4L26", "3T", "3L37"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7L1", "6L1", "5L1", "4L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T", "3L1"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["7V"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L11", "7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "5T", "4T"],
			megadrain: ["7L36", "6L36", "5L36", "4L36", "3L55"],
			megakick: ["7V", "3T"],
			metalsound: ["7L45", "6L45", "5L45", "4L45", "3L46"],
			mimic: ["7V", "3T"],
			mudshot: ["7L16", "6L16", "5L16", "4L16", "3L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			nightslash: ["7L72", "7L1", "6L1", "5L72", "4L72"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L21", "6L21", "5L21", "4L21", "3L31"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			scratch: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			skullbash: ["7V"],
			slash: ["7L1", "7V", "6L40", "5L40", "4L40", "3L40"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			takedown: ["7V"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wringout: ["7L63", "6L63", "5L63", "4L63"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	aerodactyl: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L17", "7V", "6L17", "5L17", "4L17", "3L8"],
			aircutter: ["4T"],
			ancientpower: ["7L25", "6L25", "5L25", "4T", "4L25", "3L29"],
			aquatail: ["6T", "5T", "4T"],
			assurance: ["7E", "6E", "5E", "5D", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bite: ["7L1", "7V", "6L1", "5L1", "5D", "4L1", "3L15"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L33", "6L33", "5L33", "4L33"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonbreath: ["7E", "6E", "5E", "4E", "3E"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrage: ["7V"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firefang: ["7L1", "6L1", "5L1", "5S0", "4L1"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "7L81", "6M", "6L81", "5M", "5L81", "4M", "4L73"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7L65", "7V", "6M", "6L65", "5M", "5L65", "4M", "4L57", "3M", "3L50"],
			icefang: ["7L1", "6L1", "5L1", "5S0", "4L1"],
			incinerate: ["6M", "5M"],
			ironhead: ["7L57", "7L1", "6T", "6L1", "5T", "5L57", "4T", "4L49"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L9", "6M", "6L9", "5M", "5L9", "4M", "4L9", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L73", "6M", "6L73", "5M", "5L73", "4M", "4L65", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scaryface: ["7L1", "6L1", "5L1", "4L1", "3L36"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["7V", "6T", "5T", "4T", "3T"],
			skydrop: ["7M", "7L49", "6M", "6L49", "5M", "5L49"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "5D", "4M"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "5S0", "4M", "4E", "3M", "3E"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L1", "7V", "6L1", "5L1", "4L1", "3L22"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwind: ["7E", "6T", "6E", "5T", "5E", "4T"],
			takedown: ["7L41", "7V", "6L41", "5L41", "4L41", "3L43"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L1", "6L1", "5L1", "5S0", "4L1"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["7E", "7V", "6E", "5E", "4E", "3E"],
			wideguard: ["7E", "6E"],
			wingattack: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	munchlax: {
		inherit: true,
		learnset: {
			afteryou: ["7E", "6T", "6E", "5T", "5E"],
			amnesia: ["7L9", "6L9", "5L9", "4L9"],
			attract: ["7M", "6M", "5M", "4M"],
			belch: ["7E", "6E"],
			bellydrum: ["7L44", "6L44"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bodyslam: ["7L25", "6L25", "5L36", "4L33"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			charm: ["7E", "6E", "5E", "4E"],
			chipaway: ["7L17", "6L17", "5L25"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E"],
			covet: ["6T", "5T"],
			curse: ["7E", "6E", "5E", "4E", "4S1"],
			defensecurl: ["7L4", "6L4", "5L4", "4L4", "4S0"],
			doubleedge: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "4T"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L36"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gunkshot: ["6T", "5T", "4T"],
			happyhour: ["7S2"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			holdback: ["7S2"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			lastresort: ["7L57", "7L1", "6T", "6L1", "5T", "5L57", "4T", "4L49"],
			lick: ["7L12", "7E", "7L1", "6L1", "6E", "5L12", "5E", "4L12", "4E"],
			metronome: ["7L1", "7S2", "6L1", "5L1", "4L1", "4S0", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["7L49", "7E", "6L49", "6E", "5L49", "5E", "4M", "4L44"],
			odorsleuth: ["7L1", "6L1", "5L1", "4L1", "4S1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			pursuit: ["7E", "6E", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["7L1", "6T", "6L1", "5T", "5L17", "4M", "4L17"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["7L36", "6L36", "5L44", "4T", "4L41"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			screech: ["7L20", "6L20", "5L20", "4L20"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			selfdestruct: ["7E", "6E", "5E", "4S0"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["7L50", "6T", "6L1", "5T", "5L52"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stockpile: ["7L28", "6L28", "5L28", "4L25"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M", "4E"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swallow: ["7L33", "6L33", "5L33", "4L28"],
			tackle: ["7L1", "7S2", "6L1", "5L1", "4L1", "4S0", "4S1"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M"],
			whirlpool: ["4M"],
			whirlwind: ["7E", "6E", "5E", "4E"],
			workup: ["7M", "5M"],
			zenheadbutt: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
		},
	},
	snorlax: {
		inherit: true,
		learnset: {
			afteryou: ["7E", "6T", "6E", "5T", "5E"],
			amnesia: ["7L9", "7V", "6L9", "5L9", "5D", "4L9", "3L5"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7E", "6E"],
			bellydrum: ["7L44", "6L44", "5L17", "4L17", "3L13"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			block: ["7L41", "6T", "6L41", "5T", "5L41", "4T", "4L36", "3L37"],
			bodyslam: ["7L25", "7V", "6L25", "5L36", "4L33", "3T", "3L33", "3S0"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			charm: ["7E", "6E", "5E", "4E", "3E"],
			chipaway: ["7L17", "6L17", "5L25"],
			confide: ["7M", "6M"],
			counter: ["7E", "7V", "6E", "5E", "4E", "3T"],
			covet: ["6T", "5T", "3L42"],
			crunch: ["7L49", "6L49", "5L49", "4L44"],
			curse: ["7E", "6E", "5E", "4E", "3E", "3S0"],
			defensecurl: ["7L4", "6L4", "5L4", "4L4", "3T", "3L9"],
			doubleedge: ["7E", "7V", "6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "5D", "4T", "3T"],
			fissure: ["7E", "7V", "6E", "5E", "4E", "3E", "3S0"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "7L35", "6M", "6L57", "5M", "5L57", "4M", "4L49"],
			gunkshot: ["6T", "5T", "4T"],
			harden: ["7V"],
			headbutt: ["7V", "4T", "3L17"],
			heavyslam: ["7L50", "6L50", "5L52"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			highhorsepower: ["7L57"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M", "3L51"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			lick: ["7L12", "7E", "6L12", "6E", "5L12", "5E", "4L12", "4E", "3E"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			outrage: ["6T", "5T", "4T"],
			payday: ["7V"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			psywave: ["7V"],
			pursuit: ["7E", "6E", "5E", "4E"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "5D", "4M"],
			reflect: ["7V"],
			refresh: ["3S0"],
			rest: ["7M", "7L28", "7V", "6M", "6L28", "5M", "5L28", "4M", "4L25", "3M", "3L25"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L36", "6L36", "5L44", "4T", "4L41", "3T", "3L46"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["7V", "3T"],
			selfdestruct: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "7L33", "6M", "6L33", "5T", "5L33", "4M", "4L28", "3T", "3L37"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["7L28", "6T", "6L28", "5T", "5L28", "4T", "4L28", "3T", "3L28"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			whirlwind: ["7E", "6E", "5E", "4E"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			yawn: ["7L20", "6L20", "5L20", "4L20", "3L21"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	articuno: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L36", "7V", "6L36", "5L36", "4L36", "4S3", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			ancientpower: ["7L29", "6L29", "5L29", "4T", "4L29"],
			auroraveil: ["7M"],
			avalanche: ["4M"],
			bide: ["7V"],
			blizzard: ["7M", "7L78", "7V", "6M", "6L71", "5M", "5L71", "4M", "4L71", "3M", "3L73"],
			bubblebeam: ["7V"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["3S2"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			freezedry: ["7L43", "6L1", "6S6"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "7L57", "6M", "6L57", "6S5", "6S6", "5M", "5L85", "4M", "4L85", "3M"],
			haze: ["3S2"],
			healbell: ["3S2"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7L92", "6L1", "5L92"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7L71", "7V", "6M", "6L43", "6S5", "6S6", "5M", "5L43", "4M", "4L43", "4S3", "4S4", "3M", "3L49", "3S0", "3S1", "3S2"],
			iceshard: ["7L15", "6L15", "5L15", "4L15"],
			icywind: ["6T", "5T", "4T", "3T"],
			mimic: ["7V", "3T"],
			mindreader: ["7L22", "6L22", "5L22", "4L22", "4S4", "3L37", "3S0", "3S1"],
			mist: ["7L8", "7V", "6L8", "5L8", "4L8", "4S4", "3L13", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["7V"],
			pluck: ["5M", "4M"],
			powdersnow: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			reflect: ["7M", "7L50", "7V", "6M", "6L50", "6S5", "6S6", "5M", "5L50", "4M", "4L50", "4S3", "3M", "3L61", "3S1"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["7M", "7L85", "6M", "6L1", "5T", "5L57", "4M", "4L57", "4S3"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["7L99", "6L1", "5L78", "4L78", "3L85"],
			signalbeam: ["6T", "5T", "4T"],
			skyattack: ["7V", "6T", "5T", "4T", "3T"],
			skydrop: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwind: ["7L64", "6T", "6L1", "6S5", "5T", "5L64", "4T", "4L64"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlwind: ["7V"],
		},
	},
	zapdos: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L43", "7V", "6L43", "6S5", "6S6", "5L43", "4L43", "4S3", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			ancientpower: ["7L29", "6L29", "5L29", "4T", "4L29"],
			batonpass: ["3S2"],
			bide: ["7V"],
			charge: ["7L36", "6L36", "5L36", "4L36", "4S3", "3L61", "3S1"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			detect: ["7L15", "6L15", "5L15", "4L15", "4S4", "3L37", "3S0", "3S1"],
			discharge: ["7L50", "6L50", "6S5", "6S6", "5L50", "4L50", "4S3"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drillpeck: ["7L71", "7V", "6L1", "5L71", "4L71", "4S4", "3L49", "3S0", "3S1"],
			endure: ["4M", "3T"],
			extrasensory: ["3S2"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			lightscreen: ["7M", "7L64", "7V", "6M", "6L64", "6S5", "5M", "5L64", "4M", "4L64", "3M", "3L73"],
			magneticflux: ["7L92"],
			metalsound: ["3S2"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			pluck: ["7L22", "6L22", "5M", "5L22", "4M", "4L22"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "7L57", "6M", "6L57", "6S5", "6S6", "5M", "5L85", "4M", "4L85", "3M"],
			razorwind: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["7M", "7L85", "6M", "6L1", "5T", "5L57", "4M", "4L57", "4S3"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skyattack: ["7V", "6T", "5T", "4T", "3T"],
			skydrop: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			thunder: ["7M", "7L78", "7V", "6M", "6L78", "5M", "5L78", "4M", "4L78", "3M", "3L85"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M", "3S2"],
			thundershock: ["7L1", "7V", "6L1", "6S6", "5L1", "4L1", "3L1"],
			thunderwave: ["7M", "7L8", "7V", "6M", "6L8", "5M", "5L8", "4M", "4L8", "4S4", "3T", "3L13", "3S0"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			voltswitch: ["7M", "6M", "5M"],
			whirlwind: ["7V"],
			wildcharge: ["7M", "6M", "5M"],
			zapcannon: ["7L99", "6L1", "5L92"],
		},
	},
	moltres: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L15", "7V", "6L15", "5L15", "4L15", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			airslash: ["7L50", "6L50", "6S5", "5L50", "4L50", "4S3"],
			ancientpower: ["7L29", "6L29", "5L29", "4T", "4L29"],
			bide: ["7V"],
			burnup: ["7L99"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			ember: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			endure: ["7L22", "6L22", "5L22", "4M", "4L22", "4S4", "3T", "3L37", "3S0", "3S1"],
			extrasensory: ["3S2"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firespin: ["7L8", "7V", "6L8", "5L8", "4L8", "4S4", "3L13", "3S0"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L36", "6M", "6L36", "5M", "5L36", "4M", "4L36", "4S3", "4S4", "3M", "3L49", "3S0", "3S1", "3S2"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			heatwave: ["7L64", "6T", "6L1", "6S5", "6S6", "5T", "5L64", "4T", "4L64", "3L73"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7L92", "6L1", "5L92"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			leer: ["7V"],
			mimic: ["7V", "3T"],
			morningsun: ["3S2"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			peck: ["7V"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["7M", "7L85", "6M", "6L1", "5T", "5L57", "4M", "4L57", "4S3"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L43", "6M", "6L43", "6S5", "6S6", "5M", "5L43", "4M", "4L43", "4S3", "3M", "3L61", "3S1"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["7L78", "7V", "6T", "6L1", "6S6", "5T", "5L78", "4T", "4L78", "3T", "3L85"],
			skydrop: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L71", "6M", "6L71", "5M", "5L71", "4M", "4L71"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "7L57", "6M", "6L57", "6S5", "6S6", "5M", "5L85", "4M", "4L85", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7V"],
			willowisp: ["7M", "6M", "5M", "4M", "3S2"],
			wingattack: ["7L1", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	dratini: {
		inherit: true,
		learnset: {
			agility: ["7L25", "7V", "6L25", "5L25", "4L25", "3L36"],
			aquajet: ["7E", "6E", "5E"],
			aquatail: ["7L35", "6T", "6L35", "5T", "5L35", "4T", "4L31"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brutalswing: ["7M"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonbreath: ["7E", "6E", "5E", "5D", "4E", "3E"],
			dragondance: ["7L51", "7E", "6L51", "6E", "5L51", "5E", "4L45", "4E", "3E"],
			dragonpulse: ["7E", "6T", "6E", "5T", "5E", "4M"],
			dragonrage: ["7L15", "7V", "6L15", "5L15", "4L15", "3L22"],
			dragonrush: ["7L41", "7E", "6L41", "6E", "5L41", "5E", "4L35", "4E"],
			dragontail: ["7M", "7L31", "6M", "6L31", "5M", "5L31"],
			endure: ["4M", "3T"],
			extremespeed: ["7E", "6E", "5E", "4E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7L61", "7V", "6M", "6L61", "5M", "5L61", "4M", "4L55", "3M", "3L57"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4E", "3E"],
			mimic: ["7V", "3T"],
			mist: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			outrage: ["7L55", "6T", "6L55", "5T", "5L55", "4T", "4L51", "3L50"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L45", "6M", "6L45", "5M", "5L45", "4M", "4L41", "3M", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			slam: ["7L21", "7V", "6L21", "5L21", "4L21", "3L29"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "7L5", "7V", "6M", "6L5", "5M", "5L5", "5D", "4M", "4L5", "3T", "3L8"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["7L11", "6L11", "5L11", "4T", "4L11", "3L15"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["7E", "6T", "6E", "5E", "5D", "4M", "3M"],
			whirlpool: ["4M"],
			wrap: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	dragonair: {
		inherit: true,
		learnset: {
			agility: ["7L25", "7V", "6L25", "5L25", "4L25", "3L38"],
			aquatail: ["7L39", "6T", "6L39", "5T", "5L39", "4T", "4L33"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brutalswing: ["7M"],
			bubblebeam: ["7V"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragondance: ["7L61", "6L61", "5L61", "4L53"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrage: ["7L15", "7V", "6L15", "5L15", "4L15", "3L22"],
			dragonrush: ["7L47", "6L47", "5L47", "4L39"],
			dragontail: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			horndrill: ["7V"],
			hyperbeam: ["7M", "7L75", "7V", "6M", "6L75", "5M", "5L75", "4M", "4L67", "3M", "3L65"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M"],
			mimic: ["7V", "3T"],
			naturalgift: ["4M"],
			outrage: ["7L67", "6T", "6L67", "5T", "5L67", "4T", "4L61", "3L56"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L53", "6M", "6L53", "5M", "5L53", "4M", "4L47", "3M", "3L47"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			slam: ["7L21", "7V", "6L21", "5L21", "4L21", "3L29"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			takedown: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "7L5", "7L1", "7V", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["7L11", "7L1", "6L1", "5L1", "4T", "4L1", "3L1"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wrap: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	dragonite: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L25", "7V", "6L25", "6S8", "5L25", "4L25", "3L38", "3S0"],
			aircutter: ["4T"],
			aquatail: ["7L39", "6T", "6L39", "5T", "5L39", "4T", "4L33"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["6S8"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bubblebeam: ["7V"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T", "4S2"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragondance: ["7L61", "6L61", "6S7", "5L61", "5S3", "4L53", "4S2", "3S1"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrage: ["7L15", "7V", "6L15", "5L15", "4L15", "3L22"],
			dragonrush: ["7L47", "6L47", "5L47", "5S4", "5S5", "4L39"],
			dragontail: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			endure: ["4M", "3T"],
			extremespeed: ["6S7", "5S3", "5S5"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "5S6", "4M", "3M"],
			firepunch: ["7L1", "6T", "6L1", "5T", "5L1", "5S3", "4T", "4L1", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["3S1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			horndrill: ["7V"],
			hurricane: ["7L81", "7L1", "6L1", "6S7", "5L81"],
			hyperbeam: ["7M", "7L75", "7V", "6M", "6L75", "6S8", "5M", "5L75", "5S6", "4M", "4L73", "3M", "3L75", "3S1"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["7L67", "6T", "6L67", "6S7", "5T", "5L67", "5S3", "5S6", "4T", "4L64", "4S2", "3L61", "3S0"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			reflect: ["7V"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7L1", "6M", "6L1", "5T", "5L1", "4M", "4L1"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L53", "6M", "6L53", "5M", "5L53", "5S4", "5S5", "5S6", "4M", "4L47", "3M", "3L47", "3S0"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			skullbash: ["7V"],
			skydrop: ["7M", "6M", "5M"],
			slam: ["7L21", "7V", "6L21", "6S8", "5L21", "4L21", "3L29"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "4S2", "3M"],
			thunderpunch: ["7L1", "6T", "6L1", "5T", "5L1", "5S4", "4T", "4L1", "3T"],
			thunderwave: ["7M", "7L5", "7L1", "7V", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			twister: ["7L11", "7L1", "6L1", "5L1", "4T", "4L1", "3L1"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wingattack: ["7L1", "6L55", "5L55", "5S4", "5S5", "4L55", "3L55", "3S0"],
			wrap: ["7L1", "7V", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	mewtwo: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			amnesia: ["7L79", "7V", "6L79", "5L50", "4L57", "4S1", "3L77"],
			aquatail: ["6T", "5T", "4T"],
			aurasphere: ["7L70", "6L70", "6S4", "6S5", "5L93", "5S2", "4L100"],
			avalanche: ["4M"],
			barrier: ["7L64", "7V", "6L64", "6S4", "5L1", "4L8", "3L11"],
			bide: ["7V"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			bodyslam: ["7V", "3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bubblebeam: ["7V"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			counter: ["7V", "3T"],
			disable: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			dive: ["6M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			electroball: ["5S2"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L15", "6L15", "5L15", "4L22", "3L44"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			guardswap: ["7L43", "6L43", "5L57", "4L64", "4S1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healpulse: ["5S3"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["5S3"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7V", "6M", "5M", "5S3", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			laserfocus: ["7L1"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mefirst: ["7L93", "6L93", "5L71", "4L79"],
			megakick: ["7V", "3T"],
			megapunch: ["7V", "3T"],
			metronome: ["7V", "3T"],
			mimic: ["7V", "3T"],
			miracleeye: ["7L29", "6L29", "5L29", "4L36"],
			mist: ["7L86", "7V", "6L86", "5L36", "4L43", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payday: ["7V"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			powerswap: ["7L43", "6L43", "5L57", "4L64", "4S1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L57", "7V", "6M", "6L57", "6S4", "6S5", "5M", "5L64", "4M", "4L71", "3M", "3L66", "3S0"],
			psychocut: ["7L36", "6L36", "5L43", "4L50", "4S1"],
			psychup: ["7M", "7L22", "6M", "6L22", "5M", "5L22", "4M", "4L29", "3T", "3L33"],
			psyshock: ["7M", "6M", "5M"],
			psystrike: ["7L100", "6L100", "6S5", "5L100", "5S2", "5S3"],
			psywave: ["7L1", "7V"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L50", "7V", "6L50", "6S4", "6S5", "5L79", "4L86", "3L44", "3S0"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L1", "6M", "6L1", "5M", "5L86", "4M", "4L93", "3M", "3L55", "3S0"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7V", "3T"],
			selfdestruct: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "5S2", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skullbash: ["7V"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L8", "7V", "6L8", "5L8", "4T", "4L15", "3T", "3L22", "3S0"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["7V"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			triattack: ["7V"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	mew: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			afteryou: ["6T", "5T"],
			aircutter: ["4T"],
			allyswitch: ["5M"],
			amnesia: ["7L60", "6L60", "5L60", "4L60", "4S17"],
			ancientpower: ["7L50", "6L50", "5L50", "4T", "4L50", "4S14", "3L50"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurasphere: ["7L100", "6L100", "5L100", "4L100", "4S14", "4S15", "4S16", "4S17", "4S18", "4S19"],
			auroraveil: ["7M"],
			avalanche: ["4M"],
			barrier: ["7L40", "7S24", "6L40", "5L40", "4L40", "4S15"],
			batonpass: ["7L80", "6L80", "5L80", "4L80"],
			bide: ["7V"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "7V", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7V", "3T"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["4M"],
			brutalswing: ["7M"],
			bubblebeam: ["7V"],
			bugbite: ["6T", "5T", "4T"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["4M", "3M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["7V", "3T"],
			covet: ["6T", "5T"],
			cut: ["7V", "6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["7V", "6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7V", "3T"],
			doubleteam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrage: ["7V"],
			dragontail: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "7V", "6M", "5M", "4M", "3T"],
			drillrun: ["6T", "5T"],
			dualchop: ["6T", "5T"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7V", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			eggbomb: ["7V"],
			electroweb: ["6T", "5T"],
			embargo: ["7M", "6M", "5M", "4M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			explosion: ["7M", "7V", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["3S2", "3S3"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			feintattack: ["3S4", "3S5"],
			fireblast: ["7M", "7V", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fissure: ["7V"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7V", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "7V", "6M", "5M", "4M", "3M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gastroacid: ["6T", "5T", "4T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gunkshot: ["6T", "5T", "4T"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			horndrill: ["7V"],
			hyperbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["4S20", "3S6", "3S7"],
			icebeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			infestation: ["7M", "6M"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			leechlife: ["7M"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			magnetrise: ["6T", "5T", "4T"],
			mefirst: ["7L70", "6L70", "5L70", "4L70"],
			megadrain: ["7V"],
			megakick: ["7V", "3T"],
			megapunch: ["7L10", "7V", "6L10", "5L10", "4L10", "4S16", "3T", "3L20", "3S0"],
			metronome: ["7L20", "7V", "7S24", "6L20", "5L20", "4L20", "4S14", "4S15", "4S16", "4S17", "4S18", "4S19", "3T", "3L30", "3S0"],
			mimic: ["7V", "3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L90", "6L90", "5L90", "4L90"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			nightmare: ["3T"],
			nightshade: ["3S8", "3S9"],
			ominouswind: ["4T"],
			outrage: ["6T", "5T", "4T"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			payday: ["7V"],
			pluck: ["5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			pound: ["7L1", "7V", "7S23", "6L1", "6S22", "5L1", "4L1", "4S21", "3L1", "3S0", "3S1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L30", "7V", "7S24", "6M", "6L30", "5M", "5L30", "4M", "4L30", "4S19", "3M", "3L40"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7V"],
			quash: ["7M", "6M", "5M"],
			rage: ["7V"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7V"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7V", "6M", "5M", "4M", "3M"],
			reflecttype: ["7L1", "6L1", "5L1"],
			rest: ["7M", "7V", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "4S20", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7V", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T", "3S10", "3S11"],
			rollout: ["4T", "3T"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["7V", "3T"],
			selfdestruct: ["7V", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skullbash: ["7V"],
			skyattack: ["7V", "6T", "5T", "4T", "3T"],
			skydrop: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			smartstrike: ["7M"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			softboiled: ["7V", "3T"],
			solarbeam: ["7M", "7V", "6M", "5M", "4M", "3M"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			steelwing: ["7M", "6M", "4M", "3M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["7V", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			submission: ["7V"],
			substitute: ["7M", "7V", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "7V", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7V", "4T", "3T"],
			swordsdance: ["7M", "7V", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T", "4S20"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7V"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["7V", "4S14", "4S15", "4S16", "4S17", "4S18", "4S19", "4S20"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "7V", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7V", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7V", "6M", "5M", "4M", "3M"],
			transform: ["7L1", "7V", "7S24", "6L1", "5L1", "4L1", "4S18", "3L10", "3S0", "3S1"],
			triattack: ["7V"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["4T"],
			venoshock: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7V"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			whirlwind: ["7V"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			workup: ["7M", "5M"],
			worryseed: ["6T", "5T", "4T"],
			xscissor: ["7M", "6M", "5M", "4M"],
			zapcannon: ["3S12", "3S13"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	chikorita: {
		inherit: true,
		learnset: {
			ancientpower: ["7E", "6E", "5E", "4T", "4E", "3E", "3S1"],
			aromatherapy: ["7L42", "7E", "6L42", "6E", "5L42", "5E", "4L42", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L34", "7E", "6L34", "6E", "5L34", "5E", "4L34", "4E", "3T", "3L29"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frenzyplant: ["3S1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			grasswhistle: ["7E", "6E", "5E", "4E", "3E"],
			grassyterrain: ["7E", "6E"],
			growl: ["7L1", "6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			headbutt: ["4T"],
			healpulse: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			ingrain: ["7E", "6E", "5E", "4E", "3E"],
			irontail: ["6T", "5T", "4M", "3M"],
			leafstorm: ["7E", "6E", "5E", "4E"],
			leechseed: ["7E", "6E", "5E", "4E", "3E"],
			lightscreen: ["7M", "7L31", "6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L36"],
			magicalleaf: ["7L20", "6L20", "5L20", "4L20"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7L23", "6L23", "5L23", "4M", "4L23"],
			naturepower: ["7M", "7E", "6M", "6E", "5E", "4E", "3E"],
			poisonpowder: ["7L9", "6L9", "5L9", "4L9", "3L15"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			razorleaf: ["7L6", "6L6", "5L6", "4L6", "3L8", "3S0"],
			reflect: ["7M", "7L17", "6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L12"],
			refresh: ["7E", "6E", "5E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L39", "6M", "6L39", "5M", "5L39", "4M", "4L39", "3M", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L45", "6M", "6L45", "5M", "5L45", "4M", "4L45", "3M", "3L50"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L28", "6L28", "5L28", "4L28"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7L12", "6T", "6L12", "5T", "5L12", "4T", "4L12", "3L22"],
			tackle: ["7L1", "6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			vinewhip: ["7E", "6E", "5E", "4E", "3E"],
			workup: ["7M"],
			worryseed: ["6T", "5T", "4T"],
			wringout: ["7E", "6E", "5E", "4E"],
		},
	},
	bayleef: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aromatherapy: ["7L50", "6L50", "5L50", "4L50"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L40", "6L40", "5L40", "4L40", "3T", "3L31"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "7L36", "6M", "6L36", "5M", "5L36", "4M", "4L36", "3M", "3L39"],
			magicalleaf: ["7L22", "6L22", "5L22", "4L22"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7L26", "6L26", "5L26", "4M", "4L26"],
			naturepower: ["7M", "6M"],
			poisonpowder: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L15"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			razorleaf: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			reflect: ["7M", "7L18", "6M", "6L18", "5M", "5L18", "4M", "4L18", "3M", "3L1"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L46", "6M", "6L46", "5M", "5L46", "4M", "4L46", "3M", "3L47"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L54", "6M", "6L54", "5M", "5L54", "4M", "4L54", "3M", "3L55"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L32", "6L32", "5L32", "4L32"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7L12", "6T", "6L12", "5T", "5L12", "4T", "4L12", "3L23"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			workup: ["7M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	meganium: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aromatherapy: ["7L60", "6L60", "5L60", "4L60"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L46", "6L46", "6S0", "5L46", "4L46", "3T", "3L31"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragontail: ["7M", "6M", "5M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frenzyplant: ["7T", "6T", "5T", "4T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "7L40", "6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L41"],
			magicalleaf: ["7L22", "6L22", "5L22", "4L22"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7L26", "6L26", "5L26", "4M", "4L26"],
			naturepower: ["7M", "6M"],
			outrage: ["6T", "5T", "4T"],
			petalblizzard: ["7L70", "7L1", "6L1"],
			petaldance: ["7L1", "6L32", "5L32", "4L32"],
			poisonpowder: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L15"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			razorleaf: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			reflect: ["7M", "7L18", "6M", "6L18", "5M", "5L18", "4M", "4L18", "3M", "3L1"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L54", "6M", "6L54", "5M", "5L54", "4M", "4L54", "3M", "3L51"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L66", "6M", "6L66", "6S0", "5M", "5L66", "4M", "4L66", "3M", "3L61"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "6S0", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L34", "6L34", "5L34", "4L34"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7L12", "6T", "6L12", "6S0", "5T", "5L12", "4T", "4L12", "3L23"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			workup: ["7M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	cyndaquil: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blastburn: ["3S1"],
			bodyslam: ["3T"],
			burnup: ["7L58"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E", "5T", "5E", "4E", "3E"],
			crushclaw: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["7L22", "6L22", "5L22", "4L22", "3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L55", "7E", "6L55", "6E", "5L55", "5E", "4L46", "4E", "3T"],
			doublekick: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			ember: ["7L10", "6L10", "5L10", "4L10", "3L12"],
			endure: ["4M", "3T"],
			eruption: ["7L64", "6L58", "5L58", "4L49"],
			extrasensory: ["7E", "6E", "5E", "4E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepledge: ["7T", "6T", "5T"],
			flameburst: ["7E", "6E", "5E"],
			flamecharge: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			flamethrower: ["7M", "7L40", "6M", "6L40", "5M", "5L40", "4M", "4L37", "3M", "3L46"],
			flamewheel: ["7L19", "6L19", "5L19", "4L19", "3L27"],
			flareblitz: ["7E", "6E", "5E", "4E"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7E", "6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7E", "6E", "5E", "4E", "3E"],
			incinerate: ["6M", "5M"],
			inferno: ["7L46", "6L46", "5L46"],
			lavaplume: ["7L37", "6L37", "5L37", "4L31"],
			leer: ["7L1", "6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "7E", "6M", "6E", "5E"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L13", "7E", "6L13", "6E", "5L13", "5E", "4L13", "4E", "3L19", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7E", "6E", "5E", "4E", "3E", "3S1"],
			rollout: ["7L49", "6L49", "5L49", "4T", "4L40", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smokescreen: ["7L6", "6L6", "5L6", "4L4", "3L6", "3S0"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L31", "6L31", "5L31", "4T", "4L28", "3T", "3L36"],
			tackle: ["7L1", "6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			thrash: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M"],
		},
	},
	quilava: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			burnup: ["7L68"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["7L24", "6L24", "5L24", "4L24", "3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L64", "6L64", "5L64", "4L53", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			ember: ["7L10", "6L10", "5L10", "4L10", "3L12"],
			endure: ["4M", "3T"],
			eruption: ["7L75", "6L68", "5L68", "4L57"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepledge: ["7T", "6T", "5T"],
			flamecharge: ["7M", "7L35", "6M", "6L35", "5M", "5L35"],
			flamethrower: ["7M", "7L46", "6M", "6L46", "5M", "5L46", "4M", "4L42", "3M", "3L54"],
			flamewheel: ["7L20", "6L20", "5L20", "4L20", "3L31"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			inferno: ["7L53", "6L53", "5L53"],
			lavaplume: ["7L42", "6L42", "5L42", "4L35"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L13", "6L13", "5L13", "4L13", "3L21"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["7L57", "6L57", "5L57", "4T", "4L46", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smokescreen: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L31", "6L31", "5L31", "4T", "4L31", "3T", "3L42"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M"],
		},
	},
	typhlosion: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blastburn: ["7T", "6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			burnup: ["7L74"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["7L24", "6L24", "5L24", "4L24", "3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L69", "7L1", "6L1", "5L69", "4L53", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			ember: ["7L10", "7L1", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			eruption: ["7L82", "7L1", "6L1", "5L74", "4L57"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepledge: ["7T", "6T", "5T"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamecharge: ["7M", "7L35", "6M", "6L35", "6S1", "5M", "5L35"],
			flamethrower: ["7M", "7L48", "6M", "6L48", "5M", "5L48", "4M", "4L42", "3M", "3L60", "3S0"],
			flamewheel: ["7L20", "6L20", "6S1", "5L20", "4L20", "3L31", "3S0"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			inferno: ["7L56", "6L56", "5L56"],
			lavaplume: ["7L43", "6L43", "5L43", "4L35"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			overheat: ["7M", "6M", "6S1", "5M", "4M", "3M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L13", "6L13", "5L13", "4L13", "3L21", "3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["7L61", "6L61", "5L61", "4T", "4L46", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smokescreen: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L31", "6L31", "6S1", "5L31", "4T", "4L31", "3T", "3L45", "3S0"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M"],
		},
	},
	totodile: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["7E", "6E", "5E", "4T", "4E", "3E"],
			aquajet: ["7E", "6E", "5E", "4E"],
			aquatail: ["7L43", "6T", "6L43", "5T", "5L43", "4T", "4L36"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L13", "6L13", "5L13", "4L13", "3L20"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["7E", "6T", "6E", "5T", "5E"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chipaway: ["7L29", "6L29", "5L29"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crunch: ["7L27", "7E", "6L27", "6E", "5L27", "5E", "4L27", "4E", "3E", "3S1"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "6M", "5M", "4E", "3E"],
			dragondance: ["7E", "6E", "5E", "4E"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6E", "5E"],
			flail: ["7L22", "6L22", "5L22", "4L22"],
			flatter: ["7E", "6E"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydrocannon: ["3S1"],
			hydropump: ["7L50", "7E", "6L50", "6E", "5L50", "5E", "4L43", "4E", "3L52", "3E"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7L20", "6L20", "5L20", "4L20"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["7E", "6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7L8", "6L8", "5L8", "4L8", "3L7", "3S0"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			scaryface: ["7L15", "6L15", "5L15", "4L15", "3L27"],
			scratch: ["7L1", "6L1", "6S2", "5L1", "4L1", "3L1", "3S0", "3S1"],
			screech: ["7L36", "6L36", "5L36", "4L34", "3L43"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L34", "6L34", "5L34", "4L29", "3L35"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["7L48", "6T", "6L48", "5T", "5L48", "4T", "4L41"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			thrash: ["7L41", "7E", "6L41", "6E", "5L41", "5E", "4L22", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L6", "6L6", "5L6", "4L6", "3L13"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			watersport: ["7E", "6E", "5E", "4E", "3E"],
			whirlpool: ["4M"],
			workup: ["7M"],
		},
	},
	croconaw: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["7L51", "6T", "6L51", "5T", "5L51", "4T", "4L42"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L13", "6L13", "5L13", "4L13", "3L21"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chipaway: ["7L33", "6L33", "5L33"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crunch: ["7L30", "6L30", "5L30", "4L30"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "6M", "5M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L24", "6L24", "5L24", "4L24"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["7L60", "6L60", "5L60", "4L51", "3L55"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7L21", "6L21", "5L21", "4L21"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7L8", "6L8", "5L8", "4L8", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			scaryface: ["7L15", "6L15", "5L15", "4L15", "3L28"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7L42", "6L42", "5L42", "4L39", "3L45"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L39", "6L39", "5L39", "4L33", "3L37"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["7L57", "6T", "6L57", "5T", "5L57", "4T", "4L48"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			thrash: ["7L48", "6L48", "5L48", "4L24"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L13"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M"],
		},
	},
	feraligatr: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L1", "6L30", "5L30", "4L30"],
			ancientpower: ["4T"],
			aquatail: ["7L63", "6T", "6L63", "5T", "5L63", "4T", "4L50"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["7L13", "6L13", "5L13", "4L13", "3L21"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L37", "6L37", "5L37"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crunch: ["7L32", "6L32", "6S0", "5L32", "4L32"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L24", "6L24", "5L24", "4L24"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydrocannon: ["7T", "6T", "5T", "4T"],
			hydropump: ["7L76", "6L76", "5L76", "4L63", "3L58"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7L21", "6L21", "5L21", "4L21"],
			icepunch: ["6T", "6S0", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			scaryface: ["7L15", "6L15", "5L15", "4L15", "3L28"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7L50", "6L50", "6S0", "5L50", "4L45", "3L47"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L45", "6L45", "5L45", "4L37", "3L38"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["7L71", "6T", "6L71", "5T", "5L71", "4T", "4L58"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			thrash: ["7L58", "6L58", "5L58", "4L24"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterfall: ["7M", "6M", "6S0", "5M", "4M", "3M"],
			watergun: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M"],
		},
	},
	sentret: {
		inherit: true,
		learnset: {
			amnesia: ["7L36", "6L36", "5L36", "4L36", "3L49"],
			aquatail: ["6T", "5T", "4T"],
			assist: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L39", "6L39", "5L39", "4L39"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			captivate: ["7E", "6E", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7E", "6E", "5E", "4E"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E", "5T", "5E", "5D", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["7L4", "6L4", "5L4", "4L4", "3T", "3L4"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["5D", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7E", "6E", "5E", "4E", "3E"],
			focuspunch: ["6T", "4M", "3M"],
			followme: ["7L19", "6L19", "5L19", "4L19", "3L31"],
			foresight: ["7L1", "6L1", "5L1", "4L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L13", "6L13", "5L13", "4L13", "3L12"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["7L16", "6T", "6L16", "5T", "5L16", "4T", "4L16", "3L17"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["7L47", "6T", "6L47", "5T", "5L47", "4L47"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			mefirst: ["7L42", "6L42", "5L42", "4L42"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			quickattack: ["7L7", "6L7", "5L7", "4L7", "3L7"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "4M", "4L28", "3M", "3L40"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7E", "6E", "5E", "4E", "3E"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			slam: ["7L25", "6L25", "5L25", "4L25", "3L24"],
			slash: ["7E", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["7L31", "6L31", "5L31", "4T", "4L31"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["7E", "6T", "6E", "5T", "5E", "4E", "3E"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
		},
	},
	furret: {
		inherit: true,
		learnset: {
			agility: ["7L1"],
			amnesia: ["7L42", "6L42", "5L42", "4L42", "3L59"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L46", "6L46", "5L46", "4L46"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			coil: ["7L1"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["7L4", "7L1", "6L1", "5L1", "4L1", "3T", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			followme: ["7L21", "6L21", "5L21", "4L21", "3L37"],
			foresight: ["7L1", "6L1", "5L1", "4L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L13", "6L13", "5L13", "4L13", "3L12"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["7L17", "6T", "6L17", "5T", "5L17", "4T", "4L17", "3L19"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["7L56", "6T", "6L56", "5T", "5L56", "4L56"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			mefirst: ["7L50", "6L50", "5L50", "4L50"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L32", "6M", "6L32", "5M", "5L32", "4M", "4L32", "3M", "3L48"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			slam: ["7L28", "6L28", "5L28", "4L28", "3L28"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L36", "6L36", "5L36", "4T", "4L36"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
		},
	},
	hoothoot: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7E", "6E", "5E", "4E"],
			aircutter: ["4T"],
			airslash: ["7L31", "6L33", "5L33", "4L29"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L10", "6L21", "5L21", "4L21", "3L34"],
			defog: ["7E", "6E", "5E", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "7L46", "6M", "6L57", "5M", "5L57", "4M", "4L49", "3T", "3L48"],
			echoedvoice: ["7M", "7L13", "6M", "6L25", "5M", "5L25"],
			endure: ["4M", "3T"],
			extrasensory: ["7L22", "6L45", "5L45", "4L37"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			featherdance: ["7E", "6E", "5E", "4E", "3E"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			flash: ["3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			foresight: ["7L1", "6L1", "5L1", "5D", "4L1", "3L6", "3S0"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["7L4", "6L5", "5L5", "4L5", "3L16"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mirrormove: ["7E", "6E", "5E", "4E", "3E"],
			moonblast: ["7L40"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["7E", "6E", "5E", "5D", "4E"],
			ominouswind: ["4T"],
			peck: ["7L7", "6L9", "5L9", "4L9", "3L11"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychoshift: ["7L19", "6L49", "5L49", "4L41"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "5D", "4M"],
			reflect: ["7M", "7L28", "6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L22"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7L37", "6M", "6L53", "5T", "5L53", "4M", "4L45"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			silverwind: ["4M"],
			skyattack: ["7E", "6T", "6E", "5T", "5E", "4E", "3T", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["7L43", "6L41", "5L41"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7L25", "6L29", "5L29", "4L25", "3L28"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["7L34", "6T", "6L13", "5T", "5L13", "4T", "4L13"],
			whirlwind: ["7E", "6E", "5E", "4E", "3E"],
			wingattack: ["7E", "6E", "5E", "4E", "3E"],
			workup: ["7M", "5M"],
			zenheadbutt: ["7L16", "6T", "6L37", "5T", "5L37", "4T", "4L33"],
		},
	},
	noctowl: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["7L35", "6L37", "5L37", "4L32"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L10", "6L22", "5L22", "4L22", "3L41"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "7L55", "7L1", "6M", "6L1", "5M", "5L67", "4M", "4L57", "3T", "3L57"],
			echoedvoice: ["7M", "7L13", "6M", "6L27", "5M", "5L27"],
			endure: ["4M", "3T"],
			extrasensory: ["7L23", "6L52", "5L52", "4L42"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			foresight: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L16"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			moonblast: ["7L47"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			peck: ["7L7", "6L9", "5L9", "4L9", "3L1"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychoshift: ["7L19", "6L57", "5L57", "4L47"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "7L31", "6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L25"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7L43", "6M", "6L62", "5T", "5L62", "4M", "4L52"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			silverwind: ["4M"],
			skyattack: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["7L51", "6L47", "5L47"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7L27", "6L32", "5L32", "4L27", "3L33"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["7L39", "6T", "6L13", "5T", "5L13", "4T", "4L13"],
			workup: ["7M", "5M"],
			zenheadbutt: ["7L16", "6T", "6L42", "5T", "5L42", "4T", "4L37"],
		},
	},
	ledyba: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			agility: ["7L29", "6L30", "5L30", "4L30", "3L43"],
			aircutter: ["4T"],
			airslash: ["7L36"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L26", "6L22", "5L22", "4L22", "3L29"],
			bide: ["7E", "6E", "5E", "4E", "3E"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bugbite: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E"],
			bugbuzz: ["7L33", "7E", "6L41", "6E", "5L41", "5E", "4L41", "4E"],
			captivate: ["4M"],
			cometpunch: ["7L22", "6L9", "5L9", "5D", "4L9", "3L15"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M", "4M", "3M"],
			dizzypunch: ["7E", "6E", "5E"],
			doubleedge: ["7L40", "6L38", "5L38", "4L38", "3T", "3L50"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["7E", "6T", "6E", "5T", "5E", "4M"],
			dynamicpunch: ["3T"],
			encore: ["7E", "6E", "5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["7E", "6T", "6E", "5E", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			knockoff: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			lightscreen: ["7M", "7L12", "6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L22"],
			machpunch: ["7L15", "6L17", "5L17", "4L17"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7E", "6E", "5E", "4E", "3E", "3S0"],
			reflect: ["7M", "7L12", "6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L22"],
			refresh: ["3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L12", "6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L22"],
			screech: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			silverwind: ["7L19", "7E", "6L25", "6E", "5L25", "5E", "4M", "4L25", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L5", "6L6", "5L6", "4L6", "3L8", "3S0"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L8", "6L33", "5L33", "4T", "4L33", "3T", "3L36"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwind: ["7E", "6T", "6E", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "5D", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
		},
	},
	ledian: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L33", "6L36", "5L36", "4L36", "3L51"],
			aircutter: ["4T"],
			airslash: ["7L42"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L29", "6L24", "5L24", "4L24", "3L33"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L38", "6L53", "5L53", "4L53"],
			captivate: ["4M"],
			cometpunch: ["7L24", "6L1", "5L1", "4L1", "3L15"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L47", "6L48", "5L48", "4L48", "3T", "3L60"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			knockoff: ["6T", "5T", "4T"],
			lightscreen: ["7M", "7L12", "6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L24"],
			machpunch: ["7L15", "6L17", "5L17", "4L17"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "7L12", "6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L24"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L12", "6M", "6L14", "5M", "5L14", "4M", "4L14", "3M", "3L24"],
			secretpower: ["6M", "4M", "3M"],
			silverwind: ["7L20", "6L29", "5L29", "4M", "4L29"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L8", "7L1", "6L41", "5L41", "4T", "4L41", "3T", "3L42"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
		},
	},
	spinarak: {
		inherit: true,
		learnset: {
			absorb: ["7L5"],
			agility: ["7L33", "6L33", "5L33", "4L33", "3L45"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			bugbite: ["6T", "5T", "5D", "4T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			constrict: ["7L1", "6L8", "5L8", "4L8", "3L11"],
			crosspoison: ["7L47", "6L47", "5L47"],
			dig: ["6M", "5M", "4M", "3M", "3S0"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			electroweb: ["7E", "6T", "6E", "5T", "5E", "5D"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7L22", "6L22", "5L22", "4L22", "3L30"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			infestation: ["7M", "7L8", "6M"],
			leechlife: ["7M", "6L12", "5L12", "4L12", "3L23"],
			megahorn: ["7E", "6E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightshade: ["7L15", "6L15", "5L15", "4L15", "3L17", "3S0"],
			nightslash: ["7E", "6E", "5E"],
			pinmissile: ["7L36", "6L36", "5L36", "4L36"],
			poisonjab: ["7M", "7L43", "6M", "6L43", "5M", "5L43", "4M", "4L43", "4E"],
			poisonsting: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7E", "6E", "5E", "4E", "3E"],
			psychic: ["7M", "7L40", "6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L53"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			ragepowder: ["7E", "6E", "5E"],
			refresh: ["3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L12", "6L5", "5L5", "4L5", "3L6"],
			secretpower: ["6M", "4M", "3M"],
			shadowsneak: ["7L19", "6L19", "5L19", "4L19"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			sonicboom: ["7E", "6E", "5E", "4E", "3E"],
			spiderweb: ["7L29", "6L29", "5L29", "4L29", "3L37"],
			stickyweb: ["7L50", "6L50"],
			stringshot: ["7L1", "6L1", "5L1", "4T", "4L1", "3L1"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L26", "6L26", "5L26", "4T", "4L26"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7E", "6E", "5E", "4E"],
			toxicthread: ["7L54"],
			twineedle: ["7E", "6E", "5E"],
			venoshock: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	ariados: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "7L1"],
			agility: ["7L37", "6L37", "5L37", "4L37", "3L53"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			bugbite: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			constrict: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			crosspoison: ["7L55", "6L55", "5L55"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			electroweb: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fellstinger: ["7L1", "6L1"],
			flash: ["6M", "5M", "4M", "3M"],
			focusenergy: ["7L1"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7L23", "6L23", "5L23", "4L23", "3L34"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "7L8", "6M"],
			leechlife: ["7M", "6L12", "5L12", "4L12", "3L25"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightshade: ["7L15", "6L15", "5L15", "4L15", "3L17"],
			pinmissile: ["7L41", "6L41", "5L41", "4L41"],
			poisonjab: ["7M", "7L50", "6M", "6L50", "5M", "5L50", "4M", "4L50"],
			poisonsting: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L46", "6M", "6L46", "5M", "5L46", "4M", "4L46", "3M", "3L63"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L12", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowsneak: ["7L19", "6L19", "5L19", "4L19"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			smartstrike: ["7M"],
			snore: ["6T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spiderweb: ["7L32", "6L32", "5L32", "4L32", "3L43"],
			stickyweb: ["7L58", "6L58"],
			stringshot: ["7L1", "6L1", "5L1", "4T", "4L1", "3L1"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L28", "6L28", "5L28", "4T", "4L28"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "7L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			toxicthread: ["7L63"],
			venomdrench: ["7L1", "6L1"],
			venoshock: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	chinchou: {
		inherit: true,
		learnset: {
			agility: ["7E", "6E", "5E", "4E"],
			amnesia: ["7E", "6E", "5E", "5D", "4E", "3E"],
			aquaring: ["7L42", "6L42", "5L42", "4L39"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["7E", "6E", "5E", "4M"],
			bubble: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["7L20", "6L20", "5L31", "4L28"],
			captivate: ["4M"],
			charge: ["7L50", "6L50", "5L50", "4L45", "3L49"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L17", "6L17", "5L12", "4L17", "3L29"],
			dazzlinggleam: ["7M", "6M"],
			discharge: ["7L34", "6L34", "5L39", "4L34"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			electroball: ["7L9", "6L9", "5L28"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L31", "7E", "6L9", "6E", "5L9", "5E", "4L9", "4E", "3L13", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			healbell: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L45", "6L45", "5L45", "4L42", "3L41"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T"],
			iondeluge: ["7L47", "6L47"],
			mimic: ["3T"],
			mist: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7E", "6E", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["7E", "6T", "6E", "5E", "5D", "4M", "3M"],
			signalbeam: ["7L28", "6T", "6L28", "5T", "5L34", "4T", "4L31"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7E", "6E"],
			spark: ["7L23", "6L20", "5L20", "4L20", "3L25"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			supersonic: ["7L1", "6L1", "5L1", "4L1", "3L5"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7L39", "6L23", "5L23", "4L23", "3L37"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "7L6", "6M", "6L6", "5M", "5L6", "5D", "4M", "4L6", "3T", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L12", "6L1", "5L17", "4L12", "3L17"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			whirlpool: ["7E", "6E", "5E", "4M", "4E"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	lanturn: {
		inherit: true,
		learnset: {
			aquaring: ["7L47", "6L47", "5L52", "4L47"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["4M"],
			bubble: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["7L20", "6L20", "5L35", "4L30"],
			captivate: ["4M"],
			charge: ["7L58", "6L58", "5L64", "4L57", "3L61"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L17", "6L17", "5L17", "4L17", "3L32"],
			dazzlinggleam: ["7M", "6M"],
			discharge: ["7L37", "6L37", "5L47", "4L40"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			eerieimpulse: ["7L1", "6L1"],
			electroball: ["7L9", "7L1", "6L1", "5L30"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L33", "6L9", "5L9", "4L9", "3L13"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			healbell: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L51", "6L51", "5L57", "4L52", "3L50"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T"],
			iondeluge: ["7L54", "6L54"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["7L29", "6T", "6L29", "5T", "5L40", "4T", "4L35"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spark: ["7L23", "6L20", "5L20", "4L20", "3L25"],
			spitup: ["7L1", "6L27", "5L27", "4L27"],
			stockpile: ["7L1", "6L27", "5L27", "4L27"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			supersonic: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L1", "6L27", "5L27", "4L27"],
			takedown: ["7L43", "6L23", "5L23", "4L23", "3L43"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "7L6", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L12", "6L1", "5L12", "4L12", "3L17"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	togepi: {
		inherit: true,
		learnset: {
			afteryou: ["7L53", "6T", "6L53", "5T", "5L53"],
			ancientpower: ["7L33", "6L33", "5L33", "4T", "4L33", "3L21", "3S1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L41", "6L41", "5L41", "4L42", "3L41"],
			bestow: ["7L25", "6L25", "5L25"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			doubleedge: ["7L45", "6L45", "5L45", "4L46", "3T", "3L37"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7L17", "6L17", "5L17", "4L19", "3L17"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			extrasensory: ["7E", "6E", "5E", "4E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			followme: ["7L21", "6L21", "5L21", "4L24", "3L25", "3S1"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E", "6E", "5E", "4E", "3E"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["3S1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			lastresort: ["7L49", "6T", "6L49", "5T", "5L49", "4T", "4L51"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7E", "6E", "5E", "5D", "4E"],
			magiccoat: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["7L5", "6L5", "5L5", "5D", "4L6", "3T", "3L4", "3S0"],
			mimic: ["3T"],
			mirrormove: ["7E", "6E", "5E", "4E", "3E"],
			morningsun: ["7E", "6E", "5E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			peck: ["7E", "6E", "5E", "4E", "3E"],
			present: ["7E", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychoshift: ["7E", "6E", "5E", "4E"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L33"],
			secretpower: ["7E", "6M", "6E", "5E", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			storedpower: ["7E", "6E", "5E"],
			substitute: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["7L9", "6L9", "5L9", "4L10", "3L9", "3S0"],
			swift: ["4T", "3T"],
			telekinesis: ["5M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			triattack: ["3S1"],
			trick: ["6T", "5T", "4T"],
			uproar: ["6T", "5T", "5D", "4T"],
			waterpulse: ["6T", "4M", "3M"],
			wish: ["7L29", "6L29", "5L29", "4L28", "3L29"],
			workup: ["7M", "5M"],
			yawn: ["7L13", "6L13", "5L13", "4L15", "3L13", "3S0"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	togetic: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			afteryou: ["7L53", "6T", "6L53", "5T", "5L53"],
			aircutter: ["4T"],
			ancientpower: ["7L33", "6L33", "5L33", "4T", "4L33", "3L21"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L41", "6L41", "5L41", "4L42", "3L41"],
			bestow: ["7L25", "6L25", "5L25"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			charm: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			doubleedge: ["7L45", "6L45", "5L45", "4L46", "3T", "3L37"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7L17", "6L17", "5L17", "4L19", "3L17"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			extrasensory: ["7E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fairywind: ["7L14", "6L14"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			focuspunch: ["6T", "4M", "3M"],
			followme: ["7L21", "6L21", "5L21", "4L24", "3L25"],
			foresight: ["7E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			lastresort: ["7L49", "6T", "6L49", "5T", "5L49", "4T", "4L51"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7E"],
			magicalleaf: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			magiccoat: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["7L5", "7L1", "6L1", "5L1", "4L1", "3T", "3L1"],
			mimic: ["3T"],
			mirrormove: ["7E"],
			morningsun: ["7E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7E"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["7E"],
			present: ["7E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychoshift: ["7E"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L33"],
			secretpower: ["7E", "6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			skyattack: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			steelwing: ["7M", "6M", "4M", "3M"],
			storedpower: ["7E"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			telekinesis: ["5M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			twister: ["4T"],
			waterpulse: ["6T", "4M", "3M"],
			wish: ["7L29", "6L29", "5L29", "4L28", "3L29"],
			workup: ["7M", "5M"],
			yawn: ["7L13", "6L13", "5L13", "4L15", "3L13"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	togekiss: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			afteryou: ["7L1", "6T", "6L1"],
			aircutter: ["4T"],
			airslash: ["7L1", "6L1", "5L1", "5S0", "4L1"],
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M"],
			aurasphere: ["7L1", "6L1", "5L1", "5S0", "4L1"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			defog: ["4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			extremespeed: ["7L1", "6L1", "5L1", "5S0", "4L1"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magiccoat: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			present: ["5S0"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rollout: ["4T"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			skyattack: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			steelwing: ["7M", "6M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tailwind: ["6T", "5T", "4T"],
			telekinesis: ["5M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			twister: ["4T"],
			waterpulse: ["6T", "4M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	natu: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			aircutter: ["4T"],
			allyswitch: ["7E", "6E", "5M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L23", "6L23", "5L23", "4L23", "3L40"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			drillpeck: ["7E", "6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			featherdance: ["7E", "6E", "5E", "5D", "4E", "3E"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L44", "6L36", "5L36", "4L36", "3L30", "3S0"],
			gigadrain: ["6T", "5T", "5D", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			guardswap: ["7L47", "6L47", "5L47", "4L44"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7L12", "6L12", "5L12", "4L12"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mefirst: ["7L50", "6L20", "5L20", "4L20"],
			mimic: ["3T"],
			miracleeye: ["7L36", "6L17", "5L17", "4L17"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["7L6", "6L6", "5L6", "5D", "4L6", "3L10", "3S0"],
			ominouswind: ["7L20", "6L20", "5L44", "4T", "4L39"],
			painsplit: ["6T", "5T", "4T"],
			peck: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			powerswap: ["7L47", "6L47", "5L47", "4L44"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L33", "6M", "6L33", "5M", "5L50", "4M", "4L47", "3M", "3L50"],
			psychoshift: ["7L39", "6L33", "5L33", "4L33"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["7M", "6M", "5M"],
			quickattack: ["7E", "6E", "5E", "4E", "3E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			simplebeam: ["7E", "6E"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			skyattack: ["6T", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "4M", "4E", "3M", "3E"],
			storedpower: ["7L17", "6L17", "5L39"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7E", "6E", "5E", "4T", "4E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["7E", "6E", "5E"],
			tailwind: ["6T", "5T", "4T"],
			telekinesis: ["5M"],
			teleport: ["7L9", "6L9", "5L9", "4L9", "3L20"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			wish: ["7L28", "6L28", "5L28", "4L28", "3L30"],
			zenheadbutt: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
		},
	},
	xatu: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["7L1", "6L25"],
			allyswitch: ["5M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L23", "6L23", "5L23", "4L23", "3L50"],
			dazzlinggleam: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L49", "6L42", "5L42", "4L42", "3L35"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			guardswap: ["7L53", "6L53", "5L59", "4L54"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7L12", "6L12", "5L12", "4L12"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mefirst: ["7L57", "6L20", "5L20", "4L20"],
			mimic: ["3T"],
			miracleeye: ["7L39", "6L17", "5L17", "4L17"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["7L6", "7L1", "6L1", "5L6", "4L6", "3L10"],
			ominouswind: ["7L20", "6L20", "5L54", "4T", "4L47"],
			painsplit: ["6T", "5T", "4T"],
			peck: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			powerswap: ["7L53", "6L53", "5L54", "4L54"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L35", "6M", "6L35", "5M", "5L66", "4M", "4L59", "3M", "3L65"],
			psychoshift: ["7L43", "6L37", "5L37", "4L37"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skyattack: ["6T", "5T", "4T", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			steelwing: ["7M", "6M", "4M", "3M"],
			storedpower: ["7L17", "6L17", "5L47"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["7L1", "6T", "6L1", "5T", "5L27", "4T", "4L27"],
			telekinesis: ["5M"],
			teleport: ["7L9", "7L1", "6L1", "5L9", "4L9", "3L20"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			wish: ["7L29", "6L29", "5L30", "4L30", "3L35"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	mareep: {
		inherit: true,
		learnset: {
			afteryou: ["7E", "6T", "6E", "5T", "5E"],
			agility: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "4E", "3T", "3E", "3S2"],
			captivate: ["4M"],
			charge: ["7L15", "7E", "6L15", "6E", "5L23", "5E", "4L23", "4E", "3E"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L25", "6L25", "5L25"],
			cottonguard: ["7L36", "6L36", "5L32"],
			cottonspore: ["7L11", "6L11", "5L19", "4L19", "3L23", "3S0"],
			defensecurl: ["3T"],
			discharge: ["7L32", "6L32", "5L37", "4L28"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			eerieimpulse: ["7E", "6E"],
			electricterrain: ["7E", "6E"],
			electroball: ["7L22", "6L22", "5L28"],
			electroweb: ["6T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flatter: ["7E", "6E", "5E", "4E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L5", "4L5", "3L1", "3S1"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T", "3S2"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			holdback: ["6S3"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			lightscreen: ["7M", "7L43", "6M", "6L43", "5M", "5L46", "4M", "4L37", "3M", "3L30"],
			magnetrise: ["6T", "5T", "4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			odorsleuth: ["7E", "6E", "5E", "4E", "3E"],
			powergem: ["7L29", "6L29", "5L50", "4L41"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["5D", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4E", "3E"],
			sandattack: ["7E", "6E", "5E", "4E"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "5D", "4M", "3M"],
			signalbeam: ["7L39", "6T", "6L39", "5T", "5L41", "4T", "4L32"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "6S3", "5L1", "4L1", "3L1", "3S1"],
			takedown: ["7L18", "7E", "6L18", "6E", "5L18", "5E", "4E", "3E"],
			thunder: ["7M", "7L46", "6M", "6L46", "5M", "5L55", "4M", "4L46", "3M", "3L37", "3S0"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thundershock: ["7L8", "6L8", "6S3", "5L10", "5D", "4L10", "3L9", "3S0", "3S1", "3S2"],
			thunderwave: ["7M", "7L4", "6M", "6L4", "6S3", "5M", "5L14", "4M", "4L14", "3T", "3L16", "3S0", "3S2"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	flaaffy: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			charge: ["7L16", "6L16", "5L25", "4L25"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L29", "6L29", "5L29"],
			cottonguard: ["7L43", "6L43", "5L36"],
			cottonspore: ["7L11", "6L11", "5L20", "4L20", "3L27"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["7L38", "6L38", "5L42", "4L31"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			electroball: ["7L25", "6L25", "5L31"],
			electroweb: ["6T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "7L52", "6M", "6L52", "5M", "5L53", "4M", "4L42", "3M", "3L36"],
			magnetrise: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			powergem: ["7L34", "6L34", "5L59", "4L47"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["7L47", "6T", "6L47", "5T", "5L47", "4T", "4L36"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L20", "6L20", "5L20"],
			thunder: ["7M", "7L56", "6M", "6L56", "5M", "5L65", "4M", "4L53", "3M", "3L45"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thundershock: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			thunderwave: ["7M", "7L4", "7L1", "6M", "6L1", "5M", "5L14", "4M", "4L14", "3T", "3L18"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	ampharos: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			charge: ["7L16", "6L16", "5L25", "4L25"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L29", "6L29", "5L29"],
			cottonguard: ["7L46", "6L46", "5L40"],
			cottonspore: ["7L11", "6L11", "5L20", "4L20", "3L27"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["7L40", "6L40", "5L48", "4L34"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["7L65", "7L1", "6T", "6L1"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			electroball: ["7L25", "6L25", "5L33"],
			electroweb: ["6T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			iondeluge: ["7L1", "6L1"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "7L57", "6M", "6L57", "5M", "5L63", "4M", "4L51", "3M", "3L42"],
			magneticflux: ["7L1", "6L1"],
			magnetrise: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			powergem: ["7L35", "6L35", "5L71", "4L59"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["7L51", "6T", "6L51", "5T", "5L55", "4T", "4L42"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L20", "6L20", "5L20"],
			thunder: ["7M", "7L62", "6M", "6L62", "5M", "5L79", "4M", "4L68", "3M", "3L57"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["7L1", "6T", "6L30", "5T", "5L30", "4T", "4L30", "3T", "3L30"],
			thundershock: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			thunderwave: ["7M", "7L4", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			zapcannon: ["7L1", "6L1"],
		},
	},
	azurill: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "4E", "3T"],
			bounce: ["7L23", "6T", "6L23", "5T", "5L23"],
			bubble: ["7L7", "6L7", "5L10", "4L10", "3L10"],
			bubblebeam: ["7L13", "6L13", "5L13"],
			camouflage: ["7E", "6E"],
			captivate: ["4M"],
			charm: ["7L10", "6L10", "5L2", "4L2", "3L3"],
			confide: ["7M", "6M"],
			copycat: ["7E", "6E"],
			covet: ["6T", "5T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			encore: ["7E", "6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6E", "5E", "4E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["7L16", "6T", "6L16", "5T", "5L16", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M"],
			mimic: ["3T"],
			muddywater: ["7E", "6E", "5E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["3T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sing: ["7E", "6E", "5E", "4E", "3E"],
			slam: ["7L20", "7E", "6L20", "6E", "5L15", "5E", "4L15", "4E", "3L15", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7E", "6E", "5E"],
			splash: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["7L2", "6L2", "5L7", "4L7", "3L6"],
			tickle: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L18", "4L18", "3L21"],
			waterpulse: ["6T", "4M", "3M"],
			watersport: ["7L5", "7E", "6L5", "6E", "5L5", "5E"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
		},
	},
	marill: {
		inherit: true,
		learnset: {
			amnesia: ["7E", "6E", "5E", "4E", "3E"],
			aquajet: ["7E", "6E", "5E", "5D", "4E"],
			aquaring: ["7L28", "6L28", "5L23", "4L23"],
			aquatail: ["7L20", "6T", "6L20", "5T", "5L37", "4T", "4L37"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bellydrum: ["7E", "6E", "5E", "4E", "3E"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "4E", "3T"],
			bounce: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubble: ["7L7", "6L7", "5L1"],
			bubblebeam: ["7L13", "6L13", "5L18", "4L18", "3L21"],
			camouflage: ["7E", "6E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			defensecurl: ["7L10", "6L10", "5L2", "5D", "4L2", "3T", "3L3"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7L37", "6L23", "5L27", "4L27", "3T", "3L28"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E", "6E", "5E", "4E", "3E"],
			grassknot: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["7L16", "6T", "6L16", "5T", "5L16", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L47", "6L40", "5L42", "4L42", "3L45"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "5D", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			muddywater: ["7E", "6E", "5E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			perishsong: ["7E", "6E", "5E", "4E", "3E"],
			playrough: ["7L23", "6L23"],
			poweruppunch: ["6M"],
			present: ["6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "7L31", "6M", "6L31", "5M", "5L32", "4M", "4L32", "3M", "3L36"],
			refresh: ["7E", "6E", "5E", "4E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["7L10", "6L10", "5L15", "4T", "4L15", "3T", "3L15"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			superpower: ["7L40", "7E", "6T", "6L37", "6E", "5T", "5L37", "5E", "4T", "4E"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L2", "6L2", "5L7", "4L7", "3L6"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L10", "4L10", "3L10"],
			waterpulse: ["6T", "4M", "3M"],
			watersport: ["7L5", "7E", "6L5", "6E", "5L5", "5E"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
		},
	},
	azumarill: {
		inherit: true,
		learnset: {
			aquaring: ["7L31", "6L31", "5L27", "4L27"],
			aquatail: ["7L21", "6T", "6L21", "5T", "5L47", "4T", "4L47"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubble: ["7L7", "6L7", "5L1"],
			bubblebeam: ["7L13", "6L13", "5L20", "4L20", "3L24"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			defensecurl: ["7L10", "6L10", "5L1", "4L1", "3T", "3L1"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7L42", "6L25", "5L33", "4L33", "3T", "3L34"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["7L16", "6T", "6L16", "5T", "5L16", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L55", "6L46", "5L54", "4L54", "3L57"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			playrough: ["7L25", "6L25"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "7L35", "6M", "6L35", "5M", "5L40", "4M", "4L40", "3M", "3L45"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["7L10", "6L10", "5L15", "4T", "4L15", "3T", "3L15"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["7L46", "6T", "6L42", "5T", "5L42", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L2", "7L1", "6L1", "5L1", "4L1", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			watersport: ["7L5", "7L1", "6L1", "5L1"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
		},
	},
	bonsly: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M", "4M"],
			block: ["7L29", "6T", "6L26", "5T", "5L22", "4T", "4L22"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			copycat: ["7L1", "6L1", "5L1", "4L1"],
			counter: ["7L36", "6L33"],
			covet: ["6T", "5T"],
			curse: ["7E", "6E", "5E"],
			defensecurl: ["7E", "6E", "5E", "4E"],
			dig: ["6M", "5M", "4M"],
			doubleedge: ["7L43", "6L40", "5L46", "4L46"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			endure: ["7E", "6E", "5E", "4M"],
			explosion: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			faketears: ["7L1", "6L1", "5L1", "4L1"],
			feintattack: ["7L19", "6L19", "5L25", "4L25"],
			flail: ["7L5", "6L5", "5L6", "4L6"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			harden: ["7E", "6E", "5E", "4E"],
			headbutt: ["7E", "6E", "5E", "4T", "4E"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			lowkick: ["7L8", "6T", "6L8", "5T", "5L9", "4T", "4L9"],
			mimic: ["7L15", "6L15", "5L17", "4L17"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L33", "6M", "6L29", "5M", "5L33", "4M", "4L33"],
			rockthrow: ["7L12", "6L12", "5L14", "4L14"],
			rocktomb: ["7M", "7L26", "6M", "6L22", "5M", "5L30", "4M", "4L30"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["7E", "6E", "5E", "4T", "4E"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			sandtomb: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			selfdestruct: ["7E", "6E", "5E", "4E"],
			slam: ["5L38", "4L38"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L40", "6L36", "5L41", "4T", "4L41"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			tearfullook: ["7L22"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
		},
	},
	sudowoodo: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			block: ["7L29", "6T", "6L26", "5T", "5L22", "4T", "4L22", "3L33"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			copycat: ["7L1", "6L1", "5L1", "4L1"],
			counter: ["7L36", "6L33", "5L33", "3T"],
			covet: ["6T", "5T"],
			curse: ["7E", "6E", "5E"],
			defensecurl: ["7E", "6E", "5E", "4E", "3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L43", "6L40", "5L46", "4L46", "3T", "3L57"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L19", "6L19", "5L25", "4L25", "3L41"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flail: ["7L5", "7L1", "6L1", "5L1", "5D", "4L1", "3L9"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hammerarm: ["7L50", "6L47", "5L49", "4L49"],
			harden: ["7E", "6E", "5E", "4E"],
			headbutt: ["7E", "6E", "5E", "4T", "4E"],
			headsmash: ["7L54"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			lowkick: ["7L8", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["7L15", "6L15", "5L17", "4L17", "3T", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L33", "6M", "6L29", "5M", "5L33", "4M", "4L33", "3T", "3L25"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L12", "7L1", "6L1", "5L1", "4L1", "3L1"],
			rocktomb: ["7M", "7L26", "6M", "6L22", "5M", "5L30", "4M", "4L30", "3M"],
			roleplay: ["6T", "5T", "5D", "4T"],
			rollout: ["7E", "6E", "5E", "5D", "4T", "4E", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			sandtomb: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["7E", "6E", "5E", "4E", "3T", "3E"],
			slam: ["7L1", "6L15", "5L38", "4L38", "3L49"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E", "4M"],
			stoneedge: ["7M", "7L47", "6M", "6L43", "5M", "5L43", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L40", "6L36", "5L41", "4T", "4L41"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			tearfullook: ["7L22"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			woodhammer: ["7L1", "6L1", "5L1", "4L1"],
		},
	},
	hoppip: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			amnesia: ["7E", "6E", "5E", "4E", "3E"],
			aromatherapy: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["7L46", "6T", "6L46", "5T", "5L46", "5D", "4T", "4L40"],
			bulletseed: ["7L19", "6L19", "5L19", "5D", "4M", "4L19", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7E", "6E", "5E", "4E", "3E"],
			cottonguard: ["7E", "6E", "5E"],
			cottonspore: ["7L34", "6L34", "5L34", "4L28", "3L25"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			encore: ["7E", "6E", "5E", "5D", "4E", "3E"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fairywind: ["7L10", "6L10"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7L43", "6T", "6L43", "5T", "5L43", "4M", "4L37", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grassyterrain: ["7E", "6E"],
			headbutt: ["4T"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			leechseed: ["7L22", "6L22", "5L22", "4L22", "3L20"],
			megadrain: ["7L25", "6L25", "5L25", "4L25", "3L30"],
			memento: ["7L49", "6L49", "5L49", "4L43"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["7L12", "6L12", "5L12", "4L12", "3L13"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4E", "3E"],
			ragepowder: ["7L31", "6L31", "5L31"],
			reflect: ["7M", "6M", "5M", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["7E", "6T", "6E", "5T", "5E", "4T"],
			silverwind: ["4M"],
			sleeppowder: ["7L16", "6L16", "5L16", "4L16", "3L17"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			splash: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			stunspore: ["7L14", "6L14", "5L14", "4L14", "3L15"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7L4", "6T", "6L4", "5T", "5L4", "5D", "4T", "4L4", "3L5"],
			tackle: ["7L8", "6L8", "5L10", "4L10", "3L10"],
			tailwhip: ["7L6", "6L6", "5L7", "4L7", "3L5"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uturn: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L31"],
			worryseed: ["7L40", "7E", "6T", "6L40", "6E", "5T", "5L40", "5E", "4T", "4L34", "4E"],
		},
	},
	skiploom: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L32", "6M", "6L32", "5M", "5L32"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["7L56", "6T", "6L56", "5T", "5L56", "4T", "4L48"],
			bulletseed: ["7L20", "6L20", "5L20", "4M", "4L20", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cottonspore: ["7L40", "6L40", "5L40", "4L32", "3L29"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fairywind: ["7L10", "6L10"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7L52", "6T", "6L52", "5T", "5L52", "4M", "4L44", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			leechseed: ["7L24", "6L24", "5L24", "4L24", "3L22"],
			megadrain: ["7L28", "6L28", "5L28", "4L28", "3L36"],
			memento: ["7L60", "6L60", "5L60", "4L52"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["7L12", "6L12", "5L12", "4L12", "3L13"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M"],
			ragepowder: ["7L36", "6L36", "5L36"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			sleeppowder: ["7L16", "6L16", "5L16", "4L16", "3L17"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			splash: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			stunspore: ["7L14", "6L14", "5L14", "4L14", "3L15"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7L4", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			tackle: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uturn: ["7M", "7L44", "6M", "6L44", "5M", "5L44", "4M", "4L36"],
			worryseed: ["7L48", "6T", "6L48", "5T", "5L48", "4T", "4L40"],
		},
	},
	jumpluff: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L34", "6M", "6L34", "5M", "5L34"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["7L64", "6T", "6L64", "5T", "5L64", "4T", "4L48"],
			bulletseed: ["7L20", "6L20", "5L20", "5S0", "4M", "4L20", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cottonspore: ["7L44", "6L44", "5L44", "4L32", "3L33"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fairywind: ["7L10", "6L10"],
			falseswipe: ["5S0"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7L59", "6T", "6L59", "5T", "5L59", "4M", "4L44", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			leechseed: ["7L24", "6L24", "5L24", "5S0", "4L24", "3L22"],
			megadrain: ["7L29", "6L29", "5L29", "4L28", "3L44"],
			memento: ["7L69", "6L69", "5L69", "4L52"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["7L12", "6L12", "5L12", "4L12", "3L13"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M"],
			ragepowder: ["7L39", "6L39", "5L39"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			sleeppowder: ["7L16", "6L16", "5L16", "5S0", "4L16", "3L17"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			splash: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			stunspore: ["7L14", "6L14", "5L14", "4L14", "3L15"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7L4", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			tackle: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uturn: ["7M", "7L49", "6M", "6L49", "5M", "5L49", "4M", "4L36"],
			worryseed: ["7L54", "6T", "6L54", "5T", "5L54", "4T", "4L40"],
		},
	},
	aipom: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L29", "7E", "6L29", "6E", "5L29", "5E", "4L29", "4E", "3L50", "3E"],
			astonish: ["7L8", "6L8", "5L8", "4L8", "3L13"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L11", "6L11", "5L11", "4L11", "3L18"],
			beatup: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			covet: ["7E", "6T", "6E", "5T", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublehit: ["7L32", "6L32", "5L32", "4L32"],
			doubleslap: ["7E", "6E", "5E", "4E", "3E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "5D", "4E"],
			firepunch: ["6T", "5T", "5D", "4T", "3T"],
			fling: ["7M", "7L36", "6M", "6L36", "5M", "5L36", "4M", "4L36"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L18", "6L18", "5L18", "4L18", "3L31"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["7L43", "6T", "6L43", "5T", "5L43", "4T", "4L43"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L39", "6L39", "5L39", "4L39"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			quickguard: ["7E", "6E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7E", "6E", "5E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L4", "6L4", "5L4", "4L4", "3L6", "3S0"],
			scratch: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			screech: ["7L25", "7E", "6L25", "6E", "5L25", "5E", "4L25", "4E", "3L43", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			slam: ["7E", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L22", "6L22", "5L22", "4T", "4L22", "3T", "3L38"],
			switcheroo: ["7E", "6E", "5E"],
			tailwhip: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			tickle: ["7L15", "6L15", "5L15", "4L15", "3L25"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M", "3M"],
			workup: ["7M", "5M"],
		},
	},
	ambipom: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M"],
			agility: ["7L29", "6L29", "5L29", "4L29"],
			astonish: ["7L8", "7L1", "6L1", "5L1", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			batonpass: ["7L11", "6L11", "5L11", "4L11"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doublehit: ["7L32", "6L32", "5L32", "4L32"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			dualchop: ["7L1"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "4T"],
			fling: ["7M", "7L36", "6M", "6L36", "5M", "5L36", "4M", "4L36"],
			focuspunch: ["6T", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["7L18", "6L18", "5L18", "4L18"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["7L43", "6T", "6L43", "5T", "5L43", "4T", "4L43"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			mudslap: ["4T"],
			nastyplot: ["7L39", "6L39", "5L39", "4L39"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L4", "7L1", "6L1", "5L1", "4L1"],
			scratch: ["7L1", "6L1", "5L1", "4L1"],
			screech: ["7L25", "6L25", "5L25", "4L25"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["7L22", "6L22", "5L22", "4T", "4L22"],
			tailwhip: ["7L1", "6L1", "5L1", "4L1"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			tickle: ["7L15", "6L15", "5L15", "4L15"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			workup: ["7M", "5M"],
		},
	},
	sunkern: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7E", "6E", "5E"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L37", "6L37", "5L37", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "5D", "4T"],
			encore: ["7E", "6E", "5E", "4E", "3E"],
			endeavor: ["7L25", "6T", "6L25", "5T", "5L21", "4T", "4L21", "3L25"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7L22", "6T", "6L22", "5T", "5L41", "4M", "4L41", "3M", "3L42"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["7L7", "7E", "6L7", "6E", "5L13", "5E", "4L13", "4E", "3E"],
			grassyterrain: ["7E", "6E"],
			growth: ["7L1", "6L1", "5L1", "4L1", "3L6", "3S0"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			ingrain: ["7L4", "7E", "6L4", "6E", "5L9", "5E", "4L9", "4E", "3L18"],
			leechseed: ["7L13", "7E", "6L13", "6E", "5L17", "5E", "4L17", "4E", "3E"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			megadrain: ["7L10", "6L10", "5L5", "5D", "4L5", "3L13"],
			mimic: ["3T"],
			morningsun: ["7E", "6E", "5E"],
			naturalgift: ["7L31", "7E", "6L31", "6E", "5L31", "5E", "4M"],
			naturepower: ["7M", "7E", "6M", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			razorleaf: ["7L16", "6L16", "5L29", "4L29"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["7L43", "6T", "6L43", "5T", "5L45", "4T", "4L45"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L34", "6M", "6L34", "5M", "5L34", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "7L40", "6M", "6L40", "5M", "5L37", "4M", "4L37", "3M", "3L30"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7E", "6E", "5E", "5D", "4E"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7L28", "6T", "6L28", "5T", "5L33", "4T", "4L33", "3L37"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			worryseed: ["7L19", "6T", "6L19", "5T", "5L25", "4T", "4L25"],
		},
	},
	sunflora: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bulletseed: ["7L25", "6L25", "5L21", "4M", "4L21", "3M", "3L25"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L37", "6L37", "5L37", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flowershield: ["7L1", "6L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7L22", "6T", "6L22", "5T", "5L22", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["7L7", "6L7", "5L13", "4L13"],
			growth: ["7L1", "6L1", "5L1", "4L1", "3L6"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			ingrain: ["7L4", "6L4", "5L9", "4L9", "3L18"],
			leafstorm: ["7L43", "6L43", "5L45", "4L43"],
			leechseed: ["7L13", "6L13", "5L17", "4L17"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			megadrain: ["7L10", "6L10", "5L5", "4L5"],
			mimic: ["3T"],
			naturalgift: ["7L31", "6L31", "5L31", "4M"],
			naturepower: ["7M", "6M"],
			petalblizzard: ["7L50", "6L50"],
			petaldance: ["7L28", "6L28", "5L33", "4L33", "3L37"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			razorleaf: ["7L16", "6L16", "5L29", "4L29", "3L13"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L34", "6M", "6L34", "5M", "5L41", "4M", "4L41", "3M", "3L42"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "7L40", "6M", "6L40", "5M", "5L37", "4M", "4L37", "3M", "3L30"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			worryseed: ["7L19", "6T", "6L19", "5T", "5L25", "4T", "4L25"],
		},
	},
	yanma: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["7L54", "6L54", "5L54", "4L54"],
			ancientpower: ["7L33", "6L33", "5L33", "4T", "4L33"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L57", "6L57", "5L57", "4L57"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			detect: ["7L17", "6L17", "5L17", "4L17", "3L25"],
			doubleedge: ["7E", "6E", "5E", "3T"],
			doubleteam: ["7M", "7L11", "6M", "6L11", "5M", "5L11", "4M", "4L11", "3M", "3L12"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7E", "6E", "5E", "5D", "4E"],
			feintattack: ["7E", "6E", "5E", "4E"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "5D", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypnosis: ["7L38", "6L38", "5L38", "4L38", "3L23"],
			leechlife: ["7E", "6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L30", "7E", "6L30", "6E", "5L30", "5E", "4L30", "4E"],
			quickattack: ["7L6", "6L6", "5L6", "5D", "4L6", "3L6"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7E", "6E", "5E", "4E", "3E"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			screech: ["7L46", "6L46", "5L46", "4L46", "3L49"],
			secretpower: ["7E", "6M", "6E", "5E", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			silverwind: ["7E", "6E", "5E", "4M", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			sonicboom: ["7L14", "6L14", "5L14", "4L14", "3L17"],
			steelwing: ["7M", "6M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L22", "6L22", "5L22", "4L22", "3L31"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["7L27", "6T", "6L27", "5T", "5L27", "4T", "4L27", "3L34"],
			uturn: ["7M", "7L49", "6M", "6L49", "5M", "5L49", "4M", "4L49"],
			whirlwind: ["7E", "6E", "5E", "4E", "3E"],
			wingattack: ["7L43", "6L43", "5L43", "4L43", "3L39"],
		},
	},
	yanmega: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			aircutter: ["4T"],
			airslash: ["7L54", "7L1", "6L1", "5L54", "4L49"],
			ancientpower: ["7L33", "6L33", "5L33", "4T", "4L33"],
			attract: ["7M", "6M", "5M", "4M"],
			bugbite: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			bugbuzz: ["7L57", "7L1", "6L1", "5L57", "4L54"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			detect: ["7L17", "6L17", "5L17", "4L17"],
			doubleteam: ["7M", "7L11", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			dreameater: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			feint: ["7L38", "6L38", "5L38", "4L38"],
			flash: ["6M", "5M", "4M"],
			foresight: ["7L1", "6L1", "5L1", "4L1"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["6T", "5T", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			leechlife: ["7M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["7L1", "6L1", "5L1", "4L1"],
			ominouswind: ["4T"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L30", "6L30", "5L30", "4L30"],
			quickattack: ["7L6", "7L1", "6L1", "5L1", "4L1"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			screech: ["7L46", "6L46", "5L46", "4L43"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			slash: ["7L43", "6L43", "5L43", "4L38"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			sonicboom: ["7L14", "6L14", "5L14", "4L14"],
			steelwing: ["7M", "6M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			supersonic: ["7L22", "6L22", "5L22", "4L22"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["7L27", "6T", "6L27", "5T", "5L27", "4T", "4L27"],
			uturn: ["7M", "7L49", "6M", "6L49", "5M", "5L49", "4M", "4L46"],
		},
	},
	wooper: {
		inherit: true,
		learnset: {
			acidspray: ["7E", "6E", "5E"],
			afteryou: ["7E", "6T", "6E", "5T", "5E"],
			amnesia: ["7L23", "6L23", "5L23", "4L23", "3L21"],
			ancientpower: ["7E", "6E", "5E", "4T", "4E", "3E"],
			aquatail: ["6T", "5T", "5D", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "5D", "4E", "3T", "3E"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doublekick: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L33", "6M", "6L33", "5M", "5L33", "4M", "4L33", "3M", "3L36"],
			eerieimpulse: ["7E", "6E"],
			encore: ["7E", "6E", "5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			guardswap: ["7E", "6E"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7L43", "6L43", "5L43", "4L43", "3L51"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T"],
			infestation: ["7M", "6M"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["3T"],
			mist: ["7L43", "6L43", "5L43", "4L43", "3L51"],
			mudbomb: ["7L19", "6L19", "5L19", "4L19"],
			muddywater: ["7L47", "6L47", "5L47", "4L47"],
			mudshot: ["7L9", "6L9", "5L9", "4L9", "3L16"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L5", "7E", "6L5", "6E", "5L5", "5E", "4L5", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L41"],
			recover: ["7E", "6E", "5E", "4E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4E", "3E"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			slam: ["7L15", "6L15", "5L15", "4L15", "3L11"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spitup: ["7E", "6E", "5E", "4E", "3E"],
			stockpile: ["7E", "6E", "5E", "4E", "3E"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7E", "6E", "5E", "4E", "3E"],
			tailwhip: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			yawn: ["7L29", "6L29", "5L29", "4L29", "3L31"],
		},
	},
	quagsire: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			amnesia: ["7L24", "6L24", "5L24", "4L24", "3L23"],
			ancientpower: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L36", "6M", "6L36", "5M", "5L36", "4M", "4L36", "3M", "3L42"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7L48", "6L48", "5L48", "4L48", "3L61"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T"],
			infestation: ["7M", "6M"],
			irontail: ["6T", "5T", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mist: ["7L48", "6L48", "5L48", "4L48", "3L61"],
			mudbomb: ["7L19", "6L19", "5L19", "4L19"],
			muddywater: ["7L53", "6L53", "5L53", "4L53"],
			mudshot: ["7L9", "6L9", "5L9", "4L9", "3L16"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L41", "3M", "3L49"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			slam: ["7L15", "6L15", "5L15", "4L15", "3L11"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tailwhip: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			yawn: ["7L31", "6L31", "5L31", "4L31", "3L35"],
		},
	},
	murkrow: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			assurance: ["7L25", "7E", "6L25", "6E", "5L25", "5E", "4L25"],
			astonish: ["7L1", "6L1", "5L1", "4L1", "3L9", "3S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bravebird: ["7E", "6E", "5E", "4E"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "5D", "4E", "3E"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			drillpeck: ["7E", "6E", "5E", "4E", "3E"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			featherdance: ["7E", "6E", "5E", "4E", "3E"],
			feintattack: ["7L35", "7E", "6L35", "6E", "5L35", "5E", "4L35", "4E", "3L35"],
			flatter: ["7E", "6E"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			foulplay: ["7L45", "6T", "6L45", "5T", "5L45"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7L11", "6L11", "5L11", "4L11", "3L22"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			meanlook: ["7L41", "6L41", "5L41", "4L41", "3L48"],
			mimic: ["3T"],
			mirrormove: ["7E", "6E", "5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["7L21", "6L21", "5L21", "4L21", "3L27"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			peck: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			perishsong: ["7E", "6E", "5E", "4E", "3E"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychoshift: ["7E", "6E", "5E", "4E"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			pursuit: ["7L5", "6L5", "5L5", "4L5", "3L14"],
			quash: ["7M", "7L65", "6M", "6L65", "5M", "5L65"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E", "5D", "4M"],
			round: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			skyattack: ["7E", "6T", "6E", "5T", "5E", "4E", "3T", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "3T"],
			spite: ["6T", "5T", "4T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L55", "6L55", "5L55", "4T", "4L45"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["7L50", "6T", "6L50", "5T", "5L51", "4T"],
			taunt: ["7M", "7L31", "6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L40"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "7L61", "6M", "6L61", "5M", "5L61", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["6T", "5T", "4T"],
			whirlwind: ["7E", "6E", "5E", "4E", "3E"],
			wingattack: ["7L15", "7E", "6L15", "6E", "5L15", "5E", "4L15", "4E", "3E"],
		},
	},
	honchkrow: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			aircutter: ["4T"],
			astonish: ["7L1", "6L1", "5L1", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			darkpulse: ["7M", "7L75", "6M", "6L75", "5T", "5L75", "4M", "4L55"],
			defog: ["4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "6M", "5M", "4M"],
			foulplay: ["7L45", "6T", "6L45", "5T", "5L45"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			haze: ["7L1", "6L1", "5L1", "4L1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			mudslap: ["4T"],
			nastyplot: ["7L35", "6L35", "5L35", "4L35"],
			naturalgift: ["4M"],
			nightslash: ["7L55", "7L1", "6L1", "5L55", "4L45"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L1", "6L1", "5L1", "4L1"],
			quash: ["7M", "7L65", "6M", "6L65", "5M", "5L65"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			skyattack: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T"],
			spite: ["6T", "5T", "4T"],
			steelwing: ["7M", "6M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L1", "6L1", "4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "4M", "4L25"],
			swift: ["4T"],
			tailwind: ["6T", "5T", "4T"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uproar: ["6T", "5T", "4T"],
			wingattack: ["7L1", "6L1", "5L1", "4L1"],
		},
	},
	misdreavus: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			astonish: ["7L10", "6L10", "5L10", "4L10", "3L11"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L14", "6L14", "5L14", "4L14", "3L17"],
			curse: ["7E", "6E", "5E", "4E"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			destinybond: ["7E", "6E", "5E", "5D", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			grudge: ["7L50", "6L50", "5L50", "4L46", "3L53"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			hex: ["7L23", "6L23", "5L23"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icywind: ["6T", "5T", "4T"],
			imprison: ["7E", "6E", "5E", "4E", "3E"],
			inferno: ["5D"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			meanlook: ["7L19", "6L19", "5L19", "4L19", "3L23"],
			mefirst: ["7E", "6E"],
			memento: ["7E", "6E", "5E", "4E"],
			mimic: ["3T"],
			nastyplot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["7E", "6E", "5E", "4T", "4E"],
			painsplit: ["7L32", "6T", "6L32", "5T", "5L32", "4T", "4L28", "3L37"],
			payback: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L32"],
			perishsong: ["7L46", "6L46", "5L46", "4L41", "3L45"],
			powergem: ["7L55", "6L55", "5L55", "4L50"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L28", "6L28", "5L28", "4L23", "3L30"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			psywave: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L37", "3M"],
			shadowsneak: ["7E", "6E", "5E", "4E"],
			shockwave: ["6T", "4M", "3M"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["7L5", "7E", "6T", "6L5", "6E", "5T", "5L5", "5E", "4T", "4L5", "4E", "3L6", "3S0"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7E", "6E", "5E", "4T", "4E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
			wonderroom: ["7E", "6T", "6E", "5T", "5E"],
		},
	},
	mismagius: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			astonish: ["7L1", "6L1", "5L1", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			icywind: ["6T", "5T", "4T"],
			luckychant: ["7L1", "6L1", "5L1", "4L1"],
			magicalleaf: ["7L1", "6L1", "5L1", "4L1"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mysticalfire: ["7L1", "6L1"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			phantomforce: ["7L1", "6L1"],
			powergem: ["7L1", "6L1"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psywave: ["7L1", "6L1", "5L1", "4L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			taunt: ["7M", "6M", "5M", "4M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
		},
	},
	unown: {
		inherit: true,
		learnset: {
			hiddenpower: ["7M", "7L1", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	wynaut: {
		inherit: true,
		learnset: {
			charm: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			counter: ["7L15", "6L15", "5L15", "4L15", "3L15"],
			destinybond: ["7L15", "6L15", "5L15", "4L15", "3L15"],
			encore: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			mirrorcoat: ["7L15", "6L15", "5L15", "4L15", "3L15"],
			safeguard: ["7M", "7L15", "6M", "6L15", "5L15", "4L15", "3L15"],
			splash: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			tickle: ["3S0"],
		},
	},
	wobbuffet: {
		inherit: true,
		learnset: {
			charm: ["5D"],
			counter: ["7L1", "6L1", "6S2", "6S3", "5L1", "4L1", "3L1", "3S0", "3S1"],
			destinybond: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			encore: ["5D"],
			mirrorcoat: ["7L1", "6L1", "6S3", "5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			safeguard: ["7M", "7L1", "6M", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
		},
	},
	girafarig: {
		inherit: true,
		learnset: {
			agility: ["7L23", "6L14", "5L14", "4L14", "3L31"],
			amnesia: ["7E", "6E", "5E", "4E", "3E"],
			assurance: ["7L10", "6L10", "5L28", "4L28"],
			astonish: ["7L1", "6L1", "5L1", "4L1", "3L7"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L41", "6L23", "5L23", "4L23", "3L37"],
			beatup: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "5D", "4L1", "3L13"],
			crunch: ["7L37", "6L37", "5L46", "4L46", "3L49"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["3T"],
			doublehit: ["7L28", "6L28", "5L32", "4L32"],
			doublekick: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E", "6E", "5E", "4E", "3E"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			guardswap: ["7L1", "6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			meanlook: ["7E", "6E", "5E"],
			mimic: ["3T"],
			mirrorcoat: ["7E", "6E", "5E", "5D", "4E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L46", "6L46"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["7L5", "6L5", "5L5", "4L5", "3L25"],
			powerswap: ["7L1", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L19", "6L19", "5L19", "4L19", "3L43"],
			psychic: ["7M", "7L50", "6M", "6L37", "5M", "5L37", "4M", "4L37", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7E", "6E", "5E", "4E"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["7E", "6M", "6E", "5E", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "5D", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stomp: ["7L14", "6L10", "5L10", "4L10", "3L19"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7E", "6E", "5E", "4E", "3E"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			wish: ["7E", "6E", "5E", "4E", "3E"],
			workup: ["7M", "5M"],
			zenheadbutt: ["7L32", "6T", "6L32", "5T", "5L41", "4T", "4L41"],
		},
	},
	pineco: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7L20", "6L20", "5L20", "4L17", "3L29"],
			bodyslam: ["3T"],
			bugbite: ["7L9", "6T", "6L9", "5T", "5L9", "4T", "4L9"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E", "3S1"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L45", "7E", "6L45", "6E", "5L45", "5E", "4L42", "4E", "3T", "3L50"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drillrun: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			explosion: ["7M", "7L34", "6M", "6L34", "5M", "5L34", "4M", "4L31", "3T", "3L36"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gravity: ["6T", "5T", "5D", "4T"],
			gyroball: ["7M", "7L42", "6M", "6L42", "5M", "5L42", "4M", "4L39"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			irondefense: ["7L39", "6T", "6L39", "5T", "5L39", "4T", "4L34"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["7L23", "6L23", "5L23", "4M", "4L20"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "7L31", "6M", "6L31", "5M", "5L31", "4M", "4L28"],
			pinmissile: ["7E", "6E", "5E", "4E", "3E", "3S1"],
			powertrick: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1", "3S0"],
			rapidspin: ["7L17", "6L17", "5L17", "4L12", "3L22"],
			reflect: ["7M", "6M", "5M", "4M", "4E", "3M", "3E"],
			refresh: ["3S1"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7E", "6E", "5E", "4E"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			sandtomb: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7L6", "6L6", "5L6", "5D", "4L6", "3T", "3L8", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spikes: ["7L28", "6L28", "5L28", "4L23", "3L43", "3S1"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7E", "6E", "5E", "4E", "3E"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			takedown: ["7L12", "6L12", "5L12", "4L9", "3L15"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7E", "6E", "5E", "5D", "4E"],
			venoshock: ["7M", "6M", "5M"],
		},
	},
	forretress: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			autotomize: ["7L1", "6L32", "5L32"],
			bide: ["7L20", "6L20", "5L20", "4L17", "3L29"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			bugbite: ["7L9", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L50", "6L56", "5L56", "4L50", "3T", "3L59"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drillrun: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L36", "6M", "6L42", "5M", "5L42", "4M", "4L33", "3T", "3L39"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "7L46", "6M", "6L50", "5M", "5L50", "4M", "4L45"],
			headbutt: ["4T"],
			heavyslam: ["7L64", "7L1", "6L1", "5L70"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			irondefense: ["7L42", "6T", "6L46", "5T", "5L46", "4T", "4L38"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magnetrise: ["7L56", "7L1", "6T", "6L1", "5T", "5L60", "4T", "4L57"],
			mimic: ["3T"],
			mirrorshot: ["7L1", "6L31", "5L31", "4L31"],
			naturalgift: ["7L23", "6L23", "5L23", "4M", "4L20"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "7L32", "6M", "6L36", "5M", "5L36", "4M", "4L28"],
			protect: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			rapidspin: ["7L17", "6L17", "5L17", "4L12", "3L22"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7L6", "7L1", "6L1", "5L1", "4L1", "3T", "3L1"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spikes: ["7L28", "6L28", "5L28", "4L23", "3L49"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L12", "6L12", "5L12", "4L1", "3L15"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7L1", "6L1", "5L1", "4L1"],
			venoshock: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			zapcannon: ["7L60", "7L1", "6L1", "5L64", "4L62", "3L31"],
		},
	},
	dunsparce: {
		inherit: true,
		learnset: {
			agility: ["7E", "6E", "5E", "4E"],
			airslash: ["7L41"],
			ancientpower: ["7L16", "7E", "6L19", "6E", "5L48", "5E", "4T", "4L41", "4E", "3E"],
			aquatail: ["6T", "5T", "4T"],
			astonish: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7E", "6E", "5E", "4E", "3E"],
			bind: ["6T", "5T"],
			bite: ["7E", "6E", "5E", "4E", "3E"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L18", "3T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			coil: ["7L28", "6L37", "5L43"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			defensecurl: ["7L1", "6L1", "5L4", "5D", "4L5", "3T", "3L4"],
			dig: ["7L31", "6M", "6L31", "5M", "5L53", "4M", "4L45", "3M"],
			doubleedge: ["7L36", "6L34", "5L34", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonrush: ["7L43"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			drillrun: ["7L21", "6T", "6L43", "5T", "5L43"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endeavor: ["7L38", "6T", "6L46", "5T", "5L58", "4T", "4L49", "3L41"],
			endure: ["7L46", "6L40", "5L40", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L48", "6L49", "5L63", "4L53", "3L44"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			glare: ["7L33", "6L28", "5L12", "4L13", "3L14"],
			gyroball: ["7M", "6M", "5M", "4M"],
			headbutt: ["7E", "6E", "5E", "4T", "4E", "3E"],
			hex: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			magiccoat: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			pursuit: ["7L8", "6L10", "5L24", "4L25", "3L24"],
			rage: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L3", "6L4", "5L16", "4T", "4L17", "3T", "3L21"],
			roost: ["7M", "7L23", "6M", "6L25", "5T", "5L33", "4M", "4L33"],
			round: ["7M", "6M", "5M"],
			screech: ["7L11", "6L13", "5L28", "4L29", "3L31"],
			secretpower: ["7E", "6M", "6E", "5E", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "3T"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["7L6", "6T", "6L7", "5T", "5L20", "4T", "4L21", "3L21"],
			stealthrock: ["6T", "5T", "5D", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7L26", "6L22", "5L38", "4L37", "3L34"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trumpcard: ["7E", "6E", "5E", "4E"],
			waterpulse: ["6T", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			yawn: ["7L13", "6L16", "5L8", "4L9", "3L11"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	gligar: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L22", "6M", "6L22", "5M", "5L27"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7E", "6E", "5E", "4E"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7E", "6E", "5E", "4E"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bugbite: ["6T", "5T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			crosspoison: ["7E", "6E", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			feint: ["7E", "6E", "5E", "5D", "4E"],
			feintattack: ["7L19", "6L19", "5L23", "4L23", "3L28"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L16", "6L16", "5L20", "4T", "4L20", "3T"],
			guillotine: ["7L55", "6L55", "5L49", "4L45", "3L52"],
			harden: ["7L7", "6L7", "5L9", "4L9", "3L13"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["7L10", "6T", "6L10", "5T", "5L12", "4T", "4L12"],
			metalclaw: ["7E", "6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["7E", "6E", "5E", "4E"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			poisontail: ["7E", "6E", "5E"],
			powertrick: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L13", "6L13", "5L16", "4L16", "3L20"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["7E", "6E", "5E"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L4", "6L4", "5L5", "5D", "4L5", "3L6", "3S0"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			sandtomb: ["7E", "6E", "5E", "4E", "3E"],
			screech: ["7L35", "6L35", "5L31", "4L27", "3L44"],
			secretpower: ["6M", "4M", "3M"],
			skyuppercut: ["7L45", "6L45", "5L45"],
			slash: ["7L27", "6L27", "5L34", "4L31", "3L36"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			steelwing: ["7M", "6M", "4M", "3M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "7L50", "6M", "6L50", "5M", "5L38", "4M", "4L34", "3T"],
			tailwind: ["6T", "5T", "5D", "4T"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uturn: ["7M", "7L30", "6M", "6L30", "5M", "5L42", "4M", "4L38"],
			venoshock: ["7M", "6M", "5M"],
			wingattack: ["7E", "6E", "5E", "4E", "3E"],
			xscissor: ["7M", "7L40", "6M", "6L40", "5M", "5L45", "4M", "4L42"],
		},
	},
	gliscor: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L22", "6M", "6L22", "5M", "5L27"],
			aerialace: ["7M", "6M", "5M", "4M"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M"],
			batonpass: ["4C"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brutalswing: ["7M"],
			bugbite: ["6T", "5T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			feintattack: ["7L19", "6L19", "5L23", "4L23"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["7L16", "6L16", "5L20", "4T", "4L20"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			guillotine: ["7L55", "7L1", "6L1", "5L49", "4L45"],
			harden: ["7L7", "7L1", "6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icefang: ["7L1", "6L1", "5L1", "4L1"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["7L10", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["7L27", "6L27", "5L34", "4L31"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["7M", "6M", "5M", "4M"],
			quickattack: ["7L13", "6L13", "5L16", "4L16"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L4", "7L1", "6L1", "5L1", "4L1"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			screech: ["7L35", "6L35", "5L31", "4L27"],
			secretpower: ["6M", "4M"],
			skyattack: ["6T", "5T", "4T"],
			skyuppercut: ["7L45", "6L45", "5L45"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			steelwing: ["7M", "6M", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "7L50", "6M", "6L50", "5M", "5L38", "4M", "4L34"],
			tailwind: ["6T", "5T", "4T"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uturn: ["7M", "7L30", "6M", "6L30", "5M", "5L42", "4M", "4L38"],
			venoshock: ["7M", "6M", "5M"],
			xscissor: ["7M", "7L40", "6M", "6L40", "5M", "5L45", "4M", "4L42"],
		},
	},
	snubbull: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L7", "6L7", "5L7", "4L7", "3L13"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			charm: ["7L1", "6L1", "5L1", "5D", "4L1", "3L8", "3S0"],
			closecombat: ["7E", "6E", "5E", "5D", "4E"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			crunch: ["7L49", "7E", "6L49", "6E", "5L49", "5E", "4L49", "4E", "3L53", "3E"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7E", "6E", "5E", "5D", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6E"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7L1", "7E", "6L1", "6E", "5L1", "5E", "4L1", "4E"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["7E", "6T", "6E", "5E", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["7L19", "6L19", "5L19", "4T", "4L19"],
			healbell: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icefang: ["7L1", "7E", "6L1", "6E", "5L1", "5E", "4L1", "4E"],
			icepunch: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lastresort: ["6T", "5T", "4T"],
			lick: ["7L13", "6L13", "5L13", "4L13", "3L19"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["7E", "6E", "5E", "4E", "3T", "3E"],
			mimic: ["7E", "6E", "5E", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			payback: ["7M", "7L43", "6M", "6L43", "5M", "5L43", "4M", "4L43"],
			playrough: ["7L37", "6L37"],
			poweruppunch: ["6M"],
			present: ["7E", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7L31", "6L31", "5L31", "4L31", "3L34"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L26"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			smellingsalts: ["7E", "6E", "5E", "4E", "3E"],
			snarl: ["7M", "6M", "5M"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			tailwhip: ["7L1", "6L1", "5L1", "4L1", "3L4", "3S0"],
			takedown: ["5L37", "4L37", "3L43"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L1", "7E", "6L1", "6E", "5L1", "5E", "4L1", "4E"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
		},
	},
	granbull: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L7", "6L7", "5L7", "4L7", "3L13"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			charm: ["7L1", "6L1", "5L1", "4L1", "3L8"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			crunch: ["7L59", "6L59", "5L59", "4L59", "3L61"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["7L19", "6L19", "5L19", "4T", "4L19"],
			healbell: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icefang: ["7L1", "6L1", "5L1", "4L1"],
			icepunch: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			lick: ["7L13", "6L13", "5L13", "4L13", "3L19"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["7L67", "7L1", "6T", "6L1", "5T", "5L67"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			payback: ["7M", "7L51", "6M", "6L51", "5M", "5L51", "4M", "4L51"],
			playrough: ["7L43", "6L43"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7L35", "6L35", "5L35", "4L35", "3L38"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L27", "6M", "6L27", "5M", "5L27", "4M", "4L27", "3M", "3L28"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L1", "6L1", "5L1", "4L1", "3L4"],
			takedown: ["5L43", "4L43", "3L49"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
		},
	},
	qwilfish: {
		inherit: true,
		learnset: {
			acidspray: ["7E", "6E", "5E"],
			aquajet: ["7E", "6E", "5E", "5D", "4E"],
			aquatail: ["7L45", "6T", "6L45", "5T", "5L45", "4T", "4L45"],
			astonish: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["7L33", "7E", "6L33", "6E", "5L33", "5E", "4M", "4L33"],
			bubble: ["7L13", "6L13"],
			bubblebeam: ["7E", "6E", "5E", "4E", "3E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defensecurl: ["3T"],
			destinybond: ["7L53", "7L1", "6L1", "5L53", "4L53", "3L45"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fellstinger: ["7L60", "7L1", "6L1"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7L9", "6L9", "5L9", "4L9", "3L9", "3S0"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L57", "7L1", "6L1", "5L57", "4L57", "3L37"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			mimic: ["3T"],
			minimize: ["7L9", "6L9", "5L9", "4L9", "3L9", "3S0"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			pinmissile: ["7L37", "6L37", "5L37", "4L37", "3L21"],
			poisonjab: ["7M", "7L49", "6M", "6L49", "5M", "5L49", "4M", "4L49", "4E"],
			poisonsting: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7L29", "6L29", "5L29", "4L29", "3L25"],
			rollout: ["7L17", "6L17", "5L17", "4T", "4L17", "3T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "5D", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spikes: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			spitup: ["7L25", "6L25", "5L25", "4L25"],
			stockpile: ["7L25", "6L25", "5L25", "4L25"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			takedown: ["7L41", "6L41", "5L41", "4L41", "3L33"],
			taunt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			toxicspikes: ["7L21", "6L21", "5L21", "4L21"],
			venoshock: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L13", "4L13", "3L13"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	shuckle: {
		inherit: true,
		learnset: {
			acid: ["7E", "6E", "5E"],
			acupressure: ["7E", "6E", "5E", "4E"],
			afteryou: ["6T", "5T"],
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7L1", "6L1", "5L1", "4L1", "3L28"],
			bind: ["6T", "5T"],
			bodyslam: ["3T"],
			bugbite: ["7L42", "6T", "6L42", "5T", "5L49", "4T", "4L40"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			constrict: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			encore: ["7L5", "6L5", "5L7", "5D", "4L9", "3L14", "3S1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			finalgambit: ["7E", "6E", "5E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["7L27", "6T", "6L27", "5T", "5L31", "4T", "4L35"],
			guardsplit: ["7L45", "6L45", "5L55"],
			gyroball: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			knockoff: ["7E", "6T", "6E", "5T", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["7E", "6E", "5E", "4T", "4E", "3T"],
			naturalgift: ["4M"],
			powersplit: ["7L45", "6L45", "5L55"],
			powertrick: ["7L31", "6L31", "5L43", "4L48"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L20", "6M", "6L20", "5M", "5L25", "4M", "4L27", "3M", "3L37"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7E", "6E", "5E"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L38", "6M", "6L38", "5M", "5L38", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L23", "6L23", "5L23"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L1", "6L1", "5L37", "4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L16", "6M", "6L16", "5M", "5L19", "4M", "4L14", "3M", "3L23"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			sandtomb: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			shellsmash: ["7L34", "6L34", "5L34", "5D"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			sludgewave: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stickyweb: ["7L53", "7L1", "6L1"],
			stoneedge: ["7M", "7L49", "6M", "6L49", "5M", "5L49", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["7L12", "6M", "6L12", "5M", "5L1"],
			substitute: ["7M", "6M", "5M", "4M", "3T", "3S1"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			venoshock: ["7M", "6M", "5M"],
			withdraw: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			wrap: ["7L9", "6L9", "5L13", "4L22", "3L9", "3S0"],
		},
	},
	heracross: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L10", "6M", "6L10", "5M", "5L13", "4M", "4L13"],
			armthrust: ["7L1", "6L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "7L28", "6M", "6L25", "5M", "5L19", "4M", "4L19", "3M", "3L23"],
			brutalswing: ["7M"],
			bugbite: ["6T", "5T", "4T"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["7L1", "6L1", "6S0", "6S1"],
			captivate: ["4M"],
			chipaway: ["7L16", "6L16", "5L16"],
			closecombat: ["7L43", "6L34", "6S0", "5L37", "4L37"],
			confide: ["7M", "6M"],
			counter: ["7L19", "6L19", "5L25", "4L25", "3T", "3L30"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "6S1", "5M", "4M", "3M"],
			endure: ["7L1", "6L1", "5L1", "4M", "4L1", "3T", "3L11"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4E", "3E"],
			feint: ["7L7", "6L7", "5L49", "4L49"],
			flail: ["7E", "6E", "5E", "5D", "4E", "3E"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["7E", "6T", "6E", "5E", "5D", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L25", "6L7", "5L7", "4L7", "3L17"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			harden: ["7E", "6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hornattack: ["7L1", "6L1", "5L1", "5D", "4L1", "3L6"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "5T", "4T"],
			megahorn: ["7L37", "7E", "6L37", "6E", "6S0", "5L55", "5E", "4L55", "3L53"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["7L1", "6L1", "5L1", "4L1"],
			pinmissile: ["7L31", "6L31", "6S0", "6S1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7E", "6E", "5E", "4E"],
			reversal: ["7L46", "6L43", "5L43", "4L43", "3L45"],
			rockblast: ["7E", "6E", "6S1"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7E", "6E", "5E", "3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L34", "6L28", "5L31", "4L31", "3L37"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			venoshock: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
		},
	},
	sneasel: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L20", "6L20", "5L24", "4L24", "3L36"],
			assist: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["7E", "6E", "5E", "4M"],
			beatup: ["7L28", "6L28", "5L42", "4L38", "3L57"],
			bite: ["7E", "6E", "5E", "4E", "3E"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			crushclaw: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublehit: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "4E", "3E"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			feint: ["7E", "6E", "5E"],
			feintattack: ["7L10", "6L10", "5L14", "4L14", "3L22"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L16", "6L16", "5L21", "4L21", "3L29"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["7L25", "6M", "6L25", "5M", "5L35"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3T"],
			iceshard: ["7L47", "7E", "6L47", "6E", "5L51", "5E", "4L49", "4E"],
			iciclecrash: ["7E", "6E"],
			icywind: ["7L14", "6T", "6L14", "5T", "5L28", "4T", "4L28", "3T", "3L43"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			lowkick: ["6T", "5T", "5D", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			metalclaw: ["7L22", "6L22", "5L49", "4L42", "3L64"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			punishment: ["7L44", "7E", "6L44", "6E", "5L44", "5E", "4E"],
			pursuit: ["7E", "6E", "5E", "4E"],
			quickattack: ["7L8", "6L8", "5L8", "4L8", "3L8", "3S0"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			screech: ["7L32", "6L32", "5L10", "4L10", "3L15"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L35", "6L35", "5L38", "4L35", "3L50"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["7L40", "6T", "6L40", "5T", "5L40", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "5D", "4M", "4L1", "3M", "3L1", "3S0"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			throatchop: ["7E"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			whirlpool: ["4M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	weavile: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			assurance: ["7L1", "6L1", "5L1", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "6S1", "5M", "4M", "4S0"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["7M", "7L47", "6M", "6L47", "5T", "5L51", "4M", "4L49"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			embargo: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fakeout: ["4S0"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			feintattack: ["7L10", "6L10", "5L14", "4L14"],
			fling: ["7M", "7L28", "6M", "6L28", "5M", "5L42", "4M", "4L38"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["7L16", "6L16", "5L21", "4L21"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["7L25", "6M", "6L25", "5M", "5L35"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "6S1", "5T", "4T"],
			iceshard: ["4S0"],
			icywind: ["7L14", "6T", "6L14", "5T", "5L28", "4T", "4L28"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			metalclaw: ["7L22", "6L22", "5L49", "4L42"],
			mudslap: ["4T"],
			nastyplot: ["7L20", "6L20", "5L24", "4L24"],
			naturalgift: ["4M"],
			nightslash: ["7L35", "6L35", "6S1", "5L35", "4L35", "4S0"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			punishment: ["7L44", "6L44"],
			quickattack: ["7L8", "7L1", "6L1", "5L1", "4L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			revenge: ["7L1", "6L1", "5L1", "4L1"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1"],
			screech: ["7L32", "6L32", "5L10", "4L10"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["7L40", "6T", "6L40", "5T", "5L40", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			thief: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			whirlpool: ["4M"],
			xscissor: ["7M", "6M", "6S1", "5M", "4M"],
		},
	},
	teddiursa: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			babydolleyes: ["7L1", "6L1"],
			bellydrum: ["7E", "6E", "5E", "4E"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			charm: ["7L36", "6L36", "5L36", "4L36"],
			chipaway: ["7E", "6E", "5E"],
			closecombat: ["7E", "6E", "5E", "4E"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			covet: ["7L1", "6T", "6L1", "5T", "5L1", "4L1"],
			crosschop: ["7E", "6E", "5E", "4E"],
			crunch: ["7E", "6E", "5E", "5D", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7L1", "7E", "6L1", "6E", "5L1", "5E", "5D", "4L1", "4E", "3L19", "3E"],
			feintattack: ["7L15", "6L15", "5L15", "4L15", "3L25"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fling: ["7M", "7L57", "7L1", "6M", "6L1", "5M", "5L57", "4M", "4L57"],
			focuspunch: ["6T", "5D", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L8", "6L8", "5L8", "4L8", "3L13"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["6T", "5T"],
			icepunch: ["6T", "5T", "4T", "3T"],
			lastresort: ["6T", "5T", "4T"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			lick: ["7L1", "6L1", "5L1", "4L1", "3L7", "3S0", "3S1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["7E", "6E", "5E", "4E", "3E", "3S1"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["7E", "6E", "5E", "4E"],
			payback: ["7M", "6M", "5M", "4M"],
			playnice: ["7L25", "6L25"],
			playrough: ["7E", "6E"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S1"],
			rest: ["7M", "7L43", "6M", "6L43", "5M", "5L43", "4M", "4L43", "3M", "3L31"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["7E", "6E", "5E", "4E", "3T", "3E"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L29", "6L29", "5L29", "4L29", "3L37"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			snore: ["7L43", "6T", "6L43", "5T", "5L43", "4T", "4L43", "3T", "3L43"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L22", "6L22", "5L22", "4L22"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7E", "6E", "5E", "4E", "3E"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L50", "6L50", "5L50", "4L50", "3L49"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			workup: ["7M", "5M"],
			yawn: ["7E", "6E", "5E", "4E", "3E"],
		},
	},
	ursaring: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["7L1", "6T", "6L1", "5T", "5L1", "4L1"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7L1", "6L1", "5L1", "4L1", "3L19"],
			feintattack: ["7L15", "6L15", "5L15", "4L15", "3L25"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L8", "6L8", "5L8", "4L8", "3L1"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gunkshot: ["6T", "5T", "4T"],
			hammerarm: ["7L67", "7L1", "6L1", "5L67", "4L67"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icepunch: ["6T", "5T", "4T", "3T"],
			lastresort: ["6T", "5T", "4T"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lick: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			playnice: ["7L25", "6L25"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L47", "6M", "6L47", "5M", "5L47", "4M", "4L47", "3M", "3L31"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L38", "6L38", "5L38", "4L38"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L29", "6L29", "5L29", "4L29", "3L37"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["7L49", "6T", "6L49", "5T", "5L49", "4T", "4L49", "3T", "3L43"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L22", "6L22", "5L22", "4L22"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L58", "6L58", "5L58", "4L58", "3L49"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			workup: ["7M", "5M"],
		},
	},
	slugma: {
		inherit: true,
		learnset: {
			acidarmor: ["7E", "6E", "5E", "4E", "3E"],
			afteryou: ["6T", "5T"],
			amnesia: ["7L36", "6L32", "5L32", "4L31", "3L29"],
			ancientpower: ["7L22", "6L22", "5L28", "4T", "4L26"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L41", "6L41", "5L46", "4L46", "3T", "3L50"],
			captivate: ["4M"],
			clearsmog: ["7L20", "6L20"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "4E"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["7L50", "7E", "6T", "6L50", "6E", "5T", "5L55", "5E", "4T", "4L56"],
			ember: ["7L6", "6L5", "5L5", "5D", "4L8", "3L8"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flameburst: ["7L27", "6L23", "5L23"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L48", "6M", "6L48", "5M", "5L50", "4M", "4L53", "3M", "3L36"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			guardswap: ["7E", "6E"],
			harden: ["7L13", "6L13", "5L14", "4L16", "3L22"],
			heatwave: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["7L15", "6M", "6L15", "5M"],
			inferno: ["7E", "6E", "5E", "5D"],
			infestation: ["7M", "6M"],
			irondefense: ["6T", "5T", "4T"],
			lavaplume: ["7L34", "6L34", "5L37", "4L38"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			memento: ["7E", "6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L43", "6L19", "5L19", "4L23"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "7L29", "6M", "6L29", "5M", "5L41", "4M", "4L41", "3T", "3L43"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L8", "6L8", "5L10", "4L11", "3L15"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["7E", "6E", "5E", "4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smog: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			smokescreen: ["7E", "6E", "5E", "4E"],
			snore: ["6T", "5T", "4T", "3T"],
			spitup: ["7E", "6E", "5E", "4E"],
			stockpile: ["7E", "6E", "5E", "4E"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			yawn: ["7L1", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	magcargo: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			amnesia: ["7L36", "6L32", "5L32", "4L31", "3L29"],
			ancientpower: ["7L22", "6L22", "5L28", "4T", "4L26"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L43", "6L43", "5L52", "4L52", "3T", "3L60"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			clearsmog: ["7L20", "6L20"],
			confide: ["7M", "6M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["7L58", "7L1", "6T", "6L1", "5T", "5L67", "4T", "4L66"],
			earthquake: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			ember: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flameburst: ["7L27", "6L23", "5L23"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L54", "6M", "6L54", "5M", "5L59", "4M", "4L61", "3M", "3L36", "3S0"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			harden: ["7L13", "6L13", "5L14", "4L16", "3L22"],
			heatwave: ["6T", "5T", "4T", "3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["7L15", "6M", "6L15", "5M"],
			infestation: ["7M", "6M"],
			irondefense: ["6T", "5T", "4T"],
			lavaplume: ["7L34", "6L34", "5L37", "4L40"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L47", "6L19", "5L19", "4L23"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L29", "6M", "6L29", "5M", "5L44", "4M", "4L45", "3T", "3L48"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shellsmash: ["7L1", "6L38", "5L38"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			smog: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			yawn: ["7L1", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	swinub: {
		inherit: true,
		learnset: {
			amnesia: ["7L48", "6L48", "5L49", "4L49", "3L55"],
			ancientpower: ["7E", "6E", "5E", "5D", "4T", "4E", "3E", "3S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["7E", "6E", "5E"],
			bite: ["7E", "6E", "5E", "4E", "3E"],
			blizzard: ["7M", "7L44", "6M", "6L44", "5M", "5L44", "4M", "4L44", "3M", "3L46"],
			bodyslam: ["7E", "6E", "5E", "4E", "3T", "3E"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			charm: ["3S0"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "4E"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L37", "3M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["7L14", "6L14", "5L16", "4M", "4L16", "3T", "3L19"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7E", "6E", "5E", "4E"],
			flail: ["7L40", "6L40", "5L40"],
			freezedry: ["7E", "6E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			iceshard: ["7L24", "6L24", "5L28", "4L28"],
			iciclecrash: ["7E", "6E", "5E"],
			iciclespear: ["7E", "6E", "5E", "5D", "4E", "3E"],
			icywind: ["7L21", "6T", "6L21", "5T", "5L25", "4T", "4L25", "3T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mist: ["7L35", "6L35", "5L40", "4L40", "3L37", "3S0"],
			mudbomb: ["7L18", "6L18", "5L20", "4L20"],
			mudshot: ["7E", "6E", "5E", "4E", "3E", "3S0"],
			mudslap: ["7L11", "6L11", "5L13", "4T", "4L13", "3T"],
			mudsport: ["7L5", "6L5", "5L4", "4L4"],
			naturalgift: ["4M"],
			odorsleuth: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			powdersnow: ["7L8", "6L8", "5L8", "4L8", "3L10"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L28", "7E", "6L28", "6E", "5L32", "5E", "4L32", "4E", "3L28", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
		},
	},
	piloswine: {
		inherit: true,
		learnset: {
			amnesia: ["7L58", "6L58", "5L65", "4L65", "3L70"],
			ancientpower: ["7L1", "6L1", "5L1", "4T", "4L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["7M", "7L52", "6M", "6L52", "5M", "5L56", "4M", "4L56", "3M", "3L56"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L46", "6M", "6L46", "5M", "5L40", "4M", "4L40", "3M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["7L14", "6L14", "5L16", "4M", "4L16", "3T", "3L1"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L1", "6L33", "5L33", "4L33", "3L33"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hornattack: ["3L1"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7L24", "6L24", "5L28", "4L28"],
			icywind: ["7L21", "6T", "6L21", "5T", "5L25", "4T", "4L25", "3T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mist: ["7L37", "6L37", "5L48", "4L48", "3L42"],
			mudbomb: ["7L18", "6L18", "5L20", "4L20"],
			mudslap: ["7L11", "6L11", "5L13", "4T", "4L13", "3T"],
			mudsport: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			odorsleuth: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			peck: ["7L1", "6L1", "5L1", "4L1"],
			powdersnow: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7L28", "6L28", "5L32", "4L32", "3L28"],
			thrash: ["7L41", "6L41", "5L41"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
		},
	},
	mamoswine: {
		inherit: true,
		learnset: {
			ancientpower: ["7L1", "6L1", "5L1", "4T", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["7M", "7L52", "6M", "6L52", "5M", "5L56", "4M", "4L56"],
			block: ["6T", "5T", "4T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M", "4M"],
			doublehit: ["7L33", "6L33", "5L33", "5S0", "4L33"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L46", "6M", "6L46", "6S1", "5M", "5L40", "4M", "4L40"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["7L14", "6L14", "5L16", "4M", "4L16"],
			facade: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furyattack: ["7L1"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "7L21", "6M", "6L21", "5M", "5L25", "5S0", "4M", "4L25"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icefang: ["7L24", "6L24", "5L28", "5S0", "4L28"],
			iciclecrash: ["6S1"],
			iciclespear: ["6S1"],
			icywind: ["6T", "5T", "4T"],
			ironhead: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			mist: ["7L37", "6L37", "5L48", "4L48"],
			mudbomb: ["7L18", "6L18", "5L20", "4L20"],
			mudslap: ["7L11", "6L11", "5L13", "4T", "4L13"],
			mudsport: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			odorsleuth: ["7L1", "6L1", "5L1", "4L1"],
			peck: ["7L1", "6L1", "5L1", "4L1"],
			powdersnow: ["7L8", "7L1", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "6S1", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			scaryface: ["7L58", "7L1", "6L1", "5L65", "4L65"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M"],
			takedown: ["7L28", "6L28", "5L32", "5S0", "4L32"],
			thrash: ["7L41", "6L41", "5L41"],
			toxic: ["7M", "6M", "5M", "4M"],
		},
	},
	corsola: {
		inherit: true,
		learnset: {
			amnesia: ["7E", "6E", "5E", "4E", "3E"],
			ancientpower: ["7L17", "6L17", "5L32", "4T", "4L32", "3L45"],
			aquaring: ["7L38", "7E", "6L38", "6E", "5L37", "5E", "4L37", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7E", "6E", "5E"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["7L27", "6L27", "4M"],
			bubble: ["7L4", "6L4", "5L8", "5D", "4L8", "3L12"],
			bubblebeam: ["7L10", "6L10", "5L25", "4L25", "3L23"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			camouflage: ["7E", "6E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "5D", "4E", "3E"],
			curse: ["7E", "6E", "5E", "4E"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["7L47", "6T", "6L47", "5T", "5L53", "4T", "4L53"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["7L35", "6L35", "5L35", "4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L50", "6L50", "5L52"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7L1", "6L1", "5L4", "4L4", "3L6"],
			headbutt: ["4T"],
			headsmash: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			iciclespear: ["7E", "6E", "5E", "4E", "3E"],
			icywind: ["6T", "5T", "4T"],
			ingrain: ["7E", "6E", "5E", "4E", "3E"],
			irondefense: ["7L29", "6T", "6L29", "5T", "5L29"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			liquidation: ["7E"],
			luckychant: ["7L23", "6L23", "5L28", "4L28"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mirrorcoat: ["7L45", "6L45", "5L48", "4L48", "3L39"],
			mist: ["7E", "6E", "5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S0"],
			naturalgift: ["4M"],
			naturepower: ["7M", "7E", "6M", "6E", "5E", "4E"],
			powergem: ["7L41", "6L41", "5L44", "4L44"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L8", "6L8", "5L13", "4L13", "3L17"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7L13", "6L13", "5L16", "4L16", "3L17"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L31", "6L31", "5L20", "4L20", "3L34"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spikecannon: ["7L20", "6L20", "5L40", "4L40", "3L28"],
			stealthrock: ["6T", "5T", "5D", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	remoraid: {
		inherit: true,
		learnset: {
			acidspray: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7L14", "7E", "6L14", "6E", "5L14", "5E", "4L14", "4E", "3L22", "3E"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["5D", "4M"],
			bubblebeam: ["7L18", "6L18", "5L19", "4L19", "3L22"],
			bulletseed: ["7L38", "6L38", "5L27", "4M", "4L27"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			defensecurl: ["3T"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			entrainment: ["7E", "6E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7E", "6E", "5E", "4E"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			focusenergy: ["7L22", "6L22", "5L23", "4L23", "3L33"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gunkshot: ["6T", "5T", "4T"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L42", "6L42", "5L42"],
			hyperbeam: ["7M", "7L46", "6M", "6L46", "5M", "5L45", "4M", "4L45", "3M", "3L55"],
			icebeam: ["7M", "7L34", "6M", "6L34", "5M", "5L40", "4M", "4L40", "3M", "3L44"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			lockon: ["7L6", "6L6", "5L6", "5D", "4L6", "3L11"],
			mimic: ["3T"],
			mudshot: ["7E", "6E", "5E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			octazooka: ["7E", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L10", "6L10", "5L10", "4L10", "3L22"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7E", "6E", "5E", "5D", "4E", "3E"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			signalbeam: ["7L30", "6T", "6L30", "5T", "5L36", "4T", "4L36"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T"],
			soak: ["7L50", "6L50", "5L49"],
			stringshot: ["4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7E", "6E", "5E", "4T", "3T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["7L26", "7E", "6T", "6L26", "6E", "5L32", "5E", "4M", "4L32", "3M"],
			waterspout: ["7E", "6E", "5E", "4E"],
			whirlpool: ["4M"],
		},
	},
	octillery: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7L14", "7L1", "6L1", "5L1", "4L1", "3L22"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["4M"],
			bubblebeam: ["7L18", "6L18", "5L19", "4L19", "3L22"],
			bulletseed: ["7L46", "6L46", "5L29", "4M", "4L29", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			constrict: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L11"],
			defensecurl: ["3T"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L22", "6L22", "5L23", "4L23", "3L38"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gunkshot: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L52", "6L52", "5L52"],
			hyperbeam: ["7M", "7L58", "6M", "6L58", "5M", "5L55", "4M", "4L55", "4S0", "3M", "3L70"],
			icebeam: ["7M", "7L40", "6M", "6L40", "5M", "5L48", "4M", "4L48", "4S0", "3M", "3L54"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			octazooka: ["7L1", "6L25", "5L25", "4L25", "4S0", "3L25"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L10", "7L1", "6L1", "5L1", "4L1", "3L22"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L1", "6L1", "5L1", "4L1"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["3T"],
			signalbeam: ["7L34", "6T", "6L34", "5T", "5L42", "4T", "4L42", "4S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7L64", "6L64", "5L61"],
			stringshot: ["4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wringout: ["7L28", "6L28", "5L36", "4L36"],
		},
	},
	delibird: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7E", "6E", "5E", "4E", "3E"],
			auroraveil: ["7M"],
			avalanche: ["4M"],
			bestow: ["7E", "6E", "5E"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brutalswing: ["7M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defog: ["4M"],
			destinybond: ["7E", "6E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drillpeck: ["7L25"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "4E"],
			fling: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			focuspunch: ["6T", "5D", "4M", "3M"],
			freezedry: ["7E", "6E"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E", "6E", "5E", "4E", "3E"],
			gunkshot: ["6T", "5T", "4T"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			happyhour: ["6S1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			iceball: ["7E", "6E", "5E", "4E", "3E"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "4E"],
			iceshard: ["7E", "6E", "5E", "5D", "4E"],
			icywind: ["7E", "6T", "6E", "5T", "5E", "4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			poweruppunch: ["6M"],
			present: ["7L1", "6L1", "6S1", "5L1", "5D", "4L1", "3L1", "3S0"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7E", "6E", "5E", "4E", "3E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7E", "6E", "5E", "4E", "3E"],
			recycle: ["6T", "5T", "4M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["3T"],
			signalbeam: ["6T", "5T", "4T"],
			skyattack: ["6T", "5T", "4T", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "3T"],
			spikes: ["7E", "6E"],
			splash: ["7E", "6E", "5E", "4E", "3E"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
		},
	},
	mantyke: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M"],
			agility: ["7L32", "6L32", "5L19", "4L19"],
			aircutter: ["4T"],
			airslash: ["7L36", "6L36", "5L36"],
			amnesia: ["7E", "6E", "5E"],
			aquaring: ["7L39", "6L39", "5L46", "4L46"],
			attract: ["7M", "6M", "5M", "4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bounce: ["7L46", "6T", "6L46", "5T", "5L40", "4T", "4L40"],
			bubble: ["7L1", "6L1", "5L1", "4L1"],
			bubblebeam: ["7L7", "6L7", "5L10", "4L10"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L11", "6L11", "5L37", "4L37"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M"],
			haze: ["7E", "6E", "5E", "4E"],
			headbutt: ["7L16", "6L16", "5L13", "4T", "4L13"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hydropump: ["7L49", "7E", "6L49", "6E", "5L49", "5E", "4L49", "4E"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			mirrorcoat: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T"],
			mudsport: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4E"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E", "4E"],
			slam: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			splash: ["7E", "6E", "5E", "4E"],
			substitute: ["7M", "6M", "5M", "4M"],
			supersonic: ["7L3", "6L3", "5L4", "4L4"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			tailwind: ["7E", "6E"],
			takedown: ["7L27", "6L27", "5L31", "4L31"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["7E", "6E", "5E", "4E"],
			waterfall: ["7M", "6M", "5M", "4M"],
			waterpulse: ["7L19", "6T", "6L19", "5L28", "4M", "4L28"],
			watersport: ["7E", "6E", "5E", "4E"],
			whirlpool: ["4M"],
			wideguard: ["7L23", "7E", "6L23", "6E", "5L23", "5E"],
			wingattack: ["7L14", "6L14", "5L22", "4L22"],
		},
	},
	mantine: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L32", "6L32", "5L19", "4L19", "3L29"],
			aircutter: ["5D", "4T"],
			airslash: ["7L36", "6L36", "5L36"],
			amnesia: ["7E", "6E", "5E"],
			aquaring: ["7L39", "6L39", "5L46", "4L46"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["7L46", "6T", "6L46", "5T", "5L40", "4T", "4L40"],
			brine: ["4M"],
			bubble: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			bubblebeam: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L15"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["7L1", "6L1", "5L1", "4M", "4L1"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L11", "6L11", "5L37", "4L37", "3L50"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gunkshot: ["6T", "5T", "4T"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			headbutt: ["7L16", "6L16", "5L13", "4T", "4L13"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L49", "7E", "6L49", "6E", "5L49", "5E", "4L49", "4E", "3E"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			ironhead: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mirrorcoat: ["7E", "6E", "5E", "5D", "4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L1", "6L1", "5L1", "4L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3E"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roost: ["7M", "7L1"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			signalbeam: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			slam: ["7E", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			splash: ["7E", "6E", "5E", "4E"],
			stringshot: ["4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			supersonic: ["7L3", "7L1", "6L1", "5L1", "5D", "4L1", "3L8", "3S0"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7L27", "6L27", "5L31", "4L31", "3L22"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["7E", "6E", "5E", "4E", "3E"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["7L19", "6T", "6L19", "5L28", "4M", "4L28", "3M", "3L43"],
			watersport: ["7E", "6E", "5E", "4E"],
			whirlpool: ["4M"],
			wideguard: ["7L23", "7E", "6L23", "6E", "5L23", "5E"],
			wingattack: ["7L14", "6L14", "5L22", "4L22", "3L36"],
		},
	},
	skarmory: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L31", "6L12", "5L12", "4L12", "3L16"],
			aircutter: ["7L12", "6L12", "5L23", "4T", "4L23", "3L29"],
			airslash: ["7L45", "6L42", "5L42", "4L39"],
			assurance: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			autotomize: ["7L50", "6L39", "5L39"],
			bravebird: ["7E", "6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drillpeck: ["7E", "6E", "5E", "5D", "4E", "3E"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7L20", "6L20", "5L20", "4L20"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L17", "6L17", "5L17", "4L17", "3L26"],
			furycutter: ["4T"],
			guardswap: ["7E", "6E", "5E", "4E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			metalclaw: ["7L9", "6L9"],
			metalsound: ["7L42", "6L31", "5L31", "4L31", "3L45"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["7L53", "6L50", "5L50", "4L45"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			peck: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roost: ["7M", "6M", "5T", "5D", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L6", "6L6", "5L6", "4L6", "3L10"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			skydrop: ["7M", "6M", "5M"],
			slash: ["7L39", "6L39", "5L45", "4L42"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spikes: ["7L28", "6L28", "5L28", "4L27", "3L42"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E", "4M"],
			steelwing: ["7M", "7L34", "6M", "6L34", "5L34", "4M", "4L34", "3M", "3L32"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L23", "6L9", "5L9", "4T", "4L9", "3T", "3L13"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			tailwind: ["6T", "5T", "4T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["7E", "6E", "5E", "4E", "3E"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	houndour: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			beatup: ["7L25", "7E", "6L25", "6E", "5L25", "5E", "4L27", "4E", "3E"],
			bite: ["7L16", "6L16", "5L16", "4L17", "3L25"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["3S1"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			crunch: ["7L49", "6L49", "5L49", "4L48", "3L49"],
			darkpulse: ["7M", "6M", "5T", "5D", "4M"],
			destinybond: ["7E", "6E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			embargo: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L40"],
			ember: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7E", "6E", "5E", "5D", "4E"],
			feintattack: ["7L32", "6L32", "5L32", "4L35", "3L37", "3S1"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7L28", "7E", "6L28", "6E", "5L28", "5E", "4L30", "4E"],
			firespin: ["7E", "6E", "5E", "4E", "3E"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L44", "6M", "6L44", "5M", "5L44", "4M", "4L43", "3M", "3L43"],
			foulplay: ["7L40", "6T", "6L40", "5T", "5L40"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7L4", "6L4", "5L4", "5D", "4L4", "3L7", "3S0"],
			hypervoice: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			inferno: ["7L56", "6L56", "5L56"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L52", "7E", "6L52", "6E", "5L52", "5E", "4L53", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["7L20", "6L20", "5L20", "4L22", "3L31"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			punishment: ["7E", "6E", "5E", "4E"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			rage: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7E", "6E", "5E", "4E", "3E"],
			roar: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "4M", "4L14", "3M", "3L19", "3S1"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			smog: ["7L8", "6L8", "5L8", "4L9", "3L13"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7E", "6E", "5E", "4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7E", "6E", "5E", "4E"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			willowisp: ["7M", "6M", "5M", "4M", "4E", "3E"],
		},
	},
	houndoom: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			beatup: ["7L26", "6L26", "5L26", "4L28"],
			bite: ["7L16", "6L16", "5L16", "4L17", "3L27"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crunch: ["7L56", "6L56", "5L56", "4L54", "3L59"],
			darkpulse: ["7M", "6M", "6S0", "5T", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			embargo: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L44"],
			ember: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L35", "6L35", "5L35", "4L38", "3L43"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7L30", "6L30", "5L30", "4L32"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L50", "6M", "6L50", "6S0", "5M", "5L50", "4M", "4L48", "3M", "3L51"],
			foulplay: ["7L45", "6T", "6L45", "5T", "5L45"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			inferno: ["7L65", "7L1", "6L1", "5L65"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L60", "7L1", "6L1", "5L60", "4L60"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["7L20", "6L20", "5L20", "4L22", "3L35"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "4M", "4L14", "3M", "3L19"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "6S0", "5M", "4M", "3M"],
			smog: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L13"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "6S0", "5M", "4M", "3M"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	phanpy: {
		inherit: true,
		learnset: {
			ancientpower: ["7E", "6E", "5E", "4T", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "4E", "3T", "3E"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			charm: ["7L33", "6L33", "5L33", "4L33"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			defensecurl: ["7L1", "6L1", "5L1", "4L1", "3T", "3L9"],
			doubleedge: ["7L42", "6L42", "5L42", "4L42", "3T", "3L49"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			endure: ["7L19", "6L19", "5L28", "4M", "4L28", "3T", "3L41"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7E", "6E", "5E", "4E", "3E"],
			flail: ["7L6", "6L6", "5L6", "5D", "4L6", "3L17"],
			focusenergy: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			headsmash: ["7E", "6E", "5E", "4E"],
			heavyslam: ["7E", "6E", "5E", "5D"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			iceshard: ["7E", "6E", "5E", "4E"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["7L37", "6T", "6L37", "5T", "5L37", "4L37"],
			mimic: ["3T"],
			mudslap: ["7E", "6E", "5E", "4T", "3T"],
			naturalgift: ["7L15", "6L15", "5L19", "4M", "4L19"],
			odorsleuth: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			playrough: ["7E", "6E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L10", "6L10", "5L15", "4T", "4L15", "3T", "3L33"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "5D", "4T"],
			slam: ["7L24", "6L24", "5L24", "4L24"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L28", "6L10", "5L10", "4L10", "3L25"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
		},
	},
	donphan: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			assurance: ["7L15", "6L15", "5L31", "4L31"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "7L1", "6M", "6L1", "5M", "5L1"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defensecurl: ["7L1", "6L1", "5L1", "4L1", "3T", "3L9"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L43", "6M", "6L43", "5M", "5L46", "4M", "4L46", "3M", "3L49"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			flail: ["4L1", "3L17"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L1", "6L25", "5L25", "4L25", "3L25"],
			gigaimpact: ["7M", "7L50", "6M", "6L50", "5M", "5L54", "4M", "4L54"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			gunkshot: ["6T", "5T", "4T"],
			gyroball: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hornattack: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			irondefense: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["7L19", "6T", "6L10", "5T", "5L10", "4T", "4L10"],
			lastresort: ["6T", "5T"],
			magnitude: ["7L30", "6L19", "5L19", "4L19"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["3L1"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7L6", "6L6", "5L6", "4L6", "3L41"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L10", "6L10", "5L15", "4T", "4L15", "3T", "3L33"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scaryface: ["7L37", "6L37", "5L39", "4L39"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			slam: ["7L24", "6L24", "5L24", "4L24"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
		},
	},
	stantler: {
		inherit: true,
		learnset: {
			astonish: ["7L7", "6L7", "5L7", "4L7", "3L11"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L27", "6M", "6L27", "5M", "5L27", "4M", "4L27", "3M", "3L47"],
			captivate: ["7L50", "6L50", "5L53", "4M", "4L49"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L23", "6L23", "5L23", "4L23", "3L41"],
			disable: ["7E", "6E", "5E", "5D", "4E", "3E"],
			doubleedge: ["3T"],
			doublekick: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			extrasensory: ["7E", "6E", "5E", "4E", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypnosis: ["7L10", "6L10", "5L10", "4L10", "3L17"],
			imprison: ["7L49", "6L49", "5L49", "4L43"],
			irontail: ["6T", "5T", "4M", "3M"],
			jumpkick: ["7L43", "6L43", "5L43"],
			lastresort: ["6T", "5T", "4T"],
			leer: ["7L3", "6L3", "5L3", "4L3", "3L7", "3S0"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magicroom: ["6T", "5T"],
			mefirst: ["7L55", "7E", "7L1", "6L1", "6E", "5L55", "5E", "4L53"],
			megahorn: ["7E", "6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7E", "6E", "5E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			psyshock: ["7M", "6M", "5M"],
			rage: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["7L33", "6T", "6L33", "5T", "5L33", "4T", "4L33", "3L31"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L16", "6L16", "5L16", "4L16", "3L27"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "5D", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			stomp: ["7L13", "6L13", "5L13", "4L13", "3L21"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			takedown: ["7L21", "6L21", "5L21", "4L21", "3L37"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7E", "6E", "5E", "4E"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["7L38", "7E", "6T", "6L38", "6E", "5T", "5L38", "5E", "4T", "4L38", "4E"],
		},
	},
	smeargle: {
		inherit: true,
		learnset: {
			captivate: ["5D"],
			falseswipe: ["5S1"],
			meanlook: ["5S1"],
			odorsleuth: ["5S1"],
			sketch: ["7L91", "7L81", "7L71", "7L61", "7L51", "7L41", "7L31", "7L21", "7L11", "7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			sleeptalk: ["5D"],
			spore: ["5S1"],
		},
	},
	miltank: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "6S0", "5M", "4M", "3M"],
			belch: ["7E", "6E"],
			bide: ["7L15", "6L15", "5L15", "4L15", "3L26"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7L24", "6L24", "5L24", "4L24", "3T", "3L43"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["7L35", "6L35", "5L35", "4M", "4L35"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			curse: ["7E", "6E", "5E", "5D", "4E", "3E"],
			defensecurl: ["7L5", "6L5", "5L5", "5D", "4L5", "3T", "3L8"],
			dizzypunch: ["7E", "6E", "5E", "4E"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E", "4M", "4E", "3T", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L3", "6L3", "5L3", "4L3", "3L4"],
			gyroball: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L41"],
			hammerarm: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			healbell: ["7L48", "6T", "6L48", "5T", "5L48", "4T", "4L48", "3L53"],
			heartstamp: ["7E", "6E", "5E"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "5D", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			milkdrink: ["7L11", "6L11", "6S0", "5L11", "4L11", "3L19"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			poweruppunch: ["6M"],
			present: ["7E", "6E", "5E", "4E", "3E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			punishment: ["7E", "6E", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7E", "6E", "5E", "4E", "3E"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L19", "6L19", "6S0", "5L19", "4T", "4L19", "3T", "3L34"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7E", "6E", "5E", "4E", "3T", "3E"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stealthrock: ["6T", "5T", "4M"],
			stomp: ["7L8", "6L8", "6S0", "5L8", "4L8", "3L13"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			wakeupslap: ["7L50", "6L50", "5L55", "4L55"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["7L29", "6T", "6L29", "5T", "5L29", "4T", "4L29"],
		},
	},
	raikou: {
		inherit: true,
		learnset: {
			aurasphere: ["4S3"],
			bite: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L78", "6M", "6L78", "5M", "5L78", "4M", "4L78", "3M", "3L81"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			crunch: ["7L43", "6L43", "5L43", "4L43", "3L61", "3S1"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			discharge: ["7L57", "7L1", "6L1", "5L57", "4L57"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["7L64", "7L1", "6L1", "5L64", "4L64"],
			extremespeed: ["4S3"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magnetrise: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			quash: ["7M", "6M", "5M"],
			quickattack: ["7L22", "6L22", "5L22", "4L22", "4S2", "3L31", "3S0", "3S1"],
			raindance: ["7M", "7L71", "6M", "6L71", "5M", "5L71", "4M", "4L71", "3M"],
			reflect: ["7M", "7L36", "6M", "6L36", "5M", "5L36", "4M", "4L36", "4S2", "3M", "3L51", "3S1"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L15", "6M", "6L15", "5M", "5L15", "4M", "4L15", "4S2", "3M", "3L21", "3S0"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spark: ["7L29", "6L29", "5L29", "4L29", "4S2", "3L41", "3S0", "3S1"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["7M", "7L85", "6M", "6L85", "5M", "5L85", "4M", "4L71", "3M", "3L71"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L50", "6L50", "5L50", "4L50"],
			thundershock: ["7L8", "6L8", "5L8", "4L8", "3L11", "3S0"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			weatherball: ["4S3"],
			wildcharge: ["7M", "6M", "5M"],
			zapcannon: ["4S3"],
		},
	},
	entei: {
		inherit: true,
		learnset: {
			bite: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L78", "6M", "6L78", "5M", "5L78", "4M", "4L78", "3M", "3L81"],
			confide: ["7M", "6M"],
			crushclaw: ["4S3"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			ember: ["7L8", "6L8", "5L8", "4L8", "3L11", "3S0"],
			endure: ["4M", "3T"],
			eruption: ["7L85", "7L1", "6L1", "5L85", "4L85"],
			extrasensory: ["7L64", "7L1", "6L1", "5L64", "4L64"],
			extremespeed: ["4S3"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7L71", "6M", "6L71", "5M", "5L71", "4M", "4L71", "3M", "3L71"],
			firefang: ["7L50", "6L50", "5L50", "4L50"],
			firespin: ["7L22", "6L22", "5L22", "4L22", "4S2", "3L31", "3S0", "3S1"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L36", "6M", "6L36", "5M", "5L36", "4M", "4L36", "4S2", "3M", "3L51", "3S1"],
			flareblitz: ["4S3"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["4S3"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lavaplume: ["7L57", "7L1", "6L1", "5L57", "4L57"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L15", "6M", "6L15", "5M", "5L15", "4M", "4L15", "4S2", "3M", "3L21", "3S0"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sacredfire: ["7L1", "6L1"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stomp: ["7L29", "6L29", "5L29", "4L29", "4S2", "3L41", "3S0", "3S1"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L43", "6M", "6L43", "5M", "5L43", "4M", "4L43", "3T", "3L61", "3S1"],
			swift: ["4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	suicune: {
		inherit: true,
		learnset: {
			airslash: ["4S3"],
			aquaring: ["4S3"],
			aurorabeam: ["7L29", "6L29", "5L29", "4L29", "4S2", "3L41", "3S0", "3S1"],
			avalanche: ["4M"],
			bite: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			blizzard: ["7M", "7L85", "6M", "6L85", "5M", "5L85", "4M", "4L85", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bubblebeam: ["7L8", "7L1", "6L8", "5L8", "4L8", "3L11", "3S0"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L78", "6M", "6L78", "5M", "5L78", "4M", "4L78", "3M", "3L81"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["7L64", "6L1", "5L64", "4L64"],
			extremespeed: ["4S3"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L22", "6L22", "5L22", "4L22", "4S2", "3L31", "3S0", "3S1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L71", "6L1", "5L71", "4L71", "3L71"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7L50", "6L50", "5L50", "4L50"],
			icywind: ["6T", "5T", "4T", "3T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mirrorcoat: ["7L43", "6L43", "5L43", "4L43", "3L61", "3S1"],
			mist: ["7L36", "6L36", "5L36", "4L36", "4S2", "3L51", "3S1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "7L15", "7L1", "6M", "6L15", "5M", "5L15", "4M", "4L15", "4S2", "3M", "3L21", "3S0"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sheercold: ["7L1", "4S3"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["7L57", "6T", "6L1", "5T", "5L57", "4T", "4L57"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	larvitar: {
		inherit: true,
		learnset: {
			ancientpower: ["7E", "6E", "5E", "4T", "4E", "3E"],
			assurance: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L1", "6L1", "5L1", "5S1", "5D", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L14", "6L14", "5L14"],
			confide: ["7M", "6M"],
			crunch: ["7L41", "6L41", "5L41", "4L37", "3L43"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			darkpulse: ["7M", "7L32", "6M", "6L32", "5T", "5L32", "5D", "4M", "4L28"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragondance: ["7E", "6E", "5E", "4E", "3E", "3S0"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L46", "6M", "6L46", "5M", "5L46", "4M", "4L41", "3M", "3L50"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			focusenergy: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7L55", "6M", "6L55", "5M", "5L55", "4M", "4L50", "3M", "3L57"],
			irondefense: ["7E", "6T", "6E", "5T", "5E", "4E"],
			ironhead: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			irontail: ["7E", "6T", "6E", "5T", "5E"],
			leer: ["7L1", "6L1", "5L1", "5S1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["7E", "6T", "6E", "5T", "5E", "4E", "3E", "3S0"],
			payback: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L32"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L19", "6M", "6L19", "5M", "5L19", "4M", "4L14", "3T", "3L22"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "7L5", "6M", "6L5", "5M", "5L5", "5S1", "4M", "4L5", "3M", "3L8", "3S0"],
			scaryface: ["7L23", "6L23", "5L23", "4L19", "3L36"],
			screech: ["7L10", "6L10", "5L10", "4L10", "3L15"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E", "5D", "4M"],
			stomp: ["7E", "6E", "5E", "4E", "3E"],
			stoneedge: ["7M", "7L50", "6M", "6L50", "5M", "5L50", "4M", "4L46"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "5S1", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L28", "6L28", "5L28", "4L23", "3L29"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
		},
	},
	pupitar: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L14", "6L14", "5L14"],
			confide: ["7M", "6M"],
			crunch: ["7L47", "6L47", "5L47", "4L41", "3L47"],
			darkpulse: ["7M", "7L34", "6M", "6L34", "5T", "5L34", "4M", "4L28"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L54", "6M", "6L54", "5M", "5L54", "4M", "4L47", "3M", "3L56"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7L67", "6M", "6L67", "5M", "5L67", "4M", "4L60", "3M", "3L65"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T"],
			payback: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L34"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L19", "6M", "6L19", "5M", "5L19", "4M", "4L14", "3T", "3L22"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "7L5", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			scaryface: ["7L23", "6L23", "5L23", "4L19", "3L38"],
			screech: ["7L10", "7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "7L60", "6M", "6L60", "5M", "5L60", "4M", "4L54"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L28", "6L28", "5L28", "4L23", "3L29"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
		},
	},
	tyranitar: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L14", "6L14", "5L14"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crunch: ["7L47", "6L47", "6S3", "6S4", "6S5", "6S6", "5L47", "5S1", "5S2", "4L41", "3L47", "3S0"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "7L34", "6M", "6L34", "5T", "5L34", "4M", "4L28"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L54", "6M", "6L54", "6S3", "6S4", "5M", "5L54", "5S2", "4M", "4L47", "3M", "3L61", "3S0"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "5S1", "4M", "3M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "7L82", "6M", "6L82", "5M", "5L82", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7L73", "6M", "6L73", "5M", "5L73", "4M", "4L70", "3M", "3L75"],
			icebeam: ["7M", "6M", "5M", "5S1", "4M", "3M"],
			icefang: ["7L1", "6L1", "5L1", "4L1"],
			icepunch: ["6T", "6S3", "6S6", "5T", "4T"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "6S5", "6S6", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			outrage: ["6T", "5T", "4T"],
			payback: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "5S2", "4M", "4L34"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "6S5", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L19", "6M", "6L19", "6S4", "6S5", "6S6", "5M", "5L19", "4M", "4L14", "3T", "3L22"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "7L5", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			scaryface: ["7L23", "6L23", "5L23", "4L19", "3L38", "3S0"],
			screech: ["7L10", "7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["5S2", "3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "7L63", "6M", "6L63", "6S3", "6S4", "5M", "5L63", "5S1", "4M", "4L54"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L28", "6L28", "5L28", "4L23", "3L29", "3S0"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	lugia: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aeroblast: ["7L43", "6L43", "6S5", "6S6", "5L43", "4L43", "4S2", "4S3", "3L77"],
			aircutter: ["4T"],
			ancientpower: ["7L57", "6L57", "5L57", "4T", "4L57", "4S3", "3L88"],
			aquatail: ["6T", "5T", "4T"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L93", "6M", "6L93", "5M", "5L93", "4M", "4L93", "3M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrush: ["7L15", "6L15", "6S6", "5L15", "4L15"],
			dragontail: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			extrasensory: ["7L23", "6L23", "5L23", "4L23", "4S2"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			featherdance: ["3S1"],
			flash: ["6M", "5M", "4M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L79", "6L79", "5L79", "4L79", "3L99"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L9", "6L9", "5L9", "4L9", "3L22"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L37", "6L37", "6S5", "6S6", "5L37", "4L29", "4S2", "3L44", "3S0", "3S1"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "6S6", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7L85", "6L85", "5L85", "4M", "4L51"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychoboost: ["3S1"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			punishment: ["7L50", "6L50", "6S5", "5L50", "4L50", "4S3"],
			raindance: ["7M", "7L29", "6M", "6L29", "6S5", "5M", "5L29", "4M", "4L29", "4S2", "3M", "3L55", "3S0"],
			recover: ["7L71", "6L71", "5L71", "4L23", "3L33", "3S0"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L65", "6M", "6L65", "5M", "5L65", "4M", "4L9", "4S3", "3M", "3L11"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			skyattack: ["7L99", "6T", "6L99", "5T", "5L99", "4T", "4L99"],
			skydrop: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "4L43", "3T", "3L66", "3S0"],
			tailwind: ["6T", "5T", "4T"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			twister: ["4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			weatherball: ["7L1", "6L1", "5L1", "5S4", "4L1"],
			whirlpool: ["4M"],
			whirlwind: ["7L1", "6L1", "5L1", "5S4", "4L1", "3L1"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	hooh: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			ancientpower: ["7L57", "6L57", "5L57", "4T", "4L57", "4S2", "3L88"],
			bravebird: ["7L15", "7S6", "6L15", "6S5", "5L15", "4L15"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L93", "6M", "6L93", "5M", "5L93", "4M", "4L93", "3M"],
			celebrate: ["6S5"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			extrasensory: ["7L23", "6L23", "5L23", "4L23", "4S1"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7L37", "6M", "6L37", "6S4", "5M", "5L37", "4M", "4L29", "4S1", "3M", "3L44", "3S0"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L79", "6L79", "5L79", "4L79", "3L99"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L9", "6L9", "5L9", "4L9", "3L22"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7L85", "6L85", "5L85", "4M", "4L51"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			punishment: ["7L50", "6L50", "6S4", "5L50", "4L50", "4S2"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L71", "7S6", "6L71", "6S5", "5L71", "4L23", "3L33", "3S0"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			sacredfire: ["7L43", "7S6", "6L43", "6S4", "6S5", "5L43", "4L43", "4S1", "4S2", "3L77"],
			safeguard: ["7M", "7L65", "7S6", "6M", "6L65", "5M", "5L65", "4M", "4L9", "4S2", "3M", "3L11"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skyattack: ["7L99", "6T", "6L99", "5T", "5L99", "4T", "4L99", "3T"],
			skydrop: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			steelwing: ["7M", "6M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "7L29", "6M", "6L29", "6S4", "5M", "5L29", "4M", "4L29", "4S1", "3M", "3L55", "3S0"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "4L43", "3T", "3L66", "3S0"],
			tailwind: ["6T", "5T", "4T"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			weatherball: ["7L1", "6L1", "5L1", "5S3", "4L1"],
			whirlwind: ["7L1", "6L1", "5L1", "5S3", "4L1", "3L1"],
			willowisp: ["7M", "6M", "5M", "4M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	celebi: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["7L28", "7S7", "6L28", "5L28", "4T", "4L28", "3L20", "3S1", "3S3"],
			batonpass: ["7L37", "6L37", "5L37", "4L37", "3L40", "3S1"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "6S6", "5L1", "4L1", "3L1", "3S0"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthpower: ["6T", "5T", "4T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L64", "7S7", "6L64", "5L64", "4L64", "3L30", "3S1", "3S3"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			healbell: ["7L1", "7S7", "6T", "6L1", "6S5", "6S6", "5T", "5L1", "4T", "4L1", "3L1", "3S0", "3S2", "3S3"],
			healblock: ["7L55", "6L55", "5L55", "4L55"],
			healingwish: ["7L73", "6L73", "5L73", "4L73", "4S4"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			holdback: ["6S5"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			leafstorm: ["7L82", "6L82", "5L82", "4L82", "4S4"],
			leechseed: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S2"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magicalleaf: ["7L19", "6L19", "5L19", "4L19"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4S4"],
			naturalgift: ["7L46", "6L46", "5L46", "4M", "4L46"],
			naturepower: ["7M", "6M"],
			nightmare: ["3T"],
			perishsong: ["7L91", "6L91", "5L91", "4L91", "3L50", "3S1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L1", "6L1", "6S5", "6S6", "5L1", "4L1", "4S4", "3L1", "3S0", "3S2"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L10", "7S7", "6M", "6L10", "6S5", "6S6", "5M", "5L10", "4M", "4L10", "3M", "3L10", "3S0", "3S2", "3S3"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stealthrock: ["6T", "5T", "4M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M", "3M"],
			wonderroom: ["6T", "5T"],
			worryseed: ["6T", "5T", "4T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	treecko: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "6L5", "5L6", "5S1", "4L6", "3L6", "3S0"],
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L25", "6L25", "5L31", "4L31", "3L31"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulletseed: ["7E", "6E", "5E", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crunch: ["7E", "6E", "5E", "4E", "3E"],
			crushclaw: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			detect: ["7L33", "6L33", "5L41", "4L41", "3L41"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonbreath: ["7E", "6E", "5E", "4E", "3E"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["3T"],
			endeavor: ["7L45", "7E", "6T", "6L45", "6E", "5T", "5E", "4T", "4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["7M", "7L37", "6M", "6L37", "5M", "5L51", "4M", "4L51"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["7L21", "6T", "6L21", "5T", "5L46", "4M", "4L46", "3M", "3L46"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			grasswhistle: ["7E", "6E", "5E", "4E"],
			grassyterrain: ["7E", "6E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leafstorm: ["7E", "6E", "5E", "4E"],
			leechseed: ["7E", "6E", "5E", "4E", "3E"],
			leer: ["7L1", "6L1", "5L1", "5S1", "4L1", "3L1", "3S0"],
			lowkick: ["6T", "5T", "4T"],
			magicalleaf: ["7E", "6E", "5E", "4E"],
			megadrain: ["7L13", "6L13", "5L26", "4L26", "3L26"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			naturepower: ["7M", "6M"],
			pound: ["7L1", "6L1", "5L1", "5S1", "4L1", "3L1", "3S0"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L17", "6L16", "5L16", "4L16", "3L16"],
			quickattack: ["7L9", "6L9", "5L11", "4L11", "3L11"],
			quickguard: ["7L41", "6L41"],
			razorwind: ["7E", "6E", "5E", "4E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			screech: ["7L49", "6L21", "5L21", "4L21", "3L21"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["3T"],
			slam: ["7L29", "6L29", "5L36", "4L36", "3L36"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			workup: ["7M"],
			worryseed: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
		},
	},
	grovyle: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L28", "6L28", "5L35", "4L35", "3L35"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			detect: ["7L38", "6L38", "5L47", "4L47", "3L47"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["3T"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "7L48", "6M", "6L48", "5M", "5L53", "4M", "4L53", "3L53"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L1", "6L16", "5L16", "4T", "4L16", "3T", "3L16"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leafblade: ["7L23", "6L23", "5L29", "4L29", "3L29"],
			leafstorm: ["7L58", "6L58", "5L59", "4L59"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megadrain: ["7L13", "6L13"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L18", "6L17", "5L17", "4L17", "3L17"],
			quickattack: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			quickguard: ["7L53", "6L53"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			screech: ["7L63", "6L23", "5L23", "4L23", "3L23"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["3T"],
			slam: ["7L33", "6L33", "5L41", "4L41", "3L41"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			workup: ["7M"],
			worryseed: ["6T", "5T", "4T"],
			xscissor: ["7M", "7L43", "6M", "6L43", "5M", "4M"],
		},
	},
	sceptile: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L28", "6L28", "5L35", "4L35", "3L35"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			detect: ["7L39", "6L39", "5L51", "4L51", "3L51"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "5S0", "4M"],
			drainpunch: ["6T", "5T", "4M"],
			dualchop: ["7L1", "6T", "6L36"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "7L51", "6M", "6L51", "5M", "5L59", "4M", "4L59", "3L59"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "5S0", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frenzyplant: ["7T", "6T", "5T", "4T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L1", "6L16", "4T", "3T", "3L16"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leafblade: ["7L23", "6L23", "5L29", "4L29", "3L29"],
			leafstorm: ["7L63", "7L1", "6L1", "5L67", "5S0", "4L67"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megadrain: ["7L13", "6L13"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			nightslash: ["7L1", "6L1", "5L1", "4L1"],
			outrage: ["6T", "5T", "4T"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L18", "6L17", "5L17", "4L17", "3L17"],
			quickattack: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			quickguard: ["7L57", "6L57"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "5S0", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			screech: ["7L69", "6L23", "5L23", "4L23", "3L23"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["3T"],
			slam: ["7L33", "6L33", "5L43", "4L43", "3L43"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			workup: ["7M"],
			worryseed: ["6T", "5T", "4T"],
			xscissor: ["7M", "7L45", "6M", "6L16", "5M", "5L16", "4M", "4L16"],
		},
	},
	torchic: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7E", "6E", "5E", "4E"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			crushclaw: ["7E", "6E", "5E", "4E"],
			curse: ["7E", "6E", "5E"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L5", "6L5", "6S2", "5L10", "5S1", "5S2", "4L10", "3L10", "3S0"],
			endure: ["7E", "6E", "5E", "4M", "4E", "3T", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			featherdance: ["7E", "6E", "5E", "4E"],
			feint: ["7E", "6E", "5E", "4E"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepledge: ["7T", "6T", "5T"],
			firespin: ["7L19", "6L19", "5L25", "4L25", "3L25"],
			flameburst: ["7L28", "7E", "6L28", "6E", "5E"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L46", "6M", "6L43", "5M", "5L43", "4M", "4L43", "3M", "3L43"],
			focusenergy: ["7L32", "6L7", "6S2", "5L7", "5S1", "5S2", "4L7", "3L7", "3S0"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "6S2", "5L1", "5S1", "5S2", "4L1", "3L1", "3S0"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			lastresort: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			lowkick: ["7E", "6T", "6E", "5T", "5E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["7L41", "6L37", "5L37", "4L37", "3L37"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["7E", "6E", "5E", "4E"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			peck: ["7L14", "6L14", "5L16", "4L16", "3L16"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L23", "6L23", "5L28", "4L28", "3L28"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7E", "6E", "5E", "4E", "3E"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L10", "6L10", "5L19", "4L19", "3L19"],
			scratch: ["7L1", "6L1", "6S2", "5L1", "5S1", "5S2", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L37", "6L34", "5L34", "4L34", "3L34"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smellingsalts: ["7E", "6E", "5E", "4E", "3E"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M"],
		},
	},
	combusken: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "7L31", "6M", "6L28", "5M", "5L28", "4M", "4L28", "3M", "3L28"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["7L1", "6L16", "5L16", "4L16", "3L16"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dualchop: ["6T", "5T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepledge: ["7T", "6T", "5T"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamecharge: ["7M", "7L20", "6M", "6L20", "5M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flareblitz: ["7L58", "6L54", "5L54", "4L54"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L36", "6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			lastresort: ["6T", "5T", "4T"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["7L47", "6L43", "5L43", "4L43", "3L43"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			peck: ["7L14", "6L14", "5L17", "4L17", "3L17"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L25", "6L25", "5L32", "4L32", "3L32"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L10", "7L1", "6L1", "5L21", "4L21", "3L21"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			skyuppercut: ["7L53", "6L50", "5L50", "4L50", "3L50"],
			slash: ["7L42", "6L39", "5L39", "4L39", "3L39"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M", "5M"],
		},
	},
	blaziken: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blastburn: ["7T", "6T", "5T", "4T"],
			blazekick: ["7L1", "6L36", "5L36", "4L36", "3L36", "3S0"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			bravebird: ["7L50", "6L49", "5L49", "4L49"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "7L31", "6M", "6L28", "5M", "5L28", "4M", "4L28", "3M", "3L28"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["7L1", "6L16", "5L16", "4L16", "3L16"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dualchop: ["6T", "5T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepledge: ["7T", "6T", "5T"],
			firepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3T", "3L1"],
			flamecharge: ["7M", "7L20", "6M", "6L20", "5M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flareblitz: ["7L63", "7L1", "6L1", "5L66", "5S1", "4L66"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L37", "6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			highjumpkick: ["7L1", "6L1", "5L1", "5S1"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["3L49", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			peck: ["7L14", "6L14", "5L17", "4L17", "3L17"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L25", "6L25", "5L32", "4L32", "3L32"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L10", "7L1", "6L1", "5L21", "4L21", "3L21"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			skyuppercut: ["7L57", "6L57", "5L59", "4L59", "3L59", "3S0"],
			slash: ["7L44", "6L42", "5L42", "4L42", "3L42", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stoneedge: ["7M", "6M", "5M", "5S1", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			thunderpunch: ["6T", "5T", "5S1", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M", "5M"],
		},
	},
	mudkip: {
		inherit: true,
		learnset: {
			ancientpower: ["7E", "6E", "5E", "4T", "4E"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["7E", "6E", "5E"],
			barrier: ["7E", "6E"],
			bide: ["7L17", "6L15", "5L15", "4L15", "3L15"],
			bite: ["7E", "6E", "5E", "4E"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L44", "6T", "6L44", "5T", "5L46", "4T", "4L46", "3L46"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			foresight: ["7L12", "6L12", "5L19", "4L19", "3L19"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L1", "5S1", "4L1", "3L1", "3S0"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L41", "6L41", "5L42", "4L42", "3L42"],
			iceball: ["7E", "6E", "5E", "4E", "3E"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mirrorcoat: ["7E", "6E", "5E", "4E", "3E"],
			mudbomb: ["7E", "6E", "5E", "4E"],
			mudslap: ["7L9", "6L6", "5L6", "5S1", "4T", "4L6", "3T", "3L6", "3S0"],
			mudsport: ["7L20", "6L20", "5L24", "4L24", "3L24"],
			naturalgift: ["4M"],
			protect: ["7M", "7L28", "6M", "6L28", "5M", "5L37", "4M", "4L37", "3M", "3L37"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L25", "6L25"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludge: ["7E", "6E", "5E", "4E"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stomp: ["7E", "6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "5S1", "4L1", "3L1", "3S0"],
			takedown: ["7L36", "6L28", "5L28", "4L28", "3L28"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["7E", "6T", "6E", "5E", "4E", "3E"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L4", "6L4", "5L10", "5S1", "4L10", "3L10", "3S0"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["7L33", "7E", "6L33", "6E", "5L33", "5E", "4M", "4L33", "4E", "3L33"],
			wideguard: ["7E", "6E", "5E"],
			workup: ["7M"],
			yawn: ["7E", "6E", "5E", "4E"],
		},
	},
	marshtomp: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7L18", "6L15", "5L15", "4L15", "3L15"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L48", "6M", "6L46", "5M", "5L46", "4M", "4L46", "3M", "3L46"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L52", "6T", "6L52", "5T", "5L53", "4T", "4L53", "3L53"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			foresight: ["7L12", "6L12", "5L20", "4L20", "3L20"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["7L22", "6L22", "5L25", "4L25"],
			muddywater: ["7L38", "6L37", "5L37", "4L37", "3L37"],
			mudshot: ["7L1", "6L16", "5L16", "4L16", "3L16"],
			mudslap: ["7L9", "7L1", "6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			mudsport: ["3L25"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "7L32", "6M", "6L32", "5M", "5L42", "4M", "4L42", "3M", "3L42"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "7L28", "6M", "6L28", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L42", "6L31", "5L31", "4L31", "3L31"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M"],
		},
	},
	swampert: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bide: ["7L18", "6L15", "5L15", "4L15", "3L15"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L51", "6M", "6L51", "5M", "5L52", "5S0", "4M", "4L52", "3M", "3L52"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L56", "6T", "6L56", "5T", "5L61", "4T", "4L61", "3L61"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foresight: ["7L12", "6L12", "5L20", "4L20", "3L20"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hammerarm: ["7L63", "7L1", "6L1", "5L69", "5S0", "4L69"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydrocannon: ["7T", "6T", "5T", "4T"],
			hydropump: ["5S0"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "5S0", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["7L22", "6L22", "5L25", "4L25"],
			muddywater: ["7L39", "6L39", "5L39", "4L39", "3L39"],
			mudshot: ["7L1", "6L16", "5L16", "4L16", "3L16"],
			mudslap: ["7L9", "7L1", "6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			mudsport: ["3L25"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["7M", "7L32", "6M", "6L32", "5M", "5L46", "4M", "4L46", "3M", "3L46"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "7L28", "6M", "6L28", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L44", "6L31", "5L31", "4L31", "3L31"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M"],
		},
	},
	poochyena: {
		inherit: true,
		learnset: {
			assurance: ["7L22", "6L22", "5L29", "4L29"],
			astonish: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L10", "6L10", "5L13", "4L13", "3L13"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["7E", "6T", "6E", "5T", "5E", "4E", "3E"],
			crunch: ["7L34", "6L37", "5L53", "4L53", "3L41"],
			darkpulse: ["7M", "6M", "5T", "5D", "4M"],
			dig: ["6M", "5M", "4M", "3M", "3S0"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			embargo: ["7M", "7L28", "6M", "6L28", "5M", "5L41", "4M", "4L41"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7E", "6E", "5E", "4E"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7L4", "6L4", "5L5", "5D", "4L5", "3L5", "3S0"],
			hypervoice: ["6T", "5T"],
			icefang: ["7E", "6E", "5E", "4E"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7E", "6E", "5E", "4E", "3E"],
			mefirst: ["7E", "6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["7L13", "6L13", "5L17", "4L17", "3L17"],
			payback: ["7M", "6M", "5M", "4M"],
			playrough: ["7L46", "7E", "6E"],
			poisonfang: ["7E", "6E", "5E", "5D", "4E", "3E", "3S0"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L16", "6M", "6L16", "5M", "5L21", "4M", "4L21", "3M", "3L21"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L7", "6L7", "5L9", "4L9", "3L9"],
			scaryface: ["7L25", "6L25", "5L33", "4L33", "3L29"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L43", "7E", "6L40", "6E", "5L49", "5E", "4T", "4L49", "4E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "7L19", "6M", "6L19", "5M", "5L25", "4M", "4L25", "3T", "3L25"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L40", "6L34", "5L45", "4L45", "3L33"],
			taunt: ["7M", "7L31", "6M", "6L31", "5M", "5L37", "4M", "4L37", "3M", "3L37"],
			thief: ["7M", "6M", "5M", "4M", "3M", "3L45"],
			thunderfang: ["7E", "6E", "5E", "4E"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			yawn: ["7L37", "7E", "6E", "5E", "4E", "3E"],
		},
	},
	mightyena: {
		inherit: true,
		learnset: {
			assurance: ["7L24", "6L24", "5L32", "4L32"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L10", "7L1", "6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			crunch: ["7L40", "7L1", "6L1", "3L47"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			embargo: ["7M", "7L32", "6M", "6L32", "5M", "5L47", "4M", "4L47"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7L1"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icefang: ["7L1"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["7L13", "6L13", "5L17", "4L17", "3L17"],
			payback: ["7M", "6M", "5M", "4M"],
			playrough: ["7L56"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L16", "6M", "6L16", "5M", "5L22", "4M", "4L22", "3M", "3L22"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			scaryface: ["7L28", "6L28", "5L37", "4L37", "3L32"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "7L1", "6M", "6L18", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L52", "6L48", "5L62", "4T", "4L62"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "7L20", "6M", "6L20", "5M", "5L27", "4M", "4L27", "3T", "3L27"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L48", "6L40", "5L52", "4L52", "3L37"],
			taunt: ["7M", "7L36", "6M", "6L36", "5M", "5L42", "4M", "4L42", "3M", "3L42"],
			thief: ["7M", "7L1", "6M", "6L1", "5M", "5L57", "4M", "4L57", "3M", "3L52"],
			thunderfang: ["7L1"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			yawn: ["7L44"],
		},
	},
	zigzagoon: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			babydolleyes: ["7L12", "6L11"],
			bellydrum: ["7L37", "6L37", "5L45", "4L41", "3L41"],
			bestow: ["7L25", "6L25", "5L33"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7E", "6E", "5E", "4E", "3E"],
			confide: ["7M", "6M"],
			covet: ["7L23", "6T", "6L23", "5T", "5L29", "4L29", "3L29"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			extremespeed: ["3S1"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L29", "6L29", "5L37", "4L33", "3L33"],
			fling: ["7M", "7L41", "6M", "6L41", "5M", "5L49", "4M", "4L45"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["7L11", "6L9", "5L9", "4T", "4L9", "3L9"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "5D", "4T"],
			mimic: ["3T"],
			mudslap: ["7E", "6E", "5E", "4T", "4E", "3T"],
			mudsport: ["7L17", "6L17", "5L21", "4L21", "3L21"],
			naturalgift: ["4M"],
			odorsleuth: ["7L13", "6L13", "5L17", "4L17", "3L17"],
			pinmissile: ["7L19", "6L19", "5L25", "4L25", "3L25"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L35", "6M", "6L35", "5M", "5L41", "4M", "4L37", "3M", "3L37"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["7E", "6E", "5E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L7", "6L7", "5L13", "4L13", "3L13"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			simplebeam: ["7E", "6E", "5E"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			tailwhip: ["7L5", "6L5", "5L5", "4L5", "3L5", "3S0", "3S1"],
			takedown: ["7L31", "6L31"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			tickle: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
		},
	},
	linoone: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			babydolleyes: ["6S0"],
			bellydrum: ["7L43", "6L43", "5L59", "4L53", "3L53"],
			bestow: ["7L27", "6L27", "5L41"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			covet: ["7L24", "6T", "6L24", "5T", "5L35", "4L35", "3L35"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L35", "6L35", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			extremespeed: ["6S0"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "7L48", "6M", "6L48", "5M", "5L65", "4M", "4L59"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L19", "6L19", "5L29", "4L29", "3L29"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["7L11", "6L1", "5L1", "4T", "4L1", "3L1"],
			helpinghand: ["6T", "6S0", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L17", "6L17", "5L23", "4L23", "3L23"],
			naturalgift: ["4M"],
			odorsleuth: ["7L13", "6L13", "5L17", "4L17", "3L17"],
			playrough: ["7L1", "6L1"],
			protect: ["7M", "6M", "6S0", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L40", "6M", "6L40", "5M", "5L53", "4M", "4L47", "3M", "3L47"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			rototiller: ["7L1", "6L1"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L7", "7L1", "6L1", "5L13", "4L13", "3L13"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			slash: ["7L32", "6L32", "5L47", "4L41", "3L41"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			switcheroo: ["7L1", "6L1", "5L1", "4L1"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwhip: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
		},
	},
	wurmple: {
		inherit: true,
		learnset: {
			bugbite: ["7L15", "6T", "6L15", "5T", "5L15", "5D", "4T", "4L15"],
			electroweb: ["6T", "5T"],
			poisonsting: ["7L5", "6L5", "5L5", "5D", "4L5", "3L5"],
			snore: ["6T", "5T", "5D", "4T"],
			stringshot: ["7L1", "6L1", "5L1", "4T", "4L1", "3L1"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	silcoon: {
		inherit: true,
		learnset: {
			bugbite: ["6T", "5T", "4T"],
			electroweb: ["6T", "5T"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			irondefense: ["6T", "5T", "4T"],
			stringshot: ["4T"],
		},
	},
	beautifly: {
		inherit: true,
		learnset: {
			absorb: ["7L12", "6L1", "5L1", "4L1", "3L1"],
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["7L20", "6L20", "4T"],
			attract: ["7M", "7L27", "6M", "6L27", "5M", "5L31", "4M", "4L31", "3M", "3L31"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L35", "6L35", "5L41", "4L41"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			electroweb: ["6T", "5T"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7L32", "6T", "6L32", "5T", "5L38", "4M", "4L38", "3M", "3L38"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L1", "6L1", "5L13", "4L13", "3L13"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			megadrain: ["7L22", "6L22", "5L24", "4L24", "3L24"],
			mimic: ["3T"],
			morningsun: ["7L17", "6L17", "5L20", "4L20", "3L20"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			quiverdance: ["7L40", "6L40", "5L45"],
			rage: ["7L37", "6L37"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["7L25", "6L25", "5L34", "4M", "4L34", "3L34"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["7L15", "6L15", "5L17", "4L17", "3L17"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			venoshock: ["7M", "6M", "5M"],
			whirlwind: ["7L30", "6L27", "5L27", "4L27", "3L27"],
		},
	},
	cascoon: {
		inherit: true,
		learnset: {
			bugbite: ["6T", "5T", "4T"],
			electroweb: ["6T", "5T"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			irondefense: ["6T", "5T", "4T"],
			stringshot: ["4T"],
		},
	},
	dustox: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L35", "6L35", "5L41", "4L41"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L12", "6L1", "5L1", "4L1", "3L1"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			electroweb: ["6T", "5T"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L1", "6L1", "5L13", "4L13", "3L13"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			lightscreen: ["7M", "7L27", "6M", "6L27", "5M", "5L31", "4M", "4L31", "3M", "3L31"],
			mimic: ["3T"],
			moonlight: ["7L17", "6L17", "5L20", "4L20", "3L20"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonpowder: ["7L15", "6L15"],
			protect: ["7M", "7L37", "6M", "6L17", "5M", "5L17", "4M", "4L17", "3M", "3L17"],
			psybeam: ["7L22", "6L22", "5L24", "4L24", "3L24"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			quiverdance: ["7L40", "6L40", "5L45"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["7L25", "6L25", "5L34", "4M", "4L34", "3L34"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "7L32", "6M", "6L32", "5M", "5L38", "4M", "4L38", "3M", "3L38"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			venoshock: ["7M", "7L20", "6M", "6L20", "5M"],
			whirlwind: ["7L30", "6L27", "5L27", "4L27", "3L27"],
		},
	},
	lotad: {
		inherit: true,
		learnset: {
			absorb: ["7L6", "6L5", "5L5", "5D", "4L5", "3L7", "3S0"],
			astonish: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bubble: ["7L9", "6L9"],
			bubblebeam: ["7L21", "6L21", "5L25", "4L25"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E"],
			dive: ["6M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "7L36", "6M", "6L36", "5M", "5L45", "4M", "4L43"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7L30", "7E", "6T", "6L30", "6E", "5T", "5E", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L3", "6L3", "5L3", "4L3", "3L3", "3S0"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			leechseed: ["7E", "6E", "5E", "5D", "4E", "3E"],
			megadrain: ["7L18", "6L18", "5L19", "4L19", "3L43"],
			mimic: ["3T"],
			mist: ["7L15", "6L11", "5L11", "4L11", "3L21"],
			naturalgift: ["7L12", "6L12", "5L15", "4M", "4L15"],
			naturepower: ["7M", "7L24", "6M", "6L7", "5L7", "4L7", "3L13"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "7L27", "6M", "6L27", "5M", "5L37", "4M", "4L35", "3M", "3L31"],
			razorleaf: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7E", "6E", "5E", "4E", "3E"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			teeterdance: ["7E", "6E", "5E"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			tickle: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			watergun: ["7E", "6E", "5E", "4E", "3E"],
			waterpulse: ["6T", "5D", "4M", "3M"],
			whirlpool: ["4M"],
			zenheadbutt: ["7L33", "6T", "6L31", "5T", "5L31", "4T", "4L27"],
		},
	},
	lombre: {
		inherit: true,
		learnset: {
			absorb: ["7L6", "6L5", "5L5", "4L5", "3L7"],
			astonish: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubble: ["7L9", "6L9"],
			bubblebeam: ["7L24", "6L24", "5L25", "4L25"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L16", "6L11", "5L11", "4L11", "3L19"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyswipes: ["7L12", "6L12", "5L15", "4L15", "3L25"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L3", "6L3", "5L3", "4L3", "3L3"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["7L44", "6L44", "5L45", "4L43", "3L49"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			knockoff: ["7L36", "6T", "6L36"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "7L28", "6M", "6L7", "5L7", "4L7", "3L13"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M", "3L37"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["7L32", "6T", "6L32", "5T", "5L37", "4T", "4L35", "3L43"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			watersport: ["7L20", "6L19", "5L19", "4L19", "3L31"],
			whirlpool: ["4M"],
			zenheadbutt: ["7L40", "6T", "6L31", "5T", "5L31", "4T", "4L27"],
		},
	},
	ludicolo: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			astonish: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["5S0"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "5S0", "5S1", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["5S0"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "5S0", "5S1", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			knockoff: ["6T"],
			megadrain: ["7L1", "6L1", "5L1", "4L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "7L1", "6M", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M", "5S1"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "5S1", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	seedot: {
		inherit: true,
		learnset: {
			amnesia: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			beatup: ["7E", "6E", "5E"],
			bide: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			bulletseed: ["7E", "6E", "5E", "5D", "4M", "3M", "3S1"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defensecurl: ["3T"],
			defog: ["7E", "6E", "5E"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			explosion: ["7M", "7L33", "6M", "6L33", "5M", "5L43", "4M", "4L43", "3T", "3L43"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["7E", "6T", "6E", "5T", "5E", "5D"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M", "3S1"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grassyterrain: ["7E", "6E"],
			growth: ["7L9", "6L7", "5L7", "5D", "4L7", "3L7", "3S0"],
			harden: ["7L3", "6L3", "5L3", "4L3", "3L3", "3S0"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			leechseed: ["7E", "6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			nastyplot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			naturepower: ["7M", "7L15", "6M", "6L13", "5L13", "4L13", "3L13"],
			powerswap: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7E", "6E", "5E", "4E", "3E"],
			razorwind: ["7E", "6E", "5E", "4E", "3E"],
			refresh: ["3S1"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M", "3S1"],
			seedbomb: ["6T", "5T", "4T"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "7L27", "6M", "6L27", "5M", "5L31", "4M", "4L31", "3M", "3L31"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7L21", "6T", "6L21", "5T", "5L21", "4T", "4L21", "3L21"],
			takedown: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			worryseed: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
		},
	},
	nuzleaf: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			extrasensory: ["7L36", "6L36", "5L49", "4L49", "3L49"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L12", "6L12", "5L19", "4L19", "3L19"],
			falseswipe: ["7M", "6M", "5M"],
			feintattack: ["7L24", "6L24", "5L31", "4L31", "3L31"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["7L6", "6L6", "5L7", "4L7", "3L7"],
			harden: ["7L3", "6L3", "5L3", "4L3", "3L3"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			leafblade: ["7L28", "6L28"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "7L16", "6M", "6L9", "5L13", "4L13", "3L13"],
			payback: ["7M", "6M", "5M", "4M"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			razorleaf: ["7L1", "6L1", "5L1", "4L1"],
			razorwind: ["7L20", "6L20", "5L37", "4L37", "3L37"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L32", "6M", "6L32", "5M", "5L43", "4M", "4L43", "3T", "3L43"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "7L9", "6M", "6L16", "5M", "5L25", "4M", "4L25", "3M", "3L25"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	shiftry: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M"],
			feintattack: ["7L1", "6L1", "5L1", "4L1"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["3L1"],
			harden: ["3L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7L32", "6L32"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			leafstorm: ["7L44", "6L44", "5L49", "4L49"],
			leaftornado: ["7L20", "6L19", "5L19"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M", "3L1"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			pound: ["3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			razorleaf: ["7L1", "6L1", "5L1", "4L1"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["7L1", "6L1", "5L1", "4L1"],
			worryseed: ["6T", "5T", "4T"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	taillow: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L21", "6M", "6L21", "5M", "5L34", "4M", "4L34", "3M", "3L34"],
			agility: ["7L29", "6L29", "5L43", "4L43", "3L43"],
			aircutter: ["4T"],
			airslash: ["7L33", "6L33", "5L53", "4L53"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			boomburst: ["7E", "6E"],
			bravebird: ["7L41", "7E", "6L41", "6E", "5E", "5D", "4E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defog: ["7E", "6E", "5E", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "7L17", "6M", "6L17", "5M", "5L19", "4M", "4L19", "3M", "3L19"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L37", "6T", "6L26", "5T", "5L26", "4T", "4L26", "3L26"],
			endure: ["5D", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			featherdance: ["3S0"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			focusenergy: ["7L5", "6L4", "5L4", "4L4", "3L4", "3S0"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7E"],
			mimic: ["3T"],
			mirrormove: ["7E", "6E", "5E", "5D", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			quickattack: ["7L9", "6L7", "5L8", "4L8", "3L8"],
			quickguard: ["7L25", "6L25"],
			rage: ["7E", "6E", "5E", "4E", "3E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7L45"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["7E", "6T", "6E", "5E", "4E", "3T", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "5D", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7E", "6E", "5E", "4E"],
			wingattack: ["7L13", "6L13", "5L13", "4L13", "3L13"],
			workup: ["7M", "5M"],
		},
	},
	swellow: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L21", "6M", "6L21", "5M", "5L38", "4M", "4L38", "3M", "3L38"],
			agility: ["7L33", "6L33", "5L49", "4L49", "3L49", "3S0"],
			aircutter: ["4T"],
			airslash: ["7L39", "7L1", "6L1", "5L61", "4L61"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["3S0"],
			bravebird: ["7L51", "7L1", "6L1"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "7L17", "6M", "6L17", "5M", "5L19", "4M", "4L19", "3M", "3L19"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L45", "6T", "6L28", "5T", "5L28", "4T", "4L28", "3L28"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			focusenergy: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			pluck: ["7L1", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			quickguard: ["7L27", "6L27"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7L57"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skyattack: ["6T", "5T", "4T", "3T", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			wingattack: ["7L13", "6L13", "5L13", "4L13", "3L13"],
			workup: ["7M", "5M"],
		},
	},
	wingull: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L29", "6M", "6L29", "5M", "5L42", "4M", "4L42", "3M"],
			agility: ["7L36", "7E", "6L36", "6E", "5L37", "5E", "4L37", "4E", "3L55", "3E"],
			aircutter: ["7L22", "6L22", "5L33", "4T"],
			airslash: ["7L40", "6L40", "5L47", "4L47"],
			aquaring: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["7E", "6E", "5E", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			gust: ["7E", "6E", "5E", "4E", "3E"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7L43", "6L43", "5L50"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			knockoff: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			mimic: ["3T"],
			mist: ["7L12", "7E", "6L12", "6E", "5L16", "5E", "4L16", "4E", "3L21", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L26", "6L26", "5L34", "4L34", "3L43"],
			quickattack: ["7L19", "6L19", "5L24", "4L24", "3L31"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7E", "7L33", "6M", "6L26", "6E", "5T", "5L29", "5E", "4M", "4L29"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "5D", "4M", "3M"],
			skyattack: ["6T", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7E", "6E"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			supersonic: ["7L5", "6L5", "5L6", "4L6", "3L7"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["7E", "6E", "5E", "5D", "4T", "4E", "3E"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			watergun: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			waterpulse: ["7L15", "6T", "6L15", "5L19", "4M", "4L19", "3M"],
			watersport: ["7E", "6E", "5E", "4E", "3E"],
			wideguard: ["7E", "6E"],
			wingattack: ["7L8", "6L8", "5L11", "4L11", "3L13"],
		},
	},
	pelipper: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["7L22", "6L28", "5L34", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "7L28", "6M", "6L39", "5M", "5L43", "4M", "4L43"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			gunkshot: ["6T", "5T", "4T"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7L55", "7L1", "6L1", "5L63"],
			hydropump: ["7L50", "7L1", "6L1", "5L57", "4L57", "3L61"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			knockoff: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mist: ["7L12", "6L12", "5L16", "4L16", "3L21"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["7M", "7L19", "6M", "6L19", "5M", "5L24", "4M", "4L24"],
			pluck: ["5M", "4M"],
			protect: ["7M", "7L1", "6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L25"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7L39", "6M", "6L22", "5T", "5L31", "4M", "4L31"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			shockwave: ["6T", "4M", "3M"],
			skyattack: ["6T", "5T", "4T", "3T"],
			skydrop: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7L1", "6L1", "5L1"],
			spitup: ["7L33", "6L33", "5L38", "4L38", "3L47"],
			steelwing: ["7M", "6M", "4M", "3M"],
			stockpile: ["7L33", "6L33", "5L38", "4L38", "3L33"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			supersonic: ["7L5", "6L5", "5L6", "4L6", "3L7"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L33", "6L33", "5L38", "4L38", "3L33"],
			swift: ["4T", "3T"],
			tailwind: ["7L44", "7L1", "6T", "6L1", "5T", "5L50", "4T", "4L50"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			watergun: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["7L15", "6T", "6L15", "5L19", "4M", "4L19", "3M"],
			watersport: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
			wingattack: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	ralts: {
		inherit: true,
		learnset: {
			allyswitch: ["7E", "6E", "5M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["7M", "7L24", "6M", "6L24", "5M", "5L28", "4M", "4L23", "3M", "3L21"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L34", "6L34", "5L43", "4L39", "3S1"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "4E"],
			confusion: ["7L4", "6L4", "5L6", "5D", "4L6", "3L6", "3S2"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			destinybond: ["7E", "6E", "5E", "5D", "4E", "3E"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			disarmingvoice: ["7L11", "6L11"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "7L6", "6M", "6L6", "5M", "5L10", "4M", "4L10", "3M", "3L11"],
			drainingkiss: ["7L22", "6L22"],
			dreameater: ["7M", "7L39", "6M", "6L39", "5M", "5L50", "4M", "4L45", "3T", "3L46"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7E", "6E", "6S0", "5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L32", "6L32", "5L39", "4L34", "3L36"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "6S0", "5L1", "4L1", "3L1", "3S0", "3S1"],
			grudge: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			healpulse: ["7L19", "6L19", "5L23"],
			helpinghand: ["6T", "5T", "5D", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["7L37", "6L37", "5L45", "4L43", "3L41"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			imprison: ["7L29", "6L29", "5L34", "4L32", "3L31"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7L14", "6L14", "5L17", "4L17"],
			magicalleaf: ["7L17", "6L17", "5L21", "4L21"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			meanlook: ["7E", "6E", "5E", "4E", "3E"],
			memento: ["7E", "6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			mistyterrain: ["7E", "6E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L27", "6M", "6L27", "5M", "5L32", "4M", "4L28", "3M", "3L26"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M", "3S2"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowsneak: ["7E", "6E", "5E", "4E"],
			shockwave: ["6T", "4M", "3M", "3S2"],
			signalbeam: ["6T", "5T", "4T"],
			sing: ["3S2"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			storedpower: ["7L42", "6L42", "5L54"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T"],
			synchronoise: ["7E", "6E", "5E"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["7L9", "6L9", "5L12", "4L12", "3L16"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			willowisp: ["7M", "6M", "5M", "4E", "3E"],
			wish: ["3S0"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	kirlia: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["7M", "7L26", "6M", "6L26", "5M", "5L31", "4M", "4L25", "3M", "3L21"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L40", "6L40", "5L50", "4L45"],
			confide: ["7M", "6M"],
			confusion: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			disarmingvoice: ["7L11", "6L11"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "7L6", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			drainingkiss: ["7L23", "6L23"],
			dreameater: ["7M", "7L47", "6M", "6L47", "5M", "5L59", "4M", "4L53", "3T", "3L54"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L37", "6L37", "5L45", "4L39", "3L40"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healpulse: ["7L19", "6L19", "5L25"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["7L44", "6L44", "5L53", "4L50", "3L47"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			imprison: ["7L33", "6L33", "5L39", "4L36", "3L33"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7L14", "6L14", "5L17", "4L17"],
			magicalleaf: ["7L17", "6L17", "5L22", "4L22", "3L1"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L30", "6M", "6L30", "5M", "5L36", "4M", "4L31", "3M", "3L26"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			storedpower: ["7L51", "6L51", "5L64"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			willowisp: ["7M", "6M", "5M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	gardevoir: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["7M", "7L26", "6M", "6L26", "6S1", "5M", "5L33", "4M", "4L25", "3M", "3L21"],
			captivate: ["7L44", "6L44", "5L60", "4M", "4L53"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			dazzlinggleam: ["7M", "6M", "6S1"],
			defensecurl: ["3T"],
			disarmingvoice: ["7L11", "6L11"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "7L6", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			drainingkiss: ["7L23", "6L23"],
			dreameater: ["7M", "7L53", "6M", "6L53", "5M", "5L73", "4M", "4L65", "3T", "3L60"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "5S0", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L40", "6L40", "5L53", "4L45", "3L42"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			healingwish: ["7L1", "6L1", "5L1", "4L1"],
			healpulse: ["7L19", "6L19", "5L25"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["7L49", "6L49", "5L65", "5S0", "4L60", "3L51"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			imprison: ["7L35", "6L35", "5L45", "4L40", "3L33"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magicalleaf: ["7L17", "6L17", "5L22", "4L22"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mimic: ["3T"],
			mistyterrain: ["7L1", "6L1"],
			moonblast: ["7L62", "7L1", "6L1", "6S1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L31", "6M", "6L31", "5M", "5L40", "5S0", "4M", "4L33", "3M", "3L26"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			storedpower: ["7L58", "7L1", "6L1", "6S1", "5L80"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "5S0", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			willowisp: ["7M", "6M", "5M"],
			wish: ["7L14", "6L14", "5L17", "4L17"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	gallade: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L17", "6M", "5M", "4M"],
			allyswitch: ["5M"],
			attract: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			closecombat: ["7L53", "7L1", "6L1", "5L59", "4L53"],
			confide: ["7M", "6M"],
			confusion: ["7L4", "7L1", "6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "7L6", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			dualchop: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			falseswipe: ["7M", "7L44", "6M", "6L44", "5M", "5L50", "4M", "4L45"],
			feint: ["7L40", "6L40", "5L45", "4L39"],
			firepunch: ["6T", "5T", "4T"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["7L14", "6L14", "5L17", "4T", "4L17"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healpulse: ["7L19", "6L19", "5L25"],
			helpinghand: ["7L35", "6T", "6L35", "5T", "5L39", "4T", "4L36"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			icepunch: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			leafblade: ["7L1", "6L1", "5L1", "4L1"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["7L1", "6L1", "5L1", "4L1"],
			painsplit: ["6T", "5T", "4T"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "7L49", "6M", "6L49", "5M", "5L53", "4M", "4L50"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychocut: ["7L31", "6L31", "5L36", "4L31"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M"],
			quickguard: ["7L11", "6L11"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			slash: ["7L1", "6L17", "5L22", "4L22"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			storedpower: ["7L58", "7L1", "6L1", "5L64"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "7L26", "6M", "6L26", "5M", "5L31", "4M", "4L25"],
			taunt: ["7M", "6M", "5M", "4M"],
			telekinesis: ["5M"],
			teleport: ["7L9", "7L1", "6L1", "5L1", "4L1"],
			thief: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["4T"],
			wideguard: ["7L23", "6L23"],
			willowisp: ["7M", "6M", "5M"],
			wonderroom: ["6T", "5T"],
			workup: ["7M", "5M"],
			xscissor: ["7M", "6M", "5M", "4M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	surskit: {
		inherit: true,
		learnset: {
			agility: ["7L22", "6L22", "5L31", "4L31", "3L31"],
			aquajet: ["7L30", "7E", "6L30", "6E", "5E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L35", "6L35", "5L43", "4L43"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bubble: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			bubblebeam: ["7L17", "6L17", "5L25", "4L25", "3L25"],
			bugbite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fellstinger: ["7E", "6E"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "5D", "4M", "3M"],
			haze: ["7L25", "6L25", "5L37", "4L37", "3L37"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7E", "6E", "5E", "5D", "4E", "3E"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			lunge: ["7E"],
			mimic: ["3T"],
			mindreader: ["7E", "6E", "5E", "4E", "3E"],
			mist: ["7L25", "6L25", "5L37", "4L37", "3L37"],
			mudshot: ["7E", "6E", "5E", "4E", "3E"],
			mudslap: ["4T"],
			mudsport: ["3S0"],
			naturalgift: ["4M"],
			powersplit: ["7E", "6E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7E", "6E", "5E", "4E", "3E"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			quickattack: ["7L6", "6L6", "5L7", "4L7", "3L7", "3S1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stickyweb: ["7L38", "6L38"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L9", "6L9", "5L13", "4L13", "3L13"],
			swift: ["4T", "3T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			watersport: ["7L14", "6L14", "5L19", "4L19", "3L19"],
		},
	},
	masquerain: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["7L22", "6L22", "4T"],
			airslash: ["7L38", "6L38", "5L47", "4L47"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bubble: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L42", "7L1", "6L1", "5L61", "4L61"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L17", "6L17", "5L22", "4L22", "3L26"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["3C"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["7L1", "6L1", "5L1", "4T", "4L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			quickattack: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			quiverdance: ["7L52", "7L1", "6L1", "5L68"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			scaryface: ["7L22", "6L22", "5L26", "4L26", "3L33"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["7L32", "6L32", "5L40", "4M", "4L40", "3L47"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			stunspore: ["7L26", "6L26", "5L33", "4L33", "3L40"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M", "3M"],
			watersport: ["7L14", "7L1", "6L1", "5L1", "4L1", "3L1"],
			whirlwind: ["7L48", "7L1", "6L1", "5L54", "4L54", "3L53"],
		},
	},
	shroomish: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["7E", "6E", "5E", "5D", "4M", "3M"],
			captivate: ["4M"],
			charm: ["7E", "6E", "5E", "4E", "3E"],
			confide: ["7M", "6M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["7E", "6T", "6E", "5T", "5E"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6E", "5E", "4E", "3E"],
			falseswipe: ["7M", "6M", "5M", "4E", "3E", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			focuspunch: ["7E", "6T", "6E", "5E", "5D"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["7L26", "6T", "6L26", "5T", "5L37", "4M", "4L37", "3M", "3L45"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["7L29", "6L29", "5L33", "4L33", "3L36"],
			headbutt: ["7L15", "6L15", "5L21", "4T", "4L21", "3L22"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			leechseed: ["7L8", "6L8", "5L13", "4L13", "3L10"],
			megadrain: ["7L12", "6L12", "5L17", "4L17", "3L16", "3S0"],
			mimic: ["3T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			poisonpowder: ["7L19", "6L19", "5L25", "4L25", "3L28"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["7L36", "7E", "6T", "6L36", "6E", "5T", "5L41", "5E", "4T", "4L41", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spore: ["7L40", "6L40", "5L45", "4L45", "3L54"],
			stunspore: ["7L5", "6L5", "5L9", "5D", "4L9", "3L7", "3S0"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			tackle: ["7L1", "6L1", "5L5", "4L5", "3L4"],
			toxic: ["7M", "7L33", "6M", "6L33", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			wakeupslap: ["7E", "6E", "5E", "4E"],
			worryseed: ["7L22", "7E", "6T", "6L22", "6E", "5T", "5L29", "5E", "4T", "4L29", "4E"],
		},
	},
	breloom: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7L22", "6L22", "5L25", "4L25", "3T", "3L28"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["7L50", "6L45", "5L45", "4L45", "3T", "3L54"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M"],
			feint: ["7L19", "6L19"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			forcepalm: ["7L28", "6L28", "5L29", "4L29"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["7L15", "6L15", "5L21", "4T", "4L21", "3L22"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leechseed: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			lowsweep: ["7M", "6M", "5M"],
			machpunch: ["7L1", "6L23", "5L23", "4L23", "3L23"],
			megadrain: ["7L12", "6L12", "5L17", "4L17", "3L16"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mindreader: ["7L33", "6L33", "5L37", "4L37", "3L45"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["7L44", "6T", "6L41", "5T", "5L41", "4T", "4L41"],
			seismictoss: ["3T"],
			skyuppercut: ["7L39", "6L33", "5L33", "4L33", "3L36"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stunspore: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			venoshock: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	slakoth: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			afteryou: ["7E", "6T", "6E", "5T", "5E"],
			amnesia: ["7L17", "6L17", "5L25", "4L25", "3L25"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "4E", "3T", "3E"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chipaway: ["7L25", "6L25", "5L37"],
			confide: ["7M", "6M"],
			counter: ["7L30", "6L30", "5L43", "4L37", "3T", "3L37"],
			covet: ["7L22", "6T", "6L22", "5T", "5L31", "4L31", "3L31"],
			crushclaw: ["7E", "6E", "5E", "4E", "3E"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["7L6", "6L6", "5L7", "4L7", "3L7"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L14", "6L14", "5L19", "4L19", "3L19"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flail: ["7L33", "6L33", "5L49", "4L43", "3L43"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gunkshot: ["6T", "5T", "4T"],
			hammerarm: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["7E", "6E", "5E", "5D", "4E"],
			playrough: ["7L38", "6L38"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			slackoff: ["7L9", "6L9", "5L13", "4L13", "3L13"],
			slash: ["7E", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["5D", "4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			tickle: ["7E", "6E", "5E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			workup: ["7M", "5M"],
			yawn: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
		},
	},
	vigoroth: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L27", "6L27", "5L43"],
			confide: ["7M", "6M"],
			counter: ["7L33", "6L33", "5L37", "4L37", "3T", "3L37"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			encore: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			endure: ["7L17", "6L17", "5L25", "4M", "4L25", "3T", "3L25"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["7L37", "6T", "6L37", "5L49", "4M", "4L43", "3M", "3L43"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L14", "6L14", "5L19", "4L19", "3L19"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7L43", "7L1", "6L1", "5L55", "4L49", "3L49"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			slash: ["7L23", "6L23", "5L31", "4L31", "3L31"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["7L9", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			workup: ["7M", "5M"],
		},
	},
	slaking: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "4S0", "3M"],
			afteryou: ["6T", "5T"],
			amnesia: ["7L17", "6L17", "5L25", "4L25", "3L25"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L27", "6L27", "5L37"],
			confide: ["7M", "6M"],
			counter: ["7L33", "6L33", "5L43", "4L37", "3T", "3L37"],
			covet: ["7L23", "6T", "6L23", "5T", "5L31", "4L31", "3L31"],
			cut: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			encore: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L14", "6L14", "5L19", "4L19", "3L19"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flail: ["7L39", "6L39", "5L49", "4L43", "3L43"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "7L47", "7L1", "6M", "6L1", "5M", "5L55", "4M", "4L49"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M", "4S0"],
			gunkshot: ["6T", "5T", "4T"],
			hammerarm: ["7L61", "7L1", "6L1", "5L67", "4L61"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			punishment: ["7L53", "7L1", "6L1", "5L61", "4L55"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "4S0", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M", "4S0"],
			shockwave: ["6T", "4M", "3M"],
			slackoff: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L1", "6M", "6L36", "5M", "5L36", "4M", "4L36", "3T", "3L36"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			workup: ["7M", "5M"],
			yawn: ["7L1", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	nincada: {
		inherit: true,
		learnset: {
			absorb: ["7L5"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7L29", "6L29"],
			bugbite: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			bugbuzz: ["7E", "6E", "5E", "4E"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["7L37", "6M", "6L37", "5M", "5L45", "4M", "4L45", "3M", "3L45"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7E", "6E", "5E", "5D", "4M", "4E", "3T", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "7L33", "6M", "6L25", "5M", "5L25", "4M", "4L25", "3L25"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			finalgambit: ["7E", "6E", "5E"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L13", "6L13", "5L14", "4L14", "3L14"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gust: ["7E", "6E", "5E", "4E", "3E"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			leechlife: ["7M", "6L5", "5L5", "5D", "4L5", "3L5"],
			metalclaw: ["7L21", "6L21", "5L38", "4L38", "3L38"],
			mimic: ["3T"],
			mindreader: ["7L25", "6L19", "5L19", "4L19", "3L19"],
			mudslap: ["7L17", "6L17", "5L31", "4T", "4L31", "3T", "3L31"],
			naturalgift: ["4M"],
			nightslash: ["7E", "6E", "5E", "5D", "4E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L9", "6L9", "5L9", "4L9", "3L9"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			silverwind: ["7E", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["6T", "5T", "4T"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	ninjask: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "7L1"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L17", "6L17", "5L38", "4L38", "3L38"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L35", "6L35", "5L45", "4L45", "3L45"],
			bugbite: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "7L1", "6M", "6L20", "5M", "5L20", "4M", "4L20", "3M", "3L20"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L1", "6L20", "5L20", "4T", "4L20", "3T", "3L20"],
			furyswipes: ["7L13", "6L13", "5L14", "4L14", "3L14"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			leechlife: ["7M", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mindreader: ["7L29", "6L19", "5L19", "4L19", "3L19"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7L1", "6L20", "5L20", "4L20", "3L20"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			silverwind: ["4M"],
			slash: ["7L23", "6L23", "5L31", "4L31", "3L31"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["6T", "5T", "4T"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "7L41", "6M", "6L25", "5M", "5L25", "4M", "4L25", "3T", "3L25"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			xscissor: ["7M", "7L47", "6M", "6L47", "5M", "5L52", "4M", "4L52"],
		},
	},
	shedinja: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "7L1"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["3S4"],
			batonpass: ["3S5"],
			bugbite: ["6T", "5T", "4T"],
			confide: ["7M", "6M"],
			confuseray: ["7L29", "6L29", "5L31", "4L31", "3L31", "3S0"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T", "3S1"],
			furyswipes: ["7L13", "6L13", "5L14", "4L14", "3L14"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grudge: ["7L37", "6L37", "5L45", "4L45", "3L45", "3S0"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			healblock: ["7L41", "6L41", "5L52", "4L52"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			leechlife: ["7M", "6L5", "5L5", "4L5", "3L5"],
			mimic: ["3T"],
			mindreader: ["7L25", "6L19", "5L19", "4L19", "3L19"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			phantomforce: ["7L45", "6L45"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L9", "7L1", "6L9", "5L9", "4L9", "3L9"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			screech: ["3S1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "7L33", "6M", "6L33", "5M", "5L59", "4M", "4L59", "3M", "3L38", "3S0"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shadowsneak: ["7L21", "6L21", "5L38", "4L38"],
			slash: ["3S3"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["7L17", "6T", "6L17", "5T", "5L25", "4T", "4L25", "3L25", "3S0"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["3S2"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
			xscissor: ["7M", "6M", "5M", "4M", "4S6"],
		},
	},
	whismur: {
		inherit: true,
		learnset: {
			astonish: ["7L8", "6L8", "5L11", "4L11", "3L11"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			circlethrow: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			disarmingvoice: ["7E", "6E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "7L4", "6M", "6L4", "5M"],
			endeavor: ["7E", "6T", "6E", "5T", "5E", "5D", "4E"],
			endure: ["4M", "3T"],
			extrasensory: ["7E", "6E", "5E", "4E", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6E", "5E"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hammerarm: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7L11", "6L11", "5L15", "4L15", "3L15"],
			hypervoice: ["7L39", "6T", "6L39", "5T", "5L51", "4L45", "3L45"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L32", "6M", "6L32", "5M", "5L45", "4M", "4L41", "3M", "3L41"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L29", "6M", "6L29", "5M", "5L35", "4M", "4L35", "3M", "3L35"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			screech: ["7L15", "6L15", "5L31", "4L31", "3L31"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "7L36", "6M", "6L36", "5T", "5L45", "4M", "4L41", "3T", "3L41"],
			smellingsalts: ["7E", "6E", "5E", "4E", "3E"],
			smokescreen: ["7E", "6E", "5E", "4E"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stomp: ["7L22", "6L22", "5L25", "4L25", "3L25"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L18", "6L18", "5L21", "4L21", "3L21"],
			swagger: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			synchronoise: ["7L43", "6L41", "5L41"],
			takedown: ["7E", "6E", "5E", "4E", "3E"],
			teeterdance: ["3S0"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["7L25", "6T", "6L5", "5T", "5L5", "5D", "4T", "4L5", "3L5", "3S0"],
			waterpulse: ["6T", "4M", "3M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "5D", "4T"],
		},
	},
	loudred: {
		inherit: true,
		learnset: {
			astonish: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L1", "6L20", "5L20", "4L20"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "7L4", "7L1", "6M", "6L1", "5M"],
			endeavor: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7L11", "7L1", "6L1", "5L1", "4L1", "3L1"],
			hypervoice: ["7L45", "6T", "6L45", "5T", "5L65", "4L57", "3L57"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L36", "6M", "6L36", "5M", "5L57", "4M", "4L51", "3M", "3L51"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L32", "6M", "6L32", "5M", "5L43", "4M", "4L43", "3M", "3L43"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			screech: ["7L15", "6L15", "5L37", "4L37", "3L37"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "7L41", "6M", "6L41", "5T", "5L57", "4M", "4L51", "3T", "3L51"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stomp: ["7L23", "6L23", "5L29", "4L29", "3L29"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L18", "6L18", "5L23", "4L23", "3L23"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			synchronoise: ["7L50", "6L50", "5L51"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["7L27", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	exploud: {
		inherit: true,
		learnset: {
			astonish: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["7L1", "6L20", "5L20", "4L20"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			boomburst: ["7L58", "7L1", "6L1"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crunch: ["7L1", "6L40", "5L40", "4L40"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "7L4", "7L1", "6M", "6L1", "5M"],
			endeavor: ["6T", "5T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7L11", "7L1", "6L1", "5L1", "4L1", "3L1"],
			hyperbeam: ["7M", "7L64", "6M", "6L64", "5M", "5L79", "4M", "4L71", "3M", "3L40", "3S1"],
			hypervoice: ["7L47", "6T", "6L47", "5T", "5L71", "4L63", "3L63", "3S0"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7L1", "6L1", "5L1", "4L1"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L36", "6M", "6L36", "5M", "5L55", "4M", "4L55", "3M", "3L55", "3S0"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L32", "6M", "6L32", "5M", "5L45", "4M", "4L45", "3M", "3L45", "3S0", "3S1"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			screech: ["7L15", "6L15", "5L37", "4L37", "3L37", "3S1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "7L42", "6M", "6L42", "5T", "5L63", "4M", "4L55", "3T", "3L55", "3S0"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stomp: ["7L23", "6L23", "5L29", "4L29", "3L29", "3S1"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			supersonic: ["7L18", "6L18", "5L23", "4L23", "3L23"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			synchronoise: ["7L53", "6L53", "5L55"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["7L27", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	makuhita: {
		inherit: true,
		learnset: {
			armthrust: ["7L7", "6L7", "5L7", "5D", "4L7", "3L10", "3S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bellydrum: ["7L25", "6L25", "5L25", "4L25", "3L37"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7E", "6E", "5E", "4E"],
			captivate: ["4M"],
			chipaway: ["7E", "6E", "5E"],
			closecombat: ["7L40", "6L40", "5L40", "4L40"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			crosschop: ["7E", "6E", "5E", "4E", "3E"],
			detect: ["7E", "6E", "5E", "4E", "3E"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["7E", "6E", "5E", "4E", "3T", "3E"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7L37", "6L37", "5L37", "4M", "4L37", "3T", "3L40"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L10", "6L10", "5L13", "4L13", "3L19"],
			feint: ["7E", "6E", "5E", "4E"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["7E", "6T", "6E", "5E", "4M", "3M"],
			forcepalm: ["7L13", "6L13", "5L28", "4L28"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["7L46", "6L46", "5L46"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "5D", "4T", "3T"],
			knockoff: ["7L19", "6T", "6L19", "5T", "5L19", "4T", "4L19", "3L28"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7E", "6E", "5E", "4E", "3E"],
			reversal: ["7L43", "6L43", "5L43", "4L43", "3L49"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L4", "6L4", "5L4", "4L4", "3L4"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7L31", "6L31", "5L31", "4L31", "3T", "3L46"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			smellingsalts: ["7L28", "6L22", "5L22", "4L22", "3L31"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["7L22", "6L10", "5L10", "4L10", "3L13"],
			wakeupslap: ["7L34", "7E", "6L34", "6E", "5L34", "5E", "4L34", "4E"],
			whirlpool: ["4M"],
			whirlwind: ["7L16", "6L16", "5L16", "4L16", "3L22"],
			wideguard: ["7E", "6E", "5E"],
			workup: ["7M", "5M"],
		},
	},
	hariyama: {
		inherit: true,
		learnset: {
			armthrust: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bellydrum: ["7L26", "6L26", "5L27", "4L27", "3L40"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["7L1", "6L1", "5L1", "4M", "4L1"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			closecombat: ["7L46", "6L46", "5L52", "4L52"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7L42", "6L42", "5L47", "4M", "4L47", "3T", "3L44"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L10", "6L10", "5L13", "4L13", "3L19"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			focuspunch: ["6T", "4M", "3M"],
			forcepalm: ["7L13", "6L13", "5L32", "4L32"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heavyslam: ["7L54", "6L54", "5L62"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			ironhead: ["6T", "5T", "4T"],
			knockoff: ["7L19", "6T", "6L19", "5T", "5L19", "4T", "4L19", "3L29"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7L50", "6L50", "5L57", "4L57", "3L55"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7L34", "6L34", "5L37", "4L37", "3T", "3L51"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			smellingsalts: ["7L30", "6L22", "5L22", "4L22", "3L33"],
			snore: ["6T", "5T", "4T", "3T"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["7L22", "6L10", "5L10", "4L10", "3L13"],
			wakeupslap: ["7L38", "6L38", "5L42", "4L42"],
			whirlpool: ["4M"],
			whirlwind: ["7L16", "6L16", "5L16", "4L16", "3L22"],
			workup: ["7M", "5M"],
		},
	},
	nosepass: {
		inherit: true,
		learnset: {
			ancientpower: ["5D", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			block: ["7L7", "7E", "6T", "6L7", "6E", "5T", "5L19", "5E", "4T", "4L19", "4E", "3L16"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			discharge: ["7L31", "6L31", "5L55", "4L49"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["7L37", "6T", "6L37", "5T", "5L79", "4T", "4L73"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gravity: ["6T", "5T", "4T"],
			harden: ["7L4", "6L4", "5L7", "4L7", "3L7"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			irondefense: ["6T", "5T", "4T"],
			lockon: ["7L43", "6L43", "5L73", "4L67", "3L46"],
			magiccoat: ["6T", "5T", "4T"],
			magnetrise: ["6T", "5T", "4T"],
			magnitude: ["7E", "6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			powergem: ["7L25", "6L25", "5L49", "4L49"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L16", "6M", "6L16", "5M", "5L43", "4M", "4L43", "3M", "3L37"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L28", "6L18", "5L18"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L22", "6M", "6L22", "5M", "5L31", "4M", "4L31", "3T", "3L28", "3S0"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L10", "6L10", "5L13", "4L13", "3L13"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7E", "6E", "5E", "4T", "4E", "3T", "3E"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "7L34", "6M", "6L34", "5M", "5L37", "4M", "4L37", "3M", "3L31"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spark: ["7L19", "6L19", "5L25"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E", "5D", "4M"],
			stoneedge: ["7M", "7L40", "6M", "6L40", "5M", "5L61", "4M", "4L55"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7L13", "6M", "6L13", "5M", "5L25", "4M", "4L25", "3T", "3L22", "3S0"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			voltswitch: ["7M", "6M", "5M"],
			wideguard: ["7E", "6E"],
			zapcannon: ["7L43", "6L43", "5L67", "4L61", "3L43"],
		},
	},
	probopass: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M"],
			block: ["7L7", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dazzlinggleam: ["7M", "6M"],
			discharge: ["7L31", "6L31", "5L55", "4L49"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["7L37", "6T", "6L37", "5T", "5L79", "4T", "4L73"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "4T"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			irondefense: ["7L4", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			ironhead: ["6T", "5T", "4T"],
			lockon: ["7L43", "6L43", "5L73", "4L67"],
			magiccoat: ["6T", "5T", "4T"],
			magnetbomb: ["7L10", "7L1", "6L1", "5L1", "4L1"],
			magneticflux: ["7L1"],
			magnetrise: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			powergem: ["7L25", "6L25", "5L49", "4L49"],
			protect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "7L16", "6M", "6L16", "5M", "5L43", "4M", "4L43"],
			return: ["7M", "6M", "5M", "4M"],
			rockblast: ["7L28", "6L18", "5L18"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L22", "6M", "6L22", "5M", "5L31", "4M", "4L31"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "7L34", "6M", "6L34", "5M", "5L37", "4M", "4L37"],
			secretpower: ["6M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			spark: ["7L19", "6L19", "5L25"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "7L40", "6M", "6L40", "5M", "5L61", "4M", "4L55"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			taunt: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "7L13", "6M", "6L13", "5M", "5L25", "4M", "4L25"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			triattack: ["7L1"],
			voltswitch: ["7M", "6M", "5M"],
			wideguard: ["7L1", "6L1"],
			zapcannon: ["7L43", "6L43", "5L67", "4L61"],
		},
	},
	skitty: {
		inherit: true,
		learnset: {
			assist: ["7L31", "6L22", "5L22", "4L18", "3L19"],
			attract: ["7M", "7L10", "6M", "6L8", "5M", "5L8", "4M", "4L4", "3M", "3L7", "3S2"],
			batonpass: ["7E", "6E", "5E", "4E", "3E"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["7L43", "7E", "6L43", "6E", "5L46", "5E", "5D", "4M", "4L42"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L25", "6L25", "5L25", "4L22", "3L25"],
			confide: ["7M", "6M"],
			copycat: ["7L19", "6L18", "5L18", "4L11"],
			cosmicpower: ["7E", "6E"],
			covet: ["7L34", "6T", "6L34", "5T", "5L36", "4L32", "3L31"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disarmingvoice: ["7L13", "6L13"],
			doubleedge: ["7L40", "6L40", "5L42", "4L39", "3T", "3L39"],
			doubleslap: ["7L16", "6L15", "5L15", "4L15", "3L15"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L1", "7E", "6L1", "6E", "5L1", "5E", "4L1", "4E"],
			faketears: ["7E", "6E", "5E", "4E", "3E"],
			feintattack: ["7L22", "6L22", "5L29", "4L25", "3L27"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["7L4", "6L4", "5L4", "5D", "4L4"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1", "3S2"],
			headbutt: ["4T"],
			healbell: ["7L37", "6T", "6L37", "5T", "5L39", "4T", "4L36", "3L37"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			mimic: ["3T"],
			mudbomb: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			payday: ["3S0"],
			playrough: ["7L46", "6L46"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T", "3S1"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			simplebeam: ["7E", "6E", "5E"],
			sing: ["7L7", "6L7", "5L11", "4L8", "3L13"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["7E", "6E", "5E", "4T", "4E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1", "3S2"],
			tailwhip: ["7L1", "6L1", "5L1", "4L1", "3L3", "3S0", "3S1", "3S2"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			tickle: ["7E", "6E", "5E", "5D", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["7E", "6T", "6E", "5T", "5E", "4E", "3E"],
			wakeupslap: ["7L28", "6L28", "5L32", "4L29"],
			waterpulse: ["6T", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			wish: ["7E", "6E", "5E", "4E", "3E"],
			workup: ["7M", "5M"],
			zenheadbutt: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
		},
	},
	delcatty: {
		inherit: true,
		learnset: {
			attract: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1", "3S0"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L1", "6L1", "5L1", "4L1"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["3L1"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M", "3S0"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M", "3S0"],
			sing: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["3S0"],
			swift: ["4T", "3T"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T"],
			waterpulse: ["6T", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	sableye: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			astonish: ["7L9", "6L9", "5L11", "4L11", "3L13"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			calmmind: ["7M", "6M", "6S3", "5M", "4M", "3M"],
			captivate: ["7E", "6E", "5E", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L31", "6L31", "5L46", "4L46", "3L37"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dazzlinggleam: ["7M", "6M"],
			detect: ["7L14", "6L14", "5L22", "4L22", "3L25"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7L21", "6L18", "5L18", "4L18", "3L21"],
			feint: ["7E", "6E", "5E", "4E"],
			feintattack: ["7L19", "6L19", "5L32", "4L32", "3L29", "3S1"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			flatter: ["7E", "6E", "5E", "4E"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foresight: ["7L4", "6L4", "5L4", "5D", "4L4", "3L5", "3S0"],
			foulplay: ["7L41", "6T", "6L41", "5T", "5L50", "5S2"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L11", "6L11", "5L15", "4L15", "3L17"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["3S1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T"],
			imprison: ["7E", "6E"],
			incinerate: ["6M", "5M"],
			knockoff: ["7L26", "6T", "6L26", "5T", "5L29", "4T", "4L29", "3L33"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T", "4T"],
			meanlook: ["7L46", "7E", "6L1", "6E", "5L60", "5E", "4L57", "3L45"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalburst: ["7E", "6E", "5E"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["7E", "6E", "5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["7L6", "6L6", "5L8", "4L8", "3L9", "3S0"],
			octazooka: ["5S2"],
			ominouswind: ["4T"],
			painsplit: ["6T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			powergem: ["7L36", "6L36", "5L43", "4L43"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			punishment: ["7L24", "6L24", "5L36", "4L36"],
			quash: ["7M", "7L44", "6M", "6L44"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7E", "6E", "6S3", "6S4", "5E", "4E", "3E", "3S1"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "7L39", "6M", "6L39", "6S3", "5M", "5L57", "4M", "4L53", "3M", "3L41", "3S1"],
			shadowclaw: ["7M", "7L29", "6M", "6L29", "5M", "5L39", "4M", "4L39"],
			shadowsneak: ["7L16", "6L16", "5L25", "4L25"],
			shockwave: ["6T", "6S4", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "5D", "4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7E", "6E", "5E", "5D", "4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "6S4", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			tickle: ["5S2"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["7E", "6T", "6E", "5T", "5E", "5S2", "4T"],
			waterpulse: ["6T", "4M", "3M"],
			willowisp: ["7M", "6M", "6S3", "6S4", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["7L34", "6T", "6L1", "5T", "5L53", "4T", "4L50"],
		},
	},
	mawile: {
		inherit: true,
		learnset: {
			ancientpower: ["7E", "6E", "5E", "4T", "4E", "3E"],
			astonish: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L25", "6L25", "5L31", "4L31", "3L31"],
			bite: ["7L9", "6L9", "5L11", "4L11", "3L11"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["7E", "6E", "5E", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crunch: ["7L29", "6L29", "5L36", "4L36", "3L36"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fairywind: ["7L1", "6L1"],
			faketears: ["7L5", "6L5", "5L6", "5D", "4L6", "3L6", "3S0"],
			falseswipe: ["7M", "6M", "5M", "4E", "3E", "3S1"],
			feintattack: ["7L21", "6L21", "5L26", "4L26", "3L26"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7E", "6E", "6S2", "5E", "5D", "4E"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1"],
			guardswap: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7E", "6E", "5E", "4E"],
			icepunch: ["6T", "5T", "5D", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["7L33", "6T", "6L33", "5T", "5L41", "4T", "4L41", "3L41", "3S1"],
			ironhead: ["7L45", "7L1", "6T", "6L1", "6S2", "6S3", "5T", "5L56", "4T", "4L56"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T"],
			magnetrise: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalburst: ["7E", "6E", "5E"],
			mimic: ["3T"],
			mistyterrain: ["7E", "6E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			playrough: ["7L49", "7L1", "6L1", "6S2", "6S3"],
			poisonfang: ["7E", "6E", "5E", "4E", "3E"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "6S3", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4E", "3T", "3E"],
			punishment: ["7E", "6E", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7E", "6E", "3T"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sing: ["3S1"],
			slam: ["7E", "6E", "5E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spitup: ["7L41", "6L41", "5L51", "4L51", "3L46"],
			stealthrock: ["6T", "5T"],
			stockpile: ["7L41", "6L41", "5L51", "4L51", "3L46"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L37", "7E", "6L37", "6E", "6S2", "6S3", "5L46", "5E", "4T", "4L46", "4E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L41", "6L41", "5L51", "4L51", "3L46"],
			sweetscent: ["7L13", "6L13", "5L16", "4L16", "3L16"],
			swordsdance: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			taunt: ["7M", "7L1", "6M", "6L1", "5M", "4M", "3M"],
			thunderfang: ["7E", "6E", "5E", "4E"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			tickle: ["7E", "6E", "5E", "4E", "3E"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			visegrip: ["7L17", "6L17", "5L21", "4L21", "3L21", "3S1"],
		},
	},
	aron: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			autotomize: ["7L43", "6L39", "5L43"],
			bodyslam: ["7E", "6E", "5E", "4E", "3T", "3E"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L40", "6L40", "5L50", "4L43", "3T", "3L44"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonrush: ["7E", "6E", "5E", "4E"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endeavor: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			harden: ["7L1", "6L1", "5L4", "5D", "4L4", "3L4"],
			headbutt: ["7L7", "6L7", "5L11", "4T", "4L11", "3L10"],
			headsmash: ["7E", "6E", "5E", "5D", "4E"],
			heavyslam: ["7L46", "6L43", "5L46"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["7L37", "6T", "6L15", "5T", "5L18", "4T", "4L18", "3L17"],
			ironhead: ["7L22", "7E", "6T", "6L22", "6E", "5T", "5L29", "5E", "4T", "4L29", "4E"],
			irontail: ["7L34", "6T", "6L34", "5T", "5L39", "4M", "4L39", "3M", "3L29"],
			magnetrise: ["6T", "5T", "4T"],
			metalburst: ["7L49", "6L49", "5L53", "4L46"],
			metalclaw: ["7L10", "6L10", "5L15", "4L15", "3L13"],
			metalsound: ["7L31", "6L31", "5L36", "4L36", "3L39"],
			mimic: ["3T"],
			mudslap: ["7L4", "6L4", "5L8", "4T", "4L8", "3T", "3L7"],
			naturalgift: ["4M"],
			protect: ["7M", "7L16", "6M", "6L16", "5M", "5L32", "4M", "4L32", "3M", "3L34"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7E", "6E"],
			roar: ["7M", "7L19", "6M", "6L18", "5M", "5L22", "4M", "4L22", "3M", "3L21"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L25", "6M", "6L25", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "7L13", "6M", "6L13", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			screech: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smellingsalts: ["7E", "6E", "5E", "4E", "3E"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E", "4M"],
			stomp: ["7E", "6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["7E", "6T", "6E", "5T", "5E", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L28", "6L22", "5L25", "4L25", "3L25"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M", "3M"],
		},
	},
	lairon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			autotomize: ["7L47", "6L45", "5L51"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L43", "6L43", "5L62", "4L51", "3T", "3L53"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["7L7", "7L1", "6L1", "5L1", "4T", "4L1", "3L1"],
			heavyslam: ["7L51", "6L51", "5L56"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["7L39", "6T", "6L15", "5T", "5L18", "4T", "4L18", "3L17"],
			ironhead: ["7L22", "6T", "6L22", "5T", "5L29", "4T", "4L29"],
			irontail: ["7L35", "6T", "6L35", "5T", "5L45", "4M", "4L45", "3M", "3L29"],
			magnetrise: ["6T", "5T", "4T"],
			metalburst: ["7L55", "6L55", "5L67", "4L56"],
			metalclaw: ["7L10", "6L10", "5L15", "4L15", "3L13"],
			metalsound: ["7L31", "6L31", "5L40", "4L40", "3L45"],
			mimic: ["3T"],
			mudslap: ["7L4", "7L1", "6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			naturalgift: ["4M"],
			protect: ["7M", "7L16", "6M", "6L16", "5M", "5L34", "4M", "4L34", "3M", "3L37"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L19", "6M", "6L18", "5M", "5L22", "4M", "4L22", "3M", "3L21"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L25", "6M", "6L25", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "7L13", "6M", "6L13", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L28", "6L22", "5L25", "4L25", "3L25"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M", "3M"],
		},
	},
	aggron: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			autotomize: ["7L51", "6L48", "5L57"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7L45", "6L45", "5L74", "4L57", "3T", "3L63", "3S0"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "6S2", "5M", "4M", "3M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["7L7", "7L1", "6L1", "5L1", "4T", "4L1", "3L1"],
			headsmash: ["6S2"],
			heavyslam: ["7L57", "6L57", "5L65"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irondefense: ["7L39", "6T", "6L15", "5T", "5L18", "4T", "4L18", "3L17"],
			ironhead: ["7L22", "6T", "6L22", "6S2", "5T", "5L29", "4T", "4L29"],
			irontail: ["7L35", "6T", "6L35", "5T", "5L48", "4M", "4L48", "3M", "3L29", "3S0", "3S1"],
			lowkick: ["6T", "5T", "4T"],
			magnetrise: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalburst: ["7L63", "6L63", "5L82", "4L65"],
			metalclaw: ["7L10", "6L10", "5L15", "4L15", "3L13"],
			metalsound: ["7L31", "6L31", "5L40", "4L40", "3L50", "3S0", "3S1"],
			mimic: ["3T"],
			mudslap: ["7L4", "7L1", "6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "7L16", "6M", "6L16", "5M", "5L34", "4M", "4L34", "3M", "3L37", "3S0", "3S1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L19", "6M", "6L18", "5M", "5L22", "4M", "4L22", "3M", "3L21"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L25", "6M", "6L25", "6S2", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "7L13", "6M", "6L13", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			smartstrike: ["7M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L28", "6L22", "5L25", "4L25", "3L25", "3S1"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	meditite: {
		inherit: true,
		learnset: {
			acupressure: ["7L33", "6L33", "5L39"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7E", "6E", "5E", "4E", "3E"],
			bide: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulletpunch: ["7E", "6E", "5E", "4E"],
			calmmind: ["7M", "7L23", "6M", "6L23", "5M", "5L25", "4M", "4L25", "3M", "3L28"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L7", "6L7", "5L8", "4L8", "3L9", "3S0", "3S1"],
			counter: ["7L44", "6L44", "3T"],
			detect: ["7L9", "6L9", "5L11", "4L11", "3L12", "3S1"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["7E", "6T", "6E", "5T", "5E", "5D", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["7E", "6E", "5E", "4E", "3T", "3E", "3S1"],
			endure: ["7L12", "6L12", "5D", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "4E", "3E"],
			feint: ["7L15", "6L15", "5L22", "4L22"],
			firepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			forcepalm: ["7L17", "6L17", "5L29", "4L29"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			guardswap: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "7L20", "6M", "6L15", "5M", "5L15", "4M", "4L15", "3M", "3L17"],
			highjumpkick: ["7L28", "6L28", "5L32", "4L32", "3L32"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T", "4T"],
			meditate: ["7L4", "6L4", "5L4", "5D", "4L4", "3L4", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["7L25", "6L18", "5L18", "4L18", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			powerswap: ["7E", "6E", "5E", "4E"],
			powertrick: ["7L36", "6L36", "5L43", "4L39"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychocut: ["7E", "6E", "5E", "4E"],
			psychup: ["7M", "7L31", "6M", "6L31", "5M", "5L36", "4M", "4L36", "3T", "3L36"],
			psyshock: ["7M", "6M", "5M"],
			quickguard: ["7E", "6E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L41", "6L41", "5L50", "4L46", "3L44"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7L39", "6L39", "5L46", "4L43", "3L41"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["7E", "6M", "6E", "5E", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T", "3L20"],
			swift: ["4T", "3T"],
			telekinesis: ["5M"],
			thunderpunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			vacuumwave: ["4T"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	medicham: {
		inherit: true,
		learnset: {
			acupressure: ["7L33", "6L33", "5L42"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			calmmind: ["7M", "7L23", "6M", "6L23", "5M", "5L25", "4M", "4L25", "3M", "3L28"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			counter: ["7L53", "6L53", "3T"],
			detect: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["7L12", "6L12", "4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7L15", "6L15", "5L22", "4L22"],
			firepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3T", "3L1"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			forcepalm: ["7L17", "6L17", "5L29", "4L29"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "7L20", "6M", "6L15", "5M", "5L15", "4M", "4L15", "3M", "3L17"],
			highjumpkick: ["7L28", "6L28", "5L32", "4L32", "3L32"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3T", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T", "4T"],
			meditate: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["7L25", "6L18", "5L18", "4L18", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			powertrick: ["7L36", "6L36", "5L49", "4L42"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "7L31", "6M", "6L31", "5M", "5L36", "4M", "4L36", "3T", "3L36"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L47", "6L47", "5L62", "4L55", "3L54"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			reversal: ["7L42", "6L42", "5L55", "4L49", "3L46"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T", "3L20"],
			swift: ["4T", "3T"],
			telekinesis: ["5M"],
			thunderpunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3T", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			vacuumwave: ["4T"],
			workup: ["7M", "5M"],
			zenheadbutt: ["7L1", "6T", "6L1", "5T", "4T"],
		},
	},
	electrike: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L24", "6L24", "5L28", "4L28", "3L33"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["7L44", "6L44", "5L44", "4L44", "3L41"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			crunch: ["7E", "6E", "5E", "4E", "3E"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			discharge: ["7L29", "7E", "6L29", "6E", "5L41", "5E", "4L41", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			eerieimpulse: ["7E", "6E"],
			electroball: ["7E", "6E", "5E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7E", "6E", "5E", "4E"],
			flameburst: ["7E", "6E", "5E"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["7E", "6E", "5E", "4T", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7L7", "6L7", "5L12", "4L12", "3L12"],
			icefang: ["7E", "6E", "5E", "5D", "4E"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L4", "6L4", "5L9", "4L9", "3L9"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magnetrise: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["7L16", "6L16", "5L25", "4L25", "3L25"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L10", "6L10", "5L17", "4L17", "3L17"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L34", "6M", "6L34", "5M", "5L36", "4M", "4L36", "3M", "3L28"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["7E", "6T", "6E", "5E", "4M", "3M"],
			signalbeam: ["6T", "5T", "5D", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spark: ["7L13", "6L13", "5L20", "4L20", "3L20"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7E", "6E", "5E", "4T", "4E", "3T", "3E"],
			switcheroo: ["7E", "6E", "5E", "4E"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7L49", "6M", "6L49", "5M", "5L52", "4M", "4L49", "3M", "3L36"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderfang: ["7L19", "7E", "6L19", "6E", "5L33", "5E", "4L33", "4E"],
			thunderwave: ["7M", "7L1", "6M", "6L1", "5M", "5L4", "5D", "4M", "4L4", "3T", "3L4"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["7E", "6T", "6E", "5T", "5E", "4E", "3E"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "7L39", "6M", "6L39", "5M", "5L49"],
		},
	},
	manectric: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L24", "6L24", "5L30", "4L30", "3L39", "3S0"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["7L48", "6L48", "5L54", "4L54", "3L53"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			discharge: ["7L30", "6L30", "5L49", "4L49"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			electricterrain: ["7L60", "7L1", "6L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magnetrise: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["7L16", "6L16", "5L25", "4L25", "3L25"],
			overheat: ["7M", "6M", "6S1", "5M", "4M"],
			protect: ["7M", "6M", "6S1", "5M", "4M", "3M"],
			quickattack: ["7L10", "6L10", "5L17", "4L17", "3L17"],
			raindance: ["7M", "6M", "5M", "4M", "3M", "3S0"],
			refresh: ["3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "7L36", "6M", "6L36", "5M", "5L42", "4M", "4L42", "3M", "3L31"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spark: ["7L13", "6L13", "5L20", "4L20", "3L20"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "7L54", "6M", "6L54", "5M", "5L66", "4M", "4L61", "3M", "3L45", "3S0"],
			thunderbolt: ["7M", "6M", "6S1", "5M", "4M", "3M"],
			thunderfang: ["7L19", "6L19", "5L37", "4L37"],
			thunderwave: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T"],
			voltswitch: ["7M", "6M", "6S1", "5M"],
			wildcharge: ["7M", "7L42", "6M", "6L42", "5M", "5L61"],
		},
	},
	plusle: {
		inherit: true,
		learnset: {
			agility: ["7L37", "6L37", "5L48", "4L44", "3L47"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L34", "6L34", "5L44", "4L42", "3L40"],
			bestow: ["7L13", "6L13"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["7L28", "6L28", "5L38", "4L35", "3L31"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L25", "7E", "6L25"],
			confide: ["7M", "6M"],
			copycat: ["7L22", "6L22", "5L24", "4L24"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["7L31", "7E", "6L31", "6E", "5E", "5D", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			electroball: ["7L19", "6L19", "5L29"],
			electroweb: ["6T"],
			encore: ["7L10", "6L10", "5L17", "4L17", "3L22"],
			endure: ["4M", "3T"],
			entrainment: ["7L49", "6L1", "5L63"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6L35", "5L21", "4L21", "3L28"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			headbutt: ["4T"],
			helpinghand: ["7L4", "6T", "6L4", "5T", "5L10", "4T", "4L10", "3L13"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["7L40", "6T", "6L40", "5T", "5L51", "4T", "4L48"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7E", "6E", "5E"],
			magnetrise: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S0"],
			nastyplot: ["7L46", "6L1", "5L56", "4L51"],
			naturalgift: ["4M"],
			nuzzle: ["7L1", "6L1"],
			playnice: ["7L1", "6L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L1", "6L1", "5L7", "4L7", "3L10", "3S1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "5D", "4T"],
			sing: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spark: ["7L7", "6L7", "5L15", "4L15", "3L19"],
			substitute: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["7E", "6E", "5E", "4E"],
			swift: ["7L16", "6L16", "5L31", "4T", "4L29", "3T"],
			thunder: ["7M", "7L43", "6M", "6L42", "5M", "5L42", "4M", "4L38", "3M", "3L37"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7L1", "6M", "6L1", "5M", "5L3", "5D", "4M", "4L3", "3T", "3L4", "3S0", "3S1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			wish: ["7E", "6E", "5E", "4E", "3E"],
		},
	},
	minun: {
		inherit: true,
		learnset: {
			agility: ["7L37", "6L37", "5L48", "4L44", "3L47"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L34", "6L34", "5L44", "4L42", "3L40"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["7L28", "6L28", "5L38", "4L35", "3L31"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7E", "6L21", "5L21", "4L21", "3L28"],
			confide: ["7M", "6M"],
			copycat: ["7L22", "6L22", "5L24", "4L24"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["7L31", "7E", "6L31", "6E", "5E", "5D", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["7M", "6M", "5M"],
			electroball: ["7L19", "6L19", "5L29"],
			electroweb: ["6T"],
			encore: ["7L10", "6L10", "5L17", "4L17", "3L22"],
			endure: ["4M", "3T"],
			entrainment: ["7L49", "6L1", "5L63"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7L25", "7E", "6L25", "5L35", "4L31"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			headbutt: ["4T"],
			helpinghand: ["7L4", "6T", "6L4", "5T", "5L10", "4T", "4L10", "3L13"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			irontail: ["6T", "5T", "4M", "3M"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7E", "6E", "5E"],
			magnetrise: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7L46", "6L1", "5L56", "4L51"],
			naturalgift: ["4M"],
			nuzzle: ["7L1", "6L1"],
			playnice: ["7L1", "6L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7L1", "6L1", "5L7", "4L7", "3L10", "3S1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "5D", "4T"],
			sing: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spark: ["7L7", "6L7", "5L15", "4L15", "3L19"],
			substitute: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["7E", "6E", "5E", "4E"],
			swift: ["7L16", "6L16", "5L31", "4T", "4L29", "3T"],
			switcheroo: ["7L13", "6L13"],
			thunder: ["7M", "7L43", "6M", "6L42", "5M", "5L42", "4M", "4L38", "3M", "3L37"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "7L1", "6M", "6L1", "5M", "5L3", "5D", "4M", "4L3", "3T", "3L4", "3S0", "3S1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trumpcard: ["7L40", "6L40", "5L51", "4L48"],
			uproar: ["6T", "5T", "4T"],
			voltswitch: ["7M", "6M", "5M"],
			watersport: ["3S0"],
			wildcharge: ["7M", "6M", "5M"],
			wish: ["7E", "6E", "5E", "4E", "3E"],
		},
	},
	volbeat: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L40", "7E", "6L40", "6E", "5L41", "5E", "4L41", "4E"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L8", "6L8", "5L9", "4L9", "3L5"],
			counter: ["3T"],
			dazzlinggleam: ["7M", "6M"],
			dizzypunch: ["7E", "6E", "5E"],
			doubleedge: ["7L47", "6L45", "5L45", "4L45", "3T", "3L37"],
			doubleteam: ["7M", "7L5", "6M", "6L5", "5M", "5L5", "4M", "4L5", "3M", "3L9"],
			dynamicpunch: ["3T"],
			encore: ["7E", "6E", "5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["7L1", "6M", "6L1", "5M", "5L1", "5D", "4M", "4L1", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			helpinghand: ["7L36", "6T", "6L33", "5T", "5L33", "4T", "4L33", "3L33"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "7L50"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["7L19", "6L13", "5L13", "4L13", "3L13"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			playrough: ["7L43", "6L43"],
			poweruppunch: ["6M"],
			protect: ["7M", "7L29", "6M", "6L29", "5M", "5L29", "4M", "4L29", "3M", "3L29"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			quickattack: ["7L12", "6L12", "5L17", "4L17", "3L17"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["7E", "6E", "5E", "3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["7L26", "6T", "6L25", "5T", "5L25", "4T", "4L25", "3L25"],
			silverwind: ["7E", "6E", "5E", "4M", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["7L15", "6M", "6L15", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailglow: ["7L22", "6L21", "5L21", "4L21", "3L21"],
			tailwind: ["6T", "5T", "5D", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["7E", "6T", "6E", "5T", "5E", "5D", "4E", "3E"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M", "3M"],
			zenheadbutt: ["7L33", "6T", "6L33", "5T", "5L37", "4T", "4L37"],
		},
	},
	illumise: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L40", "7E", "6L40", "6E", "5L41", "5E", "4L41", "4E"],
			captivate: ["7E", "6E", "5E", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L9", "6L9", "5L9", "5D", "4L9", "3L9"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E"],
			counter: ["3T"],
			covet: ["7L47", "6T", "6L45", "5T", "5L45", "4L45", "3L37"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["7L26", "7E", "6L25", "6E", "5L25", "5E", "4L25", "4E", "3L25"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6E", "5E", "5D"],
			flash: ["6M", "5M", "4M", "3M"],
			flatter: ["7L29", "6L29", "5L29", "4L29", "3L29"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			growth: ["7E", "6E", "5E", "4E", "3E"],
			helpinghand: ["7L36", "6T", "6L33", "5T", "5L33", "4T", "4L33", "3L33"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "7L50"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["7L19", "6L13", "5L13", "4L13", "3L13"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			playnice: ["7L1", "6L1"],
			playrough: ["7L43", "6L43"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			quickattack: ["7L12", "6L12", "5L17", "4L17", "3L17"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			silverwind: ["7E", "6E", "5E", "4M", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["7L15", "6M", "6L15", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L5", "6L5", "5L5", "4L5", "3L5"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwind: ["6T", "5T", "5D", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M", "3M"],
			wish: ["7L22", "6L21", "5L21", "4L21", "3L21"],
			zenheadbutt: ["7L33", "6T", "6L33", "5T", "5L37", "4T", "4L37"],
		},
	},
	budew: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cottonspore: ["7E", "6E", "5E", "4E"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			extrasensory: ["7E", "6E", "5E", "4E"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["7E", "6T", "6E", "5T", "5E", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["7E", "6E", "5E"],
			growth: ["7L4", "6L4", "5L4", "4L4"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			leafstorm: ["7E", "6E", "5E", "4E"],
			megadrain: ["7L13", "6L13", "5L13", "4L13"],
			mindreader: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			naturepower: ["7M", "6M"],
			pinmissile: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			razorleaf: ["7E", "6E", "5E", "4E"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["7E", "6T", "6E", "5T", "5E", "4T"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sleeppowder: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			spikes: ["7E", "6E", "5E", "4E"],
			stunspore: ["7L10", "6L10", "5L10", "4L10"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
			watersport: ["7L7", "6L7", "5L7", "4L7"],
			worryseed: ["7L16", "6T", "6L16", "5T", "5L16", "4T", "4L16"],
		},
	},
	roselia: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			aromatherapy: ["7L43", "6L43", "5L43", "4L43", "3L53"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["7E", "6E", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cottonspore: ["7E", "6E", "5E", "4E", "3E"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M", "3M"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["7L25", "7E", "6T", "6L25", "6E", "5T", "5L25", "5E", "4M", "4L25", "3M", "3L33"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["7L22", "7E", "6L22", "6E", "5L22", "5E", "4L22", "3L29", "3S1"],
			growth: ["7L4", "6L4", "5L4", "5D", "4L4", "3L5", "3S0"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			ingrain: ["7L34", "6L34", "5L34", "4L34", "3L41"],
			leafstorm: ["7E", "6E", "5E", "4E"],
			leechseed: ["7L16", "6L16", "5L16", "4L16", "3L21", "3S1"],
			magicalleaf: ["7L19", "6L19", "5L19", "4L19", "3L25", "3S1"],
			megadrain: ["7L13", "6L13", "5L13", "4L13", "3L17"],
			mimic: ["3T"],
			mindreader: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			naturepower: ["7M", "6M"],
			nightmare: ["3T"],
			petalblizzard: ["7L37", "6L37"],
			petaldance: ["7L50", "6L37", "5L40", "4L40", "3L49"],
			pinmissile: ["7E", "6E", "5E", "4E", "3E"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L7", "6L7", "5L7", "4L7", "3L9", "3S0"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M"],
			razorleaf: ["7E", "6E", "5E", "4E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["7E", "6T", "6E", "5T", "5E", "4T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sleeppowder: ["7E", "6E", "5E", "5D", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spikes: ["7E", "6E", "5E", "4E", "3E"],
			stunspore: ["7L10", "6L10", "5L10", "4L10", "3L13"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["3S1"],
			sweetscent: ["7L31", "6L31", "5L31", "4L31", "3L37"],
			swift: ["5D", "4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7L46", "7E", "6T", "6L46", "6E", "5T", "5L46", "5E", "4T", "4L46", "4E", "3L57", "3E"],
			toxic: ["7M", "7L40", "6M", "6L40", "5M", "5L37", "4M", "4L37", "3M", "3L45"],
			toxicspikes: ["7L28", "6L28", "5L28", "4L28"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	roserade: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigadrain: ["6T", "5T", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grassyterrain: ["7L1", "6L1"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			magicalleaf: ["7L1", "6L1", "5L1", "4L1"],
			megadrain: ["7L1", "6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L1", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			sweetscent: ["7L1", "6L1", "5L1", "4L1"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			venomdrench: ["7L1", "6L1"],
			venoshock: ["7M", "6M", "5M"],
			weatherball: ["7L1", "6L1", "5L1", "4L1"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	gulpin: {
		inherit: true,
		learnset: {
			acidarmor: ["7E", "6E", "5E", "5D", "4E", "3E"],
			acidspray: ["7L17", "6L17", "5L34"],
			amnesia: ["7L12", "6L12", "5L17", "4L17", "3L17"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7L41", "6L40"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			curse: ["7E", "6E", "5E", "4E"],
			defensecurl: ["3T"],
			destinybond: ["7E", "6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			dynamicpunch: ["3T"],
			encore: ["7L20", "6L20", "5L23", "4L23", "3L23"],
			endure: ["4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["7L36", "6T", "6L36", "5T", "5L49", "4T", "4L44"],
			gigadrain: ["6T", "5T", "5D", "4M", "3M"],
			gunkshot: ["7L49", "7E", "6T", "6L49", "6E", "5T", "5L59", "5E", "4T", "4L54"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			mimic: ["3T"],
			mudslap: ["7E", "6E", "5E", "4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			poisongas: ["7L8", "6L8", "5L9", "5D", "4L9", "3L9"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M", "3S0"],
			sing: ["3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludge: ["7L10", "6L10", "5L14", "4L14", "3L14", "3S0"],
			sludgebomb: ["7M", "7L33", "6M", "6L33", "5M", "5L44", "4M", "4L39", "3M", "3L39"],
			sludgewave: ["7M", "6M", "5M"],
			smog: ["7E", "6E", "5E", "4E", "3E"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spitup: ["7L28", "6L28", "5L39", "4L34", "3L34"],
			stockpile: ["7L28", "6L28", "5L39", "4L34", "3L34"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L28", "6L28", "5L39", "4L34", "3L34"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7L25", "6M", "6L25", "5M", "5L28", "4M", "4L28", "3M", "3L28", "3S0"],
			venomdrench: ["7E", "6E"],
			venoshock: ["7M", "6M", "5M"],
			waterpulse: ["6T", "4M", "3M"],
			wringout: ["7L44", "6L44", "5L54", "4L49"],
			yawn: ["7L5", "6L5", "5L6", "4L6", "3L6"],
		},
	},
	swalot: {
		inherit: true,
		learnset: {
			acidspray: ["7L17", "6L17", "5L38"],
			amnesia: ["7L12", "6L12", "5L17", "4L17", "3L17"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7L49", "6L46"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7L1", "6L26", "5L26", "4L26", "3T", "3L26"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			encore: ["7L20", "6L20", "5L23", "4L23", "3L23"],
			endure: ["4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["7L42", "6T", "6L42", "5T", "5L59", "4T", "4L52"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gunkshot: ["7L61", "7L1", "6T", "6L1", "5T", "5L73", "4T", "4L66"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["6T", "5T", "4T"],
			poisongas: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			pound: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludge: ["7L10", "7L1", "6L1", "5L1", "4L1", "3L1"],
			sludgebomb: ["7M", "7L37", "6M", "6L37", "5M", "5L52", "4M", "4L45", "3M", "3L48"],
			sludgewave: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spitup: ["7L30", "6L30", "5L45", "4L38", "3L40"],
			stockpile: ["7L30", "6L30", "5L45", "4L38", "3L40"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L30", "6L30", "5L45", "4L38", "3L40"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "7L25", "6M", "6L25", "5M", "5L30", "4M", "4L30", "3M", "3L31"],
			venomdrench: ["7L1"],
			venoshock: ["7M", "6M", "5M"],
			waterpulse: ["6T", "4M", "3M"],
			wringout: ["7L54", "7L1", "6L1", "5L66", "4L59"],
			yawn: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
		},
	},
	carvanha: {
		inherit: true,
		learnset: {
			agility: ["7L39", "6L36", "5L36", "4L36", "3L43"],
			ancientpower: ["7E", "6E", "5E", "4T", "4E"],
			aquajet: ["7L11", "6L11", "5L31", "4L31"],
			assurance: ["7L15", "6L15", "5L26", "4L26"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L1", "6L1", "6S1", "5L1", "5D", "4L1", "3L1", "3S0"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["7E", "6E", "5E", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L36", "6L28", "5L28", "4L28", "3L22"],
			darkpulse: ["7M", "6M", "5T", "5D", "4M"],
			destinybond: ["7E", "6E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			focusenergy: ["7L8", "6L8", "5L8", "4L8", "3L13"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7E", "6E", "6S1", "5E", "4E", "3E"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7L25", "6L16", "5L16", "4L16"],
			icywind: ["6T", "5T", "4T", "3T"],
			leer: ["7L1", "6L1", "6S1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonfang: ["7L32", "6L32"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychicfangs: ["7E"],
			rage: ["7L4", "6L4", "5L6", "4L6", "3L7"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			scaryface: ["7L29", "6L11", "5L11", "4L11", "3L16", "3S0"],
			screech: ["7L18", "6L18", "5L18", "4L18", "3L28"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superfang: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L22", "6M", "6L21", "5M", "5L21", "4M", "4L21", "3T", "3L37"],
			swift: ["7E", "6E", "5E", "4T", "3T"],
			takedown: ["7L43", "6L38", "5L38", "4L38", "3L31"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7E", "6E", "5E", "5D", "4E", "3E"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M", "3S0"],
			whirlpool: ["4M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	sharpedo: {
		inherit: true,
		learnset: {
			agility: ["7L45", "6L45", "5L45", "4L45", "3L53"],
			ancientpower: ["4T"],
			aquajet: ["7L11", "6L11", "6S0", "5L34", "4L34"],
			assurance: ["7L15", "6L15", "5L26", "4L26"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L40", "6L28", "6S0", "6S1", "5L28", "4L28", "3L22"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			destinybond: ["6S0"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7L1", "6L1", "5L1", "4L1"],
			focusenergy: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7L25", "6L16", "6S0", "5L16", "4L16"],
			icywind: ["6T", "5T", "4T", "3T"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["7L62", "7L1", "6L1", "5L56", "4L56"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonfang: ["7L34", "6L34", "6S1"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			scaryface: ["7L29", "6L11", "6S1", "5L11", "4L11", "3L16"],
			screech: ["7L18", "6L18", "5L18", "4L18", "3L28"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7L51", "6L50", "5L50", "4L50", "3L48"],
			slash: ["7L1", "6L30", "6S1", "5L30", "4L30", "3L33"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superfang: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L22", "6M", "6L21", "5M", "5L21", "4M", "4L21", "3T", "3L43"],
			swift: ["4T", "3T"],
			taunt: ["7M", "7L56", "6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L38"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	wailmer: {
		inherit: true,
		learnset: {
			amnesia: ["7L37", "6L37", "5L37", "4L37", "3L46"],
			aquaring: ["7E", "6E", "5E", "4E"],
			astonish: ["7L16", "6L16", "5L17", "4L17", "3L23"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "4E", "3T"],
			bounce: ["7L45", "6T", "6L44", "5T", "5L44", "5D", "4T", "4L44"],
			brine: ["7L25", "6L25", "5L31", "4M", "4L31"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			clearsmog: ["7E", "6E"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			defensecurl: ["7E", "6E", "5E", "4E", "3T"],
			dive: ["7L41", "6M", "6L33", "5M", "5L41", "4T", "4L41", "3M"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L4", "6L4", "5L4", "4L4", "3L5"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["7L53", "6L50", "5L50"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L49", "6L47", "5L47", "4L47", "3L50"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			mimic: ["3T"],
			mist: ["7L22", "6L22", "5L24", "4L24", "3L32"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L29", "6M", "6L27", "5M", "5L27", "4M", "4L27", "3M", "3L37"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L10", "6L10", "5L11", "4T", "4L11", "3T", "3L14"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "5D", "4M", "4E", "3T", "3E"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T", "3E"],
			soak: ["7E", "6E", "5E"],
			splash: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			thrash: ["7E", "6E", "5E", "4E", "3E"],
			tickle: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L7", "6L7", "5L7", "5D", "4L7", "3L10"],
			waterpulse: ["7L19", "6T", "6L19", "5L21", "4M", "4L21", "3M", "3L28"],
			waterspout: ["7L33", "6L34", "5L34", "4L34", "3L41"],
			whirlpool: ["7L13", "6L13", "5L14", "4M", "4L14", "3L19"],
			zenheadbutt: ["7E", "6T", "6E", "5T", "5E"],
		},
	},
	wailord: {
		inherit: true,
		learnset: {
			amnesia: ["7L37", "6L37", "5L37", "4L37", "3L52", "3S0"],
			astonish: ["7L16", "6L16", "5L17", "4L17", "3L23"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			bounce: ["7L51", "6T", "6L51", "5T", "5L54", "4T", "4L54"],
			brine: ["7L25", "6L29", "5L31", "4M", "4L31"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defensecurl: ["3T"],
			dive: ["7L44", "6M", "6L44", "5M", "5L46", "4T", "4L46", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["7L65", "7L1", "6L1", "5L70"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L58", "6L58", "5L62", "4L62", "3L59", "3S0"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			ironhead: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mist: ["7L22", "6L22", "5L24", "4L24", "3L32", "3S1"],
			naturalgift: ["4M"],
			nobleroar: ["7L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L29", "6M", "6L25", "5M", "5L27", "4M", "4L27", "3M", "3L37", "3S0", "3S1"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L10", "7L1", "6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7L1"],
			splash: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["7L19", "6T", "6L19", "5L21", "4M", "4L21", "3M", "3L28", "3S1"],
			waterspout: ["7L33", "6L33", "5L34", "4L34", "3L44", "3S0", "3S1"],
			whirlpool: ["7L13", "6L13", "5L14", "4M", "4L14", "3L19"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	numel: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			amnesia: ["7L19", "6L19", "5L31", "4L25", "3L31"],
			ancientpower: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "5D", "4E", "3T", "3E"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			charm: ["3S0"],
			confide: ["7M", "6M"],
			curse: ["7L29", "6L29", "5L29"],
			defensecurl: ["7E", "6E", "5E", "4E", "3T", "3E"],
			dig: ["6M", "5M", "4M", "3M", "3S0"],
			doubleedge: ["7L47", "6L47", "5L55", "4L51", "3T", "3L49"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["7L26", "6T", "6L26", "5T", "5L41", "4T", "4L35"],
			earthquake: ["7M", "7L40", "6M", "6L40", "5M", "5L45", "4M", "4L41", "3M", "3L35"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L5", "6L5", "5L5", "5D", "4L5", "3L11", "3S0"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flameburst: ["7L15", "6L15", "5L21"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L43", "6M", "6L43", "5M", "5L51", "4M", "4L45", "3M", "3L41"],
			focusenergy: ["7L8", "6L8", "5L15", "4L15", "3L25"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "6S1", "5L1", "4L1", "3L1"],
			growth: ["7E", "6E"],
			headbutt: ["4T"],
			heatwave: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			howl: ["7E", "6E", "5E", "4E", "3E"],
			incinerate: ["6M", "5M"],
			ironhead: ["7E", "6T", "6E", "6S1", "5T", "5E"],
			lavaplume: ["7L22", "6L22", "5L35", "4L31"],
			magnitude: ["7L12", "6L8", "5L11", "4L11", "3L19"],
			mimic: ["3T"],
			mudbomb: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7E", "6E", "5E", "4T", "4E", "3T", "3E"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scaryface: ["7E", "6E", "5E", "4E", "3E"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spitup: ["7E", "6E", "5E", "4E"],
			stealthrock: ["6T", "5T", "4M"],
			stockpile: ["7E", "6E", "5E", "4E"],
			stomp: ["7E", "6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7E", "6E", "5E", "4E"],
			tackle: ["7L1", "6L1", "6S1", "5L1", "4L1", "3L1"],
			takedown: ["7L31", "6L31", "5L25", "4L21", "3L29", "3S0"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			yawn: ["7L36", "7E", "6L36", "6E", "5L36", "5E", "4E"],
		},
	},
	camerupt: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			amnesia: ["7L19", "6L19", "5L31", "4L25", "3L31"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			curse: ["7L29", "6L29", "6S0", "5L29"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["7L26", "6T", "6L26", "5T", "5L49", "4T", "4L39"],
			earthquake: ["7M", "7L46", "6M", "6L46", "5M", "5L57", "4M", "4L49", "3M", "3L37"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L8", "7L1", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			eruption: ["7L52", "7L1", "6L1", "5L67", "4L57", "3L45"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7L59", "7L1", "6L1", "5L75", "4L67", "3L55"],
			flameburst: ["7L15", "6L15", "5L21"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L8", "7L1", "6L1", "5L15", "4L15", "3L25"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			lavaplume: ["7L22", "6L22", "5L33", "4L31"],
			magnitude: ["7L12", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "7L1", "6M", "6L33", "6S0", "5M", "5L39", "4M", "4L33", "3T", "3L33"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L31", "6L31", "6S0", "5L25", "4L21", "3L29"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			yawn: ["7L39", "6L39", "6S0", "5L39"],
		},
	},
	torkoal: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			amnesia: ["7L40", "6L40", "5L49", "4L49", "3L40"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7L27", "6L27", "5L33", "4L33", "3T", "3L20"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			clearsmog: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			curse: ["7L22", "6L12", "5L12", "4L12", "3L7"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "4E"],
			ember: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			endure: ["7E", "6E", "5E", "4M", "4E", "3T", "3E"],
			eruption: ["7E", "6E", "5E", "4E", "3E"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firespin: ["7L13", "6L13", "5L17", "4L17", "3L17"],
			fissure: ["7E", "6E", "5E", "5D", "4E"],
			flail: ["7L42", "6L1", "5L52", "4L52", "3L43"],
			flameburst: ["7E", "6E", "5E"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L34", "6M", "6L28", "5M", "5L28", "4M", "4L28", "3M", "3L30"],
			flamewheel: ["7L18", "6L18"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["7L45", "6T", "6L1", "5T", "5L55", "4T", "4L55", "3L46"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			inferno: ["7L50", "6L1", "5L60"],
			irondefense: ["7L38", "6T", "6L38", "5T", "5L44", "4T", "4L44", "3L33"],
			irontail: ["6T", "5T", "4M", "3M"],
			lavaplume: ["7L25", "6L25", "5L39", "4L39"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			protect: ["7M", "7L30", "6M", "6L1", "5M", "5L36", "4M", "4L36", "3M", "3L27"],
			rapidspin: ["7L10", "6L10", "5L23", "4L23"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shellsmash: ["7L47", "6L1", "5L65"],
			skullbash: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "4E", "3T", "3E"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			smog: ["7L4", "6L4", "5L4", "4L4", "3L4"],
			smokescreen: ["7L15", "6L15", "5L20", "4L20", "3L14"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stealthrock: ["6T", "5T", "5D", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["7E", "6T", "6E"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			withdraw: ["7L7", "6L7", "5L7", "4L7"],
			yawn: ["7E", "6E", "5E", "4E", "3E"],
		},
	},
	spoink: {
		inherit: true,
		learnset: {
			amnesia: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["7L50", "6T", "6L50", "5T", "5L53", "4T", "4L48", "3L43"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L18", "6L18", "5L18", "4L18", "3L25"],
			covet: ["6T", "5T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			extrasensory: ["7E", "6E", "5E", "4E", "3E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E", "6E", "5E", "4E", "3E"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			luckychant: ["7E", "6E", "5E"],
			magiccoat: ["7L21", "6T", "6L21", "5T", "5L21", "4T", "4L21", "3L28"],
			mimic: ["3T"],
			mirrorcoat: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			odorsleuth: ["7L10", "6L10", "5L10", "4L10", "3L10"],
			payback: ["7M", "7L40", "6M", "6L40", "5M", "5L41", "4M", "4L34"],
			powergem: ["7L29", "6L29", "5L48", "4L46"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L14", "6L14", "5L14", "4L14", "3L16"],
			psychic: ["7M", "7L44", "6M", "6L44", "5M", "5L46", "4M", "4L41", "3M", "3L34"],
			psychup: ["7M", "7L15", "6M", "6L15", "5M", "5L15", "4M", "4L15", "3T", "3L19"],
			psyshock: ["7M", "7L38", "6M", "6L38", "5M", "5L34"],
			psywave: ["7L7", "6L7", "5L7", "5D", "4L7", "3L7"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "5D", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L29", "6M", "6L29", "5M", "5L29", "4M", "4L29", "3M", "3L37"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			simplebeam: ["7E", "6E"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "5D", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["7L33", "6T", "6L29", "5T", "5L29", "4T", "4L29", "3T", "3L37"],
			splash: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			substitute: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["3S0"],
			whirlwind: ["7E", "6E", "5E"],
			zenheadbutt: ["7L26", "7E", "6T", "6L26", "6E", "5T", "5L26", "5E", "4T", "4L26", "4E"],
		},
	},
	grumpig: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7L1"],
			bodyslam: ["3T"],
			bounce: ["7L60", "6T", "6L60", "5T", "5L68", "4T", "4L60", "3L55"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L18", "6L18", "5L18", "4L18", "3L25"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["7L21", "6T", "6L21", "5T", "5L21", "4T", "4L21", "3L28"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["7L10", "7L1", "6L1", "5L1", "4L1", "3L1"],
			payback: ["7M", "7L46", "6M", "6L46", "5M", "5L47", "4M", "4L37"],
			powergem: ["7L29", "6L29", "5L60", "4L55"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L14", "7L1", "6L1", "5L1", "4L1", "3L1"],
			psychic: ["7M", "7L52", "6M", "6L52", "5M", "5L55", "4M", "4L47", "3M", "3L37"],
			psychup: ["7M", "7L15", "6M", "6L15", "5M", "5L15", "4M", "4L15", "3T", "3L19"],
			psyshock: ["7M", "7L42", "6M", "6L42", "5M", "5L37"],
			psywave: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L35", "6M", "6L29", "5M", "5L29", "4M", "4L29", "3M", "3L43"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["7L35", "6T", "6L29", "5T", "5L29", "4T", "4L29", "3T", "3L43"],
			splash: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			teeterdance: ["7L1", "6L32"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			zenheadbutt: ["7L26", "6T", "6L26", "5T", "5L26", "4T", "4L26"],
		},
	},
	spinda: {
		inherit: true,
		learnset: {
			assist: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7E", "6E", "5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			copycat: ["7L5", "6L5", "5L10", "5D", "4L10"],
			counter: ["3T"],
			covet: ["6T", "5T"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			dizzypunch: ["7L23", "6L23", "5L28", "4L28", "3L27"],
			doubleedge: ["7L46", "6L46", "5L46", "4L46", "3T", "3L45"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			encore: ["7E", "6E", "5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "5D", "4E"],
			faketears: ["7E", "6E", "5E"],
			feintattack: ["7L10", "6L10", "5L14", "4L14", "3L12"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flail: ["7L50", "6L50", "5L50", "4L50", "3L49"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			guardsplit: ["7E", "6E"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["7L19", "6L19", "5L23", "4L23", "3L23"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["7E", "6T", "6E", "5T", "5E", "4T", "3T"],
			lastresort: ["6T", "5T", "4T"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L14", "6L14", "5L19", "4L19", "3L16"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychocut: ["7E", "6E", "5E", "4E"],
			psychoshift: ["7E", "6E"],
			psychup: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L41", "3T", "3L38"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7E", "6E", "5E"],
			recycle: ["6T", "5T", "4M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sing: ["3S0"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smellingsalts: ["7E", "6E", "5E", "4E", "3E"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spotlight: ["7E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L28", "6L28", "5L32", "4T", "4L32"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["5D"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			teeterdance: ["7L32", "6L32", "5L37", "4L37", "3L34"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thrash: ["7L55", "6L50", "5L55", "4L55", "3L56"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["7E", "6T", "6E", "5T", "5E", "4E", "3E"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["7L37", "6T", "6L5", "5T", "5L5", "4T", "4L5", "3L5", "3S0"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			wildcharge: ["7M", "6M", "5M"],
			wish: ["7E", "6E", "5E", "4E", "3E"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	trapinch: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7L1", "6L1", "5L17"],
			bite: ["7L1", "6L1", "5L1", "5S0", "5D", "4L1", "3L1"],
			bodyslam: ["3T"],
			bugbite: ["7E", "6T", "6E", "5T", "5E", "4T"],
			bulldoze: ["7M", "7L8", "6M", "6L8", "5M", "5L21"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L22", "6L22", "5L33", "4L33", "3L33"],
			dig: ["7L19", "6M", "6L19", "5M", "5L41", "4M", "4L41", "3M", "3L41"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["7L26", "7E", "6T", "6L26", "6E", "5T", "5L65", "5E", "4T", "4L65"],
			earthquake: ["7M", "7L33", "6M", "6L33", "5M", "5L73", "4M", "4L73", "3M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7L29", "6L1", "5L81", "4L81"],
			feintattack: ["7L1", "6L1", "5L17", "4L17", "3L17"],
			fissure: ["7L47", "6L1", "5L89", "4L89"],
			flail: ["7E", "6E", "5E", "4E"],
			focusenergy: ["7E", "6E", "5E", "4E", "3E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7E", "6E", "5E", "4T", "4E"],
			gigadrain: ["6T", "5T", "5D", "4M", "3M"],
			gust: ["7E", "6E", "5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7L43", "6M", "6L43", "5M", "5L57", "4M", "4L57", "3M", "3L57"],
			mimic: ["3T"],
			mudshot: ["7E", "6E", "5E", "4E"],
			mudslap: ["7L5", "6L5", "5L13", "4T", "3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			quickattack: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "7L15", "6M", "6L15", "5M", "5L25", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L1", "6L1", "5L9", "4L9", "3L9"],
			sandstorm: ["7M", "7L36", "6M", "6L36", "5M", "5L49", "4M", "4L49", "3M", "3L49"],
			sandtomb: ["7L12", "6L10", "5L25", "4L25", "3L25"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E", "5D"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["7L40", "6T", "6L1", "5T", "5L67"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
		},
	},
	vibrava: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7L1", "6L1", "5L17"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			boomburst: ["7L47", "6L47"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L29", "6L29"],
			bulldoze: ["7M", "7L8", "6M", "6L8", "5M", "5L21"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["3L33"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonbreath: ["7L1", "6L35", "5L35", "4L35", "3L35"],
			dragonpulse: ["6T", "5T", "4M"],
			earthpower: ["7L26", "6T", "6L26", "5T", "5L39", "4T"],
			earthquake: ["7M", "7L33", "6M", "6L33", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7L43", "6M", "6L43", "5M", "5L57", "4M", "4L57", "3M", "3L57"],
			mimic: ["3T"],
			mudslap: ["7L5", "6L5", "5L13", "4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "7L15", "6M", "6L15", "5M", "5L25", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			sandstorm: ["7M", "7L36", "6M", "6L36", "5M", "5L49", "4M", "4L49", "3M", "3L49"],
			sandtomb: ["7L12", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7L22", "6L22", "5L41", "4L41", "3L41"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6T", "5T"],
			silverwind: ["4M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			sonicboom: ["7L1", "6L1", "5L1", "4L1"],
			steelwing: ["7M", "6M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T"],
			supersonic: ["7L19", "6L19", "5L33", "4L33"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["7L40", "6T", "6L40"],
			uturn: ["7M", "6M", "5M", "4M"],
		},
	},
	flygon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bide: ["7L1", "6L1", "5L17"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			brutalswing: ["7M"],
			bugbite: ["6T", "5T", "4T"],
			bulldoze: ["7M", "7L8", "6M", "6L8", "5M", "5L21"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["3L33", "3S0"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T", "4S1"],
			dragonbreath: ["7L1", "6L35", "5L35", "4L35", "3L35", "3S0"],
			dragonclaw: ["7M", "7L1", "6M", "6L45", "5M", "5L45", "4M", "4L45", "4S1", "3M"],
			dragondance: ["7L1"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrush: ["7L47", "6L47"],
			dragontail: ["7M", "7L29", "6M", "6L29", "5M", "5L65"],
			earthpower: ["7L26", "6T", "6L26", "5T", "5L39", "4T"],
			earthquake: ["7M", "7L33", "6M", "6L33", "5M", "4M", "4S1", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7L43", "6M", "6L43", "5M", "5L57", "4M", "4L57", "3M", "3L65"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["7L5", "6L5", "5L13", "4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["6T", "5T", "4T"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "7L15", "6M", "6L15", "5M", "5L25", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			sandstorm: ["7M", "7L36", "6M", "6L36", "5M", "5L49", "4M", "4L49", "3M", "3L53"],
			sandtomb: ["7L12", "6L1", "5L1", "4L1", "3L1", "3S0"],
			screech: ["7L22", "6L22", "5L41", "4L41", "3L41", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			signalbeam: ["6T", "5T"],
			silverwind: ["4M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			sonicboom: ["7L1", "6L1", "5L1", "4L1"],
			steelwing: ["7M", "6M", "4M", "3M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T"],
			supersonic: ["7L19", "6L19", "5L33", "4L33"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["7L40", "6T", "6L40"],
			uturn: ["7M", "6M", "5M", "4M", "4S1"],
		},
	},
	cacnea: {
		inherit: true,
		learnset: {
			absorb: ["7L4", "6L4", "5L5", "5D", "4L5", "3L5", "3S0"],
			acid: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7E", "6E"],
			block: ["7E", "6T", "6E", "5T", "5E"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cottonspore: ["7L46", "6L46", "5L49", "4L49", "3L41"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			destinybond: ["7L54", "6L54", "5L57", "4L57", "3L49"],
			disable: ["7E", "6E", "5E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["7E", "6E", "5E", "4E", "3T", "3E"],
			encore: ["3S0"],
			endure: ["4M", "3T"],
			energyball: ["7M", "7L42", "6M", "6L42", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L19", "6L19", "5L29", "4L29", "3L29"],
			fellstinger: ["7E", "6E"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["7E", "6E", "5E", "4E", "3E"],
			growth: ["7L7", "6L7", "5L9", "4L9", "3L9"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			ingrain: ["7L22", "6L22", "5L25", "4L25", "3L25"],
			leechseed: ["7L10", "6L10", "5L13", "4L13", "3L13"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			lowkick: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			magicalleaf: ["7E", "6E", "5E", "4E"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			needlearm: ["7L16", "6L16", "5L45", "4L45", "3L37"],
			payback: ["7M", "7L26", "6M", "6L26", "5M", "5L41", "4M", "4L41"],
			pinmissile: ["7L38", "6L21", "5L21", "4L21", "3L21"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			rototiller: ["7E", "6E"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L13", "6L13", "5L17", "4L17", "3L17"],
			sandstorm: ["7M", "7L50", "6M", "6L50", "5M", "5L53", "4M", "4L53", "3M", "3L45"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smellingsalts: ["7E", "6E", "5E", "4E"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spikes: ["7L30", "6L30", "5L33", "4L33", "3L33"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L34", "6L34", "5L37", "4T", "4L37"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			switcheroo: ["7E", "6E", "5E"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			teeterdance: ["7E", "6E", "5E", "5D", "4E", "3E"],
			thunderpunch: ["6T", "5T", "5D", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["7E", "6T", "6E", "5T", "5E", "4T"],
		},
	},
	cacturne: {
		inherit: true,
		learnset: {
			absorb: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cottonspore: ["7L49", "6L49", "5L59", "4L59", "3L47"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			destinybond: ["7L59", "7L1", "6L1", "5L71", "4L71", "3L59"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["3T"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "7L44", "6M", "6L44", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L19", "6L19", "5L29", "4L29", "3L29", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			ingrain: ["7L22", "6L22", "5L25", "4L25", "3L25", "3S0"],
			leechseed: ["7L10", "6L10", "5L13", "4L13", "3L13"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			needlearm: ["7L16", "6L16", "5L53", "4L53", "3L41", "3S0"],
			payback: ["7M", "7L26", "6M", "6L26", "5M", "5L47", "4M", "4L47"],
			pinmissile: ["7L38", "6L21", "5L21", "4L21", "3L21"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L13", "6L13", "5L17", "4L17", "3L17"],
			sandstorm: ["7M", "7L54", "6M", "6L54", "5M", "5L65", "4M", "4L65", "3M", "3L53"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			seismictoss: ["3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spikes: ["7L30", "6L30", "5L35", "4L35", "3L35", "3S0"],
			spikyshield: ["7L1", "6L32"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L35", "6L35", "5L41", "4T", "4L41"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["6T", "5T", "4T"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	swablu: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7E", "6E", "5E", "4E", "3E"],
			aircutter: ["4T"],
			astonish: ["7L3", "6L3", "5L5", "4L5", "3L8"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cottonguard: ["7L34", "6L34", "5L40"],
			dazzlinggleam: ["7M", "6M"],
			disarmingvoice: ["7L11", "6L11"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["7L38", "6T", "6L38", "5T", "5L50", "4M", "4L45"],
			dragonrush: ["7E", "6E", "5E", "4E"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["3S0"],
			featherdance: ["7E", "6E", "5E", "5D", "4E"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L7", "6L7", "5L13", "4L13", "3L18"],
			growl: ["7L1", "6L1", "6S2", "5L1", "5S1", "4L1", "3L1", "3S0"],
			haze: ["7E", "6E", "5E", "4E", "3E"],
			healbell: ["6T", "5T", "4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["7E", "6T", "6E", "6S2", "5T", "5E"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["7L30", "6L30", "5L36", "4L36", "3L38"],
			mist: ["7L14", "6L14", "5L23", "4L23", "3L28"],
			moonblast: ["7L46", "6L46"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7L20", "6L20", "5L32", "4M", "4L32"],
			ominouswind: ["4T"],
			outrage: ["6T", "5T", "4T"],
			peck: ["7L1", "6L1", "6S2", "5L1", "5S1", "5D", "4L1", "3L1", "3S0"],
			perishsong: ["7L42", "6L42", "5L55", "4L50", "3L48"],
			pluck: ["5M", "4M"],
			powerswap: ["7E", "6E", "5E", "4E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			pursuit: ["7E", "6E", "5E", "4E", "3E"],
			rage: ["7E", "6E", "5E", "4E", "3E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7L26", "6L26", "5L45", "4L40", "3L41"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E", "5D", "4M"],
			round: ["7M", "7L17", "6M", "6L17", "5M", "5L18"],
			safeguard: ["7M", "7L9", "6M", "6L9", "5M", "5L18", "4M", "4L18", "3M", "3L21"],
			secretpower: ["6M", "4M", "3M"],
			sing: ["7L5", "6L5", "5L9", "4L9", "3L11"],
			skyattack: ["6T", "3T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7L23", "6L23", "5L28", "4L28", "3L31"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["6T", "5T", "4T"],
		},
	},
	altaria: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			agility: ["6S3"],
			aircutter: ["4T"],
			astonish: ["7L3", "7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cottonguard: ["7L34", "6L34", "5L46"],
			dazzlinggleam: ["7M", "6M"],
			disarmingvoice: ["7L11", "6L11"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonbreath: ["7L1", "6L35", "5L35", "5S2", "4L35", "3L35", "3S0", "3S1"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragondance: ["7L30", "6L30", "5L39", "4L39", "3L40", "3S0"],
			dragonpulse: ["7L40", "6T", "6L40", "5T", "5L62", "4M", "4L54"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["5S2"],
			fireblast: ["7M", "6M", "6S3", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furyattack: ["7L7", "6L7", "5L13", "4L13", "3L18"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			healbell: ["6T", "5T", "4T", "3S1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "6S3", "5T"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["3T"],
			mist: ["7L14", "6L14", "5L23", "4L23", "3L28"],
			moonblast: ["7L52", "6L52"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7L20", "6L20", "5L32", "5S2", "4M", "4L32"],
			ominouswind: ["4T"],
			outrage: ["6T", "5T", "4T"],
			peck: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			perishsong: ["7L46", "6L46", "5L70", "4L62", "3L54"],
			pluck: ["7L1", "6L1", "5M", "5L1", "4M", "4L1"],
			protect: ["7M", "6M", "6S3", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7L26", "6L26", "5L54", "4L46", "3L45", "3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "7L17", "6M", "6L17", "5M", "5L18"],
			safeguard: ["7M", "7L9", "6M", "6L9", "5M", "5L18", "4M", "4L18", "3M", "3L21"],
			secretpower: ["6M", "4M", "3M"],
			sing: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			skyattack: ["7L59", "7L1", "6T", "6L1", "5T", "5L77", "4T", "4L70", "3T", "3L59"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			steelwing: ["7M", "6M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7L23", "6L23", "5L28", "5S2", "4L28", "3L31", "3S0", "3S1"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["6T", "5T", "4T"],
			wonderroom: ["6T", "5T"],
		},
	},
	zangoose: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M", "3S2"],
			captivate: ["4M"],
			closecombat: ["7L50", "6L47", "5L53", "4L53"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E", "3T", "3E", "3S2"],
			crushclaw: ["7L26", "6L22", "5L31", "4L31", "3L31", "3S2"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			defensecurl: ["3T"],
			detect: ["7L36", "6L33", "5L40", "4L40", "3L46"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7E", "6E", "5E", "4E"],
			doubleedge: ["3T"],
			doublehit: ["7E", "6E", "5E", "5D", "4E"],
			doublekick: ["7E", "6E", "5E", "4E", "3E"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			embargo: ["7M", "7L33", "6M", "6L19", "5M", "5L27", "4M", "4L27"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "7L29", "6M", "6L29", "5M", "5L44", "4M", "4L44", "3L55"],
			feint: ["7E", "6E", "5E"],
			finalgambit: ["7E", "6E", "5E"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flail: ["7E", "6E", "5E", "4E", "3E"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L8", "6L8", "5L14", "4T", "4L14", "3T", "3L13", "3S0"],
			furyswipes: ["7E", "6E", "5E", "4E"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["7L15", "6M", "6L15", "5M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L4", "3S0", "3S1"],
			lowkick: ["6T", "5T", "5D", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["7E", "6E", "5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["7E", "6E", "5E", "4E"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			pursuit: ["7L12", "6L12", "5L22", "4L22", "3L25"],
			quickattack: ["7L5", "6L5", "5L5", "5D", "4L5", "3L7", "3S0", "3S1"],
			quickguard: ["7E", "6E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7E", "6E", "5E", "4E", "3E"],
			refresh: ["3S2"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			revenge: ["7L22", "6L22", "5L26"],
			roar: ["7M", "6M", "5M", "4M", "4E", "3M", "3E"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			slash: ["7L19", "6L15", "5L18", "4L18", "3L19"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "7L47", "6M", "6L43", "5M", "5L9", "4M", "4L9", "3T", "3L10", "3S0", "3S1"],
			taunt: ["7M", "7L43", "6M", "6L40", "5M", "5L35", "4M", "4L35", "3M", "3L37"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			workup: ["7M", "5M"],
			xscissor: ["7M", "7L40", "6M", "6L36", "5M", "5L48", "4M", "4L48"],
		},
	},
	seviper: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T", "5D", "4T"],
			assurance: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7L41", "6L43"],
			bind: ["6T", "5T"],
			bite: ["7L4", "6L4", "5L10", "5D", "4L10", "3L10", "3S0", "3S2"],
			bodyslam: ["7E", "6E", "5E", "5D", "4E", "3T", "3E"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			coil: ["7L44", "6L46", "5L64"],
			confide: ["7M", "6M"],
			crunch: ["7L39", "6L40", "5L28", "4L28", "3L28", "3S1"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragontail: ["7M", "6M", "5M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feint: ["7L11"],
			finalgambit: ["7E", "6E", "5E"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gastroacid: ["7L29", "6T", "6L31", "5T", "5L34"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			glare: ["7L19", "6L19", "5L25", "4L25", "3L25", "3S1"],
			haze: ["7L34", "6L37", "5L43", "4L43", "3L43"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lick: ["7L6", "6L7", "5L7", "4L7", "3L7", "3S0", "3S2"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["7L26", "7E", "6L28", "6E", "5L46", "5E", "4L46", "4E"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonfang: ["7L21", "6L22", "5L34", "4L34", "3L34"],
			poisonjab: ["7M", "7L31", "6M", "6L34", "5M", "5L52", "4M", "4L52"],
			poisontail: ["7L9", "6L10", "5L16", "4L16", "3L16", "3S0", "3S1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			punishment: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7E", "6E", "5E", "4E"],
			screech: ["7L14", "6L13", "5L19", "4L19", "3L19", "3S1"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spitup: ["7E", "6E", "5E", "4E", "3E"],
			stockpile: ["7E", "6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L1", "6M", "6L1", "5M", "5L37", "4M", "4L37", "3T", "3L37"],
			swallow: ["7E", "6E", "5E", "4E", "3E"],
			swift: ["4T", "3T"],
			switcheroo: ["7E", "6E", "5E", "4E"],
			swordsdance: ["7M", "7L36"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			venomdrench: ["7L24", "6L25"],
			venoshock: ["7M", "7L16", "6M", "6L16", "5M", "5L55"],
			wrap: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S2"],
			wringout: ["7L46", "7E", "6L49", "6E", "5L61", "5E", "4L55"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	lunatone: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			ancientpower: ["4T"],
			batonpass: ["3S1"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "5D", "4L1", "3L7", "3S0"],
			cosmicpower: ["7L25", "7S2", "6L25", "5L34", "4L34", "3L31"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthpower: ["6T", "5T", "5D", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			embargo: ["7M", "7L17", "6M", "6L17", "5M", "5L31", "4M", "4L31"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L45", "6M", "6L45", "5M", "5L56", "4M", "4L56", "3T", "3L49"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L41", "6L41", "5L53", "4L53", "3L43"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "6M", "5M", "4M"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			healblock: ["7L33", "6L33", "5L42", "4L42"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "7S2", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypnosis: ["7L5", "6L5", "5L12", "4L12", "3L19"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T"],
			ironhead: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["7L49", "6T", "6L1", "5T", "5L64"],
			mimic: ["3T"],
			moonblast: ["7L1", "7S2", "6L1"],
			moonlight: ["5D"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			powergem: ["7L1", "7S2"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L29", "6M", "6L29", "5M", "5L45", "4M", "4L45", "3M", "3L37", "3S1"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "7L1", "6M", "5M"],
			psywave: ["7L13", "6L13", "5L23", "4L23", "3L25"],
			raindance: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "7L9", "6M", "6L9", "5M", "5L20", "4M", "4L20"],
			rockslide: ["7M", "7L21", "6M", "6L21", "5M", "5L25", "4M", "3T"],
			rockthrow: ["7L1", "6L1", "5L9", "4L9", "3L13"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "7L37", "6M", "6L37", "5M", "5L41", "4M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			telekinesis: ["5M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trickroom: ["7M", "6M", "5M", "4M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	solrock: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			ancientpower: ["4T"],
			batonpass: ["3S1"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "5D", "4L1", "3L7", "3S0"],
			cosmicpower: ["7L25", "7S2", "6L25", "5L34", "4L34", "3L31", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			embargo: ["7M", "7L17", "6M", "6L17", "5M", "5L31", "4M", "4L31"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L45", "6M", "6L45", "5M", "5L56", "4M", "4L56", "3T", "3L49"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firespin: ["7L5", "6L5", "5L12", "4L12", "3L19"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flareblitz: ["7L1"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "6M", "5M", "4M"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			healblock: ["7L33", "6L33", "5L42", "4L42"],
			heatwave: ["6T", "5T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "7S2", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			morningsun: ["5D"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L29", "6M", "6L29", "5M", "5L33", "4M", "3M", "3S1"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7L13", "6L13", "5L23", "4L23", "3L25"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "7L9", "6M", "6L9", "5M", "5L20", "4M", "4L20"],
			rockslide: ["7M", "7L21", "6M", "6L21", "5M", "5L45", "4M", "4L45", "3T", "3L37"],
			rockthrow: ["7L1", "6L1", "5L9", "4L9", "3L13"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L41", "7S2", "6M", "6L41", "5M", "5L53", "4M", "4L53", "3M", "3L43"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "7L37", "7S2", "6M", "6L37", "5M", "5L41", "4M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M", "3S1"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			telekinesis: ["5M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trickroom: ["7M", "6M", "5M", "4M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			wonderroom: ["7L49", "6T", "6L1", "5T", "5L64"],
			zenheadbutt: ["6T", "5T", "5D", "4T"],
		},
	},
	barboach: {
		inherit: true,
		learnset: {
			amnesia: ["7L15", "6L15", "5L18", "4L18", "3L21"],
			aquatail: ["7L28", "6T", "6L28", "5T", "5L35", "4T", "4L35"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragondance: ["7E", "6E", "5E", "4E"],
			earthpower: ["7E", "6T", "6E", "5T", "5E", "4T"],
			earthquake: ["7M", "7L32", "6M", "6L32", "5M", "5L39", "4M", "4L39", "3M", "3L31"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7L44", "6L44", "5L47", "4L47", "3L41"],
			flail: ["7E", "6E", "5E", "4E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L39", "6L39", "5L43", "4L43", "3L36"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7E", "6E", "5E", "4E"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			magnitude: ["7L20", "6L20", "5L26", "4L26", "3L16"],
			mimic: ["3T"],
			mudbomb: ["7L13", "6L13", "5L14", "4L14"],
			muddywater: ["7L35", "7E", "6L35", "6E", "5E"],
			mudshot: ["7E", "6E", "5E"],
			mudslap: ["7L1", "6L1", "5L1", "5D", "4T", "4L1", "3T", "3L1"],
			mudsport: ["7L6", "6L6", "5L6", "4L6", "3L6"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L25", "6M", "6L25", "5M", "5L31", "4M", "4L31", "3M", "3L26"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "5D", "4M", "3T"],
			snore: ["7L25", "6T", "6L25", "5T", "5L31", "4T", "4L31", "3T", "3L26"],
			spark: ["7E", "6E", "5E", "5D", "4E", "3E"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			takedown: ["7E", "6E", "5E", "4E"],
			thrash: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L9", "6L9", "5L10", "4L10", "3L11"],
			waterpulse: ["7L17", "6T", "6L17", "5L22", "4M", "4L22", "3M"],
			watersport: ["7L6", "6L6", "5L6", "4L6", "3L6"],
			whirlpool: ["7E", "6E", "5E", "4M", "4E", "3E"],
		},
	},
	whiscash: {
		inherit: true,
		learnset: {
			amnesia: ["7L15", "6L15", "5L18", "4L18", "3L21"],
			aquatail: ["7L28", "6T", "6L28", "5T", "5L39", "4T", "4L39", "4S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			belch: ["7L1"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L34", "6M", "6L34", "5M", "5L45", "4M", "4L45", "4S0", "3M", "3L36"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7L52", "6L52", "5L57", "4L57", "3L56"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L45", "6L45", "5L51", "4L51", "3L46"],
			gigaimpact: ["7M", "6M", "5M", "4M", "4S0"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			magnitude: ["7L20", "6L20", "5L26", "4L26", "3L16"],
			mimic: ["3T"],
			mudbomb: ["7L13", "6L13", "5L14", "4L14"],
			muddywater: ["7L39", "6L39"],
			mudslap: ["7L1", "6L1", "5L1", "4T", "4L1", "3T", "3L1"],
			mudsport: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L25", "6M", "6L25", "5M", "5L33", "4M", "4L33", "3M", "3L26"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["7L25", "6T", "6L25", "5T", "5L33", "4T", "4L33", "3T", "3L26"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			thrash: ["7L1"],
			tickle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L9", "7L1", "6L1", "5L10", "4L10", "3L11"],
			waterpulse: ["7L17", "6T", "6L17", "5L22", "4M", "4L22", "3M"],
			watersport: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
			zenheadbutt: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "4S0"],
		},
	},
	corphish: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["7E", "6E", "5E", "4T", "4E", "3E"],
			aquajet: ["7E", "6E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "4E", "3T", "3E"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubble: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			bubblebeam: ["7L14", "6L14", "5L20", "4L20", "3L19"],
			captivate: ["4M"],
			chipaway: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crabhammer: ["7L43", "6L38", "5L38", "4L38", "3L34"],
			crunch: ["7L39", "6L39", "5L47", "4L47", "3L43"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["7E", "6E", "5E", "3T"],
			doublehit: ["7L20", "6L20"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragondance: ["7E", "6E", "5E", "4E"],
			endeavor: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			guillotine: ["7L48", "6L48", "5L53", "4L53", "3L44"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7L5", "6L5", "5L7", "5D", "4L7", "3L7"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["7L23", "7E", "6T", "6L23", "6E", "5T", "5L26", "5E", "4T", "4L26", "4E", "3L25"],
			leer: ["7L10", "6L10", "5L13", "4L13", "3L13"],
			metalclaw: ["7E", "6E", "5E", "5D", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			nightslash: ["7L26", "6L26", "5L35", "4L35"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "7L17", "6M", "6L17", "5M", "5L23", "4M", "4L23", "3M", "3L22"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorshell: ["7L31", "6L31"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			switcheroo: ["7E", "6E"],
			swordsdance: ["7M", "7L37", "6M", "6L37", "5M", "5L44", "4M", "4L44", "3T", "3L37"],
			taunt: ["7M", "7L34", "6M", "6L32", "5M", "5L32", "4M", "4L32", "3M", "3L31"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trumpcard: ["7E", "6E", "5E"],
			visegrip: ["7L7", "6L7", "5L10", "4L10", "3L10"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			watersport: ["3S0"],
			whirlpool: ["4M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	crawdaunt: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bubble: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			bubblebeam: ["7L14", "6L14", "5L20", "4L20", "3L19"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			crabhammer: ["7L48", "6L44", "5L44", "4L44", "3L38", "3S0", "3S1"],
			crunch: ["7L43", "6L43", "5L57", "4L57", "3L51"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["6M", "5M", "4M", "3M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doublehit: ["7L20", "6L20"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			guillotine: ["7L54", "6L1", "5L65", "4L65", "3L52", "3S0"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["7L23", "6T", "6L23", "5T", "5L26", "4T", "4L26", "3L25", "3S1"],
			leer: ["7L10", "7L1", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			nightslash: ["7L26", "6L26", "5L39", "4L39"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "7L17", "6M", "6L17", "5M", "5L23", "4M", "4L23", "3M", "3L22"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorshell: ["7L32", "6L32"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L1", "6L30", "5L30", "4T", "4L30", "3T"],
			swordsdance: ["7M", "7L40", "6M", "6L40", "5M", "5L52", "4M", "4L52", "3T", "3L43", "3S0", "3S1"],
			taunt: ["7M", "7L36", "6M", "6L34", "5M", "5L34", "4M", "4L34", "3M", "3L33", "3S0", "3S1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			visegrip: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	baltoy: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			ancientpower: ["7L19", "6L19", "5L26", "4T", "4L25", "3L25"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			cosmicpower: ["7L22", "6L22", "5L37", "4L45", "3L37"],
			dazzlinggleam: ["7M", "6M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			drillrun: ["6T", "5T"],
			earthpower: ["7L37", "6T", "6L37", "5T", "5L51", "4T", "4L53"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L46", "6M", "6L46", "5M", "5L60", "4M", "4L71", "3T", "3L45"],
			extrasensory: ["7L31", "6L28", "5L43"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "5D", "4T"],
			guardsplit: ["7L34", "6L34", "5L48"],
			gyroball: ["7M", "6M", "5M", "4M"],
			harden: ["7L1", "6L1", "5L4", "4L3", "3L3"],
			headbutt: ["4T"],
			healblock: ["7L10", "6L10", "5L54", "4L61"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			imprison: ["7L43", "6L43"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["7L7", "6L7", "5L11", "4T", "4L7", "3T", "3L7", "3S0"],
			naturalgift: ["4M"],
			powersplit: ["7L34", "6L34", "5L48"],
			powertrick: ["7L25", "6L17", "5L31", "4L31"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L16", "6L13", "5L15", "4L11", "3L11", "3S0"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7L4", "6L4", "5L7", "5D", "4L5", "3L5"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocktomb: ["7M", "7L13", "6M", "6L10", "5M", "5L18", "4M", "4L15", "3M", "3L15", "3S0"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandstorm: ["7M", "7L40", "6M", "6L40", "5M", "5L34", "4M", "4L37", "3M", "3L31"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7L28", "6L25", "5L21", "4L19", "3T", "3L19"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stealthrock: ["6T", "5T", "4M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			telekinesis: ["5M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "5D", "4T"],
		},
	},
	claydol: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			ancientpower: ["7L19", "6L19", "5L26", "4T", "4L25", "3L25"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			cosmicpower: ["7L22", "6L22", "5L47", "4L51", "3L42"],
			dazzlinggleam: ["7M", "6M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			drillrun: ["6T", "5T"],
			earthpower: ["7L40", "6T", "6L40", "5T", "5L59", "4T", "4L62"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L58", "6M", "6L58", "5M", "5L72", "4M", "4L86", "3T", "3L55"],
			extrasensory: ["7L31", "6L28", "5L39"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			guardsplit: ["7L34", "6L34", "5L54"],
			gyroball: ["7M", "6M", "5M", "4M"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healblock: ["7L10", "6L10", "5L64", "4L73"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7L1", "6M", "6L36", "5M", "5L36", "4M", "4L36", "3M", "3L36"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			imprison: ["7L52", "6L52"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mudslap: ["7L7", "6L7", "5L11", "4T", "4L7", "3T", "3L7"],
			naturalgift: ["4M"],
			powersplit: ["7L34", "6L34", "5L54"],
			powertrick: ["7L25", "6L17", "5L31", "4L31"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L16", "6L13", "5L15", "4L11", "3L11"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rapidspin: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "7L13", "6M", "6L10", "5M", "5L18", "4M", "4L15", "3M", "3L15"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandstorm: ["7M", "7L46", "6M", "6L46", "5M", "5L34", "4M", "4L40", "3M", "3L31"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["7L28", "6L25", "5L21", "4L19", "3T", "3L19"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			telekinesis: ["5M"],
			teleport: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	lileep: {
		inherit: true,
		learnset: {
			acid: ["7L5", "6L5", "5L8", "5S0", "5D", "4L8", "3L15"],
			amnesia: ["7L36", "6L29", "5L29", "4L29", "3L36"],
			ancientpower: ["7L17", "6L17", "5L43", "4T", "4L43", "3L43"],
			astonish: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7E", "6E", "5E", "4E", "3E"],
			bind: ["6T", "5T"],
			bodyslam: ["3T"],
			brine: ["7L21", "6L21"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L13", "6L13", "5L22", "4L22", "3L29"],
			constrict: ["7L1", "6L1", "5L1", "5S0", "4L1", "3L8"],
			curse: ["7E", "6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			energyball: ["7M", "7L41", "6M", "6L41", "5M", "5L50", "4M", "4L50"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["7L31", "6T", "6L31", "5T", "5L36", "4T", "4L36"],
			gigadrain: ["7L26", "6T", "6L26", "5T", "5D", "4M", "3M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			ingrain: ["7L9", "6L9", "5L15", "4L15", "3L22"],
			megadrain: ["7E", "6E", "5E"],
			mimic: ["3T"],
			mirrorcoat: ["7E", "6E", "5E", "5D", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			recover: ["7E", "6E", "5E", "5S0", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "5S0", "4M", "4E", "3T", "3E"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spitup: ["7L46", "6L46", "5L57", "4L57", "3L50"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E", "4M"],
			stockpile: ["7L46", "6L46", "5L57", "4L57", "3L50"],
			stringshot: ["4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L46", "6L46", "5L57", "4L57", "3L50"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["6T", "5T", "4T"],
			tickle: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			worryseed: ["6T", "5T", "4T"],
			wringout: ["7L52", "7E", "6L52", "6E", "5L64", "5E", "4L64", "4E"],
		},
	},
	cradily: {
		inherit: true,
		learnset: {
			acid: ["7L5", "7L1", "6L1", "5L1", "4L1", "3L1"],
			amnesia: ["7L36", "6L29", "5L29", "4L29", "3L36"],
			ancientpower: ["7L17", "6L17", "5L36", "4T", "4L36", "3L48"],
			astonish: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bind: ["6T", "5T"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brine: ["7L21", "6L21"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L13", "6L13", "5L22", "4L22", "3L29"],
			constrict: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "7L44", "6M", "6L44", "5M", "5L56", "4M", "4L56"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gastroacid: ["7L31", "6T", "6L31", "5T", "5L46", "4T", "4L46"],
			gigadrain: ["7L26", "6T", "6L26", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			infestation: ["7M", "6M"],
			ingrain: ["7L9", "7L1", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["3T"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			sludgewave: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spitup: ["7L52", "6L1", "5L66", "4L66", "3L60"],
			stealthrock: ["6T", "5T", "4M"],
			stockpile: ["7L52", "6L1", "5L66", "4L66", "3L60"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7L52", "6L1", "5L66", "4L66", "3L60"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			worryseed: ["6T", "5T", "4T"],
			wringout: ["7L61", "7L1", "6L1", "5L76", "4L76"],
		},
	},
	anorith: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["7L21", "6L21", "5L31", "4T", "4L31", "3L37"],
			aquajet: ["7E", "6E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["7L29", "6L29"],
			bugbite: ["7L25", "6T", "6L25", "5T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crosspoison: ["7E", "6E", "5E", "5S0", "5D", "4E"],
			crushclaw: ["7L39", "6L39", "5L55", "4L55"],
			curse: ["7E", "6E", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L10", "6L10", "5L37", "4T", "4L37", "3T", "3L43"],
			harden: ["7L1", "6L1", "5L1", "5S0", "4L1", "3L7"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["7E", "6T", "6E", "5T", "5E", "4T"],
			knockoff: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			metalclaw: ["7L17", "6L17", "5L19", "4L19", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L4", "6L4", "5L7", "5S0", "4L7", "3L13"],
			naturalgift: ["4M"],
			protect: ["7M", "7L49", "6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L31"],
			rapidspin: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L55", "6L49", "5L49", "4L49", "3L55"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7E", "6E", "5E", "4E"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scratch: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			screech: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M", "3M"],
			slash: ["7L34", "6L34", "5L43", "4L43", "3L49"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "7L13", "6M", "6L13", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "5D", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L7", "6L7", "5L13", "5S0", "4L13", "3L19"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			xscissor: ["7M", "7L44", "6M", "6L44", "5M", "5L61", "4M", "4L61"],
		},
	},
	armaldo: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["7L21", "6L21", "5L31", "4T", "4L31", "3L37"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["7L29", "6L29"],
			brutalswing: ["7M"],
			bugbite: ["6T", "5T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crushclaw: ["7L39", "6L1", "5L67", "4L67"],
			cut: ["6M", "5M", "4M", "3M"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["7L10", "6L10", "5L37", "4T", "4L37", "3T", "3L46"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			irondefense: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lowkick: ["6T", "5T", "4T"],
			metalclaw: ["7L17", "6L17", "5L19", "4L19", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["7M", "7L53", "6M", "6L25", "5M", "5L25", "4M", "4L25", "3M", "3L31"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockblast: ["7L61", "6L55", "5L55", "4L55", "3L64"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			slash: ["7L34", "7L25", "6L25", "5L46", "4L46", "3L55"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "7L13", "6M", "6L13", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			xscissor: ["7M", "7L46", "6M", "6L46", "5M", "5L73", "4M", "4L73"],
		},
	},
	feebas: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["7E", "6E", "5E"],
			captivate: ["7E", "6E", "5E", "5D", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "4E", "3E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonbreath: ["7E", "6E", "5E", "4E", "3E"],
			dragonpulse: ["7E", "6T", "6E", "5T", "5E"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L30", "6L30", "5L30", "4L30", "3L30"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			haze: ["7E", "6E", "5E", "4E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypnosis: ["7E", "6E", "5E", "4E", "3E"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["7E", "6T", "6E", "5T", "5E"],
			lightscreen: ["7M", "6M", "5M", "4E", "3E"],
			mimic: ["3T"],
			mirrorcoat: ["7E", "6E", "5E", "5D", "4E", "4S0", "3E"],
			mist: ["7E", "6E", "5E", "4E"],
			mudsport: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			splash: ["7L1", "6L1", "5L1", "5D", "4L1", "4S0", "3L1"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L15", "6L15", "5L15", "4L15", "3L15"],
			tickle: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	milotic: {
		inherit: true,
		learnset: {
			aquaring: ["7L17", "6L21", "5L49", "4L49"],
			aquatail: ["7L31", "6T", "6L29", "5T", "5L29", "4T", "4L29"],
			attract: ["7M", "7L34", "6M", "6L37", "5M", "5L41", "4M", "4L41", "3M", "3L45"],
			avalanche: ["4M"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["7L21", "6L24", "5L25", "4M", "4L25"],
			coil: ["7L41", "6L44"],
			confide: ["7M", "6M"],
			disarmingvoice: ["7L11", "6L11"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "7L24", "6M", "6L27", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L44", "6L37", "5L37", "5S3", "4L37", "4S1", "4S2", "3L40"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "5S3", "5S4", "4M", "4S1", "3M"],
			icywind: ["6T", "5T", "4T", "4S2", "3T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			mirrorcoat: ["5S3"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "7L47", "6M", "6L33", "5M", "5L33", "4M", "4L33", "4S1", "4S2", "3M", "3L35", "3S0"],
			recover: ["7L27", "6L21", "5L21", "5S3", "5S4", "4L21", "4S1", "4S2", "3L30", "3S0"],
			refresh: ["7L7", "7L1", "6L7", "5L9", "4L9", "3L15"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L37", "6M", "6L41", "5M", "5L45", "4M", "4L45", "3M", "3L50"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "5S4", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["7M", "6M", "5M", "5S4", "4M", "3M"],
			twister: ["7L14", "6L14", "5L17", "4T", "4L17", "3L25", "3S0"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["7L1", "6T", "6L13", "5L13", "4M", "4L13", "3M", "3L20", "3S0"],
			watersport: ["7L4", "7L1", "6L4", "5L5", "4L5", "3L10"],
			whirlpool: ["4M"],
			wrap: ["7L1", "6L1", "5L1", "4L1", "3L5"],
		},
	},
	castform: {
		inherit: true,
		learnset: {
			amnesia: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["7M", "7L35", "6M", "6L35", "5M", "5L50", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			clearsmog: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			cosmicpower: ["7E", "6E"],
			defensecurl: ["3T"],
			disable: ["7E", "6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			ember: ["7L10", "6L10", "5L10", "5D", "4L10", "3L10"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7L35", "6M", "6L35", "5M", "5L50", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E", "6E", "5E", "4E", "3E"],
			guardswap: ["7E", "6E"],
			hail: ["7M", "7L20", "6M", "6L20", "5M", "5L30", "4M", "4L20", "3M", "3L20"],
			headbutt: ["7L15", "6L15", "5L20"],
			hex: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hurricane: ["7L45", "6L45"],
			hydropump: ["7L35", "6L35", "5L50"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			lastresort: ["6T", "5T", "4T"],
			luckychant: ["7E", "6E", "5E", "4E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["7E", "6E", "5E", "5D", "4T", "4E"],
			powdersnow: ["7L10", "6L10", "5L10", "4L10", "3L10"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			raindance: ["7M", "7L20", "6M", "6L20", "5M", "5L30", "4M", "4L20", "3M", "3L20"],
			reflecttype: ["7E", "6E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "7L20", "6M", "6L20", "5M", "5L30", "4M", "4L20", "3M", "3L20"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L10", "6L10", "5L10", "4L10", "3L10"],
			waterpulse: ["6T", "5D", "4M", "3M"],
			weatherball: ["7L25", "6L25", "5L40", "4L30", "3L30"],
			workup: ["7M", "5M"],
		},
	},
	kecleon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			afteryou: ["6T", "5T"],
			ancientpower: ["7L21", "6L1", "5L55", "4T", "4L55", "3L49"],
			aquatail: ["6T", "5T", "4T"],
			astonish: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bind: ["7L4", "6T", "6L4", "5T", "5L4", "4L4", "3L4"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			camouflage: ["7L30", "7E", "6L30", "6E"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			dizzypunch: ["7E", "6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fakeout: ["7E", "6E", "5E", "4E"],
			feint: ["7L10", "6L10", "5L14", "4L14"],
			feintattack: ["7L16", "6L7", "5L7", "5D", "4L7", "3L7"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foulplay: ["7E", "6T", "6E", "5T", "5E"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["7L13", "6L10", "5L10", "4L10", "3L12"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			lick: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lowkick: ["6T", "5T", "4T"],
			magiccoat: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psybeam: ["7L18", "6L18", "5L18", "4L15", "3L17"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7E", "6E", "5E", "4E"],
			recycle: ["6T", "5T", "4M"],
			reflecttype: ["5D"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			screech: ["7L38", "6L32", "5L32", "4L32", "3L24"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "7L33", "6M", "6L33", "5M", "5L49", "4M", "4L49"],
			shadowsneak: ["7L7", "6L7", "5L22", "4L20"],
			shockwave: ["6T", "4M", "3M"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "5D", "4M", "3M"],
			slash: ["7L25", "6L25", "5L27", "4L25", "3L31"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "7L42", "6M", "6L37", "5M", "5L37", "4M", "4L37", "3T", "3L40"],
			suckerpunch: ["7L46", "6L43", "5L43", "4T", "4L43"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["7L50", "6L1", "5L58"],
			tailwhip: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			thief: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			trickroom: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M", "3M"],
			wonderroom: ["6T", "5T"],
			workup: ["7M", "5M"],
		},
	},
	shuppet: {
		inherit: true,
		learnset: {
			astonish: ["7E", "6E", "5E", "4E", "3E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "4E"],
			curse: ["7L26", "6L19", "5L13", "4L13", "3L20"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dazzlinggleam: ["7M", "6M"],
			destinybond: ["7E", "6E", "5E", "5D", "4E", "3E"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			embargo: ["7M", "7L34", "6M", "6L34", "5M", "5L43", "4M", "4L38"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L19", "6L19", "5L28", "4L28", "3L37", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			foresight: ["7E", "6E", "5E", "4E", "3E"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			grudge: ["7L46", "6L46", "5L50", "4L46", "3L56"],
			gunkshot: ["7E", "6E", "5E"],
			headbutt: ["4T"],
			hex: ["7L22", "6L22", "5L31"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			imprison: ["7E", "6E", "5E", "4E", "3E"],
			knockoff: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["7L7", "6L7", "5L8", "5D", "4L8", "3L13"],
			ominouswind: ["7E", "6E", "5E", "4T"],
			painsplit: ["6T", "5T", "5D", "4T"],
			payback: ["7M", "6M", "5M", "4M", "4E"],
			phantomforce: ["7L54", "7E", "6L54", "6E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			pursuit: ["7E", "6E", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			screech: ["7L4", "6L4", "5L5", "4L5", "3L8"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "7L30", "6M", "6L30", "5M", "5L35", "4M", "4L31", "3M", "3L44", "3S0"],
			shadowsneak: ["7L13", "7E", "6L13", "6E", "5L20", "5E", "4L20", "4E"],
			shockwave: ["6T", "4M", "3M"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["7L42", "6T", "6L42", "5T", "5L46", "4M", "4L43", "3M", "3L49"],
			snore: ["6T", "3T"],
			spite: ["7L10", "6T", "6L10", "5T", "5L16", "4T", "4L16", "3L25", "3S0"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L38", "6L34", "5L38", "4T", "4L35"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["7L50", "6T", "6L50", "5T", "5L55", "4T", "4L50"],
			trickroom: ["7M", "6M", "5M", "4M"],
			willowisp: ["7M", "7L16", "6M", "6L13", "5M", "5L23", "4M", "4L23", "3L32", "3S0"],
		},
	},
	banette: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			cottonguard: ["5S1"],
			curse: ["7L26", "6L1", "5L1", "4L1", "3L1", "3S0"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			embargo: ["7M", "7L34", "6M", "6L34", "5M", "5L51", "4M", "4L42"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L19", "6L19", "5L28", "5S1", "4L28", "3L39", "3S0"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grudge: ["7L52", "6L52", "5L66", "4L58", "3L64"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hex: ["7L22", "6L22", "5L31", "5S1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			knockoff: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			ominouswind: ["4T"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			phantomforce: ["7L64", "7L1", "6L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			screech: ["7L4", "7L1", "6L1", "5L1", "4L1", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "7L30", "6M", "6L30", "5M", "5L35", "5S1", "4M", "4L31", "3M", "3L48", "3S0"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shadowsneak: ["7L13", "6L13", "5L20", "4L20"],
			shockwave: ["6T", "4M", "3M"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["7L46", "6T", "6L46", "5T", "5L58", "4M", "4L51", "3M", "3L55"],
			snore: ["6T", "3T"],
			spite: ["7L10", "7L1", "6T", "6L1", "5T", "5L16", "4T", "4L16", "3L25"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L40", "6L34", "5L42", "4T", "4L35"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["7L58", "6T", "6L58", "5T", "5L75", "4T", "4L66"],
			trickroom: ["7M", "6M", "5M", "4M"],
			willowisp: ["7M", "7L16", "6M", "6L13", "5M", "5L23", "4M", "4L23", "3L32"],
		},
	},
	duskull: {
		inherit: true,
		learnset: {
			astonish: ["7L9", "6L9", "5L14", "4L14", "3L16", "3S1"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L30", "6L17", "5L17", "4L17", "3L23", "3S1"],
			curse: ["7L33", "6L30", "5L30", "4L30", "3L34", "3S0"],
			darkpulse: ["7M", "7E", "6M", "6E", "5T", "5E", "4M"],
			destinybond: ["7E", "6E", "5E", "4E", "3E"],
			disable: ["7L6", "6L6", "5L6", "5D", "4L6", "3L5"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			foresight: ["7L14", "6L9", "5L9", "4L9", "3L12"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L54", "6L49", "5L49", "4L46", "3L49"],
			gravity: ["6T", "5T", "4T"],
			grudge: ["7E", "6E", "5E", "4E", "3E"],
			haze: ["7E", "6E"],
			headbutt: ["4T"],
			helpinghand: ["3S1"],
			hex: ["7L38", "6L38", "5L38"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			imprison: ["7E", "6E", "5E", "4E", "3E"],
			infestation: ["7M", "6M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			meanlook: ["7L46", "6L41", "5L41", "4L38", "3L45", "3S0"],
			memento: ["7E", "6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			ominouswind: ["7E", "6E", "5E", "4T", "4E"],
			painsplit: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E", "3E"],
			payback: ["7M", "7L49", "6M", "6L46", "5M", "5L46", "4M", "4L41"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			pursuit: ["7L22", "6L22", "5L25", "4L25", "3L27", "3S0"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "7L41", "6M", "6L41", "5M", "4M", "3M", "3S1"],
			shadowsneak: ["7L17", "6L17", "5L22", "4L22"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "5D", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			willowisp: ["7M", "7L25", "6M", "6L25", "5M", "5L33", "4M", "4L33", "3L38", "3S0"],
			wonderroom: ["6T", "5T"],
		},
	},
	dusclops: {
		inherit: true,
		learnset: {
			astonish: ["7L9", "7L1", "6L1", "5L14", "4L14", "3L16"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bind: ["7L1", "6T", "6L1", "5T", "5L1", "4L1", "3L1"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L30", "6L17", "5L17", "4L17", "3L23"],
			counter: ["3T"],
			curse: ["7L33", "6L30", "5L30", "4L30", "3L34"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			disable: ["7L6", "7L1", "6L1", "5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			foresight: ["7L14", "6L9", "5L9", "4L9", "3L12"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L64", "7L1", "6L1", "5L61", "4L61", "3L58"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			headbutt: ["4T"],
			hex: ["7L40", "6L40", "5L42"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			meanlook: ["7L52", "6L49", "5L49", "4L43", "3L51"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			ominouswind: ["4T"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "7L57", "6M", "6L57", "5M", "5L58", "4M", "4L51"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			pursuit: ["7L22", "6L22", "5L25", "4L25", "3L27"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "7L45", "6M", "6L45", "5M", "4M", "3M"],
			shadowpunch: ["7L1", "6L37", "5L37", "4L37", "3L37"],
			shadowsneak: ["7L17", "6L17", "5L22", "4L22"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			willowisp: ["7M", "7L25", "6M", "6L25", "5M", "5L33", "4M", "4L33", "3L41"],
			wonderroom: ["6T", "5T"],
		},
	},
	dusknoir: {
		inherit: true,
		learnset: {
			astonish: ["7L9", "7L1", "6L1", "5L14", "4L14"],
			attract: ["7M", "6M", "5M", "4M"],
			bind: ["7L1", "6T", "6L1", "5T", "5L1", "4L1"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L30", "6L17", "5L17", "4L17"],
			curse: ["7L33", "6L30", "5L30", "4L30"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			disable: ["7L6", "7L1", "6L1", "5L1", "4L1"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			earthquake: ["7M", "6M", "5M", "4M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			firepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			foresight: ["7L14", "6L9", "5L9", "4L9"],
			frustration: ["7M", "6M", "5M", "4M"],
			futuresight: ["7L64", "7L1", "6L1", "5L61", "4L61"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			headbutt: ["4T"],
			hex: ["7L40", "6L40", "5L42"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			icywind: ["6T", "5T", "4T"],
			infestation: ["7M", "6M"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			meanlook: ["7L52", "6L49", "5L49", "4L43"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightshade: ["7L1", "6L1", "5L1", "4L1"],
			ominouswind: ["4T"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "7L57", "6M", "6L57", "5M", "5L58", "4M", "4L51"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L22", "6L22", "5L25", "4L25"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "7L45", "6M", "6L45", "5M", "4M"],
			shadowpunch: ["7L1", "6L37", "5L37", "4L37"],
			shadowsneak: ["7L17", "6L17", "5L22", "4L22"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "6M", "5M", "4M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			willowisp: ["7M", "7L25", "6M", "6L25", "5M", "5L33", "4M", "4L33"],
			wonderroom: ["6T"],
		},
	},
	tropius: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["7L36", "6L36", "5L51", "4L47", "4S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bestow: ["7L46", "6L1", "5L57"],
			bodyslam: ["7L41", "6L37", "5L37", "4L37", "3T", "3L37"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["7E", "6E", "5E", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "4E"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragondance: ["7E", "6E", "5E", "4E"],
			dragonpulse: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["6T", "5T", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["7L1", "6L1", "5L7", "4L7", "3L7"],
			gust: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			headbutt: ["7E", "6E", "5E", "4T", "4E", "3E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			leafblade: ["7E", "6E", "5E", "4E"],
			leafstorm: ["7L61", "7E", "7L1", "6L1", "6E", "5L71", "5E", "4L61", "4E"],
			leaftornado: ["7L26", "6L26", "5L47"],
			leechseed: ["7E", "6E", "5E", "5D", "4E", "3E"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			magicalleaf: ["7L16", "6L16", "5L31", "4L31", "3L31"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["7L30", "7E", "6L1", "6E", "5L67", "5E", "4M", "4L57"],
			naturepower: ["7M", "7E", "6M", "6E", "5E", "4E", "3E"],
			ominouswind: ["4T"],
			outrage: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			razorleaf: ["7L1", "6L1", "5L11", "4L11", "3L11"],
			razorwind: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seedbomb: ["6T", "5T"],
			silverwind: ["5D", "4M"],
			slam: ["7E", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L56", "6M", "6L56", "5M", "5L61", "4M", "4L51", "4S0", "3M", "3L41"],
			steelwing: ["7M", "6M", "4M", "3M"],
			stomp: ["7L10", "6L10", "5L17", "4L17", "3L17"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "4S0", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetscent: ["7L6", "6L6", "5L21", "4L21", "3L21"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			synthesis: ["7L50", "7E", "6T", "6L41", "6E", "5T", "5L41", "5E", "4T", "4L41", "4E", "4S0", "3L47"],
			tailwind: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["7L21", "6L21", "5L27", "4L27", "3L27"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	chingling: {
		inherit: true,
		learnset: {
			astonish: ["7L7", "6L7", "5L9", "4L9"],
			attract: ["7M", "6M", "5M", "4M"],
			bind: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L10", "6L10", "5L14", "4L14"],
			cosmicpower: ["7E", "6E"],
			curse: ["7E", "6E", "5E", "4E"],
			dazzlinggleam: ["7M", "6M"],
			disable: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "4E"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			entrainment: ["7L19", "6L19", "5L25"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			futuresight: ["7E", "6E", "5E", "4E"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			growl: ["7L4", "6L4", "5L6", "4L6"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["7E", "6E", "5E", "4E"],
			icywind: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["7L16", "6T", "6L16", "5T", "5L22", "4T", "4L22"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magiccoat: ["6T", "5T", "4T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recover: ["7E", "6E", "5E", "4E"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			storedpower: ["7E", "6E", "5E"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			taunt: ["7M", "6M", "5M", "4M"],
			telekinesis: ["5M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["7L32", "6T", "6L17", "5T", "5L17", "4T", "4L17"],
			wish: ["7E", "6E", "5E", "4E"],
			wrap: ["7L1", "6L1", "5L1", "4L1"],
			yawn: ["7L13", "6L13"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	chimecho: {
		inherit: true,
		learnset: {
			astonish: ["7L7", "7L1", "6L1", "5L9", "4L9", "3L9", "3S0"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bind: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L10", "7L1", "6L1", "5L14", "4L14", "3L14"],
			cosmicpower: ["7E", "6E"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			disable: ["7E", "6E", "5E", "4E", "3E"],
			doubleedge: ["7L42", "6L33", "5L33", "4L33", "3T", "3L33"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dreameater: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			extrasensory: ["7L22", "6L22", "5L46", "4L46"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7E", "6E", "5E", "4E"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			growl: ["7L4", "7L1", "6L1", "5L6", "4L6", "3L6", "3S0"],
			healbell: ["7L27", "6T", "6L27", "5T", "5L38", "4T", "4L38", "3L38"],
			healingwish: ["7L57", "7L1", "6L1", "5L57", "4L49"],
			healpulse: ["7L47", "6L47", "5L49"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T", "5D"],
			hypnosis: ["7E", "6E", "5E", "5D", "4E", "3E"],
			icywind: ["6T", "5T", "4T", "3T"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "6M", "5M", "4M", "3M", "3L46"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7L16", "6L16", "5L30", "4L30", "3L30"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7E", "6E"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L37", "6M", "6L37", "5M", "5L41", "4M", "4L41", "3M", "3L41"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["7E", "6T", "6E", "5T", "5E", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			storedpower: ["7E", "6E", "5E"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			synchronoise: ["7L52", "7L1", "6L1", "5L54"],
			takedown: ["7L19", "6L19", "5L22", "4L22", "3L17"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			telekinesis: ["5M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["7L32", "6T", "6L17", "5T", "5L17", "4T", "4L17", "3L22"],
			wish: ["7E", "6E", "5E", "4E"],
			wrap: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1", "3S0"],
			yawn: ["7L13", "6L13", "5L25", "4L25", "3L25"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	absol: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			assurance: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7E", "6E", "5E", "4E", "3E"],
			bite: ["7L16", "6L16", "5L28", "4L28", "3L21", "3S2"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			brutalswing: ["7M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			detect: ["7L33", "6L1", "5L49", "4L49"],
			doubleedge: ["7E", "6E", "5E", "4E", "3T", "3E"],
			doubleteam: ["7M", "7L19", "6M", "6L19", "5M", "5L33", "4M", "4L33", "3M", "3L31", "3S3"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			feint: ["7L1", "6L1", "5L1", "5D", "4L1"],
			feintattack: ["7E", "6E", "5E", "4E", "3E"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			futuresight: ["7L53", "7L1", "6L1", "5L41", "4L41", "3L41", "3S3"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hex: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			knockoff: ["6T", "5T", "4T"],
			leer: ["7L4", "7L1", "6L1", "5L4", "4L4", "3L5", "3S0", "3S1"],
			magiccoat: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			meanlook: ["7E", "6E", "5E", "4E"],
			mefirst: ["7L41", "7E", "6L1", "6E", "5L57", "5E", "4L57", "4E"],
			megahorn: ["7E", "6E", "5E", "5D", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["7L29", "6L29", "5L52", "4L52"],
			payback: ["7M", "6M", "5M", "4M"],
			perishsong: ["7L57", "7E", "7L1", "6L1", "6E", "5L65", "5E", "4L65", "3L46", "3S3"],
			playrough: ["7E", "6E"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychocut: ["7L37", "6L37", "5L60", "4L60"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			punishment: ["7E", "6E", "5E", "4E"],
			pursuit: ["7L10", "6L10", "5L20", "4L20"],
			quickattack: ["7L7", "7L1", "6L1", "5L12", "4L12", "3L13"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			razorwind: ["7L49", "6L1", "5L17", "4L17", "3L17", "3S2"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scratch: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0", "3S1"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			slash: ["7L22", "6L22", "5L36", "4L36", "3L36", "3S3"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T", "3S1", "3S2"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["7L45", "7E", "6L45", "6E", "5L44", "5E", "4T", "4L44", "4E"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["6T", "5T", "5D", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "4M", "4L25", "3T", "3L26", "3S2"],
			taunt: ["7M", "7L13", "6M", "6L1", "5M", "5L9", "4M", "4L9", "3M", "3L9"],
			thief: ["7M", "6M", "5M", "4M", "3M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			wish: ["3S0"],
			xscissor: ["7M", "6M", "5M", "4M"],
			zenheadbutt: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
		},
	},
	snorunt: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["7E", "6E", "5E", "4M"],
			bide: ["7E", "6E", "5E", "4E"],
			bite: ["7L19", "6L10", "5L10", "4L10", "3L10", "3S0"],
			blizzard: ["7M", "7L46", "6M", "6L46", "5M", "5L46", "4M", "4L46", "3M", "3L43"],
			block: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L41", "6L31", "5L31", "4L31", "3L28"],
			disable: ["7E", "6E", "5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "7L5", "6M", "6L4", "5M", "5L4", "4M", "4L4", "3M", "3L7"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			faketears: ["7E", "6E", "5E"],
			flash: ["6M", "5M", "4M", "3M"],
			frostbreath: ["7M", "7L37", "6M", "6L37", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "7L50", "6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L37"],
			headbutt: ["7L28", "6L19", "5L19", "4T", "4L19", "3L19"],
			hex: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M", "3L34"],
			icefang: ["7L23", "6L23", "5L28", "4L28"],
			iceshard: ["7L10", "6L10", "5L37", "4L37"],
			icywind: ["7L14", "6T", "6L13", "5T", "5L13", "4T", "4L13", "3T", "3L16", "3S0"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			powdersnow: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			protect: ["7M", "7L32", "6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L25"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7E", "6E", "5E", "4T", "4E"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sing: ["3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spikes: ["7E", "6E", "5E", "4E", "3E"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			switcheroo: ["7E", "6E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "5D", "4M", "3M", "3S0"],
			weatherball: ["7E", "6E", "5E", "5D", "4E"],
		},
	},
	glalie: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["7L19", "6L1", "5L1", "4L1", "3L1"],
			blizzard: ["7M", "7L48", "6M", "6L48", "5M", "5L51", "4M", "4L51", "3M", "3L53"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L41", "6L31", "5L31", "4L31", "3L28"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "7L5", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3M", "3L1"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			freezedry: ["7L1", "6L42"],
			frostbreath: ["7M", "7L37", "6M", "6L37", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "7L54", "6M", "6L40", "5M", "5L40", "4M", "4L40", "3M", "3L42"],
			headbutt: ["7L28", "6L19", "5L19", "4T", "4L19", "3L19"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "6L37", "5M", "5L37", "4M", "4L37", "3M", "3L34"],
			icefang: ["7L23", "6L23", "5L28", "4L28"],
			iceshard: ["7L10", "7L1", "6L1"],
			icywind: ["7L14", "6T", "6L13", "5T", "5L13", "4T", "4L13", "3T", "3L16"],
			ironhead: ["6T", "5T", "4T"],
			leer: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			powdersnow: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "7L32", "6M", "6L22", "5M", "5L22", "4M", "4L22", "3M", "3L25"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			sheercold: ["7L61", "7L1", "6L1", "5L59", "4L59", "3L61"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			taunt: ["7M", "6M", "5M", "4M", "3M"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
		},
	},
	froslass: {
		inherit: true,
		learnset: {
			astonish: ["7L19", "6L1", "5L1", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			auroraveil: ["7M"],
			avalanche: ["4M"],
			blizzard: ["7M", "7L48", "6M", "6L48", "5M", "5L51", "4M", "4L51"],
			block: ["6T", "5T", "4T"],
			captivate: ["7L41", "6L31", "5L31", "4M", "4L31"],
			confide: ["7M", "6M"],
			confuseray: ["7L32", "6L19", "5L19", "4L19"],
			destinybond: ["7L61", "7L1", "6L1", "5L59", "4L59"],
			doubleteam: ["7M", "7L5", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			drainingkiss: ["7L23", "6L23"],
			dreameater: ["7M", "6M", "5M", "4M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "7L54", "6M", "6L40", "5M", "5L40", "4M", "4L40"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			iceshard: ["7L10", "7L1", "6L1", "5L37", "4L37"],
			icywind: ["7L14", "6T", "6L13", "5T", "5L13", "4T", "4L13"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["7L1", "6L22", "5L22", "4T", "4L22"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			powdersnow: ["7L1", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "7L42", "6M", "6L42", "5M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["4T"],
			swagger: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "6M", "5M", "4M"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			wakeupslap: ["7L37", "6L28", "5L28", "4L28"],
			waterpulse: ["6T", "4M"],
			willowisp: ["7M", "7L28"],
		},
	},
	spheal: {
		inherit: true,
		learnset: {
			aquaring: ["7E", "6E", "5E", "4E"],
			aquatail: ["6T", "5T", "5D", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7L21", "6L21", "5L25", "4L25", "3L25", "3S0"],
			bellydrum: ["7E", "6E"],
			blizzard: ["7M", "7L41", "6M", "6L41", "5M", "5L43", "4M", "4L43", "3M", "3L43"],
			bodyslam: ["7L26", "6L19", "5L19", "4L19", "3T", "3L19"],
			brine: ["7L17", "6L17", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			charm: ["3S0"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "4E", "3E"],
			defensecurl: ["7L1", "6L1", "5L1", "4L1", "3T", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7L9", "6L7", "5L7", "4L7", "3L7"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fissure: ["7E", "6E", "5E", "5D", "4E", "3E"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "7L36", "6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L31"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			iceball: ["7L13", "6L13", "5L13", "4L13", "3L13"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T", "3S0"],
			naturalgift: ["4M"],
			powdersnow: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L31", "6M", "6L31", "5M", "5L37", "4M", "4L37", "3M", "3L37"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L5", "7E", "6L5", "6E", "5E", "4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["7L46", "6L46", "5L49", "4L49", "3L49"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M", "3T"],
			snore: ["7L31", "6T", "6L31", "5T", "5L37", "4T", "4L37", "3T", "3L37"],
			spitup: ["7E", "6E", "5E", "4E", "3E"],
			stockpile: ["7E", "6E", "5E", "4E", "3E"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superfang: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swallow: ["7E", "6E", "5E", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			watersport: ["7E", "6E", "5E", "4E", "3E"],
			whirlpool: ["4M"],
			yawn: ["7E", "6E", "5E", "4E", "3E"],
		},
	},
	sealeo: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7L21", "6L21", "5L25", "4L25", "3L25"],
			blizzard: ["7M", "7L45", "6M", "6L45", "5M", "5L47", "4M", "4L47", "3M", "3L47"],
			bodyslam: ["7L26", "6L19", "5L19", "4L19", "3T", "3L19"],
			brine: ["7L17", "6L17", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defensecurl: ["7L1", "6L1", "3T", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7L9", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "7L38", "6M", "6L31", "5M", "5L31", "4M", "4L31", "3M", "3L31"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			iceball: ["7L13", "6L13", "5L13", "4L13", "3L13"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			powdersnow: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L31", "6M", "6L31", "5M", "5L39", "4M", "4L39", "3M", "3L39"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L5", "6L5", "4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["7L52", "6L52", "5L55", "4L55", "3L55"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["7L31", "6T", "6L31", "5T", "5L39", "4T", "4L39", "3T", "3L39"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superfang: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L1", "6M", "6L32", "5M", "5L32", "4M", "4L32", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	walrein: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			aurorabeam: ["7L19", "6L19", "5L25", "4L25", "3L25"],
			avalanche: ["4M"],
			blizzard: ["7M", "7L49", "6M", "6L49", "5M", "5L52", "4M", "4L52", "3M", "3L50"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7L25", "6L19", "5L19", "4L19", "3T", "3L19"],
			brine: ["7L19", "6L19", "5S0", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L1", "6L1", "5L1", "4L1"],
			defensecurl: ["7L1", "6L1", "3T", "3L1"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7L7", "6L1", "5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			hail: ["7M", "7L38", "6M", "6L31", "5M", "5L31", "5S0", "4M", "4L31", "3M", "3L31"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			iceball: ["7L13", "6L13", "5L13", "4L13", "3L13"],
			icebeam: ["7M", "6M", "5M", "5S0", "4M", "3M"],
			icefang: ["7L1", "6L44", "5L44", "4L44"],
			icywind: ["6T", "5T", "4T", "3T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			powdersnow: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L31", "6M", "6L31", "5M", "5L39", "4M", "4L39", "3M", "3L39"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["7L7", "6L7", "4T", "3T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["7L60", "6L60", "5L65", "5S0", "4L65", "3L61"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["7L31", "6T", "6L31", "5T", "5L39", "4T", "4L39", "3T", "3L39"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superfang: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "7L1", "6M", "6L32", "5M", "5L32", "4M", "4L32", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	clamperl: {
		inherit: true,
		learnset: {
			aquaring: ["7E", "6E", "5E", "5D", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			barrier: ["7E", "6E", "5E", "4E", "3E"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["7E", "6E", "5E", "4E", "3T", "3E"],
			brine: ["7E", "6E", "5E", "4M"],
			captivate: ["5D", "4M"],
			clamp: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "4E", "3E"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1", "3L1"],
			mimic: ["3T"],
			muddywater: ["7E", "6E", "5E", "4E"],
			mudsport: ["7E", "6E", "5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7E", "6E", "5E", "4E", "3E"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shellsmash: ["7L50", "6L50", "5L51"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			waterpulse: ["7E", "6T", "6E", "5E", "4M", "3M"],
			whirlpool: ["7L1", "6L1", "5L1", "5D", "4M", "4L1", "3L1"],
		},
	},
	huntail: {
		inherit: true,
		learnset: {
			aquatail: ["7L39", "6T", "6L39", "5T", "5L46", "4T", "4L46"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L29", "6L29", "5L33", "4L33", "3L43"],
			bind: ["6T", "5T"],
			bite: ["7L1", "6L1", "5L6", "4L6", "3L8"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			brine: ["7L19", "6L19", "5L28", "4M", "4L28"],
			captivate: ["4M"],
			coil: ["7L45", "6L45"],
			confide: ["7M", "6M"],
			crunch: ["7L34", "6L34", "5L42", "4L42", "3L36"],
			dive: ["7L26", "6M", "6L26", "5M", "5L37", "4T", "4L37", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			feintattack: ["7L11", "6L11"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L50", "6L50", "5L51", "4L51", "3L50"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icefang: ["7L16", "6L16", "5L24", "4L24"],
			icywind: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			scaryface: ["7L9", "6L9", "5L19", "4L19", "3L29"],
			screech: ["7L5", "6L5", "5L10", "4L10", "3L15"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["6T", "5T", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["7L23", "6L23", "4T"],
			superfang: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["7L14", "6T", "6L14", "5L15", "4M", "4L15", "3M", "3L22"],
			whirlpool: ["7L1", "6L1", "5L1", "4M", "4L1", "3L1"],
		},
	},
	gorebyss: {
		inherit: true,
		learnset: {
			agility: ["7L9", "6L9", "5L10", "4L10", "3L15"],
			amnesia: ["7L16", "6L16", "5L19", "4L19", "3L29"],
			aquaring: ["7L19", "6L19", "5L24", "4L24"],
			aquatail: ["7L39", "6T", "6L39", "5T", "5L46", "4T", "4L46"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			batonpass: ["7L29", "6L29", "5L33", "4L33", "3L43"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			brine: ["4M"],
			captivate: ["7L23", "6L23", "5L28", "4M", "4L28"],
			coil: ["7L45", "6L45"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L6", "4L6", "3L8"],
			dive: ["7L26", "6M", "6L26", "5M", "5L37", "4T", "4L37", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainingkiss: ["7L11", "6L11"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L50", "6L50", "5L51", "4L51", "3L50"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			infestation: ["7M", "6M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L34", "6M", "6L34", "5M", "5L42", "4M", "4L42", "3M", "3L36"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["7L14", "6T", "6L14", "5L15", "4M", "4L15", "3M", "3L22"],
			watersport: ["7L5", "6L5"],
			whirlpool: ["7L1", "6L1", "5L1", "4M", "4L1", "3L1"],
		},
	},
	relicanth: {
		inherit: true,
		learnset: {
			amnesia: ["7E", "6E", "5E", "4E", "3E"],
			ancientpower: ["7L21", "6L1", "5L43", "4T", "4L43", "3L43"],
			aquatail: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["6T", "5T", "4T"],
			brine: ["7E", "6E", "5E", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dive: ["7L26", "6M", "6L26", "5M", "5L57", "4T", "4L57", "3M"],
			doubleedge: ["7L50", "6L50", "5L50", "4L50", "3T", "3L57"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthpower: ["6T", "5T", "5D", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L1"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			harden: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			headsmash: ["7L56", "7L1", "6L1", "5L78", "4L78"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L46", "6L1", "5L71", "4L71", "3L64"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			magnitude: ["7E", "6E", "5E", "4E", "3E"],
			mimic: ["3T"],
			muddywater: ["7E", "6E", "5E", "4E"],
			mudshot: ["7E", "6E", "5E"],
			mudslap: ["7E", "6E", "5E", "4T", "4E", "3T"],
			mudsport: ["7L6", "7L1", "6L1", "5L36", "4L36", "3L36"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L41", "6M", "6L41", "5M", "5L64", "4M", "4L64", "3M", "3L50"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "7L15", "6M", "6L15", "5M", "5L15", "4M", "4L15", "3M", "3L15"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			skullbash: ["7E", "6E", "5E", "4E", "3E"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "5D", "4M", "4E", "3T", "3E"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L31", "6L29", "5L29", "4L29", "3L29"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L10", "7L1", "6L1", "5L8", "5D", "4L8", "3L8"],
			waterpulse: ["6T", "4M", "3M"],
			watersport: ["7E", "6E", "5E", "4E", "3E"],
			whirlpool: ["4M"],
			yawn: ["7L35", "6L22", "5L22", "4L22", "3L22"],
			zenheadbutt: ["7E", "6T", "6E", "5T", "5E"],
		},
	},
	luvdisc: {
		inherit: true,
		learnset: {
			agility: ["7L7", "6L7", "5L9", "4L9", "3L16"],
			aquajet: ["7E", "6E", "5E", "4E"],
			aquaring: ["7L40", "7E", "6L40", "6E", "5L46", "5E", "4L37", "4E"],
			attract: ["7M", "7L20", "6M", "6L22", "5M", "5L27", "4M", "4L22", "3M", "3L28"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["7E", "6E", "5E", "4M"],
			captivate: ["7L37", "7E", "6L46", "6E", "5L51", "5E", "4M", "4L40", "4E"],
			charm: ["7L1", "6L1", "5L4", "5D", "4L4", "3L4"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainingkiss: ["7L9", "6L9"],
			endure: ["4M", "3T"],
			entrainment: ["7E", "6E"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flail: ["7L26", "6L27", "5L31", "4L46", "3L40"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			healpulse: ["7E", "6E", "5E"],
			heartstamp: ["7L22"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L46", "6L40", "5L40"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "5D", "4T", "3T"],
			luckychant: ["7L13", "6L14", "5L17", "4L17"],
			mimic: ["3T"],
			mudsport: ["7E", "6E", "5E", "5D", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L49", "6M", "6L55", "5M", "5L55", "4M", "4L51", "3M", "3L48"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			soak: ["7L42"],
			splash: ["7E", "6E", "5E", "4E", "3E"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			supersonic: ["7E", "6E", "5E", "4E", "3E"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			sweetkiss: ["7L31", "6L31", "5L37", "4L27", "3L36"],
			swift: ["4T", "3T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			takedown: ["7L34", "6L14", "5L14", "4L14", "3L24"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			watergun: ["7L4", "6L4", "5L7", "4L7", "3L12"],
			waterpulse: ["7L17", "6T", "6L17", "5L22", "4M", "4L31", "3M"],
			watersport: ["7E", "6E", "5E", "4E", "3E"],
			whirlpool: ["4M"],
		},
	},
	bagon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L10", "6L5", "5L5", "5D", "4L5", "3L5", "3S0", "3S1"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L25", "6L25", "5L46", "4L46", "3L41"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["7E", "6E", "5E"],
			doubleedge: ["7L49", "6L49", "5L55", "4L55", "3T", "3L53"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonbreath: ["7L13", "6L13", "5L31", "4L31", "3L33"],
			dragonclaw: ["7M", "7L29", "6M", "6L29", "5M", "5L50", "4M", "4L50", "3M", "3L49"],
			dragondance: ["7E", "6E", "5E", "5D", "4E", "3E"],
			dragonpulse: ["7E", "6T", "6E", "5T", "5E", "4M"],
			dragonrage: ["7E", "6E", "5E", "4E", "3E"],
			dragonrush: ["7E", "6E", "5E", "4E"],
			ember: ["7L4", "6L4", "5L25", "4L25", "3L25"],
			endure: ["7E", "6E", "5E", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			firefang: ["7E", "6E", "5E", "4E"],
			flamethrower: ["7M", "7L44", "6M", "6L44", "5M", "4M", "3M"],
			focusenergy: ["7L21", "6L20", "5L20", "4L20", "3L21"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["7L17", "6L16", "5L16", "4T", "4L16", "3L17"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["7E", "6E", "5E", "4E", "3E"],
			hypervoice: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			irondefense: ["3S1"],
			leer: ["7L7", "6L7", "5L10", "4L10", "3L9"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "5D", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			rage: ["7L1", "6L1", "6S3", "5L1", "5S2", "4L1", "3L1", "3S0", "3S1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L39", "6L39", "5L40", "4L40", "3L37"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			thrash: ["7E", "6E", "6S3", "5E", "4E", "3E"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["7E", "6E", "5E", "4T", "4E", "3E"],
			wish: ["3S0"],
			zenheadbutt: ["7L34", "6T", "6L34", "5T", "5L35", "4T", "4L35"],
		},
	},
	shelgon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L10", "7L1", "6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L25", "6L25", "5L50", "4L50", "3L56"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["7L56", "6L56", "5L61", "4L61", "3T", "3L78"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonbreath: ["7L13", "6L13", "5L32", "4L32", "3L38"],
			dragonclaw: ["7M", "7L29", "6M", "6L29", "5M", "5L55", "4M", "4L55", "3M", "3L69"],
			dragonpulse: ["6T", "5T", "4M"],
			ember: ["7L4", "7L1", "6L1", "5L25", "4L25", "3L25"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "7L49", "6M", "6L49", "5M", "4M", "3M"],
			focusenergy: ["7L21", "6L20", "5L20", "4L20", "3L21"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["7L17", "6L1", "5L1", "4T", "4L1", "3L1"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T", "4T"],
			leer: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			protect: ["7M", "7L1", "6M", "6L30", "5M", "5L30", "4M", "4L30", "3M", "3L30"],
			rage: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L42", "6L42", "5L43", "4L43", "3L47"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			zenheadbutt: ["7L35", "6T", "6L35", "5T", "5L37", "4T", "4L37"],
		},
	},
	salamence: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "5S3", "4M", "3M", "3S1"],
			aircutter: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bite: ["7L10", "7L1", "6L1", "5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L25", "6L25", "5L53", "4L53", "3L61"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			doubleedge: ["7L63", "6L1", "5L70", "4L70", "3T", "3L93"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonbreath: ["7L13", "6L13", "5L32", "4L32", "3L38", "3S0"],
			dragonclaw: ["7M", "7L29", "6M", "6L29", "5M", "5L61", "5S3", "4M", "4L61", "4S2", "3M", "3L79", "3S1"],
			dragondance: ["5S3", "3S1"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "7L1", "6M", "6L1", "5M", "5L80"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			ember: ["7L4", "7L1", "6L1", "5L25", "4L25", "3L25"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "4S2", "3M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			flamethrower: ["7M", "7L49", "6M", "6L49", "5M", "4M", "3M"],
			fly: ["7M", "7L1", "6M", "6L50", "5M", "5L50", "4M", "4L50", "3M", "3L50", "3S0"],
			focusenergy: ["7L21", "6L20", "5L20", "4L20", "3L21"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["7L17", "6L1", "5L1", "4T", "4L1", "3L1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["4S2"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			hypervoice: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M", "3M"],
			leer: ["7L7", "7L1", "6L1", "5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["6T", "5T", "5S3", "4T"],
			protect: ["7M", "7L1", "6M", "6L30", "5M", "5L30", "4M", "4L30", "3M", "3L30", "3S0"],
			rage: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S1"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L42", "6L42", "5L43", "4L43", "3L47", "3S0"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			steelwing: ["7M", "6M", "4M", "3M"],
			stoneedge: ["7M", "6M", "5M", "4M", "4S2"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["4T"],
			zenheadbutt: ["7L35", "6T", "6L35", "5T", "5L37", "4T", "4L37"],
		},
	},
	beldum: {
		inherit: true,
		learnset: {
			headbutt: ["4T"],
			holdback: ["6S0"],
			irondefense: ["6T", "6S0", "5T", "4T"],
			ironhead: ["6T", "6S0", "5T", "5D", "4T"],
			takedown: ["7L1", "6L1", "5L1", "5D", "4L1", "3L1"],
			zenheadbutt: ["6T", "6S0", "5T", "5D", "4T"],
		},
	},
	metang: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L41", "6L38", "5L44", "4L44", "3L56"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7L26", "6L26", "5L32", "4L32"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "4L1", "3L20", "3S0"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7L50", "6M", "6L50", "5M", "5L56", "4M", "4L56", "3M", "3L62"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["7L47", "6T", "6L47", "5T", "5L40", "4T", "4L40", "3L44"],
			ironhead: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magnetrise: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			metalclaw: ["7L1", "6L1", "5L1", "4L1", "3L20", "3S0"],
			meteormash: ["7L44", "6L44", "5L48", "4L48", "3L50"],
			mimic: ["3T"],
			miracleeye: ["7L29", "6L26", "5L26"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L38", "6M", "6L38", "5M", "5L36", "4M", "4L36", "3M", "3L38"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			pursuit: ["7L23", "6L23", "5L28", "4L28", "3L32"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scaryface: ["7L35", "6L35", "5L24", "4L24", "3L26"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["7L1", "6L1", "5L1", "4L1", "3L1", "3S0"],
			telekinesis: ["5M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			zenheadbutt: ["7L32", "6T", "6L29", "5T", "5L52", "4T", "4L52"],
		},
	},
	metagross: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L41", "6L38", "5L44", "5S4", "4L44", "3L66"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7L26", "6L26", "5L32", "5S1", "5S2", "4L32", "4S0"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["5S4", "5S5", "3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "5S1", "5S3", "5S6", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "6M", "5M", "4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hammerarm: ["7L1", "6L45", "5L45", "5S1", "5S2", "5S4", "5S5", "4L45", "4S0"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7L60", "6M", "6L60", "5M", "5L71", "5S6", "4M", "4L71", "3M", "3L77"],
			icepunch: ["6T", "5T", "5S2", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["7L52", "6T", "6L52", "5T", "5L40", "5S4", "4T", "4L40", "3L44"],
			ironhead: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magnetrise: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			metalclaw: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			meteormash: ["7L44", "6L44", "5L53", "5S1", "5S3", "5S5", "5S6", "4L53", "4S0", "3L55"],
			mimic: ["3T"],
			miracleeye: ["7L29", "6L26", "5L26"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "5S3", "4M", "3M"],
			psychic: ["7M", "7L38", "6M", "6L38", "5M", "5L36", "5S5", "5S6", "4M", "4L36", "3M", "3L38"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			pursuit: ["7L23", "6L23", "5L28", "4L28", "3L32"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scaryface: ["7L35", "6L35", "5L24", "4L24", "3L1"],
			secretpower: ["6M", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			sludgebomb: ["7M", "6M", "5M", "4M", "3M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			telekinesis: ["5M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			zenheadbutt: ["7L32", "6T", "6L29", "5T", "5L62", "5S2", "5S3", "4T", "4L62", "4S0"],
		},
	},
	regirock: {
		inherit: true,
		learnset: {
			ancientpower: ["7L31", "6L31", "6S4", "5L33", "4T", "4L33", "3L33", "3S0", "3S1"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "7L19", "7L1", "6M", "6L1", "6S4", "5M"],
			chargebeam: ["7M", "7L13", "7L1", "6M", "6L1", "5M", "5L49", "5S3", "4M", "4L49"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			curse: ["7L25", "6L17", "6S4", "5L17", "4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			drainpunch: ["6T", "5T", "4M"],
			dynamicpunch: ["3T"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L1", "6M", "6L1", "6S5", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			hammerarm: ["7L49", "6L1", "6S5", "5L81", "4L81"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7L67", "6M", "6L67", "5M", "5L89", "4M", "4L89", "3M", "3L65", "3S1"],
			icepunch: ["6T", "6S5", "5T", "4T", "3T"],
			irondefense: ["7L37", "6T", "6L37", "6S4", "5T", "5L41", "5S3", "4L41", "3L41"],
			ironhead: ["6T", "5T", "4T"],
			lockon: ["7L55", "6L1", "5L57", "5S3", "4L57", "3L57"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rockthrow: ["7L7", "7L1", "6L1", "5L9", "4L9", "4S2", "3S0", "3L9"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stomp: ["7L1", "6L1", "5L1", "4L1", "4S2"],
			stoneedge: ["7M", "7L43", "6M", "6L43", "6S5", "5M", "5L73", "4M", "4L73"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["7L61", "6T", "6L25", "5T", "5L25", "4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			zapcannon: ["7L55", "6L1", "5L65", "5S3", "4L65", "3L49"],
		},
	},
	regice: {
		inherit: true,
		learnset: {
			amnesia: ["7L37", "6L37", "6S4", "6S5", "5L41", "5S3", "4L41", "3L41"],
			ancientpower: ["7L31", "6L31", "6S4", "5L33", "4T", "4L33", "3L33", "3S0", "3S1"],
			auroraveil: ["7M"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "7L19", "7L1", "6M", "6L1", "6S4", "5M"],
			chargebeam: ["7M", "7L13", "7L1", "6M", "6L1", "5M", "5L49", "5S3", "4M", "4L49"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			curse: ["7L25", "6L17", "6S4", "5L17", "4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			hail: ["7M", "6M", "6S5", "5M", "4M", "3M"],
			hammerarm: ["7L49", "6L1", "5L81", "4L81"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7L67", "6M", "6L67", "5M", "5L89", "4M", "4L89", "3M", "3L65", "3S1"],
			icebeam: ["7M", "7L43", "6M", "6L43", "6S5", "5M", "5L73", "4M", "4L73", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["7L7", "7L1", "6T", "6L1", "5T", "5L9", "4T", "4L9", "4S2", "3T", "3L9", "3S0"],
			ironhead: ["6T", "5T", "4T"],
			lockon: ["7L55", "6L1", "5L57", "5S3", "4L57", "3L57"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stomp: ["7L1", "6L1", "5L1", "4L1", "4S2"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			superpower: ["7L61", "6T", "6L25", "5T", "5L25", "4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "6S5", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			zapcannon: ["7L55", "6L1", "5L65", "5S3", "4L65", "3L49"],
		},
	},
	registeel: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			amnesia: ["7L37", "6L37", "6S4", "5L41", "5S3", "4L41", "3L41"],
			ancientpower: ["7L31", "6L31", "6S4", "5L33", "4T", "4L33", "3L33", "3S0", "3S1"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "7L19", "7L1", "6M", "6L1", "5M"],
			chargebeam: ["7M", "7L13", "7L1", "6M", "6L1", "5M", "5L49", "5S3", "4M", "4L49"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			curse: ["7L25", "6L17", "6S4", "5L17", "4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1", "3T", "3L1"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "7L43", "6M", "6L43", "5M", "5L73", "4M", "4L73"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "6S5", "5T", "4T"],
			hammerarm: ["7L49", "6L1", "5L81", "4L81"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7L67", "6M", "6L67", "5M", "5L89", "4M", "4L89", "3M", "3L65", "3S1"],
			icepunch: ["6T", "5T", "4T", "3T"],
			irondefense: ["7L37", "6T", "6L37", "6S4", "6S5", "5T", "5L41", "4T", "4L41", "3L41"],
			ironhead: ["7L43", "6T", "6L1", "6S5", "5T", "5L73", "4T", "4L73"],
			lockon: ["7L55", "6L1", "5L57", "5S3", "4L57", "3L57"],
			magnetrise: ["6T", "5T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["7L7", "7L1", "6L1", "5L9", "4L9", "4S2", "3L9", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "6S5", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			stomp: ["7L1", "6L1", "5L1", "4L1", "4S2"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["7L61", "6T", "6L25", "5T", "5L25", "4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			zapcannon: ["7L55", "6L1", "5L65", "5S3", "4L65", "3L49"],
		},
	},
	latias: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L7", "6L1", "5L55", "5S5", "4L55", "3L50", "3S1", "3S2"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonbreath: ["7L20", "6L20", "6S6", "5L20", "4L20", "4S3", "3L20"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["7L56", "6T", "6L1", "5T", "5L80", "4M", "4L70"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			guardsplit: ["7L46", "6L1", "5L75"],
			healingwish: ["7L61", "7L1", "6L1", "5L85", "4L60"],
			healpulse: ["7L16", "6L1", "6S6", "5L65", "5S5"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L10", "4T", "4L10", "3L10"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mimic: ["3T"],
			mistball: ["7L24", "6L24", "6S6", "5L35", "4L35", "4S3", "4S4", "3L35", "3S0", "3S1", "3S2"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L51", "6M", "6L51", "5M", "5L60", "5S5", "4M", "4L65", "3M", "3L40", "3S0", "3S1", "3S2"],
			psychoshift: ["7L28", "6L28", "6S6", "5L50", "5S5", "4L50"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L32", "6L32", "5L45", "4L45", "3L45", "3S1", "3S2"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			reflecttype: ["7L36", "6L1", "5L70"],
			refresh: ["7L13", "6L13", "5L30", "4L30", "4S3", "4S4", "3L30", "3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L1", "6M", "6L1", "5M", "5L15", "4M", "4L15", "3M", "3L15"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			steelwing: ["7M", "6M", "4M", "3M"],
			storedpower: ["7L10", "6L10"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			twister: ["4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			watersport: ["7L4", "6L4", "5L25", "4L25", "4S3", "4S4", "3L25", "3S0"],
			whirlpool: ["4M"],
			wish: ["7L1", "6L1", "5L5", "4L5", "3L5"],
			zenheadbutt: ["7L41", "6T", "6L40", "5T", "5L40", "4T", "4L40", "4S4"],
		},
	},
	latios: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			attract: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M", "3M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonbreath: ["7L20", "6L20", "6S6", "5L20", "4L20", "4S3", "3L20"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragondance: ["7L7", "6L1", "5L55", "5S5", "4L55", "3L50", "3S1", "3S2"],
			dragonpulse: ["7L56", "6T", "6L1", "6S7", "5T", "5L80", "4M", "4L70"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			flash: ["6M", "5M", "4M", "3M"],
			fly: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			healblock: ["7L1", "6L1", "5L5", "4L5"],
			healpulse: ["7L16", "6L1", "6S6", "6S7", "5L65", "5S5"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L10", "4T", "4L10", "3L10"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			lusterpurge: ["7L24", "6L24", "6S6", "6S7", "5L35", "4L35", "4S3", "4S4", "3L35", "3S0", "3S1", "3S2"],
			magiccoat: ["6T", "5T", "4T"],
			memento: ["7L61", "7L1", "6L1", "5L85", "4L60", "3L5"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			powersplit: ["7L46", "6L1", "5L75"],
			protect: ["7M", "7L4", "6M", "6L4", "5M", "5L25", "4M", "4L25", "4S3", "4S4", "3M", "3L25", "3S0"],
			psychic: ["7M", "7L51", "6M", "6L51", "6S7", "5M", "5L60", "5S5", "4M", "4L65", "3M", "3L40", "3S0", "3S1", "3S2"],
			psychoshift: ["7L28", "6L28", "6S6", "5L50", "5S5", "4L50"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L32", "6L32", "5L45", "4L45", "3L45", "3S1", "3S2"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7L13", "6L13", "5L30", "4L30", "4S3", "4S4", "3L30", "3S0"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L1", "6M", "6L1", "5M", "5L15", "4M", "4L15", "3M", "3L15"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			steelwing: ["7M", "6M", "4M", "3M"],
			storedpower: ["7L10", "6L10"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["6T", "5T", "4T"],
			telekinesis: ["7L36", "6L1", "5M", "5L70"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			twister: ["4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["7L41", "6T", "6L40", "5T", "5L40", "4T", "4L40", "4S4"],
		},
	},
	kyogre: {
		inherit: true,
		learnset: {
			ancientpower: ["7L1", "6L1", "5L45", "5S3", "4T", "4L15", "4S2", "3L15"],
			aquaring: ["7L30", "6L30", "6S5", "5L30", "4L30", "4S2"],
			aquatail: ["7L15", "6T", "6L15", "5T", "5L65", "4T", "4L65"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7L20", "6L15", "6S5", "5L15", "4L15", "3T", "3L20", "3S0"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brine: ["4M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L50", "6M", "6L50", "5M", "5L60", "4M", "4L30", "3M", "3L30", "3S0"],
			confide: ["7M", "6M"],
			defensecurl: ["3T"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["7L80", "6L80", "5L80", "4L65", "3T", "3L65", "3S1"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			earthquake: ["7M", "6M", "5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hydropump: ["7L75", "6L75", "5L90", "4L45", "3L45", "3S0", "3S1"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icebeam: ["7M", "7L35", "6M", "6L35", "6S5", "6S6", "5M", "5L35", "5S3", "5S4", "4M", "4L35", "4S2", "3M", "3L35", "3S0"],
			icywind: ["6T", "5T", "4T", "3T"],
			ironhead: ["6T", "5T", "4T"],
			mimic: ["3T"],
			muddywater: ["7L60", "6L20", "5L20", "4L20"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			originpulse: ["7L45", "6L45", "6S5"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "4L50", "3M", "3L50", "3S1"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			scald: ["7M", "6M", "5M"],
			scaryface: ["7L5", "6L5", "5L5", "4L5", "3L5"],
			secretpower: ["6M", "4M", "3M"],
			sheercold: ["7L65", "6L65", "6S6", "5L75", "5S4", "4L60", "3L60", "3S1"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["7M", "6M", "6S6", "5M", "5S3", "5S4", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["7L1", "6T", "6L1", "5L1", "4M", "4L1", "3M", "3L1"],
			waterspout: ["7L90", "6L50", "6S6", "5L50", "5S3", "5S4", "4L50", "4S2", "3L75"],
			whirlpool: ["4M"],
		},
	},
	groudon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["7L1", "6L1", "5L45", "5S3", "4T", "4L15", "4S2", "3L15"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "7L50", "6M", "6L50", "5M", "5L60", "4M", "4L30", "3M", "3L30", "3S0"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			counter: ["3T"],
			cut: ["6M", "5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["6M", "5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dragonclaw: ["7M", "6M", "5M", "4M", "3M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			dynamicpunch: ["3T"],
			earthpower: ["7L15", "6T", "6L15", "5T", "5L65", "5S4", "4T", "4L65"],
			earthquake: ["7M", "7L35", "6M", "6L35", "6S5", "5M", "5L35", "5S3", "4M", "4L35", "4S2", "3M", "3L35", "3S0"],
			endure: ["4M", "3T"],
			eruption: ["7L90", "6L50", "5L50", "5S3", "5S4", "4L50", "4S2", "3L75"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "7L75", "6M", "6L75", "5M", "5L90", "4M", "4L45", "3M", "3L45", "3S0", "3S1"],
			firepunch: ["6T", "6S6", "5T", "4T", "3T"],
			fissure: ["7L65", "6L65", "5L75", "4L60", "3L60", "3S1"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hammerarm: ["7L80", "6L20", "6S6", "5L20", "5S4", "4L20"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			lavaplume: ["7L20", "6L15", "6S5", "5L15", "4L15"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudshot: ["7L1", "6L1", "5L1", "4L1", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			poweruppunch: ["6M"],
			precipiceblades: ["7L45", "6L45", "6S5"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			rest: ["7M", "7L30", "6M", "6L30", "6S5", "5M", "5L30", "4M", "4L30", "4S2", "3M", "3L50", "3S1"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "6S6", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scaryface: ["7L5", "6L5", "5L5", "4L5", "3L5"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			slash: ["4L20", "3L20", "3S0"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "7L60", "6M", "6L60", "6S6", "5M", "5L80", "5S3", "5S4", "4M", "4L65", "3M", "3L65", "3S1"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M", "3T"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			uproar: ["6T", "5T", "4T"],
		},
	},
	rayquaza: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			airslash: ["7L30", "6L30", "5L35", "4L35", "4S1"],
			ancientpower: ["7L15", "6L15", "5L45", "5S2", "4T", "4L15", "4S1", "3L15"],
			aquatail: ["6T", "5T", "4T"],
			avalanche: ["4M"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "6M", "5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "6M", "5M", "4M", "3M"],
			bulldoze: ["7M", "6M", "5M"],
			celebrate: ["6S7"],
			confide: ["7M", "6M"],
			crunch: ["7L20", "6L15", "5L15", "4L15", "3L35"],
			dive: ["6M", "5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["7T", "6T", "6S7", "5T", "4T"],
			dragonascent: ["7T", "6T", "6S4", "6S6", "6S7"],
			dragonclaw: ["7M", "6M", "6S6", "5M", "4M", "4L20", "3M", "3L20"],
			dragondance: ["7L60", "6L60", "6S4", "6S6", "5L60", "5S2", "4L30", "3L30"],
			dragonpulse: ["7L50", "6T", "6L50", "6S4", "6S5", "5T", "5L90", "5S2", "5S3", "4M", "4L75"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "6S6", "5M", "4M", "3M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			extremespeed: ["7L45", "6L45", "6S4", "6S5", "5L75", "5S3", "4L60", "3L60", "3S0"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			fireblast: ["7M", "6M", "5M", "4M", "3M"],
			flamethrower: ["7M", "6M", "5M", "4M", "3M"],
			fling: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "7L65", "6M", "6L65", "6S7", "5M", "5L65", "4M", "4L45", "3M", "3L45", "3S0"],
			focusblast: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gyroball: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7L90", "6M", "6L80", "5M", "5L80", "5S3", "4M", "4L65", "3M", "3L75"],
			hypervoice: ["7L75", "6T", "6L20", "5T", "5L20", "4L20"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icywind: ["6T", "5T", "4T", "3T"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["7L80", "6T", "6L50", "5T", "5L50", "5S2", "4T", "4L50", "4S1", "3L65", "3S0"],
			overheat: ["7M", "6M", "5M", "4M", "3M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "7L35", "6M", "6L30", "5M", "5L30", "4M", "4L30", "4S1", "3M", "3L50", "3S0"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			roar: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			scaryface: ["7L5", "6L5", "5L5", "4L5", "3L5"],
			secretpower: ["6M", "4M", "3M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M", "3M"],
			skydrop: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			surf: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			tailwind: ["6T", "5T", "4T"],
			thunder: ["7M", "6M", "6S5", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			twister: ["7L1", "6L1", "6S5", "5L1", "4T", "4L1", "3L1"],
			uproar: ["6T", "5T", "4T"],
			vcreate: ["5S3"],
			waterfall: ["7M", "6M", "5M", "4M", "3M"],
			waterpulse: ["6T", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	jirachi: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			ancientpower: ["4T"],
			bodyslam: ["3T"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "6S18", "6S20", "6S21", "5L1", "4L1", "4S11", "4S12", "3L1", "3S0", "3S1", "3S2", "3S3", "3S4", "3S5", "3S6", "3S7", "3S8", "3S9"],
			cosmicpower: ["7L60", "6L60", "6S19", "5L60", "5S15", "4L60", "3L45"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["3T"],
			doomdesire: ["7L70", "6L70", "5L70", "4L70", "3L50"],
			doubleedge: ["7L40", "6L40", "5L40", "4L40", "3T", "3L35"],
			doubleteam: ["7M", "6M", "5M", "4M", "3M"],
			dracometeor: ["5S14", "4S12"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			followme: ["5S14"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			futuresight: ["7L55", "6L55", "5L55", "4L55", "3L40"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["7L45", "6T", "6L45", "5T", "5L45", "4T", "4L45"],
			happyhour: ["6S20"],
			headbutt: ["4T"],
			healingwish: ["7L50", "7S22", "6L50", "6S17", "5L50", "5S13", "5S15", "5S16", "4L50"],
			heartstamp: ["6S19"],
			helpinghand: ["7L15", "6T", "6L15", "6S18", "5T", "5L15", "4T", "4L15", "3L15", "3S10"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["6T", "5T", "4T"],
			lastresort: ["7L65", "6T", "6L65", "5T", "5L65", "4T", "4L65"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			meteormash: ["5S13", "5S14", "5S15"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonblast: ["6S17"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			playrough: ["6S19"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L20", "6M", "6L20", "5M", "5L20", "5S13", "4M", "4L20", "3M", "3L20", "3S10"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			refresh: ["7L25", "6L25", "5L25", "4L25", "3L25", "3S10"],
			rest: ["7M", "7L30", "7L5", "7S22", "6M", "6L5", "6S21", "5M", "5L5", "4M", "4L5", "4S11", "4S12", "3M", "3L5", "3S0", "3S1", "3S2", "3S3", "3S4", "3S5", "3S6", "3S7", "3S8", "3S9", "3S10"],
			return: ["7M", "6M", "6S18", "5M", "5S16", "4M", "3M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			sandstorm: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snore: ["6T", "5T", "4T", "3T"],
			stealthrock: ["6T", "5T", "4M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L10", "7S22", "6L10", "6S17", "6S20", "5L10", "5S13", "5S16", "4T", "4L10", "3T", "3L10"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M", "3M"],
			wish: ["7L1", "7S22", "6L1", "6S17", "6S18", "6S19", "6S20", "6S21", "5L1", "5S14", "5S15", "5S16", "4L1", "4S11", "4S12", "3L1", "3S0", "3S1", "3S2", "3S3", "3S4", "3S5", "3S6", "3S7", "3S8", "3S9"],
			zenheadbutt: ["7L35", "6T", "6L35", "5T", "5L35", "4T", "4L35"],
		},
	},
	deoxys: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M", "3M"],
			agility: ["7L55", "6L55", "5L73", "4L73", "3L35"],
			allyswitch: ["5M"],
			amnesia: ["7L55", "6L55", "5L73", "4L73", "3L35"],
			avalanche: ["4M"],
			bind: ["6T", "5T"],
			bodyslam: ["3T"],
			brickbreak: ["7M", "6M", "5M", "4M", "3M"],
			brutalswing: ["7M"],
			calmmind: ["7M", "6M", "5M", "4M", "3M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			cosmicpower: ["7L55", "6L55", "6S10", "5L73", "4L73", "3L35", "3S3"],
			counter: ["7L73", "6L73", "5L97", "4L97", "4S6", "3T", "3L50"],
			cut: ["6M", "5M", "4M", "3M"],
			darkpulse: ["7M", "6M", "5S9"],
			detect: ["4S6"],
			doubleedge: ["3T"],
			doubleteam: ["7L13", "7M", "6M", "6L13", "5M", "5L17", "4M", "4L17", "4S5", "3M", "3L10"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["7M", "6M", "5M", "4M"],
			extremespeed: ["7L73", "6L73", "5L97", "4L97", "4S4", "4S5", "3L50"],
			facade: ["7M", "6M", "5M", "4M", "3M"],
			firepunch: ["6T", "5T", "4T", "3T"],
			flash: ["6M", "5M", "4M", "3M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M", "3M"],
			frustration: ["7M", "6M", "5M", "4M", "3M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M", "3M"],
			hyperbeam: ["7M", "7L73", "6M", "6L73", "6S10", "5M", "5L97", "4M", "4L97", "4S7", "3M", "3L50", "3S3"],
			icebeam: ["7M", "6M", "5M", "4M", "3M"],
			icepunch: ["6T", "5T", "4T", "3T"],
			icywind: ["6T", "5T", "4T", "3T"],
			irondefense: ["7L55", "6T", "6L55", "5T", "5L73", "4L73", "4S4", "3L35"],
			knockoff: ["7L19", "6T", "6L19", "5T", "5L25", "4T", "4L25", "3L15", "3S1", "3S2"],
			leer: ["7L1", "6L1", "5L1", "4L1", "4S8", "3L1"],
			lightscreen: ["7M", "6M", "5M", "4M", "3M"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			meteormash: ["4S7"],
			mimic: ["3T"],
			mirrorcoat: ["7L73", "6L73", "5L97", "4L97", "4S6", "3L50"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5S9"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["7L7", "6L7", "5L9", "4L9", "4S8", "3L5"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M", "3M"],
			psychic: ["7M", "7L31", "6M", "6L31", "5M", "5L41", "4M", "4L41", "3M", "3L25", "3S0", "3S1", "3S2"],
			psychoboost: ["7L67", "6L67", "6S10", "5L89", "5S9", "4L89", "4S4", "4S5", "4S6", "4S7", "4S8", "3L45", "3S3"],
			psychoshift: ["7L43", "6L43", "5L57", "4L57"],
			psychup: ["7M", "6M", "5M", "4M", "3T"],
			psyshock: ["7M", "6M", "5M"],
			pursuit: ["7L25", "6L25", "5L33", "4L33", "3L20", "3S0", "3S2"],
			raindance: ["7M", "6M", "5M", "4M", "3M"],
			recover: ["7L61", "6L61", "6S10", "5L81", "5S9", "4L81", "3L40", "3S3"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M", "3M"],
			rest: ["7M", "6M", "5M", "4M", "3M"],
			return: ["7M", "6M", "5M", "4M", "3M"],
			rockslide: ["7M", "6M", "5M", "4M", "3T"],
			rocksmash: ["6M", "5M", "4M", "3M"],
			rocktomb: ["7M", "6M", "5M", "4M", "3M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M", "3M"],
			secretpower: ["6M", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["7M", "6M", "5M", "4M", "3M"],
			shockwave: ["6T", "4M", "3M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M", "3M"],
			sleeptalk: ["7M", "6M", "5T", "4M", "3T"],
			snatch: ["7L37", "6T", "6L37", "5T", "5L49", "4M", "4L49", "3M", "3L30", "3S1"],
			snore: ["6T", "5T", "4T", "3T"],
			solarbeam: ["7M", "6M", "5M", "4M", "3M"],
			spikes: ["7L25", "6L25", "5L33", "4L33", "3L20", "3S1"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M", "3M"],
			substitute: ["7M", "6M", "5M", "4M", "3T"],
			sunnyday: ["7M", "6M", "5M", "4M", "3M"],
			superpower: ["7L37", "6T", "6L37", "5L49", "4L49", "4S7", "3S0"],
			swagger: ["7M", "6M", "5M", "4M", "3T"],
			swift: ["7L37", "6L37", "5L49", "4T", "4L49", "4S5", "3T", "3L30", "3S2"],
			taunt: ["7L19", "7M", "6M", "6L19", "5M", "5L25", "4M", "4L25", "3M", "3L15", "3S0"],
			telekinesis: ["5M"],
			teleport: ["7L13", "6L13", "5L17", "4L17", "3L10"],
			thunder: ["7M", "6M", "5M", "4M", "3M"],
			thunderbolt: ["7M", "6M", "5M", "4M", "3M"],
			thunderpunch: ["6T", "5T", "4T", "3T"],
			thunderwave: ["7M", "6M", "5M", "4M", "3T"],
			torment: ["7M", "6M", "5M", "4M", "3M"],
			toxic: ["7M", "6M", "5M", "4M", "3M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M", "3M"],
			wonderroom: ["6T", "5T"],
			wrap: ["7L1", "6L1", "5L1", "4L1", "4S8", "3L1"],
			zapcannon: ["7L61", "6L61", "5L81", "4L81", "4S4", "3L40"],
			zenheadbutt: ["7L49", "6T", "6L49", "5T", "5L65", "4T", "4L65"],
		},
	},
	turtwig: {
		inherit: true,
		learnset: {
			absorb: ["7L9", "6L9", "5L9", "5S0", "5S1", "4L9"],
			amnesia: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M"],
			bite: ["7L21", "6L21", "5L21", "4L21"],
			bodyslam: ["7E", "6E", "5E", "4E"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L37", "6L37", "5L37", "4L37"],
			curse: ["7L17", "6L17", "5L17", "4L17"],
			cut: ["6M", "5M", "4M"],
			doubleedge: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["7E", "6T", "6E", "5T", "5E", "4T"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["7L41", "6T", "6L41", "5T", "5L41", "4M", "4L41"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			grassyterrain: ["7E", "6E"],
			growth: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			irontail: ["6T", "5T", "4M"],
			leafstorm: ["7L45", "6L45", "5L45", "4L45"],
			leechseed: ["7L29", "6L29", "5L29", "4L29"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			megadrain: ["7L25", "6L25", "5L25", "4L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			protect: ["7M", "6M", "5M", "4M"],
			razorleaf: ["7L13", "6L13", "5L13", "4L13"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandtomb: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			seedbomb: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			spitup: ["7E", "6E", "5E", "4E"],
			stealthrock: ["6T", "5T", "4M"],
			stockpile: ["7E", "6E", "5E", "5S1", "4E"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			swagger: ["7M", "6M", "5M", "4M"],
			swallow: ["7E", "6E", "5E", "4E"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["7L33", "6T", "6L33", "5T", "5L33", "4T", "4L33"],
			tackle: ["7L1", "6L1", "5L1", "5S0", "5S1", "4L1"],
			thrash: ["7E", "6E", "5E", "4E"],
			tickle: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "6M", "5M", "4M"],
			wideguard: ["7E", "6E", "5E"],
			withdraw: ["7L5", "6L5", "5L5", "5S0", "5S1", "4L5"],
			workup: ["7M"],
			worryseed: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
		},
	},
	grotle: {
		inherit: true,
		learnset: {
			absorb: ["7L9", "7L1", "6L9", "5L9", "4L9"],
			attract: ["7M", "6M", "5M", "4M"],
			bite: ["7L22", "6L22", "5L22", "4L22"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L42", "6L42", "5L42", "4L42"],
			curse: ["7L17", "6L17", "5L17", "4L17"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["7L47", "6T", "6L47", "5T", "5L47", "4M", "4L47"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			irontail: ["6T", "5T", "4M"],
			leafstorm: ["7L52", "6L52", "5L52", "4L52"],
			leechseed: ["7L32", "6L32", "5L32", "4L32"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			megadrain: ["7L27", "6L27", "5L27", "4L27"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			protect: ["7M", "6M", "5M", "4M"],
			razorleaf: ["7L13", "6L13", "5L13", "4L13"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["7L37", "6T", "6L37", "5T", "5L37", "4T", "4L37"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			toxic: ["7M", "6M", "5M", "4M"],
			withdraw: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			workup: ["7M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	torterra: {
		inherit: true,
		learnset: {
			absorb: ["7L9", "7L1", "6L1", "5L1", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			bite: ["7L22", "6L22", "5L22", "4L22"],
			block: ["6T", "5T", "4T"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L45", "6L45", "5L45", "4L45"],
			curse: ["7L17", "6L17", "5L17", "4L17"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L1", "6M", "6L32", "5M", "5L32", "5S0", "4M", "4L32"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frenzyplant: ["7T", "6T", "5T", "4T"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["7L51", "6T", "6L51", "5T", "5L51", "4M", "4L51"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasspledge: ["7T", "6T", "5T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			leafstorm: ["7L57", "6L57", "5L57", "4L57"],
			leechseed: ["7L33", "6L33", "5L33", "4L33"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			megadrain: ["7L27", "6L27", "5L27", "4L27"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			outrage: ["6T", "5T", "5S0", "4T"],
			protect: ["7M", "6M", "5M", "4M"],
			razorleaf: ["7L13", "7L1", "6L1", "5L1", "4L1"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "5S0", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["7L39", "6T", "6L39", "5T", "5L39", "4T", "4L39"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			toxic: ["7M", "6M", "5M", "4M"],
			withdraw: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			woodhammer: ["7L1", "6L1", "5L1", "5S0", "4L1"],
			workup: ["7M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	chimchar: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			aerialace: ["7M", "6M", "5M", "4M"],
			assist: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M"],
			blazekick: ["7E", "6E", "5E", "4E"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doublekick: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			ember: ["7L7", "6L7", "5L7", "5S1", "5S3", "4L7"],
			encore: ["7E", "6E", "5E", "4E"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			facade: ["7M", "7L31", "6M", "6L31", "5M", "5L31", "4M", "4L31"],
			fakeout: ["7E", "6E", "5E", "5S3", "4E"],
			fireblast: ["7M", "6M", "5M", "4M"],
			firepledge: ["7T", "6T", "5T"],
			firepunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			firespin: ["7L33", "6L33", "5L33", "4L33"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L47", "6M", "6L47", "5M", "5L47", "4M", "4L41", "4S0", "4S2"],
			flamewheel: ["7L17", "6L17", "5L17", "4L17"],
			fling: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7E", "6E", "5E", "4E"],
			focuspunch: ["7E", "6T", "6E", "5E", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furyswipes: ["7L15", "6L15", "5L15", "4L15"],
			grassknot: ["7M", "6M", "5M", "4M", "4S0", "4S2"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			heatwave: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "4S0", "4S2"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M"],
			leer: ["7L1", "6L1", "5L1", "5S1", "5S3", "4L1"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			mudslap: ["4T"],
			nastyplot: ["7L23", "6L23", "5L23", "4L23"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			quickguard: ["7E", "6E", "5E"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "5S1", "4L1"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slackoff: ["7L41", "6L41", "5L41", "4L39"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M"],
			submission: ["7E", "6E", "5E"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "7L9", "6M", "6L9", "5M", "5L9", "5S1", "5S3", "4M", "4L9"],
			thunderpunch: ["7E", "6T", "6E", "5T", "5E", "4T", "4E", "4S0", "4S2"],
			torment: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "4M", "4L25"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M"],
		},
	},
	monferno: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L46", "6M", "6L46", "5M", "5L46"],
			aerialace: ["7M", "6M", "5M", "4M"],
			attract: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			closecombat: ["7L36", "6L36", "5L36", "4L36"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dualchop: ["6T", "5T"],
			ember: ["7L7", "7L1", "6L1", "5L1", "4L1"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			feint: ["7L26", "6L26", "5L26", "4L26"],
			fireblast: ["7M", "6M", "5M", "4M"],
			firepledge: ["7T", "6T", "5T"],
			firepunch: ["6T", "5T", "4T"],
			firespin: ["7L39", "6L39", "5L39", "4L39"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flamewheel: ["7L19", "6L19", "5L19", "4L19"],
			flareblitz: ["7L56", "6L56", "5L56", "4L49"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furyswipes: ["7L16", "6L16", "5L16", "4L16"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			machpunch: ["7L1", "6L14", "5L14", "4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slackoff: ["7L49", "6L49", "5L49", "4L46"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "7L9", "6M", "6L9", "5M", "5L9", "4M", "4L9"],
			thunderpunch: ["6T", "5T", "4T"],
			torment: ["7M", "7L29", "6M", "6L29", "5M", "5L29", "4M", "4L29"],
			toxic: ["7M", "6M", "5M", "4M"],
			uturn: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M", "5M"],
		},
	},
	infernape: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L52", "6M", "6L52", "5M", "5L52"],
			aerialace: ["7M", "6M", "5M", "4M"],
			attract: ["7M", "6M", "5M", "4M"],
			blastburn: ["7T", "6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L58", "6M", "6L58", "5M", "5L58", "4M", "4L53"],
			captivate: ["4M"],
			closecombat: ["7L1", "6L36", "6S1", "5L36", "5S0", "4L41"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dualchop: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			ember: ["7L7", "7L1", "6L1", "5L1", "4L1"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			feint: ["7L26", "6L26", "5L26", "4L29"],
			fireblast: ["7M", "6M", "6S1", "5M", "5S0", "4M"],
			firepledge: ["7T", "6T", "5T"],
			firepunch: ["6T", "6S1", "5T", "4T"],
			firespin: ["7L42", "6L42", "5L42", "4L45"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flamewheel: ["7L19", "6L19", "5L19", "4L21"],
			flareblitz: ["7L68", "7L1", "6L1", "5L68", "4L57"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "6S1", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furyswipes: ["7L16", "6L16", "5L16", "4L17"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "5S0", "4M"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			machpunch: ["7L1", "6L14", "5L14", "4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			punishment: ["7L29", "6L29", "5L29", "4L33"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "7L9", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			thunderpunch: ["6T", "5T", "4T"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uturn: ["7M", "6M", "5M", "5S0", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M", "5M"],
		},
	},
	piplup: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			agility: ["7E", "6E", "5E", "4E"],
			aquaring: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M"],
			bide: ["7L22", "7E", "6L22", "6E", "5L22", "5E", "4L18"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brine: ["7L29", "6L29", "5L29", "4M", "4L29"],
			bubble: ["7L8", "6L8", "5L8", "5S0", "5S3", "4L8"],
			bubblebeam: ["7L18", "7S5", "6L18", "5L18", "4L18"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doublehit: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drillpeck: ["7L39", "7S5", "6L39", "5L39", "4L39"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			featherdance: ["7E", "6E", "5E", "5S1", "5S2", "5S3", "4E"],
			flail: ["7E", "6E", "5E", "4E"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furyattack: ["7L25", "6L25", "5L25", "4L25"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L4", "6L4", "6S4", "5L4", "5S0", "5S3", "4L4"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hydropump: ["7L43", "7E", "7S5", "6L43", "6E", "5L43", "5E", "5S1", "4L43", "4E"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["7E", "6T", "6E", "5T", "5E", "4T"],
			mist: ["7L36", "6L36", "5L36", "4L36"],
			mudslap: ["7E", "6E", "5E", "4T", "4E"],
			mudsport: ["7E", "6E", "5E", "4E"],
			naturalgift: ["4M"],
			peck: ["7L15", "6L15", "5L15", "5S1", "5S2", "4L15"],
			pluck: ["5M", "4M"],
			pound: ["7L1", "6L1", "6S4", "5L1", "5S0", "5S3", "4L1"],
			protect: ["7M", "6M", "5M", "4M"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "6S4", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M", "5S2"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			sing: ["5S2"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			stealthrock: ["6T", "5T", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			supersonic: ["7E", "6E", "5E", "4E"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterfall: ["7M", "6M", "5M", "4M"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["6T", "4M"],
			watersport: ["7L11", "6L11", "5L11", "5S1", "4L11"],
			whirlpool: ["7L32", "7S5", "6L32", "5L32", "4M", "4L32"],
			workup: ["7M"],
			yawn: ["7E", "6E", "5E", "4E"],
		},
	},
	prinplup: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			attract: ["7M", "6M", "5M", "4M"],
			bide: ["7L24", "6L24", "5L24", "4L19"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brine: ["7L33", "6L33", "5L33", "4M", "4L33"],
			bubble: ["7L8", "7L1", "6L8", "5L8", "4L8"],
			bubblebeam: ["7L19", "6L19", "5L19", "4L19"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drillpeck: ["7L46", "6L46", "5L46", "4L46"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furyattack: ["7L28", "6L28", "5L28", "4L28"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L4", "7L1", "6L1", "5L1", "4L1"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["7L50", "6L50", "5L51", "4L51"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			metalclaw: ["7L1", "6L16", "5L16", "4L16"],
			mist: ["7L42", "6L42", "5L42", "4L42"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["7L15", "6L15", "5L15", "4L15"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterfall: ["7M", "6M", "5M", "4M"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["6T", "4M"],
			watersport: ["7L11", "6L11", "5L11", "4L11"],
			whirlpool: ["7L37", "6L37", "5L37", "4M", "4L37"],
			workup: ["7M"],
		},
	},
	empoleon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			aquajet: ["7L1", "6L36", "5L36", "5S0", "4L36"],
			attract: ["7M", "6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brine: ["7L33", "6L33", "5L33", "4M", "4L33"],
			bubble: ["7L8", "7L1", "6L1", "5L1", "4L1"],
			bubblebeam: ["7L19", "6L19", "5L19", "4L19"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drillpeck: ["7L52", "6L52", "5L52", "4L52"],
			earthquake: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furyattack: ["7L28", "6L28", "5L28", "4L28"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "5S0", "4M"],
			growl: ["7L4", "7L1", "6L1", "5L1", "4L1"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hydrocannon: ["7T", "6T", "5T", "4T"],
			hydropump: ["7L59", "6L59", "5L59", "5S0", "4L59"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "5S0", "4M"],
			icywind: ["6T", "5T", "4T"],
			irondefense: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			metalclaw: ["7L1", "6L16", "5L16", "4L16"],
			mist: ["7L46", "6L46", "5L46", "4L46"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["7L15", "6L15", "5L15", "4L15"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			steelwing: ["7M", "6M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "7L24", "6M", "6L24", "5M", "5L24", "4M", "4L19"],
			swordsdance: ["7M", "7L11", "6M", "6L11", "5M", "5L11", "4M", "4L11"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterfall: ["7M", "6M", "5M", "4M"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["6T", "4M"],
			whirlpool: ["7L39", "6L39", "5L39", "4M", "4L39"],
			workup: ["7M"],
		},
	},
	starly: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "4M", "4L25"],
			agility: ["7L33", "6L33", "5L33", "4L33"],
			aircutter: ["4T"],
			astonish: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M"],
			bravebird: ["7L37", "6L37", "5L37", "4L37"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			detect: ["7E", "6E", "5E"],
			doubleedge: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "4M", "4L13"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L17", "6T", "6L17", "5T", "5L17", "4T", "4L17"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			featherdance: ["7E", "6E", "5E", "4E"],
			finalgambit: ["7L41", "6L41", "5L41"],
			fly: ["7M", "6M", "5M", "4M"],
			foresight: ["7E", "6E", "5E", "4E"],
			frustration: ["7M", "6M", "5M", "4M"],
			furyattack: ["7E", "6E", "5E", "4E"],
			growl: ["7L1", "6L1", "5L1", "4L1", "4S0"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			mirrormove: ["7E", "6E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			pursuit: ["7E", "6E", "5E", "4E"],
			quickattack: ["7L5", "6L5", "5L5", "4L5"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			revenge: ["7E", "6E", "5E"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1", "4S0"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7L29", "6L29", "5L29", "4L29"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uproar: ["7E", "6T", "6E", "5E"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7L21", "6L21", "5L21", "4L21"],
			wingattack: ["7L9", "6L9", "5L9", "4L9"],
			workup: ["7M", "5M"],
		},
	},
	staravia: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "4M", "4L28"],
			agility: ["7L38", "6L38", "5L38", "4L38"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M"],
			bravebird: ["7L43", "6L43", "5L43", "4L43"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleteam: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "4M", "4L13"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L18", "6T", "6L18", "5T", "5L18", "4T", "4L18"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			featherdance: ["5D"],
			finalgambit: ["7L48", "6L48", "5L48"],
			fly: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			quickattack: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			steelwing: ["7M", "6M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			tailwind: ["6T", "5T", "5D", "4T"],
			takedown: ["7L33", "6L33", "5L33", "4L33"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uproar: ["6T"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7L23", "6L23", "5L23", "4L23"],
			wingattack: ["7L9", "6L9", "5L9", "5D", "4L9"],
			workup: ["7M", "5M"],
		},
	},
	staraptor: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "4M", "4L28"],
			agility: ["7L41", "6L41", "5L41", "4L41"],
			aircutter: ["4T"],
			attract: ["7M", "6M", "5M", "4M"],
			bravebird: ["7L49", "6L49", "5L49", "4L49"],
			captivate: ["4M"],
			closecombat: ["7L1", "6L34", "5L34", "4L34"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			doubleteam: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "4M", "4L13"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L18", "6T", "6L18", "5T", "5L18", "4T", "4L18"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			finalgambit: ["7L57", "6L57", "5L57"],
			fly: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			quickattack: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			skyattack: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			steelwing: ["7M", "6M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			tailwind: ["6T", "5T", "4T"],
			takedown: ["7L33", "6L33", "5L33", "4L33"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uproar: ["6T"],
			uturn: ["7M", "6M", "5M", "4M"],
			whirlwind: ["7L23", "6L23", "5L23", "4L23"],
			wingattack: ["7L9", "7L1", "6L1", "5L1", "4L1"],
			workup: ["7M", "5M"],
		},
	},
	bidoof: {
		inherit: true,
		learnset: {
			amnesia: ["7L41", "6L29", "5L29", "4L29"],
			aquatail: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E"],
			attract: ["7M", "6M", "5M", "4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			crunch: ["7L25"],
			curse: ["7L49", "6L45", "5L45", "4L45"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["7L5", "7E", "6L9", "6E", "5L9", "5E", "4L9", "4E"],
			dig: ["6M", "5M", "4M"],
			doubleedge: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["7E", "6E", "5E", "4E"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L5", "5L5", "4L5"],
			headbutt: ["7L13", "6L17", "5L17", "4T", "4L17"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperfang: ["7L17", "6L21", "5L21", "4L21"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			lastresort: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["7E", "6E", "5E", "4E"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			quickattack: ["7E", "6E", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["7E", "6E", "5E"],
			rocksmash: ["6M", "5M", "4M"],
			rollout: ["7L9", "7E", "6L13", "6E", "5L13", "5E", "4T", "4L13", "4E"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "5D", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			skullbash: ["7E", "6E", "5E"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superfang: ["7L33", "6T", "6L37", "5T", "5L37", "4T", "4L37"],
			superpower: ["7L45", "6T", "6L41", "5T", "5L41", "4T", "4L41"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "7L37"],
			tackle: ["7L1", "6L1", "5L1", "5D", "4L1", "4S0"],
			takedown: ["7L29", "6L33", "5L33", "4L33"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			watersport: ["7E", "6E", "5E", "4E"],
			workup: ["7M", "5M"],
			yawn: ["7L21", "6L25", "5L25", "4L25"],
		},
	},
	bibarel: {
		inherit: true,
		learnset: {
			amnesia: ["7L48", "6L33", "5L33", "4L33"],
			aquajet: ["7L1"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			crunch: ["7L28"],
			curse: ["7L58", "6L53", "5L53", "4L53"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["7L5", "6L9", "5L9", "4L9"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1"],
			headbutt: ["7L13", "6L18", "5L18", "4T", "4L18"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hyperfang: ["7L18", "6L23", "5L23", "4L23"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			lastresort: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M"],
			rollout: ["7L9", "6L13", "5L13", "4T", "4L13"],
			rototiller: ["7L1", "6L1"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superfang: ["7L38", "6T", "6L43", "5T", "5L43", "4T", "4L43"],
			superpower: ["7L53", "6T", "6L48", "5T", "5L48", "4T", "4L48"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "7L43"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L33", "6L38", "5L38", "4L38"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterfall: ["7M", "6M", "5M", "4M"],
			watergun: ["7L1", "6L15", "5L15", "4L15"],
			waterpulse: ["6T", "4M"],
			whirlpool: ["4M"],
			workup: ["7M", "5M"],
			yawn: ["7L23", "6L28", "5L28", "4L28"],
		},
	},
	kricketot: {
		inherit: true,
		learnset: {
			bide: ["7L1", "6L1", "5L1", "4L1"],
			bugbite: ["7L16", "6T", "6L16", "5T", "5L16", "4T", "4L16"],
			endeavor: ["6T", "5T", "5D", "4T"],
			growl: ["7L1", "6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			snore: ["6T", "5T", "4T"],
			stringshot: ["4T"],
			strugglebug: ["7L6", "6M", "6L6", "5L6", "5D"],
			uproar: ["6T", "5T", "5D", "4T"],
		},
	},
	kricketune: {
		inherit: true,
		learnset: {
			absorb: ["7L14"],
			aerialace: ["7M", "6M", "5M", "4M"],
			attract: ["7M", "6M", "5M", "4M"],
			bide: ["7L1", "6L1", "5L1", "4L1"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bugbite: ["6T", "5T", "4T"],
			bugbuzz: ["7L46", "6L46", "5L46", "4L34"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			fellstinger: ["7L36", "6L36"],
			flash: ["6M", "5M", "4M"],
			focusenergy: ["7L22", "6L22", "5L22", "4L22"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["7L1", "6L10", "5L10", "4T", "4L10"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1"],
			healbell: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			infestation: ["7M", "6M"],
			knockoff: ["6T", "5T", "4T"],
			leechlife: ["7M", "6L14", "5L14", "4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["7L42", "6L42", "5L42", "4L42"],
			perishsong: ["7L50", "6L50", "5L50", "4L38"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			screech: ["7L34", "6L34", "5L34", "4L30"],
			secretpower: ["6M", "4M"],
			silverwind: ["4M"],
			sing: ["7L18", "6L18", "5L18", "4L18"],
			slash: ["7L26", "6L26", "5L26", "4L26"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stickyweb: ["7L44", "6L44"],
			strength: ["6M", "5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "7L38", "6M", "6L38", "5M", "5L38", "4M", "4L38"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			xscissor: ["7M", "7L30", "6M", "6L30", "5M", "5L30", "4M", "4L26"],
		},
	},
	shinx: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			babydolleyes: ["7L11", "6L11"],
			bite: ["7L17", "6L17", "5L17", "4L13"],
			captivate: ["4M"],
			charge: ["7L9", "6L9", "5L9", "5D", "4L9"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			crunch: ["7L33", "6L33", "5L33", "4L29"],
			discharge: ["7L41", "6L41", "5L41", "4L41"],
			doublekick: ["7E", "6E", "5E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			eerieimpulse: ["7E", "6E"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			faketears: ["7E", "6E"],
			firefang: ["7E", "6E", "5E", "4E"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["7E", "6T", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			howl: ["7E", "6E", "5E", "4E"],
			icefang: ["7E", "6E", "5E", "4E"],
			irontail: ["6T", "5T", "4M"],
			leer: ["7L5", "6L5", "5L5", "4L5"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magnetrise: ["6T", "5T", "5D", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["7E", "6E", "5E", "5D", "4E"],
			protect: ["7M", "6M", "5M", "4M"],
			quickattack: ["7E", "6E", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "7L21", "6M", "6L21", "5M", "5L21", "4M", "4L21"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L37", "6L37", "5L37", "4L37"],
			secretpower: ["6M", "4M"],
			shockwave: ["7E", "6T", "6E", "5E", "4M"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			spark: ["7L13", "6L13", "5L13", "4L13"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "4M", "4L25"],
			swift: ["7E", "6E", "5E", "4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7E", "6E", "5E", "4E"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderfang: ["7L29", "7E", "6L29", "6E", "5L29", "5E", "4L29", "4E"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
		},
	},
	luxio: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			bite: ["7L18", "6L18", "5L18", "4L13"],
			captivate: ["4M"],
			charge: ["7L9", "6L9", "5L9", "4L9"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			crunch: ["7L38", "6L38", "5L38", "4L33"],
			discharge: ["7L48", "6L48", "5L48", "4L48"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			irontail: ["6T", "5T", "4M"],
			leer: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magnetrise: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "7L23", "6M", "6L23", "5M", "5L23", "4M", "4L23"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L43", "6L43", "5L43", "4L43"],
			secretpower: ["6M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			spark: ["7L13", "6L13", "5L13", "4L13"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "4M", "4L28"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderfang: ["7L33", "6L33", "5L33", "4L33"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "7L53", "6M", "6L53", "5M", "5L53"],
		},
	},
	luxray: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			bite: ["7L18", "6L18", "5L18", "4L13"],
			captivate: ["4M"],
			charge: ["7L9", "7L1", "6L1", "5L1", "4L1"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			crunch: ["7L42", "6L42", "5L42", "4L35"],
			discharge: ["7L56", "6L56", "5L56", "4L56"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			electricterrain: ["7L67", "7L1", "6L1"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			irontail: ["6T", "5T", "4M"],
			leer: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magnetrise: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "7L23", "6M", "6L23", "5M", "5L23", "4M", "4L23"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L49", "6L49", "5L49", "4L49"],
			secretpower: ["6M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			spark: ["7L13", "6L13", "5L13", "4L13"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "4M", "4L28"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderfang: ["7L35", "6L35", "5L35", "4L35"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "7L63", "6M", "6L63", "5M", "5L63"],
		},
	},
	cranidos: {
		inherit: true,
		learnset: {
			ancientpower: ["7L33", "6L33", "5L33", "4T", "4L28"],
			assurance: ["7L24", "6L24", "5L24", "4L24"],
			attract: ["7M", "6M", "5M", "4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L28", "6L28", "5L28"],
			confide: ["7M", "6M"],
			crunch: ["7E", "6E", "5E", "5S0", "4E"],
			curse: ["7E", "6E", "5E", "4E"],
			dig: ["6M", "5M", "4M"],
			doubleedge: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dragonpulse: ["6T", "5T", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "5D", "4T"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L6", "6L6", "5L6", "4L6"],
			frustration: ["7M", "6M", "5M", "4M"],
			hammerarm: ["7E", "6E", "5E", "4E"],
			headbutt: ["7L1", "6L1", "5L1", "5S0", "5D", "4T", "4L1"],
			headsmash: ["7L46", "6L46", "5L46", "4L43"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			ironhead: ["7E", "6T", "6E", "5T", "5E", "5D", "4T"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M"],
			leer: ["7L1", "7E", "6L1", "6E", "5L1", "5E", "4L1", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L10", "6L10", "5L10", "5S0", "4L10"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			scaryface: ["7L19", "6L19", "5L19", "4L19"],
			screech: ["7L42", "6L42", "5L42", "4L37"],
			secretpower: ["6M", "4M"],
			shockwave: ["6T", "4M"],
			slam: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stomp: ["7E", "6E", "5E", "4E"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			takedown: ["7L15", "6L15", "5L15", "5S0", "4L15"],
			thief: ["7M", "6M", "5M", "4M"],
			thrash: ["7E", "6E", "5E", "4E"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			whirlwind: ["7E", "6E", "5E", "4E"],
			zenheadbutt: ["7L37", "6T", "6L37", "5T", "5L37", "4T", "4L33"],
		},
	},
	rampardos: {
		inherit: true,
		learnset: {
			ancientpower: ["7L36", "6L36", "5L36", "4T", "4L28"],
			assurance: ["7L24", "6L24", "5L24", "4L24"],
			attract: ["7M", "6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			chipaway: ["7L28", "6L28", "5L28"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endeavor: ["7L1", "6T", "6L30", "5T", "5L30", "4T", "4L30"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "4T"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L6", "7L1", "6L6", "5L6", "4L6"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["7L1", "6L1", "5L1", "4T", "4L1"],
			headsmash: ["7L58", "6L58", "5L58", "4L52"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L10", "7L1", "6L10", "5L10", "4L10"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			scaryface: ["7L19", "6L19", "5L19", "4L19"],
			screech: ["7L51", "6L51", "5L51", "4L43"],
			secretpower: ["6M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			takedown: ["7L15", "6L15", "5L15", "4L15"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			whirlpool: ["4M"],
			zenheadbutt: ["7L43", "6T", "6L43", "5T", "5L43", "4T", "4L36"],
		},
	},
	shieldon: {
		inherit: true,
		learnset: {
			ancientpower: ["7L28", "6L28", "5L28", "4T", "4L28"],
			attract: ["7M", "6M", "5M", "4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bodyslam: ["7E", "6E", "5E", "5S0", "4E"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "5D", "4E"],
			curse: ["7E", "6E", "5E", "4E"],
			dig: ["6M", "5M", "4M"],
			doubleedge: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["7L33", "6L33", "5L33", "4M", "4L33"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			fissure: ["7E", "6E", "5E", "5D", "4E"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7E", "6E", "5E", "4E"],
			frustration: ["7M", "6M", "5M", "4M"],
			guardsplit: ["7E", "6E"],
			headbutt: ["7E", "6E", "5E", "4T", "4E"],
			heavyslam: ["7L46", "6L46", "5L46"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irondefense: ["7L19", "6T", "6L19", "5T", "5L19", "4T", "4L19"],
			ironhead: ["7L42", "6T", "6L42", "5T", "5L42", "4T", "4L43"],
			irontail: ["6T", "5T", "4M"],
			magnetrise: ["6T", "5T", "4T"],
			metalburst: ["7L37", "6L37", "5L37", "4L37"],
			metalsound: ["7L10", "6L10", "5L10", "5S0", "4L10"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "5S0", "5D", "4M", "4L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockblast: ["7E", "6E", "5E", "4E"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			scaryface: ["7E", "6E", "5E", "4E"],
			screech: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "7L24", "6M", "6L24", "5M", "5L24", "4M", "4L24"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L15", "6L15", "5L15", "5S0", "4L15"],
			taunt: ["7M", "7L6", "6M", "6L6", "5M", "5L6", "4M", "4L6"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			wideguard: ["7E", "6E", "5E"],
		},
	},
	bastiodon: {
		inherit: true,
		learnset: {
			ancientpower: ["7L28", "6L28", "5L28", "4T", "4L28"],
			attract: ["7M", "6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			block: ["7L1", "6T", "6L30", "5T", "5L30", "4T", "4L30"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["7L36", "6L36", "5L36", "4M", "4L36"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heavyslam: ["7L58", "6L58", "5L58"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irondefense: ["7L19", "6T", "6L19", "5T", "5L19", "4T", "4L19"],
			ironhead: ["7L51", "6T", "6L51", "5T", "5L51", "4T", "4L52"],
			irontail: ["6T", "5T", "4M"],
			magiccoat: ["6T", "5T", "4T"],
			magnetrise: ["6T", "5T", "4T"],
			metalburst: ["7L43", "6L43", "5L43", "4L43"],
			metalsound: ["7L10", "7L1", "6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			protect: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "7L24", "6M", "6L24", "5M", "5L24", "4M", "4L24"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L15", "6L15", "5L15", "4L15"],
			taunt: ["7M", "7L6", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
		},
	},
	burmy: {
		inherit: true,
		learnset: {
			bugbite: ["7L15", "6T", "6L15", "5T", "5L15", "5D", "4T", "4L15"],
			electroweb: ["6T", "5T"],
			hiddenpower: ["7M", "7L20", "6M", "6L20", "5L20", "4L20"],
			protect: ["7M", "7L1", "6M", "6L1", "5L1", "5D", "4L1"],
			snore: ["6T", "5T", "5D", "4T"],
			stringshot: ["4T"],
			tackle: ["7L10", "6L10", "5L10", "4L10"],
		},
	},
	wormadam: {
		inherit: true,
		learnset: {
			attract: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L41"],
			bugbite: ["7L15", "7L1", "6T", "6L15", "5T", "5L15", "4T", "4L15"],
			bugbuzz: ["7L50"],
			bulletseed: ["4M"],
			captivate: ["7L35", "6L35", "5L35", "4M", "4L35"],
			confide: ["7M", "6M"],
			confusion: ["7L23", "6L23", "5L23", "4L23"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			electroweb: ["6T", "5T"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flail: ["7L38", "6L38", "5L38", "4L38"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["6T", "5T", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["7L29", "6L29", "5L29", "4L29"],
			hiddenpower: ["7M", "7L20", "6M", "6L20", "5M", "5L20", "4M", "4L20"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			infestation: ["7M", "6M"],
			leafstorm: ["7L47", "6L47", "5L47", "4L47"],
			naturalgift: ["4M"],
			protect: ["7M", "7L10", "7L1", "6M", "6L10", "5M", "5L10", "4M", "4L10"],
			psybeam: ["7L32", "6L32", "5L32", "4L32"],
			psychic: ["7M", "7L44", "6M", "6L44", "5M", "5L44", "4M", "4L44"],
			psychup: ["7M", "6M", "5M", "4M"],
			quiverdance: ["7L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			razorleaf: ["7L26", "6L26", "5L26", "4L26"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			shadowball: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L1", "4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			synthesis: ["6T", "5T", "4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	wormadamsandy: {
		inherit: true,
		learnset: {
			attract: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L41"],
			bugbite: ["7L15", "7L1", "6T", "6L15", "5T", "5L15", "4T", "4L15"],
			bugbuzz: ["7L50"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["7L35", "6L35", "5L35", "4M", "4L35"],
			confide: ["7M", "6M"],
			confusion: ["7L23", "6L23", "5L23", "4L23"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			electroweb: ["6T", "5T"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fissure: ["7L47", "6L47", "5L47", "4L47"],
			flail: ["7L38", "6L38", "5L38", "4L38"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			harden: ["7L29", "6L29", "5L29", "4L29"],
			hiddenpower: ["7M", "7L20", "6M", "6L20", "5M", "5L20", "4M", "4L20"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			infestation: ["7M", "6M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "7L10", "7L1", "6M", "6L10", "5M", "5L10", "4M", "4L10"],
			psybeam: ["7L32", "6L32", "5L32", "4L32"],
			psychic: ["7M", "7L44", "6M", "6L44", "5M", "5L44", "4M", "4L44"],
			psychup: ["7M", "6M", "5M", "4M"],
			quiverdance: ["7L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockblast: ["7L26", "6L26", "5L26", "4L26"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L1", "4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
		},
	},
	wormadamtrash: {
		inherit: true,
		learnset: {
			attract: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L41"],
			bugbite: ["7L15", "7L1", "6T", "6L15", "5T", "5L15", "4T", "4L15"],
			bugbuzz: ["7L50"],
			captivate: ["7L35", "6L35", "5L35", "4M", "4L35"],
			confide: ["7M", "6M"],
			confusion: ["7L23", "6L23", "5L23", "4L23"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			electroweb: ["6T", "5T"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flail: ["7L38", "6L38", "5L38", "4L38"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gunkshot: ["6T", "5T", "4T"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hiddenpower: ["7M", "7L20", "6M", "6L20", "5M", "5L20", "4M", "4L20"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			infestation: ["7M", "6M"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["7L47", "6T", "6L47", "5T", "5L47", "4T", "4L47"],
			magnetrise: ["6T", "5T", "4T"],
			metalburst: ["7L1"],
			metalsound: ["7L29", "6L29", "5L29", "4L29"],
			mirrorshot: ["7L26", "6L26", "5L26", "4L26"],
			naturalgift: ["4M"],
			protect: ["7M", "7L10", "7L1", "6M", "6L10", "5M", "5L10", "4M", "4L10"],
			psybeam: ["7L32", "6L32", "5L32", "4L32"],
			psychic: ["7M", "7L44", "6M", "6L44", "5M", "5L44", "4M", "4L44"],
			psychup: ["7M", "6M", "5M", "4M"],
			quiverdance: ["7L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L1", "4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			venoshock: ["7M", "6M", "5M"],
		},
	},
	mothim: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M"],
			aircutter: ["4T"],
			airslash: ["7L41", "6L41", "5L41", "4L41"],
			attract: ["7M", "6M", "5M", "4M"],
			bugbite: ["7L15", "7L1", "6T", "6L15", "5T", "5L15", "4T", "4L15"],
			bugbuzz: ["7L50", "6L47", "5L47", "4L47"],
			camouflage: ["7L35", "6L35", "5L35", "4L35"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confusion: ["7L23", "6L23", "5L23", "4L23"],
			defog: ["4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			electroweb: ["6T", "5T"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["6T", "5T", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L26", "6L26", "5L26", "4L26"],
			hiddenpower: ["7M", "7L20", "6M", "6L20", "5M", "5L20", "4M", "4L20"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			infestation: ["7M", "6M"],
			lunge: ["7L47"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonpowder: ["7L29", "6L29", "5L29", "4L29"],
			protect: ["7M", "7L10", "7L1", "6M", "6L10", "5M", "5L10", "4M", "4L10"],
			psybeam: ["7L32", "6L32", "5L32", "4L32"],
			psychic: ["7M", "7L44", "6M", "6L44", "5M", "5L44", "4M", "4L44"],
			psychup: ["7M", "6M", "5M", "4M"],
			quiverdance: ["7L1", "6L50", "5L50"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["7L38", "6L38", "5L38", "4M", "4L38"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			venoshock: ["7M", "6M", "5M"],
		},
	},
	combee: {
		inherit: true,
		learnset: {
			aircutter: ["5D", "4T"],
			bugbite: ["7L13", "6T", "6L13", "5T", "5L13", "4T", "4L13"],
			bugbuzz: ["7L29", "6L29", "5L29"],
			endeavor: ["6T", "5T", "4T"],
			gust: ["7L1", "6L1", "5L1", "5D", "4L1"],
			mudslap: ["4T"],
			ominouswind: ["4T"],
			snore: ["6T", "5T", "4T"],
			stringshot: ["4T"],
			sweetscent: ["7L1", "6L1", "5L1", "4L1"],
			swift: ["4T"],
			tailwind: ["6T", "5T", "5D", "4T"],
		},
	},
	vespiquen: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M", "4M"],
			aircutter: ["4T"],
			airslash: ["7L37", "6L37", "5L37"],
			attackorder: ["7L45", "6L45", "5L37", "4L37"],
			attract: ["7M", "6M", "5M", "4M"],
			bugbite: ["6T", "5T", "4T"],
			captivate: ["7L41", "6L41", "5L33", "4M", "4L33"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L1", "5L7", "4L7"],
			cut: ["6M", "5M", "4M"],
			defendorder: ["7L17", "6L17", "5L13", "4L13"],
			defog: ["4M"],
			destinybond: ["7L53", "7L1", "6L1", "5L43", "4L43"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fellstinger: ["7L57", "7L1", "6L1"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["7L5", "6L5", "5L9", "4T", "4L9"],
			furyswipes: ["7L13", "6L13", "5L19", "4L19"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L1", "6L1", "5L1", "4L1"],
			healorder: ["7L29", "6L29", "5L25", "4L25"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			infestation: ["7M", "6M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonsting: ["7L1", "6L1", "5L3", "4L3"],
			powergem: ["7L25", "6L25", "5L21", "4L21"],
			protect: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L9", "6L9", "5L15", "4L15"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roost: ["7M", "6M", "5T", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			slash: ["7L1", "6L21", "5L31", "4L31"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			snore: ["6T", "5T", "4T"],
			stringshot: ["4T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "7L49", "6M", "6L49", "5M", "5L39", "4M", "4L39"],
			sweetscent: ["7L1", "6L1", "5L1", "4L1"],
			swift: ["4T"],
			tailwind: ["6T", "5T", "4T"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "7L33", "6M", "6L33", "5M", "5L27", "4M", "4L27"],
			uturn: ["7M", "6M", "5M", "4M"],
			venoshock: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	pachirisu: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			bestow: ["7E", "6E", "5E"],
			bide: ["7L1", "6L1", "5L1", "4L1"],
			bite: ["7E", "6E", "5E", "4E"],
			captivate: ["4M"],
			charge: ["7E", "6E", "5E"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L9", "6L9", "5L9", "4L9"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E", "5T", "5E", "5D", "4E"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["7E", "6E", "5E", "4E"],
			dig: ["6M", "5M", "4M"],
			discharge: ["7L41", "6L41", "5L41", "4L29"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			electroball: ["7L25", "6L25", "5L25"],
			electroweb: ["6T"],
			endure: ["7L17", "6L17", "5L17", "4M", "4L17"],
			facade: ["7M", "6M", "5M", "4M"],
			faketears: ["7E", "6E", "5E", "4E"],
			flail: ["7E", "6E", "5E", "4E"],
			flash: ["6M", "5M", "4M"],
			flatter: ["7E", "6E", "5E", "4E"],
			fling: ["7M", "6M", "5M", "4M"],
			followme: ["7E", "6E", "6S0", "5E"],
			frustration: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growl: ["7L1", "6L1", "5L1", "4L1"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperfang: ["7L49", "6L49", "5L49"],
			iondeluge: ["7E", "6E"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M"],
			lastresort: ["7L45", "6T", "6L45", "5T", "5L45", "4T", "4L37"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magnetrise: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nuzzle: ["7L19", "6L19", "6S0"],
			protect: ["7M", "6M", "6S0", "5M", "4M"],
			quickattack: ["7L5", "6L5", "5L5", "5D", "4L5"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rollout: ["7E", "6E", "5E", "4T", "4E"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			shockwave: ["6T", "5D", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spark: ["7L13", "6L13", "5L13", "4L13"],
			substitute: ["7M", "6M", "5M", "4M"],
			superfang: ["7L37", "6T", "6L37", "6S0", "5T", "5L37", "4T", "4L33"],
			swagger: ["7M", "6M", "5M", "4M"],
			sweetkiss: ["7L29", "6L29", "5L29", "4L25"],
			swift: ["7L21", "6L21", "5L21", "4T", "4L21"],
			tailwhip: ["7E", "6E", "5E"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "7L33", "6M", "6L33", "5M", "5L33", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			voltswitch: ["7M", "6M", "5M"],
		},
	},
	buizel: {
		inherit: true,
		learnset: {
			agility: ["7L41", "6L41", "5L28", "4L28"],
			aquajet: ["7L24", "6L24", "5L21", "4L21"],
			aquaring: ["7E", "6E", "5E"],
			aquatail: ["7L38", "7E", "6T", "6L38", "6E", "5T", "5L55", "5E"],
			attract: ["7M", "6M", "5M", "4M"],
			batonpass: ["7E", "6E", "5E", "4E"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brine: ["4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doublehit: ["7L27", "6L27", "5L27"],
			doubleslap: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["7E", "6E", "5E", "4E"],
			furyswipes: ["7E", "6E", "5E", "4E"],
			growl: ["7L4", "6L4", "5L1", "4L1"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["7E", "6E", "5E", "4T", "4E"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hydropump: ["7L45", "6L45", "5L45"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			mefirst: ["7E", "6E", "5E"],
			mudslap: ["7E", "6E", "5E", "4T", "4E"],
			naturalgift: ["4M"],
			odorsleuth: ["7E", "6E", "5E", "4E"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L18", "6L18", "5L10", "4L10"],
			quickattack: ["7L11", "6L11", "5L3", "4L3"],
			raindance: ["7M", "6M", "5M", "4M"],
			razorwind: ["7L35", "6L35", "5L45", "4L45"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			slash: ["7E", "6E", "5E", "5D", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			soak: ["7E", "6E"],
			sonicboom: ["7L1", "6L1", "5L1", "4L1"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["7L21", "6L21", "5L15", "4T", "4L15"],
			switcheroo: ["7E", "6E", "5E"],
			tailslap: ["7E", "6E", "5E"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterfall: ["7M", "6M", "5M", "4M"],
			watergun: ["7L15", "6L15", "5L6", "5D", "4L6"],
			waterpulse: ["6T", "5D", "4M"],
			watersport: ["7L7", "6L7", "5L1", "5D", "4L1"],
			whirlpool: ["7L31", "6L31", "5L36", "4M", "4L36"],
		},
	},
	floatzel: {
		inherit: true,
		learnset: {
			agility: ["7L51", "6L51", "5L29", "4L29"],
			aquajet: ["7L24", "6L24", "5L21", "4L21"],
			aquatail: ["7L46", "6T", "6L46", "5T", "5L62", "4T"],
			attract: ["7M", "6M", "5M", "4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brine: ["4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L1", "6L1", "5L26", "4L26"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doublehit: ["7L29", "6L29", "5L29"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L4", "7L1", "6L1", "5L1", "4L1"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hydropump: ["7L57", "6L57", "5L57"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icefang: ["7L1", "6L1", "5L1", "4L1"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			lowkick: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L18", "6L18", "5L10", "4L10"],
			quickattack: ["7L11", "7L1", "6L1", "5L1", "4L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			razorwind: ["7L41", "6L41", "5L50", "4L50"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			sonicboom: ["7L1", "6L1", "5L1", "4L1"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["7L21", "6L21", "5L15", "4T", "4L15"],
			taunt: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterfall: ["7M", "6M", "5M", "4M"],
			watergun: ["7L15", "6L15", "5L6", "4L6"],
			waterpulse: ["6T", "4M"],
			watersport: ["7L7", "7L1", "6L1", "5L1", "4L1"],
			whirlpool: ["7L35", "6L35", "5L39", "4M", "4L39"],
		},
	},
	cherubi: {
		inherit: true,
		learnset: {
			aromatherapy: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M"],
			bulletseed: ["5D", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["7E", "6E", "5E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			flowershield: ["7E", "6E"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["6T", "5T", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["7E", "6E", "5E", "4E"],
			growth: ["7L7", "6L7", "5L7", "4L7"],
			healingwish: ["7E", "6E", "5E"],
			healpulse: ["7E", "6E", "5E", "5D"],
			helpinghand: ["7L13", "6T", "6L13", "5T", "5L13", "4T", "4L13"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			leechseed: ["7L10", "6L10", "5L10", "5D", "4L10"],
			luckychant: ["7L40", "6L40", "5L40", "4L40"],
			magicalleaf: ["7L19", "6L19", "5L19", "4L19"],
			morningsun: ["7L1", "6L1", "5L1"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			naturepower: ["7M", "7E", "6M", "6E", "5E", "4E"],
			petalblizzard: ["7L47", "6L47"],
			protect: ["7M", "6M", "5M", "4M"],
			razorleaf: ["7E", "6E", "5E", "4E"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rollout: ["7E", "6E", "5E", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["7E", "6T", "6E", "5T", "5E", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L37"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "7L22", "6M", "6L22", "5M", "5L22", "4M", "4L22"],
			swagger: ["7M", "6M", "5M", "4M"],
			sweetscent: ["7E", "6E", "5E", "4E"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["6T", "5T", "4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L31", "6L31", "5L31", "4L31"],
			tickle: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "6M", "5M", "4M"],
			weatherball: ["7E", "6E", "5E", "4E"],
			worryseed: ["7L28", "6T", "6L28", "5T", "5L28", "4T", "4L28"],
		},
	},
	cherrim: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["6T", "5T", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			growth: ["7L7", "7L1", "6L1", "5L1", "4L1"],
			helpinghand: ["7L13", "6T", "6L13", "5T", "5L13", "4T", "4L13"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			leechseed: ["7L10", "7L1", "6L10", "5L10", "4L10"],
			luckychant: ["7L48", "6L48", "5L48", "4L48"],
			magicalleaf: ["7L19", "6L19", "5L19", "4L19"],
			morningsun: ["7L1", "6L1", "5L1"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			petalblizzard: ["7L50", "6L50"],
			petaldance: ["7L1", "6L25", "5L25", "4L25"],
			protect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "7L43", "6M", "6L43", "5M", "5L43", "4M", "4L43"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "7L22", "6M", "6L22", "5M", "5L22", "4M", "4L22"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["6T", "5T", "4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L35", "6L35", "5L35", "4L35"],
			toxic: ["7M", "6M", "5M", "4M"],
			worryseed: ["7L30", "6T", "6L30", "5T", "5L30", "4T", "4L30"],
		},
	},
	shellos: {
		inherit: true,
		learnset: {
			acidarmor: ["7E", "6E"],
			amnesia: ["7E", "6E", "5E", "4E"],
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bodyslam: ["7L29", "6L29", "5L29", "4L29"],
			brine: ["7E", "6E", "5E", "4M"],
			captivate: ["4M"],
			clearsmog: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E"],
			curse: ["7E", "6E", "5E", "4E"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fissure: ["7E", "6E", "5E", "4E"],
			frustration: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M"],
			harden: ["7L4", "6L4", "5L4", "4L4"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "7L16", "6M", "6L16", "5M", "5L16", "4M", "4L16"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			infestation: ["7M", "6M"],
			memento: ["7E", "6E", "5E", "4E"],
			mirrorcoat: ["7E", "6E", "5E", "4E"],
			mist: ["7E", "6E", "5E"],
			mudbomb: ["7L11", "6L11", "5L11", "4L11"],
			muddywater: ["7L37", "6L37", "5L37", "4L37"],
			mudslap: ["7L1", "6L1", "5L1", "5D", "4T", "4L1"],
			mudsport: ["7L2", "6L2", "5L2", "4L2"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "7L22", "6M", "6L22", "5M", "5L22", "4M", "4L22"],
			recover: ["7L46", "6L46", "5L46", "4L46"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "5D", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludge: ["7E", "6E", "5E", "4E"],
			snore: ["6T", "5T", "4T"],
			spitup: ["7E", "6E", "5E", "4E"],
			stockpile: ["7E", "6E", "5E", "4E"],
			stringshot: ["4T"],
			substitute: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swallow: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "6M", "5M", "4M"],
			trumpcard: ["7E", "6E", "5E", "4E"],
			waterpulse: ["7L7", "6T", "6L7", "5L7", "4M", "4L7"],
			whirlpool: ["4M"],
			yawn: ["7E", "6E", "5E", "5D", "4E"],
		},
	},
	gastrodon: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["7M", "6M", "5M", "4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			block: ["6T", "5T", "4T"],
			bodyslam: ["7L29", "6L29", "5L29", "4L29"],
			brine: ["4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M"],
			harden: ["7L4", "7L1", "6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "7L16", "6M", "6L16", "5M", "5L16", "4M", "4L16"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			infestation: ["7M", "6M"],
			mudbomb: ["7L11", "6L11", "5L11", "4L11"],
			muddywater: ["7L41", "6L41", "5L41", "4L41"],
			mudslap: ["7L1", "6L1", "5L1", "4T", "4L1"],
			mudsport: ["7L2", "7L1", "6L1", "5L1", "4L1"],
			naturalgift: ["4M"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "7L22", "6M", "6L22", "5M", "5L22", "4M", "4L22"],
			recover: ["7L54", "6L54", "5L54", "4L54"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			stringshot: ["4T"],
			substitute: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterfall: ["7M", "6M", "5M", "4M"],
			waterpulse: ["7L7", "7L1", "6T", "6L1", "5L1", "4M", "4L1"],
			whirlpool: ["4M"],
		},
	},
	drifloon: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aircutter: ["4T"],
			amnesia: ["7L40", "6L40", "5L40"],
			astonish: ["7L4", "6L4", "5L6", "4L6"],
			attract: ["7M", "6M", "5M", "4M"],
			batonpass: ["7L44", "6L44", "5L38", "4L33"],
			bind: ["6T", "5T"],
			bodyslam: ["7E", "6E", "5E", "4E"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			clearsmog: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			constrict: ["7L1", "6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M"],
			defog: ["7E", "6E", "5E", "4M"],
			destinybond: ["7E", "6E", "5E", "4E"],
			disable: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["7M", "7L50", "6M", "6L50", "5M", "5L46", "4M", "4L43"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			focusenergy: ["7L13", "6L13", "5L14", "4L14"],
			frustration: ["7M", "6M", "5M", "4M"],
			gust: ["7L8", "6L8", "5L11", "4L11"],
			gyroball: ["7M", "6M", "5M", "4M"],
			haze: ["7E", "6E", "5E", "4E"],
			hex: ["7L27", "6L27", "5L22"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hypnosis: ["7E", "6E", "5E", "5D", "4E"],
			icywind: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			magiccoat: ["6T", "5T", "4T"],
			memento: ["7E", "6E", "5E", "4E"],
			minimize: ["7L1", "6L1", "5L1", "5D", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["7L20", "6L20", "5L33", "4T", "4L30"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "7L16", "6M", "6L16", "5M", "5L17", "4M", "4L17"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["6T", "5T", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "7L36", "6M", "6L36", "5M", "5L43", "4M", "4L38"],
			shockwave: ["6T", "4M"],
			silverwind: ["4M"],
			skillswap: ["6T", "5T", "5D", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			spitup: ["7L32", "6L32", "5L30", "4L27"],
			stockpile: ["7L25", "6L25", "5L27", "4L22"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swallow: ["7L32", "6L32", "5L30", "4L27"],
			swift: ["4T"],
			tailwind: ["7E", "6T", "6E", "5T", "4T"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			weatherball: ["7E", "6E", "5E", "4E"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	drifblim: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aircutter: ["4T"],
			amnesia: ["7L46", "6L46", "5L46"],
			astonish: ["7L4", "7L1", "6L1", "5L1", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			batonpass: ["7L52", "6L52", "5L44", "4L37"],
			bind: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			constrict: ["7L1", "6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M"],
			defog: ["4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["7M", "7L60", "6M", "6L60", "5M", "5L56", "4M", "4L51"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fly: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L13", "6L13", "5L14", "4L14"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L8", "7L1", "6L1", "5L1", "4L1"],
			gyroball: ["7M", "6M", "5M", "4M"],
			hex: ["7L27", "6L27", "5L22"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			magiccoat: ["6T", "5T", "4T"],
			minimize: ["7L1", "6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["7L20", "6L20", "5L37", "4T", "4L32"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "7L16", "6M", "6L16", "5M", "5L17", "4M", "4L17"],
			phantomforce: ["7L65", "7L1", "6L1"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["6T", "5T", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "7L40", "6M", "6L40", "5M", "5L51", "4M", "4L44"],
			shockwave: ["6T", "4M"],
			silverwind: ["4M"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			spitup: ["7L34", "6L34", "5L32", "4L27"],
			stockpile: ["7L25", "6L25", "5L27", "4L22"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swallow: ["7L34", "6L34", "5L32", "4L27"],
			swift: ["4T"],
			tailwind: ["6T", "5T", "4T"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	buneary: {
		inherit: true,
		learnset: {
			afteryou: ["7L43", "6T", "6L43", "5T", "5L43"],
			agility: ["7L33", "6L33", "5L33", "4L33"],
			attract: ["7M", "6M", "5M", "4M", "4E"],
			babydolleyes: ["7L13", "6L10"],
			batonpass: ["7L26", "6L26", "5L26", "4L26"],
			bounce: ["7L56", "6T", "6L56", "5T", "5L56", "4T", "4L46"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L46", "6L46", "5L46", "4L43"],
			circlethrow: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			copycat: ["7E", "6E", "5E"],
			cosmicpower: ["7E", "6E"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["7L1", "6L1", "5L1", "4L1"],
			dig: ["6M", "5M", "4M"],
			dizzypunch: ["7L36", "6L36", "5L36", "4L36"],
			doublehit: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drainpunch: ["6T", "5T", "5D", "4M"],
			encore: ["7E", "6E", "5E", "4E"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["7L6", "6L6", "5L6", "4M", "4L6"],
			entrainment: ["7L50", "6L50", "5L53"],
			facade: ["7M", "6M", "5M", "4M"],
			fakeout: ["7E", "6E", "5E", "5D", "4E"],
			faketears: ["7E", "6E", "5E", "4E"],
			firepunch: ["7E", "6T", "6E", "5T", "5E", "4E"],
			flail: ["7E", "6E", "5E", "4E"],
			fling: ["7M", "6M", "5M", "4M"],
			focuspunch: ["7E", "6T", "6E", "5E", "4M"],
			foresight: ["7L1", "6L1", "5L1", "5D", "4L1"],
			frustration: ["7M", "7L1", "6M", "6L13", "5M", "5L13", "4M", "4L13"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			healingwish: ["7L63", "6L63", "5L63", "4L53"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["7E", "6T", "6E", "5T", "5E", "4E"],
			irontail: ["6T", "5T", "4M"],
			jumpkick: ["7L23", "6L23", "5L23", "4L23"],
			lastresort: ["6T", "5T", "4T"],
			lowkick: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			magiccoat: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			mudsport: ["7E", "6E"],
			naturalgift: ["4M"],
			pound: ["7L1", "6L1", "5L1", "4L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			quickattack: ["7L16", "6L16", "5L16", "4L16"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			skyuppercut: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			splash: ["7L1", "6L1", "5L1", "4L1"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			sweetkiss: ["7E", "6E", "5E", "4E"],
			swift: ["4T"],
			switcheroo: ["7E", "6E", "5E", "4E"],
			teeterdance: ["7E", "6E"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["7E", "6T", "6E", "5T", "5E", "4E"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M"],
			workup: ["7M", "5M"],
		},
	},
	lopunny: {
		inherit: true,
		learnset: {
			afteryou: ["7L43", "6T", "6L43", "5T", "5L43"],
			agility: ["7L33", "6L33", "5L33", "4L33"],
			attract: ["7M", "6M", "5M", "4M"],
			babydolleyes: ["7L13"],
			batonpass: ["7L26", "6L26", "5L26", "4L26"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bounce: ["7L56", "7L1", "6T", "6L1", "5T", "5L56", "4T", "4L46"],
			brutalswing: ["7M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L46", "6L46", "5L46", "4L43"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			defensecurl: ["7L1", "6L1", "5L1", "4L1"],
			dig: ["6M", "5M", "4M"],
			dizzypunch: ["7L36", "6L36", "5L36", "4L36"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drainpunch: ["6T", "5T", "4M"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["7L6", "6L6", "5L6", "4M", "4L6"],
			entrainment: ["7L53", "6L53", "5L53"],
			facade: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "4T"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			foresight: ["7L1", "6L1", "5L1", "4L1"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			healingwish: ["7L63", "7L1", "6L1", "5L63", "4L53"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			highjumpkick: ["7L66", "6L66"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			jumpkick: ["7L23", "6L23", "5L23", "4L23"],
			lastresort: ["6T", "5T", "4T"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			mirrorcoat: ["7L1", "6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pound: ["7L1", "6L1", "5L1", "4L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			quickattack: ["7L16", "6L16", "5L16", "4L16"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "7L1", "6M", "6L13", "5M", "5L13", "4M", "4L13"],
			rocksmash: ["6M", "5M", "4M"],
			rototiller: ["7L1", "6L1"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			splash: ["7L1", "6L1", "5L1", "4L1"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M"],
			workup: ["7M", "5M"],
		},
	},
	glameow: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			assist: ["7L29", "6L29", "5L29", "4L29"],
			assurance: ["7E", "6E", "5E", "5D", "4E"],
			attract: ["7M", "7L44", "6M", "6L44", "5M", "5L44", "4M", "4L45"],
			bite: ["7E", "6E", "5E", "4E"],
			captivate: ["7L32", "6L32", "5L32", "4M", "4L32"],
			charm: ["7L25", "6L25", "5L25", "4L25"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fakeout: ["7L1", "6L1", "5L1", "5D", "4L1"],
			faketears: ["7E", "6E", "5E", "4E"],
			feintattack: ["7L17", "6L17", "5L17", "4L17"],
			flail: ["7E", "6E", "5E", "4E"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["7L20", "6L20", "5L20", "4L20"],
			growl: ["7L8", "6L8", "5L8", "4L8"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["7L48", "6M", "6L48", "5M", "5L48"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["7L13", "6L13", "5L13", "4L13"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["7E", "6T", "6E", "5T", "5E", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			playrough: ["7L50", "6L50"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			quickattack: ["7E", "6E", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7E", "6E", "5E", "4E"],
			scratch: ["7L5", "6L5", "5L5", "4L5"],
			secretpower: ["6M", "5D", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			slash: ["7L37", "6L37", "5L37", "4L37"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["7E", "6T", "6E", "5T", "5E", "4M"],
			snore: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L41", "6L41", "5L41", "4T", "4L41"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tailwhip: ["7E", "6E", "5E", "4E"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uturn: ["7M", "6M", "5M", "4M"],
			wakeupslap: ["7E", "6E", "5E"],
			waterpulse: ["6T", "4M"],
			workup: ["7M", "5M"],
		},
	},
	purugly: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			assist: ["7L29", "6L29", "5L29", "4L29"],
			attract: ["7M", "7L52", "6M", "6L52", "5M", "5L52", "4M", "4L53"],
			bodyslam: ["7L45", "6L45", "5L45", "4L45"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["7L32", "6L32", "5L32", "4M", "4L32"],
			charm: ["7L25", "6L25", "5L25", "4L25"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fakeout: ["7L1", "6L1", "5L1", "4L1"],
			feintattack: ["7L17", "6L17", "5L17", "4L17"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["7L20", "6L20", "5L20", "4L20"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			growl: ["7L8", "7L1", "6L1", "5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["7L60", "6M", "6L60", "5M", "5L60"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			hypnosis: ["7L13", "6L13", "5L13", "4L13"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			slash: ["7L37", "6L37", "5L37", "4L37"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "7L1", "6M", "6L38", "5M", "5L38", "4M", "4L38"],
			swift: ["4T"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			workup: ["7M", "5M"],
		},
	},
	stunky: {
		inherit: true,
		learnset: {
			acidspray: ["7L19", "6L32", "5L32"],
			astonish: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M"],
			belch: ["7L43", "6L46"],
			bite: ["7L21"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7E", "6E", "5E", "4E"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			doubleedge: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["7M", "7L45", "6M", "6L49", "5M", "5L49", "4M", "4L44"],
			facade: ["7M", "6M", "5M", "4M"],
			feint: ["7L15", "6L18", "5L18", "4L18"],
			fireblast: ["7M", "6M", "5M", "4M"],
			flameburst: ["7E", "6E", "5E"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			focusenergy: ["7L1", "6L1", "5L1", "4L1"],
			foulplay: ["7E", "6T", "6E", "5T", "5E", "5D"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["7L9", "6L10", "5L10", "4L10"],
			haze: ["7E", "6E", "5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M"],
			leer: ["7E", "6E", "5E", "4E"],
			memento: ["7L33", "6L43", "5L43", "4L37"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["7L31", "6L37", "5L37", "4L31"],
			payback: ["7M", "6M", "5M", "4M"],
			playrough: ["7E", "6E"],
			poisongas: ["7L3", "6L4", "5L4", "4L4"],
			protect: ["7M", "6M", "5M", "4M"],
			punishment: ["7E", "6E", "5E", "4E"],
			pursuit: ["7E", "6E", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7E", "6E", "5E", "4E"],
			scratch: ["7L1", "6L1", "5L1", "4L1"],
			screech: ["7L7", "6L7", "5L7", "5D", "4L7"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L25", "6L22", "5L22", "4L22"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			smog: ["7E", "6E", "5E", "4E"],
			smokescreen: ["7L13", "6L14", "5L14", "4L14"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L39", "5D", "4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "7L27", "6M", "6L27", "5M", "5L27", "4M", "4L20"],
			venomdrench: ["7L37"],
			venoshock: ["7M", "6M", "5M"],
		},
	},
	skuntank: {
		inherit: true,
		learnset: {
			acidspray: ["7L19", "6L32", "5L32"],
			attract: ["7M", "6M", "5M", "4M"],
			belch: ["7L43", "6L56"],
			bite: ["7L21"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defog: ["4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["7M", "7L45", "6M", "6L61", "5M", "5L61", "4M", "4L52"],
			facade: ["7M", "6M", "5M", "4M"],
			feint: ["7L15", "6L18", "5L18", "4L18"],
			fireblast: ["7M", "6M", "5M", "4M"],
			flamethrower: ["7M", "7L1", "6M", "6L34", "5M", "5L34", "4M", "4L34"],
			focusenergy: ["7L1", "6L1", "5L1", "4L1"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["7L9", "6L10", "5L10", "4L10"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M"],
			memento: ["7L33", "6L51", "5L51", "4L41"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["7L31", "6L41", "5L41", "4L31"],
			payback: ["7M", "6M", "5M", "4M"],
			poisongas: ["7L3", "7L1", "6L1", "5L1", "4L1"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1", "4L1"],
			screech: ["7L7", "7L1", "6L7", "5L7", "4L7"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L25", "6L22", "5L22", "4L22"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			smokescreen: ["7L13", "6L14", "5L14", "4L14"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L39", "4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "7L27", "6M", "6L27", "5M", "5L27", "4M", "4L20"],
			venomdrench: ["7L37"],
			venoshock: ["7M", "6M", "5M"],
		},
	},
	bronzor: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L11", "6L11", "5L11", "4L14"],
			confusion: ["7L1", "6L1", "5L1", "4L1"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			extrasensory: ["7L39", "6L39", "5L19", "4L19"],
			facade: ["7M", "6M", "5M", "4M"],
			feintattack: ["7L21", "6L21", "5L21", "4L41"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			futuresight: ["7L29", "6L29", "5L29", "4L37"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "5D", "4T"],
			gyroball: ["7M", "7L35", "6M", "6L35", "5M", "5L35", "4M", "4L35"],
			healblock: ["7L45", "6L45", "5L45", "4L52"],
			heavyslam: ["7L49", "6L49", "5L49"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hypnosis: ["7L5", "6L5", "5L5", "5D", "4L7"],
			imprison: ["7L9", "6L9", "5L9", "4L12"],
			irondefense: ["7L19", "6T", "6L19", "5T", "5L19", "4L26"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			metalsound: ["7L31", "6L31", "5L31"],
			naturalgift: ["4M"],
			payback: ["7M", "7L41", "6M", "6L41", "5M", "5L49", "4M", "4L49"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7L15", "6L15", "5L15"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "4M", "4L30"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "5D", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stealthrock: ["6T", "5T", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			telekinesis: ["5M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
		},
	},
	bronzong: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			block: ["7L1", "6T", "6L33", "5T", "5L33", "4T", "4L33"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L11", "6L11", "5L11", "4L14"],
			confusion: ["7L1", "6L1", "5L1", "4L1"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			explosion: ["7M", "6M", "5M", "4M"],
			extrasensory: ["7L42", "6L42", "5L19", "4L19"],
			facade: ["7M", "6M", "5M", "4M"],
			feintattack: ["7L21", "6L21", "5L21", "4L50"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			futuresight: ["7L29", "6L29", "5L29", "4L43"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			gyroball: ["7M", "7L36", "6M", "6L36", "5M", "5L36", "4M", "4L38"],
			healblock: ["7L52", "6L52", "5L52", "4L67"],
			heavyslam: ["7L58", "6L58", "5L58"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypnosis: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			imprison: ["7L9", "7L1", "6L1", "5L1", "4L1"],
			irondefense: ["7L19", "6T", "6L19", "5T", "5L19", "4L26"],
			ironhead: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			metalsound: ["7L31", "6L31", "5L31"],
			naturalgift: ["4M"],
			payback: ["7M", "7L46", "6M", "6L46", "5M", "5L46", "4M", "4L61"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7L15", "6L15", "5L15"],
			raindance: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			rollout: ["4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "4M", "4L30"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stealthrock: ["6T", "5T", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			swagger: ["7M", "6M", "5M", "4M"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			telekinesis: ["5M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	chatot: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			agility: ["7E", "6E", "5E", "4E"],
			aircutter: ["7E", "6E", "5E", "4T"],
			attract: ["7M", "6M", "5M", "4M"],
			boomburst: ["7E", "6E"],
			captivate: ["4M"],
			chatter: ["7L21", "7L1", "6L1", "5L21", "4L21", "4S0"],
			confide: ["7M", "7L1", "6M", "6L1"],
			defog: ["7E", "6E", "5E", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "7L37", "6M", "6L37", "5M", "5L37"],
			encore: ["7E", "6E", "5E", "4E"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			featherdance: ["7L50", "6L50", "5L53", "4L41"],
			fly: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furyattack: ["7L17", "6L17", "5L17", "4L17", "4S0"],
			growl: ["7L5", "6L5", "5L5", "4L5"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hypervoice: ["7L57", "7L1", "6T", "6L1", "5T", "5L57", "4L45"],
			mimic: ["7L33", "6L33", "5L33", "4L29"],
			mirrormove: ["7L9", "6L9", "5L9", "5D", "4L9", "4S0"],
			mudslap: ["4T"],
			nastyplot: ["7E", "6E", "5E", "5D", "4E"],
			naturalgift: ["4M"],
			nightshade: ["7E", "6E", "5E", "4E"],
			ominouswind: ["4T"],
			peck: ["7L1", "6L1", "5L1", "4L1"],
			pluck: ["5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "5D", "4T"],
			roost: ["7M", "7L41", "6M", "6L41", "5T", "5L41", "4M", "4L33"],
			round: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			secretpower: ["6M", "4M"],
			sing: ["7L13", "6L13", "5L13", "4L13"],
			skyattack: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M"],
			snore: ["6T", "5T", "4T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			supersonic: ["7E", "6E", "5E", "4E"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			synchronoise: ["7L49", "6L49", "5L49"],
			tailwind: ["6T", "5T", "4T"],
			taunt: ["7M", "7L25", "7L1", "6M", "6L1", "5M", "5L25", "4M", "4L25", "4S0"],
			thief: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uproar: ["7L45", "6T", "6L45", "5T", "5L45", "4T", "4L37"],
			uturn: ["7M", "6M", "5M", "4M"],
			workup: ["7M", "5M"],
		},
	},
	spiritomb: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["7E", "6E", "5E", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L1", "5L1", "4L1"],
			curse: ["7L1", "6L1", "5L1", "4L1"],
			darkpulse: ["7M", "7L49", "6M", "6L49", "5T", "5L49", "5S0", "4M", "4L49"],
			destinybond: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "7L19", "6M", "6L19", "5M", "5L19", "4M", "4L19"],
			embargo: ["7M", "6M", "5M", "5S0", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			feintattack: ["7L7", "6L7", "5L7", "4L7"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["7E", "6T", "6E", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grudge: ["7E", "6E", "5E", "4E"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypnosis: ["7L13", "6L13", "5L13", "4L13"],
			icywind: ["6T", "5T", "5D", "4T"],
			imprison: ["7E", "6E", "5E", "4E"],
			infestation: ["7M", "6M"],
			memento: ["7L43", "6L43", "5L43", "4L43"],
			nastyplot: ["7L37", "6L37", "5L37", "4L37"],
			naturalgift: ["4M"],
			nightmare: ["7E", "6E", "5E"],
			ominouswind: ["7L25", "6L25", "5L25", "4T", "4L25"],
			painsplit: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "5S0", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L1", "6L1", "5L1", "4L1"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowsneak: ["7L1", "7E", "6L1", "6E", "5L1", "5E", "4L1", "4E"],
			shockwave: ["6T", "4M"],
			silverwind: ["5S0", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			smokescreen: ["7E", "6E", "5E", "4E"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["7L1", "6T", "6L1", "5T", "5L1", "5D", "4T", "4L1"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L31", "6L31", "5L31", "4T", "4L31"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "6M", "5M", "4M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			uproar: ["6T", "5T", "4T"],
			waterpulse: ["6T", "4M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
		},
	},
	gible: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			attract: ["7M", "6M", "5M", "4M"],
			bodyslam: ["7E", "6E", "5E", "4E"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			dig: ["7L31", "6M", "6L31", "5M", "5L31", "4M", "4L31"],
			doubleedge: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonbreath: ["7E", "6E", "5E", "4E"],
			dragonclaw: ["7M", "7L27", "6M", "6L27", "5M", "5L27", "4M", "4L27"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrage: ["7L7", "6L7", "5L7", "5D", "4L7"],
			dragonrush: ["7L37", "6L37", "5L37", "4L37"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["5D", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			ironhead: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			irontail: ["7E", "6T", "6E", "5T", "5E"],
			metalclaw: ["7E", "6E", "5E", "4E"],
			mudshot: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["7E", "6T", "6E", "5T", "5E", "5D", "4T", "4E"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["7E", "6E", "5E", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L3", "6L3", "5L3", "4L3"],
			sandstorm: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "4M", "4L13"],
			sandtomb: ["7L19", "7E", "6L19", "6E", "5L19", "5E", "4L19", "4E"],
			scaryface: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L25", "6L25", "5L25", "4L25"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L15", "6L15", "5L15", "4L15"],
			thrash: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["7E", "6E", "5E", "4T", "4E"],
		},
	},
	gabite: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			attract: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			dig: ["7L40", "6M", "6L40", "5M", "5L40", "4M", "4L40"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonclaw: ["7M", "7L33", "6M", "6L33", "5M", "5L33", "4M", "4L33"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrage: ["7L7", "7L1", "6L7", "5L7", "4L7"],
			dragonrush: ["7L49", "6L49", "5L49", "4L49"],
			dualchop: ["7L1", "6T", "6L24", "5T", "5L24"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L3", "7L1", "6L1", "5L1", "4L1"],
			sandstorm: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "4M", "4L13"],
			sandtomb: ["7L19", "6L19", "5L19", "4L19"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L28", "6L28", "5L28", "4L28"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L15", "6L15", "5L15", "4L15"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
		},
	},
	garchomp: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "6S4", "5M", "4M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L1", "6L48", "6S2", "6S3", "5L48", "5S1", "4L48"],
			cut: ["6M", "5M", "4M"],
			dig: ["7L40", "6M", "6L40", "6S2", "6S3", "5M", "5L40", "5S1", "4M", "4L40"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dracometeor: ["7T", "6T", "6S2", "5T", "4T"],
			dragonclaw: ["7M", "7L33", "6M", "6L33", "6S2", "6S3", "5M", "5L33", "5S1", "4M", "4L33"],
			dragonpulse: ["6T", "5T", "4M"],
			dragonrage: ["7L7", "7L1", "6L1", "5L1", "4L1"],
			dragonrush: ["7L55", "6L55", "6S4", "5L55", "4L55"],
			dragontail: ["7M", "6M", "5M"],
			dualchop: ["7L1", "6T", "6L24", "5T", "5L24"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "6S4", "5M", "5S0", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "6S4", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "5S0", "5S1", "4T"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L3", "7L1", "6L1", "5L1", "4L1"],
			sandstorm: ["7M", "7L13", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			sandtomb: ["7L19", "6L19", "5L19", "4L19"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			slash: ["7L28", "6L28", "6S3", "5L28", "4L28"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "5S0", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "5S0", "4M"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L15", "6L15", "5L15", "4L15"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			whirlpool: ["4M"],
		},
	},
	riolu: {
		inherit: true,
		learnset: {
			agility: ["7E", "6E", "5E", "4E"],
			attract: ["7M", "6M", "5M", "4M"],
			aurasphere: ["4S0"],
			bite: ["7E", "6E", "5E", "4E"],
			blazekick: ["7E", "6E", "5E", "4E"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7E", "6E", "5E", "5D", "4E", "4S0"],
			captivate: ["4M"],
			circlethrow: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			copycat: ["7L19", "6L19", "5L29", "4L29"],
			counter: ["7L6", "6L6", "5L6", "4L6"],
			crosschop: ["7E", "6E", "5E", "4E"],
			crunch: ["7E", "6E", "5E", "4E"],
			detect: ["7E", "6E", "5E", "4E"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drainpunch: ["6T", "5T", "4M", "4S0"],
			dualchop: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["7L1", "6L1", "5L1", "5D", "4M", "4L1"],
			facade: ["7M", "6M", "5M", "4M"],
			feint: ["7L11", "6L11", "5L15", "4L15"],
			finalgambit: ["7L50", "6L50", "5L55"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "5D", "4M"],
			followme: ["7E", "6E", "5E", "4E"],
			forcepalm: ["7L15", "6L15", "5L11", "4L11"],
			foresight: ["7L1", "6L1", "5L1", "4L1"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			highjumpkick: ["7E", "6E", "5E", "4E"],
			icepunch: ["6T", "5T", "4T"],
			irondefense: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			irontail: ["6T", "5T", "4M"],
			lowkick: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			lowsweep: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T", "4T"],
			mindreader: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T"],
			nastyplot: ["7L47", "6L47", "5L47"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			quickattack: ["7L1", "6L1", "5L1", "4L1"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			reversal: ["7L29", "6L29", "5L19", "4L19"],
			roar: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			screech: ["7L24", "6L24", "5L24", "4L24"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M", "4S0"],
			skyuppercut: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["7E", "6E", "5E", "4T", "4E"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	lucario: {
		inherit: true,
		learnset: {
			agility: ["7E"],
			attract: ["7M", "6M", "5M", "4M"],
			aurasphere: ["7L1", "7S5", "6L1", "6S4", "5L51", "4L37", "4S0"],
			bite: ["7E"],
			blazekick: ["7E", "4S1"],
			bonerush: ["7L29", "6L29", "5L19", "4L19", "4S1"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7E", "5S2", "5S3"],
			calmmind: ["7M", "7L47", "6M", "6L47", "5M", "5L47", "4M"],
			captivate: ["4M"],
			circlethrow: ["7E"],
			closecombat: ["7L55", "6L1", "6S4", "5L55", "5S3", "4L42"],
			confide: ["7M", "6M"],
			counter: ["7L6", "6L6", "5L6", "5S2", "4L6"],
			crosschop: ["7E"],
			crunch: ["7E"],
			darkpulse: ["7M", "6M", "5T", "5L1", "4M", "4L1", "4S0"],
			detect: ["7L1", "7E", "6L1", "5L1", "5S2", "4L1"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dragonpulse: ["7L60", "7S5", "6T", "6L1", "5T", "5L60", "4M", "4L47", "4S0"],
			drainpunch: ["6T", "5T", "4M"],
			dualchop: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			extremespeed: ["7L65", "7S5", "6L1", "5L65", "4L51"],
			facade: ["7M", "6M", "5M", "4M"],
			feint: ["7L11", "6L11", "5L15", "4L15"],
			flashcannon: ["7M", "6M", "6S4", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			followme: ["7E"],
			forcepalm: ["5L11", "4L11", "4S1"],
			foresight: ["7L1", "6L1", "5L1", "4L1"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healpulse: ["7L51", "6L51", "5L42"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			highjumpkick: ["7E", "7S5"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			irondefense: ["7E", "6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			laserfocus: ["7L1"],
			lowkick: ["7E", "6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T", "4T"],
			mefirst: ["7L37", "6L37", "5L29", "4L29"],
			metalclaw: ["7L1", "6L1", "5L1", "5S2", "4L1"],
			metalsound: ["7L24", "6L24", "5L24", "4L24"],
			mindreader: ["7E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["7L15", "6M", "6L15"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			quickattack: ["7L1", "6L1", "6S4", "5L1", "4L1"],
			quickguard: ["7L33", "6L33", "5L33"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "5S3", "4M"],
			skyuppercut: ["7E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stoneedge: ["7M", "6M", "5M", "5S3", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M", "4S1"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "7L19", "6M", "6L19", "5M", "5L37", "4M", "4L33"],
			thunderpunch: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["7E", "4T"],
			waterpulse: ["6T", "4M", "4S0"],
			workup: ["7M", "7L42", "5M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	hippopotas: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			bite: ["7L7", "6L7", "5L7", "5D", "4L7"],
			bodyslam: ["7E", "6E", "5E", "4E"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L31", "6L31", "5L31", "4L31"],
			curse: ["7E", "6E", "5E", "4E"],
			dig: ["7L19", "6M", "6L19", "5M", "5L19", "4M", "4L19"],
			doubleedge: ["7L44", "6L44", "5L44", "4L44"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "4M", "4L37"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fissure: ["7L50", "6L50", "5L50", "4L50"],
			frustration: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			irontail: ["6T", "5T", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			revenge: ["7E", "6E", "5E", "4E"],
			roar: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L1", "6L1", "5L1", "4L1"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			sandtomb: ["7L25", "7E", "6L25", "6E", "5L25", "5E", "4L25", "4E"],
			secretpower: ["6M", "4M"],
			slackoff: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E", "4M"],
			snore: ["6T", "5T", "4T"],
			spitup: ["7E", "6E", "5E", "4E"],
			stealthrock: ["6T", "5T", "4M"],
			stockpile: ["7E", "6E", "5E", "5D", "4E"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "5D", "4T"],
			swagger: ["7M", "6M", "5M", "4M"],
			swallow: ["7E", "6E", "5E", "4E"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L19", "6L19", "5L19", "4L19"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			whirlwind: ["7E", "6E", "5E"],
			yawn: ["7L13", "6L13", "5L13", "4L13"],
		},
	},
	hippowdon: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			bite: ["7L7", "7L1", "6L1", "5L1", "4L1"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L31", "6L31", "5L31", "4L31"],
			dig: ["7L19", "6M", "6L19", "5M", "5L19", "4M", "4L19"],
			doubleedge: ["7L50", "6L50", "5L50", "4L50"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "7L40", "6M", "6L40", "5M", "5L40", "4M", "4L40"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			fissure: ["7L60", "6L60", "5L60", "4L60"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icefang: ["7L1", "6L1", "5L1", "4L1"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L1", "6L1", "5L1", "4L1"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			sandtomb: ["7L25", "6L25", "5L25", "4L25"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T"],
			swagger: ["7M", "6M", "5M", "4M"],
			tackle: ["7L1", "6L1", "5L1", "4L1"],
			takedown: ["7L19", "6L19", "5L19", "4L19"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			yawn: ["7L13", "7L1", "6L1", "5L1", "4L1"],
		},
	},
	skorupi: {
		inherit: true,
		learnset: {
			acupressure: ["7L13", "6L13", "5L17", "4L17"],
			aerialace: ["7M", "6M", "5M", "4M"],
			agility: ["7E", "6E", "5E", "5D", "4E"],
			aquatail: ["6T", "5T", "5D", "4T"],
			attract: ["7M", "6M", "5M", "4M"],
			bite: ["7L1", "6L1", "5L1", "5D", "4L1"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bugbite: ["7L20", "6T", "6L20", "5T", "5L34", "4T", "4L34"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E", "4E"],
			crosspoison: ["7L49", "6L49", "5L61", "4L50"],
			crunch: ["7L45", "6L45", "5L56", "4L45"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			feintattack: ["7E", "6E", "5E", "4E"],
			fellstinger: ["7L47", "6L47"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["7L30", "6M", "6L30", "5M", "5L45"],
			infestation: ["7M", "6M"],
			irontail: ["7E", "6T", "6E", "5T", "5E", "4M"],
			knockoff: ["7L5", "6T", "6L5", "5T", "5L6", "4T", "4L6"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["7L38", "7E", "6L38", "6E", "5L38", "5E", "4E"],
			payback: ["7M", "6M", "5M", "4M"],
			pinmissile: ["7L9", "6L9", "5L12", "4L12"],
			poisonfang: ["7L23", "6L23", "5L39", "4L39"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L1", "6L1", "5L1", "4L1"],
			poisontail: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L16", "7E", "6L16", "6E", "5L16", "5E", "4E"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7E", "6E", "5E", "4E"],
			scaryface: ["7L41", "6L41", "5L23", "4L23"],
			screech: ["7E", "6E", "5E", "4E"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			slash: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			snore: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			toxicspikes: ["7L34", "6L34", "5L28", "4L28"],
			twineedle: ["7E", "6E", "5E"],
			venoshock: ["7M", "7L27", "6M", "6L27", "5M", "5L50"],
			whirlwind: ["7E", "6E", "5E", "4E"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	drapion: {
		inherit: true,
		learnset: {
			acupressure: ["7L13", "6L13", "5L17", "4L17"],
			aerialace: ["7M", "6M", "5M", "4M"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "6M", "5M", "4M"],
			bite: ["7L1", "6L1", "5L1", "4L1"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brutalswing: ["7M"],
			bugbite: ["7L20", "6T", "6L20", "5T", "5L34", "4T", "4L34"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crosspoison: ["7L57", "6L57", "5L73", "4L58"],
			crunch: ["7L49", "6L49", "5L65", "4L49"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			falseswipe: ["7M", "6M", "5M", "4M"],
			fellstinger: ["7L53", "6L53"],
			firefang: ["7L1", "6L1", "5L1", "4L1"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["7L30", "6M", "6L30", "5M", "5L48"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icefang: ["7L1", "6L1", "5L1", "4L1"],
			infestation: ["7M", "6M"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["7L5", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["7L38", "6L38", "5L38"],
			payback: ["7M", "6M", "5M", "4M"],
			pinmissile: ["7L9", "6L9", "5L12", "4L1"],
			poisonfang: ["7L23", "6L23", "5L39", "4L39"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poisonsting: ["7L1", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L16", "6L16", "5L16"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L43", "6L43", "5L23", "4L23"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunderfang: ["7L1", "6L1", "5L1", "4L1"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			toxicspikes: ["7L34", "6L34", "5L28", "4L28"],
			venoshock: ["7M", "7L27", "6M", "6L27", "5M", "5L56"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	croagunk: {
		inherit: true,
		learnset: {
			acupressure: ["7E", "6E", "5E"],
			astonish: ["7L1", "6L1", "5L1", "5S0", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			belch: ["7L47", "6L47"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletpunch: ["7E", "6E", "5E", "4E"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "4E"],
			crosschop: ["7E", "6E", "5E", "4E"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drainpunch: ["7E", "6T", "6E", "5T", "5E", "5D"],
			dualchop: ["6T", "5T"],
			dynamicpunch: ["7E", "6E", "5E", "4E"],
			earthquake: ["7M", "6M", "5M", "4M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fakeout: ["7E", "6E", "5E", "4E"],
			feint: ["7E", "6E", "5E", "4E"],
			feintattack: ["7L17", "6L17", "5L17", "4L17"],
			flatter: ["7L50", "6L50", "5L50", "4L45"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gunkshot: ["6T", "5T", "5D", "4T"],
			headbutt: ["7E", "6E", "5E", "4T", "4E"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			meditate: ["7E", "6E", "5E", "4E"],
			mefirst: ["7E", "6E", "5E", "4E"],
			mudbomb: ["7L29", "6L29", "5L29", "4L29"],
			mudslap: ["7L3", "6L3", "5L3", "5S0", "5S1", "4T", "4L3"],
			nastyplot: ["7L38", "6L38", "5L38", "4L36"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "7L43", "6M", "6L43", "5M", "5L43", "5S1", "4M", "4L38"],
			poisonsting: ["7L8", "6L8", "5L8", "5S0", "5S1", "5D", "4L8"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L15", "6L15", "5L15", "4L15"],
			quickguard: ["7E", "6E"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			revenge: ["7L22", "6L22", "5L22", "4L22"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "7L45", "6M", "6L45", "5M", "5L45", "4M", "4L43"],
			sludgewave: ["7M", "6M", "5M"],
			smellingsalts: ["7E", "6E", "5E", "4E"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L31", "6L31", "5L31", "4T", "4L31"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "7L24", "6M", "6L24", "5M", "5L24", "4M", "4L24"],
			taunt: ["7M", "7L10", "6M", "6L10", "5M", "5L10", "5S0", "5S1", "4M", "4L10"],
			thief: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["7E", "6E", "5E", "4T", "4E"],
			venoshock: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			wakeupslap: ["7E", "6E", "5E", "4E"],
			workup: ["7M", "5M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	toxicroak: {
		inherit: true,
		learnset: {
			astonish: ["7L1", "6L1", "5L1", "4L1"],
			attract: ["7M", "6M", "5M", "4M"],
			belch: ["7L58", "6L58"],
			bounce: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drainpunch: ["6T", "5T"],
			dualchop: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			embargo: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			feintattack: ["7L17", "6L17", "5L17", "4L17"],
			flatter: ["7L62", "6L62", "5L62", "4L54"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gunkshot: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			icywind: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			lowkick: ["6T", "5T", "4T"],
			lowsweep: ["7M", "6M", "5M"],
			mudbomb: ["7L29", "6L29", "5L29", "4L29"],
			mudslap: ["7L3", "7L1", "6L1", "5L1", "4T", "4L1"],
			nastyplot: ["7L41", "6L41", "5L41", "4L36"],
			naturalgift: ["4M"],
			payback: ["7M", "6M", "5M", "4M"],
			poisonjab: ["7M", "7L49", "6M", "6L49", "5M", "5L49", "4M", "4L41"],
			poisonsting: ["7L8", "7L1", "6L1", "5L1", "4L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			pursuit: ["7L15", "6L15", "5L15", "4L15"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			revenge: ["7L22", "6L22", "5L22", "4L22"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "7L54", "6M", "6L54", "5M", "5L54", "4M", "4L49"],
			sludgewave: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["7L31", "6L31", "5L31", "4T", "4L31"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superfang: ["6T", "5T", "4T"],
			swagger: ["7M", "7L24", "6M", "6L24", "5M", "5L24", "4M", "4L24"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "7L10", "6M", "6L10", "5M", "5L10", "4M", "4L10"],
			thief: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			vacuumwave: ["4T"],
			venoshock: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			workup: ["7M", "5M"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	carnivine: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			bind: ["7L1", "6T", "6L1", "5T", "5L1", "4L1"],
			bite: ["7L7", "6L7", "5L7", "5D", "4L7"],
			bugbite: ["6T", "5T", "4T"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L41", "6L41", "5L41", "4L37"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			feintattack: ["7L27", "6L27", "5L27", "4L27"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gastroacid: ["6T", "5T", "5D", "4T"],
			gigadrain: ["7E", "6T", "6E", "5T", "5E", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["7E", "6E", "5E"],
			growth: ["7L1", "6L1", "5L1", "4L1"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			infestation: ["7M", "6M"],
			ingrain: ["7L21", "6L21", "5L21", "4L21"],
			knockoff: ["6T", "5T", "4T"],
			leaftornado: ["7L31", "6L31", "5L31"],
			leechseed: ["7E", "6E", "5E", "4E"],
			magicalleaf: ["7E", "6E", "5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M", "5M", "4M"],
			powerwhip: ["7L50", "6L50", "5L51", "4L47"],
			protect: ["7M", "6M", "5M", "4M"],
			ragepowder: ["7E", "6E", "5E", "5D"],
			razorleaf: ["7E", "6E", "5E", "4E"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			slam: ["7E", "6E", "5E", "4E"],
			sleeppowder: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			spitup: ["7L37", "6L37", "5L37", "4L31"],
			stockpile: ["7L37", "6L37", "5L37", "4L31"],
			stunspore: ["7E", "6E", "5E", "4E"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swallow: ["7L37", "6L37", "5L37", "4L31"],
			sweetscent: ["7L17", "6L17", "5L17", "4L17"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			thief: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			vinewhip: ["7L11", "6L11", "5L11", "4L11"],
			worryseed: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			wringout: ["7L47", "6L47", "5L47", "4L41"],
		},
	},
	finneon: {
		inherit: true,
		learnset: {
			agility: ["7E", "6E", "5E", "4E"],
			aircutter: ["4T"],
			aquaring: ["7L33", "6L33", "5L33", "4L33"],
			aquatail: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			attract: ["7M", "7L10", "6M", "6L10", "5M", "5L10", "5D", "4M", "4L10"],
			aurorabeam: ["7E", "6E", "5E"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bounce: ["7L45", "6T", "6L45", "5T", "5L45", "4T", "4L45"],
			brine: ["7E", "6E", "5E", "4M"],
			captivate: ["7L26", "6L26", "5L26", "4M", "4L26"],
			charm: ["7E", "6E", "5E", "4E"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flail: ["7E", "6E", "5E", "4E"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gust: ["7L17", "6L17", "5L17", "4L17"],
			hail: ["7M", "6M", "5M", "4M"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			pound: ["7L1", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M"],
			psybeam: ["7E", "6E", "5E", "4E"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "4M", "4L13"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L29", "6M", "6L29", "5M", "5L29", "4M", "4L29"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["7E", "6T", "6E", "5T", "5E"],
			silverwind: ["7L49", "6L49", "5L49", "4M", "4L49"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			soak: ["7L54", "6L54", "5L54"],
			splash: ["7E", "6E", "5E", "4E"],
			substitute: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			sweetkiss: ["7E", "6E", "5E", "5D", "4E"],
			swift: ["4T"],
			tailwind: ["6T", "5T", "4T"],
			tickle: ["7E", "6E", "5E", "4E"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["7M", "7L42", "6M", "6L42", "5M", "5L42", "4M", "4L42"],
			waterfall: ["7M", "6M", "5M", "4M"],
			watergun: ["7L6", "6L6", "5L6", "4L6"],
			waterpulse: ["7L22", "6T", "6L22", "5L22", "5D", "4M", "4L22"],
			whirlpool: ["7L38", "6L38", "5L38", "4M", "4L38"],
		},
	},
	lumineon: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			aquaring: ["7L35", "6L35", "5L35", "4L35"],
			aquatail: ["6T", "5T", "4T"],
			attract: ["7M", "7L10", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bounce: ["7L53", "6T", "6L53", "5T", "5L53", "4T", "4L53"],
			brine: ["4M"],
			captivate: ["7L26", "6L26", "5L26", "4M", "4L26"],
			confide: ["7M", "6M"],
			defog: ["4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gust: ["7L17", "7L1", "6L1", "5L17", "4L17"],
			hail: ["7M", "6M", "5M", "4M"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["7M", "6M", "5M", "4M"],
			pound: ["7L1", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "7L13", "6M", "6L13", "5M", "5L13", "4M", "4L13"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L29", "6M", "6L29", "5M", "5L29", "4M", "4L29"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["6T", "5T"],
			silverwind: ["7L59", "6L59", "5L59", "4M", "4L59"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			soak: ["7L66", "7L1", "6L1", "5L66"],
			substitute: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tailwind: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			uturn: ["7M", "7L48", "6M", "6L48", "5M", "5L48", "4M", "4L48"],
			waterfall: ["7M", "6M", "5M", "4M"],
			watergun: ["7L6", "7L1", "6L1", "5L1", "4L1"],
			waterpulse: ["7L22", "6T", "6L22", "5L22", "4M", "4L22"],
			whirlpool: ["7L42", "6L42", "5L42", "4M", "4L42"],
		},
	},
	snover: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			avalanche: ["7E", "6E", "5E", "5D", "4M"],
			blizzard: ["7M", "7L41", "6M", "6L41", "5M", "5L41", "4M", "4L41"],
			bulletseed: ["7E", "6E", "5E", "4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			doubleedge: ["7E", "6E", "5E", "4E"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["6T", "5T", "5D", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["7L13", "6L13", "5L13", "4L13"],
			growth: ["7E", "6E", "5E", "4E"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			iceshard: ["7L26", "6L26", "5L26", "4L26"],
			icywind: ["7L9", "6T", "6L9", "5T", "5L9", "4T", "4L9"],
			ingrain: ["7L31", "6L31", "5L31", "4L31"],
			irontail: ["6T", "5T", "4M"],
			leechseed: ["7E", "6E", "5E", "4E"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magicalleaf: ["7E", "6E", "5E", "4E"],
			mist: ["7L21", "7E", "6L21", "6E", "5L21", "5E", "4L21", "4E"],
			mudslap: ["4T"],
			naturalgift: ["7E", "6E", "5E", "4M"],
			powdersnow: ["7L1", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			razorleaf: ["7L5", "6L5", "5L5", "5D", "4L5"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["7E", "6T", "6E", "5T", "5E", "4T", "4E"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sheercold: ["7L46", "6L46", "5L46", "4L46"],
			skullbash: ["7E", "6E", "5E", "4E"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stomp: ["7E", "6E", "5E", "4E"],
			substitute: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "7L17", "6M", "6L17", "5M", "5L17", "4M", "4L17"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			woodhammer: ["7L36", "6L36", "5L36", "4L36"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	abomasnow: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["7M", "7L47", "6M", "6L47", "5M", "5L47", "4M", "4L47"],
			block: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["6T", "5T", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["7L13", "6L13", "5L13", "4L13"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			iceshard: ["7L26", "6L26", "5L26", "4L26"],
			icywind: ["7L9", "7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			ingrain: ["7L31", "6L31", "5L31", "4L31"],
			irontail: ["6T", "5T", "4M"],
			leer: ["7L1", "6L1", "5L1", "4L1"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			mist: ["7L21", "6L21", "5L21", "4L21"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			powdersnow: ["7L1", "6L1", "5L1", "4L1"],
			protect: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			razorleaf: ["7L5", "7L1", "6L1", "5L1", "4L1"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			shadowball: ["7M", "6M", "5M", "4M"],
			sheercold: ["7L58", "6L58", "5L58", "4L58"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "7L17", "6M", "6L17", "5M", "5L17", "4M", "4L17"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			woodhammer: ["7L36", "6L36", "5L36", "4L36"],
			worryseed: ["6T", "5T", "4T"],
		},
	},
	rotom: {
		inherit: true,
		learnset: {
			astonish: ["7L1", "6L1", "6S1", "5L1", "5S0", "4L1"],
			charge: ["7L57", "7L1", "6L1", "5L57", "4L43"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L1", "5L1", "4L1"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			discharge: ["7L64", "7L1", "6L1", "5L64", "4L50"],
			doubleteam: ["7M", "7L15", "6M", "6L15", "5M", "5L15", "4M", "4L15"],
			dreameater: ["7M", "6M", "5M", "4M"],
			electroball: ["7L43", "6L43", "5L43"],
			electroweb: ["6T", "5T"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			foulplay: ["6T"],
			frustration: ["7M", "6M", "5M", "4M"],
			hex: ["7L50", "6L50", "5L50"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["7L29", "6L29", "5L29", "4T", "4L29"],
			painsplit: ["6T", "5T", "4T"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["7L22", "6T", "6L22", "6S1", "5L22", "5D", "4M", "4L22"],
			signalbeam: ["6T", "5T", "5D", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			substitute: ["7M", "7L36", "6M", "6L36", "5M", "5L36", "4M", "4L36"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thundershock: ["7L1", "6L1", "5T", "5L1", "5S0", "4T", "4L1"],
			thunderwave: ["7M", "7L1", "6M", "6L1", "6S1", "5M", "5L1", "5D", "4M", "4L1"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["7L1", "6T", "6L1", "6S1", "5T", "5L1", "5S0", "4T", "4L1"],
			uproar: ["7L8", "6T", "6L8", "5T", "5L8", "5S0", "4T", "4L8"],
			voltswitch: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	rotomheat: {
		inherit: true,
		learnset: {
			overheat: ["7L1", "6L1", "5T", "4T"],
		},
	},
	rotomwash: {
		inherit: true,
		learnset: {
			hydropump: ["7L1", "6L1", "5T", "4T"],
		},
	},
	rotomfrost: {
		inherit: true,
		learnset: {
			blizzard: ["7L1", "6L1", "5T", "4T"],
		},
	},
	rotomfan: {
		inherit: true,
		learnset: {
			airslash: ["7L1", "6L1", "5T", "4T"],
		},
	},
	rotommow: {
		inherit: true,
		learnset: {
			leafstorm: ["7L1", "6L1", "5T", "4T"],
		},
	},
	uxie: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			amnesia: ["7L46", "6L46", "6S3", "5L46", "5S2", "4L46", "4S0", "4S1"],
			calmmind: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "4L1", "4S0"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			endure: ["7L16", "6L16", "5L16", "4M", "4L16"],
			energyball: ["7M", "6M", "5M", "4M"],
			extrasensory: ["7L50", "6L50", "6S3", "5L51", "5S2", "4L51"],
			facade: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "4T"],
			flail: ["7L61", "7L1", "6L1", "5L61", "5S2", "4L61"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			futuresight: ["7L36", "6L36", "6S3", "5L36", "5S2", "4L36", "4S0", "4S1"],
			gigadrain: ["6T", "5T", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			imprison: ["7L6", "6L6", "5L6", "4L6"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			memento: ["7L76", "7L1", "6L1", "5L76", "4L76"],
			mudslap: ["4T"],
			naturalgift: ["7L66", "7L1", "6L1", "5L66", "4M", "4L66"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			return: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stealthrock: ["6T", "5T", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["7L21", "6L21", "5L21", "4T", "4L21", "4S1"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			wonderroom: ["6T", "5T"],
			yawn: ["7L31", "6L31", "6S3", "5L31", "4L31", "4S0", "4S1"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	mesprit: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			charm: ["7L46", "6L46", "6S3", "5L46", "5S2", "4L46", "4S0", "4S1"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "4L1", "4S0"],
			copycat: ["7L61", "7L1", "6L1", "5L61", "5S2", "4L61"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			extrasensory: ["7L50", "6L50", "6S3", "5L51", "5S2", "4L51"],
			facade: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "4T"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			futuresight: ["7L36", "6L36", "6S3", "5L36", "5S2", "4L36", "4S0", "4S1"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healingwish: ["7L76", "7L1", "6L1", "5L76", "4L76"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			imprison: ["7L6", "6L6", "5L6", "4L6"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			luckychant: ["7L31", "6L31", "6S3", "5L31", "4L31", "4S0", "4S1"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mudslap: ["4T"],
			naturalgift: ["7L66", "7L1", "6L1", "5L66", "4M", "4L66"],
			poweruppunch: ["6M"],
			protect: ["7M", "7L16", "6M", "6L16", "5M", "5L16", "4M", "4L16"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			return: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["7L21", "6L21", "5L21", "4T", "4L21", "4S1"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	azelf: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "4L1", "4S0"],
			dazzlinggleam: ["7M", "6M"],
			detect: ["7L16", "6L16", "5L16", "4L16"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			explosion: ["7M", "7L76", "6M", "6L76", "5M", "5L76", "4M", "4L76"],
			extrasensory: ["7L50", "6L50", "6S3", "5L51", "5S2", "4L51"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			firepunch: ["6T", "5T", "4T"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			futuresight: ["7L36", "6L36", "6S3", "5L36", "5S2", "4L36", "4S0", "4S1"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["6T", "5T", "4T"],
			imprison: ["7L6", "6L6", "5L6", "4L6"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T", "4M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["7L61", "7L1", "6T", "6L1", "5T", "5L61", "4T", "4L61"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mudslap: ["4T"],
			nastyplot: ["7L46", "6L46", "6S3", "5L46", "5S2", "4L46", "4S0", "4S1"],
			naturalgift: ["7L66", "7L1", "6L1", "5L66", "4M", "4L66"],
			payback: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			return: ["7M", "6M", "5M", "4M"],
			roleplay: ["6T", "5T", "4T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["7L21", "6L21", "5L21", "4T", "4L21", "4S1"],
			taunt: ["7M", "6M", "5M", "4M"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["6T", "5T", "4T"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			uproar: ["7L31", "6T", "6L31", "6S3", "5T", "5L31", "5S2", "4T", "4L31", "4S0", "4S1"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	dialga: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			ancientpower: ["7L10", "6L10", "5L10", "4T", "4L10", "4S0"],
			aurasphere: ["7L37", "6L37", "6S5", "5L37", "5S4", "4L37"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dracometeor: ["7T", "6T", "5T", "5S4", "4T"],
			dragonbreath: ["7L1", "6L1", "5L1", "5S3", "4L1", "4S2"],
			dragonclaw: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "4M", "4L28", "4S0"],
			dragonpulse: ["6T", "5T", "5S4", "4M"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["7L33", "6T", "6L33", "5T", "5L33", "4T", "4L33", "4S1"],
			earthquake: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["7M", "7L50", "6M", "6L50", "6S5", "6S6", "5M", "5L50", "4M", "4L42"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			healblock: ["4L50", "4S1"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["7L42", "6T", "6L42", "6S5", "5T", "5L42", "4M"],
			magnetrise: ["6T", "5T", "4T"],
			metalburst: ["7L24", "6L24", "6S6", "5L24", "4L24"],
			metalclaw: ["7L6", "6L6", "5L6", "4L6", "4S0"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			overheat: ["7M", "6M", "6S6", "5M", "4M"],
			powergem: ["7L19", "6L19", "5L19", "4L19"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			roaroftime: ["7L46", "6L46", "6S5", "6S6", "5L46", "5S4", "4L40", "4S0", "4S1"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			scaryface: ["7L1", "6L1", "5L1", "5S3", "4L1", "4S2"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			slash: ["7L15", "6L15", "5L15", "4L15", "4S1"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trickroom: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
		},
	},
	palkia: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			ancientpower: ["7L10", "6L10", "5L10", "4T", "4L10", "4S0"],
			aquatail: ["7L42", "7L24", "6T", "6L24", "5T", "5L24", "4T", "4L24"],
			aurasphere: ["7L37", "6L37", "6S5", "6S6", "5L37", "5S4", "4L37"],
			avalanche: ["4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brine: ["4M"],
			bulkup: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			dive: ["6M", "5M", "4T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dracometeor: ["7T", "6T", "5T", "5S4", "4T"],
			dragonbreath: ["7L1", "6L1", "5L1", "5S3", "4L1", "4S2"],
			dragonclaw: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "4M", "4L28", "4S0"],
			dragonpulse: ["6T", "5T", "4M"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["7L33", "6T", "6L33", "6S5", "6S6", "5T", "5L33", "4T", "4L33", "4S1"],
			earthquake: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			healblock: ["4L50", "4S1"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["7L50", "6L50", "6S5", "6S6", "5L50", "5S4", "4L42"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			icebeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["6T", "5T", "4T"],
			powergem: ["7L19", "6L19", "5L19", "4L19"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			scaryface: ["7L1", "6L1", "5L1", "5S3", "4L1", "4S2"],
			secretpower: ["6M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			slash: ["7L15", "6L15", "5L15", "4L15", "4S1"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spacialrend: ["7L46", "6L46", "6S5", "6S6", "5L46", "5S4", "4L40", "4S0", "4S1"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trickroom: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			waterpulse: ["7L6", "6T", "6L6", "5L6", "4M", "4L6", "4S0"],
			whirlpool: ["4M"],
		},
	},
	heatran: {
		inherit: true,
		learnset: {
			ancientpower: ["7L1", "6L1", "5L1", "4T", "4L1", "4S2"],
			attract: ["7M", "6M", "5M", "4M"],
			bugbite: ["6T", "5T", "4T"],
			bulldoze: ["7M", "6M", "5M"],
			captivate: ["4M"],
			confide: ["7M", "6M"],
			crunch: ["7L33", "6L33", "6S4", "5L33", "4L33", "4S1"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			dig: ["6M", "5M", "4M"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dragonpulse: ["6T", "5T", "4M"],
			earthpower: ["7L73", "7L1", "6T", "6L1", "5T", "5L73", "4T", "4L73", "4S2"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			eruption: ["4S2"],
			explosion: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			firefang: ["7L17", "6L17", "5L17", "4L17"],
			firespin: ["7L57", "7L1", "6L1", "5L57", "5S3", "4L57", "4S0"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["7L81", "7L1", "6T", "6L1", "5T", "5L81", "4T", "4L81"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["7L65", "7L1", "6T", "6L1", "5T", "5L65", "5S3", "4T", "4L65", "4S0"],
			lavaplume: ["7L49", "6L49", "6S4", "5L49", "5S3", "4L49", "4S0", "4S1"],
			leer: ["7L9", "6L9", "5L9", "4L9"],
			magmastorm: ["7L96", "7L1", "6L1", "5L96", "4L96", "4S2"],
			metalsound: ["7L25", "6L25", "6S4", "5L25", "4L25", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			overheat: ["7M", "6M", "5M", "4M"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L41", "6L41", "6S4", "5L41", "5S3", "4L41", "4S0", "4S1"],
			secretpower: ["6M", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "7L88", "6M", "6L88", "5M", "5L88", "4M", "4L88"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	regigigas: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			ancientpower: ["4T"],
			avalanche: ["4M"],
			block: ["6T", "5T", "4T"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L1", "5L1", "4L1", "4S0", "4S1"],
			crushgrip: ["7L75", "7L1", "6L1", "5L75", "4L75", "4S2"],
			dizzypunch: ["7L1", "6L1", "5L1", "4L1", "4S1"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			drainpunch: ["6T", "5T", "4M"],
			earthpower: ["6T", "5T", "4T"],
			earthquake: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			firepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			foresight: ["7L1", "6L1", "6S4", "5L1", "4L1", "4S1"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "7L100", "6M", "6L100", "5M", "5L100", "4M", "4L100"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			heavyslam: ["7L90", "7L1", "6L1", "5L90"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icepunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			icywind: ["6T", "5T", "4T", "4S2"],
			ironhead: ["6T", "5T", "4T", "4S2"],
			knockoff: ["7L1", "6T", "6L1", "5T", "5L1", "4L1", "4S1"],
			megapunch: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "7L65", "6M", "6L65", "5M", "5L65", "5S3"],
			poweruppunch: ["6M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			revenge: ["7L25", "6L25", "6S4", "5L25", "5S3", "4L25"],
			rockclimb: ["4M"],
			rockpolish: ["7M", "6M", "5M", "4M"],
			rockslide: ["7M", "6M", "5M", "4M", "4S2"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			stomp: ["4L1", "4S0"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			superpower: ["6T", "5T", "4T", "4L25", "4S0"],
			swagger: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderpunch: ["7L1", "6T", "6L1", "5T", "5L1", "4T", "4L1"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			wideguard: ["7L40", "6L40", "6S4", "5L40", "5S3"],
			zenheadbutt: ["7L50", "6T", "6L50", "6S4", "5T", "5L50", "5S3", "4T", "4L50", "4S0"],
		},
	},
	giratina: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			aircutter: ["4T"],
			ancientpower: ["7L10", "6L10", "5L10", "4T", "4L10", "4S1"],
			aquatail: ["6T", "5T", "4T"],
			aurasphere: ["7L37", "6L37", "6S5", "6S6", "5L37", "5S4", "4L37"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defog: ["4M"],
			destinybond: ["7L24", "6L24", "5L24", "4L24"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dracometeor: ["7T", "6T", "6S6", "5T", "4T"],
			dragonbreath: ["7L1", "6L1", "5L1", "5S3", "4L1", "4S2"],
			dragonclaw: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "5S4", "4M", "4L28", "4S1"],
			dragonpulse: ["6T", "5T", "5S4", "4M"],
			dragontail: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			earthpower: ["7L33", "6T", "6L33", "5T", "5L33", "4T", "4L33", "4S0"],
			earthquake: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			headbutt: ["4T"],
			healblock: ["4L50", "4S0"],
			hex: ["7L50", "6L50", "6S5", "5L50"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypervoice: ["6T", "5T"],
			icywind: ["6T", "5T", "4T"],
			ironhead: ["6T", "6S6", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			magiccoat: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["7L6", "6L6", "5L6", "4T", "4L6", "4S1"],
			outrage: ["6T", "5T", "4T"],
			painsplit: ["6T", "5T", "4T"],
			payback: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			scaryface: ["7L1", "6L1", "5L1", "5S3", "4L1", "4S2"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowclaw: ["7M", "7L42", "6M", "6L42", "6S5", "5M", "5L42", "4M", "4L42"],
			shadowforce: ["7L46", "6L46", "6S5", "6S6", "5L46", "5S4", "4L40", "4S0", "4S1"],
			shadowsneak: ["7L19", "6L19", "5L19", "4L19"],
			shockwave: ["6T", "4M"],
			silverwind: ["4M"],
			slash: ["7L15", "6L15", "5L15", "4L15", "4S0"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spite: ["6T", "5T", "4T"],
			steelwing: ["7M", "6M", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tailwind: ["6T", "5T", "4T"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
		},
	},
	cresselia: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M", "4M"],
			aurorabeam: ["7L29", "6L29", "6S3", "5L29", "4L29", "4S0"],
			calmmind: ["7M", "6M", "5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1", "4L1"],
			doubleteam: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "4M", "4L1"],
			dreameater: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "5S2", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			futuresight: ["7L38", "6L38", "6S3", "5L38", "5S1", "4L38", "4S0"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "5S2", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "5S2", "4M"],
			icywind: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			lunardance: ["7L84", "7L1", "6L1", "5L84", "4L84"],
			magiccoat: ["6T", "5T", "4T"],
			magicroom: ["6T", "5T"],
			mist: ["7L20", "6L20", "6S3", "5L20", "4L20", "4S0"],
			moonblast: ["7L99", "6L99"],
			moonlight: ["7L57", "7L1", "6L1", "5L57", "5S1", "4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "7L93", "6M", "6L93", "5M", "5L93", "4M", "4L93"],
			psychocut: ["7L66", "7L1", "6L1", "5L66", "4L66"],
			psychoshift: ["7L75", "7L1", "6L1", "5L75", "4L75"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M", "5S2"],
			raindance: ["7M", "6M", "5M", "4M"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L11", "6M", "6L11", "5M", "5L11", "4M", "4L11"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			slash: ["7L47", "6L47", "6S3", "5L47", "5S1", "4L47", "4S0"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			telekinesis: ["5M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "5S1", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	phione: {
		inherit: true,
		learnset: {
			acidarmor: ["7L31", "6L31", "5L31", "4L31"],
			ancientpower: ["4T"],
			aquaring: ["7L54", "6L54", "5L54", "4L54"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["4M"],
			bubble: ["7L1", "6L1", "5L1", "4L1"],
			bubblebeam: ["7L24", "6L24", "5L24", "4L24"],
			charm: ["7L9", "6L9", "5L9", "4L9"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			dive: ["7L61", "6M", "6L61", "5M", "5L61", "4T", "4L61"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M", "4S0"],
			hail: ["7M", "6M", "5M", "4M"],
			healbell: ["6T", "5T", "4T"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "7L69", "6M", "6L69", "5M", "5L69", "4M", "4L69", "4S0"],
			rest: ["7M", "6M", "5M", "4M", "4S0"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M"],
			supersonic: ["7L16", "6L16", "5L16", "4L16"],
			surf: ["7M", "6M", "5M", "4M", "4S0"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterfall: ["7M", "6M", "5M", "4M"],
			waterpulse: ["7L46", "6T", "6L46", "5L46", "4M", "4L46"],
			watersport: ["7L1", "6L1", "5L1", "4L1"],
			whirlpool: ["7L39", "6L39", "5L39", "4M", "4L39"],
		},
	},
	manaphy: {
		inherit: true,
		learnset: {
			acidarmor: ["7L31", "6L31", "5L31", "4L31", "4S2"],
			ancientpower: ["4T"],
			aquaring: ["7L54", "6L54", "5L54", "4L54", "4S3"],
			blizzard: ["7M", "6M", "5M", "4M"],
			bounce: ["6T", "5T", "4T"],
			brine: ["4M"],
			bubble: ["7L1", "6L1", "6S4", "6S5", "5L1", "4L1", "4S0", "4S1"],
			bubblebeam: ["7L24", "6L24", "5L24", "4L24"],
			calmmind: ["7M", "6M", "5M", "4M"],
			charm: ["7L9", "6L9", "5L9", "4L9"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			dive: ["7L61", "6M", "6L61", "5M", "5L61", "4T", "4L61"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			hail: ["7M", "6M", "5M", "4M"],
			healbell: ["6T", "5T", "4T"],
			heartswap: ["7L76", "6L76", "6S4", "5L76", "4L76", "4S2", "4S3"],
			helpinghand: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			raindance: ["7M", "7L69", "6M", "6L69", "5M", "5L69", "4M", "4L69"],
			reflect: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			skillswap: ["6T", "5T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			substitute: ["7M", "6M", "5M", "4M"],
			supersonic: ["7L16", "6L16", "5L16", "4L16"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			tailglow: ["7L1", "6L1", "6S4", "6S5", "5L1", "4L1", "4S0", "4S1"],
			toxic: ["7M", "6M", "5M", "4M"],
			uproar: ["6T", "5T", "4T"],
			uturn: ["7M", "6M", "5M", "4M"],
			waterfall: ["7M", "6M", "5M", "4M"],
			waterpulse: ["7L46", "6T", "6L46", "5L46", "4M", "4L46", "4S2", "4S3"],
			watersport: ["7L1", "6L1", "6S4", "6S5", "5L1", "4L1", "4S0", "4S1", "4S3"],
			whirlpool: ["7L39", "6L39", "5L39", "4M", "4L39", "4S2"],
		},
	},
	darkrai: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["7M", "7L93", "6M", "6L93", "6S5", "5T", "5L93", "4M", "4L93", "4S2"],
			darkvoid: ["7L66", "6L66", "6S5", "6S6", "5L66", "5S4", "4L66", "4S2"],
			disable: ["7L1", "6L1", "5L1", "4L1"],
			doubleteam: ["7M", "7L47", "6M", "6L47", "5M", "5L47", "4M", "4L47", "4S2", "4S3"],
			drainpunch: ["6T", "5T", "4M"],
			dreameater: ["7M", "7L84", "6M", "6L84", "6S5", "5M", "5L84", "4M", "4L84"],
			embargo: ["7M", "6M", "5M", "4M", "4L75"],
			endure: ["4M"],
			facade: ["7M", "6M", "5M", "4M"],
			feintattack: ["7L29", "6L29", "6S6", "5L29", "5S4", "4L29", "4S3"],
			flash: ["6M", "5M", "4M"],
			fling: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			focuspunch: ["6T", "4M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			haze: ["7L57", "6L57", "5L57", "4L57"],
			headbutt: ["4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			hypnosis: ["7L20", "6L20", "5L20", "4L20", "4S0", "4S1", "4S3"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			knockoff: ["6T", "5T", "4T"],
			lastresort: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			nastyplot: ["7L75", "6L75", "5L75", "4L75"],
			naturalgift: ["4M"],
			nightmare: ["7L38", "6L38", "6S6", "5L38", "5S4", "4L38", "4S0", "4S1", "4S3"],
			nightshade: ["4L1"],
			ominouswind: ["7L1", "6L1", "6S6", "5L1", "5S4", "4T", "4L1"],
			payback: ["7M", "6M", "5M", "4M"],
			phantomforce: ["6S5"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			pursuit: ["4L29", "4S0"],
			quickattack: ["7L11", "6L11", "5L11", "4L11", "4S0"],
			raindance: ["7M", "6M", "5M", "4M"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roaroftime: ["4S1"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M", "4M"],
			shadowball: ["7M", "6M", "5M", "4M", "4S2"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shockwave: ["6T", "4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			spacialrend: ["4S1"],
			spite: ["6T", "5T", "4T"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			taunt: ["7M", "6M", "5M", "4M"],
			thief: ["7M", "6M", "5M", "4M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			torment: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			willowisp: ["7M", "6M", "5M", "4M"],
			wonderroom: ["6T", "5T"],
			xscissor: ["7M", "6M", "5M", "4M"],
		},
	},
	shaymin: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			airslash: ["6L64", "6S3", "5L64", "4L64"],
			aromatherapy: ["7L64", "6L64", "6S4", "5L64", "4L64", "4S0"],
			bulletseed: ["4M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["4L1"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			earthpower: ["6T", "5T", "4T"],
			endeavor: ["6T", "5T", "4T"],
			endure: ["4M"],
			energyball: ["7M", "7L73", "6M", "6L73", "6S4", "5M", "5L73", "4M", "4L73", "4S0"],
			facade: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			gigadrain: ["6T", "5T", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			grasswhistle: ["4L82"],
			growth: ["7L1", "6L1", "6S3", "5L1", "4L1", "4S1"],
			headbutt: ["4T"],
			healingwish: ["7L91", "6L91", "5L91", "4L91"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			hyperbeam: ["7M", "6M", "5M", "4M"],
			lastresort: ["6T", "5T", "4T"],
			leafstorm: ["6L91", "5L91", "4L91"],
			leechseed: ["7L19", "6L19", "5L19", "5S2", "4L19", "4S1"],
			luckychant: ["4L91"],
			magicalleaf: ["7L10", "6L10", "6S3", "5L10", "4L10", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["7L46", "6L46", "5L46", "4M", "4L46"],
			naturepower: ["7M", "6M"],
			ominouswind: ["4T"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			quickattack: ["6L28", "5L28", "4L28"],
			rest: ["7M", "6M", "5M", "4M"],
			return: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seedbomb: ["6T", "5T", "4T"],
			seedflare: ["7L100", "6L100", "6S3", "6S4", "5L100", "5S2", "4L100", "4S0"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			substitute: ["7M", "6M", "6S4", "5M", "4M", "4S0"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			sweetkiss: ["7L82", "6L82", "5L82", "4L82"],
			sweetscent: ["7L37", "6L37", "5L37", "5S2", "4L37"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			synthesis: ["7L28", "6T", "6L28", "5T", "5L28", "5S2", "4T", "4L28", "4S1"],
			tailwind: ["6T", "5T", "4T"],
			toxic: ["7M", "6M", "5M", "4M"],
			worryseed: ["7L55", "6T", "6L55", "5T", "5L55", "4T", "4L55"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	arceus: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M", "4M"],
			ancientpower: ["4T"],
			aquatail: ["6T", "5T", "4T"],
			avalanche: ["4M"],
			blastburn: ["6S2"],
			blizzard: ["7M", "6M", "5M", "4M"],
			brickbreak: ["7M", "6M", "5M", "4M"],
			brine: ["4M"],
			bulldoze: ["7M", "6M", "5M"],
			bulletseed: ["4M"],
			calmmind: ["7M", "6M", "5M", "4M"],
			chargebeam: ["7M", "6M", "5M", "4M"],
			confide: ["7M", "6M"],
			cosmicpower: ["7L1", "6L1", "5L1", "4L1"],
			cut: ["6M", "5M", "4M"],
			darkpulse: ["7M", "6M", "5T", "4M"],
			defog: ["4M"],
			dive: ["6M", "4T"],
			doubleteam: ["7M", "6M", "5M", "4M"],
			dracometeor: ["7T", "6T", "5T", "4T"],
			dragonclaw: ["7M", "6M", "5M", "4M"],
			dragonpulse: ["6T", "5T", "4M"],
			dreameater: ["7M", "6M", "5M", "4M"],
			earthpower: ["7L20", "6T", "6L20", "6S2", "5T", "5L20", "4T", "4L20"],
			earthquake: ["7M", "6M", "5M", "4M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["4M"],
			energyball: ["7M", "6M", "5M", "4M"],
			extremespeed: ["7L40", "6L40", "5L40", "4L40"],
			facade: ["7M", "6M", "5M", "4M"],
			fireblast: ["7M", "6M", "5M", "4M"],
			flamethrower: ["7M", "6M", "5M", "4M"],
			flash: ["6M", "5M", "4M"],
			flashcannon: ["7M", "6M", "5M", "4M"],
			fly: ["7M", "6M", "5M", "4M"],
			focusblast: ["7M", "6M", "5M", "4M"],
			frustration: ["7M", "6M", "5M", "4M"],
			furycutter: ["4T"],
			futuresight: ["7L60", "6L60", "5L60", "4L60"],
			gigadrain: ["6T", "5T", "4M"],
			gigaimpact: ["7M", "6M", "5M", "4M"],
			grassknot: ["7M", "6M", "5M", "4M"],
			gravity: ["7L10", "6T", "6L10", "5T", "5L10", "4T", "4L10"],
			hail: ["7M", "6M", "5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["6T", "5T", "4T"],
			hiddenpower: ["7M", "6M", "5M", "4M"],
			honeclaws: ["6M", "5M"],
			hydrocannon: ["6S2"],
			hyperbeam: ["7M", "7L80", "6M", "6L80", "6S3", "5M", "5L80", "5S1", "4M", "4L80"],
			hypervoice: ["7L30", "6T", "6L30", "5T", "5L30", "4L30"],
			icebeam: ["7M", "6M", "5M", "4M"],
			icywind: ["6T", "5T", "4T"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T", "4T"],
			ironhead: ["6T", "5T", "4T"],
			irontail: ["6T", "5T", "4M"],
			judgment: ["7L100", "6L100", "6S2", "6S3", "5L100", "5S1", "4L100", "4S0"],
			lastresort: ["6T", "5T", "4T"],
			lightscreen: ["7M", "6M", "5M", "4M"],
			magiccoat: ["6T", "5T", "4T"],
			mudslap: ["4T"],
			naturalgift: ["7L1", "6L1", "5L1", "4M", "4L1"],
			ominouswind: ["4T"],
			outrage: ["6T", "5T", "4T"],
			overheat: ["7M", "6M", "5M", "4M"],
			payback: ["7M", "6M", "5M", "4M"],
			perishsong: ["7L90", "6L90", "6S3", "5L90", "5S1", "4L90"],
			poisonjab: ["7M", "6M", "5M", "4M"],
			protect: ["7M", "6M", "5M", "4M"],
			psychic: ["7M", "6M", "5M", "4M"],
			psychup: ["7M", "6M", "5M", "4M"],
			psyshock: ["7M", "6M", "5M"],
			punishment: ["7L1", "6L1", "5L1", "4L1"],
			quash: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M", "4M"],
			recover: ["7L70", "6L70", "6S3", "5L70", "5S1", "4L70"],
			recycle: ["6T", "5T", "4M"],
			reflect: ["7M", "6M", "5M", "4M"],
			refresh: ["7L50", "6L50", "5L50", "4L50"],
			rest: ["7M", "6M", "5M", "4M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M", "4M"],
			roar: ["7M", "6M", "5M", "4M"],
			roaroftime: ["4S0"],
			rockclimb: ["4M"],
			rockslide: ["7M", "6M", "5M", "4M"],
			rocksmash: ["6M", "5M", "4M"],
			rocktomb: ["7M", "6M", "5M", "4M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M", "4M"],
			sandstorm: ["7M", "6M", "5M", "4M"],
			secretpower: ["6M", "4M"],
			seismictoss: ["7L1", "6L1", "5L1", "4L1"],
			shadowball: ["7M", "6M", "5M", "4M"],
			shadowclaw: ["7M", "6M", "5M", "4M"],
			shadowforce: ["4S0"],
			shockwave: ["6T", "4M"],
			signalbeam: ["6T", "5T", "4T"],
			silverwind: ["4M"],
			sleeptalk: ["7M", "6M", "5T", "4M"],
			sludgebomb: ["7M", "6M", "5M", "4M"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T", "4T"],
			solarbeam: ["7M", "6M", "5M", "4M"],
			spacialrend: ["4S0"],
			stealthrock: ["6T", "5T", "4M"],
			stoneedge: ["7M", "6M", "5M", "4M"],
			strength: ["6M", "5M", "4M"],
			substitute: ["7M", "6M", "5M", "4M"],
			sunnyday: ["7M", "6M", "5M", "4M"],
			surf: ["7M", "6M", "5M", "4M"],
			swagger: ["7M", "6M", "5M", "4M"],
			swift: ["4T"],
			swordsdance: ["7M", "6M", "5M", "4M"],
			tailwind: ["6T", "5T", "4T"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M", "4M"],
			thunderbolt: ["7M", "6M", "5M", "4M"],
			thunderwave: ["7M", "6M", "5M", "4M"],
			toxic: ["7M", "6M", "5M", "4M"],
			trick: ["6T", "5T", "4T"],
			trickroom: ["7M", "6M", "5M", "4M"],
			twister: ["4T"],
			waterfall: ["7M", "6M", "5M", "4M"],
			waterpulse: ["6T", "4M"],
			whirlpool: ["4M"],
			willowisp: ["7M", "6M", "5M", "4M"],
			workup: ["7M", "5M"],
			xscissor: ["7M", "6M", "5M", "4M"],
			zenheadbutt: ["6T", "5T", "4T"],
		},
	},
	victini: {
		inherit: true,
		learnset: {
			blueflare: ["5S2"],
			boltstrike: ["5S2"],
			bounce: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M"],
			celebrate: ["7S6"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "6S3", "6S4", "5L1", "5S0"],
			dazzlinggleam: ["7M", "6M"],
			doubleedge: ["7L65", "6L65", "5L65"],
			doubleteam: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			endure: ["7L9", "6L9", "6S4", "5L9", "5S0"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			finalgambit: ["7L81", "6L81", "5L81"],
			fireblast: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			flameburst: ["7L41", "6L41", "5L41"],
			flamecharge: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			flamethrower: ["7M", "6M", "5M"],
			flareblitz: ["7L73", "6L73", "5L73"],
			flash: ["6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focusenergy: ["7L1", "6L1", "5L1"],
			frustration: ["7M", "6M", "5M"],
			fusionbolt: ["5S1"],
			fusionflare: ["5S1"],
			gigaimpact: ["7M", "6M", "5M"],
			glaciate: ["5S2"],
			grassknot: ["7M", "6M", "5M"],
			headbutt: ["7L17", "6L17", "5L17"],
			heatwave: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			incinerate: ["7L1", "6M", "6L1", "6S4", "5M", "5L1", "5S0"],
			inferno: ["7L57", "6L57", "5L57"],
			lastresort: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			overheat: ["7M", "7L97", "6M", "6L97", "5M", "5L97"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "6M", "5M"],
			quickattack: ["7L1", "6L1", "6S3", "6S4", "6S5", "5L1", "5S0"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			reversal: ["7L33", "7S6", "6L33", "5L33"],
			rocksmash: ["6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			searingshot: ["7L1", "6L1", "6S3", "5L1", "5S1"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			storedpower: ["7L89", "7S6", "6L89", "5L89"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "6S5", "5M"],
			taunt: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
			vcreate: ["7S6", "6S3", "6S5", "5S1", "5S2"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["7L49", "6T", "6L49", "5T", "5L49"],
		},
	},
	snivy: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			aromatherapy: ["5S0"],
			attract: ["7M", "6M", "5M"],
			bind: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M"],
			captivate: ["7E", "6E", "5E"],
			coil: ["7L31", "6L31", "5L31"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M", "5S0"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["7L40", "6T", "6L40", "5T", "5L40"],
			gigadrain: ["7L34", "6T", "6L34", "5T", "5L34"],
			glare: ["7E", "6E", "5E"],
			grassknot: ["7M", "6M", "5M"],
			grasspledge: ["7T", "6T", "5T"],
			grassyterrain: ["7E", "6E"],
			growth: ["7L13", "6L13", "5L13", "5S0"],
			hiddenpower: ["7M", "6M", "5M"],
			irontail: ["7E", "6T", "6E", "5T", "5E"],
			knockoff: ["6T", "5T"],
			leafblade: ["7L28", "6L28", "5L28"],
			leafstorm: ["7L43", "6L43", "5L43"],
			leaftornado: ["7L16", "6L16", "5L16"],
			leechseed: ["7L19", "6L19", "5L19"],
			leer: ["7L4", "6L4", "5L4"],
			lightscreen: ["7M", "6M", "5M"],
			magicalleaf: ["7E", "6E", "5E"],
			meanlook: ["7E", "6E", "5E"],
			megadrain: ["7L22", "6L22", "5L22"],
			mirrorcoat: ["7E", "6E", "5E"],
			naturalgift: ["7E", "6E", "5E"],
			naturepower: ["7M", "6M"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7E", "6E", "5E"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			slam: ["7L25", "6L25", "5L25"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			sweetscent: ["7E", "6E", "5E"],
			swordsdance: ["7M", "6M", "5M"],
			synthesis: ["6T", "5T", "5S0"],
			tackle: ["7L1", "6L1", "5L1"],
			taunt: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			twister: ["7E", "6E", "5E"],
			vinewhip: ["7L7", "6L7", "5L7"],
			workup: ["7M"],
			worryseed: ["6T", "5T"],
			wrap: ["7L10", "6L10", "5L10"],
			wringout: ["7L37", "6L37", "5L37"],
		},
	},
	servine: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			bind: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M"],
			coil: ["7L36", "6L36", "5L36"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["7L48", "6T", "6L48", "5T", "5L48"],
			gigadrain: ["7L40", "6T", "6L40", "5T", "5L40"],
			grassknot: ["7M", "6M", "5M"],
			grasspledge: ["7T", "6T", "5T"],
			growth: ["7L13", "6L13", "5L13"],
			hiddenpower: ["7M", "6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leafblade: ["7L32", "6L32", "5L32"],
			leafstorm: ["7L52", "6L52", "5L52"],
			leaftornado: ["7L16", "6L16", "5L16"],
			leechseed: ["7L20", "6L20", "5L20"],
			leer: ["7L4", "7L1", "6L1", "5L1"],
			lightscreen: ["7M", "6M", "5M"],
			megadrain: ["7L24", "6L24", "5L24"],
			naturepower: ["7M", "6M"],
			protect: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			slam: ["7L28", "6L28", "5L28"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			synthesis: ["6T", "5T"],
			tackle: ["7L1", "6L1", "5L1"],
			taunt: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			vinewhip: ["7L7", "7L1", "6L1", "5L1"],
			workup: ["7M"],
			worryseed: ["6T", "5T"],
			wrap: ["7L10", "7L1", "6L1", "5L1"],
			wringout: ["7L44", "6L44", "5L44"],
		},
	},
	serperior: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			bind: ["6T", "5T"],
			brutalswing: ["7M"],
			calmmind: ["7M", "6M", "5M"],
			coil: ["7L38", "6L38", "5L38"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dragonpulse: ["6T", "5T"],
			dragontail: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frenzyplant: ["7T", "6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["7L56", "6T", "6L56", "5T", "5L56"],
			gigadrain: ["7L44", "6T", "6L44", "6S1", "5T", "5L44", "5S0"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			grasspledge: ["7T", "6T", "5T"],
			growth: ["7L13", "6L13", "5L13"],
			hiddenpower: ["7M", "6M", "5M"],
			holdback: ["6S1"],
			hyperbeam: ["7M", "6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leafblade: ["7L32", "6L32", "5L32"],
			leafstorm: ["7L62", "6L62", "6S1", "5L62", "5S0"],
			leaftornado: ["7L16", "6L16", "5L16"],
			leechseed: ["7L20", "6L20", "5L20", "5S0"],
			leer: ["7L4", "7L1", "6L1", "5L1"],
			lightscreen: ["7M", "6M", "5M"],
			megadrain: ["7L24", "6L24", "5L24"],
			naturepower: ["7M", "6M"],
			outrage: ["6T", "5T"],
			protect: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			slam: ["7L28", "6L28", "5L28"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "5S0"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			synthesis: ["6T", "5T"],
			tackle: ["7L1", "6L1", "5L1"],
			taunt: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			vinewhip: ["7L7", "7L1", "6L1", "5L1"],
			workup: ["7M"],
			worryseed: ["6T", "5T"],
			wrap: ["7L10", "7L1", "6L1", "5L1"],
			wringout: ["7L50", "6L50", "6S1", "5L50"],
		},
	},
	tepig: {
		inherit: true,
		learnset: {
			assurance: ["7L31", "6L31", "5L31"],
			attract: ["7M", "6M", "5M"],
			bodyslam: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E", "5T", "5E"],
			curse: ["7E", "6E", "5E"],
			defensecurl: ["7L13", "6L13", "5L13"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L7", "6L7", "5L7"],
			endeavor: ["7E", "6T", "6E", "5T", "5E"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "6M", "5M"],
			firepledge: ["7T", "6T", "5T"],
			flamecharge: ["7M", "7L15", "6M", "6L15", "5M", "5L15"],
			flamethrower: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			flareblitz: ["7L43", "6L43", "5L43"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gyroball: ["7M", "6M", "5M"],
			headsmash: ["7L37", "6L37", "5L37"],
			heatcrash: ["7L27", "6L27", "5L27"],
			heatwave: ["6T", "5T"],
			heavyslam: ["7E", "6E", "5E"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			magnitude: ["7E", "6E", "5E"],
			odorsleuth: ["7L9", "6L9", "5L9"],
			overheat: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rollout: ["7L21", "6L21", "5L21"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			smog: ["7L19", "6L19", "5L19"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["7E", "6E"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["7E", "6T", "6E", "5T", "5E"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			tailwhip: ["7L3", "6L3", "5L3"],
			takedown: ["7L25", "6L25", "5L25"],
			taunt: ["7M", "6M", "5M"],
			thrash: ["7E", "6E", "5E"],
			toxic: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M"],
			workup: ["7M"],
			yawn: ["7E", "6E", "5E"],
			zenheadbutt: ["6T"],
		},
	},
	pignite: {
		inherit: true,
		learnset: {
			armthrust: ["7L1", "6L17", "5L17"],
			assurance: ["7L36", "6L36", "5L36"],
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "6M", "5M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			defensecurl: ["7L13", "6L13", "5L13"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L7", "7L1", "6L1", "5L1"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "6M", "5M"],
			firepledge: ["7T", "6T", "5T"],
			firepunch: ["6T", "5T"],
			flamecharge: ["7M", "7L15", "6M", "6L15", "5M", "5L15"],
			flamethrower: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			flareblitz: ["7L52", "6L52", "5L52"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gyroball: ["7M", "6M", "5M"],
			headsmash: ["7L44", "6L44", "5L44"],
			heatcrash: ["7L31", "6L31", "5L31"],
			heatwave: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			odorsleuth: ["7L9", "7L1", "6L1", "5L1"],
			overheat: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "7L47", "6M", "6L47", "5M", "5L47"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rollout: ["7L23", "6L23", "5L23"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smog: ["7L20", "6L20", "5L20"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			tailwhip: ["7L3", "7L1", "6L1", "5L1"],
			takedown: ["7L28", "6L28", "5L28"],
			taunt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			toxic: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T"],
		},
	},
	emboar: {
		inherit: true,
		learnset: {
			armthrust: ["7L1", "6L17", "5L17"],
			assurance: ["7L38", "6L38", "5L38"],
			attract: ["7M", "6M", "5M"],
			blastburn: ["7T", "6T", "5T"],
			block: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M"],
			bulkup: ["7M", "6M", "5M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			defensecurl: ["7L13", "6L13", "5L13"],
			doubleteam: ["7M", "6M", "5M"],
			earthquake: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			ember: ["7L7", "7L1", "6L1", "5L1"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "6M", "5M"],
			firepledge: ["7T", "6T", "5T"],
			firepunch: ["6T", "5T"],
			flamecharge: ["7M", "7L15", "6M", "6L15", "5M", "5L15"],
			flamethrower: ["7M", "7L43", "6M", "6L43", "5M", "5L43"],
			flareblitz: ["7L62", "6L62", "6S1", "5L62", "5S0"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gyroball: ["7M", "6M", "5M"],
			hammerarm: ["7L1", "6L1", "5L1", "5S0"],
			headsmash: ["7L50", "6L50", "6S1", "5L50", "5S0"],
			heatcrash: ["7L31", "6L31", "5L31"],
			heatwave: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			holdback: ["6S1"],
			hyperbeam: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T"],
			irontail: ["6T", "5T"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			odorsleuth: ["7L9", "7L1", "6L1", "5L1"],
			overheat: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "7L55", "6M", "6L55", "5M", "5L55"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rollout: ["7L23", "6L23", "5L23"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "6M", "5M"],
			smog: ["7L20", "6L20", "5L20"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			tailwhip: ["7L3", "7L1", "6L1", "5L1"],
			takedown: ["7L28", "6L28", "6S1", "5L28"],
			taunt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			toxic: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M", "5S0"],
			willowisp: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T"],
		},
	},
	oshawott: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			airslash: ["7E", "6E", "5E"],
			aquajet: ["7L29", "6L29", "5L29"],
			aquatail: ["7L35", "6T", "6L35", "5T", "5L35"],
			assurance: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			blizzard: ["7M", "6M", "5M"],
			brine: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			copycat: ["7E", "6E", "5E"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			detect: ["7E", "6E", "5E"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			encore: ["7L31", "6L31", "5L31"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusenergy: ["7L13", "6L13", "5L13"],
			frustration: ["7M", "6M", "5M"],
			furycutter: ["7L19", "6L19", "5L19"],
			grassknot: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L43", "6L43", "5L43"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			irontail: ["6T", "5T"],
			nightslash: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			razorshell: ["7L17", "6L17", "5L17"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L37", "6M", "6L37", "5M", "5L37"],
			return: ["7M", "6M", "5M"],
			revenge: ["7L25", "6L25", "5L25"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			tackle: ["7L1", "6L1", "5L1"],
			tailwhip: ["7L5", "6L5", "5L5"],
			taunt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trumpcard: ["7E", "6E", "5E"],
			waterfall: ["7M", "6M", "5M"],
			watergun: ["7L7", "6L7", "5L7"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["7L23", "6T", "6L23", "5L23"],
			watersport: ["7L11", "6L11", "5L11"],
			workup: ["7M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	dewott: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquajet: ["7L34", "6L33", "5L33"],
			aquatail: ["7L42", "6T", "6L41", "5T", "5L41"],
			attract: ["7M", "6M", "5M"],
			blizzard: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			encore: ["7L37", "6L36", "5L36"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusenergy: ["7L13", "6L13", "5L13"],
			frustration: ["7M", "6M", "5M"],
			furycutter: ["7L21", "6L20", "5L20"],
			grassknot: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L53", "6L52", "5L52"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			irontail: ["6T", "5T"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			razorshell: ["7L18", "6L17", "5L17"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L45", "6M", "6L44", "5M", "5L44"],
			return: ["7M", "6M", "5M"],
			revenge: ["7L29", "6L28", "5L28"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L50", "6M", "6L49", "5M", "5L49"],
			tackle: ["7L1", "6L1", "5L1"],
			tailwhip: ["7L5", "7L1", "6L1", "5L1"],
			taunt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M"],
			watergun: ["7L7", "7L1", "6L1", "5L1"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["7L26", "6T", "6L25", "5L25"],
			watersport: ["7L11", "7L1", "6L1", "5L1"],
			workup: ["7M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	samurott: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquajet: ["7L34", "6L33", "5L33"],
			aquatail: ["7L46", "6T", "6L45", "5T", "5L45"],
			attract: ["7M", "6M", "5M"],
			blizzard: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			confide: ["7M", "6M", "6S1"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dragontail: ["7M", "6M", "5M"],
			encore: ["7L39", "6L38", "5L38"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusenergy: ["7L13", "6L13", "5L13"],
			frustration: ["7M", "6M", "5M"],
			furycutter: ["7L21", "6L20", "5L20"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			holdback: ["6S1"],
			hydrocannon: ["7T", "6T", "5T"],
			hydropump: ["7L63", "6L62", "6S1", "5L62", "5S0"],
			hyperbeam: ["7M", "6M", "5M"],
			icebeam: ["7M", "6M", "5M", "5S0"],
			icywind: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			megahorn: ["7L1", "6L1", "5L1", "5S0"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			razorshell: ["7L18", "6L17", "6S1", "5L17"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L51", "6M", "6L50", "5M", "5L50"],
			return: ["7M", "6M", "5M"],
			revenge: ["7L29", "6L28", "5L28"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			slash: ["7L1", "6L36", "5L36"],
			sleeptalk: ["7M", "6M", "5T"],
			smartstrike: ["7M"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T", "5S0"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L58", "6M", "6L57", "5M", "5L57"],
			tackle: ["7L1", "6L1", "5L1"],
			tailwhip: ["7L5", "7L1", "6L1", "5L1"],
			taunt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M"],
			watergun: ["7L7", "7L1", "6L1", "5L1"],
			waterpledge: ["7T", "6T", "5T"],
			waterpulse: ["7L25", "6T", "6L25", "5L25"],
			watersport: ["7L11", "7L1", "6L1", "5L1"],
			workup: ["7M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	patrat: {
		inherit: true,
		learnset: {
			afteryou: ["7L23", "6T", "6L23", "5T", "5L23"],
			aquatail: ["6T", "5T"],
			assurance: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			batonpass: ["7L38", "6L33", "5L33"],
			bide: ["7L8", "6L8", "5L8"],
			bite: ["7L6", "6L6", "5L6"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			crunch: ["7L16", "6L16", "5L16"],
			cut: ["6M", "5M"],
			detect: ["7L11", "6L11", "5L11"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			flail: ["7E", "6E", "5E"],
			fling: ["7M", "6M", "5M"],
			focusenergy: ["7L26"],
			foresight: ["7E", "6E", "5E"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gunkshot: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperfang: ["7L31", "6L28", "5L28"],
			hypnosis: ["7L18", "6L18", "5L18"],
			irontail: ["7E", "6T", "6E", "5T", "5E"],
			lastresort: ["6T", "5T"],
			leer: ["7L3", "6L3", "5L3"],
			lowkick: ["6T", "5T"],
			meanlook: ["7L36", "6L31", "5L31"],
			nastyplot: ["7L33"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			revenge: ["7E", "6E", "5E"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L13", "6L13", "5L13"],
			screech: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			slam: ["7L41", "6L36", "5L36"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superfang: ["7L21", "6T", "6L21", "5T", "5L21"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			thunderbolt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			workup: ["7M", "7L28", "6L26", "5M", "5L26"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	watchog: {
		inherit: true,
		learnset: {
			afteryou: ["7L25", "6T", "6L25", "5T", "5L25"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			batonpass: ["7L46", "6L39", "5L39"],
			bide: ["7L8", "6L8", "5L8"],
			bite: ["7L6", "7L1", "6L1", "5L1"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L20", "5L20"],
			covet: ["6T", "5T"],
			crunch: ["7L16", "6L16", "5L16"],
			cut: ["6M", "5M"],
			detect: ["7L11", "6L11", "5L11"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			flamethrower: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focusenergy: ["7L29"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gunkshot: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hyperfang: ["7L36", "6L32", "5L32"],
			hypnosis: ["7L18", "6L18", "5L18"],
			icepunch: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			lastresort: ["6T", "5T"],
			leer: ["7L3", "7L1", "6L1", "5L1"],
			lightscreen: ["7M", "6M", "5M"],
			lowkick: ["7L1", "6T", "6L1", "5T", "5L1"],
			meanlook: ["7L43", "6L36", "5L36"],
			nastyplot: ["7L39"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "7L32", "6M", "6L29", "5M", "5L29"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rototiller: ["7L1", "6L1"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L13", "6L13", "5L13"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			slam: ["7L50", "6L43", "5L43"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superfang: ["7L22", "6T", "6L22", "5T", "5L22"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	lillipup: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			afteryou: ["7E", "6T", "6E"],
			attract: ["7M", "6M", "5M"],
			babydolleyes: ["7L10", "6L10"],
			bite: ["7L8", "6L8", "5L8"],
			charm: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			crunch: ["7L22", "6L22", "5L22"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E"],
			facade: ["7M", "6M", "5M"],
			firefang: ["7E", "6E", "5E"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "7L40", "6M", "6L40", "5M", "5L40"],
			helpinghand: ["7L12", "6T", "6L12", "5T", "5L12"],
			hiddenpower: ["7M", "6M", "5M"],
			howl: ["7E", "6E", "5E"],
			hypervoice: ["6T", "5T"],
			icefang: ["7E", "6E", "5E"],
			lastresort: ["7L36", "6T", "6L36", "5T", "5L36"],
			leer: ["7L1", "6L1", "5L1"],
			lick: ["7E", "6E", "5E"],
			mudslap: ["7E", "6E", "5E"],
			odorsleuth: ["7L5", "6L5", "5L5"],
			playrough: ["7L45", "6L45"],
			protect: ["7M", "6M", "5M"],
			psychicfangs: ["7E"],
			pursuit: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L29", "6M", "6L29", "5M", "5L29"],
			return: ["7M", "6M", "5M"],
			reversal: ["7L33", "6L33", "5L33"],
			roar: ["7M", "7L26", "6M", "6L26", "5M", "5L26"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			takedown: ["7L15", "6L15", "5L15"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderfang: ["7E", "6E", "5E"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "7L19", "6L19", "5M", "5L19"],
			yawn: ["7E", "6E", "5E"],
		},
	},
	herdier: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			afteryou: ["6T"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L8", "7L1", "6L1", "5L1"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			crunch: ["7L24", "6L24", "5L24"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "7L47", "6M", "6L47", "5M", "5L47"],
			helpinghand: ["7L12", "6T", "6L12", "5T", "5L12"],
			hiddenpower: ["7M", "6M", "5M"],
			hypervoice: ["6T", "5T"],
			lastresort: ["7L42", "6T", "6L42", "5T", "5L42"],
			leer: ["7L1", "6L1", "5L1"],
			odorsleuth: ["7L5", "7L1", "6L1", "5L1"],
			payback: ["7M", "6M", "5M"],
			playrough: ["7L52", "6L52"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L33", "6M", "6L33", "5M", "5L33"],
			return: ["7M", "6M", "5M"],
			reversal: ["7L38", "6L38", "5L38"],
			roar: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			takedown: ["7L15", "6L15", "5L15"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "7L20", "6L20", "5M", "5L20"],
		},
	},
	stoutland: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			afteryou: ["6T"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L8", "7L1", "6L1", "5L1"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			crunch: ["7L24", "6L24", "5L24"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			firefang: ["7L1", "6L1", "5L1"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "7L59", "6M", "6L59", "5M", "5L59"],
			helpinghand: ["7L12", "6T", "6L12", "5T", "5L12"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["6T", "5T"],
			icefang: ["7L1", "6L1", "5L1"],
			ironhead: ["6T", "5T"],
			lastresort: ["7L51", "6T", "6L51", "5T", "5L51"],
			leer: ["7L1", "6L1", "5L1"],
			odorsleuth: ["7L5", "7L1", "6L1", "5L1"],
			payback: ["7M", "6M", "5M"],
			playrough: ["7L63", "6L63"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L36", "6M", "6L36", "5M", "5L36"],
			return: ["7M", "6M", "5M"],
			reversal: ["7L42", "6L42", "5L42"],
			roar: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			snarl: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			takedown: ["7L15", "6L15", "5L15"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderfang: ["7L1", "6L1", "5L1"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "7L20", "6L20", "5M", "5L20"],
		},
	},
	purrloin: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			assist: ["7L6", "6L6", "5L6"],
			assurance: ["7L28", "6L28", "5L28"],
			attract: ["7M", "6M", "5M"],
			captivate: ["7L33", "6L33", "5L33"],
			charm: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			copycat: ["7E", "6E"],
			covet: ["7E", "6T", "6E", "5T", "5E"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "6M", "5T"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			encore: ["7E", "6E", "5E"],
			facade: ["7M", "6M", "5M"],
			fakeout: ["7L21", "6L21", "5L21"],
			faketears: ["7E", "6E", "5E"],
			feintattack: ["7E", "6E", "5E"],
			foulplay: ["7E", "6T", "6E", "5T", "5E"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L12", "6L12", "5L12"],
			grassknot: ["7M", "6M", "5M"],
			growl: ["7L3", "6L3", "5L3"],
			gunkshot: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["7L24", "6M", "6L24", "5M", "5L24"],
			hypervoice: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			nastyplot: ["7L42", "6L42", "5L42"],
			nightslash: ["7L37", "6L37", "5L37"],
			payback: ["7M", "6M", "5M"],
			payday: ["7E", "6E", "5E"],
			playrough: ["7L49", "6L49"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			pursuit: ["7L15", "6L15", "5L15"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L10", "6L10", "5L10"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			shadowball: ["7M", "6M", "5M"],
			shadowclaw: ["7M", "6M", "5M"],
			slash: ["7L30", "6L30", "5L30"],
			sleeptalk: ["7M", "6M", "5T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["7L39", "6T", "6L39", "5T", "5L39"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["7L46", "6L46", "5L46"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "7L19", "6M", "6L19", "5M", "5L19"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
			yawn: ["7E", "6E", "5E"],
		},
	},
	liepard: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			assist: ["7L6", "7L1", "6L1", "5L1"],
			assurance: ["7L31", "6L31", "5L31"],
			attract: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "6M", "5T"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			encore: ["5S0"],
			facade: ["7M", "6M", "5M"],
			fakeout: ["7L22", "6L22", "5L22", "5S0"],
			foulplay: ["6T", "5T", "5S0"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L12", "6L12", "5L12"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			growl: ["7L3", "7L1", "6L1", "5L1"],
			gunkshot: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["7L26", "6M", "6L26", "5M", "5L26"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			nastyplot: ["7L50", "6L50", "5L50"],
			nightslash: ["7L43", "6L43", "5L43"],
			payback: ["7M", "6M", "5M"],
			playrough: ["7L58", "6L58"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			pursuit: ["7L15", "6L15", "5L15"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L10", "7L1", "6L1", "5L1"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			shadowball: ["7M", "6M", "5M"],
			shadowclaw: ["7M", "6M", "5M"],
			slash: ["7L34", "6L34", "5L34"],
			sleeptalk: ["7M", "6M", "5T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["7L47", "6T", "6L47", "5T", "5L47"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["7L55", "6L55", "5L55"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M", "5S0"],
			taunt: ["7M", "7L38", "6M", "6L38", "5M", "5L38"],
			thief: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "7L19", "6M", "6L19", "5M", "5L19"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
		},
	},
	pansage: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L31", "6M", "6L31", "5M", "5L31"],
			astonish: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L19", "6L19", "5L19", "5S0"],
			bulletseed: ["7E", "6E", "5E", "5S0"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E", "5T", "5E"],
			crunch: ["7L43", "6L43", "5L43"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M", "5S0", "5S2"],
			disarmingvoice: ["7E", "6E"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L13", "6L13", "5L13"],
			gastroacid: ["6T"],
			gigadrain: ["6T", "5T"],
			grassknot: ["7M", "7L34", "6M", "6L34", "5M", "5L34"],
			grasspledge: ["7T"],
			grasswhistle: ["7E", "6E", "5E"],
			gunkshot: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leafstorm: ["7E", "6E", "5E", "5S1"],
			leechseed: ["7L16", "6L16", "5L16"],
			leer: ["7L4", "6L4", "5L4", "5S1"],
			lick: ["7L7", "6L7", "5L7", "5S1"],
			lowkick: ["7E", "6T", "6E", "5T", "5E"],
			lowsweep: ["7M", "6M", "5M"],
			magicalleaf: ["7E", "6E", "5E"],
			nastyplot: ["7E", "6E", "5E"],
			naturalgift: ["7L40", "6L40", "5L40"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M", "5M"],
			playnice: ["7L1", "6L1"],
			protect: ["7M", "6M", "5M"],
			recycle: ["7L37", "6T", "6L37", "5T", "5L37"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M", "5S2"],
			roleplay: ["7E", "6T", "6E", "5T", "5E"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			seedbomb: ["7L22", "6T", "6L22", "5T", "5L22", "5S2"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M", "5S0", "5S2"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			synthesis: ["6T", "5T"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			tickle: ["7E", "6E", "5E"],
			torment: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			vinewhip: ["7L10", "6L10", "5L10", "5S1"],
			workup: ["7M", "5M"],
			worryseed: ["6T", "5T"],
		},
	},
	simisage: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L1", "6L1", "5L1"],
			gastroacid: ["6T"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			grasspledge: ["7T"],
			gunkshot: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lick: ["7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["7L1", "6T", "6L1", "5T", "5L1"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			synthesis: ["6T", "5T"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			workup: ["7M", "5M"],
			worryseed: ["6T", "5T"],
		},
	},
	pansear: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L31", "6M", "6L31", "5M", "5L31"],
			amnesia: ["7L25", "6L25", "5L25"],
			astonish: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L19", "6L19", "5L19"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E", "5T", "5E"],
			crunch: ["7L43", "6L43", "5L43"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			disarmingvoice: ["7E", "6E"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "7L34", "6M", "6L34", "5M", "5L34"],
			firepledge: ["7T"],
			firepunch: ["7E", "6T", "6E", "5T", "5E"],
			firespin: ["7E", "6E", "5E"],
			flameburst: ["7L22", "6L22", "5L22"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M"],
			fling: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L13", "6L13", "5L13"],
			gastroacid: ["6T"],
			grassknot: ["7M", "6M", "5M"],
			gunkshot: ["6T", "5T"],
			heatwave: ["7E", "6T", "6E", "5T", "5E", "5S0"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["7L10", "6M", "6L10", "5M", "5L10", "5S0"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L4", "6L4", "5L4", "5S0"],
			lick: ["7L7", "6L7", "5L7", "5S0"],
			lowkick: ["7E", "6T", "6E", "5T", "5E"],
			lowsweep: ["7M", "6M", "5M"],
			nastyplot: ["7E", "6E", "5E"],
			naturalgift: ["7L40", "6L40", "5L40"],
			overheat: ["7M", "6M", "5M"],
			payback: ["7M", "6M", "5M"],
			playnice: ["7L1", "6L1"],
			protect: ["7M", "6M", "5M"],
			recycle: ["7L37", "6T", "6L37", "5T", "5L37"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["7E", "6T", "6E", "5T", "5E"],
			round: ["7M", "6M", "5M"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			tickle: ["7E", "6E", "5E"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			willowisp: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			yawn: ["7L16", "6L16", "5L16"],
		},
	},
	simisear: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "6M", "5M"],
			firepledge: ["7T"],
			firepunch: ["6T", "5T"],
			flameburst: ["7L1", "6L1", "5L1"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L1", "6L1", "5L1"],
			gastroacid: ["6T"],
			gigaimpact: ["7M", "6M", "6S0", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gunkshot: ["6T", "5T"],
			heatwave: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "6S0", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lick: ["7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			overheat: ["7M", "6M", "5M"],
			payback: ["7M", "6M", "5M"],
			poweruppunch: ["6M", "6S0"],
			protect: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			willowisp: ["7M", "6M", "5M"],
			workup: ["7M", "6S0", "5M"],
		},
	},
	panpour: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L31", "6M", "6L31", "5M", "5L31"],
			aquaring: ["7E", "6E", "5E"],
			aquatail: ["7E", "6T", "6E", "5T", "5E"],
			astonish: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L19", "6L19", "5L19"],
			blizzard: ["7M", "6M", "5M"],
			brine: ["7L34", "6L34", "5L34"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E", "5T", "5E"],
			crunch: ["7L43", "6L43", "5L43"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			disarmingvoice: ["7E", "6E"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			fling: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L13", "6L13", "5L13"],
			gastroacid: ["6T"],
			grassknot: ["7M", "6M", "5M"],
			gunkshot: ["6T", "5T"],
			hail: ["7M", "6M", "5M"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hydropump: ["7E", "6E", "5E", "5S0"],
			icebeam: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			icywind: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L4", "6L4", "5L4", "5S0"],
			lick: ["7L7", "6L7", "5L7", "5S0"],
			lowkick: ["7E", "6T", "6E", "5T", "5E"],
			lowsweep: ["7M", "6M", "5M"],
			mudsport: ["7E", "6E", "5E"],
			nastyplot: ["7E", "6E", "5E"],
			naturalgift: ["7L40", "6L40", "5L40"],
			payback: ["7M", "6M", "5M"],
			playnice: ["7L1", "6L1"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			recycle: ["7L37", "6T", "6L37", "5T", "5L37"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["7E", "6T", "6E", "5T", "5E"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			thief: ["7M", "6M", "5M"],
			tickle: ["7E", "6E", "5E"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			waterfall: ["7M", "6M", "5M"],
			watergun: ["7L10", "6L10", "5L10", "5S0"],
			waterpledge: ["7T"],
			waterpulse: ["6T"],
			watersport: ["7L16", "6L16", "5L16"],
			workup: ["7M", "5M"],
		},
	},
	simipour: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			blizzard: ["7M", "6M", "5M"],
			brickbreak: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L1", "6L1", "5L1"],
			gastroacid: ["6T"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gunkshot: ["6T", "5T"],
			hail: ["7M", "6M", "5M"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			icebeam: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			icywind: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lick: ["7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			payback: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "7L1", "6M", "6L1", "5M", "5L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			waterfall: ["7M", "6M", "5M"],
			waterpledge: ["7T"],
			waterpulse: ["6T"],
			workup: ["7M", "5M"],
		},
	},
	munna: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			barrier: ["7E", "6E", "5E"],
			batonpass: ["7E", "6E", "5E"],
			calmmind: ["7M", "7L35", "6M", "6L35", "5M", "5L35"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["7L1", "6L1", "5L1"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			futuresight: ["7L31", "6L31", "5L31"],
			gravity: ["6T", "5T"],
			gyroball: ["7M", "6M", "5M"],
			healbell: ["6T", "5T"],
			healingwish: ["7E", "6E"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E"],
			hiddenpower: ["7M", "6M", "5M"],
			hypnosis: ["7L19", "6L19", "5L19"],
			imprison: ["7L13", "6L13", "5L13"],
			lightscreen: ["7M", "6M", "5M"],
			luckychant: ["7L5", "6L5", "5L5"],
			magiccoat: ["7E", "6T", "6E", "5T", "5E"],
			moonlight: ["7L17", "6L17", "5L17"],
			nightmare: ["7L29", "6L29", "5L29"],
			painsplit: ["6T", "5T"],
			protect: ["7M", "6M", "5M"],
			psybeam: ["7L11", "6L11", "5L11"],
			psychic: ["7M", "7L37", "6M", "6L37", "5M", "5L37"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7L1", "6L1", "5L1"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["7E", "6M", "6E", "5E"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			snore: ["6T", "5T"],
			sonicboom: ["7E", "6E", "5E"],
			storedpower: ["7L47", "6L47", "5L47"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swift: ["7E", "6E", "5E"],
			synchronoise: ["7L25", "6L25", "5L25"],
			telekinesis: ["7L43", "6L43", "5M", "5L43"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			wonderroom: ["6T", "5T"],
			worryseed: ["6T", "5T"],
			yawn: ["7L7", "6L7", "5L7"],
			zenheadbutt: ["7L23", "6T", "6L23", "5T", "5L23"],
		},
	},
	musharna: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			dazzlinggleam: ["7M", "6M"],
			defensecurl: ["7L1", "6L1", "5L1", "5S0"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			gyroball: ["7M", "6M", "5M"],
			healbell: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypnosis: ["7L1", "6L1", "5L1", "5S0"],
			lightscreen: ["7M", "6M", "5M"],
			luckychant: ["7L1", "6L1", "5L1", "5S0"],
			magiccoat: ["6T", "5T"],
			painsplit: ["6T", "5T"],
			protect: ["7M", "6M", "5M"],
			psybeam: ["7L1", "6L1", "5L1", "5S0"],
			psychic: ["7M", "6M", "5M"],
			psychicterrain: ["7L1"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			wonderroom: ["6T", "5T"],
			worryseed: ["6T", "5T"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	pidove: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aircutter: ["7L15", "6L15", "5L15", "5S0"],
			airslash: ["7L29", "6L29", "5L29"],
			attract: ["7M", "6M", "5M"],
			bestow: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			detect: ["7L22", "6L22", "5L22"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			facade: ["7M", "7L43", "6M", "6L43", "5M", "5L43"],
			featherdance: ["7L36", "6L36", "5L36"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			growl: ["7L4", "6L4", "5L4"],
			gust: ["7L1", "6L1", "5L1", "5S0", "5D"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hypnosis: ["7E", "6E", "5E", "5D"],
			leer: ["7L8", "6L8", "5L8"],
			luckychant: ["7E", "6E", "5E"],
			morningsun: ["7E", "6E", "5E", "5D"],
			nightslash: ["7E", "6E"],
			pluck: ["5M"],
			protect: ["7M", "6M", "5M"],
			quickattack: ["7L11", "6L11", "5L11", "5S0"],
			raindance: ["7M", "6M", "5M"],
			razorwind: ["7L32", "6L32", "5L32"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roost: ["7M", "7L18", "6M", "6L18", "5T", "5L18"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			skyattack: ["7L50", "6T", "6L50", "5T", "5L50"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			tailwind: ["7L46", "6T", "6L46", "5T", "5L46"],
			taunt: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7E", "6T", "6E", "5T", "5E"],
			uturn: ["7M", "6M", "5M"],
			wish: ["7E", "6E", "5E"],
			workup: ["7M", "5M"],
		},
	},
	tranquill: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aircutter: ["7L15", "6L15", "5L15"],
			airslash: ["7L32", "6L32", "5L32"],
			attract: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			detect: ["7L23", "6L23", "5L23"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			facade: ["7M", "7L50", "6M", "6L50", "5M", "5L50"],
			featherdance: ["7L41", "6L41", "5L41"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			growl: ["7L4", "7L1", "6L1", "5L1"],
			gust: ["7L1", "6L1", "5L1"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			leer: ["7L8", "7L1", "6L1", "5L1"],
			pluck: ["5M"],
			protect: ["7M", "6M", "5M"],
			quickattack: ["7L11", "7L1", "6L1", "5L1"],
			raindance: ["7M", "6M", "5M"],
			razorwind: ["7L36", "6L36", "5L36"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roost: ["7M", "7L18", "6M", "6L18", "5T", "5L18"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			skyattack: ["7L59", "6T", "6L59", "5T", "5L59"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			tailwind: ["7L54", "6T", "6L54", "5T", "5L54"],
			taunt: ["7M", "7L27", "6M", "6L27", "5M", "5L27"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
		},
	},
	unfezant: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aircutter: ["7L15", "6L15", "5L15"],
			airslash: ["7L33", "6L33", "5L33"],
			attract: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			detect: ["7L23", "6L23", "5L23"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			facade: ["7M", "7L55", "6M", "6L55", "5M", "5L55"],
			featherdance: ["7L44", "6L44", "5L44"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			growl: ["7L4", "7L1", "6L1", "5L1"],
			gust: ["7L1", "6L1", "5L1"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			leer: ["7L8", "7L1", "6L1", "5L1"],
			pluck: ["5M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			quickattack: ["7L11", "7L1", "6L1", "5L1"],
			raindance: ["7M", "6M", "5M"],
			razorwind: ["7L38", "6L38", "5L38"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roost: ["7M", "7L18", "6M", "6L18", "5T", "5L18"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			skyattack: ["7L66", "6T", "6L66", "5T", "5L66"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "7L49", "6M", "6L49", "5M", "5L49"],
			tailwind: ["7L60", "6T", "6L60", "5T", "5L60"],
			taunt: ["7M", "7L27", "6M", "6L27", "5M", "5L27"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
		},
	},
	blitzle: {
		inherit: true,
		learnset: {
			agility: ["7L36", "6L36", "5L36"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			charge: ["7L8", "6L8", "5L8"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			discharge: ["7L32", "6L32", "5L32"],
			doubleedge: ["7E", "6E", "5E"],
			doublekick: ["7E", "6E", "5E"],
			doubleteam: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E"],
			facade: ["7M", "6M", "5M"],
			flamecharge: ["7M", "7L18", "6M", "6L18", "5M", "5L18"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			lightscreen: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T"],
			mefirst: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7L22", "6L22", "5L22"],
			quickattack: ["7L1", "6L1", "5L1"],
			rage: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7E", "6E", "5E"],
			screech: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			shockwave: ["7L11", "7E", "6T", "6L11", "6E", "5L11", "5E"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["7E", "6T", "6E"],
			snore: ["6T", "5T"],
			spark: ["7L25", "6L25", "5L25"],
			stomp: ["7L29", "6L29", "5L29"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwhip: ["7L4", "6L4", "5L4"],
			takedown: ["7E", "6E", "5E"],
			thrash: ["7L43", "6L43", "5L43"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "7L15", "6M", "6L15", "5M", "5L15"],
			toxic: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
		},
	},
	zebstrika: {
		inherit: true,
		learnset: {
			agility: ["7L42", "6L42", "5L42"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			charge: ["7L8", "7L1", "6L1", "5L1"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			discharge: ["7L36", "6L36", "5L36"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flamecharge: ["7M", "7L18", "6M", "6L18", "5M", "5L18"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			iondeluge: ["7L58", "7L1", "6L1"],
			lightscreen: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T"],
			overheat: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7L22", "6L22", "5L22"],
			quickattack: ["7L1", "6L1", "5L1"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shockwave: ["7L11", "6T", "6L11", "5L11"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T"],
			snore: ["6T", "5T"],
			spark: ["7L25", "6L25", "5L25"],
			stomp: ["7L31", "6L31", "5L31"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwhip: ["7L4", "7L1", "6L1", "5L1"],
			thrash: ["7L53", "6L53", "5L53"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "7L15", "7L1", "6M", "6L1", "5M", "5L1"],
			toxic: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "7L47", "6M", "6L47", "5M", "5L47"],
		},
	},
	roggenrola: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			autotomize: ["7E", "6E", "5E"],
			block: ["6T", "5T"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M"],
			explosion: ["7M", "7L40", "6M", "6L40", "5M", "5L40"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gravity: ["7E", "6T", "6E", "5T", "5E"],
			harden: ["7L4", "6L4", "5L4"],
			headbutt: ["7L10", "6L10", "5L10"],
			heavyslam: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M"],
			irondefense: ["7L20", "6T", "6L20", "5T", "5L20"],
			lockon: ["7E", "6E", "5E"],
			magnitude: ["7E", "6E", "5E"],
			mudslap: ["7L17", "6L17", "5L17"],
			naturepower: ["7M", "6M"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockblast: ["7L14", "6L14", "5L14"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L27", "6M", "6L27", "5M", "5L27"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "7E", "6M", "6E", "5M", "5E"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L7", "6L7", "5L7"],
			sandstorm: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "7L23", "6M", "6L23", "5M", "5L23"],
			snore: ["6T", "5T"],
			stealthrock: ["7L30", "6T", "6L30", "5T", "5L30"],
			stoneedge: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			takedown: ["7E", "6E", "5E"],
			toxic: ["7M", "6M", "5M"],
			wideguard: ["7E", "6E"],
		},
	},
	boldore: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			curse: ["5D"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M"],
			explosion: ["7M", "7L55", "6M", "6L55", "5M", "5L55"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			harden: ["7L4", "7L1", "6L1", "5L1"],
			headbutt: ["7L10", "7L1", "6L1", "5L1"],
			heavyslam: ["5D"],
			hiddenpower: ["7M", "6M", "5M"],
			irondefense: ["7L20", "6T", "6L20", "5T", "5L20"],
			mudslap: ["7L17", "6L17", "5L17"],
			naturepower: ["7M", "6M"],
			powergem: ["7L1", "6L25", "5L25"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockblast: ["7L14", "6L14", "5L14"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L30", "6M", "6L30", "5M", "5L30"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L7", "7L1", "6L1", "5L1"],
			sandstorm: ["7M", "7L42", "6M", "6L42", "5M", "5L42"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "7L23", "6M", "6L23", "5M", "5L23", "5D"],
			snore: ["6T", "5T"],
			stealthrock: ["7L36", "6T", "6L36", "5T", "5L36"],
			stoneedge: ["7M", "7L48", "6M", "6L48", "5M", "5L48"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			toxic: ["7M", "6M", "5M"],
		},
	},
	gigalith: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M"],
			explosion: ["7M", "7L55", "6M", "6L55", "5M", "5L55"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			harden: ["7L4", "7L1", "6L1", "5L1"],
			headbutt: ["7L10", "7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			irondefense: ["7L20", "6T", "6L20", "5T", "5L20"],
			ironhead: ["6T", "5T"],
			mudslap: ["7L17", "6L17", "5L17"],
			naturepower: ["7M", "6M"],
			powergem: ["7L1", "6L25", "5L25"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockblast: ["7L14", "6L14", "5L14"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L30", "6M", "6L30", "5M", "5L30"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L7", "7L1", "6L1", "5L1"],
			sandstorm: ["7M", "7L42", "6M", "6L42", "5M", "5L42"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "7L23", "6M", "6L23", "5M", "5L23"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stealthrock: ["7L36", "6T", "6L36", "5T", "5L36"],
			stoneedge: ["7M", "7L48", "6M", "6L48", "5M", "5L48"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			toxic: ["7M", "6M", "5M"],
		},
	},
	woobat: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M"],
			afteryou: ["6T", "5T"],
			aircutter: ["7L21", "6L21", "5L21"],
			airslash: ["7L32", "6L32", "5L32"],
			amnesia: ["7L29", "6L29", "5L29"],
			assurance: ["7L12", "6L12", "5L12"],
			attract: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			calmmind: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			captivate: ["7E", "6E"],
			chargebeam: ["7M", "6M", "5M"],
			charm: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			endeavor: ["7L47", "6T", "6L47", "5T", "5L47"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			faketears: ["7E", "6E", "5E"],
			flash: ["6M", "5M"],
			flatter: ["7E", "6E", "5E"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			futuresight: ["7L36", "6L36", "5L36"],
			gigadrain: ["6T", "5T"],
			gust: ["7L8", "6L8", "5L8"],
			gyroball: ["7M", "6M", "5M"],
			heartstamp: ["7L15", "6L15", "5L15"],
			heatwave: ["6T", "5T"],
			helpinghand: ["7E", "6T", "6E", "5T", "5E"],
			hiddenpower: ["7M", "6M", "5M"],
			imprison: ["7L19", "6L19", "5L19"],
			knockoff: ["7E", "6T", "6E", "5T", "5E"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			odorsleuth: ["7L4", "6L4", "5L4"],
			pluck: ["5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			psychoshift: ["7E", "6E"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			storedpower: ["7E", "6E", "5E"],
			substitute: ["7M", "6M", "5M"],
			superfang: ["6T", "5T"],
			supersonic: ["7E", "6E", "5E"],
			swagger: ["7M", "6M", "5M"],
			synchronoise: ["7E", "6E", "5E"],
			tailwind: ["6T", "5T"],
			taunt: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
			venomdrench: ["7E", "6E"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	swoobat: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M"],
			afteryou: ["6T", "5T"],
			aircutter: ["7L21", "6L21", "5L21"],
			airslash: ["7L32", "6L32", "5L32"],
			amnesia: ["7L29", "6L29", "5L29"],
			assurance: ["7L12", "7L1", "6L1", "5L1"],
			attract: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			calmmind: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			endeavor: ["7L47", "6T", "6L47", "5T", "5L47"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			futuresight: ["7L36", "6L36", "5L36"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			gust: ["7L8", "7L1", "6L1", "5L1"],
			gyroball: ["7M", "6M", "5M"],
			heartstamp: ["7L15", "6L15", "5L15"],
			heatwave: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			imprison: ["7L19", "6L19", "5L19"],
			knockoff: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			odorsleuth: ["7L4", "7L1", "6L1", "5L1"],
			pluck: ["5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["6T", "5T"],
			skyattack: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			substitute: ["7M", "6M", "5M"],
			superfang: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["6T", "5T"],
			taunt: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	drilbur: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "6M", "5M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crushclaw: ["7E", "6E", "5E"],
			cut: ["6M", "5M"],
			dig: ["7L19", "6M", "6L19", "5M", "5L19"],
			doubleteam: ["7M", "6M", "5M"],
			drillrun: ["7L43", "6T", "6L43", "5T", "5L43"],
			earthpower: ["7E", "6T", "6E", "5T", "5E"],
			earthquake: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			facade: ["7M", "6M", "5M"],
			fissure: ["7L47", "6L47", "5L47"],
			fling: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L12", "6L12", "5L12"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["7L22", "6M", "6L22", "5M", "5L22"],
			irondefense: ["7E", "6T", "6E", "5T", "5E"],
			metalclaw: ["7L15", "6L15", "5L15"],
			metalsound: ["7E", "6E", "5E", "5D"],
			mudslap: ["7L8", "6L8", "5L8"],
			mudsport: ["7L1", "6L1", "5L1"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			rapidspin: ["7L5", "7E", "6L5", "6E", "5L5", "5E", "5D"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockclimb: ["7E", "6E", "5E", "5D"],
			rockslide: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "7L40", "6M", "6L40", "5M", "5L40"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			skullbash: ["7E", "6E", "5E"],
			slash: ["7L26", "6L26", "5L26"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			strength: ["6M", "5M"],
			submission: ["7E", "6E", "5E"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			toxic: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	excadrill: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			dig: ["7L19", "6M", "6L19", "5M", "5L19"],
			doubleteam: ["7M", "6M", "5M"],
			drillrun: ["7L55", "6T", "6L55", "5T", "5L55"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			facade: ["7M", "6M", "5M"],
			fissure: ["7L62", "6L62", "5L62"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L12", "6L12", "5L12"],
			gigaimpact: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["7L22", "6M", "6L22", "5M", "5L22"],
			horndrill: ["7L1", "6L31", "5L31"],
			hyperbeam: ["7M", "6M", "5M"],
			irondefense: ["6T", "5T"],
			ironhead: ["6T", "5T"],
			magnetrise: ["6T", "5T"],
			metalclaw: ["7L15", "6L15", "5L15"],
			mudslap: ["7L8", "7L1", "6L1", "5L1"],
			mudsport: ["7L1", "6L1", "5L1"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			rapidspin: ["7L5", "7L1", "6L1", "5L1"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rototiller: ["7L1", "6L1"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "7L49", "6M", "6L49", "5M", "5L49"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			slash: ["7L26", "6L26", "5L26"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			smartstrike: ["7M"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L42", "6M", "6L42", "5M", "5L42"],
			toxic: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	audino: {
		inherit: true,
		learnset: {
			afteryou: ["7L41", "6T", "6L40", "5T", "5L40"],
			amnesia: ["7E", "6E", "5E"],
			attract: ["7M", "7L21", "6M", "6L15", "5M", "5L15"],
			babydolleyes: ["7L5", "6L5"],
			bestow: ["7E", "6E", "5E"],
			blizzard: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			dig: ["6M", "5M"],
			disarmingvoice: ["7L13", "6L13"],
			doubleedge: ["7L49", "6L49", "5L50"],
			doubleslap: ["7L17", "6L10", "5L10", "5S0"],
			doubleteam: ["7M", "6M", "5M"],
			drainingkiss: ["7E", "6E"],
			drainpunch: ["6T", "5T"],
			dreameater: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7E", "6E", "5E", "5D"],
			entrainment: ["7L29", "6L25", "5L25"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			flamethrower: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			growl: ["7L1", "6L1", "5L1"],
			healbell: ["7E", "6T", "6E", "5T", "5E"],
			healingwish: ["7E", "6E", "5E"],
			healpulse: ["7L37", "6L35", "6S2", "5L35", "5S0", "5S1"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L1", "5S0", "5S1", "5D"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["7L53", "7L1", "6T", "5T"],
			icebeam: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			icywind: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			lastresort: ["7L57", "7L1", "6T", "6L1", "5T", "5L55"],
			lightscreen: ["7M", "6M", "5M"],
			lowkick: ["6T", "5T"],
			luckychant: ["7E", "6E", "5E"],
			magiccoat: ["6T", "5T"],
			mistyterrain: ["7L1", "6L1"],
			painsplit: ["6T", "5T"],
			playnice: ["7L1", "6L1"],
			pound: ["7L1", "6L1", "5L1"],
			poweruppunch: ["6M"],
			present: ["5S1"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			refresh: ["7L9", "6L5", "5L5", "5S0", "5S1"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["7L25", "6M", "6L20", "5L20"],
			shadowball: ["7M", "6M", "5M"],
			signalbeam: ["6T", "5T"],
			simplebeam: ["7L45", "6L45", "6S2", "5L45"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			sweetkiss: ["7E", "6E", "5E"],
			takedown: ["7L33", "6L30", "5L30"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "6S2", "5M"],
			thunderpunch: ["6T", "5T"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trickroom: ["7M", "6M", "6S2", "5M"],
			uproar: ["6T", "5T"],
			wildcharge: ["7M", "6M", "5M"],
			wish: ["7E", "6E", "5E"],
			workup: ["7M", "5M"],
			yawn: ["7E", "6E", "5E", "5D"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	timburr: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			bide: ["7L8", "6L8", "5L8"],
			block: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			chipaway: ["7L24", "6L24", "5L24"],
			cometpunch: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E"],
			detect: ["7E", "6E", "5E"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["7E", "6T", "6E", "5T", "5E"],
			dynamicpunch: ["7L34", "6L34", "5L34"],
			endure: ["7E", "6E", "5E"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focusenergy: ["7L4", "6L4", "5L4"],
			focuspunch: ["7L46", "6T", "6L46", "5L46"],
			forcepalm: ["7E", "6E", "5E"],
			foresight: ["7E", "6E", "5E"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			hammerarm: ["7L40", "6L40", "5L40"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lowkick: ["7L12", "6T", "6L12", "5T", "5L12"],
			lowsweep: ["7M", "6M", "5M"],
			machpunch: ["7E", "6E", "5E"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			pound: ["7L1", "6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			reversal: ["7E", "6E", "5E"],
			rockslide: ["7M", "7L31", "6M", "6L31", "5M", "5L31"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["7L16", "6L16", "5L16"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L37", "6L37", "5L37"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "6M", "5M"],
			smellingsalts: ["7E", "6E", "5E"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "7L43", "6M", "6L43", "5M", "5L43"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["7L49", "6T", "6L49", "5T", "5L49"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			toxic: ["7M", "6M", "5M"],
			wakeupslap: ["7L20", "6L20", "5L20"],
			wideguard: ["7E", "6E", "5E"],
			workup: ["7M", "5M"],
		},
	},
	gurdurr: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			bide: ["7L8", "7L1", "6L1", "5L1"],
			block: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			chipaway: ["7L24", "6L24", "5L24"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T", "5D"],
			dynamicpunch: ["7L37", "6L37", "5L37"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focusenergy: ["7L4", "7L1", "6L1", "5L1"],
			focuspunch: ["7L53", "6T", "6L53", "5L53"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			hammerarm: ["7L45", "6L45", "5L45"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lowkick: ["7L12", "6T", "6L12", "5T", "5L12", "5D"],
			lowsweep: ["7M", "6M", "5M"],
			machpunch: ["5D"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			pound: ["7L1", "6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["7L16", "6L16", "5L16"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L41", "6L41", "5L41"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "7L49", "6M", "6L49", "5M", "5L49"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["7L57", "6T", "6L57", "5T", "5L57"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			toxic: ["7M", "6M", "5M"],
			wakeupslap: ["7L20", "6L20", "5L20"],
			workup: ["7M", "5M"],
		},
	},
	conkeldurr: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			bide: ["7L8", "7L1", "6L1", "5L1"],
			block: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			bulldoze: ["7M", "6M", "5M"],
			chipaway: ["7L24", "6L24", "5L24"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T"],
			dynamicpunch: ["7L37", "6L37", "5L37"],
			earthquake: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focusenergy: ["7L4", "7L1", "6L1", "5L1"],
			focuspunch: ["7L53", "6T", "6L53", "5L53"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			hammerarm: ["7L45", "6L45", "5L45"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lowkick: ["7L12", "6T", "6L12", "5T", "5L12"],
			lowsweep: ["7M", "6M", "5M"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			pound: ["7L1", "6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["7L16", "6L16", "5L16"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L41", "6L41", "5L41"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "7L49", "6M", "6L49", "5M", "5L49"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["7L57", "6T", "6L57", "5T", "5L57"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			toxic: ["7M", "6M", "5M"],
			wakeupslap: ["7L20", "6L20", "5L20"],
			workup: ["7M", "5M"],
		},
	},
	tympole: {
		inherit: true,
		learnset: {
			afteryou: ["7E", "6T", "6E"],
			aquaring: ["7L20", "6L20", "5L20"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			bubble: ["7L1", "6L1", "5L1"],
			bubblebeam: ["7L12", "6L12", "5L12"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["7E", "6T", "6E", "5T", "5E", "5D"],
			echoedvoice: ["7M", "7L38", "6M", "6L38", "5M", "5L38"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			flail: ["7L34", "6L34", "5L34"],
			frustration: ["7M", "6M", "5M"],
			growl: ["7L1", "6L1", "5L1"],
			hail: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L42", "6L42", "5L42"],
			hypervoice: ["7L45", "6T", "6L45", "5T", "5L45"],
			icywind: ["6T", "5T"],
			infestation: ["7M", "6M"],
			mist: ["7E", "6E", "5E"],
			mudbomb: ["7E", "6E", "5E"],
			muddywater: ["7L27", "6L27", "5L27"],
			mudshot: ["7L16", "6L16", "5L16"],
			mudsport: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "7L31", "6M", "6L31", "5M", "5L31"],
			refresh: ["7E", "6E", "5E"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "7L9", "6M", "6L9", "5M", "5L9", "5D"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			sludgebomb: ["7M", "6M", "5M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["7E", "6T", "6E", "5T", "5E"],
			substitute: ["7M", "6M", "5M"],
			supersonic: ["7L5", "6L5", "5L5"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7L23", "6T", "6L23", "5T", "5L23"],
			waterpulse: ["7E", "6T", "6E", "5E", "5D"],
		},
	},
	palpitoad: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			aquaring: ["7L20", "6L20", "5L20"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			bubble: ["7L1", "6L1", "5L1"],
			bubblebeam: ["7L12", "6L12", "5L12"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			echoedvoice: ["7M", "7L42", "6M", "6L42", "5M", "5L42"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			flail: ["7L37", "6L37", "5L37"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["6T", "5T"],
			growl: ["7L1", "6L1", "5L1"],
			hail: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L47", "6L47", "5L47"],
			hypervoice: ["7L51", "6T", "6L51", "5T", "5L51"],
			icywind: ["6T", "5T"],
			infestation: ["7M", "6M"],
			muddywater: ["7L28", "6L28", "5L28"],
			mudshot: ["7L16", "6L16", "5L16"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "7L9", "7L1", "6M", "6L1", "5M", "5L1"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			supersonic: ["7L5", "7L1", "6L1", "5L1"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7L23", "6T", "6L23", "5T", "5L23"],
			waterpulse: ["6T"],
		},
	},
	seismitoad: {
		inherit: true,
		learnset: {
			acid: ["7L1", "6L36", "5L36"],
			afteryou: ["6T"],
			aquaring: ["7L20", "6L20", "5L20"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M"],
			bubble: ["7L1", "6L1", "5L1"],
			bubblebeam: ["7L12", "6L12", "5L12"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["7L44", "6T", "6L44", "5T", "5L44"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "7L49", "6M", "6L49", "5M", "5L49"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			flail: ["7L39", "6L39", "5L39"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			growl: ["7L1", "6L1", "5L1"],
			hail: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L53", "6L53", "5L53"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["7L59", "6T", "6L59", "5T", "5L59"],
			icepunch: ["6T", "5T"],
			icywind: ["6T", "5T"],
			infestation: ["7M", "6M"],
			knockoff: ["6T", "5T"],
			lowkick: ["6T", "5T"],
			muddywater: ["7L28", "6L28", "5L28"],
			mudshot: ["7L16", "6L16", "5L16"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "7L9", "7L1", "6M", "6L1", "5M", "5L1"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			supersonic: ["7L5", "7L1", "6L1", "5L1"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7L23", "6T", "6L23", "5T", "5L23"],
			venoshock: ["7M", "6M", "5M"],
			waterpulse: ["6T"],
		},
	},
	throh: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			bide: ["7L1", "6L5", "5L5"],
			bind: ["7L1", "6T", "6L1", "5T", "5L1", "5D"],
			block: ["6T", "5T"],
			bodyslam: ["7L21", "6L29", "5L29"],
			brickbreak: ["7M", "6M", "5M"],
			bulkup: ["7M", "7L25", "6M", "6L33", "5M", "5L33"],
			bulldoze: ["7M", "6M", "5M"],
			circlethrow: ["7L29", "6L37", "5L37"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			earthquake: ["7M", "6M", "5M"],
			endure: ["7L33", "6L41", "5L41"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focusenergy: ["7L1", "6L9", "5L9"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T", "5D"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			matblock: ["7L1"],
			painsplit: ["6T", "5T"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			revenge: ["7L13", "6L21", "5L21"],
			reversal: ["7L45", "6L50", "5L53"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seismictoss: ["7L5", "6L13", "5L13"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			stormthrow: ["7L17", "6L25", "5L25"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["7L41", "6T", "6L48", "5T", "5L49", "5D"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			toxic: ["7M", "6M", "5M"],
			vitalthrow: ["7L9", "6L17", "5L17"],
			wideguard: ["7L37", "6L45", "5L45"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T"],
		},
	},
	sawk: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			bide: ["7L1", "6L5", "5L5"],
			block: ["6T", "5T"],
			brickbreak: ["7M", "7L21", "6M", "6L29", "5M", "5L29"],
			bulkup: ["7M", "7L25", "6M", "6L33", "5M", "5L33"],
			bulldoze: ["7M", "6M", "5M"],
			closecombat: ["7L41", "6L48", "5L49"],
			confide: ["7M", "6M"],
			counter: ["7L13", "6L21", "5L21"],
			dig: ["6M", "5M"],
			doublekick: ["7L5", "6L13", "5L13"],
			doubleteam: ["7M", "6M", "5M"],
			dualchop: ["6T", "5T", "5D"],
			earthquake: ["7M", "6M", "5M"],
			endure: ["7L33", "6L41", "5L41"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focusenergy: ["7L1", "6L9", "5L9"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			karatechop: ["7L17", "6L25", "5L25"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "7L9", "6M", "6L17", "5M", "5L17"],
			painsplit: ["6T", "5T"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			quickguard: ["7L37", "6L45", "5L45"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L29", "6M", "6L37", "5M", "5L37"],
			return: ["7M", "6M", "5M"],
			reversal: ["7L45", "6L50", "5L53"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["7L1", "6M", "6L1", "5M", "5L1", "5D"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T", "5D"],
			toxic: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T"],
		},
	},
	sewaddle: {
		inherit: true,
		learnset: {
			agility: ["7E", "6E", "5E"],
			airslash: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			batonpass: ["7E", "6E", "5E"],
			bugbite: ["7L8", "6T", "6L8", "5T", "5L8"],
			bugbuzz: ["7L36", "6L36", "5L36"],
			calmmind: ["7M", "6M", "5M"],
			camouflage: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			electroweb: ["6T", "5T"],
			endure: ["7L29", "6L29", "5L29"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flail: ["7L43", "6L43", "5L43"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			grassknot: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			irondefense: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			mefirst: ["7E", "6E", "5E"],
			mindreader: ["7E", "6E", "5E"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			razorleaf: ["7L15", "6L15", "5L15"],
			razorwind: ["7E", "6E", "5E"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			signalbeam: ["6T", "5T"],
			silverwind: ["7E", "6E", "5E"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stickyweb: ["7L31", "6L31"],
			stringshot: ["7L1", "6L1", "5L1"],
			strugglebug: ["7L22", "6M", "6L22", "5M", "5L22"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			synthesis: ["6T", "5T"],
			tackle: ["7L1", "6L1", "5L1"],
			toxic: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T"],
		},
	},
	swadloon: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			bugbite: ["7L1", "6T", "6L1", "5T", "5L1"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			electroweb: ["6T", "5T"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			grassknot: ["7M", "6M", "5M"],
			grasswhistle: ["7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			irondefense: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "7L1", "6M", "6L20", "5M", "5L20"],
			razorleaf: ["7L1", "6L1", "5L1"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stringshot: ["7L1", "6L1", "5L1"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			synthesis: ["6T", "5T"],
			tackle: ["7L1", "6L1", "5L1"],
			toxic: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T"],
		},
	},
	leavanny: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			attract: ["7M", "6M", "5M"],
			bugbite: ["7L8", "7L1", "6T", "6L1", "5T", "5L1"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			electroweb: ["6T", "5T"],
			energyball: ["7M", "6M", "5M"],
			entrainment: ["7L43", "6L43", "5L43"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "7L1", "6M", "6L1", "5M", "5L1"],
			fellstinger: ["7L29", "6L34"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			healbell: ["6T", "5T"],
			helpinghand: ["7L32", "6T", "6L32", "5T", "5L32"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			irondefense: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leafblade: ["7L36", "6L36", "5L36"],
			leafstorm: ["7L50", "6L50", "5L50"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			razorleaf: ["7L15", "7L1", "6L1", "5L1"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			shadowclaw: ["7M", "6M", "5M"],
			signalbeam: ["6T", "5T"],
			slash: ["7L1", "6L29", "5L29"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			steelwing: ["7M", "6M"],
			stringshot: ["7L1", "6L1", "5L1"],
			strugglebug: ["7L22", "6M", "6L22", "5M", "5L22"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L46", "6M", "6L46", "5M", "5L46"],
			synthesis: ["6T", "5T"],
			tackle: ["7L1", "6L1", "5L1"],
			toxic: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T"],
			xscissor: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
		},
	},
	venipede: {
		inherit: true,
		learnset: {
			agility: ["7L29", "6L29", "5L29"],
			attract: ["7M", "6M", "5M"],
			bugbite: ["7L22", "6T", "6L22", "5T", "5L22"],
			confide: ["7M", "6M"],
			defensecurl: ["7L1", "6L1", "5L1"],
			doubleedge: ["7L43", "6L43", "5L43"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gyroball: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			irondefense: ["6T", "5T"],
			payback: ["7M", "6M", "5M"],
			pinmissile: ["7E", "6E", "5E"],
			poisonjab: ["7M", "6M", "5M"],
			poisonsting: ["7L5", "6L5", "5L5"],
			poisontail: ["7L19", "6L19", "5L19"],
			protect: ["7M", "7L15", "6M", "6L15", "5M", "5L15"],
			pursuit: ["7L12", "6L12", "5L12"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockclimb: ["7L40", "7E", "6L40", "6E", "5L40", "5E"],
			rocksmash: ["6M", "5M"],
			rollout: ["7L1", "6L1", "5L1"],
			round: ["7M", "6M", "5M"],
			screech: ["7L8", "6L8", "5L8"],
			secretpower: ["6M"],
			signalbeam: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			spikes: ["7E", "6E", "5E"],
			steamroller: ["7L33", "6L33", "5L33"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			takedown: ["7E", "6E", "5E"],
			toxic: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			toxicspikes: ["7E", "6E", "5E"],
			twineedle: ["7E", "6E", "5E"],
			venoshock: ["7M", "7L38", "7L26", "6M", "6L26", "5M", "5L26"],
		},
	},
	whirlipede: {
		inherit: true,
		learnset: {
			agility: ["7L32", "6L32", "5L32"],
			attract: ["7M", "6M", "5M"],
			bugbite: ["7L23", "6T", "6L23", "5T", "5L23"],
			confide: ["7M", "6M"],
			defensecurl: ["7L1", "6L1", "5L1"],
			doubleedge: ["7L50", "6L50", "5L50"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gyroball: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			irondefense: ["7L1", "6T", "6L22", "5T", "5L22"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			poisonsting: ["7L5", "7L1", "6L1", "5L1"],
			poisontail: ["7L19", "6L19", "5L19"],
			protect: ["7M", "7L15", "6M", "6L15", "5M", "5L15"],
			pursuit: ["7L12", "6L12", "5L12"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockclimb: ["7L46", "6L46", "5L46"],
			rocksmash: ["6M", "5M"],
			rollout: ["7L1", "6L1", "5L1"],
			round: ["7M", "6M", "5M"],
			screech: ["7L8", "7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			signalbeam: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			steamroller: ["7L37", "6L37", "5L37"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			venomdrench: ["7L43", "6L43"],
			venoshock: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
		},
	},
	scolipede: {
		inherit: true,
		learnset: {
			agility: ["7L33", "6L33", "5L33"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			batonpass: ["7L1", "6L30", "5L30"],
			bugbite: ["7L23", "6T", "6L23", "5T", "5L23"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			defensecurl: ["7L1", "6L1", "5L1"],
			dig: ["6M", "5M"],
			doubleedge: ["7L55", "6L55", "5L55"],
			doubleteam: ["7M", "6M", "5M"],
			earthquake: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			gyroball: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			irondefense: ["7L1", "6T", "5T"],
			irontail: ["6T", "5T"],
			megahorn: ["7L65", "7L1", "6L1", "5L1"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			poisonsting: ["7L5", "7L1", "6L1", "5L1"],
			poisontail: ["7L19", "6L19", "5L19", "5D"],
			protect: ["7M", "7L15", "6M", "6L15", "5M", "5L15"],
			pursuit: ["7L12", "6L12", "5L12"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockclimb: ["7L50", "6L50", "5L50"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rollout: ["7L1", "6L1", "5L1"],
			round: ["7M", "6M", "5M"],
			screech: ["7L8", "7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			signalbeam: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			smartstrike: ["7M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			steamroller: ["7L39", "6L39", "5L39"],
			strength: ["6M", "5M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T", "5D"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			toxic: ["7M", "7L44", "6M", "6L44", "5M", "5L44"],
			toxicspikes: ["5D"],
			venomdrench: ["7L47", "6L47"],
			venoshock: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	cottonee: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			beatup: ["7E", "6E", "5E"],
			captivate: ["7E", "6E"],
			charm: ["7L28", "6L28", "5L28"],
			confide: ["7M", "6M"],
			cottonguard: ["7L37", "6L37", "5L37"],
			cottonspore: ["7L17", "6L17", "5L17"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			encore: ["7E", "6E", "5E", "5D"],
			endeavor: ["7L44", "6T", "6L44", "5T", "5L44"],
			energyball: ["7M", "7L35", "6M", "6L35", "5M", "5L35"],
			facade: ["7M", "6M", "5M"],
			fairywind: ["7L1", "6L1"],
			faketears: ["7E", "6E", "5E"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["7L26", "6T", "6L26", "5T", "5L26"],
			grassknot: ["7M", "6M", "5M"],
			grasswhistle: ["7E", "6E", "5E"],
			growth: ["7L4", "6L4", "5L4"],
			helpinghand: ["7L31", "6T", "6L31", "5T", "5L31"],
			hiddenpower: ["7M", "6M", "5M"],
			knockoff: ["6T", "5T"],
			leechseed: ["7L8", "6L8", "5L8", "5D"],
			megadrain: ["7L13", "6L13", "5L13"],
			memento: ["7E", "6E", "5E"],
			naturalgift: ["7E", "6E", "5E"],
			naturepower: ["7M", "6M"],
			poisonpowder: ["7L22", "6L22", "5L22"],
			protect: ["7M", "6M", "5M"],
			razorleaf: ["7L19", "6L19", "5L19"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "7L46", "6M", "6L46", "5M", "5L46"],
			stunspore: ["7L10", "6L10", "5L10"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "7L40", "6M", "6L40", "5M", "5L40"],
			swagger: ["7M", "6M", "5M"],
			switcheroo: ["7E", "6E", "5E"],
			tailwind: ["6T", "5T"],
			taunt: ["7M", "6M", "5M"],
			tickle: ["7E", "6E", "5E"],
			toxic: ["7M", "6M", "5M"],
			worryseed: ["7E", "6T", "6E", "5T", "5E", "5D"],
		},
	},
	whimsicott: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			beatup: ["5S0"],
			confide: ["7M", "6M"],
			cottonspore: ["7L1", "6L1", "5L1"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T", "5S0"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			growth: ["7L1", "6L1", "5L1"],
			gust: ["7L10", "6L10", "5L10"],
			helpinghand: ["6T", "5T", "5S0"],
			hiddenpower: ["7M", "6M", "5M"],
			hurricane: ["7L46", "6L46", "5L46"],
			hyperbeam: ["7M", "6M", "5M"],
			knockoff: ["6T", "5T"],
			leechseed: ["7L1", "6L1", "5L1"],
			lightscreen: ["7M", "6M", "5M"],
			megadrain: ["7L1", "6L1", "5L1"],
			moonblast: ["7L50", "6L50"],
			naturepower: ["7M", "6M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			shadowball: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M", "5S0"],
			tailwind: ["7L28", "6T", "6L28", "5T", "5L28"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trickroom: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T"],
		},
	},
	petilil: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1"],
			afteryou: ["7L44", "6T", "6L44", "5T", "5L44"],
			aromatherapy: ["7L28", "6L28", "5L28"],
			attract: ["7M", "6M", "5M"],
			bide: ["7E", "6E", "5E"],
			charm: ["7E", "6E", "5E", "5D"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E"],
			energyball: ["7M", "7L35", "6M", "6L35", "5M", "5L35"],
			entrainment: ["7L37", "6L37", "5L37"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["7L26", "6T", "6L26", "5T", "5L26"],
			grassknot: ["7M", "6M", "5M"],
			grasswhistle: ["7E", "6E", "5E"],
			growth: ["7L4", "6L4", "5L4"],
			healbell: ["6T", "5T"],
			healingwish: ["7E", "6E", "5E"],
			helpinghand: ["7L31", "6T", "6L31", "5T", "5L31"],
			hiddenpower: ["7M", "6M", "5M"],
			ingrain: ["7E", "6E", "5E"],
			leafstorm: ["7L46", "6L46", "5L46"],
			leechseed: ["7L8", "6L8", "5L8"],
			magicalleaf: ["7L19", "6L19", "5L19"],
			megadrain: ["7L13", "6L13", "5L13"],
			naturalgift: ["7E", "6E", "5E"],
			naturepower: ["7M", "6M"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			sleeppowder: ["7L10", "6L10", "5L10", "5D"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stunspore: ["7L22", "6L22", "5L22"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "7L40", "6M", "6L40", "5M", "5L40"],
			swagger: ["7M", "6M", "5M"],
			sweetscent: ["7E", "6E", "5E", "5D"],
			synthesis: ["7L17", "6T", "6L17", "5T", "5L17"],
			toxic: ["7M", "6M", "5M"],
			worryseed: ["7E", "6T", "6E", "5T", "5E"],
		},
	},
	lilligant: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			growth: ["7L1", "6L1", "5L1"],
			healbell: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			leechseed: ["7L1", "6L1", "5L1"],
			lightscreen: ["7M", "6M", "5M"],
			megadrain: ["7L1", "6L1", "5L1"],
			naturepower: ["7M", "6M"],
			petalblizzard: ["7L50", "6L50"],
			petaldance: ["7L46", "6L46", "5L46"],
			protect: ["7M", "6M", "5M"],
			quiverdance: ["7L28", "6L28", "5L28"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			synthesis: ["7L1", "6T", "6L1", "5T", "5L1"],
			teeterdance: ["7L10", "6L10", "5L10"],
			toxic: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T"],
		},
	},
	basculin: {
		inherit: true,
		learnset: {
			agility: ["7E", "6E", "5E", "5D"],
			aquajet: ["7L9", "6L13", "5L13"],
			aquatail: ["7L20", "6T", "6L28", "5T", "5L28"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L7", "6L10", "5L10"],
			bounce: ["6T", "5T"],
			brine: ["7E", "6E", "5E"],
			bubblebeam: ["7E", "6E", "5E"],
			chipaway: ["7L11", "6L16", "5L16"],
			confide: ["7M", "6M"],
			crunch: ["7L17", "6L24", "5L24"],
			cut: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleedge: ["7L26", "6L36", "5L36"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			finalgambit: ["7L38", "6L50", "5L51"],
			flail: ["7L34", "6L1", "5L46"],
			frustration: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			headbutt: ["7L5", "6L7", "5L7", "5D"],
			headsmash: ["7L46"],
			hiddenpower: ["7M", "6M", "5M"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			muddywater: ["7E", "6E", "5E"],
			mudshot: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M"],
			rage: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			revenge: ["7E", "6E", "5E"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			scaryface: ["7L30", "6L41", "5L41"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			soak: ["7L23", "6L32", "5L32"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swift: ["7E", "6E", "5E"],
			tackle: ["7L1", "6L1", "5L1"],
			tailwhip: ["7L1", "6L1"],
			takedown: ["7L14", "6L20", "5L20"],
			taunt: ["7M", "6M", "5M"],
			thrash: ["7L42", "6L1", "5L56"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7L3", "6T", "6L4", "5T", "5L4"],
			waterfall: ["7M", "6M", "5M"],
			watergun: ["7L1", "6L1", "5L1"],
			whirlpool: ["7E", "6E", "5E"],
			zenheadbutt: ["6T", "5T", "5D"],
		},
	},
	sandile: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T"],
			assurance: ["7L16", "6L16", "5L16"],
			attract: ["7M", "6M", "5M"],
			beatup: ["7E", "6E", "5E"],
			bite: ["7L4", "6L4", "5L4"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E"],
			crunch: ["7L28", "6L28", "5L28"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "6M", "5T"],
			dig: ["7L31", "6M", "6L31", "5M", "5L31"],
			doubleedge: ["7E", "6E", "5E"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "7L43", "6M", "6L43", "5M", "5L43"],
			embargo: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			facade: ["7M", "6M", "5M"],
			firefang: ["7E", "6E", "5E"],
			focusenergy: ["7E", "6E", "5E"],
			foulplay: ["7L37", "6T", "6L37", "5T", "5L37"],
			frustration: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			meanlook: ["7E", "6E", "5E"],
			mefirst: ["7E", "6E"],
			mudslap: ["7L19", "6L19", "5L19"],
			payback: ["7M", "6M", "5M"],
			powertrip: ["7E"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7E", "6E", "5E"],
			rage: ["7L1", "6L1", "5L1"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockclimb: ["7E", "6E", "5E"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L7", "6L7", "5L7"],
			sandstorm: ["7M", "7L40", "6M", "6L40", "5M", "5L40"],
			sandtomb: ["7L13", "6L13", "5L13"],
			scaryface: ["7L34", "6L34", "5L34"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thrash: ["7L46", "6L46", "5L46"],
			thunderfang: ["7E", "6E", "5E"],
			torment: ["7M", "7L10", "6M", "6L10", "5M", "5L10"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7E", "6T", "6E", "5T", "5E"],
		},
	},
	krokorok: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T"],
			assurance: ["7L16", "6L16", "5L16"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L4", "7L1", "6L1", "5L1"],
			brickbreak: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crunch: ["7L28", "6L28", "5L28"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "6M", "5T"],
			dig: ["7L32", "6M", "6L32", "5M", "5L32"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "7L48", "6M", "6L48", "5M", "5L48"],
			embargo: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			facade: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			foulplay: ["7L40", "6T", "6L40", "5T", "5L40"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			mudslap: ["7L19", "6L19", "5L19"],
			payback: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			rage: ["7L1", "6L1", "5L1"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L7", "7L1", "6L1", "5L1"],
			sandstorm: ["7M", "7L44", "6M", "6L44", "5M", "5L44"],
			sandtomb: ["7L13", "6L13", "5L13"],
			scaryface: ["7L36", "6L36", "5L36"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thrash: ["7L52", "6L52", "5L52"],
			torment: ["7M", "7L10", "6M", "6L10", "5M", "5L10"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
		},
	},
	krookodile: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			assurance: ["7L16", "6L16", "5L16"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L4", "7L1", "6L1", "5L1"],
			block: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "6M", "5M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			counter: ["5D"],
			crunch: ["7L28", "6L28", "5L28", "5D"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "6M", "5T"],
			dig: ["7L32", "6M", "6L32", "5M", "5L32"],
			doubleteam: ["7M", "6M", "5M"],
			dragonclaw: ["7M", "6M", "5M"],
			dragonpulse: ["6T", "5T"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "7L54", "6M", "6L54", "5M", "5L54"],
			embargo: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			facade: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			foulplay: ["7L42", "6T", "6L42", "5T", "5L42"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			meanlook: ["5D"],
			mudslap: ["7L19", "6L19", "5L19"],
			outrage: ["7L60", "6T", "6L1", "5T", "5L60"],
			payback: ["7M", "6M", "5M"],
			powertrip: ["7L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			rage: ["7L1", "6L1", "5L1"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L7", "7L1", "6L1", "5L1"],
			sandstorm: ["7M", "7L48", "6M", "6L48", "5M", "5L48"],
			sandtomb: ["7L13", "6L13", "5L13"],
			scaryface: ["7L36", "6L36", "5L36"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			torment: ["7M", "7L10", "6M", "6L10", "5M", "5L10"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
		},
	},
	darumaka: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			bellydrum: ["7L30", "6L30", "5L30"],
			brickbreak: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			encore: ["7E", "6E", "5E"],
			endeavor: ["6T", "5T"],
			endure: ["7E", "6E", "5E"],
			facade: ["7M", "7L19", "6M", "6L19", "5M", "5L19"],
			fireblast: ["7M", "6M", "5M"],
			firefang: ["7L11", "6L11", "5L11"],
			firepunch: ["7L22", "6T", "6L22", "5T", "5L22"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M"],
			flamewheel: ["7E", "6E", "5E"],
			flareblitz: ["7L33", "6L33", "5L33"],
			fling: ["7M", "6M", "5M"],
			focusenergy: ["7E", "6E", "5E"],
			focuspunch: ["7E", "6T", "6E", "5E"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gyroball: ["7M", "6M", "5M"],
			hammerarm: ["7E", "6E", "5E"],
			headbutt: ["7L14", "6L14", "5L14"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			incinerate: ["7L6", "6M", "6L6", "5M", "5L6"],
			overheat: ["7M", "7L42", "6M", "6L42", "5M", "5L42"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			rage: ["7L9", "6L9", "5L9"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rollout: ["7L3", "6L3", "5L3"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			snatch: ["7E", "6T", "6E"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["7L39", "6T", "6L39", "5T", "5L39"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			takedown: ["7E", "6E", "5E"],
			taunt: ["7M", "7L35", "6M", "6L35", "5M", "5L35"],
			thief: ["7M", "6M", "5M"],
			thrash: ["7L27", "6L27", "5L27"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7L17", "6T", "6L17", "5T", "5L17"],
			uturn: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M"],
			workup: ["7M", "7L25", "6L25", "5M", "5L25"],
			yawn: ["7E", "6E", "5E"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	darmanitan: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			bellydrum: ["7L30", "6L30", "6S1", "5L30", "5S0"],
			brickbreak: ["7M", "6M", "5M"],
			bulkup: ["7M", "6M", "5M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			earthquake: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "7L19", "6M", "6L19", "5M", "5L19"],
			fireblast: ["7M", "6M", "5M"],
			firefang: ["7L11", "6L11", "5L11"],
			firepunch: ["7L22", "6T", "6L22", "5T", "5L22"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M"],
			flareblitz: ["7L33", "6L33", "6S1", "5L33", "5S0"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gyroball: ["7M", "6M", "5M"],
			hammerarm: ["7L1", "6L35", "6S1", "5L35", "5S0"],
			headbutt: ["7L14", "6L14", "5L14"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			incinerate: ["7L6", "7L1", "6M", "6L1", "5M", "5L1"],
			overheat: ["7M", "7L54", "6M", "6L54", "5M", "5L54"],
			payback: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			rage: ["7L9", "7L1", "6L1", "5L1"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rollout: ["7L3", "7L1", "6L1", "5L1"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "6M", "5M"],
			snatch: ["6T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["7L47", "6T", "6L47", "5T", "5L47"],
			swagger: ["7M", "7L17", "6M", "6L17", "5M", "5L17"],
			tackle: ["7L1", "6L1", "5L1"],
			taunt: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			thief: ["7M", "6M", "5M"],
			thrash: ["7L27", "6L27", "6S1", "5L27", "5S0"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M"],
			workup: ["7M", "7L25", "6L25", "5M", "5L25"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	maractus: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1"],
			acupressure: ["7L29", "6L29", "5L29"],
			aerialace: ["7M", "6M", "5M"],
			afteryou: ["7L57", "7L1", "6T", "6L1", "5T", "5L57"],
			attract: ["7M", "6M", "5M"],
			bounce: ["7E", "6T", "6E", "5T", "5E"],
			bulletseed: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			cottonguard: ["7L55", "7L1", "6L1", "5L55"],
			cottonspore: ["7L18", "6L18", "5L18"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T"],
			endeavor: ["6T", "5T"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["7L26", "6T", "6L26", "5T", "5L26"],
			grassknot: ["7M", "6M", "5M"],
			grasswhistle: ["7E", "6E", "5E"],
			grassyterrain: ["7E", "6E"],
			growth: ["7L6", "6L6", "5L6"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hypervoice: ["6T", "5T"],
			ingrain: ["7L33", "6L33", "5L33"],
			knockoff: ["6T", "5T"],
			leechseed: ["7E", "6E", "5E", "5D"],
			megadrain: ["7L13", "6L13", "5L13"],
			naturepower: ["7M", "6M"],
			needlearm: ["7L22", "6L22", "5L22"],
			peck: ["7L1", "6L1", "5L1"],
			petalblizzard: ["7L48", "6L48"],
			petaldance: ["7L38", "6L38", "5L38"],
			pinmissile: ["7L10", "6L10", "5L10", "5D"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["7E", "6T", "6E", "5T", "5E"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "7L50", "6M", "6L50", "5M", "5L50"],
			spikes: ["7E", "6E", "5E", "5D"],
			spikyshield: ["7L1", "6L1"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["7L42", "6L42", "5L42"],
			sunnyday: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			swagger: ["7M", "6M", "5M"],
			sweetscent: ["7L3", "6L3", "5L3"],
			synthesis: ["7L15", "6T", "6L15", "5T", "5L15"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			woodhammer: ["7E", "6E", "5E"],
			worryseed: ["7E", "6T", "6E", "5T", "5E"],
		},
	},
	dwebble: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			attract: ["7M", "6M", "5M"],
			block: ["7E", "6T", "6E", "5T", "5E"],
			bugbite: ["7L23", "6T", "6L23", "5T", "5L23"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E"],
			curse: ["7E", "6E", "5E"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			earthquake: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7L13", "6L13", "5L13"],
			flail: ["7L41", "6L41", "5L41"],
			frustration: ["7M", "6M", "5M"],
			furycutter: ["7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["7E", "6T", "6E", "5T", "5E"],
			knockoff: ["6T", "5T"],
			naturepower: ["7M", "6M"],
			nightslash: ["7E", "6E", "5E"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockblast: ["7L5", "6L5", "5L5"],
			rockpolish: ["7M", "7L19", "6M", "6L19", "5M", "5L19"],
			rockslide: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rockwrecker: ["7L43", "6L43", "5L43"],
			rototiller: ["7E", "6E"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L11", "6L11", "5L11"],
			sandstorm: ["7M", "6M", "5M"],
			sandtomb: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			shellsmash: ["7L37", "6L37", "5L37"],
			slash: ["7L31", "6L31", "5L31"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "7L17", "6M", "6L17", "5M", "5L17"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			spikes: ["7E", "6E", "5E"],
			stealthrock: ["7L24", "6T", "6L24", "5T", "5L24"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			wideguard: ["7E", "6E"],
			withdraw: ["7L7", "6L7", "5L7"],
			xscissor: ["7M", "7L35", "6M", "6L35", "5M", "5L35"],
		},
	},
	crustle: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			attract: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			bugbite: ["7L23", "6T", "6L23", "5T", "5L23"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			counter: ["5D"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			earthquake: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7L13", "6L13", "5L13"],
			flail: ["7L50", "6L50", "5L50"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			irondefense: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			naturepower: ["7M", "6M"],
			nightslash: ["5D"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockblast: ["7L5", "7L1", "6L1", "5L1"],
			rockpolish: ["7M", "7L19", "6M", "6L19", "5M", "5L19"],
			rockslide: ["7M", "7L29", "6M", "6L29", "5M", "5L29", "5D"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rockwrecker: ["7L55", "6L55", "5L55"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L11", "7L1", "6L1", "5L1"],
			sandstorm: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			shellsmash: ["7L43", "7L1", "6L1", "5L1"],
			slash: ["7L31", "6L31", "5L31"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "7L17", "6M", "6L17", "5M", "5L17"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stealthrock: ["7L24", "6T", "6L24", "5T", "5L24"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			withdraw: ["7L7", "7L1", "6L1", "5L1"],
			xscissor: ["7M", "7L38", "6M", "6L38", "5M", "5L38"],
		},
	},
	scraggy: {
		inherit: true,
		learnset: {
			amnesia: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "7L23", "6M", "6L20", "5M", "5L20"],
			bulkup: ["7M", "6M", "5M"],
			chipaway: ["7L27", "6L27", "5L27"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E"],
			crunch: ["7L38", "6L38", "5L38"],
			darkpulse: ["7M", "6M", "5T"],
			detect: ["7E", "6E", "5E"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dragonclaw: ["7M", "6M", "5M"],
			dragondance: ["7E", "6E", "5E"],
			dragonpulse: ["6T", "5T"],
			dragontail: ["7M", "6M", "5M"],
			drainpunch: ["7E", "6T", "6E", "5T", "5E", "5D"],
			dualchop: ["6T", "5T"],
			facade: ["7M", "7L42", "6M", "6L42", "5M", "5L42"],
			fakeout: ["7E", "6E", "5E", "5D"],
			feintattack: ["7L9", "7E", "6L9", "6E", "5L9", "5E"],
			firepunch: ["7E", "6T", "6E", "5T", "5E"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["7L48", "6T", "6L48", "5L49"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			headbutt: ["7L1", "6L12", "5L12", "5S0"],
			headsmash: ["7L50", "6L50", "5L53"],
			hiddenpower: ["7M", "6M", "5M"],
			highjumpkick: ["7L31", "6L31", "5L31", "5S0"],
			icepunch: ["7E", "6T", "6E", "5T", "5E"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T"],
			ironhead: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1", "5S0"],
			lowkick: ["7L16", "6T", "6L1", "5T", "5L1", "5S0", "5D"],
			lowsweep: ["7M", "6M", "5M"],
			payback: ["7M", "7L20", "6M", "6L23", "5M", "5L23"],
			poisonjab: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			quickguard: ["7E", "6E"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockclimb: ["7L45", "6L45", "5L45"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "6L5", "5L5"],
			scaryface: ["7L34", "6L34", "5L34"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superfang: ["6T", "5T"],
			swagger: ["7M", "7L12", "6M", "6L16", "5M", "5L16"],
			taunt: ["7M", "6M", "5M"],
			thunderpunch: ["7E", "6T", "6E", "5T", "5E"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["7E", "6T", "6E", "5T", "5E"],
		},
	},
	scrafty: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "7L23", "6M", "6L20", "5M", "5L20"],
			bulkup: ["7M", "6M", "5M"],
			chipaway: ["7L27", "6L27", "5L27"],
			confide: ["7M", "6M"],
			crunch: ["7L38", "6L38", "5L38"],
			darkpulse: ["7M", "6M", "5T"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dragonclaw: ["7M", "6M", "5M"],
			dragonpulse: ["6T", "5T"],
			dragontail: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T", "5S0"],
			dualchop: ["6T", "5T"],
			facade: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			feintattack: ["7L9", "7L1", "6L1", "5L1"],
			firepunch: ["6T", "5T", "5S0"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["7L58", "6T", "6L58", "5L58"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			headbutt: ["7L1", "6L12", "5L12"],
			headsmash: ["7L65", "6L65", "5L65"],
			hiddenpower: ["7M", "6M", "5M"],
			highjumpkick: ["7L31", "6L31", "5L31"],
			hyperbeam: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			irondefense: ["6T", "5T"],
			ironhead: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lowkick: ["7L16", "6T", "6L1", "5T", "5L1"],
			lowsweep: ["7M", "6M", "5M"],
			outrage: ["6T", "5T"],
			payback: ["7M", "7L20", "6M", "6L23", "5M", "5L23", "5S0"],
			poisonjab: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockclimb: ["7L51", "6L51", "5L51"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L5", "7L1", "6L1", "5L1"],
			scaryface: ["7L34", "6L34", "5L34"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M", "5S0"],
			sunnyday: ["7M", "6M", "5M"],
			superfang: ["6T", "5T"],
			swagger: ["7M", "7L12", "6M", "6L16", "5M", "5L16"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	sigilyph: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aircutter: ["7L21", "6L21", "5L21"],
			airslash: ["7L41", "6L41", "5L41"],
			ancientpower: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cosmicpower: ["7L48", "6L48", "5L48"],
			darkpulse: ["7M", "6M", "5T"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			futuresight: ["7E", "6E"],
			gravity: ["7L38", "6T", "6L38", "5T", "5L38"],
			gust: ["7L1", "6L1", "5L1"],
			heatwave: ["6T", "5T", "5D"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypnosis: ["7L4", "6L4", "5L4", "5D"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			lightscreen: ["7M", "7L24", "6M", "6L24", "5M", "5L24"],
			magiccoat: ["6T", "5T"],
			magicroom: ["6T", "5T"],
			miracleeye: ["7L1", "6L1", "5L1"],
			mirrormove: ["7L34", "6L34", "5L34"],
			pluck: ["5M"],
			protect: ["7M", "6M", "5M"],
			psybeam: ["7L18", "6L18", "5L18"],
			psychic: ["7M", "7L44", "6M", "6L44", "5M", "5L44"],
			psychoshift: ["7E", "6E", "5E"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "6M", "5M"],
			psywave: ["7L8", "6L8", "5L8"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["7E", "6T", "6E", "5T", "5E"],
			skyattack: ["7L50", "6T", "6L50", "5T", "5L51"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			steelwing: ["7M", "7E", "6M", "6E", "5E"],
			storedpower: ["7E", "6E", "5E", "5D"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			synchronoise: ["7L31", "6L31", "5L31"],
			tailwind: ["7L11", "6T", "6L11", "5T", "5L11"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			whirlwind: ["7L14", "6L14", "5L14"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	yamask: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			allyswitch: ["7E", "6E"],
			astonish: ["7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			curse: ["7L29", "6L29", "5L29"],
			darkpulse: ["7M", "6M", "5T"],
			destinybond: ["7L49", "6L49", "5L49"],
			disable: ["7L5", "7E", "6L5", "6E", "5L5", "5E"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			faketears: ["7E", "6E", "5E"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			grudge: ["7L41", "6L41", "5L41"],
			guardsplit: ["7L33", "6L33", "5L33"],
			haze: ["7L9", "6L9", "5L9"],
			healblock: ["7E", "6E", "5E"],
			hex: ["7L17", "6L17", "5L17"],
			hiddenpower: ["7M", "6M", "5M"],
			imprison: ["7E", "6E", "5E"],
			infestation: ["7M", "6M"],
			irondefense: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			magiccoat: ["6T", "5T"],
			meanlook: ["7L45", "6L45", "5L45"],
			memento: ["7E", "6E", "5E"],
			nastyplot: ["7E", "6E", "5E"],
			nightmare: ["7E", "6E", "5E"],
			nightshade: ["7L13", "6L13", "5L13"],
			ominouswind: ["7L25", "6L25", "5L25"],
			painsplit: ["6T", "5T"],
			payback: ["7M", "6M", "5M"],
			powersplit: ["7L33", "6L33", "5L33"],
			protect: ["7M", "7L1", "6M", "6L1", "5M", "5L1"],
			psychic: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "7L37", "6M", "6L37", "5M", "5L37"],
			shockwave: ["6T"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			toxicspikes: ["7E", "6E"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			willowisp: ["7M", "7L21", "6M", "6L21", "5M", "5L21"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T"],
		},
	},
	cofagrigus: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			astonish: ["7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			curse: ["7L29", "6L29", "5L29"],
			darkpulse: ["7M", "6M", "5T"],
			destinybond: ["7L57", "6L57", "5L57"],
			disable: ["7L5", "7L1", "6L1", "5L1"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			grudge: ["7L45", "6L45", "5L45"],
			guardsplit: ["7L33", "6L33", "5L33"],
			haze: ["7L9", "7L1", "6L1", "5L1"],
			hex: ["7L17", "6L17", "5L17"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			irondefense: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			magiccoat: ["6T", "5T"],
			meanlook: ["7L51", "6L51", "5L51"],
			nightshade: ["7L13", "6L13", "5L13"],
			ominouswind: ["7L25", "6L25", "5L25"],
			painsplit: ["6T", "5T"],
			payback: ["7M", "6M", "5M"],
			powersplit: ["7L33", "6L33", "5L33"],
			protect: ["7M", "7L1", "6M", "6L1", "5M", "5L1"],
			psychic: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			scaryface: ["7L1", "6L34", "5L34"],
			secretpower: ["6M"],
			shadowball: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			shockwave: ["6T"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			willowisp: ["7M", "7L21", "6M", "6L21", "5M", "5L21"],
			wonderroom: ["6T", "5T"],
			zenheadbutt: ["6T"],
		},
	},
	tirtouga: {
		inherit: true,
		learnset: {
			ancientpower: ["7L18", "6L18", "5L18"],
			aquajet: ["7L15", "6L15", "5L15", "5S0"],
			aquatail: ["7L41", "6T", "6L41", "5T", "5L41"],
			attract: ["7M", "6M", "5M"],
			bide: ["7L1", "7E", "6L1", "6E", "5L1", "5E"],
			bite: ["7L8", "6L8", "5L8", "5S0"],
			blizzard: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			bodyslam: ["7E", "6E", "5E", "5S0"],
			brine: ["7L28", "6L28", "5L28"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crunch: ["7L21", "6L21", "5L21"],
			curse: ["7L35", "6L35", "5L35"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flail: ["7E", "6E", "5E", "5D"],
			frustration: ["7M", "6M", "5M"],
			guardswap: ["7E", "6E"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L50", "6L50", "5L51"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			irondefense: ["7E", "6T", "6E", "5T", "5E", "5D"],
			irontail: ["6T", "5T"],
			knockoff: ["7E", "6T", "6E", "5E"],
			liquidation: ["7E"],
			protect: ["7M", "7L11", "6M", "6L11", "5M", "5L11", "5S0"],
			raindance: ["7M", "7L48", "6M", "6L48", "5M", "5L48"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["7E", "6E", "5E"],
			rocktomb: ["7M", "6M", "5M"],
			rollout: ["7L5", "6L5", "5L5", "5D"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shellsmash: ["7L38", "6L38", "5L38"],
			slam: ["7E", "6E", "5E"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "7L31", "6M", "6L31", "5M", "5L31"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M"],
			watergun: ["7L1", "6L1", "5L1"],
			waterpulse: ["7E", "6T", "6E", "5E"],
			whirlpool: ["7E", "6E", "5E"],
			wideguard: ["7L25", "6L25", "5L25"],
			withdraw: ["7L1", "6L1", "5L1"],
			zenheadbutt: ["6T"],
		},
	},
	carracosta: {
		inherit: true,
		learnset: {
			ancientpower: ["7L18", "6L18", "5L18"],
			aquajet: ["7L15", "6L15", "5L15"],
			aquatail: ["7L45", "6T", "6L45", "5T", "5L45"],
			attract: ["7M", "6M", "5M"],
			bide: ["7L1", "6L1", "5L1"],
			bite: ["7L8", "6L8", "5L8"],
			blizzard: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			brine: ["7L28", "6L28", "5L28"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crunch: ["7L21", "6L21", "5L21"],
			curse: ["7L35", "6L35", "5L35"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L61", "6L61", "5L61"],
			hyperbeam: ["7M", "6M", "5M"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			irondefense: ["6T", "5T"],
			ironhead: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T"],
			lowkick: ["6T", "5T"],
			protect: ["7M", "7L11", "6M", "6L11", "5M", "5L11"],
			raindance: ["7M", "7L56", "6M", "6L56", "5M", "5L56"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L51", "6M", "6L51", "5M", "5L51"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rollout: ["7L5", "7L1", "6L1", "5L1"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shellsmash: ["7L40", "6L40", "5L40"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "7L31", "6M", "6L31", "5M", "5L31"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M"],
			watergun: ["7L1", "6L1", "5L1"],
			waterpulse: ["6T"],
			wideguard: ["7L25", "6L25", "5L25"],
			withdraw: ["7L1", "6L1", "5L1"],
			zenheadbutt: ["6T"],
		},
	},
	archen: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			aerialace: ["7M", "6M", "5M"],
			agility: ["7L21", "6L21", "5L21"],
			allyswitch: ["7E", "6E"],
			ancientpower: ["7L18", "6L18", "5L18"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			bite: ["7E", "6E", "5E"],
			bounce: ["6T", "5T"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crunch: ["7L35", "6L35", "5L35"],
			cut: ["6M", "5M"],
			defog: ["7E", "6E", "5E"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "7L8", "6M", "6L8", "5M", "5L8", "5S0"],
			dragonbreath: ["7L31", "6L31", "5L31"],
			dragonclaw: ["7M", "7L48", "6M", "6L48", "5M", "5L48"],
			dragonpulse: ["7E", "6T", "6E", "5T", "5E"],
			earthpower: ["7E", "6T", "6E", "5T", "5E"],
			earthquake: ["7M", "6M", "5M"],
			endeavor: ["7L38", "6T", "6L38", "5T", "5L38"],
			facade: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			headsmash: ["7E", "6E", "5E", "5S0"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["7E", "6T", "6E", "5E"],
			leer: ["7L1", "6L1", "5L1"],
			pluck: ["7L15", "6L15", "5M", "5L15"],
			protect: ["7M", "6M", "5M"],
			quickattack: ["7L1", "6L1", "5L1"],
			quickguard: ["7L25", "6L25", "5L25"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["7L5", "6L5", "5L5"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			scaryface: ["7L11", "6L11", "5L11", "5S0"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E"],
			stoneedge: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			switcheroo: ["7E", "6E"],
			tailwind: ["6T", "5T"],
			taunt: ["7M", "6M", "5M"],
			thrash: ["7L50", "6L50", "5L51"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			wingattack: ["7L1", "6L1", "5L1", "5S0"],
			zenheadbutt: ["6T"],
		},
	},
	archeops: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			aerialace: ["7M", "6M", "5M"],
			agility: ["7L21", "6L21", "5L21"],
			ancientpower: ["7L18", "6L18", "5L18"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crunch: ["7L35", "6L35", "5L35"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "7L8", "6M", "6L8", "5M", "5L8"],
			dragonbreath: ["7L31", "6L31", "5L31"],
			dragonclaw: ["7M", "7L56", "6M", "6L56", "5M", "5L56"],
			dragonpulse: ["6T", "5T"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M"],
			endeavor: ["7L40", "6T", "6L40", "5T", "5L40"],
			facade: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			irondefense: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T"],
			leer: ["7L1", "6L1", "5L1"],
			outrage: ["6T", "5T"],
			pluck: ["7L15", "6L15", "5M", "5L15"],
			protect: ["7M", "6M", "5M"],
			quickattack: ["7L1", "6L1", "5L1"],
			quickguard: ["7L25", "6L25", "5L25"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L51", "6M", "6L51", "5M", "5L51"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["7L5", "7L1", "6L1", "5L1"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			scaryface: ["7L11", "6L11", "5L11"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			skyattack: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			stoneedge: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["6T", "5T"],
			taunt: ["7M", "6M", "5M"],
			thrash: ["7L61", "6L61", "5L61"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			wingattack: ["7L1", "6L1", "5L1"],
			zenheadbutt: ["6T"],
		},
	},
	trubbish: {
		inherit: true,
		learnset: {
			acidspray: ["7L12", "6L12", "5L12"],
			amnesia: ["7L40", "6L40", "5L40"],
			attract: ["7M", "6M", "5M"],
			belch: ["7L42", "6L42"],
			clearsmog: ["7L34", "6L34", "5L34"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E"],
			darkpulse: ["7M", "6M", "5T"],
			doubleslap: ["7L14", "6L14", "5L14"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T"],
			explosion: ["7M", "7L47", "6M", "6L47", "5M", "5L47"],
			facade: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			gunkshot: ["7L45", "6T", "6L45", "5T", "5L45"],
			haze: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			mudsport: ["7E", "6E", "5E"],
			painsplit: ["6T", "5T"],
			payback: ["7M", "6M", "5M"],
			poisongas: ["7L1", "6L1", "5L1"],
			pound: ["7L1", "6L1", "5L1"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			recycle: ["7L3", "6T", "6L3", "5T", "5L3"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockblast: ["7E", "6E", "5E"],
			rollout: ["7E", "6E", "5E"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			selfdestruct: ["7E", "6E", "5E"],
			sleeptalk: ["7M", "6M", "5T"],
			sludge: ["7L18", "6L18", "5L18"],
			sludgebomb: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			spikes: ["7E", "6E", "5E"],
			spite: ["6T", "5T"],
			stockpile: ["7L23", "6L23", "5L23"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swallow: ["7L23", "6L23", "5L23"],
			takedown: ["7L25", "6L25", "5L25"],
			thief: ["7M", "6M", "5M"],
			toxic: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			toxicspikes: ["7L7", "6L7", "5L7"],
			venoshock: ["7M", "6M", "5M"],
		},
	},
	garbodor: {
		inherit: true,
		learnset: {
			acidspray: ["7L12", "6L12", "5L12"],
			amnesia: ["7L46", "6L46", "5L46"],
			attract: ["7M", "6M", "5M"],
			belch: ["7L49", "6L49"],
			bodyslam: ["7L25", "6L25", "5L25"],
			clearsmog: ["7L34", "6L34", "5L34"],
			confide: ["7M", "6M"],
			darkpulse: ["7M", "6M", "5T"],
			doubleslap: ["7L14", "6L14", "5L14"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T"],
			explosion: ["7M", "7L59", "6M", "6L59", "5M", "5L59"],
			facade: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			gunkshot: ["7L54", "6T", "6L54", "5T", "5L54"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			painsplit: ["6T", "5T"],
			payback: ["7M", "6M", "5M"],
			poisongas: ["7L1", "6L1", "5L1"],
			pound: ["7L1", "6L1", "5L1"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			recycle: ["7L3", "7L1", "6T", "6L1", "5T", "5L1"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			sludge: ["7L18", "6L18", "5L18"],
			sludgebomb: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			sludgewave: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			spite: ["6T", "5T"],
			stockpile: ["7L23", "6L23", "5L23"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swallow: ["7L23", "6L23", "5L23"],
			thief: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			toxic: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			toxicspikes: ["7L7", "7L1", "6L1", "5L1"],
			venoshock: ["7M", "6M", "5M"],
		},
	},
	zorua: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			agility: ["7L37", "6L37", "5L37"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M"],
			captivate: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			copycat: ["7E", "6E"],
			counter: ["7E", "6E", "5E"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "7E", "6M", "6E", "5T", "5E"],
			detect: ["7E", "6E", "5E"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			embargo: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			extrasensory: ["7E", "6E", "5E"],
			facade: ["7M", "6M", "5M"],
			faketears: ["7L9", "6L9", "5L9"],
			feintattack: ["7L17", "6L17", "5L17"],
			fling: ["7M", "6M", "5M"],
			foulplay: ["7L29", "6T", "6L29", "5T", "5L29"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L13", "6L13", "5L13"],
			grassknot: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hypervoice: ["6T", "5T"],
			imprison: ["7L53", "6L53", "5L53"],
			incinerate: ["6M", "5M"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			memento: ["7E", "6E", "5E"],
			nastyplot: ["7L49", "6L49", "5L49"],
			nightdaze: ["7L57", "6L57", "5L57"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			punishment: ["7L45", "6L45", "5L45"],
			pursuit: ["7L5", "6L5", "5L5"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L21", "6L21", "5L21"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["7E", "6T", "6E", "5T", "5E"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["7E", "6E", "5E"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			taunt: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			thief: ["7M", "6M", "5M"],
			torment: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
		},
	},
	zoroark: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			agility: ["7L39", "6L39", "5L39", "5S0"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "6M", "6S1", "5T"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			embargo: ["7M", "7L44", "6M", "6L44", "5M", "5L44", "5S0"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7L17", "6L17", "5L17"],
			flamethrower: ["7M", "6M", "6S1", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			foulplay: ["7L29", "6T", "6L29", "5T", "5L29"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L13", "6L13", "5L13"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["7L9", "7L1", "6M", "6L1", "5M", "5L1"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["6T", "5T"],
			imprison: ["7L59", "7L1", "6L1", "5L59"],
			incinerate: ["6M", "5M"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			nastyplot: ["7L54", "6L54", "5L54"],
			nightdaze: ["7L64", "7L1", "6L1", "5L64"],
			nightslash: ["7L1", "6L30", "5L30"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			punishment: ["7L49", "6L49", "5L49", "5S0"],
			pursuit: ["7L5", "7L1", "6L1", "5L1"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L21", "6L21", "5L21"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["6S1"],
			snarl: ["7M", "6M", "5M", "5S0"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["6S1"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			taunt: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			thief: ["7M", "6M", "5M"],
			torment: ["7M", "7L34", "6M", "6L34", "5M", "5L34"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "7L1", "6M", "6L1", "5M", "5L1"],
		},
	},
	minccino: {
		inherit: true,
		learnset: {
			afteryou: ["7L49", "6T", "6L49", "5T", "5L49"],
			aquatail: ["7E", "6T", "6E", "5T", "5E"],
			attract: ["7M", "6M", "5M"],
			babydolleyes: ["7L3", "6L3"],
			calmmind: ["7M", "6M", "5M"],
			captivate: ["7L39", "6L39", "5L39"],
			charm: ["7L27", "6L27", "5L27"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			dig: ["6M", "5M"],
			doubleslap: ["7L13", "6L13", "5L13"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "7L33", "6M", "6L33", "5M", "5L33"],
			encore: ["7L15", "6L15", "5L15"],
			endure: ["7E", "6E", "5E"],
			facade: ["7M", "6M", "5M"],
			faketears: ["7E", "6E", "5E"],
			flail: ["7E", "6E", "5E"],
			fling: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			growl: ["5L3"],
			gunkshot: ["6T", "5T"],
			helpinghand: ["7L7", "6T", "6L7", "5T", "5L7"],
			hiddenpower: ["7M", "6M", "5M"],
			hypervoice: ["7L43", "6T", "6L43", "5T", "5L43"],
			irontail: ["7E", "6T", "6E", "5T", "5E"],
			knockoff: ["7E", "6T", "6E", "5T", "5E"],
			lastresort: ["7L45", "6T", "6L45", "5T", "5L45"],
			mudslap: ["7E", "6E", "5E"],
			pound: ["7L1", "6L1", "5L1"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			shockwave: ["6T"],
			sing: ["7L21", "6L21", "5L21"],
			slam: ["7L37", "6L37", "5L37"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swift: ["7L19", "6L19", "5L19"],
			tailslap: ["7L25", "6L25", "5L25"],
			tailwhip: ["7E", "6E", "5E"],
			thief: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			tickle: ["7L9", "6L9", "5L9"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
			wakeupslap: ["7L31", "6L31", "5L31"],
			workup: ["7M", "5M"],
		},
	},
	cinccino: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			bulletseed: ["7L1", "6L1", "5L1"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gunkshot: ["6T", "5T"],
			helpinghand: ["7L1", "6T", "6L1", "5T", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["6T", "5T"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			lastresort: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockblast: ["7L1", "6L1", "5L1"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			shockwave: ["6T"],
			sing: ["7L1", "6L1", "5L1"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailslap: ["7L1", "6L1", "5L1"],
			thief: ["7M", "6M", "5M"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			tickle: ["7L1", "6L1", "5L1"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
		},
	},
	gothita: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			captivate: ["7E", "6E", "5E"],
			chargebeam: ["7M", "6M", "5M"],
			charm: ["7L46", "6L46", "5L46"],
			confide: ["7M", "6M"],
			confusion: ["7L3", "6L3", "5L3"],
			covet: ["6T", "5T"],
			darkpulse: ["7M", "7E", "6M", "6E", "5E"],
			doubleslap: ["7L14", "6L14", "5L14"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "7L19", "6M", "6L19", "5M", "5L19"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			faketears: ["7L10", "6L10", "5L10"],
			feintattack: ["7L24", "6L24", "5L24"],
			flash: ["6M", "5M"],
			flatter: ["7L28", "6L28", "5L28"],
			fling: ["7M", "6M", "5M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			futuresight: ["7L31", "6L31", "5L31"],
			grassknot: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			healbell: ["6T", "5T"],
			healblock: ["7L33", "6L33", "5L33"],
			healpulse: ["7E", "6E"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			magicroom: ["7L48", "6T", "6L48", "5T", "5L48"],
			meanlook: ["7E", "6E", "5E"],
			miracleeye: ["7E", "6E", "5E"],
			mirrorcoat: ["7E", "6E", "5E"],
			payback: ["7M", "6M", "5M"],
			playnice: ["7L8", "6L8"],
			pound: ["7L1", "6L1", "5L1"],
			protect: ["7M", "6M", "5M"],
			psybeam: ["7L16", "6L16", "5L16"],
			psychic: ["7M", "7L37", "6M", "6L37", "5M", "5L37"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			raindance: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			telekinesis: ["7L40", "6L40", "5M", "5L40"],
			thief: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			tickle: ["7L7", "6L7", "5L7"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			uproar: ["7E", "6T", "6E", "5T", "5E"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	gothorita: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			chargebeam: ["7M", "6M", "5M"],
			charm: ["7L50", "6L50", "5L50"],
			confide: ["7M", "6M"],
			confusion: ["7L3", "7L1", "6L1", "5L1"],
			covet: ["6T", "5T"],
			darkpulse: ["7M", "6M"],
			doubleslap: ["7L14", "6L14", "5L14"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "7L19", "6M", "6L19", "5M", "5L19"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			faketears: ["7L10", "6L10", "5L1"],
			feintattack: ["7L24", "6L24", "5L24"],
			flash: ["6M", "5M"],
			flatter: ["7L28", "6L28", "5L28", "5S0", "5S1"],
			fling: ["7M", "6M", "5M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			futuresight: ["7L31", "6L31", "5L31", "5S0", "5S1"],
			grassknot: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			healbell: ["6T", "5T"],
			healblock: ["7L34", "6L34", "5L34"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			imprison: ["5S1"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			magicroom: ["7L53", "6T", "6L53", "5T", "5L53"],
			mirrorcoat: ["5S0"],
			payback: ["7M", "6M", "5M"],
			playnice: ["7L1", "6L1"],
			pound: ["7L1", "6L1", "5L1"],
			protect: ["7M", "6M", "5M"],
			psybeam: ["7L16", "6L16", "5L16"],
			psychic: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "5S0", "5S1"],
			raindance: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			telekinesis: ["7L43", "6L43", "5M", "5L43"],
			thief: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			tickle: ["7L7", "7L1", "6L1", "5L1"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	gothitelle: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			chargebeam: ["7M", "6M", "5M"],
			charm: ["7L54", "6L54", "5L54"],
			confide: ["7M", "6M"],
			confusion: ["7L3", "7L1", "6L1", "5L1"],
			covet: ["6T", "5T"],
			darkpulse: ["7M", "6M"],
			doubleslap: ["7L14", "6L14", "5L14"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "7L19", "6M", "6L19", "5M", "5L19"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			faketears: ["7L10", "6L10", "5L1"],
			feintattack: ["7L24", "6L24", "5L24"],
			flash: ["6M", "5M"],
			flatter: ["7L28", "6L28", "5L28"],
			fling: ["7M", "6M", "5M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			futuresight: ["7L31", "6L31", "5L31"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			healbell: ["6T", "5T"],
			healblock: ["7L34", "6L34", "5L34"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			lightscreen: ["7M", "6M", "5M"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			magicroom: ["7L59", "6T", "6L59", "5T", "5L59"],
			payback: ["7M", "6M", "5M"],
			playnice: ["7L1", "6L1"],
			pound: ["7L1", "6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psybeam: ["7L16", "6L16", "5L16"],
			psychic: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			raindance: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			telekinesis: ["7L45", "6L45", "5M", "5L45"],
			thief: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			tickle: ["7L7", "7L1", "6L1", "5L1"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	solosis: {
		inherit: true,
		learnset: {
			acidarmor: ["7E", "6E", "5E"],
			afteryou: ["6T", "5T"],
			astonish: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			charm: ["7L19", "6L19", "5L19"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			endeavor: ["7L28", "6T", "6L28", "5T", "5L28"],
			energyball: ["7M", "6M", "5M"],
			explosion: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			futuresight: ["7L31", "6L31", "5L31"],
			gravity: ["6T", "5T"],
			gyroball: ["7M", "6M", "5M"],
			healblock: ["7L46", "6L46", "5L46"],
			helpinghand: ["7E", "6T", "6E"],
			hiddenpower: ["7M", "7L14", "6M", "6L14", "5M", "5L14"],
			imprison: ["7E", "6E", "5E"],
			infestation: ["7M", "6M"],
			irondefense: ["6T"],
			lightscreen: ["7M", "7L16", "6M", "6L16", "5M", "5L16"],
			magiccoat: ["6T", "5T"],
			nightshade: ["7E", "6E", "5E"],
			painsplit: ["7L33", "6T", "6L33", "5T", "5L33"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "7L37", "6M", "6L37", "5M", "5L37"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			psywave: ["7L1", "6L1", "5L1"],
			raindance: ["7M", "6M", "5M"],
			recover: ["7L24", "6L24", "5L24"],
			reflect: ["7M", "7L3", "6M", "6L3", "5M", "5L3"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			rollout: ["7L7", "6L7", "5L7"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["7E", "6M", "6E", "5E"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["7L40", "6T", "6L40", "5T", "5L40"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["7L10", "6T", "6L10", "5T", "5L10"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["7E", "6T", "6E", "5T", "5E"],
			trickroom: ["7M", "6M", "5M"],
			wonderroom: ["7L48", "6T", "6L48", "5T", "5L48"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	duosion: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			charm: ["7L19", "6L19", "5L19"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			endeavor: ["7L28", "6T", "6L28", "5T", "5L28"],
			energyball: ["7M", "6M", "5M"],
			explosion: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			futuresight: ["7L31", "6L31", "5L31"],
			gravity: ["6T", "5T"],
			gyroball: ["7M", "6M", "5M"],
			healblock: ["7L50", "6L50", "5L50"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "7L14", "6M", "6L14", "5M", "5L14"],
			imprison: ["5D"],
			infestation: ["7M", "6M"],
			irondefense: ["6T"],
			lightscreen: ["7M", "7L16", "6M", "6L16", "5M", "5L16"],
			magiccoat: ["6T", "5T"],
			painsplit: ["7L34", "6T", "6L34", "5T", "5L34"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			psywave: ["7L1", "6L1", "5L1"],
			raindance: ["7M", "6M", "5M"],
			recover: ["7L24", "6L24", "5L24", "5D"],
			reflect: ["7M", "7L3", "7L1", "6M", "6L1", "5M", "5L1"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			rollout: ["7L7", "7L1", "6L1", "5L1"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["7L43", "6T", "6L43", "5T", "5L43"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["7L10", "7L1", "6T", "6L1", "5T", "5L1"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T", "5D"],
			trickroom: ["7M", "6M", "5M"],
			wonderroom: ["7L53", "6T", "6L53", "5T", "5L53"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	reuniclus: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			charm: ["7L19", "6L19", "5L19"],
			confide: ["7M", "6M"],
			dizzypunch: ["7L1", "6L41", "5L41"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			endeavor: ["7L28", "6T", "6L28", "5T", "5L28"],
			energyball: ["7M", "6M", "5M"],
			explosion: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			futuresight: ["7L31", "6L31", "5L31"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			gyroball: ["7M", "6M", "5M"],
			healblock: ["7L54", "6L54", "5L54"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "7L14", "6M", "6L14", "5M", "5L14"],
			hyperbeam: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			infestation: ["7M", "6M"],
			irondefense: ["6T"],
			knockoff: ["6T", "5T"],
			lightscreen: ["7M", "7L16", "6M", "6L16", "5M", "5L16"],
			magiccoat: ["6T", "5T"],
			painsplit: ["7L34", "6T", "6L34", "5T", "5L34"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			psywave: ["7L1", "6L1", "5L1"],
			raindance: ["7M", "6M", "5M"],
			recover: ["7L24", "6L24", "5L24"],
			reflect: ["7M", "7L3", "7L1", "6M", "6L1", "5M", "5L1"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			rollout: ["7L7", "7L1", "6L1", "5L1"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			skillswap: ["7L45", "6T", "6L45", "5T", "5L45"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["7L10", "7L1", "6T", "6L1", "5T", "5L1"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			wonderroom: ["7L59", "6T", "6L59", "5T", "5L59"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	ducklett: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L15", "6M", "6L15", "5M", "5L15"],
			aircutter: ["7E", "6E", "5E"],
			airslash: ["7L27", "6L27", "5L27"],
			aquaring: ["7L24", "6L24", "5L24"],
			attract: ["7M", "6M", "5M"],
			bravebird: ["7L41", "6L41", "5L41"],
			brine: ["7E", "6E", "5E", "5D"],
			bubblebeam: ["7L19", "6L19", "5L19"],
			confide: ["7M", "6M"],
			defog: ["7L6", "6L6", "5L6", "5D"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			featherdance: ["7L21", "6L21", "5L21"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gust: ["7E", "6E", "5E"],
			hail: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			hurricane: ["7L46", "6L46", "5L46"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			luckychant: ["7E", "6E", "5E"],
			mefirst: ["7E", "6E", "5E", "5D"],
			mirrormove: ["7E", "6E", "5E"],
			mudsport: ["7E", "6E"],
			pluck: ["5M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "7L34", "6M", "6L34", "5M", "5L34"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roost: ["7M", "7L30", "6M", "6L30", "5T", "5L30"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E"],
			substitute: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["7L37", "6T", "6L37", "5T", "5L37"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			watergun: ["7L1", "6L1", "5L1"],
			waterpulse: ["7L13", "6T", "6L13", "5L13"],
			watersport: ["7L3", "6L3", "5L3"],
			wingattack: ["7L9", "6L9", "5L9"],
		},
	},
	swanna: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L15", "6M", "6L15", "5M", "5L15"],
			airslash: ["7L27", "6L27", "5L27"],
			aquaring: ["7L24", "6L24", "5L24"],
			attract: ["7M", "6M", "5M"],
			bravebird: ["7L47", "6L47", "5L47"],
			bubblebeam: ["7L19", "6L19", "5L19"],
			confide: ["7M", "6M"],
			defog: ["7L6", "7L1", "6L1", "5L1"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			featherdance: ["7L21", "6L21", "5L21"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			hurricane: ["7L55", "6L55", "5L55"],
			hyperbeam: ["7M", "6M", "5M"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			pluck: ["5M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "7L34", "6M", "6L34", "5M", "5L34"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roost: ["7M", "7L30", "6M", "6L30", "5T", "5L30"],
			round: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			skyattack: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			substitute: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["7L40", "6T", "6L40", "5T", "5L40"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			watergun: ["7L1", "6L1", "5L1"],
			waterpulse: ["7L13", "6T", "6L13", "5L13"],
			watersport: ["7L3", "7L1", "6L1", "5L1"],
			wingattack: ["7L9", "7L1", "6L1", "5L1"],
		},
	},
	vanillite: {
		inherit: true,
		learnset: {
			acidarmor: ["7L31", "6L31", "5L31"],
			astonish: ["7L7", "6L7", "5L7"],
			attract: ["7M", "6M", "5M"],
			autotomize: ["7E", "6E", "5E"],
			avalanche: ["7L19", "6L19", "5L19"],
			blizzard: ["7M", "7L49", "6M", "6L49", "5M", "5L49"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			explosion: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			hail: ["7M", "7L40", "6M", "6L40", "5M", "5L40"],
			harden: ["7L4", "6L4", "5L4"],
			hiddenpower: ["7M", "6M", "5M"],
			icebeam: ["7M", "7L35", "6M", "6L35", "5M", "5L35"],
			iceshard: ["7E", "6E", "5E"],
			iciclespear: ["7L1", "6L1", "5L1"],
			icywind: ["7L13", "6T", "6L13", "5T", "5L13"],
			imprison: ["7E", "6E", "5E"],
			irondefense: ["7E", "6T", "6E", "5T", "5E"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			magnetrise: ["7E", "6T", "6E", "5T", "5E"],
			mirrorcoat: ["7L44", "6L44", "5L44"],
			mirrorshot: ["7L26", "6L26", "5L26"],
			mist: ["7L16", "6L16", "5L16"],
			naturalgift: ["7E", "6E", "5E"],
			powdersnow: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sheercold: ["7L53", "6L53", "5L53"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7L10", "6T", "6L10", "5T", "5L10"],
			waterpulse: ["7E", "6T", "6E", "5E"],
		},
	},
	vanillish: {
		inherit: true,
		learnset: {
			acidarmor: ["7L31", "6L31", "5L31"],
			astonish: ["7L7", "7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			avalanche: ["7L19", "6L19", "5L19"],
			blizzard: ["7M", "7L53", "6M", "6L53", "5M", "5L53"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			explosion: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			hail: ["7M", "7L42", "6M", "6L42", "5M", "5L42"],
			harden: ["7L4", "7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			icebeam: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			iceshard: ["5D"],
			iciclespear: ["7L1", "6L1", "5L1"],
			icywind: ["7L13", "6T", "6L13", "5T", "5L13"],
			imprison: ["5D"],
			irondefense: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			magnetrise: ["6T", "5T"],
			mirrorcoat: ["7L47", "6L47", "5L47"],
			mirrorshot: ["7L26", "6L26", "5L26", "5D"],
			mist: ["7L16", "6L16", "5L16"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sheercold: ["7L58", "6L58", "5L58"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7L10", "7L1", "6T", "6L1", "5T", "5L1"],
			waterpulse: ["6T"],
		},
	},
	vanilluxe: {
		inherit: true,
		learnset: {
			acidarmor: ["7L31", "6L31", "5L31"],
			astonish: ["7L7", "7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			avalanche: ["7L19", "6L19", "5L19"],
			blizzard: ["7M", "7L59", "6M", "6L59", "5M", "5L59"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			explosion: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			freezedry: ["7L1", "6L1"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			hail: ["7M", "7L42", "6M", "6L42", "5M", "5L42"],
			harden: ["7L4", "7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			icebeam: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			iciclespear: ["7L1", "6L1", "5L1"],
			icywind: ["7L13", "6T", "6L13", "5T", "5L13"],
			irondefense: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			magnetrise: ["6T", "5T"],
			mirrorcoat: ["7L50", "6L50", "5L50"],
			mirrorshot: ["7L26", "6L26", "5L26"],
			mist: ["7L16", "6L16", "5L16"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sheercold: ["7L67", "7L1", "6L1", "5L67"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7L10", "7L1", "6T", "6L1", "5T", "5L1"],
			waterpulse: ["6T"],
			weatherball: ["7L1", "6L1", "5L1"],
		},
	},
	deerling: {
		inherit: true,
		learnset: {
			agility: ["7E", "6E", "5E"],
			aromatherapy: ["7L28", "6L28", "5L28", "5S0"],
			attract: ["7M", "6M", "5M"],
			batonpass: ["7E", "6E", "5E"],
			bounce: ["6T", "5T"],
			camouflage: ["7L1", "6L1", "5L1"],
			charm: ["7L36", "6L36", "5L36"],
			confide: ["7M", "6M"],
			doubleedge: ["7L46", "6L46", "5L46"],
			doublekick: ["7L10", "6L10", "5L10"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			energyball: ["7M", "7L32", "6M", "6L32", "5M", "5L32"],
			facade: ["7M", "6M", "5M"],
			faketears: ["7E", "6E", "5E"],
			feintattack: ["7L16", "6L16", "5L16", "5S0"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			grassknot: ["7M", "6M", "5M"],
			grasswhistle: ["7E", "6E", "5E"],
			growl: ["7L4", "6L4", "5L4"],
			hiddenpower: ["7M", "6M", "5M"],
			jumpkick: ["7L24", "6L24", "5L24", "5S0"],
			lastresort: ["6T", "5T"],
			leechseed: ["7L13", "6L13", "5L13"],
			lightscreen: ["7M", "6M", "5M"],
			naturalgift: ["7E", "6E", "5E"],
			naturepower: ["7M", "7L41", "6M", "6L41", "5L41"],
			odorsleuth: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			sandattack: ["7L7", "6L7", "5L7"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			shadowball: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "7L51", "6M", "6L51", "5M", "5L51"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			synthesis: ["7E", "6T", "6E", "5T", "5E"],
			tackle: ["7L1", "6L1", "5L1"],
			takedown: ["7L20", "6L20", "5L20", "5S0"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			worryseed: ["7E", "6T", "6E", "5T", "5E"],
		},
	},
	sawsbuck: {
		inherit: true,
		learnset: {
			aromatherapy: ["7L28", "6L28", "5L28"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			camouflage: ["7L1", "6L1", "5L1"],
			charm: ["7L36", "6L36", "5L36"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleedge: ["7L52", "6L52", "5L52"],
			doublekick: ["7L10", "6L10", "5L10"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			energyball: ["7M", "7L32", "6M", "6L32", "5M", "5L32"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7L16", "6L16", "5L16"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			growl: ["7L4", "7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			hornleech: ["7L1", "6L37", "5L37"],
			hyperbeam: ["7M", "6M", "5M"],
			jumpkick: ["7L24", "6L24", "5L24"],
			lastresort: ["6T", "5T"],
			leechseed: ["7L13", "6L13", "5L13"],
			lightscreen: ["7M", "6M", "5M"],
			megahorn: ["7L1", "6L1", "5L1"],
			naturepower: ["7M", "7L44", "6M", "6L44", "5L44"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			sandattack: ["7L7", "7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			shadowball: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "7L60", "6M", "6L60", "5M", "5L60"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			synthesis: ["6T", "5T"],
			tackle: ["7L1", "6L1", "5L1"],
			takedown: ["7L20", "6L20", "5L20"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			worryseed: ["6T", "5T"],
		},
	},
	emolga: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L30", "6M", "6L30", "5M", "5L30"],
			aerialace: ["7M", "6M", "5M"],
			agility: ["7L46", "6L46", "5L46"],
			airslash: ["7E", "6E", "5E", "5D"],
			astonish: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			batonpass: ["7E", "6E", "5E"],
			charge: ["7L10", "6L10", "5L10"],
			chargebeam: ["7M", "6M", "5M"],
			charm: ["7E", "6E", "5E", "5D"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E", "5T", "5E"],
			cut: ["6M", "5M"],
			discharge: ["7L50", "6L50", "5L50"],
			doubleteam: ["7M", "7L19", "6M", "6L19", "5M", "5L19"],
			electroball: ["7L26", "6L26", "5L26"],
			electroweb: ["6T"],
			encore: ["7L38", "6L38", "5L38"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			fling: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			iondeluge: ["7E", "6E"],
			irontail: ["7E", "6T", "6E", "5T", "5E"],
			knockoff: ["6T", "5T"],
			lastresort: ["6T", "5T"],
			lightscreen: ["7M", "7L34", "6M", "6L34", "5M", "5L34"],
			nuzzle: ["7L15", "6L15"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7L16", "6L16", "5L16"],
			quickattack: ["7L4", "6L4", "5L4", "5D"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shockwave: ["7L22", "7E", "6T", "6L22", "6E", "5L22", "5E"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			spark: ["7L13", "6L13", "5L13"],
			speedswap: ["7E"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwhip: ["7L7", "6L7", "5L7"],
			tailwind: ["6T", "5T"],
			taunt: ["7M", "6M", "5M"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thundershock: ["7L1", "6L1", "5L1"],
			thunderwave: ["7M", "6M", "5M"],
			tickle: ["7E", "6E", "5E"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "5M"],
			voltswitch: ["7M", "7L42", "6M", "6L42", "5M", "5L42"],
			wildcharge: ["7M", "6M", "5M"],
		},
	},
	karrablast: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			attract: ["7M", "6M", "5M"],
			bugbite: ["7E", "6T", "6E", "5T", "5E", "5D"],
			bugbuzz: ["7L28", "6L28", "5L28", "5S0"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E"],
			cut: ["6M", "5M"],
			doubleedge: ["7L56", "6L56", "5L56"],
			doubleteam: ["7M", "6M", "5M"],
			drillrun: ["7E", "6T", "6E"],
			endure: ["7L8", "6L8", "5L8", "5D"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "7L25", "6M", "6L25", "5M", "5L25", "5S0"],
			feintattack: ["7E", "6E", "5E"],
			flail: ["7L49", "6L49", "5L49", "5S1"],
			frustration: ["7M", "6M", "5M"],
			furyattack: ["7L16", "6L16", "5L16", "5S0"],
			furycutter: ["7L13", "6L13", "5L13"],
			gigadrain: ["6T", "5T"],
			headbutt: ["7L20", "6L20", "5L20", "5S0"],
			hiddenpower: ["7M", "6M", "5M"],
			hornattack: ["7E", "6E", "5E"],
			infestation: ["7M", "6M"],
			irondefense: ["6T", "5T"],
			knockoff: ["7E", "6T", "6E", "5T", "5E"],
			leer: ["7L4", "6L4", "5L4"],
			megahorn: ["7E", "6E", "5E", "5S1", "5D"],
			peck: ["7L1", "6L1", "5L1"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L40", "6L40", "5L40"],
			screech: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			signalbeam: ["6T"],
			slash: ["7L32", "6L32", "5L32"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L52", "6M", "6L52", "5M", "5L52"],
			takedown: ["7L37", "6L37", "5L37", "5S1"],
			toxic: ["7M", "6M", "5M"],
			xscissor: ["7M", "7L44", "6M", "6L44", "5M", "5L44", "5S1"],
		},
	},
	escavalier: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			attract: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bugbite: ["6T", "5T"],
			bugbuzz: ["7L28", "6L28", "5L28"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleedge: ["7L1", "6L1"],
			doubleteam: ["7M", "6M", "5M"],
			drillrun: ["6T"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			fellstinger: ["7L60", "7L1", "6L1"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furyattack: ["7L16", "6L16", "5L16"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "7L56", "6M", "6L56", "5M", "5L56"],
			headbutt: ["7L20", "6L20", "5L20"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			irondefense: ["7L40", "6T", "6L40", "5T", "5L40"],
			ironhead: ["7L37", "6T", "6L37", "5T", "5L37"],
			knockoff: ["6T", "5T"],
			leer: ["7L4", "7L1", "6L1", "5L1"],
			peck: ["7L1", "6L1", "5L1"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			quickguard: ["7L8", "7L1", "6L1", "5L1"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			reversal: ["7L49", "6L49", "5L49"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			signalbeam: ["6T"],
			slash: ["7L32", "6L32", "5L32"],
			sleeptalk: ["7M", "6M", "5T"],
			smartstrike: ["7M"],
			snore: ["6T", "5T"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L52", "6M", "6L52", "5M", "5L52"],
			toxic: ["7M", "6M", "5M"],
			twineedle: ["7L13", "7L1", "6L1", "5L1"],
			xscissor: ["7M", "7L44", "6M", "6L44", "5M", "5L44"],
		},
	},
	foongus: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1"],
			afteryou: ["6T", "5T"],
			astonish: ["7L8", "6L8", "5L8"],
			attract: ["7M", "6M", "5M"],
			bide: ["7L12", "6L12", "5L12"],
			bodyslam: ["7E", "6E", "5E"],
			clearsmog: ["7L39", "6L39", "5L39"],
			confide: ["7M", "6M"],
			defensecurl: ["7E", "6E", "5E"],
			doubleteam: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7L20", "6L20", "5L20"],
			flash: ["6M", "5M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["7E", "6T", "6E", "5T", "5E"],
			gigadrain: ["7L28", "6T", "6L28", "5T", "5L28"],
			grassknot: ["7M", "6M", "5M"],
			growth: ["7L6", "7E", "6L6", "6E", "5L6", "5E"],
			hiddenpower: ["7M", "6M", "5M"],
			ingrain: ["7L18", "6L18", "5L18"],
			megadrain: ["7L15", "6L15", "5L15"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M", "5M"],
			poisonpowder: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M"],
			ragepowder: ["7L45", "6L45", "5L45"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rollout: ["7E", "6E", "5E"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "7L43", "6M", "6L43", "5M", "5L43"],
			spore: ["7L50", "6L50", "5L50"],
			stunspore: ["7E", "6E", "5E"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			sweetscent: ["7L24", "6L24", "5L24"],
			synthesis: ["7L35", "6T", "6L35", "5T", "5L35"],
			toxic: ["7M", "7L32", "6M", "6L32", "5M", "5L32"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T"],
		},
	},
	amoonguss: {
		inherit: true,
		learnset: {
			absorb: ["7L1", "6L1", "5L1"],
			afteryou: ["6T", "5T"],
			astonish: ["7L8", "7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			bide: ["7L12", "7L1", "6L1", "5L1"],
			clearsmog: ["7L43", "6L43", "5L43"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7L20", "6L20", "5L20"],
			flash: ["6M", "5M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["6T", "5T"],
			gigadrain: ["7L28", "6T", "6L28", "5T", "5L28"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			growth: ["7L6", "7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			ingrain: ["7L18", "6L18", "5L18"],
			megadrain: ["7L15", "6L15", "5L15"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			ragepowder: ["7L54", "6L54", "5L54"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "7L49", "6M", "6L49", "5M", "5L49"],
			spore: ["7L62", "6L62", "5L62"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			sweetscent: ["7L24", "6L24", "5L24"],
			synthesis: ["7L35", "6T", "6L35", "5T", "5L35"],
			toxic: ["7M", "7L32", "6M", "6L32", "5M", "5L32"],
			venoshock: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T"],
		},
	},
	frillish: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "6L5", "5L5"],
			acidarmor: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "6M", "5M"],
			brine: ["7L32", "6L32", "5L32"],
			bubble: ["7L1", "6L1", "5L1"],
			bubblebeam: ["7L13", "6L13", "5L13"],
			confide: ["7M", "6M"],
			confuseray: ["7E", "6E", "5E"],
			constrict: ["7E", "6E", "5E"],
			darkpulse: ["7M", "6M", "5T"],
			dazzlinggleam: ["7M", "6M"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			hail: ["7M", "6M", "5M"],
			hex: ["7L43", "6L43", "5L43"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L49", "6L49", "5L49"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			magiccoat: ["6T", "5T"],
			mist: ["7E", "6E", "5E"],
			nightshade: ["7L9", "6L9", "5L9"],
			ominouswind: ["7L27", "6L27", "5L27"],
			painsplit: ["7E", "6T", "6E", "5T", "5E"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			raindance: ["7M", "7L37", "6M", "6L37", "5M", "5L37"],
			recover: ["7L17", "7E", "6L17", "6E", "5L17", "5E"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M"],
			waterpulse: ["7L22", "6T", "6L22", "5L22"],
			watersport: ["7L1", "6L1", "5L1"],
			waterspout: ["7L61", "6L61", "5L61"],
			willowisp: ["7M", "6M", "5M"],
			wringout: ["7L55", "6L55", "5L55"],
		},
	},
	jellicent: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			bind: ["6T", "5T"],
			blizzard: ["7M", "6M", "5M"],
			brine: ["7L32", "6L32", "5L32", "5S0"],
			bubble: ["7L1", "6L1", "5L1"],
			bubblebeam: ["7L13", "6L13", "5L13"],
			confide: ["7M", "6M"],
			darkpulse: ["7M", "6M", "5T"],
			dazzlinggleam: ["7M", "6M"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			hex: ["7L45", "6L45", "5L45"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L53", "6L53", "5L53"],
			hyperbeam: ["7M", "6M", "5M"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			magiccoat: ["6T", "5T"],
			nightshade: ["7L9", "7L1", "6L1", "5L1"],
			ominouswind: ["7L27", "6L27", "5L27", "5S0"],
			painsplit: ["6T", "5T"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			raindance: ["7M", "7L37", "6M", "6L37", "5M", "5L37", "5S0"],
			recover: ["7L17", "6L17", "5L17"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			waterfall: ["7M", "6M", "5M"],
			waterpulse: ["7L22", "6T", "6L22", "5L22", "5S0"],
			watersport: ["7L1", "6L1", "5L1"],
			waterspout: ["7L69", "7L1", "6L1", "5L69"],
			willowisp: ["7M", "6M", "5M"],
			wringout: ["7L61", "7L1", "6L1", "5L61"],
		},
	},
	alomomola: {
		inherit: true,
		learnset: {
			aquajet: ["7L9", "6L9", "5L9"],
			aquaring: ["7L5", "6L5", "5L5", "5D"],
			attract: ["7M", "6M", "5M"],
			blizzard: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			brine: ["7L41", "6L41", "5L41"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			dive: ["6M", "5M"],
			doubleslap: ["7L13", "6L13", "5L13"],
			doubleteam: ["7M", "6M", "5M"],
			endure: ["7E", "6E", "5E"],
			facade: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			healingwish: ["7L57", "7L1", "6L1", "5L57"],
			healpulse: ["7L17", "6L17", "5L17"],
			helpinghand: ["7L53", "7L1", "6T", "6L49", "5T", "5L49"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L65", "7L1", "6L1", "5L61"],
			icebeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			mirrorcoat: ["7E", "6E", "5E", "5D"],
			mist: ["7E", "6E", "5E"],
			painsplit: ["7E", "6T", "6E", "5T", "5E", "5D"],
			playnice: ["7L1"],
			pound: ["7L1", "6L1", "5L1"],
			protect: ["7M", "7L21", "6M", "6L21", "5M", "5L21"],
			psychic: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			refresh: ["7E", "6E", "5E"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			soak: ["7L33", "6L33", "5L33"],
			substitute: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tickle: ["7E", "6E", "5E"],
			toxic: ["7M", "6M", "5M"],
			wakeupslap: ["7L29", "6L29", "5L29"],
			waterfall: ["7M", "6M", "5M"],
			waterpulse: ["7L25", "6T", "6L25", "5L25"],
			watersport: ["7L1", "6L1", "5L1"],
			whirlpool: ["7L49"],
			wideguard: ["7L61", "7L1", "6L1", "5L53"],
			wish: ["7L37", "6L37", "5L37"],
		},
	},
	joltik: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			agility: ["7L37", "6L37", "5L37"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			bugbite: ["7L18", "6T", "6L18", "5T", "5L18"],
			bugbuzz: ["7L48", "6L48", "5L48"],
			camouflage: ["7E", "6E"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crosspoison: ["7E", "6E", "5E"],
			cut: ["6M", "5M"],
			disable: ["7E", "6E", "5E"],
			discharge: ["7L45", "6L45", "5L45"],
			doubleteam: ["7M", "6M", "5M"],
			electroball: ["7L29", "6L29", "5L29"],
			electroweb: ["7L15", "6T", "6L15", "5T", "5L15"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7E", "6E", "5E"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furycutter: ["7L12", "6L12", "5L12"],
			gastroacid: ["7L23", "6T", "6L23", "5T", "5L23"],
			gigadrain: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			leechlife: ["7M", "6L1", "5L1"],
			lightscreen: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T"],
			pinmissile: ["7E", "6E", "5E"],
			poisonjab: ["7M", "6M", "5M"],
			poisonsting: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockclimb: ["7E", "6E", "5E"],
			round: ["7M", "6M", "5M"],
			screech: ["7L7", "6L7", "5L7"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["7L34", "6T", "6L34", "5T", "5L34"],
			slash: ["7L26", "6L26", "5L26"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			spiderweb: ["7L1", "6L1", "5L1"],
			stringshot: ["7L1", "6L1", "5L1"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["7L40", "6L40", "5L40"],
			swagger: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "7L4", "6M", "6L4", "5M", "5L4"],
			toxic: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	galvantula: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			agility: ["7L40", "6L40", "5L40"],
			attract: ["7M", "6M", "5M"],
			bounce: ["6T", "5T"],
			bugbite: ["7L18", "6T", "6L18", "5T", "5L18"],
			bugbuzz: ["7L60", "6L60", "5L60"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			disable: ["5D"],
			discharge: ["7L54", "6L54", "5L54"],
			doubleteam: ["7M", "6M", "5M"],
			electroball: ["7L29", "6L29", "5L29", "5D"],
			electroweb: ["7L15", "6T", "6L15", "5T", "5L15"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furycutter: ["7L12", "6L12", "5L12"],
			gastroacid: ["7L23", "6T", "6L23", "5T", "5L23"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			leechlife: ["7M", "6L1", "5L1"],
			lightscreen: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["5D"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			screech: ["7L7", "6L7", "5L7"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["7L34", "6T", "6L34", "5T", "5L34"],
			slash: ["7L26", "6L26", "5L26"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			spiderweb: ["7L1", "6L1", "5L1"],
			stickyweb: ["7L1", "6L1"],
			stringshot: ["7L1", "6L1", "5L1"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["7L46", "6L46", "5L46"],
			swagger: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "7L4", "7L1", "6M", "6L1", "5M", "5L1"],
			toxic: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	ferroseed: {
		inherit: true,
		learnset: {
			acidspray: ["7E", "6E"],
			bulletseed: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			curse: ["7L9", "6L9", "5L9"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			energyball: ["7M", "6M", "5M"],
			explosion: ["7M", "7L55", "6M", "6L55", "5M", "5L55"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "7L52", "6M", "6L52", "5M", "5L52"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			gravity: ["7E", "6T", "6E", "5T", "5E"],
			gyroball: ["7M", "7L21", "6M", "6L21", "5M", "5L21"],
			harden: ["7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			ingrain: ["7L35", "6L35", "5L35"],
			irondefense: ["7L26", "6T", "6L26", "5T", "5L26"],
			ironhead: ["7L43", "6T", "6L43", "5T", "5L43"],
			knockoff: ["6T"],
			leechseed: ["7E", "6E", "5E"],
			magnetrise: ["6T", "5T"],
			metalclaw: ["7L14", "6L14", "5L14"],
			mirrorshot: ["7L30", "6L30", "5L30"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "7L47", "6M", "6L47", "5M", "5L47"],
			pinmissile: ["7L18", "6L18", "5L18"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockclimb: ["7E", "6E", "5E"],
			rockpolish: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rollout: ["7L6", "6L6", "5L6"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["7E", "6T", "6E", "5T", "5E"],
			selfdestruct: ["7L38", "6L38", "5L38"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			spikes: ["7E", "6E", "5E"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			worryseed: ["7E", "6T", "6E", "5T", "5E"],
		},
	},
	ferrothorn: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			block: ["6T"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			curse: ["7L9", "7L1", "6L1", "5L1"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			energyball: ["7M", "6M", "5M"],
			explosion: ["7M", "7L67", "6M", "6L67", "5M", "5L67"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "7L61", "6M", "6L61", "5M", "5L61"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			gyroball: ["7M", "7L21", "6M", "6L21", "5M", "5L21"],
			harden: ["7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			ingrain: ["7L35", "6L35", "5L35"],
			irondefense: ["7L26", "6T", "6L26", "5T", "5L26"],
			ironhead: ["7L46", "6T", "6L46", "5T", "5L46"],
			knockoff: ["6T", "5T"],
			magnetrise: ["6T", "5T"],
			metalclaw: ["7L14", "6L14", "5L14"],
			mirrorshot: ["7L30", "6L30", "5L30"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "7L53", "6M", "6L53", "5M", "5L53"],
			pinmissile: ["7L18", "6L18", "5L18"],
			poisonjab: ["7M", "6M", "5M"],
			powerwhip: ["7L1", "6L40", "5L40"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockclimb: ["7L1", "6L1", "5L1"],
			rockpolish: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rollout: ["7L6", "7L1", "6L1", "5L1"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			selfdestruct: ["7L38", "6L38", "5L38"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stealthrock: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			worryseed: ["6T", "5T"],
		},
	},
	klink: {
		inherit: true,
		learnset: {
			autotomize: ["7L31", "6L31", "5L31"],
			bind: ["7L21", "6T", "6L21", "5T", "5L21"],
			charge: ["7L6", "6L6", "5L6"],
			chargebeam: ["7M", "7L26", "6M", "6L26", "5M", "5L26"],
			confide: ["7M", "6M"],
			discharge: ["7L42", "6L42", "5L42"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			geargrind: ["7L16", "6L16", "5L16"],
			gravity: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "7L57", "6M", "6L57", "5M", "5L57"],
			irondefense: ["6T", "5T"],
			lockon: ["7L50", "6L50", "5L51"],
			magiccoat: ["6T", "5T"],
			magnetrise: ["6T", "5T"],
			metalsound: ["7L45", "6L45", "5L45"],
			mirrorshot: ["7L36", "6L36", "5L36"],
			protect: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			screech: ["7L39", "6L39", "5L39"],
			secretpower: ["6M"],
			shiftgear: ["7L48", "6L48", "5L48"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thundershock: ["7L11", "6L11", "5L11"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			visegrip: ["7L1", "6L1", "5L1"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			zapcannon: ["7L54", "6L54", "5L54"],
		},
	},
	klang: {
		inherit: true,
		learnset: {
			autotomize: ["7L31", "6L31", "5L31"],
			bind: ["7L21", "6T", "6L21", "5T", "5L21"],
			charge: ["7L6", "7L1", "6L1", "5L1"],
			chargebeam: ["7M", "7L26", "6M", "6L26", "5M", "5L26", "5D"],
			confide: ["7M", "6M"],
			discharge: ["7L44", "6L44", "5L44"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			geargrind: ["7L16", "7L1", "6L1", "5L1"],
			gravity: ["6T", "5T", "5D"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "7L64", "6M", "6L64", "5M", "5L64"],
			irondefense: ["6T", "5T"],
			lockon: ["7L56", "6L56", "5L56"],
			magiccoat: ["6T", "5T"],
			magnetrise: ["6T", "5T", "5D"],
			metalsound: ["7L48", "6L48", "5L48"],
			mirrorshot: ["7L36", "6L36", "5L36"],
			protect: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			screech: ["7L40", "6L40", "5L40"],
			secretpower: ["6M"],
			shiftgear: ["7L52", "6L52", "5L52"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thundershock: ["7L11", "7L1", "6L1", "5L1"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			visegrip: ["7L1", "6L1", "5L1"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			zapcannon: ["7L60", "6L60", "5L60"],
		},
	},
	klinklang: {
		inherit: true,
		learnset: {
			autotomize: ["7L31", "6L31", "5L31"],
			bind: ["7L21", "6T", "6L21", "5T", "5L21"],
			charge: ["7L6", "7L1", "6L1", "5L1"],
			chargebeam: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			confide: ["7M", "6M"],
			discharge: ["7L44", "6L44", "5L44"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			geargrind: ["7L16", "7L1", "6L1", "5L1"],
			gearup: ["7L1"],
			gigaimpact: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "7L72", "6M", "6L72", "5M", "5L72"],
			irondefense: ["6T", "5T"],
			lockon: ["7L60", "6L60", "5L60"],
			magiccoat: ["6T", "5T"],
			magneticflux: ["7L1", "6L1"],
			magnetrise: ["6T", "5T"],
			metalsound: ["7L48", "6L48", "5L48"],
			mirrorshot: ["7L36", "6L36", "5L36"],
			protect: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			screech: ["7L40", "6L40", "5L40"],
			secretpower: ["6M"],
			shiftgear: ["7L54", "6L54", "5L54"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thundershock: ["7L11", "7L1", "6L1", "5L1"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trickroom: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			visegrip: ["7L1", "6L1", "5L1"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			zapcannon: ["7L66", "6L1", "5L66"],
		},
	},
	tynamo: {
		inherit: true,
		learnset: {
			chargebeam: ["7M", "7L1", "6M", "6L1", "5L1"],
			magnetrise: ["6T", "5T"],
			spark: ["7L1", "6L1", "5L1"],
			tackle: ["7L1", "6L1", "5L1"],
			thunderwave: ["7M", "7L1", "6M", "6L1", "5L1"],
		},
	},
	eelektrik: {
		inherit: true,
		learnset: {
			acid: ["7L19", "6L19", "5L19"],
			acidspray: ["7L49", "6L49", "5L49"],
			acrobatics: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			bind: ["7L9", "6T", "6L9", "5T", "5L9"],
			bounce: ["6T", "5T"],
			chargebeam: ["7M", "7L1", "6M", "6L1", "5M", "5L1"],
			coil: ["7L54", "6L54", "5L54"],
			confide: ["7M", "6M"],
			crunch: ["7L1", "6L39", "5L39"],
			discharge: ["7L29", "6L29", "5L29"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["7L64", "6T", "6L64", "5T", "5L64"],
			gigadrain: ["6T", "5T"],
			headbutt: ["7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			spark: ["7L1", "6L1", "5L1"],
			substitute: ["7M", "6M", "5M"],
			superfang: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			thrash: ["7L74", "6L74", "5L74"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "7L44", "6M", "6L44", "5M", "5L44"],
			thunderwave: ["7M", "7L1", "6M", "6L1", "5M", "5L1"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "7L59", "6M", "6L59", "5M", "5L59"],
			zapcannon: ["7L69", "6L69", "5L69"],
		},
	},
	eelektross: {
		inherit: true,
		learnset: {
			acid: ["7L1", "6L1", "5L1"],
			acrobatics: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			bind: ["6T", "5T"],
			bounce: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M"],
			chargebeam: ["7M", "6M", "5M"],
			coil: ["7L1", "6L1"],
			confide: ["7M", "6M"],
			crunch: ["7L1", "6L1", "5L1"],
			crushclaw: ["7L1", "6L1", "5L1"],
			cut: ["6M", "5M"],
			discharge: ["7L1", "6L1", "5L1"],
			doubleteam: ["7M", "6M", "5M"],
			dragonclaw: ["7M", "6M", "5M"],
			dragonpulse: ["6T"],
			dragontail: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			flamethrower: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["7L1", "6T", "6L1", "5T"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			headbutt: ["7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			iondeluge: ["7L1", "6L1"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T"],
			outrage: ["6T"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superfang: ["6T", "5T"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			thrash: ["7L1", "6L1"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			zapcannon: ["7L1", "6L1"],
		},
	},
	elgyem: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			allyswitch: ["7E", "6E", "5M"],
			astonish: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			barrier: ["7E", "6E", "5E", "5D"],
			calmmind: ["7M", "7L43", "6M", "6L43", "5M", "5L43"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1"],
			cosmicpower: ["7E", "6E"],
			darkpulse: ["7M", "6M", "5T"],
			disable: ["7E", "6E", "5E"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			growl: ["7L4", "6L4", "5L4"],
			guardsplit: ["7L50", "6L50", "5L50"],
			guardswap: ["7E", "6E", "5E"],
			headbutt: ["7L18", "6L18", "5L18"],
			healblock: ["7L8", "6L8", "5L8", "5D"],
			hiddenpower: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			imprison: ["7L25", "6L25", "5L25"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			miracleeye: ["7L11", "6L11", "5L11"],
			nastyplot: ["7E", "6E", "5E", "5D"],
			painsplit: ["6T", "5T"],
			powersplit: ["7L50", "6L50", "5L50"],
			powerswap: ["7E", "6E", "5E"],
			protect: ["7M", "6M", "5M"],
			psybeam: ["7L15", "6L15", "5L15"],
			psychic: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			psychup: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			recover: ["7L46", "6L46", "5L46"],
			recycle: ["6T", "5T"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			simplebeam: ["7L29", "6L29", "5L29"],
			skillswap: ["7E", "6T", "6E", "5T", "5E"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			synchronoise: ["7L53", "6L53", "5L53"],
			telekinesis: ["5M"],
			teleport: ["7E", "6E", "5E"],
			thief: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			wonderroom: ["7L56", "6T", "6L56", "5T", "5L56"],
			zenheadbutt: ["7L32", "6T", "6L32", "5T", "5L32"],
		},
	},
	beheeyem: {
		inherit: true,
		learnset: {
			afteryou: ["6T", "5T"],
			allyswitch: ["5M"],
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1", "5L1"],
			darkpulse: ["7M", "6M", "5T"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			growl: ["7L4", "7L1", "6L1", "5L1"],
			guardsplit: ["7L56", "6L56", "5L56"],
			headbutt: ["7L18", "6L18", "5L18"],
			healblock: ["7L8", "7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			hyperbeam: ["7M", "6M", "5M"],
			imprison: ["7L25", "6L25", "5L25"],
			lightscreen: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			miracleeye: ["7L11", "7L1", "6L1", "5L1"],
			painsplit: ["6T", "5T"],
			powersplit: ["7L58", "6L58", "5L58"],
			protect: ["7M", "6M", "5M"],
			psybeam: ["7L15", "6L15", "5L15"],
			psychic: ["7M", "7L39", "6M", "6L39", "5M", "5L39"],
			psychicterrain: ["7L1"],
			psychup: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			psyshock: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			recover: ["7L50", "6L50", "5L50"],
			recycle: ["6T", "5T"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			simplebeam: ["7L29", "6L29", "5L29"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			synchronoise: ["7L63", "7L1", "6L1", "5L63"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			wonderroom: ["7L68", "7L1", "6T", "6L1", "5T", "5L68"],
			zenheadbutt: ["7L32", "6T", "6L32", "5T", "5L32"],
		},
	},
	litwick: {
		inherit: true,
		learnset: {
			acid: ["7E", "6E", "5E"],
			acidarmor: ["7E", "6E", "5E"],
			astonish: ["7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			captivate: ["7E", "6E", "5E"],
			clearsmog: ["7E", "6E", "5E"],
			confide: ["7M", "6M"],
			confuseray: ["7L10", "6L10", "5L10"],
			curse: ["7L43", "6L43", "5L43"],
			darkpulse: ["7M", "6M", "5T"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			ember: ["7L1", "6L1", "5L1"],
			endure: ["7E", "6E", "5E"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "6M", "5M"],
			firespin: ["7L7", "6L7", "5L7"],
			flameburst: ["7L20", "6L20", "5L20"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			haze: ["7E", "6E", "5E"],
			heatwave: ["7E", "6T", "6E", "5T", "5E"],
			hex: ["7L28", "6L28", "5L28"],
			hiddenpower: ["7M", "6M", "5M"],
			imprison: ["7L24", "6L24", "5L24"],
			incinerate: ["6M", "5M"],
			inferno: ["7L38", "6L38", "5L38"],
			memento: ["7L33", "6L33", "5L33"],
			minimize: ["7L3", "6L3", "5L3"],
			nightshade: ["7L13", "6L13", "5L13"],
			overheat: ["7M", "7L61", "6M", "6L61", "5M", "5L61"],
			painsplit: ["7L55", "6T", "6L55", "5T", "5L55"],
			payback: ["7M", "6M", "5M"],
			powersplit: ["7E", "6E"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "7L49", "6M", "6L49", "5M", "5L49"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			smog: ["7L5", "6L5", "5L5"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			willowisp: ["7M", "7L16", "6M", "6L16", "5M", "5L16"],
		},
	},
	lampent: {
		inherit: true,
		learnset: {
			astonish: ["7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			confuseray: ["7L10", "6L10", "5L10"],
			curse: ["7L45", "6L45", "5L45"],
			darkpulse: ["7M", "6M", "5T"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			ember: ["7L1", "6L1", "5L1"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "6M", "5M"],
			firespin: ["7L7", "6L7", "5L7"],
			flameburst: ["7L20", "6L20", "5L20"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			heatwave: ["6T", "5T"],
			hex: ["7L28", "6L28", "5L28"],
			hiddenpower: ["7M", "6M", "5M"],
			imprison: ["7L24", "6L24", "5L24"],
			incinerate: ["6M", "5M"],
			inferno: ["7L38", "6L38", "5L38"],
			memento: ["7L33", "6L33", "5L33"],
			minimize: ["7L3", "7L1", "6L1", "5L1"],
			nightshade: ["7L13", "6L13", "5L13"],
			overheat: ["7M", "7L69", "6M", "6L69", "5M", "5L69"],
			painsplit: ["7L61", "6T", "6L61", "5T", "5L61"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "7L53", "6M", "6L53", "5M", "5L53"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			smog: ["7L5", "7L1", "6L1", "5L1"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			willowisp: ["7M", "7L16", "6M", "6L16", "5M", "5L16"],
		},
	},
	chandelure: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L1", "5L1"],
			darkpulse: ["7M", "6M", "5T"],
			doubleteam: ["7M", "6M", "5M"],
			dreameater: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M", "5S0"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "6M", "5M"],
			flameburst: ["7L1", "6L1", "5L1"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			heatwave: ["6T", "5T", "5S0"],
			hex: ["7L1", "6L1", "5L1"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			overheat: ["7M", "6M", "5M"],
			painsplit: ["7L1", "6T", "6L1", "5T"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M", "5S0"],
			psychup: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M", "5S0"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M", "5T"],
			smog: ["7L1", "6L1", "5L1"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			spite: ["6T", "5T"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M"],
		},
	},
	axew: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			assurance: ["7L7", "6L7", "5L7"],
			attract: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			counter: ["7E", "6E", "5E", "5D"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "5T"],
			dragonclaw: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "5S1"],
			dragondance: ["7L32", "6L32", "5L32"],
			dragonpulse: ["7L41", "7E", "6T", "6L41", "6E", "5T", "5L41", "5E"],
			dragonrage: ["7L10", "6L10", "5L10", "5S0", "5S1", "5S2", "5D"],
			dualchop: ["7L13", "6T", "6L13", "5T", "5L13"],
			endeavor: ["7E", "6T", "6E", "5T", "5E"],
			endure: ["7E", "6E", "5E", "5S1"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "7L24", "6M", "6L24", "5M", "5L24"],
			fling: ["7M", "6M", "5M"],
			focusenergy: ["7E", "6E", "5E"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "7L61", "6M", "6L61", "5M", "5L61", "5S2"],
			guillotine: ["7L50", "6L50", "5L51"],
			harden: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["7E", "6T", "6E", "5T", "5E"],
			leer: ["7L4", "6L4", "5L4"],
			nightslash: ["7E", "6E", "5E", "5D"],
			outrage: ["7L56", "6T", "6L56", "5T", "5L56", "5S2"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			razorwind: ["7E", "6E", "5E"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M", "5S1"],
			reversal: ["7E", "6E", "5E"],
			roar: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L16", "6L16", "5L16"],
			scratch: ["7L1", "6L1", "5L1", "5S0", "5S2"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			slash: ["7L20", "6L20", "5L20"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L46", "6M", "6L46", "5M", "5L46"],
			taunt: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			toxic: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	fraxure: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			assurance: ["7L7", "7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "5T"],
			dragonclaw: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			dragondance: ["7L32", "6L32", "5L32"],
			dragonpulse: ["7L42", "6T", "6L42", "5T", "5L42"],
			dragonrage: ["7L10", "7L1", "6L1", "5L1"],
			dragontail: ["7M", "6M", "5M"],
			dualchop: ["7L13", "6T", "6L13", "5T", "5L13"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "7L24", "6M", "6L24", "5M", "5L24"],
			fling: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "7L66", "6M", "6L66", "5M", "5L66"],
			guillotine: ["7L54", "6L54", "5L54"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			leer: ["7L4", "7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			outrage: ["7L60", "6T", "6L60", "5T", "5L60"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L16", "6L16", "5L16"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			slash: ["7L20", "6L20", "5L20"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L48", "6M", "6L48", "5M", "5L48"],
			taunt: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			toxic: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	haxorus: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			assurance: ["7L7", "7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "5T"],
			dragonclaw: ["7M", "7L28", "6M", "6L28", "5M", "5L28"],
			dragondance: ["7L32", "6L32", "5L32", "5S0"],
			dragonpulse: ["7L42", "6T", "6L42", "5T", "5L42"],
			dragonrage: ["7L10", "7L1", "6L1", "5L1"],
			dragontail: ["7M", "6M", "5M"],
			dualchop: ["7L13", "6T", "6L13", "5T", "5L13", "5S0"],
			earthquake: ["7M", "6M", "5M", "5S0"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "7L24", "6M", "6L24", "5M", "5L24"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "7L74", "6M", "6L74", "5M", "5L74"],
			grassknot: ["7M", "6M", "5M"],
			guillotine: ["7L58", "6L58", "5L58"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			leer: ["7L4", "7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			outrage: ["7L66", "7L1", "6T", "6L1", "5T", "5L66"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L16", "6L16", "5L16"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			slash: ["7L20", "6L20", "5L20"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L50", "6M", "6L50", "5M", "5L50"],
			taunt: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			toxic: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M", "5S0"],
		},
	},
	cubchoo: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			assurance: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			avalanche: ["7E", "6E", "5E"],
			bide: ["7L9", "6L9", "5L9", "5S0"],
			blizzard: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			brine: ["7L21", "6L21", "5L21"],
			charm: ["7L29", "6L29", "5L29"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			encore: ["7E", "6E", "5E"],
			endure: ["7L25", "6L25", "5L25"],
			facade: ["7M", "6M", "5M"],
			flail: ["7L36", "6L36", "5L36"],
			fling: ["7M", "6M", "5M"],
			focuspunch: ["7E", "6T", "6E", "5E"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L17", "6L17", "5L17"],
			grassknot: ["7M", "6M", "5M"],
			growl: ["7L1", "6L1", "5L5", "5S0"],
			hail: ["7M", "7L49", "6M", "6L49", "5M", "5L49"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			icebeam: ["7M", "6M", "5M"],
			icepunch: ["7E", "6T", "6E", "5T", "5E"],
			icywind: ["7L13", "6T", "6L13", "5T", "5L13", "5S0"],
			lowkick: ["6T", "5T"],
			nightslash: ["7E", "6E", "5E"],
			playnice: ["7L15", "6L15"],
			playrough: ["7E", "6E"],
			powdersnow: ["7L5", "6L5", "5L1", "5S0"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			sheercold: ["7L57", "6L57", "5L57"],
			slash: ["7L33", "6L33", "5L33"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			thrash: ["7L53", "6L53", "5L53"],
			toxic: ["7M", "6M", "5M"],
			waterpulse: ["6T"],
			yawn: ["7E", "6E", "5E"],
		},
	},
	beartic: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquajet: ["7L1", "6L1", "5L1"],
			attract: ["7M", "6M", "5M"],
			bide: ["7L9", "7L1", "6L1", "5L1"],
			blizzard: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			brickbreak: ["7M", "6M", "5M"],
			brine: ["7L21", "6L21", "5L21"],
			bulkup: ["7M", "6M", "5M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			dive: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			endure: ["7L25", "6L25", "5L25"],
			facade: ["7M", "6M", "5M"],
			flail: ["7L36", "6L36", "5L36"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L17", "6L17", "5L17"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			growl: ["7L1", "6L1", "5L1"],
			hail: ["7M", "7L53", "6M", "6L53", "5M", "5L53"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			icebeam: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			iciclecrash: ["7L1", "6L37", "5L37"],
			icywind: ["7L13", "7L1", "6T", "6L1", "5T", "5L1"],
			lowkick: ["6T", "5T"],
			playnice: ["7L15", "6L9"],
			powdersnow: ["7L5", "7L1", "6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			sheercold: ["7L66", "7L1", "6L1", "5L66"],
			slash: ["7L33", "6L33", "5L33"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["7L1", "6T", "6L1", "5T", "5L1"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "7L29", "6M", "6L29", "5M", "5L29"],
			swordsdance: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thrash: ["7L59", "7L1", "6L1", "5L59"],
			toxic: ["7M", "6M", "5M"],
			waterpulse: ["6T"],
		},
	},
	cryogonal: {
		inherit: true,
		learnset: {
			acidarmor: ["7L17", "6L29", "5L29"],
			acrobatics: ["7M", "6M", "5M"],
			ancientpower: ["7L21"],
			attract: ["7M", "6M", "5M"],
			aurorabeam: ["7L13", "6L25", "5L25"],
			auroraveil: ["7M"],
			bind: ["7L1", "6T", "6L1", "5T", "5L1"],
			blizzard: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			confuseray: ["7L41", "6L45", "5L45"],
			doubleteam: ["7M", "6M", "5M"],
			explosion: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			freezedry: ["7L49", "6L50"],
			frostbreath: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			haze: ["7L9", "6L1", "5L21"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			icebeam: ["7M", "7L25", "6M", "6L33", "5M", "5L33"],
			iceshard: ["7L1", "6L1", "5L5"],
			icywind: ["7L5", "6T", "6L17", "5T", "5L17"],
			irondefense: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			lightscreen: ["7M", "7L29", "6M", "6L37", "5M", "5L37"],
			magiccoat: ["6T", "5T"],
			mist: ["7L9", "6L1", "5L21"],
			nightslash: ["7L53", "7L1", "6L1", "5L57"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rapidspin: ["7L1", "6L13", "5L13"],
			recover: ["7L45", "6L49", "5L49"],
			reflect: ["7M", "7L33", "6M", "6L37", "5M", "5L37"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sharpen: ["7L1", "6L9", "5L9"],
			sheercold: ["7L57", "7L1", "6L1", "5L61"],
			signalbeam: ["6T", "5T"],
			slash: ["7L37", "6L41", "5L41"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "7L50", "6M", "6L53", "5M", "5L53"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			waterpulse: ["6T"],
		},
	},
	shelmet: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			acid: ["7L4", "6L4", "5L4", "5D"],
			acidarmor: ["7L32", "6L32", "5L32"],
			attract: ["7M", "6M", "5M"],
			batonpass: ["7E", "6E", "5E", "5D"],
			bide: ["7L8", "6L8", "5L8"],
			bodyslam: ["7L40", "6L40", "5L40", "5S1"],
			bugbite: ["6T", "5T"],
			bugbuzz: ["7L44", "6L44", "5L44", "5S1"],
			confide: ["7M", "6M"],
			curse: ["7L13", "6L13", "5L13"],
			doubleedge: ["7E", "6E", "5E"],
			doubleteam: ["7M", "6M", "5M"],
			encore: ["7E", "6E", "5E", "5S1", "5D"],
			endure: ["7E", "6E", "5E"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			feint: ["7E", "6E", "5E"],
			finalgambit: ["7L56", "6L56", "5L56"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["6T", "5T"],
			gigadrain: ["7L37", "6T", "6L37", "5T", "5L37", "5S1"],
			guardsplit: ["7E", "6E", "5E"],
			guardswap: ["7L50", "6L50", "5L52"],
			hiddenpower: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			leechlife: ["7M", "6L1", "5L1"],
			megadrain: ["7L20", "6L20", "5L20", "5S0"],
			mindreader: ["7E", "6E", "5E"],
			mudslap: ["7E", "6E", "5E"],
			protect: ["7M", "7L28", "6M", "6L28", "5M", "5L28", "5S0"],
			pursuit: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M"],
			recover: ["7L49", "6L49", "5L49"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			spikes: ["7E", "6E", "5E"],
			strugglebug: ["7L16", "6M", "6L16", "5M", "5L16", "5S0"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			venoshock: ["7M", "6M", "5M"],
			yawn: ["7L25", "6L25", "5L25", "5S0"],
		},
	},
	accelgor: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			acidspray: ["7L4", "7L1", "6L1", "5L1"],
			agility: ["7L32", "6L32", "5L32"],
			attract: ["7M", "6M", "5M"],
			bugbite: ["6T", "5T"],
			bugbuzz: ["7L44", "6L44", "5L44"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "7L8", "7L1", "6M", "6L1", "5M", "5L1"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			finalgambit: ["7L56", "7L1", "6L1", "5L56"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gastroacid: ["6T", "5T"],
			gigadrain: ["7L37", "6T", "6L37", "5T", "5L37"],
			gigaimpact: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			knockoff: ["6T", "5T"],
			leechlife: ["7M", "6L1", "5L1"],
			mefirst: ["7L28", "6L28", "5L28"],
			megadrain: ["7L20", "6L20", "5L20"],
			powerswap: ["7L52", "7L1", "6L1", "5L52"],
			protect: ["7M", "6M", "5M"],
			quickattack: ["7L13", "7L1", "6L1", "5L1"],
			raindance: ["7M", "6M", "5M"],
			recover: ["7L49", "6L49", "5L49"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			strugglebug: ["7L16", "6M", "6L16", "5M", "5L16"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swift: ["7L25", "6L25", "5L25"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "7L40", "6M", "6L40", "5M", "5L40"],
			venoshock: ["7M", "6M", "5M"],
			watershuriken: ["7L1", "6L1"],
		},
	},
	stunfisk: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T"],
			astonish: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			bide: ["7L5", "6L5", "5L5"],
			bounce: ["7L35", "6T", "6L35", "5T", "5L35"],
			bulldoze: ["7M", "6M", "5M"],
			camouflage: ["7L17", "6L17", "5L17"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E", "5D"],
			dig: ["6M", "5M"],
			discharge: ["7L25", "6L25", "5L25"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["7E", "6T", "6E", "5T", "5E"],
			earthquake: ["7M", "6M", "5M"],
			eerieimpulse: ["7E", "6E"],
			electroweb: ["6T", "5T"],
			endeavor: ["6T", "5T"],
			endure: ["7L30", "6L30", "5L30"],
			facade: ["7M", "6M", "5M"],
			fissure: ["7L61", "7L1", "6L1", "5L61"],
			flail: ["7L55", "7L1", "6L1", "5L55"],
			flash: ["6M", "5M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			magnetrise: ["6T", "5T"],
			mefirst: ["7E", "6E"],
			mudbomb: ["7L21", "6L21", "5L21"],
			muddywater: ["7L40", "6L40", "5L40"],
			mudshot: ["7L13", "6L13", "5L13"],
			mudslap: ["7L1", "6L1", "5L1", "5D"],
			mudsport: ["7L1", "6L1", "5L1"],
			painsplit: ["7E", "6T", "6E", "5T", "5E"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflecttype: ["7E", "6E"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			revenge: ["7L50", "6L50", "5L50"],
			rockslide: ["7M", "6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shockwave: ["7E", "6T", "6E", "5E"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			sludgebomb: ["7M", "6M", "5M"],
			sludgewave: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			spark: ["7E", "6E", "5E"],
			spite: ["7E", "6T", "6E", "5T", "5E"],
			stealthrock: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			thundershock: ["7L9", "6L9", "5L9"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			watergun: ["7L1", "6L1"],
			waterpulse: ["6T"],
			yawn: ["7E", "6E", "5E", "5D"],
		},
	},
	mienfoo: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M"],
			allyswitch: ["7E", "6E"],
			attract: ["7M", "6M", "5M"],
			aurasphere: ["7L61", "6L61", "5L61"],
			batonpass: ["7E", "6E", "5E"],
			bounce: ["7L49", "6T", "6L49", "5T", "5L49"],
			brickbreak: ["7M", "6M", "5M"],
			bulkup: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			confide: ["7M", "6M"],
			detect: ["7L9", "6L9", "5L9"],
			dig: ["6M", "5M"],
			doubleslap: ["7L17", "6L17", "5L17"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["7L33", "6T", "6L33", "5T", "5L33"],
			dualchop: ["6T", "5T"],
			endure: ["7E", "6E", "5E"],
			facade: ["7M", "6M", "5M"],
			fakeout: ["7L13", "6L13", "5L13"],
			feint: ["7E", "6E", "5E"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			forcepalm: ["7L29", "6L29", "5L29"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			highjumpkick: ["7L50", "6L50", "5L53"],
			jumpkick: ["7L37", "6L37", "5L37"],
			knockoff: ["7E", "6T", "6E", "5T", "5E"],
			lowkick: ["7E", "6T", "6E", "5T", "5E"],
			lowsweep: ["7M", "6M", "5M"],
			meditate: ["7L5", "6L5", "5L5"],
			mefirst: ["7E", "6E", "5E"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			pound: ["7L1", "6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			quickguard: ["7L45", "6L45", "5L45"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			reversal: ["7L57", "6L57", "5L57"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smellingsalts: ["7E", "6E", "5E"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swift: ["7L21", "6L21", "5L21"],
			swordsdance: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			vitalthrow: ["7E", "6E", "5E"],
			workup: ["7M", "5M"],
		},
	},
	mienshao: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M"],
			attract: ["7M", "6M", "5M"],
			aurasphere: ["7L70", "7L1", "6L1", "5L70"],
			bounce: ["7L49", "6T", "6L49", "5T", "5L49"],
			brickbreak: ["7M", "6M", "5M"],
			bulkup: ["7M", "6M", "5M"],
			calmmind: ["7M", "7L25", "6M", "6L25", "5M", "5L25"],
			confide: ["7M", "6M"],
			detect: ["7L9", "7L1", "6L1", "5L1"],
			dig: ["6M", "5M"],
			doubleslap: ["7L17", "6L17", "5L17"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["7L33", "6T", "6L33", "5T", "5L33"],
			dualchop: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			fakeout: ["7L13", "7L1", "6L1", "5L1"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			forcepalm: ["7L29", "6L29", "5L29"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			highjumpkick: ["7L56", "6L56", "5L56"],
			hyperbeam: ["7M", "6M", "5M"],
			jumpkick: ["7L37", "6L37", "5L37"],
			knockoff: ["6T", "5T"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			meditate: ["7L5", "7L1", "6L1", "5L1"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			pound: ["7L1", "6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			reversal: ["7L63", "7L1", "6L1", "5L63"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swift: ["7L21", "6L21", "5L21"],
			swordsdance: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			wideguard: ["7L45", "6L45", "5L45"],
			workup: ["7M", "5M"],
		},
	},
	druddigon: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L9", "6L9", "5L9", "5D"],
			bulldoze: ["7M", "6M", "5M"],
			chargebeam: ["7M", "6M", "5M"],
			chipaway: ["7L31", "6L31", "5L31"],
			confide: ["7M", "6M"],
			crunch: ["7L25", "6L25", "5L25"],
			crushclaw: ["7E", "6E", "5E"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "6M", "5T"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "5T"],
			dragonclaw: ["7M", "7L27", "6M", "6L27", "5M", "5L27"],
			dragonpulse: ["6T", "5T"],
			dragonrage: ["7L18", "6L18", "5L18"],
			dragontail: ["7M", "7L45", "6M", "6L45", "5M", "5L45"],
			earthquake: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7E", "6E", "5E"],
			firefang: ["7E", "6E", "5E", "5D"],
			firepunch: ["6T", "5T"],
			flamethrower: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			glare: ["7E", "6E", "5E"],
			gunkshot: ["6T", "5T"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["7L5", "6M", "6L5", "5M", "5L5"],
			hyperbeam: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			ironhead: ["6T", "5T"],
			irontail: ["7E", "6T", "6E", "5T", "5E"],
			leer: ["7L1", "6L1", "5L1", "5S0"],
			metalclaw: ["7E", "6E", "5E"],
			nightslash: ["7L40", "6L40", "5L40"],
			outrage: ["7L62", "6T", "6L62", "5T", "5L62"],
			payback: ["7M", "6M", "5M"],
			poisontail: ["7E", "6E", "5E"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			revenge: ["7L35", "6L35", "5L35"],
			roar: ["7M", "6M", "5M"],
			rockclimb: ["7L49", "6L49", "5L49"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L13", "6L13", "5L13"],
			scratch: ["7L1", "6L1", "5L1", "5S0"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			slash: ["7L21", "6L21", "5L21"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["7E", "6T", "6E", "5T", "5E"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["7E", "6E", "5E", "5D"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["7L55", "6T", "6L55", "5T", "5L55"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thunderfang: ["7E", "6E", "5E"],
			thunderpunch: ["6T", "5T"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
		},
	},
	golett: {
		inherit: true,
		learnset: {
			astonish: ["7L1", "6L1", "5L1"],
			block: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			curse: ["7L45", "6L40", "5L40"],
			defensecurl: ["7L1", "6L1", "5L1"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T"],
			dynamicpunch: ["7L35", "6L30", "5L30"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "7L50", "6M", "6L45", "5M", "5L45"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T", "5D"],
			flash: ["6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["7L61", "6T", "6L55", "5L55"],
			frustration: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			gyroball: ["7M", "6M", "5M"],
			hammerarm: ["7L55", "6L50", "5L50"],
			hiddenpower: ["7M", "6M", "5M"],
			icebeam: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			icywind: ["6T", "5T"],
			irondefense: ["7L17", "6T", "6L17", "5T", "5L17"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			magnitude: ["7L30", "6L25", "5L25"],
			megapunch: ["7L25", "6L21", "5L21"],
			mudslap: ["7L5", "6L5", "5L5"],
			nightshade: ["7L40", "6L35", "5L35"],
			pound: ["7L1", "6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rollout: ["7L9", "6L9", "5L9", "5D"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shadowpunch: ["7L13", "6L13", "5L13"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			stompingtantrum: ["7L21"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T", "5D"],
			toxic: ["7M", "6M", "5M"],
		},
	},
	golurk: {
		inherit: true,
		learnset: {
			astonish: ["7L1", "6L1", "5L1"],
			block: ["6T", "5T"],
			brickbreak: ["7M", "6M", "5M"],
			bulldoze: ["7M", "6M", "5M"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			curse: ["7L47", "6L40", "5L40"],
			defensecurl: ["7L1", "6L1", "5L1"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T"],
			dynamicpunch: ["7L35", "6L30", "5L30"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "7L54", "6M", "6L50", "5M", "5L50"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["7L69", "6T", "6L1", "5L70"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			gyroball: ["7M", "6M", "5M", "5S0"],
			hammerarm: ["7L61", "6L60", "5L60", "5S0"],
			heavyslam: ["7L1", "6L43", "5L43"],
			hiddenpower: ["7M", "6M", "5M"],
			highhorsepower: ["7L1"],
			hyperbeam: ["7M", "6M", "5M", "5S0"],
			icebeam: ["7M", "6M", "5M"],
			icepunch: ["6T", "5T"],
			icywind: ["6T", "5T"],
			irondefense: ["7L17", "6T", "6L17", "5T", "5L17"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			magnitude: ["7L30", "6L25", "5L25"],
			megapunch: ["7L25", "6L21", "5L21"],
			mudslap: ["7L5", "7L1", "6L1", "5L1"],
			nightshade: ["7L40", "6L35", "5L35"],
			phantomforce: ["7L76", "6L1"],
			pound: ["7L1", "6L1", "5L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			rollout: ["7L9", "6L9", "5L9"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shadowpunch: ["7L13", "6L13", "5L13", "5S0"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stealthrock: ["6T", "5T"],
			stompingtantrum: ["7L21"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			telekinesis: ["5M"],
			thief: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			toxic: ["7M", "6M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	pawniard: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			assurance: ["7L33", "6L33", "5L33"],
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "6M", "5T"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dualchop: ["6T", "5T"],
			embargo: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "6M", "5M"],
			feintattack: ["7L17", "6L17", "5L17"],
			fling: ["7M", "6M", "5M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			furycutter: ["7L9", "6L9", "5L9", "5D"],
			grassknot: ["7M", "6M", "5M"],
			guillotine: ["7L62", "6L62", "5L62"],
			headbutt: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["7L46", "6T", "6L46", "5T", "5L46"],
			ironhead: ["7L54", "6T", "6L54", "5T", "5L54"],
			knockoff: ["6T", "5T"],
			leer: ["7L6", "6L6", "5L6"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T"],
			meanlook: ["7E", "6E", "5E"],
			metalclaw: ["7L25", "6L25", "5L25"],
			metalsound: ["7L38", "6L38", "5L38"],
			nightslash: ["7L49", "6L49", "5L49"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psychocut: ["7E", "6E", "5E", "5D"],
			pursuit: ["7E", "6E", "5E"],
			quickguard: ["7E", "6E"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			revenge: ["7E", "6E", "5E"],
			rockpolish: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			scaryface: ["7L22", "6L22", "5L22"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			slash: ["7L30", "6L30", "5L30"],
			sleeptalk: ["7M", "6M", "5T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			stealthrock: ["7E", "6T", "6E", "5T", "5E"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["7E", "6E", "5E", "5D"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L57", "6M", "6L57", "5M", "5L57"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "7L14", "6M", "6L14", "5M", "5L14"],
			toxic: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	bisharp: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			assurance: ["7L33", "6L33", "5L33"],
			attract: ["7M", "6M", "5M"],
			brickbreak: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "6M", "5T"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dualchop: ["6T", "5T"],
			embargo: ["7M", "7L41", "6M", "6L41", "5M", "5L41"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "6M", "5M"],
			feintattack: ["7L17", "6L17", "5L17"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			furycutter: ["7L9", "7L1", "6L1", "5L1"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			guillotine: ["7L71", "7L1", "6L1", "5L71"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			irondefense: ["7L46", "6T", "6L46", "5T", "5L46"],
			ironhead: ["7L57", "7L1", "6T", "6L1", "5T", "5L57"],
			knockoff: ["6T", "5T"],
			leer: ["7L6", "7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T"],
			metalburst: ["7L1", "6L1", "5L1"],
			metalclaw: ["7L25", "6L25", "5L25"],
			metalsound: ["7L38", "6L38", "5L38"],
			nightslash: ["7L49", "6L49", "5L49"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			scaryface: ["7L22", "6L22", "5L22"],
			scratch: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			slash: ["7L30", "6L30", "5L30"],
			sleeptalk: ["7M", "6M", "5T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L63", "6M", "6L63", "5M", "5L63"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "7L14", "7L1", "6M", "6L1", "5M", "5L1"],
			toxic: ["7M", "6M", "5M"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	bouffalant: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			amnesia: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			belch: ["7E", "6E"],
			bulldoze: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			earthquake: ["7M", "6M", "6S0", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "6S0", "5M"],
			focusenergy: ["7L36", "6L36", "5L36"],
			frustration: ["7M", "6M", "5M"],
			furyattack: ["7L11", "6L11", "5L11"],
			gigaimpact: ["7M", "7L61", "6M", "6L61", "5M", "5L61"],
			headbutt: ["7E", "6E", "5E"],
			headcharge: ["7L31", "6L31", "6S0", "5L31"],
			hiddenpower: ["7M", "6M", "5M"],
			hornattack: ["7L16", "6L16", "5L16"],
			ironhead: ["7E", "6T", "6E", "5T", "5E"],
			leer: ["7L1", "6L1", "5L1"],
			megahorn: ["7L41", "6L41", "5L41"],
			mudshot: ["7E", "6E", "5E"],
			mudslap: ["7E", "6E", "5E"],
			outrage: ["6T", "5T"],
			payback: ["7M", "6M", "5M"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7L1", "6L1", "5L1"],
			rage: ["7L6", "6L6", "5L6"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			revenge: ["7L26", "6L26", "5L26"],
			reversal: ["7L46", "6L46", "5L46"],
			rockclimb: ["7E", "6E", "5E"],
			rockslide: ["7M", "6M", "6S0", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L21", "6L21", "5L21"],
			secretpower: ["6M"],
			skullbash: ["7E", "6E", "5E"],
			sleeptalk: ["7M", "6M", "5T"],
			smartstrike: ["7M"],
			snore: ["6T", "5T"],
			stomp: ["7E", "6E", "5E"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L56", "6M", "6L56", "5M", "5L56"],
			taunt: ["7M", "6M", "5M"],
			thrash: ["7L50", "6L50", "5L51"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			wildcharge: ["7M", "6M", "5M"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	rufflet: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L23", "6M", "6L23", "5M", "5L23"],
			airslash: ["7L41", "6L41", "5L41"],
			attract: ["7M", "6M", "5M"],
			bravebird: ["7L59", "6L59", "5L59"],
			bulkup: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crushclaw: ["7L46", "6L46", "5L46"],
			cut: ["6M", "5M"],
			defog: ["7L32", "6L32", "5L32"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furyattack: ["7L5", "6L5", "5L5"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["7L14", "6M", "6L14", "5M", "5L14"],
			leer: ["7L1", "6L1", "5L1"],
			peck: ["7L1", "6L1", "5L1"],
			pluck: ["5M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L19", "6L19", "5L19"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			skydrop: ["7M", "7L50", "6M", "6L50", "5M", "5L50"],
			slash: ["7L28", "6L28", "5L28"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["7L37", "6T", "6L37", "5T", "5L37"],
			thrash: ["7L64", "6L64", "5L64"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "5M"],
			whirlwind: ["7L55", "6L55", "5L55"],
			wingattack: ["7L10", "6L10", "5L10"],
			workup: ["7M", "5M"],
		},
	},
	braviary: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L23", "6M", "6L23", "5M", "5L23", "5S0"],
			airslash: ["7L41", "6L41", "5L41"],
			attract: ["7M", "6M", "5M"],
			bravebird: ["7L63", "7L1", "6L1", "5L63"],
			bulkup: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crushclaw: ["7L46", "6L46", "5L46"],
			cut: ["6M", "5M"],
			defog: ["7L32", "6L32", "5L32"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furyattack: ["7L5", "7L1", "6L1", "5L1"],
			gigaimpact: ["7M", "6M", "5M"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["7L14", "6M", "6L14", "5M", "5L14", "5S0"],
			hyperbeam: ["7M", "6M", "5M"],
			leer: ["7L1", "6L1", "5L1"],
			peck: ["7L1", "6L1", "5L1"],
			pluck: ["5M"],
			protect: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L19", "6L19", "5L19", "5S0"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			skyattack: ["6T", "5T"],
			skydrop: ["7M", "7L50", "6M", "6L50", "5M", "5L50"],
			slash: ["7L28", "6L28", "5L28"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["7L1", "6T", "6L1", "5T", "5L51"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["7L37", "6T", "6L37", "5T", "5L37"],
			thrash: ["7L70", "7L1", "6L1", "5L70"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "5M"],
			whirlwind: ["7L57", "7L1", "6L1", "5L57"],
			wingattack: ["7L10", "7L1", "6L1", "5L1", "5S0"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T"],
		},
	},
	vullaby: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			airslash: ["7L41", "6L41", "5L41"],
			attract: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			bravebird: ["7L59", "6L59", "5L59"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "7L46", "6M", "6L46", "5T", "5L46"],
			defog: ["7L32", "6L32", "5L32"],
			doubleteam: ["7M", "6M", "5M"],
			embargo: ["7M", "7L50", "6M", "6L50", "5M", "5L50"],
			facade: ["7M", "6M", "5M"],
			faketears: ["7E", "6E", "5E"],
			feintattack: ["7L23", "6L23", "5L23"],
			flatter: ["7L19", "6L19", "5L19"],
			fly: ["7M", "6M", "5M"],
			foulplay: ["7E", "6T", "6E", "5T"],
			frustration: ["7M", "6M", "5M"],
			furyattack: ["7L5", "6L5", "5L5"],
			gust: ["7L1", "6L1", "5L1"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T"],
			knockoff: ["7E", "6T", "6E", "5T", "5E"],
			leer: ["7L1", "6L1", "5L1"],
			meanlook: ["7E", "6E", "5E"],
			mirrormove: ["7L64", "6L64", "5L64"],
			nastyplot: ["7L14", "6L14", "5L14"],
			payback: ["7M", "6M", "5M"],
			pluck: ["7L10", "6L10", "5M", "5L10"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			punishment: ["7L28", "6L28", "5L28"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "7E", "6M", "6E", "5T", "5E"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "7E", "6M", "6E", "5E"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["7L37", "6T", "6L37", "5T", "5L37"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "5M"],
			whirlwind: ["7L55", "6L55", "5L55"],
		},
	},
	mandibuzz: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			airslash: ["7L41", "6L41", "5L41"],
			attract: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			bonerush: ["7L1", "6L1", "5L51"],
			bravebird: ["7L63", "7L1", "6L1", "5L63"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			darkpulse: ["7M", "7L46", "6M", "6L46", "5T", "5L46"],
			defog: ["7L32", "6L32", "5L32"],
			doubleteam: ["7M", "6M", "5M"],
			embargo: ["7M", "7L50", "6M", "6L50", "5M", "5L50"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7L23", "6L23", "5L23", "5S0"],
			flatter: ["7L19", "6L19", "5L19", "5S0"],
			fly: ["7M", "6M", "5M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			furyattack: ["7L5", "7L1", "6L1", "5L1"],
			gigaimpact: ["7M", "6M", "5M"],
			gust: ["7L1", "6L1", "5L1"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			irondefense: ["5T"],
			knockoff: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			mirrormove: ["7L70", "7L1", "6L1", "5L70"],
			nastyplot: ["7L14", "6L14", "5L14", "5S0"],
			payback: ["7M", "6M", "5M"],
			pluck: ["7L10", "7L1", "6L1", "5M", "5L1", "5S0"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			punishment: ["7L28", "6L28", "5L28"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			skyattack: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snarl: ["7M", "6M", "5M"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["7L37", "6T", "6L37", "5T", "5L37"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "5M"],
			whirlwind: ["7L57", "7L1", "6L1", "5L57"],
		},
	},
	heatmor: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			amnesia: ["7L47", "6L44", "5L46"],
			attract: ["7M", "6M", "5M"],
			belch: ["7E", "6E"],
			bind: ["7L11", "6T", "6L11", "5T", "5L11"],
			bodyslam: ["7E", "6E", "5E"],
			bugbite: ["7L36", "6T", "6L36", "5T", "5L36"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E", "5E"],
			cut: ["6M", "5M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7E", "6E", "5E"],
			fireblast: ["7M", "6M", "5M"],
			firelash: ["7L44"],
			firepunch: ["6T", "5T"],
			firespin: ["7L16", "6L16", "5L16"],
			flameburst: ["7L31", "6L31", "5L31"],
			flamethrower: ["7M", "7L50", "6M", "6L47", "5M", "5L51"],
			flareblitz: ["7L61"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			furyswipes: ["7L21", "6L21", "5L21"],
			gastroacid: ["6T", "5T"],
			gigadrain: ["6T", "5T", "5D"],
			gigaimpact: ["7M", "6M", "5M"],
			heatwave: ["7E", "6T", "6E", "5T", "5E", "5D"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["7L1", "6M", "6L1", "5M"],
			incinerate: ["7L1", "6M", "6L1", "5M", "5L1", "5D"],
			inferno: ["7L66", "6L1", "5L61"],
			knockoff: ["6T", "5T"],
			lick: ["7L1", "6L1", "5L1"],
			lowkick: ["6T", "5T"],
			nightslash: ["7E", "6E", "5E"],
			odorsleuth: ["7L6", "6L6", "5L6"],
			overheat: ["7M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			pursuit: ["7E", "6E", "5E"],
			raindance: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			slash: ["7L41", "6L41", "5L41"],
			sleeptalk: ["7M", "7E", "6M", "6E", "5T", "5E"],
			snatch: ["7L26", "6T", "6L26", "5T", "5L26"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			spitup: ["7L56", "6L50", "5L56"],
			stockpile: ["7L56", "6L50", "5L56"],
			substitute: ["7M", "6M", "5M"],
			suckerpunch: ["7E", "6E", "5E"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			swallow: ["7L56", "6L50", "5L56"],
			tackle: ["7L1", "6L1"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			tickle: ["7E", "6E", "5E"],
			toxic: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M"],
			wrap: ["7E", "6E", "5E"],
		},
	},
	durant: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			agility: ["7L6", "6L16", "5L16"],
			attract: ["7M", "6M", "5M"],
			batonpass: ["7E", "6E", "5E"],
			bite: ["7L1", "6L11", "5L11"],
			bugbite: ["7L16", "6T", "6L26", "5T", "5L26"],
			confide: ["7M", "6M"],
			crunch: ["7L21", "6L31", "5L31"],
			cut: ["6M", "5M"],
			dig: ["7L31", "6M", "6L41", "5M", "5L41"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			endure: ["7E", "6E", "5E", "5D"],
			energyball: ["7M", "6M", "5M"],
			entrainment: ["7L36", "6L46", "5L46"],
			facade: ["7M", "6M", "5M"],
			feintattack: ["7E", "6E", "5E"],
			flashcannon: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furycutter: ["7L1", "6L6", "5L6", "5D"],
			gigaimpact: ["7M", "6M", "5M"],
			guillotine: ["7L51", "7L1", "6L1", "5L61"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			irondefense: ["7L46", "6T", "6L1", "5T", "5L56"],
			ironhead: ["7L26", "6T", "6L36", "5T", "5L36"],
			metalclaw: ["7L11", "6L21", "5L21"],
			metalsound: ["7L56", "7L1", "6L1", "5L66"],
			protect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockclimb: ["7E", "6E", "5E"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sandattack: ["7L1", "6L1", "5L1"],
			sandstorm: ["7M", "6M", "5M"],
			screech: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			thunderfang: ["7E", "6E", "5E", "5D"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			visegrip: ["7L1", "6L1", "5L1"],
			xscissor: ["7M", "7L41", "6M", "6L51", "5M", "5L51"],
		},
	},
	deino: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T"],
			assurance: ["7E", "6E", "5E"],
			astonish: ["7E", "6E", "5E"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L9", "6L9", "5L9"],
			bodyslam: ["7L48", "6L48", "5L48"],
			confide: ["7M", "6M"],
			crunch: ["7L25", "6L25", "5L25"],
			darkpulse: ["7M", "7E", "6M", "6E", "5T", "5E"],
			doublehit: ["7E", "6E", "5E"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "5T"],
			dragonbreath: ["7L17", "6L17", "5L17"],
			dragonpulse: ["7L32", "6T", "6L32", "5T", "5L32"],
			dragonrage: ["7L1", "6L1", "5L1", "5S0"],
			dragonrush: ["7L42", "6L42", "5L42"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["7E", "6T", "6E", "5T", "5E"],
			facade: ["7M", "6M", "5M"],
			firefang: ["7E", "6E", "5E"],
			focusenergy: ["7L4", "6L4", "5L4"],
			frustration: ["7M", "6M", "5M"],
			headbutt: ["7L12", "6L12", "5L12"],
			headsmash: ["7E", "6E", "5E"],
			hiddenpower: ["7M", "6M", "5M"],
			hypervoice: ["7L58", "6T", "6L58", "5T", "5L58"],
			icefang: ["7E", "6E", "5E"],
			incinerate: ["6M", "5M"],
			outrage: ["7L62", "6T", "6L62", "5T", "5L62"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "7L20", "6M", "6L20", "5M", "5L20"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L50", "6L50", "5L52"],
			screech: ["7E", "6E", "5E"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			slam: ["7L28", "6L28", "5L28"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			tackle: ["7L1", "6L1", "5L1", "5S0"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thunderfang: ["7E", "6E", "5E"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			workup: ["7M", "7L38", "6L38", "5M", "5L38"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	zweilous: {
		inherit: true,
		learnset: {
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L9", "7L1", "6L1", "5L1"],
			bodyslam: ["7L48", "6L48", "5L48"],
			confide: ["7M", "6M"],
			crunch: ["7L25", "6L25", "5L25"],
			darkpulse: ["7M", "6M", "5T"],
			doublehit: ["7L1", "6L1", "5L1"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "5T"],
			dragonbreath: ["7L17", "6L17", "5L17"],
			dragonpulse: ["7L32", "6T", "6L32", "5T", "5L32"],
			dragonrage: ["7L1", "6L1", "5L1"],
			dragonrush: ["7L42", "6L42", "5L42"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			focusenergy: ["7L4", "7L1", "6L1", "5L1"],
			frustration: ["7M", "6M", "5M"],
			headbutt: ["7L12", "6L12", "5L12"],
			hiddenpower: ["7M", "6M", "5M"],
			hypervoice: ["7L64", "6T", "6L64", "5T", "5L64"],
			incinerate: ["6M", "5M"],
			outrage: ["7L71", "6T", "6L71", "5T", "5L71"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "7L20", "6M", "6L20", "5M", "5L20"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L55", "6L55", "5L55"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			slam: ["7L28", "6L28", "5L28"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			workup: ["7M", "7L38", "6L38", "5M", "5L38"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	hydreigon: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aquatail: ["6T", "5T"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L9", "7L1", "6L1", "5L1"],
			bodyslam: ["7L48", "6L48", "5L48"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M", "5M"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crunch: ["7L25", "6L25", "6S1", "5L25"],
			darkpulse: ["7M", "6M", "5T"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "5T"],
			dragonbreath: ["7L17", "6L17", "5L17", "5S0"],
			dragonpulse: ["7L32", "6T", "6L32", "5T", "5L32"],
			dragonrage: ["7L1", "6L1", "5L1"],
			dragonrush: ["7L42", "6L42", "6S1", "5L42"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M"],
			echoedvoice: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M", "5S0"],
			flashcannon: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M", "5S0"],
			focusenergy: ["7L4", "7L1", "6L1", "5L1"],
			frustration: ["7M", "6M", "6S1", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			headbutt: ["7L12", "6L12", "5L12"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["7L68", "7L1", "6T", "6L1", "5T", "5L68", "5S0"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			outrage: ["7L79", "7L1", "6T", "6L1", "5T", "5L79"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "7L20", "6M", "6L20", "5M", "5L20"],
			rockslide: ["7M", "6M", "6S1", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			scaryface: ["7L55", "6L55", "5L55"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			slam: ["7L28", "6L28", "5L28"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			spite: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["6T", "5T"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			triattack: ["7L1", "6L1", "5L1"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "6M", "5M"],
			workup: ["7M", "7L38", "6L38", "5M", "5L38"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	larvesta: {
		inherit: true,
		learnset: {
			absorb: ["7L10"],
			acrobatics: ["7M", "6M", "5M"],
			amnesia: ["7L80", "6L80", "5L80"],
			bugbite: ["7L40", "6T", "6L40", "5T", "5L40"],
			bugbuzz: ["7L70", "6L70", "5L70"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			doubleedge: ["7L50", "6L50", "5L50"],
			doubleteam: ["7M", "6M", "5M"],
			ember: ["7L1", "6L1", "5L1"],
			endure: ["7E", "6E", "5E"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "6M", "5M"],
			flamecharge: ["7M", "7L30", "6M", "6L30", "5M", "5L30"],
			flamethrower: ["7M", "6M", "5M"],
			flamewheel: ["7L60", "6L60", "5L60"],
			flareblitz: ["7L100", "6L100", "5L100"],
			foresight: ["7E", "6E", "5E"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			harden: ["7E", "6E", "5E"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			leechlife: ["7M", "6L10", "5L10"],
			lightscreen: ["7M", "6M", "5M"],
			magnetrise: ["7E", "6T", "6E", "5T", "5E"],
			morningsun: ["7E", "6E", "5E"],
			overheat: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			signalbeam: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stringshot: ["7L1", "7E", "6L1", "6E", "5L1", "5E"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			takedown: ["7L20", "6L20", "5L20"],
			thrash: ["7L90", "6L90", "5L90"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M"],
			zenheadbutt: ["7E", "6T", "6E", "5T", "5E"],
		},
	},
	volcarona: {
		inherit: true,
		learnset: {
			absorb: ["7L10", "7L1"],
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M"],
			amnesia: ["7L1", "6L1"],
			bugbite: ["6T", "5T"],
			bugbuzz: ["7L70", "7L1", "6L1", "5L70", "5S1"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			ember: ["7L1", "6L1", "5L1"],
			facade: ["7M", "6M", "5M"],
			fierydance: ["7L100", "7L1", "6L1", "5L100"],
			fireblast: ["7M", "6M", "5M"],
			firespin: ["7L30", "6L30", "5L30", "5S0"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "6M", "5M"],
			flamewheel: ["7L1", "6L1"],
			flareblitz: ["7L1", "6L1"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			gust: ["7L20", "7L1", "6L1", "5L1", "5S0"],
			heatwave: ["7L60", "7L1", "6T", "6L1", "5T", "5L60"],
			hiddenpower: ["7M", "6M", "5M"],
			hurricane: ["7L90", "7L1", "6L1", "5L90"],
			hyperbeam: ["7M", "6M", "5M", "5S1"],
			incinerate: ["6M", "5M"],
			leechlife: ["7M", "6L1", "5L1", "5S0"],
			lightscreen: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T"],
			overheat: ["7M", "6M", "5M", "5S1"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			quiverdance: ["7L1", "6L1", "5L59", "5S1"],
			ragepowder: ["7L80", "7L1", "6L1", "5L80"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			signalbeam: ["6T", "5T"],
			silverwind: ["7L50", "6L50", "5L50"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stringshot: ["7L1", "6L1", "5L1", "5S0"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["6T", "5T"],
			thrash: ["7L1", "6L1"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "5M"],
			whirlwind: ["7L40", "6L40", "5L40"],
			wildcharge: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	cobalion: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			bounce: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M"],
			closecombat: ["7L61", "7L1", "6L1", "5L73"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doublekick: ["7L1", "6L7", "5L7"],
			doubleteam: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			helpinghand: ["7L13", "6T", "6L25", "5T", "5L25", "5S0", "5S1"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			irondefense: ["6T", "5T"],
			ironhead: ["7L25", "6T", "6L37", "6S3", "5T", "5L37", "5S0", "5S1"],
			leer: ["7L1", "6L1", "5L1"],
			magnetrise: ["6T", "5T"],
			metalburst: ["7L55", "7L1", "6L1", "5L67"],
			metalclaw: ["7L1", "6L13", "5L13"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			quickattack: ["7L1", "6L1", "5L1"],
			quickguard: ["7L42", "6L1", "5L55", "5S2"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L19", "6M", "6L31", "6S3", "5M", "5L31", "5S0", "5S1"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			sacredsword: ["7L31", "6L42", "6S3", "5L42", "5S0", "5S1", "5S2"],
			safeguard: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L37", "6M", "6L49", "6S3", "5M", "5L49", "5S2"],
			takedown: ["7L7", "6L19", "5L19"],
			taunt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			workup: ["7M", "7L49", "6L1", "5M", "5L61", "5S2"],
			xscissor: ["7M", "6M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	terrakion: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			bulldoze: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			closecombat: ["7L61", "7L1", "6L1", "5L73"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doublekick: ["7L1", "6L7", "5L7"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			earthquake: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			helpinghand: ["7L13", "6T", "6L25", "5T", "5L25", "5S0", "5S1"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			ironhead: ["6T", "5T"],
			leer: ["7L1", "6L1", "5L1"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			quickattack: ["7L1", "6L1", "5L1"],
			quickguard: ["7L42", "6L1", "5L55", "5S2"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L19", "6M", "6L31", "6S3", "5M", "5L31", "5S0", "5S1"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L25", "6M", "6L37", "6S3", "5M", "5L37", "5S0", "5S1"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			sacredsword: ["7L31", "6L42", "6S3", "5L42", "5S0", "5S1", "5S2"],
			safeguard: ["7M", "6M", "5M"],
			sandstorm: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			smackdown: ["7M", "7L1", "6M", "6L13", "5M", "5L13"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			stoneedge: ["7M", "7L55", "6M", "6L67", "5M", "5L67"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L37", "6M", "6L49", "6S3", "5M", "5L49", "5S2"],
			takedown: ["7L7", "6L19", "5L19"],
			taunt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			workup: ["7M", "7L49", "6L1", "5M", "5L61", "5S2"],
			xscissor: ["7M", "6M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	virizion: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			block: ["6T", "5T"],
			bounce: ["6T", "5T"],
			calmmind: ["7M", "6M", "5M"],
			closecombat: ["7L61", "7L1", "6L1", "5L73"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doublekick: ["7L1", "6L7", "5L7"],
			doubleteam: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigadrain: ["7L25", "6T", "6L37", "6S3", "5T", "5L37", "5S0", "5S1"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			helpinghand: ["7L13", "6T", "6L25", "5T", "5L25", "5S0", "5S1"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			leafblade: ["7L55", "7L1", "6L1", "5L67"],
			leer: ["7L1", "6L1", "5L1"],
			lightscreen: ["7M", "6M", "5M"],
			magicalleaf: ["7L1", "6L13", "5L13"],
			naturepower: ["7M", "6M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			quickattack: ["7L1", "6L1", "5L1"],
			quickguard: ["7L42", "6L1", "5L55", "5S2"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L19", "6M", "6L31", "6S3", "5M", "5L31", "5S0", "5S1"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			sacredsword: ["7L31", "6L42", "6S3", "5L42", "5S0", "5S1", "5S2"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			seedbomb: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L37", "6M", "6L49", "6S3", "5M", "5L49", "5S2"],
			synthesis: ["6T", "5T"],
			takedown: ["7L7", "6L19", "5L19"],
			taunt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			workup: ["7M", "7L49", "6L1", "5M", "5L61", "5S2"],
			worryseed: ["6T", "5T"],
			xscissor: ["7M", "6M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	tornadus: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M", "5M"],
			aerialace: ["7M", "6M", "5M"],
			agility: ["7L31", "6L37", "6S3", "5L37", "5S0"],
			aircutter: ["7L19", "6L25", "5L25", "5S0"],
			airslash: ["7L37", "6L43", "6S3", "5L43", "5S2"],
			astonish: ["7L1", "6L1", "5L1", "5S1"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L7", "6L13", "5L13"],
			brickbreak: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crunch: ["7L43", "6L49", "6S3", "5L49"],
			darkpulse: ["7M", "7L67", "6M", "6L73", "5T", "5L73"],
			doubleteam: ["7M", "6M", "5M"],
			embargo: ["7M", "6M", "5M"],
			extrasensory: ["7L25", "6L31", "6S3", "5L31", "5S0"],
			facade: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gust: ["7L1", "6L1", "5L1", "5S1"],
			hammerarm: ["7L73", "7L1", "6L1", "5L79", "5S2"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M", "5S2"],
			hurricane: ["7L61", "7L1", "6L1", "5L67", "5S2"],
			hyperbeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			raindance: ["7M", "7L55", "6M", "6L61", "5M", "5L61"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			revenge: ["7L13", "6L19", "5L19", "5S0"],
			rocksmash: ["6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			skydrop: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			sludgewave: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "7L1", "6M", "6L7", "5M", "5L7"],
			tailwind: ["7L49", "6T", "6L1", "5T", "5L55"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thrash: ["7L79", "7L1", "6L1", "5L85"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7L1", "6T", "6L1", "5T", "5L1", "5S1"],
			uturn: ["7M", "6M", "5M"],
		},
	},
	thundurus: {
		inherit: true,
		learnset: {
			agility: ["7L31", "6L37", "6S3", "5L37", "5S0"],
			astonish: ["7L1", "6L1", "5L1", "5S1"],
			attract: ["7M", "6M", "5M"],
			bite: ["7L7", "6L13", "5L13"],
			brickbreak: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "6M", "5M"],
			charge: ["7L49", "6L1", "5L55"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crunch: ["7L43", "6L49", "6S3", "5L49"],
			darkpulse: ["7M", "7L67", "6M", "6L73", "5T", "5L73"],
			discharge: ["7L37", "6L43", "6S3", "5L43"],
			doubleteam: ["7M", "6M", "5M"],
			electroweb: ["6T"],
			embargo: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M", "5S2"],
			foulplay: ["6T", "5T"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			hammerarm: ["7L73", "7L1", "6L1", "5L79", "5S2"],
			healblock: ["7L25", "6L31", "6S3", "5L31", "5S0"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			incinerate: ["6M", "5M"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			nastyplot: ["7L55", "7L1", "6L1", "5L61"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			revenge: ["7L13", "6L19", "5L19", "5S0"],
			rocksmash: ["6M", "5M"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shockwave: ["7L19", "6T", "6L25", "5L25", "5S0"],
			skydrop: ["7M", "6M", "5M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			sludgewave: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			smartstrike: ["7M"],
			snore: ["6T", "5T"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "7L1", "6M", "6L7", "5M", "5L7"],
			taunt: ["7M", "6M", "5M"],
			thief: ["7M", "6M", "5M"],
			thrash: ["7L79", "7L1", "6L1", "5L85"],
			thunder: ["7M", "7L61", "6M", "6L67", "5M", "5L67", "5S2"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			thundershock: ["7L1", "6L1", "5L1", "5S1"],
			thunderwave: ["7M", "6M", "5M"],
			torment: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			uproar: ["7L1", "6T", "6L1", "5T", "5L1", "5S1"],
			uturn: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M", "5S2"],
		},
	},
	reshiram: {
		inherit: true,
		learnset: {
			ancientpower: ["7L15", "6L15", "5L15"],
			blueflare: ["7L100", "6L100", "5L100", "5S2"],
			brutalswing: ["7M"],
			confide: ["7M", "6M"],
			crunch: ["7L71", "6L71", "5L71"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "5T", "5S2"],
			dragonbreath: ["7L29", "6L29", "6S3", "5L29", "5S0"],
			dragonclaw: ["7M", "6M", "5M"],
			dragonpulse: ["7L54", "6T", "6L54", "5T", "5L54", "5S1"],
			dragonrage: ["7L1", "6L1", "5L1"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			extrasensory: ["7L43", "6L43", "6S3", "5L43", "5S0", "5S1"],
			facade: ["7M", "6M", "5M"],
			fireblast: ["7M", "7L78", "6M", "6L78", "5M", "5L78"],
			firefang: ["7L1", "6L1", "5L1"],
			flamecharge: ["7M", "6M", "5M"],
			flamethrower: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			fling: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			fusionflare: ["7L50", "6L50", "6S3", "5L50", "5S0", "5S1", "5S2"],
			gigaimpact: ["7M", "6M", "5M"],
			heatwave: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["7L92", "6T", "6L92", "5T", "5L92"],
			imprison: ["7L64", "7L8", "6L8", "5L8", "5S1"],
			incinerate: ["6M", "5M"],
			lightscreen: ["7M", "6M", "5M"],
			mist: ["5S2"],
			outrage: ["7L85", "6T", "6L85", "5T", "5L85"],
			overheat: ["7M", "6M", "5M"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shadowclaw: ["7M", "6M", "5M"],
			slash: ["7L36", "6L36", "6S3", "5L36", "5S0"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "5M"],
			steelwing: ["7M", "6M"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["6T", "5T"],
			toxic: ["7M", "6M", "5M"],
			willowisp: ["7M", "6M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	zekrom: {
		inherit: true,
		learnset: {
			ancientpower: ["7L15", "6L15", "5L15"],
			boltstrike: ["7L100", "6L100", "5L100", "5S2"],
			brutalswing: ["7M"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			crunch: ["7L71", "6L71", "5L71"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "5T"],
			dragonbreath: ["7L29", "6L29", "6S3", "5L29", "5S0"],
			dragonclaw: ["7M", "7L54", "6M", "6L54", "5M", "5L54", "5S1"],
			dragonpulse: ["6T", "5T"],
			dragonrage: ["7L1", "6L1", "5L1"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			fusionbolt: ["7L50", "6L50", "6S3", "5L50", "5S0", "5S1", "5S2"],
			gigaimpact: ["7M", "6M", "5M"],
			haze: ["5S2"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["7L92", "6T", "6L92", "5T", "5L92"],
			imprison: ["7L64", "7L8", "6L8", "5L8", "5S1"],
			lightscreen: ["7M", "6M", "5M"],
			magnetrise: ["6T", "5T"],
			outrage: ["7L85", "6T", "6L85", "5T", "5L85", "5S2"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shadowclaw: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			slash: ["7L36", "6L36", "6S3", "5L36", "5S0"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			tailwind: ["6T", "5T"],
			thunder: ["7M", "7L78", "6M", "6L78", "5M", "5L78"],
			thunderbolt: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			thunderfang: ["7L1", "6L1", "5L1"],
			thunderpunch: ["6T", "5T"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			voltswitch: ["7M", "6M", "5M"],
			wildcharge: ["7M", "6M", "5M"],
			zenheadbutt: ["7L43", "6T", "6L43", "6S3", "5T", "5L43", "5S0", "5S1"],
		},
	},
	landorus: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M", "5M"],
			block: ["7L1", "6T", "6L1", "5T", "5L1", "5S1"],
			brickbreak: ["7M", "6M", "5M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "6M", "5M"],
			bulldoze: ["7M", "7L13", "6M", "6L19", "5M", "5L19"],
			calmmind: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			dig: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			earthpower: ["7L37", "6T", "6L43", "6S2", "5T", "5L43"],
			earthquake: ["7M", "7L49", "6M", "6L55", "6S3", "5M", "5L55", "5S0"],
			explosion: ["7M", "6M", "6S2", "5M"],
			extrasensory: ["7L25", "6L31", "5L31"],
			facade: ["7M", "6M", "5M"],
			fissure: ["7L61", "7L1", "6L1", "5L67", "5S0"],
			fling: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			hammerarm: ["7L73", "7L1", "6L1", "5L79"],
			hiddenpower: ["7M", "6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			imprison: ["7L1", "6L7", "5L7"],
			irontail: ["6T", "5T"],
			knockoff: ["6T", "6S3", "5T"],
			mudshot: ["7L1", "6L1", "5L1", "5S1"],
			outrage: ["7L79", "7L1", "6T", "6L1", "5T", "5L85"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			punishment: ["7L7", "6L13", "5L13"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			rockslide: ["7M", "7L43", "6M", "6L49", "6S2", "5M", "5L49", "5S0"],
			rocksmash: ["6M", "5M"],
			rockthrow: ["7L19", "6L25", "5L25"],
			rocktomb: ["7M", "7L1", "6M", "6L1", "6S3", "5M", "5L1", "5S1"],
			roleplay: ["6T", "5T"],
			round: ["7M", "6M", "5M"],
			sandstorm: ["7M", "7L55", "6M", "6L61", "5M", "5L61", "5S0"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M", "5T"],
			sludgebomb: ["7M", "6M", "5M"],
			sludgewave: ["7M", "6M", "5M"],
			smackdown: ["7M", "6M", "5M"],
			snore: ["6T", "5T"],
			stealthrock: ["6T", "5T"],
			stoneedge: ["7M", "7L67", "6M", "6L73", "5M", "5L73"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L31", "6M", "6L37", "6S2", "5M", "5L37"],
			toxic: ["7M", "6M", "5M"],
			uturn: ["7M", "6M", "6S3", "5M"],
		},
	},
	kyurem: {
		inherit: true,
		learnset: {
			ancientpower: ["7L15", "6L15", "5L15"],
			blizzard: ["7M", "7L78", "6M", "6L78", "5M", "5L78"],
			brutalswing: ["7M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "6S3", "5T"],
			dragonbreath: ["7L29", "6L29", "6S2", "5L29"],
			dragonclaw: ["7M", "6M", "5M"],
			dragonpulse: ["7L57", "6T", "6L57", "5T", "5L57", "5S0", "5S1"],
			dragonrage: ["7L1", "6L1", "5L1"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L71", "6T", "6L71", "5T", "5L71", "5S0"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			glaciate: ["7L50", "6L50", "6S2", "6S3", "5L50", "5S0", "5S1"],
			hail: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["7L92", "6T", "6L92", "5T", "5L92"],
			icebeam: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			icywind: ["7L1", "6T", "6L1", "5T", "5L1"],
			imprison: ["7L64", "7L8", "6L8", "5L8", "5S0", "5S1"],
			ironhead: ["6T", "6S3", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			outrage: ["7L85", "6T", "6L85", "5T", "5L85"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			scaryface: ["7L43", "6L43", "6S2", "6S3", "5L43", "5S1"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shadowclaw: ["7M", "6M", "5M"],
			signalbeam: ["6T", "5T"],
			slash: ["7L36", "6L36", "6S2", "5L36"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	kyuremblack: {
		inherit: true,
		learnset: {
			ancientpower: ["7L15", "6L15", "5L15"],
			blizzard: ["7M", "7L78", "6M", "6L78", "5M", "5L78"],
			brutalswing: ["7M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "6S3", "5T"],
			dragonbreath: ["7L29", "6L29", "6S2", "5L29"],
			dragonclaw: ["7M", "6M", "5M"],
			dragonpulse: ["7L57", "6T", "6L57", "5T", "5L57", "5S0", "5S1"],
			dragonrage: ["7L1", "6L1", "5L1"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L71", "6T", "6L71", "5T", "5L71", "5S0"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			freezeshock: ["7L50", "6L50", "6S2", "6S3", "5L43", "5S0", "5S1"],
			frustration: ["7M", "6M", "5M"],
			fusionbolt: ["7L43", "6L43", "6S2", "6S3", "5L50", "5S1"],
			gigaimpact: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["7L92", "6T", "6L92", "5T", "5L92"],
			icebeam: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			icywind: ["7L1", "6T", "6L1", "5T", "5L1"],
			imprison: ["7L64", "7L8", "6L8", "5L8", "5S0", "5S1"],
			ironhead: ["6T", "6S3", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			outrage: ["7L85", "6T", "6L85", "5T", "5L85"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shadowclaw: ["7M", "6M", "5M"],
			signalbeam: ["6T", "5T"],
			slash: ["7L36", "6L36", "6S2", "5L36"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	kyuremwhite: {
		inherit: true,
		learnset: {
			ancientpower: ["7L15", "6L15", "5L15"],
			blizzard: ["7M", "7L78", "6M", "6L78", "5M", "5L78"],
			brutalswing: ["7M"],
			confide: ["7M", "6M"],
			cut: ["6M", "5M"],
			doubleteam: ["7M", "6M", "5M"],
			dracometeor: ["7T", "6T", "6S3", "5T"],
			dragonbreath: ["7L29", "6L29", "6S2", "5L29"],
			dragonclaw: ["7M", "6M", "5M"],
			dragonpulse: ["7L57", "6T", "6L57", "5T", "5L57", "5S0", "5S1"],
			dragonrage: ["7L1", "6L1", "5L1"],
			dragontail: ["7M", "6M", "5M"],
			earthpower: ["6T", "5T"],
			echoedvoice: ["7M", "6M", "5M"],
			endeavor: ["7L71", "6T", "6L71", "5T", "5L71", "5S0"],
			facade: ["7M", "6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			fling: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			fusionflare: ["7L43", "6L43", "6S2", "6S3", "5L50", "5S1"],
			gigaimpact: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["7L92", "6T", "6L92", "5T", "5L92"],
			icebeam: ["7M", "7L22", "6M", "6L22", "5M", "5L22"],
			iceburn: ["7L50", "6L50", "6S2", "6S3", "5L43", "5S0", "5S1"],
			icywind: ["7L1", "6T", "6L1", "5T", "5L1"],
			imprison: ["7L64", "7L8", "6L8", "5L8", "5S0", "5S1"],
			ironhead: ["6T", "6S3", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			outrage: ["7L85", "6T", "6L85", "5T", "5L85"],
			payback: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockslide: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			rocktomb: ["7M", "6M", "5M"],
			roost: ["7M", "6M", "5T"],
			round: ["7M", "6M", "5M"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shadowclaw: ["7M", "6M", "5M"],
			signalbeam: ["6T", "5T"],
			slash: ["7L36", "6L36", "6S2", "5L36"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			steelwing: ["7M", "6M"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	keldeo: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			aquajet: ["7L1", "6L1", "6S2", "6S3", "5L1", "5S0", "5S1"],
			aquatail: ["7L37", "6T", "6L37", "5T", "5L37"],
			bounce: ["6T", "5T"],
			bubblebeam: ["7L13", "7L1", "6L13", "6S3", "5L13", "5S0"],
			calmmind: ["7M", "6M", "5M"],
			closecombat: ["7L73", "6L73", "5L73"],
			confide: ["7M", "6M"],
			covet: ["6T", "5T"],
			cut: ["6M", "5M"],
			doublekick: ["7L7", "7L1", "6L7", "6S2", "6S3", "5L7", "5S0"],
			doubleteam: ["7M", "6M", "5M"],
			endeavor: ["6T", "5T"],
			facade: ["7M", "6M", "5M"],
			falseswipe: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			hail: ["7M", "6M", "5M"],
			helpinghand: ["7L25", "6T", "6L25", "5T", "5L25"],
			hiddenpower: ["7M", "6M", "5M"],
			hydropump: ["7L67", "6L67", "6S2", "5L67", "5S1"],
			hyperbeam: ["7M", "6M", "5M"],
			icywind: ["6T", "5T"],
			lastresort: ["6T", "5T"],
			leer: ["7L1", "6L1", "6S2", "6S3", "5L1", "5S0"],
			poisonjab: ["7M", "6M", "5M"],
			protect: ["7M", "6M", "5M"],
			psychup: ["7M", "6M", "5M"],
			quickguard: ["7L55", "6L55", "5L55"],
			raindance: ["7M", "6M", "5M"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["7L31", "6M", "6L31", "5M", "5L31"],
			return: ["7M", "6M", "5M"],
			roar: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			round: ["7M", "6M", "5M"],
			sacredsword: ["7L43", "6L43", "5L43", "5S1"],
			safeguard: ["7M", "6M", "5M"],
			scald: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			secretsword: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			superpower: ["6T", "5T"],
			surf: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			swordsdance: ["7M", "7L49", "6M", "6L49", "5M", "5L49", "5S1"],
			takedown: ["7L19", "6L19", "5L19"],
			taunt: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			waterpulse: ["6T"],
			workup: ["7M", "7L61", "6L61", "5M", "5L61"],
			xscissor: ["7M", "6M", "5M"],
		},
	},
	meloetta: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L26", "6M", "6L26", "5M", "5L26"],
			brickbreak: ["7M", "6M", "5M"],
			calmmind: ["7M", "6M", "5M"],
			chargebeam: ["7M", "6M", "5M"],
			closecombat: ["7L78", "6L78", "5L78", "5S1"],
			confide: ["7M", "6M"],
			confusion: ["7L11", "7L1", "6L11", "5L11", "5S0"],
			covet: ["6T", "5T"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M", "5M"],
			drainpunch: ["6T", "5T"],
			dreameater: ["7M", "6M", "5M"],
			dualchop: ["6T", "5T"],
			echoedvoice: ["7M", "7L36", "6M", "6L36", "5M", "5L36"],
			embargo: ["7M", "6M", "5M"],
			energyball: ["7M", "6M", "5M"],
			facade: ["7M", "6M", "5M"],
			firepunch: ["6T", "5T"],
			flash: ["6M", "5M"],
			fling: ["7M", "6M", "5M"],
			focusblast: ["7M", "6M", "5M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M", "5M"],
			gigaimpact: ["7M", "6M", "5M"],
			grassknot: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			healbell: ["6T", "5T"],
			helpinghand: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "6M", "5M"],
			hypervoice: ["7L64", "6T", "6L64", "5T", "5L64"],
			icepunch: ["6T", "5T"],
			knockoff: ["6T", "5T"],
			lastresort: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			lowkick: ["6T", "5T"],
			lowsweep: ["7M", "6M", "5M"],
			magiccoat: ["6T", "5T"],
			magicroom: ["6T", "5T"],
			payback: ["7M", "6M", "5M"],
			perishsong: ["7L85", "6L85", "5L85"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M", "5M"],
			psybeam: ["7L31", "6L31", "5L31"],
			psychic: ["7M", "7L57", "6M", "6L57", "5M", "5L57", "5S1"],
			psychup: ["7M", "6M", "5M"],
			psyshock: ["7M", "6M", "5M"],
			quickattack: ["7L6", "7L1", "6L6", "5L6", "5S0"],
			raindance: ["7M", "6M", "5M"],
			recycle: ["6T", "5T"],
			relicsong: ["6T", "5T"],
			rest: ["7M", "6M", "5M"],
			retaliate: ["6M", "5M"],
			return: ["7M", "6M", "5M"],
			rocksmash: ["6M", "5M"],
			roleplay: ["7L71", "6T", "6L71", "5T", "5L71"],
			round: ["7M", "7L1", "6M", "6L1", "5M", "5L1", "5S0", "5S1"],
			safeguard: ["7M", "6M", "5M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "5M"],
			shadowclaw: ["7M", "6M", "5M"],
			shockwave: ["6T"],
			signalbeam: ["6T", "5T"],
			sing: ["7L16", "7L1", "6L16", "5L16"],
			skillswap: ["6T", "5T"],
			sleeptalk: ["7M", "6M", "5T"],
			snatch: ["6T", "5T"],
			snore: ["6T", "5T"],
			stoneedge: ["7M", "6M", "5M"],
			strength: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			sunnyday: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			teeterdance: ["7L21", "6L21", "5L21", "5S1"],
			telekinesis: ["5M"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderpunch: ["6T", "5T"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			trick: ["6T", "5T"],
			trickroom: ["7M", "6M", "5M"],
			uproar: ["6T", "5T"],
			uturn: ["7M", "7L43", "6M", "6L43", "5M", "5L43"],
			wakeupslap: ["7L50", "6L50", "5L50"],
			wonderroom: ["6T", "5T"],
			workup: ["7M", "5M"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	genesect: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M", "5M"],
			blazekick: ["5S2"],
			blizzard: ["7M", "6M", "5M"],
			bugbite: ["6T", "5T"],
			bugbuzz: ["7L55", "6L55", "5L55"],
			chargebeam: ["7M", "6M", "5M"],
			confide: ["7M", "6M"],
			darkpulse: ["7M", "6M", "5T"],
			doubleteam: ["7M", "6M", "5M"],
			electroweb: ["6T", "5T"],
			energyball: ["7M", "6M", "5M"],
			explosion: ["7M", "6M", "5M"],
			extremespeed: ["5S2"],
			facade: ["7M", "6M", "5M"],
			fellstinger: ["7L1", "6L1"],
			flamecharge: ["7M", "7L18", "6M", "6L18", "5M", "5L18"],
			flamethrower: ["7M", "6M", "5M"],
			flash: ["6M", "5M"],
			flashcannon: ["7M", "6M", "5M"],
			fly: ["7M", "6M", "5M"],
			frustration: ["7M", "6M", "5M"],
			furycutter: ["7L7", "6L7", "5L7"],
			gigadrain: ["6T", "5T"],
			gigaimpact: ["7M", "6M", "5M"],
			gravity: ["6T", "5T"],
			gunkshot: ["6T", "5T"],
			hiddenpower: ["7M", "6M", "5M"],
			honeclaws: ["6M", "5M"],
			hyperbeam: ["7M", "7L73", "6M", "6L73", "5M", "5L73"],
			icebeam: ["7M", "6M", "5M"],
			infestation: ["7M", "6M"],
			irondefense: ["6T", "5T"],
			ironhead: ["6T", "5T"],
			lastresort: ["6T", "5T"],
			lightscreen: ["7M", "6M", "5M"],
			lockon: ["7L11", "6L11", "5L11"],
			magiccoat: ["6T", "5T"],
			magnetbomb: ["7L22", "6L22", "6S3", "5L22", "5S0", "5S1"],
			magnetrise: ["7L1", "6T", "6L1", "5T", "5L1"],
			metalclaw: ["7L1", "6L1", "5L1"],
			metalsound: ["7L33", "6L33", "5L33"],
			protect: ["7M", "6M", "5M"],
			psychic: ["7M", "6M", "5M"],
			quickattack: ["7L1", "6L1", "5L1"],
			recycle: ["6T", "5T"],
			reflect: ["7M", "6M", "5M"],
			rest: ["7M", "6M", "5M"],
			return: ["7M", "6M", "5M"],
			rockpolish: ["7M", "6M", "5M"],
			round: ["7M", "6M", "5M"],
			screech: ["7L1", "6L1", "5L1"],
			secretpower: ["6M"],
			selfdestruct: ["7L77", "6L77", "5L77"],
			shadowclaw: ["7M", "6M", "5M"],
			shiftgear: ["5S2"],
			shockwave: ["6T"],
			signalbeam: ["7L40", "6T", "6L40", "6S3", "5T", "5L40", "5S0", "5S1"],
			simplebeam: ["7L62", "6L62", "5L62"],
			slash: ["7L29", "6L29", "5L29"],
			sleeptalk: ["7M", "6M", "5T"],
			snore: ["6T", "5T"],
			solarbeam: ["7M", "6M", "6S3", "5M", "5S0", "5S1"],
			strugglebug: ["6M", "5M"],
			substitute: ["7M", "6M", "5M"],
			swagger: ["7M", "6M", "5M"],
			technoblast: ["7L1", "6L1", "6S3", "5L1", "5S0", "5S1", "5S2"],
			thunder: ["7M", "6M", "5M"],
			thunderbolt: ["7M", "6M", "5M"],
			thunderwave: ["7M", "6M", "5M"],
			toxic: ["7M", "6M", "5M"],
			triattack: ["7L44", "6L44", "5L44"],
			uturn: ["7M", "6M", "5M"],
			xscissor: ["7M", "7L51", "6M", "6L51", "5M", "5L51"],
			zapcannon: ["7L66", "6L66", "5L66"],
			zenheadbutt: ["6T", "5T"],
		},
	},
	chespin: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			attract: ["7M", "6M"],
			bellydrum: ["7E", "6E"],
			bite: ["7L11", "6L11"],
			bodyslam: ["7L42", "6L42"],
			brickbreak: ["7M", "6M"],
			bulkup: ["7M", "7L39", "6M", "6L39"],
			bulldoze: ["7M", "6M"],
			confide: ["7M", "6M"],
			curse: ["7E", "6E"],
			cut: ["6M"],
			defensecurl: ["7E", "6E"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			drainpunch: ["6T"],
			dualchop: ["6T"],
			endeavor: ["6T"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			fling: ["7M", "6M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			grassknot: ["7M", "6M"],
			grasspledge: ["7T", "6T"],
			growl: ["7L1", "6L1"],
			gyroball: ["7M", "6M"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			irondefense: ["6T"],
			ironhead: ["6T"],
			irontail: ["6T"],
			leechseed: ["7L15", "6L15"],
			lowkick: ["6T"],
			lowsweep: ["7M", "6M"],
			mudshot: ["7L35", "6L35"],
			naturepower: ["7M", "6M"],
			painsplit: ["7L45", "6T", "6L45"],
			payback: ["7M", "6M"],
			pinmissile: ["7L18", "6L18"],
			poisonjab: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			quickguard: ["7E", "6E"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			rollout: ["7L8", "7E", "6L8", "6E"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			seedbomb: ["7L32", "6T", "6L32"],
			shadowclaw: ["7M", "6M"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			smackdown: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			spikes: ["7E", "6E"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superfang: ["6T"],
			superpower: ["6T"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "6M"],
			synthesis: ["7E", "6T", "6E"],
			tackle: ["6L1"],
			takedown: ["7L27", "6L27"],
			taunt: ["7M", "6M"],
			thunderpunch: ["6T"],
			toxic: ["7M", "6M"],
			vinewhip: ["7L5", "7L1", "6L5"],
			woodhammer: ["7L48", "6L48"],
			workup: ["7M"],
			worryseed: ["6T"],
			zenheadbutt: ["6T"],
		},
	},
	quilladin: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			attract: ["7M", "6M"],
			bite: ["7L11", "6L11"],
			bodyslam: ["7L48", "6L48"],
			brickbreak: ["7M", "6M"],
			bulkup: ["7M", "7L44", "6M", "6L44"],
			bulldoze: ["7M", "6M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			drainpunch: ["6T"],
			dualchop: ["6T"],
			endeavor: ["6T"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			fling: ["7M", "6M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			grassknot: ["7M", "6M"],
			grasspledge: ["7T", "6T"],
			growl: ["7L1", "6L1"],
			gyroball: ["7M", "6M"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["6M"],
			irondefense: ["6T"],
			ironhead: ["6T"],
			irontail: ["6T"],
			leechseed: ["7L15", "6L15"],
			lowkick: ["6T"],
			lowsweep: ["7M", "6M"],
			mudshot: ["7L39", "6L39"],
			naturepower: ["7M", "6M"],
			needlearm: ["7L1", "6L26"],
			painsplit: ["7L52", "6T", "6L52"],
			payback: ["7M", "6M"],
			pinmissile: ["7L19", "6L20"],
			poisonjab: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			rollout: ["7L8", "6L8"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			seedbomb: ["7L35", "6T", "6L35"],
			shadowclaw: ["7M", "6M"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			smackdown: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superfang: ["6T"],
			superpower: ["6T"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "6M"],
			synthesis: ["6T"],
			tackle: ["6L1"],
			takedown: ["7L29", "6L30"],
			taunt: ["7M", "6M"],
			thunderpunch: ["6T"],
			toxic: ["7M", "6M"],
			vinewhip: ["7L5", "7L1", "6L5"],
			woodhammer: ["7L56", "6L55"],
			workup: ["7M"],
			worryseed: ["6T"],
			zenheadbutt: ["6T"],
		},
	},
	chesnaught: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			attract: ["7M", "6M"],
			bellydrum: ["7L1", "6L1"],
			bite: ["7L11", "6L11"],
			block: ["6T"],
			bodyslam: ["7L54", "6L48"],
			brickbreak: ["7M", "6M"],
			bulkup: ["7M", "7L48", "6M", "6L44"],
			bulldoze: ["7M", "6M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			dragonclaw: ["7M", "6M"],
			drainpunch: ["6T"],
			dualchop: ["6T"],
			earthquake: ["7M", "6M"],
			endeavor: ["6T"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			feint: ["7L1", "6L1"],
			flash: ["6M"],
			fling: ["7M", "6M"],
			focusblast: ["7M", "6M"],
			focuspunch: ["6T"],
			frenzyplant: ["7T", "6T"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			gigaimpact: ["7M", "7L78", "6M", "6L70"],
			grassknot: ["7M", "6M"],
			grasspledge: ["7T", "6T"],
			growl: ["7L1", "6L1"],
			gyroball: ["7M", "6M"],
			hammerarm: ["7L72", "7L1", "6L1"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["6M"],
			hyperbeam: ["7M", "6M"],
			irondefense: ["6T"],
			ironhead: ["6T"],
			irontail: ["6T"],
			leechseed: ["7L15", "6L15"],
			lowkick: ["6T"],
			lowsweep: ["7M", "6M"],
			mudshot: ["7L41", "6L41"],
			naturepower: ["7M", "6M"],
			needlearm: ["7L1", "6L26"],
			painsplit: ["7L60", "6T", "6L52"],
			payback: ["7M", "6M"],
			pinmissile: ["7L19", "6L20"],
			poisonjab: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			rollout: ["7L8", "7L1", "6L8"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			seedbomb: ["7L35", "6T", "6L35"],
			shadowclaw: ["7M", "6M"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			smackdown: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			spikyshield: ["7L1", "6L36"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superfang: ["6T"],
			superpower: ["6T"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "6M"],
			synthesis: ["6T"],
			tackle: ["7L1", "6L1"],
			takedown: ["7L29", "6L30"],
			taunt: ["7M", "6M"],
			thunderpunch: ["6T"],
			toxic: ["7M", "6M"],
			vinewhip: ["7L5", "7L1", "6L5"],
			woodhammer: ["7L66", "6L55"],
			workup: ["7M"],
			worryseed: ["6T"],
			zenheadbutt: ["6T"],
		},
	},
	fennekin: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			cut: ["6M"],
			doubleteam: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			embargo: ["7M", "6M"],
			ember: ["7L5", "6L5"],
			facade: ["7M", "6M"],
			fireblast: ["7M", "7L48", "6M", "6L48"],
			firepledge: ["7T", "6T"],
			firespin: ["7L20", "6L20"],
			flamecharge: ["7M", "7L14", "6M", "6L14"],
			flamethrower: ["7M", "7L35", "6M", "6L35", "6S0"],
			foulplay: ["6T"],
			frustration: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			heatwave: ["7E", "6T", "6E"],
			hiddenpower: ["7M", "6M", "6S0"],
			howl: ["7L11", "6L11"],
			hypnosis: ["7E", "6E"],
			incinerate: ["6M"],
			irontail: ["6T"],
			lightscreen: ["7M", "7L27", "6M", "6L27"],
			luckychant: ["7L25", "6L25"],
			magiccoat: ["7E", "6T", "6E"],
			magicroom: ["7L46", "6T", "6L46"],
			overheat: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			psybeam: ["7L17", "6L17"],
			psychic: ["7M", "7L41", "6M", "6L41"],
			psychup: ["7M", "6M"],
			psyshock: ["7M", "7L31", "6M", "6L31"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			scratch: ["7L1", "6L1", "6S0"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "7L43", "6M", "6L43"],
			swagger: ["7M", "6M"],
			tailwhip: ["7L1", "6L1"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			willowisp: ["7M", "7L38", "6M", "6L38"],
			wish: ["7E", "6E"],
			workup: ["7M"],
		},
	},
	braixen: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			cut: ["6M"],
			doubleteam: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			embargo: ["7M", "6M"],
			ember: ["7L5", "7L1", "6L5"],
			facade: ["7M", "6M"],
			fireblast: ["7M", "7L59", "6M", "6L55"],
			firepledge: ["7T", "6T"],
			firepunch: ["6T"],
			firespin: ["7L22", "6L22"],
			flamecharge: ["7M", "7L14", "6M", "6L14"],
			flamethrower: ["7M", "7L41", "6M", "6L41"],
			foulplay: ["6T"],
			frustration: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			heatwave: ["6T"],
			hiddenpower: ["7M", "6M"],
			howl: ["7L11", "6L11"],
			incinerate: ["6M"],
			irontail: ["6T"],
			lightscreen: ["7M", "7L31", "6M", "6L30"],
			lowkick: ["6T"],
			luckychant: ["7L28", "6L27"],
			magiccoat: ["6T"],
			magicroom: ["7L56", "6T", "6L53"],
			overheat: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			psybeam: ["7L18", "6L18"],
			psychic: ["7M", "7L49", "6M", "6L48"],
			psychup: ["7M", "6M"],
			psyshock: ["7M", "7L36", "6M", "6L34"],
			raindance: ["7M", "6M"],
			recycle: ["6T"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			scratch: ["7L1", "6L1"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			skillswap: ["6T"],
			sleeptalk: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "7L52", "6M", "6L51"],
			swagger: ["7M", "6M"],
			tailwhip: ["7L1", "6L1"],
			thief: ["7M", "6M"],
			thunderpunch: ["6T"],
			toxic: ["7M", "6M"],
			trick: ["6T"],
			willowisp: ["7M", "7L45", "6M", "6L45"],
			wonderroom: ["6T"],
			workup: ["7M"],
			zenheadbutt: ["6T"],
		},
	},
	delphox: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			blastburn: ["7T", "6T"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			cut: ["6M"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			embargo: ["7M", "6M"],
			ember: ["7L5", "7L1", "6L5"],
			facade: ["7M", "6M"],
			fireblast: ["7M", "7L74", "6M", "6L61"],
			firepledge: ["7T", "6T"],
			firepunch: ["6T"],
			firespin: ["7L22", "6L22"],
			flamecharge: ["7M", "7L14", "6M", "6L14"],
			flamethrower: ["7M", "7L45", "6M", "6L42"],
			foulplay: ["6T"],
			frustration: ["7M", "6M"],
			futuresight: ["7L80", "7L1", "6L1"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			heatwave: ["6T"],
			hiddenpower: ["7M", "6M"],
			howl: ["7L11", "7L1", "6L11"],
			hyperbeam: ["7M", "6M"],
			incinerate: ["6M"],
			irontail: ["6T"],
			lightscreen: ["7M", "7L31", "6M", "6L30"],
			lowkick: ["6T"],
			luckychant: ["7L28", "6L27"],
			magiccoat: ["6T"],
			magicroom: ["7L68", "6T", "6L58"],
			mysticalfire: ["7L1", "6L36"],
			overheat: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			psybeam: ["7L18", "6L18"],
			psychic: ["7M", "7L57", "6M", "6L51"],
			psychup: ["7M", "6M"],
			psyshock: ["7M", "7L38", "6M", "6L34"],
			raindance: ["7M", "6M"],
			recycle: ["6T"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roleplay: ["7L1", "6T", "6L1"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			scratch: ["7L1", "6L1"],
			secretpower: ["6M"],
			shadowball: ["7M", "7L1", "6M", "6L1"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			skillswap: ["6T"],
			sleeptalk: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "7L62", "6M", "6L55"],
			swagger: ["7M", "6M"],
			switcheroo: ["7L1", "6L1"],
			tailwhip: ["7L1", "6L1"],
			thief: ["7M", "6M"],
			thunderpunch: ["6T"],
			toxic: ["7M", "6M"],
			trick: ["6T"],
			trickroom: ["7M", "6M"],
			willowisp: ["7M", "7L51", "6M", "6L47"],
			wonderroom: ["6T"],
			workup: ["7M"],
			zenheadbutt: ["6T"],
		},
	},
	froakie: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M"],
			aerialace: ["7M", "6M"],
			attract: ["7M", "6M"],
			bestow: ["7E", "6E"],
			blizzard: ["7M", "6M"],
			bounce: ["7L39", "6T", "6L39"],
			bubble: ["7L5", "6L5", "6S0"],
			camouflage: ["7E", "6E"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			dig: ["6M"],
			dive: ["6M"],
			doubleteam: ["7M", "7L43", "6M", "6L43"],
			echoedvoice: ["7M", "6M"],
			facade: ["7M", "6M"],
			fling: ["7M", "7L25", "6M", "6L25"],
			frustration: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			growl: ["7L1", "6L1", "6S0"],
			hiddenpower: ["7M", "6M"],
			hydropump: ["7L48", "6L48"],
			icebeam: ["7M", "6M"],
			icywind: ["6T"],
			lick: ["7L10", "6L10"],
			mindreader: ["7E", "6E"],
			mudsport: ["7E", "6E"],
			pound: ["7L1", "6L1", "6S0"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			quickattack: ["7L8", "6L8"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M", "6S0"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			roleplay: ["6T"],
			round: ["7M", "7L21", "6M", "6L21"],
			scald: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			smackdown: ["7M", "7L29", "6M", "6L29"],
			smokescreen: ["7L18", "6L18"],
			snatch: ["6T"],
			snore: ["6T"],
			spite: ["6T"],
			strength: ["6M"],
			substitute: ["7M", "7L35", "6M", "6L35"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			toxicspikes: ["7E", "6E"],
			uturn: ["7M", "6M"],
			waterfall: ["7M", "6M"],
			waterpledge: ["7T", "6T"],
			waterpulse: ["7L14", "6T", "6L14"],
			watersport: ["7E", "6E"],
			workup: ["7M"],
		},
	},
	frogadier: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M"],
			aerialace: ["7M", "6M"],
			attract: ["7M", "6M"],
			blizzard: ["7M", "6M"],
			bounce: ["7L45", "6T", "6L44"],
			bubble: ["7L5", "7L1", "6L5"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			dive: ["6M"],
			doubleteam: ["7M", "7L50", "6M", "6L48"],
			echoedvoice: ["7M", "6M"],
			facade: ["7M", "6M"],
			fling: ["7M", "7L28", "6M", "6L28"],
			frustration: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			growl: ["7L1", "6L1"],
			gunkshot: ["6T"],
			hiddenpower: ["7M", "6M"],
			hydropump: ["7L56", "6L55"],
			icebeam: ["7M", "6M"],
			icepunch: ["6T"],
			icywind: ["6T"],
			lick: ["7L10", "6L10"],
			lowkick: ["6T"],
			pound: ["7L1", "6L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			quickattack: ["7L8", "6L8"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			roleplay: ["6T"],
			round: ["7M", "7L23", "6M", "6L23"],
			scald: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			smackdown: ["7M", "7L33", "6M", "6L33"],
			smokescreen: ["7L19", "6L20"],
			snatch: ["6T"],
			snore: ["6T"],
			spite: ["6T"],
			strength: ["6M"],
			substitute: ["7M", "7L40", "6M", "6L38"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			waterfall: ["7M", "6M"],
			waterpledge: ["7T", "6T"],
			waterpulse: ["7L14", "6T", "6L14"],
			workup: ["7M"],
		},
	},
	greninja: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M"],
			aerialace: ["7M", "6M"],
			attract: ["7M", "6M"],
			blizzard: ["7M", "6M"],
			bounce: ["6T"],
			brutalswing: ["7M"],
			bubble: ["7L5", "7L1", "6L5"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			dive: ["6M"],
			doubleteam: ["7M", "7L56", "6M", "6L52"],
			echoedvoice: ["7M", "6M"],
			extrasensory: ["7L49", "6L49"],
			facade: ["7M", "6M"],
			feintattack: ["7L33", "6L33"],
			fling: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			growl: ["7L1", "6L1"],
			gunkshot: ["6T", "6S1"],
			happyhour: ["6S1"],
			haze: ["7L70", "7L1", "6L56"],
			hiddenpower: ["7M", "6M"],
			hydrocannon: ["7T", "6T", "6S1"],
			hydropump: ["7L68", "6L60", "6S0"],
			hyperbeam: ["7M", "6M"],
			icebeam: ["7M", "6M"],
			icepunch: ["6T"],
			icywind: ["6T"],
			lick: ["7L10", "6L10"],
			lowkick: ["6T"],
			matblock: ["7L1", "6L1", "6S1"],
			nightslash: ["7L77", "7L1", "6L1"],
			pound: ["7L1", "6L1"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			quickattack: ["7L8", "7L1", "6L8"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			roleplay: ["7L1", "6T", "6L1"],
			round: ["7M", "6M"],
			scald: ["7M", "6M"],
			secretpower: ["6M"],
			shadowsneak: ["7L23", "6L23", "6S0"],
			sleeptalk: ["7M", "6M"],
			smackdown: ["7M", "6M"],
			smokescreen: ["7L19", "6L20"],
			snatch: ["6T"],
			snore: ["6T"],
			spikes: ["7L28", "6L28"],
			spite: ["6T"],
			strength: ["6M"],
			substitute: ["7M", "7L42", "6M", "6L43", "6S0"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			waterfall: ["7M", "6M"],
			waterpledge: ["7T", "6T"],
			waterpulse: ["7L14", "6T", "6L14"],
			watershuriken: ["7L1", "6L36", "6S0"],
			workup: ["7M"],
		},
	},
	greninjaash: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			aerialace: ["7M", "7S0"],
			attract: ["7M"],
			blizzard: ["7M"],
			brutalswing: ["7M"],
			bubble: ["7L1"],
			confide: ["7M"],
			darkpulse: ["7M"],
			doubleteam: ["7M", "7L56", "7S0"],
			echoedvoice: ["7M"],
			extrasensory: ["7L49"],
			facade: ["7M"],
			feintattack: ["7L33"],
			fling: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			growl: ["7L1"],
			haze: ["7L1"],
			hiddenpower: ["7M"],
			hydrocannon: ["7T"],
			hydropump: ["7L68"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			lick: ["7L10"],
			matblock: ["7L1"],
			nightslash: ["7L1", "7S0"],
			pound: ["7L1"],
			protect: ["7M"],
			quickattack: ["7L1"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			roleplay: ["7L1"],
			round: ["7M"],
			scald: ["7M"],
			shadowsneak: ["7L23"],
			sleeptalk: ["7M"],
			smackdown: ["7M"],
			smokescreen: ["7L19"],
			spikes: ["7L28"],
			substitute: ["7M", "7L42"],
			surf: ["7M"],
			swagger: ["7M"],
			taunt: ["7M"],
			thief: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			waterfall: ["7M"],
			waterpledge: ["7T"],
			waterpulse: ["7L14"],
			watershuriken: ["7L1", "7S0"],
			workup: ["7M"],
		},
	},
	bunnelby: {
		inherit: true,
		learnset: {
			agility: ["7L1", "6L1"],
			attract: ["7M", "6M"],
			bounce: ["7L38", "6T", "6L38"],
			brickbreak: ["7M", "6M"],
			bulkup: ["7M", "6M"],
			bulldoze: ["7M", "6M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			defensecurl: ["7E", "6E"],
			dig: ["7L33", "6M", "6L33"],
			doublekick: ["7L20", "6L20"],
			doubleslap: ["7L10", "6L10"],
			doubleteam: ["7M", "6M"],
			earthquake: ["7M", "7L49", "6M", "6L49"],
			endeavor: ["6T"],
			facade: ["7M", "7L47", "6M", "6L47"],
			flail: ["7L29", "6L29"],
			fling: ["7M", "6M"],
			frustration: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			ironhead: ["6T"],
			irontail: ["6T"],
			lastresort: ["6T"],
			leer: ["7L1", "6L1"],
			mudshot: ["7L18", "6L18"],
			mudslap: ["7L13", "6L13"],
			naturepower: ["7M", "6M"],
			odorsleuth: ["7L25", "6L25"],
			payback: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			quickattack: ["7L7", "6L7"],
			recycle: ["6T"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			rollout: ["7E", "6E"],
			round: ["7M", "6M"],
			sandstorm: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			smackdown: ["7M", "6M"],
			snore: ["6T"],
			spikes: ["7E", "6E"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			superfang: ["7L42", "6T", "6L42"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			takedown: ["7L15", "6L15"],
			thief: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			wildcharge: ["7M", "6M"],
			workup: ["7M"],
		},
	},
	diggersby: {
		inherit: true,
		learnset: {
			agility: ["7L1", "6L1"],
			attract: ["7M", "6M"],
			bounce: ["7L43", "6T", "6L42"],
			brickbreak: ["7M", "6M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "6M"],
			bulldoze: ["7M", "7L1", "6M", "6L1"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			dig: ["7L37", "6M", "6L37"],
			doublekick: ["7L21", "6L20"],
			doubleslap: ["7L13"],
			doubleteam: ["7M", "6M"],
			earthpower: ["6T"],
			earthquake: ["7M", "7L57", "6M", "6L57"],
			endeavor: ["6T"],
			facade: ["7M", "7L54", "6M", "6L53"],
			firepunch: ["6T"],
			flail: ["7L32", "6L31"],
			fling: ["7M", "6M"],
			focuspunch: ["6T"],
			foulplay: ["6T"],
			frustration: ["7M", "6M"],
			gastroacid: ["6T"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			gunkshot: ["6T"],
			hammerarm: ["7L60", "7L1", "6L1"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			icepunch: ["6T"],
			ironhead: ["6T"],
			irontail: ["6T"],
			knockoff: ["6T"],
			lastresort: ["6T"],
			leer: ["7L1", "6L1"],
			lowkick: ["6T"],
			mudshot: ["7L18", "6L18"],
			mudslap: ["7L13", "6L13"],
			naturepower: ["7M", "6M"],
			odorsleuth: ["7L27", "6L26"],
			payback: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			quickattack: ["7L7", "6L7"],
			recycle: ["6T"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			rototiller: ["7L1", "6L1"],
			round: ["7M", "6M"],
			sandstorm: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			smackdown: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			superfang: ["7L48", "6T", "6L48"],
			superpower: ["6T"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "7L1", "6M", "6L1"],
			tackle: ["7L1", "6L1"],
			takedown: ["7L15", "6L15"],
			thief: ["7M", "6M"],
			thunderpunch: ["6T"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uproar: ["6T"],
			uturn: ["7M", "6M"],
			wildcharge: ["7M", "6M"],
			workup: ["7M"],
		},
	},
	fletchling: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L39", "6M", "6L39"],
			aerialace: ["7M", "6M"],
			agility: ["7L13", "6L13"],
			attract: ["7M", "6M"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			facade: ["7M", "6M"],
			flail: ["7L16", "6L16"],
			flamecharge: ["7M", "7L34", "6M", "6L34"],
			fly: ["7M", "6M"],
			frustration: ["7M", "6M"],
			growl: ["7L1", "6L1"],
			heatwave: ["6T"],
			hiddenpower: ["7M", "6M"],
			mefirst: ["7L41", "6L41"],
			naturalgift: ["7L29", "6L29"],
			overheat: ["7M", "6M"],
			peck: ["7L10", "6L10"],
			protect: ["7M", "6M"],
			quickattack: ["7L6", "6L6"],
			quickguard: ["7E", "6E"],
			razorwind: ["7L25", "6L25"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roost: ["7M", "7L21", "6M", "6L21"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snatch: ["7E", "6T", "6E"],
			snore: ["6T"],
			steelwing: ["7M", "7L48", "6M", "6L48"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			tailwind: ["7L45", "7E", "6T", "6L45", "6E"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			workup: ["7M"],
		},
	},
	fletchinder: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L42", "6M", "6L42"],
			aerialace: ["7M", "6M"],
			agility: ["7L13", "6L13"],
			attract: ["7M", "6M"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			ember: ["7L1", "6L17"],
			facade: ["7M", "6M"],
			fireblast: ["7M", "6M"],
			flail: ["7L16", "6L16"],
			flamecharge: ["7M", "7L38", "6M", "6L38"],
			flamethrower: ["7M", "6M"],
			fly: ["7M", "6M"],
			frustration: ["7M", "6M"],
			growl: ["7L1", "6L1"],
			heatwave: ["6T"],
			hiddenpower: ["7M", "6M"],
			incinerate: ["6M"],
			mefirst: ["7L46", "6L46"],
			naturalgift: ["7L31", "6L31"],
			overheat: ["7M", "6M"],
			peck: ["7L10", "6L10"],
			protect: ["7M", "6M"],
			quickattack: ["7L6", "7L1", "6L6"],
			razorwind: ["7L27", "6L27"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roost: ["7M", "7L25", "6M", "6L25"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			steelwing: ["7M", "7L55", "6M", "6L55"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			tailwind: ["7L51", "6T", "6L51"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			willowisp: ["7M", "6M"],
			workup: ["7M"],
		},
	},
	talonflame: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L44", "6M", "6L44"],
			aerialace: ["7M", "6M"],
			agility: ["7L13", "6L13"],
			attract: ["7M", "6M"],
			bravebird: ["7L64", "7L1", "6L1"],
			bulkup: ["7M", "6M"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			ember: ["7L1", "6L17"],
			facade: ["7M", "6M"],
			fireblast: ["7M", "6M"],
			flail: ["7L16", "6L16"],
			flamecharge: ["7M", "7L39", "6M", "6L39"],
			flamethrower: ["7M", "6M"],
			flareblitz: ["7L1", "6L1"],
			fly: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			growl: ["7L1", "6L1"],
			heatwave: ["6T"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["6M"],
			hyperbeam: ["7M", "6M"],
			incinerate: ["6M"],
			mefirst: ["7L49", "6L49"],
			naturalgift: ["7L31", "6L31"],
			overheat: ["7M", "6M"],
			peck: ["7L10", "7L1", "6L10"],
			protect: ["7M", "6M"],
			quickattack: ["7L6", "7L1", "6L6"],
			razorwind: ["7L27", "6L27"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roost: ["7M", "7L25", "6M", "6L25"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			steelwing: ["7M", "7L60", "6M", "6L60"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			tailwind: ["7L55", "6T", "6L55"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			willowisp: ["7M", "6M"],
			workup: ["7M"],
		},
	},
	scatterbug: {
		inherit: true,
		learnset: {
			bugbite: ["7L15", "6T", "6L15"],
			poisonpowder: ["7E", "6E"],
			ragepowder: ["7E", "6E"],
			stringshot: ["7L1", "6L1"],
			stunspore: ["7L6", "7E", "6L6", "6E"],
			tackle: ["7L1", "6L1"],
		},
	},
	spewpa: {
		inherit: true,
		learnset: {
			bugbite: ["6T"],
			electroweb: ["6T"],
			harden: ["7L1", "6L1"],
			irondefense: ["6T"],
			protect: ["7M", "7L1", "6M", "6L9"],
		},
	},
	vivillon: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M"],
			aerialace: ["7M", "6M"],
			aromatherapy: ["7L31", "6L31"],
			attract: ["7M", "6M"],
			bugbite: ["6T"],
			bugbuzz: ["7L35", "6L35"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			drainingkiss: ["7L25", "6L25"],
			dreameater: ["7M", "6M"],
			electroweb: ["6T"],
			endeavor: ["6T"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			gigaimpact: ["7M", "6M"],
			gust: ["7L1", "6L1"],
			hiddenpower: ["7M", "6M"],
			hurricane: ["7L50", "6L50"],
			hyperbeam: ["7M", "6M"],
			infestation: ["7M", "6M"],
			lightscreen: ["7M", "7L12", "6M", "6L1"],
			poisonpowder: ["7L1", "6L1"],
			powder: ["7L55", "7L1", "6L1"],
			protect: ["7M", "6M"],
			psybeam: ["7L17", "6L17"],
			psychic: ["7M", "6M"],
			psychup: ["7M", "6M"],
			quiverdance: ["7L45", "6L45"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roost: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "7L41", "6M", "6L41"],
			secretpower: ["6M"],
			signalbeam: ["6T"],
			sleeppowder: ["7L1", "6L1"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			strugglebug: ["7L1", "6M", "6L12"],
			stunspore: ["7L1", "6L1"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			supersonic: ["7L21", "6L21"],
			swagger: ["7M", "6M"],
			tailwind: ["6T"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
		},
	},
	vivillonfancy: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			aromatherapy: ["6L31"],
			attract: ["6M"],
			bugbite: ["6T"],
			bugbuzz: ["6L35"],
			calmmind: ["6M"],
			confide: ["6M"],
			doubleteam: ["6M"],
			drainingkiss: ["6L25"],
			dreameater: ["6M"],
			electroweb: ["6T"],
			endeavor: ["6T"],
			energyball: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			frustration: ["6M"],
			gigadrain: ["6T"],
			gigaimpact: ["6M"],
			gust: ["6L1", "6S0"],
			hiddenpower: ["6M"],
			holdhands: ["6S0"],
			hurricane: ["6L50"],
			hyperbeam: ["6M"],
			infestation: ["6M"],
			lightscreen: ["6M", "6L1", "6S0"],
			poisonpowder: ["6L1"],
			powder: ["6L1"],
			protect: ["6M"],
			psybeam: ["6L17"],
			psychic: ["6M"],
			psychup: ["6M"],
			quiverdance: ["6L45"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roost: ["6M"],
			round: ["6M"],
			safeguard: ["6M", "6L41"],
			secretpower: ["6M"],
			signalbeam: ["6T"],
			sleeppowder: ["6L1"],
			sleeptalk: ["6M"],
			snore: ["6T"],
			solarbeam: ["6M"],
			strugglebug: ["6M", "6L12", "6S0"],
			stunspore: ["6L1"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			supersonic: ["6L21"],
			swagger: ["6M"],
			tailwind: ["6T"],
			thief: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
		},
	},
	vivillonpokeball: {
		inherit: true,
		learnset: {
			acrobatics: ["6M"],
			aerialace: ["6M"],
			aromatherapy: ["6L31"],
			attract: ["6M"],
			bugbite: ["6T"],
			bugbuzz: ["6L35"],
			calmmind: ["6M"],
			confide: ["6M"],
			doubleteam: ["6M"],
			drainingkiss: ["6L25"],
			dreameater: ["6M"],
			electroweb: ["6T"],
			endeavor: ["6T"],
			energyball: ["6M"],
			facade: ["6M"],
			flash: ["6M"],
			frustration: ["6M"],
			gigadrain: ["6T"],
			gigaimpact: ["6M"],
			gust: ["6L1", "6S0"],
			hiddenpower: ["6M"],
			hurricane: ["6L50"],
			hyperbeam: ["6M"],
			infestation: ["6M"],
			lightscreen: ["6M", "6L1", "6S0"],
			poisonpowder: ["6L1"],
			powder: ["6L1"],
			protect: ["6M"],
			psybeam: ["6L17"],
			psychic: ["6M"],
			psychup: ["6M"],
			quiverdance: ["6L45"],
			raindance: ["6M"],
			rest: ["6M"],
			return: ["6M"],
			roost: ["6M"],
			round: ["6M"],
			safeguard: ["6M", "6L41"],
			secretpower: ["6M"],
			signalbeam: ["6T"],
			sleeppowder: ["6L1"],
			sleeptalk: ["6M"],
			snore: ["6T"],
			solarbeam: ["6M"],
			strugglebug: ["6M", "6L12", "6S0"],
			stunspore: ["6L1", "6S0"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			supersonic: ["6L21"],
			swagger: ["6M"],
			tailwind: ["6T"],
			thief: ["6M"],
			toxic: ["6M"],
			uturn: ["6M"],
		},
	},
	litleo: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			bulldoze: ["7M", "6M"],
			confide: ["7M", "6M"],
			crunch: ["7L39", "6L39"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			echoedvoice: ["7M", "7L33", "6M", "6L33"],
			ember: ["7L5", "6L5"],
			endeavor: ["7L28", "6T", "6L28"],
			entrainment: ["7E", "6E"],
			facade: ["7M", "6M"],
			fireblast: ["7M", "6M"],
			firefang: ["7L23", "6L23"],
			firespin: ["7E", "6E"],
			flamecharge: ["7M", "6M"],
			flamethrower: ["7M", "7L36", "6M", "6L36"],
			flareblitz: ["7E"],
			frustration: ["7M", "6M"],
			headbutt: ["7L11", "6L11"],
			heatwave: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			hypervoice: ["7L43", "6T", "6L43"],
			incinerate: ["7L46", "6M", "6L46"],
			irontail: ["6T"],
			leer: ["7L1", "6L1"],
			nobleroar: ["7L15", "6L15"],
			overheat: ["7M", "7L50", "6M", "6L50"],
			payback: ["7M", "6M"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rocksmash: ["6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snarl: ["7M", "6M"],
			snatch: ["7E", "6T", "6E"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			takedown: ["7L20", "6L20"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			wildcharge: ["7M", "6M"],
			willowisp: ["7M", "6M"],
			workup: ["7M", "7L8", "6L8"],
			yawn: ["7E", "6E"],
		},
	},
	pyroar: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			bounce: ["6T"],
			bulldoze: ["7M", "6M"],
			confide: ["7M", "6M"],
			crunch: ["7L42", "6L42"],
			darkpulse: ["7M", "6M", "6S0"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			echoedvoice: ["7M", "7L33", "6M", "6L33"],
			ember: ["7L5", "7L1", "6L5"],
			endeavor: ["7L28", "6T", "6L28"],
			facade: ["7M", "6M"],
			fireblast: ["7M", "6M", "6S0"],
			firefang: ["7L23", "6L23"],
			flamecharge: ["7M", "6M"],
			flamethrower: ["7M", "7L38", "6M", "6L38"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			headbutt: ["7L11", "6L11"],
			heatwave: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "7L1", "6M", "6L1"],
			hypervoice: ["7L48", "6T", "6L48", "6S0"],
			incinerate: ["7L51", "6M", "6L51"],
			irontail: ["6T"],
			leer: ["7L1", "6L1"],
			nobleroar: ["7L15", "6L15"],
			overheat: ["7M", "7L57", "6M", "6L57"],
			payback: ["7M", "6M"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rocksmash: ["6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snarl: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			takedown: ["7L20", "6L20"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			wildcharge: ["7M", "6M"],
			willowisp: ["7M", "6M"],
			workup: ["7M", "7L8", "7L1", "6L8"],
		},
	},
	flabebe: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			aromatherapy: ["7L33", "6L33"],
			attract: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			camouflage: ["7E", "6E"],
			captivate: ["7E", "6E"],
			confide: ["7M", "6M"],
			copycat: ["7E", "6E"],
			covet: ["6T"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			endeavor: ["6T"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			fairywind: ["7L6", "6L6"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			grassknot: ["7M", "6M"],
			grassyterrain: ["7L24", "6L24"],
			healbell: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			luckychant: ["7L10", "6L10"],
			magicalleaf: ["7L22", "6L22"],
			magiccoat: ["6T"],
			mistyterrain: ["7L37", "6L37"],
			moonblast: ["7L41", "6L41"],
			naturepower: ["7M", "6M"],
			petalblizzard: ["7L28", "6L28"],
			petaldance: ["7L45", "6L45"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			raindance: ["7M", "6M"],
			razorleaf: ["7L15", "6L15"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			secretpower: ["6M"],
			seedbomb: ["6T"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "7L48", "6M", "6L48"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			synthesis: ["6T"],
			tackle: ["7L1", "6L1"],
			toxic: ["7M", "6M"],
			vinewhip: ["7L1", "6L1"],
			wish: ["7L20", "6L20"],
			worryseed: ["6T"],
		},
	},
	floette: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			aromatherapy: ["7L38", "6L38"],
			attract: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			endeavor: ["6T"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			fairywind: ["7L6", "7L1", "6L6"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			grassknot: ["7M", "6M"],
			grassyterrain: ["7L27", "6L27"],
			healbell: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			luckychant: ["7L10", "6L10"],
			magicalleaf: ["7L25", "6L25"],
			magiccoat: ["6T"],
			mistyterrain: ["7L43", "6L43"],
			moonblast: ["7L46", "6L46"],
			naturepower: ["7M", "6M"],
			petalblizzard: ["7L33", "6L33"],
			petaldance: ["7L51", "6L51"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			raindance: ["7M", "6M"],
			razorleaf: ["7L15", "6L15"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			secretpower: ["6M"],
			seedbomb: ["6T"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "7L58", "6M", "6L58"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			synthesis: ["6T"],
			tackle: ["7L1", "6L1"],
			toxic: ["7M", "6M"],
			vinewhip: ["7L1", "6L1"],
			wish: ["7L20", "6L20"],
			worryseed: ["6T"],
		},
	},
	floetteeternal: {
		inherit: true,
		learnset: {
			aromatherapy: ["6L38"],
			attract: ["6M"],
			calmmind: ["6M"],
			confide: ["6M"],
			dazzlinggleam: ["6M"],
			doubleteam: ["6M"],
			echoedvoice: ["6M"],
			energyball: ["6M"],
			facade: ["6M"],
			fairywind: ["6L6"],
			flash: ["6M"],
			frustration: ["6M"],
			grassknot: ["6M"],
			grassyterrain: ["6L27"],
			hiddenpower: ["6M"],
			lightofruin: ["6L50"],
			luckychant: ["6L10"],
			magicalleaf: ["6L25"],
			mistyterrain: ["6L43"],
			moonblast: ["6L46"],
			naturepower: ["6M"],
			petalblizzard: ["6L33"],
			petaldance: ["6L51"],
			protect: ["6M"],
			psychic: ["6M"],
			raindance: ["6M"],
			razorleaf: ["6L15"],
			rest: ["6M"],
			return: ["6M"],
			round: ["6M"],
			safeguard: ["6M"],
			secretpower: ["6M"],
			sleeptalk: ["6M"],
			solarbeam: ["6M", "6L58"],
			substitute: ["6M"],
			sunnyday: ["6M"],
			swagger: ["6M"],
			tackle: ["6L1"],
			toxic: ["6M"],
			vinewhip: ["6L1"],
			wish: ["6L20"],
		},
	},
	florges: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			aromatherapy: ["7L1", "6L1"],
			attract: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			dazzlinggleam: ["7M", "6M"],
			disarmingvoice: ["7L1", "6L1"],
			doubleteam: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			endeavor: ["6T"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			flowershield: ["7L1", "6L1"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "7L1", "6M", "6L1"],
			grassyterrain: ["7L1", "6L1"],
			healbell: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			lightscreen: ["7M", "6M"],
			luckychant: ["7L1", "6L1"],
			magicalleaf: ["7L1", "6L1"],
			magiccoat: ["6T"],
			mistyterrain: ["7L1", "6L1"],
			moonblast: ["7L1", "6L1"],
			naturepower: ["7M", "6M"],
			petalblizzard: ["7L1", "6L1"],
			petaldance: ["7L1", "6L1"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			secretpower: ["6M"],
			seedbomb: ["6T"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			synthesis: ["6T"],
			toxic: ["7M", "6M"],
			wish: ["7L1", "6L1"],
			worryseed: ["6T"],
		},
	},
	skiddo: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			brickbreak: ["7M", "6M"],
			bulkup: ["7M", "7L34", "6M", "6L34"],
			bulldoze: ["7M", "7L26", "6M", "6L26"],
			confide: ["7M", "6M"],
			defensecurl: ["7E", "6E"],
			dig: ["6M"],
			doubleedge: ["7L38", "6L38"],
			doubleteam: ["7M", "6M"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			grassknot: ["7M", "6M"],
			growth: ["7L1", "6L1"],
			hiddenpower: ["7M", "6M"],
			hornleech: ["7L42", "6L42"],
			irontail: ["6T"],
			leafblade: ["7L45", "6L45"],
			leechseed: ["7L12", "6L12"],
			milkdrink: ["7L50", "7E", "6L50", "6E"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			razorleaf: ["7L13", "6L13"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rollout: ["7E", "6E"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			seedbomb: ["7L30", "6T", "6L30"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			synthesis: ["7L20", "6T", "6L20"],
			tackle: ["7L1", "6L1"],
			tailwhip: ["7L9", "6L9"],
			takedown: ["7L22", "6L22"],
			toxic: ["7M", "6M"],
			vinewhip: ["7L7", "6L7"],
			wildcharge: ["7M", "6M"],
			workup: ["7M"],
			worryseed: ["7L16", "6T", "6L16"],
			zenheadbutt: ["6T"],
		},
	},
	gogoat: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L1", "6M", "6L1"],
			attract: ["7M", "6M"],
			bounce: ["6T"],
			brickbreak: ["7M", "6M"],
			bulkup: ["7M", "7L34", "6M", "6L34"],
			bulldoze: ["7M", "7L26", "6M", "6L26"],
			confide: ["7M", "6M"],
			dig: ["6M"],
			doubleedge: ["7L40", "6L40"],
			doubleteam: ["7M", "6M"],
			earthquake: ["7M", "7L1", "6M", "6L60"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			growth: ["7L1", "6L1"],
			hiddenpower: ["7M", "6M"],
			hornleech: ["7L47", "6L47"],
			hyperbeam: ["7M", "6M"],
			irontail: ["6T"],
			leafblade: ["7L55", "6L55"],
			leechseed: ["7L12", "6L12"],
			milkdrink: ["7L58", "6L58"],
			naturepower: ["7M", "6M"],
			payback: ["7M", "6M"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			razorleaf: ["7L13", "6L13"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			seedbomb: ["7L30", "6T", "6L30"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["6T"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			synthesis: ["7L20", "6T", "6L20"],
			tackle: ["7L1", "6L1"],
			tailwhip: ["7L9", "7L1", "6L9"],
			takedown: ["7L22", "6L22"],
			toxic: ["7M", "6M"],
			vinewhip: ["7L7", "7L1", "6L7"],
			wildcharge: ["7M", "6M"],
			workup: ["7M"],
			worryseed: ["7L16", "6T", "6L16"],
			zenheadbutt: ["6T"],
		},
	},
	pancham: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			armthrust: ["7L7", "6L7", "6S0"],
			attract: ["7M", "6M"],
			block: ["6T"],
			bodyslam: ["7L33", "6L33"],
			brickbreak: ["7M", "6M"],
			bulkup: ["7M", "6M"],
			bulldoze: ["7M", "6M"],
			circlethrow: ["7L25", "6L25"],
			cometpunch: ["7L15", "6L15"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			crunch: ["7L39", "6L39"],
			cut: ["6M"],
			darkpulse: ["7M", "6M", "6S0"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			drainpunch: ["6T"],
			dualchop: ["6T"],
			echoedvoice: ["7M", "6M"],
			endeavor: ["6T"],
			entrainment: ["7L42", "6L42"],
			facade: ["7M", "6M"],
			falseswipe: ["7M", "6M"],
			firepunch: ["6T"],
			fling: ["7M", "6M"],
			focuspunch: ["6T"],
			foulplay: ["7E", "6T", "6E"],
			frustration: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			gunkshot: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			hypervoice: ["6T"],
			icepunch: ["6T"],
			ironhead: ["6T"],
			karatechop: ["7L12", "6L12"],
			knockoff: ["6T"],
			leer: ["7L1", "6L1"],
			lowkick: ["6T"],
			lowsweep: ["7M", "6M"],
			mefirst: ["7E", "6E"],
			partingshot: ["7L45", "6L45"],
			payback: ["7M", "6M"],
			powertrip: ["7E"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			quash: ["7E", "6E"],
			quickguard: ["7E", "6E"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M"],
			skyuppercut: ["7L48", "6L48"],
			slash: ["7L20", "6L20"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			spite: ["6T"],
			stoneedge: ["7M", "6M", "6S0"],
			stormthrow: ["7E", "6E"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["6T"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			thunderpunch: ["6T"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uproar: ["6T"],
			vitalthrow: ["7L27", "6L27"],
			workup: ["7M", "7L10", "6L10"],
			zenheadbutt: ["6T"],
		},
	},
	pangoro: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			armthrust: ["7L7", "7L1", "6L7"],
			attract: ["7M", "6M"],
			block: ["6T"],
			bodyslam: ["7L35", "6L35"],
			brickbreak: ["7M", "6M"],
			bulkup: ["7M", "6M"],
			bulldoze: ["7M", "6M"],
			bulletpunch: ["7L1"],
			circlethrow: ["7L25", "6L25"],
			cometpunch: ["7L15", "6L15"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			crunch: ["7L42", "6L42"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			dragonclaw: ["7M", "6M"],
			drainpunch: ["6T"],
			dualchop: ["6T"],
			earthquake: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			embargo: ["7M", "6M"],
			endeavor: ["6T"],
			entrainment: ["7L45", "7L1", "6L1"],
			facade: ["7M", "6M"],
			falseswipe: ["7M", "6M"],
			firepunch: ["6T"],
			fling: ["7M", "6M"],
			focusblast: ["7M", "6M"],
			focuspunch: ["6T"],
			foulplay: ["6T"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			gunkshot: ["6T"],
			hammerarm: ["7L70", "7L1", "6L1"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["6M"],
			hyperbeam: ["7M", "6M"],
			hypervoice: ["6T"],
			icepunch: ["6T"],
			infestation: ["7M", "6M"],
			ironhead: ["6T"],
			karatechop: ["7L12", "6L12"],
			knockoff: ["6T"],
			leer: ["7L1", "6L1"],
			lowkick: ["6T"],
			lowsweep: ["7M", "7L57", "7L1", "6M", "6L70"],
			outrage: ["6T"],
			partingshot: ["7L48", "6L48"],
			payback: ["7M", "6M"],
			poisonjab: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			quash: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M"],
			skyuppercut: ["7L52", "6L52"],
			slash: ["7L20", "6L20"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			snarl: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			spite: ["6T"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["6T"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			taunt: ["7M", "7L65", "6M", "6L65"],
			thief: ["7M", "6M"],
			thunderpunch: ["6T"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uproar: ["6T"],
			vitalthrow: ["7L27", "6L27"],
			workup: ["7M", "7L10", "7L1", "6L10"],
			xscissor: ["7M", "6M"],
			zenheadbutt: ["6T"],
		},
	},
	furfrou: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			babydolleyes: ["7L9", "6L9"],
			bite: ["7L22", "6L22"],
			captivate: ["7E", "6E"],
			chargebeam: ["7M", "6M"],
			charm: ["7L38", "6L38"],
			confide: ["7M", "6M"],
			cottonguard: ["7L48", "6L48"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			endeavor: ["6T"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			growl: ["7L1", "6L1"],
			headbutt: ["7L12", "6L12"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			hypervoice: ["6T"],
			irontail: ["6T"],
			lastresort: ["6T"],
			mimic: ["7E", "6E"],
			odorsleuth: ["7L27", "6L27"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			refresh: ["7E", "6E"],
			rest: ["7M", "6M"],
			retaliate: ["7L33", "6M", "6L33"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rocksmash: ["6M"],
			roleplay: ["7E", "6T", "6E"],
			round: ["7M", "6M"],
			sandattack: ["7L5", "6L5"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snarl: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			suckerpunch: ["7L42", "6L42"],
			sunnyday: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			tailwhip: ["7L15", "6L15"],
			takedown: ["7L35", "6L35"],
			thunderwave: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uproar: ["6T"],
			uturn: ["7M", "6M"],
			wildcharge: ["7M", "6M"],
			workup: ["7M", "7E", "6E"],
			zenheadbutt: ["6T"],
		},
	},
	espurr: {
		inherit: true,
		learnset: {
			assist: ["7E", "6E"],
			attract: ["7M", "6M"],
			barrier: ["7E", "6E"],
			calmmind: ["7M", "6M"],
			chargebeam: ["7M", "6M"],
			confide: ["7M", "6M"],
			confusion: ["7L9", "6L9"],
			covet: ["7L5", "6T", "6L5"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			disarmingvoice: ["7L22", "6L22"],
			doubleteam: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			fakeout: ["7L19", "6L19"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gravity: ["6T"],
			healbell: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			irontail: ["6T"],
			leer: ["7L1", "6L1"],
			lightscreen: ["7M", "7L13", "6M", "6L13"],
			magiccoat: ["6T"],
			magicroom: ["6T"],
			payback: ["7M", "6M"],
			protect: ["7M", "6M"],
			psybeam: ["7L17", "6L17"],
			psychic: ["7M", "6M"],
			psychup: ["7M", "6M"],
			psyshock: ["7M", "7L25", "6M", "6L25"],
			raindance: ["7M", "6M"],
			recycle: ["6T"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roleplay: ["6T"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			scratch: ["7L1", "6L1"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			sleeptalk: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			thunderwave: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trick: ["7E", "6T", "6E"],
			trickroom: ["7M", "6M"],
			wonderroom: ["6T"],
			workup: ["7M"],
			yawn: ["7E", "6E"],
			zenheadbutt: ["6T"],
		},
	},
	meowstic: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			chargebeam: ["7M", "6M"],
			charm: ["7L28", "6L28"],
			confide: ["7M", "6M"],
			confusion: ["7L9", "7L1", "6L9"],
			covet: ["7L5", "7L1", "6T", "6L5"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			disarmingvoice: ["7L22", "6L22"],
			doubleteam: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			fakeout: ["7L19", "6L19"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			gravity: ["6T"],
			healbell: ["6T"],
			helpinghand: ["7L1", "6T", "6L1"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			imprison: ["7L45", "6L45"],
			irontail: ["6T"],
			leer: ["7L1", "6L1"],
			lightscreen: ["7M", "7L13", "6M", "6L13"],
			magiccoat: ["6T"],
			magicroom: ["6T"],
			meanlook: ["7L1", "6L1"],
			miracleeye: ["7L31", "6L31"],
			mistyterrain: ["7L50", "6L50"],
			payback: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			psybeam: ["7L17", "6L17"],
			psychic: ["7M", "7L40", "6M", "6L40"],
			psychup: ["7M", "6M"],
			psyshock: ["7M", "7L25", "6M", "6L25"],
			quickguard: ["7L53", "7L1", "6L1"],
			raindance: ["7M", "6M"],
			recycle: ["6T"],
			reflect: ["7M", "7L35", "6M", "6L35"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roleplay: ["7L43", "6T", "6L43"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			scratch: ["7L1", "6L1"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			sleeptalk: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			suckerpunch: ["7L48", "6L48"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			thunderwave: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trick: ["6T"],
			trickroom: ["7M", "6M"],
			wonderroom: ["6T"],
			workup: ["7M"],
			zenheadbutt: ["6T"],
		},
	},
	meowsticf: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			chargebeam: ["7M", "7L28", "6M", "6L28"],
			confide: ["7M", "6M"],
			confusion: ["7L9", "7L1", "6L9"],
			covet: ["7L5", "7L1", "6L5"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			disarmingvoice: ["7L22", "6L22"],
			doubleteam: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			energyball: ["7M", "6M"],
			extrasensory: ["7L35", "6L35"],
			facade: ["7M", "6M"],
			fakeout: ["7L19", "6L19"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			futuresight: ["7L50", "6L50"],
			gigaimpact: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			leer: ["7L1", "6L1"],
			lightscreen: ["7M", "7L13", "6M", "6L13"],
			magicalleaf: ["7L1", "6L1"],
			mefirst: ["7L1", "6L1"],
			payback: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			psybeam: ["7L17", "6L17"],
			psychic: ["7M", "7L40", "6M", "6L40"],
			psychup: ["7M", "6M"],
			psyshock: ["7M", "7L25", "6M", "6L25"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roleplay: ["7L43", "6L43"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			scratch: ["7L1", "6L1"],
			secretpower: ["6M"],
			shadowball: ["7M", "7L31", "6M", "6L31"],
			signalbeam: ["7L45", "6L45"],
			sleeptalk: ["7M", "6M"],
			storedpower: ["7L53", "7L1", "6L1"],
			substitute: ["7M", "6M"],
			suckerpunch: ["7L48", "6L48"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			thunderwave: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trickroom: ["7M", "6M"],
			workup: ["7M"],
		},
	},
	honedge: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L22", "6M", "6L22"],
			afteryou: ["6T"],
			attract: ["7M", "6M"],
			autotomize: ["7L18", "6L18"],
			brickbreak: ["7M", "6M"],
			brutalswing: ["7M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			destinybond: ["7E", "6E"],
			doubleteam: ["7M", "6M"],
			facade: ["7M", "6M"],
			falseswipe: ["7M", "6M"],
			flashcannon: ["7M", "6M"],
			frustration: ["7M", "6M"],
			furycutter: ["7L5", "6L5"],
			gyroball: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			irondefense: ["7L32", "6T", "6L32"],
			ironhead: ["7L42", "6T", "6L42"],
			magnetrise: ["6T"],
			metalsound: ["7L8", "7E", "6L8", "6E"],
			nightslash: ["7L35", "6L35"],
			powertrick: ["7L39", "6L39"],
			protect: ["7M", "6M"],
			pursuit: ["7L13", "6L13"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["7L26", "6M", "6L26"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			sacredsword: ["7L47", "6L47"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M"],
			shadowsneak: ["7L20", "7E", "6L20", "6E"],
			shockwave: ["6T"],
			slash: ["7L29", "6L29"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			spite: ["6T"],
			substitute: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "7L1", "6M", "6L1"],
			tackle: ["7L1", "6L1"],
			toxic: ["7M", "6M"],
			wideguard: ["7E", "6E"],
		},
	},
	doublade: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L22", "6M", "6L22"],
			afteryou: ["6T"],
			attract: ["7M", "6M"],
			autotomize: ["7L18", "6L18"],
			brickbreak: ["7M", "6M"],
			brutalswing: ["7M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			doubleteam: ["7M", "6M"],
			facade: ["7M", "6M"],
			falseswipe: ["7M", "6M"],
			flashcannon: ["7M", "6M"],
			frustration: ["7M", "6M"],
			furycutter: ["7L5", "7L1", "6L5"],
			gyroball: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			irondefense: ["7L32", "6T", "6L32"],
			ironhead: ["7L45", "6T", "6L45"],
			magnetrise: ["6T"],
			metalsound: ["7L8", "6L8"],
			nightslash: ["7L36", "6L36"],
			powertrick: ["7L41", "6L41"],
			protect: ["7M", "6M"],
			pursuit: ["7L13", "6L13"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["7L26", "6M", "6L26"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			sacredsword: ["7L51", "6L51"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M"],
			shadowsneak: ["7L20", "6L20"],
			shockwave: ["6T"],
			slash: ["7L29", "6L29"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			spite: ["6T"],
			substitute: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "7L1", "6M", "6L1"],
			tackle: ["7L1", "6L1"],
			toxic: ["7M", "6M"],
		},
	},
	aegislash: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L1", "6M", "6L1"],
			afteryou: ["6T"],
			attract: ["7M", "6M"],
			autotomize: ["7L1", "6L1"],
			block: ["6T"],
			brickbreak: ["7M", "6M"],
			brutalswing: ["7M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			doubleteam: ["7M", "6M"],
			facade: ["7M", "6M"],
			falseswipe: ["7M", "6M"],
			flashcannon: ["7M", "6M", "6S0"],
			frustration: ["7M", "6M"],
			furycutter: ["7L1", "6L1"],
			gigaimpact: ["7M", "6M"],
			gyroball: ["7M", "6M"],
			headsmash: ["7L1", "6L1"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			irondefense: ["7L1", "6T", "6L1"],
			ironhead: ["7L1", "6T", "6L1"],
			kingsshield: ["7L1", "6L1", "6S0"],
			magnetrise: ["6T"],
			nightslash: ["7L1", "6L1"],
			powertrick: ["7L1", "6L1"],
			protect: ["7M", "6M"],
			pursuit: ["7L1", "6L1"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			round: ["7M", "6M"],
			sacredsword: ["7L1", "6L1"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M", "6S0"],
			shadowclaw: ["7M", "6M"],
			shadowsneak: ["7L1", "6L1"],
			shockwave: ["6T"],
			slash: ["7L1", "6L1"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			spite: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "7L1", "6M", "6L1"],
			toxic: ["7M", "6M"],
			wideguard: ["6S0"],
		},
	},
	spritzee: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			aromatherapy: ["7L25", "6L25"],
			attract: ["7M", "7L29", "6M", "6L29"],
			calmmind: ["7M", "7L17", "6M", "6L17"],
			captivate: ["7E", "6E"],
			chargebeam: ["7M", "6M"],
			charm: ["7L35", "6L35"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			dazzlinggleam: ["7M", "6M"],
			disable: ["7E", "6E"],
			disarmingvoice: ["7L50", "6L50"],
			doubleteam: ["7M", "6M"],
			drainingkiss: ["7L21", "6L21"],
			dreameater: ["7M", "6M"],
			echoedvoice: ["7M", "7L13", "6M", "6L13"],
			endeavor: ["6T"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			fairywind: ["7L1", "6L1"],
			flail: ["7L38", "6L38"],
			flash: ["6M"],
			flashcannon: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gyroball: ["7M", "6M"],
			healbell: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			lightscreen: ["7M", "6M"],
			magiccoat: ["6T"],
			mistyterrain: ["7L42", "6L42"],
			moonblast: ["7L31", "6L31"],
			odorsleuth: ["7L8", "6L8"],
			protect: ["7M", "6M"],
			psychic: ["7M", "7L48", "6M", "6L48"],
			psychup: ["7M", "6M"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "6M"],
			refresh: ["7E", "6E"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			skillswap: ["7L44", "6T", "6L44"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			sweetkiss: ["7L6", "6L6"],
			sweetscent: ["7L1", "6L1"],
			thunderbolt: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trickroom: ["7M", "6M"],
			wish: ["7E", "6E"],
		},
	},
	aromatisse: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			aromatherapy: ["7L25", "6L25"],
			aromaticmist: ["7L1", "6L1"],
			attract: ["7M", "7L29", "6M", "6L29"],
			calmmind: ["7M", "7L17", "6M", "6L17"],
			chargebeam: ["7M", "6M"],
			charm: ["7L35", "6L35"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			dazzlinggleam: ["7M", "6M"],
			disable: ["6S0"],
			disarmingvoice: ["7L53", "6L53"],
			doubleteam: ["7M", "6M"],
			drainingkiss: ["7L21", "6L21"],
			drainpunch: ["6T"],
			dreameater: ["7M", "6M"],
			echoedvoice: ["7M", "7L13", "6M", "6L13"],
			endeavor: ["6T"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			fairywind: ["7L1", "6L1"],
			flail: ["7L38", "6L38"],
			flash: ["6M"],
			flashcannon: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			gyroball: ["7M", "6M"],
			healbell: ["6T"],
			healpulse: ["7L1", "6L1", "6S0"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			lightscreen: ["7M", "6M"],
			magiccoat: ["6T"],
			mistyterrain: ["7L42", "6L42"],
			moonblast: ["7L31", "6L31", "6S0"],
			odorsleuth: ["7L8", "7L1", "6L8"],
			protect: ["7M", "6M"],
			psychic: ["7M", "7L48", "6M", "6L48"],
			psychup: ["7M", "7L64", "6M", "6L64"],
			psyshock: ["7M", "6M"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "7L57", "6M", "6L57"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			skillswap: ["7L44", "6T", "6L44"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			sweetkiss: ["7L6", "7L1", "6L6"],
			sweetscent: ["7L1", "6L1"],
			thunder: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trickroom: ["7M", "6M", "6S0"],
		},
	},
	swirlix: {
		inherit: true,
		learnset: {
			afteryou: ["7E", "6T", "6E"],
			aromatherapy: ["7L26", "6L26"],
			attract: ["7M", "6M"],
			bellydrum: ["7E", "6E"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			copycat: ["7E", "6E"],
			cottonguard: ["7L41", "6L41"],
			cottonspore: ["7L17", "6L17"],
			covet: ["6T"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			drainingkiss: ["7L31", "6L31"],
			dreameater: ["7M", "6M"],
			endeavor: ["7L21", "6T", "6L21"],
			energyball: ["7M", "7L36", "6M", "6L36"],
			facade: ["7M", "6M"],
			fairywind: ["7L5", "6L5"],
			faketears: ["7L10", "6L10"],
			flamethrower: ["7M", "6M"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gastroacid: ["6T"],
			healbell: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			lightscreen: ["7M", "7L58", "6M", "6L58"],
			magiccoat: ["6T"],
			playnice: ["7L8", "6L8"],
			playrough: ["7L49", "6L49"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			psychup: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "7L13", "6M", "6L13"],
			safeguard: ["7M", "7L67", "6M", "6L67"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			sweetscent: ["7L1", "6L1"],
			tackle: ["7L1", "6L1"],
			thief: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			toxic: ["7M", "6M"],
			wish: ["7L45", "6L45"],
			yawn: ["7E", "6E"],
		},
	},
	slurpuff: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			aromatherapy: ["7L26", "6L26"],
			attract: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			cottonguard: ["7L41", "6L41"],
			cottonspore: ["7L17", "6L17"],
			covet: ["6T"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			drainingkiss: ["7L31", "6L31"],
			drainpunch: ["6T"],
			dreameater: ["7M", "6M"],
			endeavor: ["7L21", "6T", "6L21"],
			energyball: ["7M", "7L36", "6M", "6L36"],
			facade: ["7M", "6M"],
			fairywind: ["7L5", "7L1", "6L5"],
			faketears: ["7L10", "6L10"],
			flamethrower: ["7M", "6M"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gastroacid: ["6T"],
			gigaimpact: ["7M", "6M"],
			healbell: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			lightscreen: ["7M", "7L58", "6M", "6L58"],
			magiccoat: ["6T"],
			playnice: ["7L8", "7L1", "6L8"],
			playrough: ["7L49", "6L49"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			psychup: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "7L13", "6M", "6L13"],
			safeguard: ["7M", "7L67", "6M", "6L67"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			sweetscent: ["7L1", "6L1"],
			tackle: ["7L1", "6L1"],
			thief: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			toxic: ["7M", "6M"],
			wish: ["7L45", "6L45"],
		},
	},
	inkay: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			attract: ["7M", "6M"],
			bind: ["6T"],
			calmmind: ["7M", "6M"],
			camouflage: ["7E", "6E"],
			confide: ["7M", "6M"],
			constrict: ["7L1", "6L1"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			destinybond: ["7E", "6E"],
			doubleteam: ["7M", "6M"],
			embargo: ["7M", "6M"],
			facade: ["7M", "6M"],
			flamethrower: ["7M", "6M"],
			flash: ["6M"],
			flatter: ["7E", "6E"],
			fling: ["7M", "6M"],
			foulplay: ["7L8", "6T", "6L8", "6S0"],
			frustration: ["7M", "6M"],
			happyhour: ["6S0"],
			hiddenpower: ["7M", "6M"],
			hypnosis: ["7L18", "6L18", "6S0"],
			knockoff: ["6T"],
			lightscreen: ["7M", "7L31", "6M", "6L31"],
			nightslash: ["7L46", "6L46"],
			payback: ["7M", "7L27", "6M", "6L27"],
			peck: ["7L1", "6L1"],
			pluck: ["7L35", "6L35"],
			powersplit: ["7E", "6E"],
			protect: ["7M", "6M"],
			psybeam: ["7L21", "6L21"],
			psychic: ["7M", "6M"],
			psychocut: ["7L39", "6L39"],
			psychup: ["7M", "6M"],
			psywave: ["7L13", "6L13"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "7L4", "6M", "6L4"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			roleplay: ["6T"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			simplebeam: ["7E", "6E"],
			slash: ["7L43", "6L43"],
			sleeptalk: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			spite: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["7L48", "6T", "6L48"],
			swagger: ["7M", "7L12", "6M", "6L12"],
			switcheroo: ["7L23", "6L23"],
			tackle: ["7L1", "6L1"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			topsyturvy: ["7L15", "6L15", "6S0"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trickroom: ["7M", "6M"],
		},
	},
	malamar: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			attract: ["7M", "6M"],
			bind: ["6T"],
			block: ["6T"],
			brutalswing: ["7M"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			constrict: ["7L1", "6L1"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			embargo: ["7M", "6M"],
			facade: ["7M", "6M", "6S0"],
			flamethrower: ["7M", "6M"],
			flash: ["6M"],
			fling: ["7M", "6M"],
			foulplay: ["7L8", "6T", "6L8"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			hypnosis: ["7L18", "6L18"],
			knockoff: ["6T", "6S0"],
			lightscreen: ["7M", "7L31", "6M", "6L31"],
			nightslash: ["7L46", "6L46"],
			payback: ["7M", "7L27", "6M", "6L27"],
			peck: ["7L1", "6L1"],
			pluck: ["7L35", "6L35"],
			protect: ["7M", "6M"],
			psybeam: ["7L21", "6L21"],
			psychic: ["7M", "6M"],
			psychocut: ["7L39", "6L39"],
			psychup: ["7M", "6M"],
			psyshock: ["7M", "6M"],
			psywave: ["7L13", "6L13"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "7L4", "7L1", "6M", "6L4"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			reversal: ["7L1", "6L1"],
			rockslide: ["7M", "6M", "6S0"],
			roleplay: ["6T"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			signalbeam: ["6T"],
			slash: ["7L43", "6L43"],
			sleeptalk: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			spite: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["7L48", "6T", "6L1", "6S0"],
			swagger: ["7M", "7L12", "6M", "6L12"],
			switcheroo: ["7L23", "6L23"],
			tackle: ["7L1", "6L1"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			topsyturvy: ["7L15", "6L15"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trickroom: ["7M", "6M"],
		},
	},
	binacle: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			ancientpower: ["7L28", "6L28"],
			attract: ["7M", "6M"],
			blizzard: ["7M", "6M"],
			brickbreak: ["7M", "6M"],
			bulldoze: ["7M", "6M"],
			clamp: ["7L20", "6L20"],
			confide: ["7M", "6M"],
			crosschop: ["7L49", "6L49"],
			cut: ["6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			dualchop: ["6T"],
			earthquake: ["7M", "6M"],
			embargo: ["7M", "6M"],
			endeavor: ["6T"],
			facade: ["7M", "6M"],
			falseswipe: ["7M", "6M"],
			fling: ["7M", "6M"],
			frustration: ["7M", "6M"],
			furycutter: ["7L37", "6L37"],
			furyswipes: ["7L10", "6L10"],
			grassknot: ["7M", "6M"],
			helpinghand: ["7E", "6T", "6E"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["7L32", "6M", "6L32"],
			icebeam: ["7M", "6M"],
			icywind: ["6T"],
			infestation: ["7M", "6M"],
			irondefense: ["6T"],
			mudslap: ["7L18", "6L18"],
			naturepower: ["7M", "6M"],
			nightslash: ["7L41", "6L41"],
			payback: ["7M", "6M"],
			poisonjab: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			razorshell: ["7L45", "6L45"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockpolish: ["7M", "7L24", "6M", "6L24"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			sandattack: ["7L1", "6L1"],
			sandstorm: ["7M", "6M"],
			scald: ["7M", "6M"],
			scratch: ["7L1", "6L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M"],
			shellsmash: ["7L1", "6L1"],
			slash: ["7L13", "6L13"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			sludgewave: ["7M", "6M"],
			smackdown: ["7M", "6M"],
			snore: ["6T"],
			stealthrock: ["6T"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			switcheroo: ["7E", "6E"],
			swordsdance: ["7M", "6M"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			tickle: ["7E", "6E"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			watergun: ["7L4", "6L4"],
			waterpulse: ["6T"],
			watersport: ["7E", "6E"],
			withdraw: ["7L7", "6L7"],
			xscissor: ["7M", "6M"],
		},
	},
	barbaracle: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			ancientpower: ["7L28", "6L28"],
			attract: ["7M", "6M"],
			blizzard: ["7M", "6M"],
			brickbreak: ["7M", "6M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "6M"],
			bulldoze: ["7M", "6M"],
			clamp: ["7L20", "6L20"],
			confide: ["7M", "6M"],
			crosschop: ["7L55", "6L55"],
			cut: ["6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			dragonclaw: ["7M", "6M"],
			dualchop: ["6T"],
			earthpower: ["6T"],
			earthquake: ["7M", "6M"],
			embargo: ["7M", "6M"],
			endeavor: ["6T"],
			facade: ["7M", "6M"],
			falseswipe: ["7M", "6M"],
			fling: ["7M", "6M"],
			focusblast: ["7M", "6M"],
			frustration: ["7M", "6M"],
			furycutter: ["7L37", "6L37"],
			furyswipes: ["7L10", "6L10"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["7L32", "6M", "6L32"],
			hyperbeam: ["7M", "6M"],
			icebeam: ["7M", "6M"],
			icywind: ["6T"],
			infestation: ["7M", "6M"],
			irondefense: ["6T"],
			lowkick: ["6T"],
			mudslap: ["7L18", "6L18"],
			naturepower: ["7M", "6M"],
			nightslash: ["7L44", "6L44"],
			payback: ["7M", "6M"],
			poisonjab: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			razorshell: ["7L48", "6L48"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockpolish: ["7M", "7L24", "6M", "6L24"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			sandattack: ["7L1", "6L1"],
			sandstorm: ["7M", "6M"],
			scald: ["7M", "6M"],
			scratch: ["7L1", "6L1"],
			secretpower: ["6M"],
			shadowclaw: ["7M", "6M"],
			shellsmash: ["7L1", "6L1"],
			skullbash: ["7L65", "7L1", "6L1"],
			slash: ["7L13", "6L13"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			sludgewave: ["7M", "6M"],
			smackdown: ["7M", "6M"],
			snore: ["6T"],
			stealthrock: ["6T"],
			stoneedge: ["7M", "7L60", "7L1", "6M", "6L1"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			superpower: ["6T"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "6M"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			watergun: ["7L4", "7L1", "6L4"],
			waterpulse: ["6T"],
			withdraw: ["7L7", "6L7"],
			xscissor: ["7M", "6M"],
		},
	},
	skrelp: {
		inherit: true,
		learnset: {
			acid: ["7L15", "6L15"],
			acidarmor: ["7E", "6E"],
			aquatail: ["7L35", "6T", "6L35"],
			attract: ["7M", "6M"],
			bounce: ["6T"],
			bubble: ["7L12", "6L12"],
			camouflage: ["7L19", "6L19"],
			confide: ["7M", "6M"],
			dive: ["6M"],
			doubleteam: ["7M", "7L28", "6M", "6L28"],
			dragonpulse: ["7L49", "6T", "6L49"],
			facade: ["7M", "6M"],
			feintattack: ["7L5", "6L5"],
			frustration: ["7M", "6M"],
			gunkshot: ["6T"],
			hail: ["7M", "6M"],
			haze: ["7E", "6E"],
			hiddenpower: ["7M", "6M"],
			hydropump: ["7L42", "6L42"],
			icywind: ["6T"],
			irontail: ["6T"],
			outrage: ["6T"],
			playrough: ["7E", "6E"],
			poisontail: ["7L23", "6L23"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			scald: ["7M", "6M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "7L38", "6M", "6L38"],
			sludgewave: ["7M", "6M"],
			smokescreen: ["7L1", "6L1"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			tailwhip: ["7L9", "6L9"],
			thunderbolt: ["7M", "6M"],
			toxic: ["7M", "7L32", "6M", "6L32"],
			toxicspikes: ["7E", "6E"],
			venomdrench: ["7E", "6E"],
			venoshock: ["7M", "6M"],
			waterfall: ["7M", "6M"],
			watergun: ["7L1", "6L1"],
			waterpulse: ["7L25", "6T", "6L25"],
		},
	},
	dragalge: {
		inherit: true,
		learnset: {
			acid: ["7L15", "6L15"],
			aquatail: ["7L35", "6T", "6L35"],
			attract: ["7M", "6M"],
			bounce: ["6T"],
			bubble: ["7L12", "6L12"],
			camouflage: ["7L19", "6L19"],
			confide: ["7M", "6M"],
			dive: ["6M"],
			doubleteam: ["7M", "7L28", "6M", "6L28"],
			dracometeor: ["7T", "6T"],
			dragonpulse: ["7L53", "6T", "6L53"],
			dragontail: ["7M", "7L59", "7L1", "6M", "6L1"],
			facade: ["7M", "6M"],
			feintattack: ["7L5", "7L1", "6L5"],
			focusblast: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			gunkshot: ["6T"],
			hail: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			hydropump: ["7L42", "6L42"],
			hyperbeam: ["7M", "6M"],
			icywind: ["6T"],
			irontail: ["6T"],
			outrage: ["6T"],
			poisontail: ["7L23", "6L23"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			scald: ["7M", "6M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "7L38", "6M", "6L38"],
			sludgewave: ["7M", "6M"],
			smokescreen: ["7L1", "6L1"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			tailwhip: ["7L9", "6L9"],
			thunder: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			toxic: ["7M", "7L32", "6M", "6L32"],
			twister: ["7L1", "6L1"],
			venoshock: ["7M", "6M"],
			waterfall: ["7M", "6M"],
			watergun: ["7L1", "6L1"],
			waterpulse: ["7L25", "6T", "6L25"],
		},
	},
	clauncher: {
		inherit: true,
		learnset: {
			aquajet: ["7L43", "7E", "6L43", "6E"],
			aquatail: ["6T"],
			attract: ["7M", "6M"],
			bounce: ["6T"],
			bubble: ["7L12", "6L12"],
			bubblebeam: ["7L20", "6L20"],
			confide: ["7M", "6M"],
			crabhammer: ["7L30", "7E", "6L30", "6E"],
			cut: ["6M"],
			dive: ["6M"],
			doubleteam: ["7M", "6M"],
			dragonpulse: ["6T"],
			endure: ["7E", "6E"],
			entrainment: ["7E", "6E"],
			facade: ["7M", "6M"],
			flail: ["7L16", "6L16"],
			flashcannon: ["7M", "6M"],
			frustration: ["7M", "6M"],
			helpinghand: ["7E", "6T", "6E"],
			hiddenpower: ["7M", "6M"],
			icebeam: ["7M", "6M"],
			icywind: ["6T"],
			irontail: ["6T"],
			muddywater: ["7L48", "6L48"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			round: ["7M", "6M"],
			scald: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			sludgewave: ["7M", "6M"],
			smackdown: ["7M", "7L39", "6M", "6L39"],
			snore: ["6T"],
			splash: ["7L1", "6L1"],
			substitute: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "7L25", "6M", "6L25"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			venoshock: ["7M", "6M"],
			visegrip: ["7L9", "6L9"],
			waterfall: ["7M", "6M"],
			watergun: ["7L1", "6L1"],
			waterpulse: ["7L34", "6T", "6L34"],
			watersport: ["7L7", "6L7"],
		},
	},
	clawitzer: {
		inherit: true,
		learnset: {
			aquajet: ["7L49", "6L47"],
			aquatail: ["6T"],
			attract: ["7M", "6M"],
			aurasphere: ["7L1", "6L1"],
			bounce: ["6T"],
			bubble: ["7L12", "6L12"],
			bubblebeam: ["7L20", "6L20"],
			confide: ["7M", "6M"],
			crabhammer: ["7L30", "6L30"],
			cut: ["6M"],
			darkpulse: ["7M", "7L1", "6M", "6L1"],
			dive: ["6M"],
			doubleteam: ["7M", "6M"],
			dragonpulse: ["7L1", "6T", "6L1"],
			facade: ["7M", "6M"],
			flail: ["7L16", "6L16"],
			flashcannon: ["7M", "6M"],
			focusblast: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			healpulse: ["7L1", "6L1"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			icebeam: ["7M", "6M"],
			icywind: ["6T"],
			irontail: ["6T"],
			muddywater: ["7L57", "6L53"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			round: ["7M", "6M"],
			scald: ["7M", "6M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			sludgewave: ["7M", "6M"],
			smackdown: ["7M", "7L42", "6M", "6L42"],
			snore: ["6T"],
			splash: ["7L1", "6L1"],
			substitute: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "7L25", "6M", "6L25"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			venoshock: ["7M", "6M"],
			visegrip: ["7L9", "7L1", "6L9"],
			waterfall: ["7M", "6M"],
			watergun: ["7L1", "6L1"],
			waterpulse: ["7L34", "6T", "6L34"],
			watersport: ["7L7", "7L1", "6L7"],
		},
	},
	helioptile: {
		inherit: true,
		learnset: {
			agility: ["7E", "6E"],
			attract: ["7M", "6M"],
			bulldoze: ["7M", "7L35", "6M", "6L35"],
			camouflage: ["7E", "6E"],
			charge: ["7L11", "6L11"],
			chargebeam: ["7M", "6M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			dragontail: ["7M", "6M"],
			electricterrain: ["7E", "6E"],
			electrify: ["7L45", "6L45"],
			electroweb: ["6T"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			glare: ["7E", "6E"],
			grassknot: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			irontail: ["6T"],
			lightscreen: ["7M", "6M"],
			lowsweep: ["7M", "6M"],
			magnetrise: ["6T"],
			mudslap: ["7L13", "6L13"],
			paraboliccharge: ["7L25", "6L25"],
			pound: ["7L1", "6L1"],
			protect: ["7M", "6M"],
			psychup: ["7M", "6M"],
			quickattack: ["7L17", "6L17"],
			raindance: ["7M", "6M"],
			razorwind: ["7L22", "6L22"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			sandstorm: ["7M", "6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tailwhip: ["7L1", "6L1"],
			thunder: ["7M", "6M"],
			thunderbolt: ["7M", "7L49", "6M", "6L49"],
			thundershock: ["7L6", "6L6"],
			thunderwave: ["7M", "7L31", "6M", "6L31"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			voltswitch: ["7M", "7L40", "6M", "6L40"],
			wildcharge: ["7M", "6M"],
		},
	},
	heliolisk: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M"],
			charge: ["7L1", "6L1"],
			chargebeam: ["7M", "6M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			dragonpulse: ["6T"],
			dragontail: ["7M", "6M"],
			eerieimpulse: ["7L1", "6L1"],
			electrify: ["7L1", "6L1"],
			electroweb: ["6T"],
			facade: ["7M", "6M"],
			firepunch: ["6T"],
			flash: ["6M"],
			focusblast: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			hypervoice: ["6T"],
			irontail: ["6T"],
			lightscreen: ["7M", "6M"],
			lowkick: ["6T"],
			lowsweep: ["7M", "6M"],
			magnetrise: ["6T"],
			paraboliccharge: ["7L1", "6L1"],
			protect: ["7M", "6M"],
			psychup: ["7M", "6M"],
			quickattack: ["7L1", "6L1"],
			raindance: ["7M", "6M"],
			razorwind: ["7L1", "6L1"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			sandstorm: ["7M", "6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			thunder: ["7M", "7L1", "6M", "6L1"],
			thunderbolt: ["7M", "6M"],
			thunderpunch: ["6T"],
			thunderwave: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			voltswitch: ["7M", "6M"],
			wildcharge: ["7M", "6M"],
		},
	},
	tyrunt: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			ancientpower: ["7L26", "6L26"],
			attract: ["7M", "6M"],
			bide: ["7L12", "6L12"],
			bite: ["7L17", "6L17"],
			block: ["6T"],
			brickbreak: ["7M", "6M"],
			bulldoze: ["7M", "6M"],
			charm: ["7L20", "6L20"],
			confide: ["7M", "6M"],
			crunch: ["7L34", "6L34"],
			curse: ["7E", "6E"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			dracometeor: ["7T", "6T"],
			dragonclaw: ["7M", "7L37", "6M", "6L37"],
			dragondance: ["7E", "6E"],
			dragonpulse: ["6T"],
			dragontail: ["7M", "7L30", "6M", "6L30"],
			earthpower: ["6T"],
			earthquake: ["7M", "7L44", "6M", "6L44"],
			facade: ["7M", "6M"],
			firefang: ["7E", "6E"],
			frustration: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["6M"],
			horndrill: ["7L49", "6L49"],
			hypervoice: ["6T"],
			icefang: ["7E", "6E"],
			irondefense: ["6T"],
			ironhead: ["6T"],
			irontail: ["6T"],
			outrage: ["6T"],
			poisonfang: ["7E", "6E"],
			protect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roar: ["7M", "7L6", "6M", "6L6", "6S0"],
			rockpolish: ["7M", "7E", "6M", "6E"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			sandstorm: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			stealthrock: ["7L15", "6T", "6L15"],
			stomp: ["7L10", "6L10", "6S0"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["6T"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1", "6S0"],
			tailwhip: ["7L1", "6L1", "6S0"],
			thrash: ["7L40", "6L40"],
			thunderfang: ["7E", "6E"],
			toxic: ["7M", "6M"],
			zenheadbutt: ["6T"],
		},
	},
	tyrantrum: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			ancientpower: ["7L26", "6L26"],
			attract: ["7M", "6M"],
			bide: ["7L12", "6L12"],
			bite: ["7L17", "6L17"],
			block: ["6T"],
			brickbreak: ["7M", "6M"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M"],
			charm: ["7L20", "6L20"],
			confide: ["7M", "6M"],
			crunch: ["7L34", "6L34"],
			darkpulse: ["7M", "6M"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			dracometeor: ["7T", "6T"],
			dragonclaw: ["7M", "7L37", "6M", "6L37"],
			dragonpulse: ["6T"],
			dragontail: ["7M", "7L30", "6M", "6L30"],
			earthpower: ["6T"],
			earthquake: ["7M", "7L47", "6M", "6L47"],
			facade: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "7L68", "6M", "6L75"],
			headsmash: ["7L58", "7L1", "6L1"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["6M"],
			horndrill: ["7L53", "6L53"],
			hyperbeam: ["7M", "6M"],
			hypervoice: ["6T"],
			irondefense: ["6T"],
			ironhead: ["6T"],
			irontail: ["6T"],
			outrage: ["6T"],
			protect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roar: ["7M", "7L6", "7L1", "6M", "6L6"],
			rockpolish: ["7M", "6M"],
			rockslide: ["7M", "7L1", "6M", "6L68"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			sandstorm: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			stealthrock: ["7L15", "6T", "6L15"],
			stomp: ["7L10", "7L1", "6L10"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["6T"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			tailwhip: ["7L1", "6L1"],
			thrash: ["7L42", "6L42"],
			toxic: ["7M", "6M"],
			zenheadbutt: ["6T"],
		},
	},
	amaura: {
		inherit: true,
		learnset: {
			ancientpower: ["7L26", "6L26"],
			aquatail: ["6T"],
			attract: ["7M", "6M"],
			aurorabeam: ["7L20", "6L20"],
			avalanche: ["7L34", "6L34"],
			barrier: ["7E", "6E"],
			blizzard: ["7M", "7L65", "6M", "6L65"],
			bulldoze: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			chargebeam: ["7M", "6M"],
			confide: ["7M", "6M"],
			darkpulse: ["7M", "6M"],
			discharge: ["7E", "6E"],
			doubleteam: ["7M", "6M"],
			dragontail: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			earthpower: ["6T"],
			echoedvoice: ["7M", "6M"],
			encore: ["7L44", "6L44"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			flashcannon: ["7M", "6M"],
			frostbreath: ["7M", "6M"],
			frustration: ["7M", "6M"],
			growl: ["7L1", "6L1", "6S0"],
			hail: ["7M", "7L38", "6M", "6L38"],
			haze: ["7E", "6E"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "7L57", "6M", "6L57"],
			hypervoice: ["6T"],
			icebeam: ["7M", "7L50", "6M", "6L50"],
			icywind: ["7L13", "6T", "6L13"],
			irondefense: ["6T"],
			ironhead: ["6T"],
			irontail: ["6T"],
			lightscreen: ["7M", "7L47", "6M", "6L47"],
			magnetrise: ["7E", "6T", "6E"],
			mirrorcoat: ["7E", "6E"],
			mist: ["7L18", "6L18"],
			naturepower: ["7M", "7L41", "6M", "6L41"],
			outrage: ["6T"],
			powdersnow: ["7L1", "6L1", "6S0"],
			protect: ["7M", "6M"],
			psychup: ["7M", "6M"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockpolish: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rockthrow: ["7L10", "6L10", "6S0"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "7L30", "6M", "6L30"],
			safeguard: ["7M", "6M"],
			sandstorm: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			stealthrock: ["6T"],
			stoneedge: ["7M", "6M"],
			substitute: ["7M", "6M"],
			swagger: ["7M", "6M"],
			takedown: ["7L15", "6L15"],
			thunderbolt: ["7M", "6M"],
			thunderwave: ["7M", "7L5", "6M", "6L5", "6S0"],
			toxic: ["7M", "6M"],
			waterpulse: ["6T"],
			zenheadbutt: ["6T"],
		},
	},
	aurorus: {
		inherit: true,
		learnset: {
			ancientpower: ["7L26", "6L26"],
			aquatail: ["6T"],
			attract: ["7M", "6M"],
			aurorabeam: ["7L20", "6L20"],
			avalanche: ["7L34", "6L34"],
			blizzard: ["7M", "7L74", "6M", "6L74"],
			bulldoze: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			chargebeam: ["7M", "6M"],
			confide: ["7M", "6M"],
			darkpulse: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			dragontail: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			earthpower: ["6T"],
			earthquake: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			encore: ["7L46", "6L46"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			flashcannon: ["7M", "6M"],
			freezedry: ["7L1", "6L1"],
			frostbreath: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			growl: ["7L1", "6L1"],
			hail: ["7M", "7L38", "6M", "6L38"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "7L63", "6M", "6L63"],
			hypervoice: ["6T"],
			icebeam: ["7M", "7L56", "6M", "6L56"],
			icywind: ["7L13", "6T", "6L13"],
			irondefense: ["6T"],
			ironhead: ["6T"],
			irontail: ["6T"],
			lightscreen: ["7M", "7L50", "6M", "6L50"],
			magnetrise: ["6T"],
			mist: ["7L18", "6L18"],
			naturepower: ["7M", "7L43", "6M", "6L43"],
			outrage: ["6T"],
			powdersnow: ["7L1", "6L1"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			psychup: ["7M", "6M"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockpolish: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rockthrow: ["7L10", "7L1", "6L10"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "7L30", "6M", "6L30"],
			safeguard: ["7M", "6M"],
			sandstorm: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			stealthrock: ["6T"],
			stoneedge: ["7M", "6M"],
			substitute: ["7M", "6M"],
			swagger: ["7M", "6M"],
			takedown: ["7L15", "6L15"],
			thunder: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			thunderwave: ["7M", "7L5", "7L1", "6M", "6L5"],
			toxic: ["7M", "6M"],
			waterpulse: ["6T"],
			zenheadbutt: ["6T"],
		},
	},
	sylveon: {
		inherit: true,
		learnset: {
			attract: ["7M", "6M"],
			babydolleyes: ["7L9", "6S1"],
			calmmind: ["7M", "7S2", "6M"],
			celebrate: ["6S0"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			cut: ["6M"],
			dazzlinggleam: ["7M", "6M"],
			dig: ["6M"],
			disarmingvoice: ["7L1", "6L1", "6S1"],
			doubleteam: ["7M", "6M"],
			drainingkiss: ["7L20", "7S2", "6L20", "6S1"],
			echoedvoice: ["7M", "6M"],
			facade: ["7M", "6M"],
			fairywind: ["7L1", "6L9", "6S0"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			healbell: ["6T"],
			helpinghand: ["7L1", "6T", "6L1", "6S0"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "7S2", "6M"],
			hypervoice: ["6T"],
			irontail: ["6T"],
			lastresort: ["7L41", "6T", "6L41"],
			lightscreen: ["7M", "7L33", "6M", "6L33"],
			magiccoat: ["6T"],
			mistyterrain: ["7L29", "6L29"],
			moonblast: ["7L37", "6L37"],
			protect: ["7M", "6M"],
			psychup: ["7M", "7L45", "6M", "6L45"],
			psyshock: ["7M", "7S2", "6M"],
			quickattack: ["7L13", "6L13", "6S1"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			sandattack: ["7L5", "6L5", "6S0"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M"],
			skillswap: ["7L25", "6T", "6L25"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			swift: ["7L17", "6L17"],
			tackle: ["7L1", "6L1"],
			tailwhip: ["7L1", "6L1"],
			toxic: ["7M", "6M"],
			workup: ["7M"],
		},
	},
	hawlucha: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M"],
			aerialace: ["7M", "7L16", "6M", "6L16"],
			agility: ["7E", "6E"],
			allyswitch: ["7E", "6E"],
			attract: ["7M", "6M"],
			batonpass: ["7E", "6E"],
			bounce: ["7L32", "6T", "6L32"],
			brickbreak: ["7M", "6M"],
			bulkup: ["7M", "6M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			detect: ["7L1", "6L1"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			drainpunch: ["6T"],
			dualchop: ["6T"],
			encore: ["7L20", "6L20"],
			endeavor: ["7L36", "6T", "6L36"],
			entrainment: ["7E", "6E"],
			facade: ["7M", "6M"],
			falseswipe: ["7M", "6M"],
			featherdance: ["7L40", "6L40"],
			firepunch: ["6T"],
			fling: ["7M", "7L24", "6M", "6L24"],
			fly: ["7M", "6M"],
			flyingpress: ["7L28", "6L28"],
			focusblast: ["7M", "6M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			highjumpkick: ["7L44", "6L44"],
			honeclaws: ["7L1", "6M", "6L1"],
			ironhead: ["6T"],
			karatechop: ["7L4", "6L4"],
			lastresort: ["6T"],
			lowkick: ["6T"],
			lowsweep: ["7M", "6M"],
			mefirst: ["7E", "6E"],
			mudsport: ["7E", "6E"],
			payback: ["7M", "6M"],
			poisonjab: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			quickguard: ["7E", "6E"],
			raindance: ["7M", "6M"],
			rest: ["7M", "6M"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			roost: ["7M", "7L12", "6M", "6L12"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			skyattack: ["7L48", "6T", "6L48"],
			skydrop: ["7M", "7L55", "6M", "6L55"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			steelwing: ["7M", "6M"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["6T"],
			swagger: ["7M", "6M"],
			swordsdance: ["7M", "7L60", "6M", "6L60"],
			tackle: ["7L1", "6L1"],
			tailwind: ["6T"],
			taunt: ["7M", "6M"],
			thunderpunch: ["6T"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			wingattack: ["7L8", "6L8"],
			workup: ["7M"],
			xscissor: ["7M", "6M"],
			zenheadbutt: ["6T"],
		},
	},
	dedenne: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "6M"],
			attract: ["7M", "6M"],
			charge: ["7L11", "6L11"],
			chargebeam: ["7M", "7L34", "6M", "6L34"],
			charm: ["7L14", "6L14"],
			confide: ["7M", "6M"],
			covet: ["7E", "6T", "6E"],
			cut: ["6M"],
			dig: ["6M"],
			discharge: ["7L50", "6L50"],
			doubleteam: ["7M", "6M"],
			eerieimpulse: ["7E", "6E"],
			electroweb: ["6T"],
			entrainment: ["7L39", "6L39"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			fling: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			helpinghand: ["7E", "6T", "6E"],
			hiddenpower: ["7M", "6M"],
			irontail: ["6T"],
			lastresort: ["6T"],
			magnetrise: ["6T"],
			naturalgift: ["7E", "6E"],
			nuzzle: ["7L20", "6L20"],
			paraboliccharge: ["7L17", "6L17"],
			playrough: ["7L42", "6L42"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			recycle: ["6T"],
			rest: ["7M", "7L30", "6M", "6L30"],
			retaliate: ["6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			sleeptalk: ["7M", "6M"],
			snore: ["7L31", "6T", "6L31"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superfang: ["6T"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			tailwhip: ["7L1", "6L1"],
			thief: ["7M", "6M"],
			thunder: ["7M", "7L45", "6M", "6L45"],
			thunderbolt: ["7M", "6M"],
			thunderpunch: ["6T"],
			thundershock: ["7L7", "6L7"],
			thunderwave: ["7M", "7L23", "6M", "6L23"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			voltswitch: ["7M", "7L26", "6M", "6L26"],
			wildcharge: ["7M", "6M"],
		},
	},
	carbink: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			ancientpower: ["7L31", "6L31"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			earthpower: ["6T"],
			explosion: ["7M", "6M"],
			facade: ["7M", "6M"],
			flail: ["7L35", "6L35"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gravity: ["6T"],
			guardsplit: ["7L27", "6L27"],
			gyroball: ["7M", "6M"],
			hail: ["7M", "6M"],
			harden: ["7L1", "6L1"],
			hiddenpower: ["7M", "6M"],
			irondefense: ["6T"],
			lightscreen: ["7M", "7L60", "6M", "6L60"],
			magiccoat: ["6T"],
			magnetrise: ["6T"],
			moonblast: ["7L50", "6L50"],
			naturepower: ["7M", "6M"],
			powergem: ["7L46", "6L46"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			psychup: ["7M", "6M"],
			reflect: ["7M", "7L18", "6M", "6L18"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockpolish: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rockthrow: ["7L5", "6L5"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "7L70", "6M", "6L70"],
			sandstorm: ["7M", "6M"],
			secretpower: ["6M"],
			sharpen: ["7L8", "6L8"],
			skillswap: ["7L40", "6T", "6L40"],
			sleeptalk: ["7M", "6M"],
			smackdown: ["7M", "7L12", "6M", "6L12"],
			snore: ["6T"],
			stealthrock: ["7L21", "6T", "6L21"],
			stoneedge: ["7M", "7L49", "6M", "6L49"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			toxic: ["7M", "6M"],
			trickroom: ["7M", "6M"],
			wonderroom: ["6T"],
		},
	},
	goomy: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "6L5"],
			acidarmor: ["7E", "6E"],
			attract: ["7M", "6M"],
			bide: ["7L13", "6L13"],
			bodyslam: ["7L32", "7S0", "6L32"],
			bubble: ["7L1", "6L1"],
			confide: ["7M", "6M"],
			counter: ["7E", "7S0", "6E"],
			curse: ["7E", "6E"],
			doubleteam: ["7M", "6M"],
			dracometeor: ["7T", "6T"],
			dragonbreath: ["7L18", "6L18"],
			dragonpulse: ["7L42", "7S0", "6T", "6L42"],
			endure: ["7E", "6E"],
			facade: ["7M", "6M"],
			flail: ["7L28", "6L28"],
			frustration: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			infestation: ["7M", "6M"],
			irontail: ["7E", "6T", "6E"],
			muddywater: ["7L38", "6L38"],
			outrage: ["6T"],
			poisontail: ["7E", "6E"],
			protect: ["7M", "7L9", "6M", "6L9"],
			raindance: ["7M", "7L25", "6M", "6L25"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			sludgewave: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			thunderbolt: ["7M", "6M"],
			toxic: ["7M", "6M"],
			waterpulse: ["6T"],
		},
	},
	sliggoo: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "7L1", "6L5"],
			attract: ["7M", "6M"],
			bide: ["7L13", "6L13"],
			blizzard: ["7M", "6M"],
			bodyslam: ["7L32", "6L32"],
			bubble: ["7L1", "6L1"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			dracometeor: ["7T", "6T"],
			dragonbreath: ["7L18", "6L18"],
			dragonpulse: ["7L47", "6T", "6L47"],
			facade: ["7M", "6M"],
			flail: ["7L28", "6L28"],
			frustration: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			icebeam: ["7M", "6M"],
			infestation: ["7M", "6M"],
			irontail: ["6T"],
			muddywater: ["7L38", "6L38"],
			outrage: ["6T"],
			protect: ["7M", "7L9", "6M", "6L9"],
			raindance: ["7M", "7L25", "6M", "6L25"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			sludgewave: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			thunderbolt: ["7M", "6M"],
			toxic: ["7M", "6M"],
			waterpulse: ["6T"],
		},
	},
	goodra: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "7L1", "6L5"],
			aquatail: ["7L1", "6T", "6L50"],
			attract: ["7M", "6M"],
			bide: ["7L13", "6L13"],
			blizzard: ["7M", "6M"],
			bodyslam: ["7L32", "6L32"],
			brutalswing: ["7M"],
			bubble: ["7L1", "6L1"],
			bulldoze: ["7M", "6M"],
			confide: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			dracometeor: ["7T", "6T"],
			dragonbreath: ["7L18", "6L18"],
			dragonpulse: ["7L47", "6T", "6L47"],
			dragontail: ["7M", "6M"],
			earthquake: ["7M", "6M"],
			facade: ["7M", "6M"],
			feint: ["7L1", "6L1"],
			fireblast: ["7M", "6M"],
			firepunch: ["6T"],
			flail: ["7L28", "6L28"],
			flamethrower: ["7M", "6M"],
			focusblast: ["7M", "6M"],
			focuspunch: ["6T"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			hail: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			icebeam: ["7M", "6M"],
			incinerate: ["6M"],
			infestation: ["7M", "6M"],
			irontail: ["6T"],
			muddywater: ["7L38", "6L38"],
			outrage: ["7L55", "7L1", "6T", "6L1"],
			powerwhip: ["7L50", "6L55"],
			protect: ["7M", "7L9", "7L1", "6M", "6L9"],
			raindance: ["7M", "7L25", "6M", "6L25"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			sludgewave: ["7M", "6M"],
			snore: ["6T"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["6T"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			thunder: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			thunderpunch: ["6T"],
			toxic: ["7M", "6M"],
			waterpulse: ["6T"],
		},
	},
	klefki: {
		inherit: true,
		learnset: {
			astonish: ["7L8", "6L8"],
			attract: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			craftyshield: ["7L23", "6L23"],
			cut: ["6M"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			drainingkiss: ["7L18", "6L18"],
			facade: ["7M", "6M"],
			fairylock: ["7L1", "6L1"],
			fairywind: ["7L5", "6L5"],
			flashcannon: ["7M", "6M"],
			foulplay: ["7L27", "6T", "6L27"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			healblock: ["7L50", "6L50"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			imprison: ["7L36", "6L36"],
			irondefense: ["7E", "6T", "6E"],
			lastresort: ["6T"],
			lightscreen: ["7M", "6M"],
			lockon: ["7E", "6E"],
			magiccoat: ["6T"],
			magicroom: ["7L44", "6T", "6L44"],
			magnetrise: ["6T"],
			metalsound: ["7L12", "6L12"],
			mirrorshot: ["7L34", "6L34"],
			playrough: ["7L43", "6L43"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			psychup: ["7M", "6M"],
			psyshock: ["7M", "6M"],
			raindance: ["7M", "6M"],
			recycle: ["7L40", "6T", "6L40"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			spikes: ["7L15", "6L15"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			switcheroo: ["7E", "6E"],
			tackle: ["7L1", "6L1"],
			thief: ["7M", "7E", "6M", "6E"],
			thunderwave: ["7M", "6M"],
			torment: ["7M", "7L32", "6M", "6L32"],
			toxic: ["7M", "6M"],
		},
	},
	phantump: {
		inherit: true,
		learnset: {
			astonish: ["7L5", "6L5"],
			attract: ["7M", "6M"],
			bestow: ["7E", "6E"],
			bulldoze: ["7M", "6M"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L1"],
			curse: ["7L28", "6L28"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			destinybond: ["7L39", "6L39"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			feintattack: ["7L19", "6L19"],
			forestscurse: ["7L35", "6L35"],
			foulplay: ["6T"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			grassknot: ["7M", "6M"],
			growth: ["7L8", "6L8"],
			grudge: ["7E", "6E"],
			hiddenpower: ["7M", "6M"],
			hornleech: ["7L54", "6L54"],
			imprison: ["7E", "6E"],
			ingrain: ["7L13", "6L13"],
			leechseed: ["7L23", "6L23"],
			magiccoat: ["6T"],
			naturepower: ["7M", "6M"],
			painsplit: ["6T"],
			phantomforce: ["7L45", "6L45"],
			poisonjab: ["7M", "6M"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			roleplay: ["6T"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			secretpower: ["6M"],
			seedbomb: ["6T"],
			shadowball: ["7M", "6M"],
			shadowclaw: ["7M", "6M"],
			skillswap: ["6T"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			spite: ["6T"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trick: ["6T"],
			trickroom: ["7M", "6M"],
			venomdrench: ["7E", "6E"],
			willowisp: ["7M", "7L31", "6M", "6L31"],
			woodhammer: ["7L49", "6L49"],
			worryseed: ["6T"],
		},
	},
	trevenant: {
		inherit: true,
		learnset: {
			astonish: ["7L5", "7L1", "6L5"],
			attract: ["7M", "6M"],
			block: ["6T"],
			brutalswing: ["7M"],
			bulldoze: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L1"],
			curse: ["7L28", "6L28"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			destinybond: ["7L39", "6L39"],
			dig: ["6M"],
			doubleteam: ["7M", "6M"],
			drainpunch: ["6T"],
			dreameater: ["7M", "6M"],
			earthquake: ["7M", "6M"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			feintattack: ["7L19", "6L19"],
			focusblast: ["7M", "6M"],
			forestscurse: ["7L35", "6L35"],
			foulplay: ["6T"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			growth: ["7L8", "7L1", "6L8"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["6M"],
			hornleech: ["7L54", "7L1", "6L1"],
			hyperbeam: ["7M", "6M"],
			ingrain: ["7L13", "6L13"],
			leechseed: ["7L23", "6L23"],
			magiccoat: ["6T"],
			naturepower: ["7M", "6M"],
			painsplit: ["6T"],
			phantomforce: ["7L45", "6L45"],
			poisonjab: ["7M", "6M"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			roleplay: ["6T"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			secretpower: ["6M"],
			seedbomb: ["6T"],
			shadowball: ["7M", "6M"],
			shadowclaw: ["7M", "7L1", "6M", "6L55"],
			skillswap: ["6T"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			spite: ["6T"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trick: ["6T"],
			trickroom: ["7M", "6M"],
			willowisp: ["7M", "7L31", "6M", "6L31"],
			woodhammer: ["7L49", "6L49"],
			worryseed: ["6T"],
			xscissor: ["7M", "6M"],
		},
	},
	pumpkaboo: {
		inherit: true,
		learnset: {
			astonish: ["7L1", "6L1"],
			attract: ["7M", "6M"],
			bestow: ["7E", "6E"],
			bulletseed: ["7L26", "6L26"],
			chargebeam: ["7M", "6M"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L1"],
			darkpulse: ["7M", "6M"],
			destinybond: ["7E", "6E"],
			disable: ["7E", "6E"],
			doubleteam: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			energyball: ["7M", "6M"],
			explosion: ["7M", "6M"],
			facade: ["7M", "6M"],
			fireblast: ["7M", "6M"],
			flamecharge: ["7M", "6M"],
			flamethrower: ["7M", "6M"],
			flash: ["6M"],
			foulplay: ["6T"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			grassknot: ["7M", "6M"],
			gyroball: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			incinerate: ["6M"],
			leechseed: ["7L20", "6L20"],
			lightscreen: ["7M", "6M"],
			magiccoat: ["6T"],
			naturepower: ["7M", "6M"],
			painsplit: ["7L42", "6T", "6L42"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			razorleaf: ["7L16", "6L16"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			roleplay: ["6T"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			scaryface: ["7L4", "6L4"],
			secretpower: ["6M"],
			seedbomb: ["7L48", "6T", "6L48"],
			shadowball: ["7M", "7L36", "6M", "6L36"],
			shadowsneak: ["7L30", "6L30"],
			skillswap: ["6T"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			solarbeam: ["7M", "6M"],
			spite: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			synthesis: ["6T"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trick: ["7L1", "6T", "6L1"],
			trickortreat: ["7L40", "7L23", "7L6", "6L6"],
			trickroom: ["7M", "6M"],
			willowisp: ["7M", "6M"],
			worryseed: ["7L11", "6T", "6L11"],
		},
	},
	gourgeist: {
		inherit: true,
		learnset: {
			astonish: ["7L1", "6L1"],
			attract: ["7M", "6M"],
			bulletseed: ["7L26", "6L26"],
			chargebeam: ["7M", "6M"],
			confide: ["7M", "6M"],
			confuseray: ["7L1", "6L1"],
			darkpulse: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			dreameater: ["7M", "6M"],
			energyball: ["7M", "6M"],
			explosion: ["7M", "7L70", "7L1", "6M", "6L1"],
			facade: ["7M", "6M"],
			fireblast: ["7M", "6M"],
			flamecharge: ["7M", "6M"],
			flamethrower: ["7M", "6M"],
			flash: ["6M"],
			focusblast: ["7M", "6M"],
			foulplay: ["6T"],
			frustration: ["7M", "6M"],
			gigadrain: ["6T"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			gyroball: ["7M", "6M"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			incinerate: ["6M"],
			leechseed: ["7L20", "6L20"],
			lightscreen: ["7M", "6M"],
			magiccoat: ["6T"],
			naturepower: ["7M", "6M"],
			painsplit: ["7L42", "6T", "6L42"],
			phantomforce: ["7L57", "7L1", "6L1"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			razorleaf: ["7L16", "6L16"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			roleplay: ["6T"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			scaryface: ["7L4", "7L1", "6L4"],
			secretpower: ["6M"],
			seedbomb: ["7L48", "6T", "6L48"],
			shadowball: ["7M", "7L36", "6M", "6L36"],
			shadowsneak: ["7L30", "6L30"],
			skillswap: ["6T"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			solarbeam: ["7M", "6M"],
			spite: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			synthesis: ["6T"],
			thief: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trick: ["7L1", "6T", "6L1"],
			trickortreat: ["7L63", "7L40", "7L23", "7L6", "6L6"],
			trickroom: ["7M", "6M"],
			willowisp: ["7M", "6M"],
			worryseed: ["7L11", "6T", "6L11"],
		},
	},
	bergmite: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			attract: ["7M", "6M"],
			avalanche: ["7L39", "6L39"],
			barrier: ["7E", "6E"],
			bite: ["7L1", "6L1"],
			blizzard: ["7M", "7L43", "6M", "6L43"],
			confide: ["7M", "6M"],
			curse: ["7L22", "6L22"],
			doubleedge: ["7L49", "6L49"],
			doubleteam: ["7M", "6M"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			flashcannon: ["7M", "6M"],
			frostbreath: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gyroball: ["7M", "6M"],
			hail: ["7M", "6M"],
			harden: ["7L1", "6L1"],
			hiddenpower: ["7M", "6M"],
			iceball: ["7L30", "6L30"],
			icebeam: ["7M", "6M"],
			icefang: ["7L26", "6L26"],
			icywind: ["7L10", "6T", "6L10"],
			irondefense: ["6T"],
			mirrorcoat: ["7E", "6E"],
			mist: ["7E", "6E"],
			powdersnow: ["7L5", "6L5"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rapidspin: ["7L35", "6L35"],
			recover: ["7L47", "7E", "6L47", "6E"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockpolish: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			secretpower: ["6M"],
			sharpen: ["7L20", "6L20"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			takedown: ["7L15", "6L15"],
			toxic: ["7M", "6M"],
			waterpulse: ["6T"],
		},
	},
	avalugg: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			attract: ["7M", "6M"],
			avalanche: ["7L42", "6L42"],
			bite: ["7L1", "6L1"],
			blizzard: ["7M", "7L46", "6M", "6L46"],
			block: ["6T"],
			bodyslam: ["7L1"],
			bulldoze: ["7M", "6M"],
			confide: ["7M", "6M"],
			crunch: ["7L65", "7L1", "6L1"],
			curse: ["7L22", "6L22"],
			doubleedge: ["7L56", "6L56"],
			doubleteam: ["7M", "6M"],
			earthquake: ["7M", "6M"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			flashcannon: ["7M", "6M"],
			frostbreath: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			gyroball: ["7M", "6M"],
			hail: ["7M", "6M"],
			harden: ["7L1", "6L1"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			iceball: ["7L30", "6L30"],
			icebeam: ["7M", "6M"],
			icefang: ["7L26", "6L26"],
			icywind: ["7L10", "6T", "6L10"],
			irondefense: ["7L1", "6T", "6L1"],
			ironhead: ["6T"],
			powdersnow: ["7L5", "7L1", "6L5"],
			protect: ["7M", "6M"],
			raindance: ["7M", "6M"],
			rapidspin: ["7L35", "6L35"],
			recover: ["7L51", "6L51"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockpolish: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			secretpower: ["6M"],
			sharpen: ["7L20", "6L20"],
			skullbash: ["7L60", "7L1", "6L1"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			superpower: ["6T"],
			surf: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			takedown: ["7L15", "6L15"],
			toxic: ["7M", "6M"],
			waterpulse: ["6T"],
		},
	},
	noibat: {
		inherit: true,
		learnset: {
			absorb: ["7L5"],
			acrobatics: ["7M", "6M"],
			aerialace: ["7M", "6M"],
			agility: ["7L18", "6L18"],
			aircutter: ["7L23", "6L23"],
			airslash: ["7L48", "6L48"],
			attract: ["7M", "6M"],
			bite: ["7L13", "6L13"],
			brickbreak: ["7M", "6M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			dracometeor: ["7T", "6T"],
			dragonpulse: ["6T"],
			dreameater: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			facade: ["7M", "6M"],
			fly: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gust: ["7L11", "6L11"],
			heatwave: ["6T"],
			hiddenpower: ["7M", "6M"],
			hurricane: ["7L58", "6L58"],
			hypervoice: ["6T"],
			irontail: ["6T"],
			leechlife: ["7M", "6L5"],
			outrage: ["7E", "6T", "6E"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			razorwind: ["7L31", "6L31"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roost: ["7M", "7L27", "6M", "6L27"],
			round: ["7M", "6M"],
			screech: ["7L1", "6L1"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M"],
			shadowclaw: ["7M", "6M"],
			skyattack: ["6T"],
			sleeptalk: ["7M", "6M"],
			snatch: ["7E", "6T", "6E"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			steelwing: ["7M", "6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superfang: ["7L43", "6T", "6L43"],
			supersonic: ["7L1", "6L1"],
			swagger: ["7M", "6M"],
			switcheroo: ["7E", "6E"],
			tackle: ["7L1", "6L1"],
			tailwind: ["7L35", "7E", "6T", "6L35", "6E"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uproar: ["6T"],
			uturn: ["7M", "6M"],
			waterpulse: ["6T"],
			whirlwind: ["7L40", "6L40"],
			wildcharge: ["7M", "6M"],
			wingattack: ["7L16", "6L16"],
			xscissor: ["7M", "6M"],
		},
	},
	noivern: {
		inherit: true,
		learnset: {
			absorb: ["7L5", "7L1"],
			acrobatics: ["7M", "6M"],
			aerialace: ["7M", "6M"],
			agility: ["7L18", "6L18"],
			aircutter: ["7L23", "6L23"],
			airslash: ["7L53", "6L53"],
			attract: ["7M", "6M"],
			bite: ["7L13", "6L13"],
			boomburst: ["7L75", "7L1", "6L1"],
			brickbreak: ["7M", "6M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			darkpulse: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			dracometeor: ["7T", "6T"],
			dragonclaw: ["7M", "6M"],
			dragonpulse: ["7L70", "7L1", "6T", "6L1"],
			dreameater: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			facade: ["7M", "6M"],
			flamethrower: ["7M", "6M"],
			fly: ["7M", "6M"],
			focusblast: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			gust: ["7L11", "6L11"],
			heatwave: ["6T"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["6M"],
			hurricane: ["7L62", "7L1", "6L1"],
			hyperbeam: ["7M", "6M"],
			hypervoice: ["6T"],
			irontail: ["6T"],
			leechlife: ["7M", "6L5"],
			moonlight: ["7L1", "6L1"],
			outrage: ["6T"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			razorwind: ["7L31", "6L31"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roost: ["7M", "7L27", "6M", "6L27"],
			round: ["7M", "6M"],
			screech: ["7L1", "6L1"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M"],
			shadowclaw: ["7M", "6M"],
			skyattack: ["6T"],
			sleeptalk: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			steelwing: ["7M", "6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superfang: ["7L43", "6T", "6L43"],
			supersonic: ["7L1", "6L1"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			tailwind: ["7L35", "6T", "6L35"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uproar: ["6T"],
			uturn: ["7M", "6M"],
			waterpulse: ["6T"],
			whirlwind: ["7L40", "6L40"],
			wildcharge: ["7M", "6M"],
			wingattack: ["7L16", "6L16"],
			xscissor: ["7M", "6M"],
		},
	},
	xerneas: {
		inherit: true,
		learnset: {
			aromatherapy: ["7L1", "6L1", "6S1"],
			aurorabeam: ["7L10", "6L10"],
			block: ["6T"],
			calmmind: ["7M", "6M"],
			closecombat: ["7L80", "6L80"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			dazzlinggleam: ["7M", "6M"],
			doubleteam: ["7M", "6M"],
			echoedvoice: ["7M", "6M"],
			endeavor: ["6T"],
			facade: ["7M", "6M"],
			flash: ["6M"],
			flashcannon: ["7M", "6M"],
			focusblast: ["7M", "6M", "6S1"],
			frustration: ["7M", "6M"],
			geomancy: ["7L26", "6L26", "6S0", "6S1"],
			gigaimpact: ["7M", "7L88", "6M", "6L88"],
			grassknot: ["7M", "6M"],
			gravity: ["7L18", "6T", "6L18", "6S0"],
			hail: ["7M", "6M"],
			healpulse: ["7L1", "6L1"],
			hiddenpower: ["7M", "6M"],
			hornleech: ["7L55", "6L55"],
			hyperbeam: ["7M", "6M"],
			hypervoice: ["6T"],
			ingrain: ["7L1", "6L1"],
			lightscreen: ["7M", "7L5", "6M", "6L5"],
			megahorn: ["7L44", "6L44", "6S0"],
			mistyterrain: ["7L63", "6L63"],
			moonblast: ["7L35", "6L35", "6S0", "6S1"],
			naturepower: ["7M", "7L72", "6M", "6L72"],
			nightslash: ["7L51", "6L51"],
			outrage: ["7L93", "6T", "6L93"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			psychup: ["7M", "7L59", "6M", "6L59"],
			psyshock: ["7M", "6M"],
			raindance: ["7M", "6M"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			takedown: ["7L1", "6L1"],
			thunder: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			thunderwave: ["7M", "6M"],
			toxic: ["7M", "6M"],
			wonderroom: ["6T"],
			zenheadbutt: ["6T"],
		},
	},
	yveltal: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "6M"],
			aerialace: ["7M", "6M"],
			airslash: ["7L10", "6L10"],
			block: ["6T"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			darkpulse: ["7M", "7L44", "6M", "6L44", "6S0", "6S1"],
			disable: ["7L35", "6L35", "6S0"],
			doubleteam: ["7M", "7L5", "6M", "6L5"],
			dragonclaw: ["7M", "6M"],
			dragonrush: ["7L63", "6L63"],
			dreameater: ["7M", "6M"],
			embargo: ["7M", "6M"],
			facade: ["7M", "6M"],
			fly: ["7M", "6M"],
			focusblast: ["7M", "7L72", "6M", "6L72"],
			foulplay: ["7L51", "6T", "6L51", "6S1"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			heatwave: ["6T"],
			hiddenpower: ["7M", "6M"],
			honeclaws: ["6M"],
			hurricane: ["7L1", "6L1"],
			hyperbeam: ["7M", "7L88", "6M", "6L88"],
			hypervoice: ["6T"],
			knockoff: ["6T"],
			oblivionwing: ["7L26", "6L26", "6S0", "6S1"],
			phantomforce: ["7L55", "6L55"],
			protect: ["7M", "6M"],
			psychic: ["7M", "7L59", "6M", "6L59"],
			raindance: ["7M", "6M"],
			razorwind: ["7L1", "6L1"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			roost: ["7M", "7L1", "6M", "6L1"],
			round: ["7M", "6M"],
			secretpower: ["6M"],
			shadowball: ["7M", "6M"],
			shadowclaw: ["7M", "6M"],
			skyattack: ["7L93", "6T", "6L93"],
			skydrop: ["7M", "6M"],
			sleeptalk: ["7M", "6M"],
			snarl: ["7M", "7L18", "6M", "6L18", "6S0"],
			snore: ["6T"],
			steelwing: ["7M", "6M"],
			substitute: ["7M", "6M"],
			suckerpunch: ["7L80", "6L80", "6S1"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tailwind: ["6T"],
			taunt: ["7M", "7L1", "6M", "6L1"],
			thief: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			uturn: ["7M", "6M"],
			zenheadbutt: ["6T"],
		},
	},
	zygarde: {
		inherit: true,
		learnset: {
			bind: ["7L18", "7S2", "7S3", "6T", "6L18"],
			bite: ["7L1", "6L1"],
			block: ["6T"],
			brickbreak: ["7M", "6M"],
			bulldoze: ["7M", "7L1", "6M", "6L1"],
			camouflage: ["7L59", "6L59", "6S0"],
			coil: ["7L72", "6L80"],
			confide: ["7M", "6M"],
			coreenforcer: ["7T"],
			crunch: ["7L51", "6L51", "6S0"],
			dig: ["7L10", "6M", "6L10"],
			doubleteam: ["7M", "6M"],
			dracometeor: ["7T", "6T"],
			dragonbreath: ["7L1", "6L1"],
			dragondance: ["7T", "6L72"],
			dragonpulse: ["7L63", "6T", "6L63", "6S0"],
			dragontail: ["7M", "6M"],
			earthpower: ["6T"],
			earthquake: ["7M", "7L55", "6M", "6L55", "6S0"],
			extremespeed: ["7T", "6L88", "6S1"],
			facade: ["7M", "6M"],
			focusblast: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			glare: ["7L1", "6L1", "6S1"],
			grassknot: ["7M", "6M"],
			haze: ["7L44", "7S2", "7S3", "6L44"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			hypervoice: ["6T"],
			irontail: ["6T"],
			landswrath: ["7L26", "7S2", "7S3", "6L26", "6S1"],
			outrage: ["7L80", "6T", "6L93", "6S1"],
			painsplit: ["6T"],
			protect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "7L5", "6M", "6L5"],
			sandstorm: ["7M", "7L35", "7S2", "7S3", "6M", "6L35"],
			secretpower: ["6M"],
			shockwave: ["6T"],
			sleeptalk: ["7M", "6M"],
			sludgewave: ["7M", "6M"],
			snore: ["6T"],
			spite: ["6T"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["6T"],
			swagger: ["7M", "6M"],
			thousandarrows: ["7T"],
			thousandwaves: ["7T"],
			toxic: ["7M", "6M"],
			zenheadbutt: ["6T"],
		},
	},
	diancie: {
		inherit: true,
		learnset: {
			afteryou: ["6T"],
			ancientpower: ["7L27", "6L31"],
			calmmind: ["7M", "6M"],
			confide: ["7M", "6M"],
			covet: ["6T"],
			dazzlinggleam: ["7M", "6M"],
			diamondstorm: ["7L50", "6L50", "6S0", "6S1"],
			doubleteam: ["7M", "6M"],
			earthpower: ["6T"],
			endeavor: ["6T"],
			explosion: ["7M", "6M"],
			facade: ["7M", "6M"],
			flail: ["7L31", "6L35"],
			flash: ["6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			gravity: ["6T"],
			guardsplit: ["7L21", "6L27"],
			gyroball: ["7M", "6M"],
			hail: ["7M", "6M"],
			harden: ["7L1", "6L1"],
			healbell: ["6T"],
			helpinghand: ["6T"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			irondefense: ["6T"],
			lastresort: ["6T"],
			lightscreen: ["7M", "7L60", "6M", "6L60"],
			magnetrise: ["6T"],
			moonblast: ["7L50", "6L50", "6S0", "6S1"],
			naturepower: ["7M", "6M"],
			powergem: ["7L40"],
			protect: ["7M", "6M"],
			psychic: ["7M", "6M"],
			psychup: ["7M", "6M"],
			psyshock: ["7M", "6M"],
			reflect: ["7M", "7L12", "6M", "6L18", "6S0", "6S1"],
			rest: ["7M", "6M"],
			return: ["7M", "6M", "6S0", "6S1"],
			rockpolish: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rockthrow: ["7L1", "6L5"],
			rocktomb: ["7M", "6M"],
			round: ["7M", "6M"],
			safeguard: ["7M", "7L70", "6M", "6L70"],
			sandstorm: ["7M", "6M"],
			secretpower: ["6M"],
			sharpen: ["7L5", "6L8"],
			skillswap: ["7L35", "6T", "6L40"],
			sleeptalk: ["7M", "6M"],
			smackdown: ["7M", "7L8", "6M", "6L12"],
			snore: ["6T"],
			stealthrock: ["7L18", "6T", "6L21"],
			stoneedge: ["7M", "7L49", "6M", "6L49"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			tackle: ["7L1", "6L1"],
			toxic: ["7M", "6M"],
			trickroom: ["7M", "7L46", "6M", "6L46"],
			wonderroom: ["6T"],
		},
	},
	hoopa: {
		inherit: true,
		learnset: {
			allyswitch: ["7L1", "6L1"],
			astonish: ["7L6", "6L6", "6S0"],
			block: ["6T"],
			brickbreak: ["7M", "6M"],
			calmmind: ["7M", "6M"],
			chargebeam: ["7M", "6M"],
			confide: ["7M", "6M"],
			confusion: ["7L1", "6L1"],
			covet: ["6T"],
			darkpulse: ["7M", "6L55"],
			destinybond: ["7L1", "6L1"],
			doubleteam: ["7M", "6M"],
			drainpunch: ["6T"],
			dreameater: ["7M", "6M"],
			dualchop: ["6T"],
			embargo: ["7M", "6M"],
			energyball: ["7M", "6M"],
			facade: ["7M", "6M"],
			firepunch: ["6T"],
			flash: ["6M"],
			fling: ["7M", "6M"],
			focusblast: ["7M", "6M"],
			focuspunch: ["6T"],
			foulplay: ["6T"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			grassknot: ["7M", "6M"],
			gravity: ["6T"],
			guardsplit: ["7L29", "6L29"],
			gunkshot: ["6T"],
			hiddenpower: ["7M", "6M"],
			hyperbeam: ["7M", "6M"],
			hyperspacefury: ["6L1"],
			hyperspacehole: ["7L85", "7L1", "6L1", "6S0"],
			icepunch: ["6T"],
			knockoff: ["6T", "6L46"],
			lastresort: ["6T"],
			lightscreen: ["7M", "7L15", "6M", "6L15"],
			magiccoat: ["7L10", "6T", "6L10"],
			magicroom: ["6T"],
			nastyplot: ["7L68", "6L68", "6S0"],
			phantomforce: ["7L35", "6L35"],
			powersplit: ["7L29", "6L29"],
			poweruppunch: ["6M"],
			protect: ["7M", "6M"],
			psybeam: ["7L19", "6L15"],
			psychic: ["7M", "7L75", "6M", "6L75", "6S0"],
			psychup: ["7M", "6M"],
			psyshock: ["7M", "6M"],
			quash: ["7M", "6M"],
			raindance: ["7M", "6M"],
			recycle: ["6T"],
			reflect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roleplay: ["6T"],
			round: ["7M", "6M"],
			safeguard: ["7M", "6M"],
			secretpower: ["6M"],
			shadowball: ["7M", "7L55", "6M", "6L55"],
			shockwave: ["6T"],
			signalbeam: ["6T"],
			skillswap: ["7L25", "6T", "6L25"],
			sleeptalk: ["7M", "6M"],
			snatch: ["6T"],
			snore: ["6T"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			swagger: ["7M", "6M"],
			taunt: ["7M", "6M"],
			thief: ["7M", "6M"],
			thunderbolt: ["7M", "6M"],
			thunderpunch: ["6T"],
			thunderwave: ["7M", "6M"],
			torment: ["7M", "6M"],
			toxic: ["7M", "6M"],
			trick: ["7L1", "6T", "6L1"],
			trickroom: ["7M", "7L50", "6M", "6L50"],
			uproar: ["6T"],
			wonderroom: ["7L50", "6T", "6L50"],
			zenheadbutt: ["7L46", "6T", "6L46"],
		},
	},
	volcanion: {
		inherit: true,
		learnset: {
			bodyslam: ["7L46", "6L46"],
			brickbreak: ["7M", "6M"],
			bulldoze: ["7M", "6M"],
			confide: ["7M", "6M"],
			cut: ["6M"],
			doubleteam: ["7M", "6M"],
			earthpower: ["6T"],
			earthquake: ["7M", "6M"],
			explosion: ["7M", "7L76", "6M", "6L76", "6S1"],
			facade: ["7M", "6M"],
			fireblast: ["7M", "6M"],
			flamecharge: ["7M", "7L15", "6M", "6L15"],
			flamethrower: ["7M", "6M", "6S1"],
			flareblitz: ["7L58", "7L1", "6L1"],
			flashcannon: ["7M", "6M"],
			fling: ["7M", "6M"],
			focusblast: ["7M", "6M"],
			frustration: ["7M", "6M"],
			gigaimpact: ["7M", "6M"],
			gyroball: ["7M", "6M"],
			haze: ["7L11", "6L11"],
			heatwave: ["6T"],
			hiddenpower: ["7M", "6M"],
			hydropump: ["7L50", "6L50", "6S0", "6S1"],
			hyperbeam: ["7M", "6M"],
			incinerate: ["6M"],
			mist: ["7L8", "6L8", "6S0"],
			overheat: ["7M", "7L65", "6M", "6L65", "6S0"],
			protect: ["7M", "6M"],
			rest: ["7M", "6M"],
			return: ["7M", "6M"],
			roar: ["7M", "6M"],
			rockslide: ["7M", "6M"],
			rocksmash: ["6M"],
			round: ["7M", "6M"],
			sandstorm: ["7M", "6M"],
			scald: ["7M", "7L32", "6M", "6L32"],
			secretpower: ["6M"],
			sleeptalk: ["7M", "6M"],
			sludgebomb: ["7M", "6M"],
			sludgewave: ["7M", "6M"],
			smackdown: ["7M", "6M"],
			snore: ["6T"],
			solarbeam: ["7M", "6M"],
			steameruption: ["7L85", "7L1", "6L1", "6S0", "6S1"],
			stomp: ["7L28", "6L28"],
			stoneedge: ["7M", "6M"],
			strength: ["6M"],
			substitute: ["7M", "6M"],
			sunnyday: ["7M", "6M"],
			superpower: ["6T"],
			swagger: ["7M", "6M"],
			takedown: ["7L1", "6L1"],
			toxic: ["7M", "6M"],
			waterpulse: ["7L21", "6T", "6L21"],
			weatherball: ["7L40", "6L40"],
			willowisp: ["7M", "6M"],
		},
	},
	rowlet: {
		inherit: true,
		learnset: {
			astonish: ["7L11"],
			attract: ["7M"],
			batonpass: ["7E"],
			bravebird: ["7L43"],
			confide: ["7M"],
			confuseray: ["7E"],
			curse: ["7E"],
			defog: ["7E"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			featherdance: ["7L39"],
			foresight: ["7L18"],
			frustration: ["7M"],
			furyattack: ["7L29"],
			grassknot: ["7M"],
			grasspledge: ["7T"],
			growl: ["7L4"],
			haze: ["7E"],
			hiddenpower: ["7M"],
			leafage: ["7L1"],
			leafblade: ["7L36"],
			lightscreen: ["7M"],
			nastyplot: ["7L46"],
			naturepower: ["7M"],
			ominouswind: ["7E"],
			peck: ["7L8"],
			pluck: ["7L22"],
			protect: ["7M"],
			razorleaf: ["7L15"],
			rest: ["7M"],
			return: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			steelwing: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L32"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			synthesis: ["7L25"],
			tackle: ["7L1"],
			toxic: ["7M"],
			workup: ["7M"],
		},
	},
	dartrix: {
		inherit: true,
		learnset: {
			astonish: ["7L11"],
			attract: ["7M"],
			bravebird: ["7L51"],
			confide: ["7M"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			featherdance: ["7L46"],
			foresight: ["7L19"],
			frustration: ["7M"],
			furyattack: ["7L33"],
			grassknot: ["7M"],
			grasspledge: ["7T"],
			growl: ["7L4", "7L1"],
			hiddenpower: ["7M"],
			leafage: ["7L1"],
			leafblade: ["7L42"],
			lightscreen: ["7M"],
			nastyplot: ["7L55"],
			naturepower: ["7M"],
			peck: ["7L8", "7L1"],
			pluck: ["7L24"],
			protect: ["7M"],
			razorleaf: ["7L15"],
			rest: ["7M"],
			return: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			steelwing: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L37"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			synthesis: ["7L28"],
			tackle: ["7L1"],
			toxic: ["7M"],
			workup: ["7M"],
		},
	},
	decidueye: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			astonish: ["7L11"],
			attract: ["7M"],
			bravebird: ["7L55"],
			confide: ["7M"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			featherdance: ["7L49"],
			foresight: ["7L19"],
			frenzyplant: ["7T"],
			frustration: ["7M"],
			furyattack: ["7L33"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			grasspledge: ["7T"],
			growl: ["7L4", "7L1"],
			hiddenpower: ["7M"],
			leafage: ["7L1"],
			leafblade: ["7L44"],
			lightscreen: ["7M"],
			lowsweep: ["7M"],
			nastyplot: ["7L60"],
			naturepower: ["7M"],
			peck: ["7L8", "7L1"],
			pluck: ["7L24"],
			protect: ["7M"],
			razorleaf: ["7L15"],
			rest: ["7M"],
			return: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			shadowball: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			smackdown: ["7M"],
			solarbeam: ["7M"],
			spiritshackle: ["7L1"],
			steelwing: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L38"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			synthesis: ["7L28"],
			tackle: ["7L1"],
			toxic: ["7M"],
			uturn: ["7M", "7L1"],
			workup: ["7M"],
		},
	},
	litten: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			attract: ["7M"],
			bite: ["7L22"],
			bodyslam: ["7E"],
			bulkup: ["7M"],
			confide: ["7M"],
			crunch: ["7E"],
			doubleteam: ["7M"],
			ember: ["7L1"],
			facade: ["7M"],
			fakeout: ["7E"],
			fireblast: ["7M"],
			firefang: ["7L15"],
			firepledge: ["7T"],
			flamecharge: ["7M"],
			flamethrower: ["7M", "7L36"],
			flareblitz: ["7L43"],
			frustration: ["7M"],
			furyswipes: ["7L29"],
			growl: ["7L4"],
			heatwave: ["7E"],
			hiddenpower: ["7M"],
			leechlife: ["7M"],
			leer: ["7L11"],
			lick: ["7L8"],
			nastyplot: ["7E"],
			outrage: ["7L46"],
			overheat: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			revenge: ["7E"],
			roar: ["7M", "7L18"],
			round: ["7M"],
			scaryface: ["7L39"],
			scratch: ["7L1"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M", "7L25"],
			swordsdance: ["7M"],
			taunt: ["7M"],
			thrash: ["7L32"],
			torment: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			willowisp: ["7M"],
			workup: ["7M"],
		},
	},
	torracat: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			attract: ["7M"],
			bite: ["7L24"],
			bulkup: ["7M"],
			confide: ["7M"],
			doubleteam: ["7M"],
			ember: ["7L1"],
			facade: ["7M"],
			fireblast: ["7M"],
			firefang: ["7L15"],
			firepledge: ["7T"],
			flamecharge: ["7M"],
			flamethrower: ["7M", "7L42"],
			flareblitz: ["7L51"],
			frustration: ["7M"],
			furyswipes: ["7L33"],
			growl: ["7L4", "7L1"],
			hiddenpower: ["7M"],
			leechlife: ["7M"],
			leer: ["7L11"],
			lick: ["7L8", "7L1"],
			outrage: ["7L55"],
			overheat: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M", "7L19"],
			round: ["7M"],
			scaryface: ["7L46"],
			scratch: ["7L1"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M", "7L28"],
			swordsdance: ["7M"],
			taunt: ["7M"],
			thrash: ["7L37"],
			torment: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			willowisp: ["7M"],
			workup: ["7M"],
		},
	},
	incineroar: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			attract: ["7M"],
			bite: ["7L24"],
			blastburn: ["7T"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "7L1"],
			bulldoze: ["7M"],
			confide: ["7M"],
			crosschop: ["7L66"],
			darkestlariat: ["7L1"],
			darkpulse: ["7M"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			embargo: ["7M"],
			ember: ["7L1"],
			facade: ["7M"],
			fireblast: ["7M"],
			firefang: ["7L15"],
			firepledge: ["7T"],
			flamecharge: ["7M"],
			flamethrower: ["7M", "7L44"],
			flareblitz: ["7L55"],
			fling: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			furyswipes: ["7L33"],
			gigaimpact: ["7M"],
			growl: ["7L4", "7L1"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			leechlife: ["7M"],
			leer: ["7L11"],
			lick: ["7L8", "7L1"],
			lowsweep: ["7M"],
			outrage: ["7L60"],
			overheat: ["7M"],
			protect: ["7M"],
			quash: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M", "7L19"],
			round: ["7M"],
			scaryface: ["7L49"],
			scratch: ["7L1"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			snarl: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M", "7L28"],
			swordsdance: ["7M"],
			taunt: ["7M"],
			thrash: ["7L38"],
			throatchop: ["7L1"],
			torment: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			willowisp: ["7M"],
			workup: ["7M"],
		},
	},
	popplio: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			amnesia: ["7E"],
			aquajet: ["7L15"],
			aquaring: ["7E"],
			aromaticmist: ["7E"],
			attract: ["7M"],
			babydolleyes: ["7L11"],
			blizzard: ["7M"],
			bubblebeam: ["7L22"],
			captivate: ["7L39"],
			charm: ["7E"],
			confide: ["7M"],
			disarmingvoice: ["7L8"],
			doubleslap: ["7L29"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			encore: ["7L18"],
			facade: ["7M"],
			frustration: ["7M"],
			growl: ["7L4"],
			hail: ["7M"],
			hiddenpower: ["7M"],
			hydropump: ["7L43"],
			hypervoice: ["7L32"],
			icebeam: ["7M"],
			mistyterrain: ["7L46"],
			moonblast: ["7L36"],
			perishsong: ["7E"],
			pound: ["7L1"],
			protect: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			scald: ["7M"],
			sing: ["7L25"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L1"],
			waterpledge: ["7T"],
			wonderroom: ["7E"],
			workup: ["7M"],
		},
	},
	brionne: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			aquajet: ["7L15"],
			attract: ["7M"],
			babydolleyes: ["7L11"],
			blizzard: ["7M"],
			bubblebeam: ["7L24"],
			captivate: ["7L46"],
			confide: ["7M"],
			disarmingvoice: ["7L8", "7L1"],
			doubleslap: ["7L33"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			encore: ["7L19"],
			facade: ["7M"],
			frustration: ["7M"],
			growl: ["7L4", "7L1"],
			hail: ["7M"],
			hiddenpower: ["7M"],
			hydropump: ["7L51"],
			hypervoice: ["7L37"],
			icebeam: ["7M"],
			mistyterrain: ["7L55"],
			moonblast: ["7L42"],
			pound: ["7L1"],
			protect: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			scald: ["7M"],
			sing: ["7L28"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L1"],
			waterpledge: ["7T"],
			workup: ["7M"],
		},
	},
	primarina: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			aquajet: ["7L15"],
			attract: ["7M"],
			babydolleyes: ["7L11"],
			blizzard: ["7M"],
			bubblebeam: ["7L24"],
			captivate: ["7L49"],
			confide: ["7M"],
			dazzlinggleam: ["7M"],
			disarmingvoice: ["7L9", "7L1"],
			doubleslap: ["7L33"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			encore: ["7L19"],
			energyball: ["7M"],
			facade: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			growl: ["7L4", "7L1"],
			hail: ["7M"],
			hiddenpower: ["7M"],
			hydrocannon: ["7T"],
			hydropump: ["7L55"],
			hypervoice: ["7L38"],
			icebeam: ["7M"],
			lightscreen: ["7M"],
			mistyterrain: ["7L60"],
			moonblast: ["7L44"],
			pound: ["7L1"],
			protect: ["7M"],
			psychic: ["7M"],
			psychup: ["7M"],
			raindance: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			scald: ["7M"],
			shadowball: ["7M"],
			sing: ["7L28"],
			sleeptalk: ["7M"],
			sparklingaria: ["7L1"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L1"],
			waterpledge: ["7T"],
			workup: ["7M"],
		},
	},
	pikipek: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			boomburst: ["7E"],
			bravebird: ["7E"],
			brickbreak: ["7M"],
			bulletseed: ["7L31"],
			confide: ["7M"],
			doubleteam: ["7M"],
			drillpeck: ["7L27"],
			echoedvoice: ["7M", "7L7"],
			featherdance: ["7L33"],
			flamecharge: ["7M"],
			fly: ["7M"],
			frustration: ["7M"],
			furyattack: ["7L21"],
			growl: ["7L3"],
			hiddenpower: ["7M"],
			hypervoice: ["7L37"],
			mirrormove: ["7E"],
			peck: ["7L1"],
			pluck: ["7L15"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rocksmash: ["7L9"],
			roost: ["7M", "7L19"],
			round: ["7M"],
			screech: ["7L25"],
			sleeptalk: ["7M"],
			smackdown: ["7M"],
			steelwing: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			supersonic: ["7L13"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tailwind: ["7E"],
			thief: ["7M"],
			toxic: ["7M"],
			uproar: ["7E"],
			uturn: ["7M"],
			workup: ["7M"],
		},
	},
	trumbeak: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			brickbreak: ["7M"],
			bulletseed: ["7L37"],
			confide: ["7M"],
			doubleteam: ["7M"],
			drillpeck: ["7L32"],
			echoedvoice: ["7M", "7L7", "7L1"],
			featherdance: ["7L40"],
			flamecharge: ["7M"],
			fly: ["7M"],
			frustration: ["7M"],
			furyattack: ["7L24"],
			growl: ["7L3", "7L1"],
			hiddenpower: ["7M"],
			hypervoice: ["7L45"],
			peck: ["7L1"],
			pluck: ["7L16"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockblast: ["7L1"],
			rocksmash: ["7L9", "7L1"],
			roost: ["7M", "7L21"],
			round: ["7M"],
			screech: ["7L29"],
			sleeptalk: ["7M"],
			smackdown: ["7M"],
			steelwing: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			supersonic: ["7L13"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			thief: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			workup: ["7M"],
		},
	},
	toucannon: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			beakblast: ["7L1"],
			brickbreak: ["7M"],
			bulletseed: ["7L40"],
			confide: ["7M"],
			doubleteam: ["7M"],
			drillpeck: ["7L34"],
			echoedvoice: ["7M", "7L7", "7L1"],
			featherdance: ["7L44"],
			flamecharge: ["7M"],
			flashcannon: ["7M"],
			fly: ["7M"],
			frustration: ["7M"],
			furyattack: ["7L24"],
			growl: ["7L3", "7L1"],
			hiddenpower: ["7M"],
			hypervoice: ["7L50"],
			overheat: ["7M"],
			peck: ["7L1"],
			pluck: ["7L16"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockblast: ["7L1"],
			rocksmash: ["7L9", "7L1"],
			roost: ["7M", "7L21"],
			round: ["7M"],
			screech: ["7L30"],
			sleeptalk: ["7M"],
			smackdown: ["7M"],
			steelwing: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			supersonic: ["7L13"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			thief: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			workup: ["7M"],
		},
	},
	yungoos: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			bide: ["7L16"],
			bite: ["7L19"],
			confide: ["7M"],
			crunch: ["7L34"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			hyperfang: ["7L37"],
			lastresort: ["7E"],
			leer: ["7L3"],
			mudslap: ["7L22"],
			odorsleuth: ["7L13"],
			payback: ["7M"],
			protect: ["7M"],
			pursuit: ["7L7"],
			rest: ["7M", "7L46"],
			return: ["7M"],
			revenge: ["7E"],
			rocktomb: ["7M"],
			round: ["7M"],
			sandattack: ["7L10"],
			sandstorm: ["7M"],
			scaryface: ["7L31"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			superfang: ["7L25"],
			swagger: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L28"],
			taunt: ["7M"],
			thief: ["7M"],
			thrash: ["7L43"],
			torment: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			workup: ["7M"],
			yawn: ["7L40"],
		},
	},
	gumshoos: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			bide: ["7L16"],
			bite: ["7L19"],
			bulldoze: ["7M"],
			confide: ["7M"],
			crunch: ["7L39"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			hyperfang: ["7L43"],
			leer: ["7L3", "7L1"],
			mudslap: ["7L23"],
			odorsleuth: ["7L13"],
			payback: ["7M"],
			protect: ["7M"],
			pursuit: ["7L7", "7L1"],
			rest: ["7M", "7L55"],
			return: ["7M"],
			roar: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			sandattack: ["7L10", "7L1"],
			sandstorm: ["7M"],
			scaryface: ["7L35"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			superfang: ["7L27"],
			swagger: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L31"],
			taunt: ["7M"],
			thief: ["7M"],
			thrash: ["7L51"],
			torment: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			workup: ["7M"],
			yawn: ["7L47"],
		},
	},
	grubbin: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L19"],
			attract: ["7M"],
			bite: ["7L10"],
			bugbite: ["7L13"],
			chargebeam: ["7M"],
			confide: ["7M"],
			crunch: ["7L22"],
			dig: ["7L28"],
			doubleteam: ["7M"],
			electroweb: ["7E"],
			endure: ["7E"],
			facade: ["7M"],
			frustration: ["7M"],
			harden: ["7E"],
			hiddenpower: ["7M"],
			lightscreen: ["7M"],
			mudshot: ["7E"],
			mudslap: ["7L7"],
			poisonjab: ["7M"],
			protect: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			sleeptalk: ["7M"],
			spark: ["7L16"],
			stringshot: ["7L4"],
			substitute: ["7M"],
			swagger: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			visegrip: ["7L1"],
			voltswitch: ["7M"],
			wildcharge: ["7M"],
			xscissor: ["7M", "7L25"],
		},
	},
	charjabug: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L19"],
			attract: ["7M"],
			bite: ["7L10", "7L1"],
			bugbite: ["7L13"],
			charge: ["7L1"],
			chargebeam: ["7M"],
			confide: ["7M"],
			crunch: ["7L25"],
			dig: ["7L37"],
			discharge: ["7L43"],
			doubleteam: ["7M"],
			facade: ["7M"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			irondefense: ["7L49"],
			lightscreen: ["7M"],
			mudslap: ["7L7", "7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			sleeptalk: ["7M"],
			spark: ["7L16"],
			stringshot: ["7L4", "7L1"],
			substitute: ["7M"],
			swagger: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			visegrip: ["7L1"],
			voltswitch: ["7M"],
			wildcharge: ["7M"],
			xscissor: ["7M", "7L31"],
		},
	},
	vikavolt: {
		inherit: true,
		learnset: {
			acrobatics: ["7M", "7L19"],
			agility: ["7L49"],
			airslash: ["7L1"],
			attract: ["7M"],
			bite: ["7L10", "7L1"],
			bugbite: ["7L13"],
			bugbuzz: ["7L31"],
			charge: ["7L1"],
			chargebeam: ["7M"],
			confide: ["7M"],
			dig: ["7L37"],
			doubleteam: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			flashcannon: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			guillotine: ["7L25"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			lightscreen: ["7M"],
			mudslap: ["7L7", "7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			skydrop: ["7M"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			spark: ["7L16"],
			stringshot: ["7L4", "7L1"],
			substitute: ["7M"],
			swagger: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M", "7L1"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			visegrip: ["7L1"],
			voltswitch: ["7M"],
			wildcharge: ["7M"],
			xscissor: ["7M"],
			zapcannon: ["7L41"],
		},
	},
	crabrawler: {
		inherit: true,
		learnset: {
			amnesia: ["7E"],
			attract: ["7M"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bubble: ["7L1"],
			bubblebeam: ["7L17"],
			bulkup: ["7M"],
			bulldoze: ["7M"],
			closecombat: ["7L49"],
			confide: ["7M"],
			crabhammer: ["7L37"],
			dizzypunch: ["7L25"],
			doubleteam: ["7M"],
			dynamicpunch: ["7L45"],
			earthquake: ["7M"],
			endeavor: ["7E"],
			facade: ["7M"],
			fling: ["7M"],
			focusblast: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			irondefense: ["7L42"],
			leer: ["7L9"],
			payback: ["7M", "7L29"],
			poweruppunch: ["7L22"],
			protect: ["7M"],
			pursuit: ["7L13"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			reversal: ["7L33"],
			rockslide: ["7M"],
			rocksmash: ["7L5"],
			rocktomb: ["7M"],
			round: ["7M"],
			scald: ["7M"],
			sleeptalk: ["7M"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			superpower: ["7E"],
			swagger: ["7M"],
			thief: ["7M"],
			toxic: ["7M"],
			wideguard: ["7E"],
			workup: ["7M"],
		},
	},
	crabominable: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			avalanche: ["7L29"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bubble: ["7L1"],
			bubblebeam: ["7L17"],
			bulkup: ["7M"],
			bulldoze: ["7M"],
			closecombat: ["7L49"],
			confide: ["7M"],
			dizzypunch: ["7L25"],
			doubleteam: ["7M"],
			dynamicpunch: ["7L45"],
			earthquake: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			focusblast: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			hail: ["7M"],
			hiddenpower: ["7M"],
			icebeam: ["7M"],
			icehammer: ["7L37"],
			icepunch: ["7L1"],
			irondefense: ["7L42"],
			leer: ["7L9", "7L1"],
			payback: ["7M"],
			poweruppunch: ["7L22"],
			protect: ["7M"],
			pursuit: ["7L13", "7L1"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			reversal: ["7L33"],
			rockslide: ["7M"],
			rocksmash: ["7L5", "7L1"],
			rocktomb: ["7M"],
			round: ["7M"],
			scald: ["7M"],
			sleeptalk: ["7M"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			thief: ["7M"],
			toxic: ["7M"],
			workup: ["7M"],
		},
	},
	oricorio: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			aerialace: ["7M"],
			agility: ["7L46"],
			aircutter: ["7L13"],
			airslash: ["7L36"],
			attract: ["7M"],
			batonpass: ["7L16"],
			calmmind: ["7M"],
			captivate: ["7L33", "7E"],
			confide: ["7M"],
			doubleslap: ["7L23"],
			doubleteam: ["7M"],
			embargo: ["7M"],
			facade: ["7M"],
			featherdance: ["7L20"],
			fly: ["7M"],
			frustration: ["7M"],
			growl: ["7L4"],
			helpinghand: ["7L10"],
			hiddenpower: ["7M"],
			hurricane: ["7L50"],
			mirrormove: ["7L43"],
			peck: ["7L6"],
			pluck: ["7E"],
			pound: ["7L1"],
			protect: ["7M"],
			quash: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			revelationdance: ["7L40"],
			roost: ["7M", "7L30"],
			round: ["7M"],
			safeguard: ["7M", "7E"],
			sandstorm: ["7M"],
			sleeptalk: ["7M"],
			steelwing: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tailwind: ["7E"],
			taunt: ["7M"],
			teeterdance: ["7L26"],
			toxic: ["7M"],
			uturn: ["7M"],
			workup: ["7M"],
		},
	},
	cutiefly: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			acrobatics: ["7M"],
			aerialace: ["7M"],
			aromatherapy: ["7L36"],
			attract: ["7M"],
			batonpass: ["7E"],
			bestow: ["7E"],
			bugbuzz: ["7L26"],
			calmmind: ["7M"],
			confide: ["7M"],
			dazzlinggleam: ["7M", "7L31"],
			doubleteam: ["7M"],
			drainingkiss: ["7L16"],
			dreameater: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			fairywind: ["7L4"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			infestation: ["7M"],
			leechlife: ["7M"],
			lightscreen: ["7M"],
			moonblast: ["7E"],
			protect: ["7M"],
			psychic: ["7M"],
			psychup: ["7M"],
			quiverdance: ["7L41"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			silverwind: ["7L13"],
			skillswap: ["7E"],
			sleeptalk: ["7M"],
			speedswap: ["7E"],
			strugglebug: ["7L10"],
			stunspore: ["7L7"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			sweetscent: ["7L21"],
			thief: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	ribombee: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			acrobatics: ["7M"],
			aerialace: ["7M"],
			aromatherapy: ["7L42"],
			attract: ["7M"],
			bugbuzz: ["7L28"],
			calmmind: ["7M"],
			confide: ["7M"],
			dazzlinggleam: ["7M", "7L35"],
			doubleteam: ["7M"],
			drainingkiss: ["7L16"],
			dreameater: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			fairywind: ["7L4", "7L1"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			infestation: ["7M"],
			leechlife: ["7M"],
			lightscreen: ["7M"],
			naturepower: ["7M"],
			pollenpuff: ["7L1"],
			protect: ["7M"],
			psychic: ["7M"],
			psychup: ["7M"],
			quiverdance: ["7L49"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			silverwind: ["7L13"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			strugglebug: ["7L10", "7L1"],
			stunspore: ["7L7", "7L1"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			sweetscent: ["7L21"],
			thief: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	rockruff: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			bite: ["7L7"],
			confide: ["7M"],
			crunch: ["7L40"],
			crushclaw: ["7E"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			firefang: ["7E"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			howl: ["7L12"],
			leer: ["7L1"],
			odorsleuth: ["7L18"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M", "7L26"],
			rockclimb: ["7L45"],
			rockpolish: ["7M"],
			rockslide: ["7M", "7L34"],
			rockthrow: ["7L15"],
			rocktomb: ["7M", "7L23"],
			round: ["7M"],
			sandattack: ["7L4"],
			scaryface: ["7L37"],
			sleeptalk: ["7M"],
			snarl: ["7M"],
			stealthrock: ["7L29"],
			stoneedge: ["7M", "7L48"],
			substitute: ["7M"],
			suckerpunch: ["7E"],
			swagger: ["7M"],
			tackle: ["7L1"],
			taunt: ["7M"],
			thrash: ["7E"],
			thunderfang: ["7E"],
			toxic: ["7M"],
		},
	},
	lycanroc: {
		inherit: true,
		learnset: {
			accelerock: ["7L1"],
			attract: ["7M"],
			bite: ["7L7", "7L1"],
			brickbreak: ["7M"],
			bulkup: ["7M"],
			confide: ["7M"],
			crunch: ["7L40"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			howl: ["7L12"],
			leer: ["7L1"],
			odorsleuth: ["7L18"],
			protect: ["7M"],
			quickattack: ["7L1"],
			quickguard: ["7L1"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M", "7L26"],
			rockclimb: ["7L45"],
			rockpolish: ["7M"],
			rockslide: ["7M", "7L34"],
			rockthrow: ["7L15"],
			rocktomb: ["7M", "7L23"],
			round: ["7M"],
			sandattack: ["7L4", "7L1"],
			scaryface: ["7L37"],
			sleeptalk: ["7M"],
			snarl: ["7M"],
			stealthrock: ["7L29"],
			stoneedge: ["7M", "7L48"],
			substitute: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tackle: ["7L1"],
			taunt: ["7M"],
			toxic: ["7M"],
		},
	},
	lycanrocmidnight: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			bite: ["7L7", "7L1"],
			brickbreak: ["7M"],
			bulkup: ["7M"],
			confide: ["7M"],
			counter: ["7L1"],
			crunch: ["7L40"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			firefang: ["7S0"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			howl: ["7L12"],
			leer: ["7L1"],
			odorsleuth: ["7L18"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			reversal: ["7L1"],
			roar: ["7M", "7L26"],
			rockclimb: ["7L45"],
			rockpolish: ["7M"],
			rockslide: ["7M", "7L34"],
			rockthrow: ["7L15"],
			rocktomb: ["7M", "7L23"],
			round: ["7M"],
			sandattack: ["7L4", "7L1"],
			scaryface: ["7L37"],
			sleeptalk: ["7M"],
			snarl: ["7M"],
			stealthrock: ["7L29"],
			stoneedge: ["7M", "7L48", "7S0"],
			substitute: ["7M"],
			suckerpunch: ["7S0"],
			swagger: ["7M"],
			swordsdance: ["7M", "7S0"],
			tackle: ["7L1"],
			taunt: ["7M", "7L1"],
			toxic: ["7M"],
		},
	},
	wishiwashi: {
		inherit: true,
		learnset: {
			aquaring: ["7L17"],
			aquatail: ["7L38"],
			attract: ["7M"],
			beatup: ["7L33"],
			brine: ["7L14"],
			bulldoze: ["7M"],
			confide: ["7M"],
			dive: ["7L30"],
			doubleedge: ["7L41"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			endeavor: ["7L49"],
			facade: ["7M"],
			feintattack: ["7L9"],
			frustration: ["7M"],
			growl: ["7L1"],
			hail: ["7M"],
			helpinghand: ["7L6"],
			hiddenpower: ["7M"],
			hydropump: ["7L54"],
			icebeam: ["7M"],
			mist: ["7E"],
			muddywater: ["7E"],
			protect: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			scald: ["7M"],
			sleeptalk: ["7M"],
			soak: ["7L46"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			takedown: ["7L25"],
			tearfullook: ["7L22"],
			toxic: ["7M"],
			uturn: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L1"],
			waterpulse: ["7E"],
			watersport: ["7E"],
		},
	},
	mareanie: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			bite: ["7L9"],
			blizzard: ["7M"],
			confide: ["7M"],
			doubleteam: ["7M"],
			facade: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			hail: ["7M"],
			haze: ["7E"],
			hiddenpower: ["7M"],
			icebeam: ["7M"],
			infestation: ["7M"],
			liquidation: ["7L49"],
			payback: ["7M"],
			peck: ["7L5"],
			pinmissile: ["7L45"],
			poisonjab: ["7M", "7L37"],
			poisonsting: ["7L1"],
			protect: ["7M"],
			raindance: ["7M"],
			recover: ["7L33"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			scald: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			spikecannon: ["7L29"],
			spitup: ["7E"],
			stockpile: ["7E", "7S0"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			swallow: ["7E", "7S0"],
			toxic: ["7M", "7L21", "7S0"],
			toxicspikes: ["7L13"],
			venomdrench: ["7L41"],
			venoshock: ["7M", "7L25"],
			wideguard: ["7L17"],
		},
	},
	toxapex: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			banefulbunker: ["7L1"],
			bite: ["7L9", "7L1"],
			blizzard: ["7M"],
			confide: ["7M"],
			doubleteam: ["7M"],
			facade: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			hail: ["7M"],
			hiddenpower: ["7M"],
			icebeam: ["7M"],
			infestation: ["7M"],
			lightscreen: ["7M"],
			liquidation: ["7L58"],
			payback: ["7M"],
			peck: ["7L5", "7L1"],
			pinmissile: ["7L51"],
			poisonjab: ["7M", "7L37"],
			poisonsting: ["7L1"],
			protect: ["7M"],
			raindance: ["7M"],
			recover: ["7L33"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			scald: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			smackdown: ["7M"],
			spikecannon: ["7L29"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			toxic: ["7M", "7L21"],
			toxicspikes: ["7L13", "7L1"],
			venomdrench: ["7L44"],
			venoshock: ["7M", "7L25"],
			wideguard: ["7L17"],
		},
	},
	mudbray: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			bide: ["7L22"],
			bodyslam: ["7E"],
			bulldoze: ["7M", "7L10"],
			closecombat: ["7E"],
			confide: ["7M"],
			counter: ["7L36"],
			doubleedge: ["7E"],
			doublekick: ["7L15"],
			doubleteam: ["7M"],
			earthquake: ["7M", "7L38"],
			facade: ["7M"],
			frustration: ["7M"],
			heavyslam: ["7L31"],
			hiddenpower: ["7M"],
			highhorsepower: ["7L24"],
			irondefense: ["7L29"],
			lowsweep: ["7M"],
			magnitude: ["7E"],
			megakick: ["7L43"],
			mudbomb: ["7E"],
			mudslap: ["7L1"],
			mudsport: ["7L3"],
			payback: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			rototiller: ["7L8"],
			round: ["7M"],
			sandstorm: ["7M"],
			sleeptalk: ["7M"],
			stomp: ["7L17"],
			substitute: ["7M"],
			superpower: ["7L45"],
			swagger: ["7M"],
			toxic: ["7M"],
		},
	},
	mudsdale: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			bide: ["7L22"],
			bulldoze: ["7M", "7L10", "7L1"],
			confide: ["7M"],
			counter: ["7L42"],
			doublekick: ["7L15"],
			doubleteam: ["7M"],
			earthquake: ["7M", "7L47"],
			facade: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			heavyslam: ["7L34"],
			hiddenpower: ["7M"],
			highhorsepower: ["7L24"],
			irondefense: ["7L29"],
			lowsweep: ["7M"],
			megakick: ["7L55"],
			mudslap: ["7L1"],
			mudsport: ["7L3", "7L1"],
			payback: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			rototiller: ["7L8", "7L1"],
			round: ["7M"],
			sandstorm: ["7M"],
			sleeptalk: ["7M"],
			stomp: ["7L17"],
			substitute: ["7M"],
			superpower: ["7L60"],
			swagger: ["7M"],
			toxic: ["7M"],
		},
	},
	dewpider: {
		inherit: true,
		learnset: {
			aquaring: ["7L24"],
			attract: ["7M"],
			aurorabeam: ["7E"],
			bite: ["7L21"],
			blizzard: ["7M"],
			bubble: ["7L1"],
			bubblebeam: ["7L16"],
			bugbite: ["7L13"],
			confide: ["7M"],
			crunch: ["7L32"],
			doubleteam: ["7M"],
			entrainment: ["7L48"],
			facade: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			icebeam: ["7M"],
			infestation: ["7M", "7L5"],
			leechlife: ["7M", "7L29"],
			liquidation: ["7L45"],
			lunge: ["7L37"],
			mirrorcoat: ["7L40"],
			poisonjab: ["7M"],
			powersplit: ["7E"],
			protect: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			scald: ["7M"],
			sleeptalk: ["7M"],
			spiderweb: ["7L8"],
			spitup: ["7E"],
			stockpile: ["7E"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watersport: ["7L1"],
			xscissor: ["7M"],
		},
	},
	araquanid: {
		inherit: true,
		learnset: {
			aquaring: ["7L26"],
			attract: ["7M"],
			bite: ["7L21"],
			blizzard: ["7M"],
			bubble: ["7L1"],
			bubblebeam: ["7L16"],
			bugbite: ["7L13", "7L1"],
			confide: ["7M"],
			crunch: ["7L38"],
			doubleteam: ["7M"],
			entrainment: ["7L62"],
			facade: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			icebeam: ["7M"],
			infestation: ["7M", "7L5", "7L1"],
			leechlife: ["7M", "7L33"],
			liquidation: ["7L57"],
			lunge: ["7L45"],
			mirrorcoat: ["7L50"],
			poisonjab: ["7M"],
			protect: ["7M"],
			raindance: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			scald: ["7M"],
			sleeptalk: ["7M"],
			soak: ["7L1"],
			spiderweb: ["7L8", "7L1"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			wideguard: ["7L1"],
			xscissor: ["7M"],
		},
	},
	fomantis: {
		inherit: true,
		learnset: {
			aromatherapy: ["7E"],
			attract: ["7M"],
			confide: ["7M"],
			defog: ["7E"],
			doubleteam: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			furycutter: ["7L1"],
			gigadrain: ["7E"],
			grassknot: ["7M"],
			growth: ["7L14"],
			hiddenpower: ["7M"],
			ingrain: ["7L19"],
			leafage: ["7L5"],
			leafblade: ["7L23"],
			leafstorm: ["7E"],
			leechlife: ["7M"],
			naturepower: ["7M"],
			payback: ["7M"],
			poisonjab: ["7M"],
			protect: ["7M"],
			razorleaf: ["7L10"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			slash: ["7L32"],
			sleeptalk: ["7M"],
			solarbeam: ["7M", "7L41"],
			substitute: ["7M"],
			sunnyday: ["7M", "7L46"],
			swagger: ["7M"],
			sweetscent: ["7L37"],
			swordsdance: ["7M"],
			synthesis: ["7L28"],
			toxic: ["7M"],
			weatherball: ["7E"],
			xscissor: ["7M"],
		},
	},
	lurantis: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			brickbreak: ["7M"],
			confide: ["7M"],
			doubleteam: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			furycutter: ["7L1"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			growth: ["7L14", "7L1"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			ingrain: ["7L19"],
			leafage: ["7L5", "7L1"],
			leafblade: ["7L23"],
			leechlife: ["7M"],
			lowsweep: ["7M"],
			naturepower: ["7M"],
			payback: ["7M"],
			petalblizzard: ["7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			razorleaf: ["7L10", "7L1"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			slash: ["7L32"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			solarblade: ["7L47"],
			substitute: ["7M"],
			sunnyday: ["7M", "7L55"],
			swagger: ["7M"],
			sweetscent: ["7L40"],
			swordsdance: ["7M"],
			synthesis: ["7L28"],
			toxic: ["7M"],
			xscissor: ["7M", "7L1"],
		},
	},
	morelull: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			amnesia: ["7E"],
			astonish: ["7L4"],
			attract: ["7M"],
			confide: ["7M"],
			confuseray: ["7L25"],
			dazzlinggleam: ["7M"],
			doubleteam: ["7M"],
			dreameater: ["7M", "7L43"],
			energyball: ["7M"],
			flash: ["7L8"],
			frustration: ["7M"],
			gigadrain: ["7L29"],
			grassknot: ["7M"],
			growth: ["7E"],
			hiddenpower: ["7M"],
			ingrain: ["7L22"],
			leechseed: ["7E"],
			lightscreen: ["7M"],
			megadrain: ["7L15"],
			moonblast: ["7L39"],
			moonlight: ["7L11"],
			naturepower: ["7M"],
			poisonpowder: ["7E"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sleeppowder: ["7L18"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			spore: ["7L36"],
			spotlight: ["7L46"],
			strengthsap: ["7L32"],
			stunspore: ["7E"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
		},
	},
	shiinotic: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			astonish: ["7L4", "7L1"],
			attract: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			confuseray: ["7L26"],
			dazzlinggleam: ["7M"],
			doubleteam: ["7M"],
			dreameater: ["7M", "7L49"],
			energyball: ["7M"],
			flash: ["7L8", "7L1"],
			frustration: ["7M"],
			gigadrain: ["7L31"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			ingrain: ["7L22", "7L1"],
			lightscreen: ["7M"],
			megadrain: ["7L15"],
			moonblast: ["7L44"],
			moonlight: ["7L11"],
			naturepower: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sleeppowder: ["7L18"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			solarbeam: ["7M"],
			spore: ["7L40"],
			spotlight: ["7L53"],
			strengthsap: ["7L35"],
			substitute: ["7M"],
			swagger: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
		},
	},
	salandit: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			belch: ["7E"],
			confide: ["7M"],
			doubleslap: ["7L21"],
			doubleteam: ["7M"],
			dragonclaw: ["7M"],
			dragonpulse: ["7L48"],
			dragonrage: ["7L13"],
			ember: ["7L5"],
			facade: ["7M"],
			fakeout: ["7E"],
			fireblast: ["7M"],
			flameburst: ["7L24"],
			flamecharge: ["7M"],
			flamethrower: ["7M", "7L40"],
			fling: ["7M"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			knockoff: ["7E"],
			leechlife: ["7M"],
			nastyplot: ["7L32"],
			overheat: ["7M"],
			payback: ["7M"],
			poisongas: ["7L1"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			sandattack: ["7E"],
			scratch: ["7L1"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			smog: ["7L16"],
			snatch: ["7E"],
			substitute: ["7M"],
			swagger: ["7M"],
			sweetscent: ["7L8"],
			taunt: ["7M"],
			thief: ["7M"],
			torment: ["7M"],
			toxic: ["7M", "7L29"],
			venomdrench: ["7L45"],
			venoshock: ["7M", "7L37"],
			willowisp: ["7M"],
		},
	},
	salazzle: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			attract: ["7M"],
			captivate: ["7L1"],
			confide: ["7M"],
			disable: ["7L1"],
			doubleslap: ["7L21"],
			doubleteam: ["7M"],
			dragonclaw: ["7M"],
			dragonpulse: ["7L56"],
			dragonrage: ["7L13"],
			dragontail: ["7M"],
			ember: ["7L5", "7L1"],
			encore: ["7L1"],
			facade: ["7M"],
			fakeout: ["7S0"],
			fireblast: ["7M"],
			flameburst: ["7L24"],
			flamecharge: ["7M"],
			flamethrower: ["7M", "7L44", "7S0"],
			fling: ["7M"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			leechlife: ["7M"],
			nastyplot: ["7L32"],
			overheat: ["7M"],
			payback: ["7M"],
			poisongas: ["7L1"],
			poisonjab: ["7M"],
			pound: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M", "7S0"],
			sludgewave: ["7M"],
			smog: ["7L16"],
			substitute: ["7M"],
			swagger: ["7M", "7L1"],
			sweetscent: ["7L8", "7L1"],
			taunt: ["7M"],
			thief: ["7M"],
			torment: ["7M", "7L1"],
			toxic: ["7M", "7L29", "7S0"],
			venomdrench: ["7L51"],
			venoshock: ["7M", "7L39"],
			willowisp: ["7M"],
		},
	},
	stufful: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			babydolleyes: ["7L10"],
			bide: ["7L5"],
			brickbreak: ["7M"],
			brutalswing: ["7M", "7L14"],
			bulkup: ["7M"],
			bulldoze: ["7M"],
			confide: ["7M"],
			doubleedge: ["7L46"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			endure: ["7E"],
			facade: ["7M"],
			flail: ["7L19"],
			fling: ["7M"],
			focusblast: ["7M"],
			forcepalm: ["7E"],
			frustration: ["7M"],
			hammerarm: ["7L32"],
			hiddenpower: ["7M"],
			icepunch: ["7E"],
			leer: ["7L1"],
			lowsweep: ["7M"],
			megakick: ["7E"],
			painsplit: ["7L41"],
			payback: ["7M", "7L23"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			sleeptalk: ["7M"],
			stompingtantrum: ["7E"],
			substitute: ["7M"],
			superpower: ["7L50"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L28"],
			taunt: ["7M"],
			thrash: ["7L37"],
			thunderpunch: ["7E"],
			toxic: ["7M"],
			wideguard: ["7E"],
			workup: ["7M"],
		},
	},
	bewear: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			babydolleyes: ["7L10", "7S0"],
			bide: ["7L5"],
			bind: ["7L1", "7S0"],
			brickbreak: ["7M"],
			brutalswing: ["7M", "7L14", "7S0"],
			bulkup: ["7M"],
			bulldoze: ["7M"],
			confide: ["7M"],
			doubleedge: ["7L56"],
			doubleteam: ["7M"],
			dragonclaw: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			flail: ["7L19"],
			fling: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			hammerarm: ["7L36"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			leer: ["7L1"],
			lowsweep: ["7M"],
			painsplit: ["7L49"],
			payback: ["7M", "7L23"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			superpower: ["7L62", "7S0"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L30"],
			taunt: ["7M"],
			thrash: ["7L43"],
			toxic: ["7M"],
			workup: ["7M"],
		},
	},
	bounsweet: {
		inherit: true,
		learnset: {
			acupressure: ["7E"],
			aromaticmist: ["7L33"],
			attract: ["7M"],
			charm: ["7E"],
			confide: ["7M"],
			dazzlinggleam: ["7M"],
			doubleteam: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			feint: ["7E"],
			flail: ["7L29"],
			frustration: ["7M"],
			grassknot: ["7M"],
			grasswhistle: ["7E"],
			hiddenpower: ["7M"],
			lightscreen: ["7M"],
			magicalleaf: ["7L21"],
			naturepower: ["7M"],
			playnice: ["7L5"],
			playrough: ["7E"],
			protect: ["7M"],
			rapidspin: ["7L9"],
			razorleaf: ["7L13"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			splash: ["7L1"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			sweetscent: ["7L17"],
			synthesis: ["7E"],
			teeterdance: ["7L25"],
			toxic: ["7M"],
		},
	},
	steenee: {
		inherit: true,
		learnset: {
			aromatherapy: ["7L41"],
			aromaticmist: ["7L33"],
			attract: ["7M"],
			captivate: ["7L37"],
			confide: ["7M"],
			dazzlinggleam: ["7M"],
			doubleslap: ["7L1", "7S0"],
			doubleteam: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			leafstorm: ["7L45"],
			lightscreen: ["7M"],
			lowsweep: ["7M"],
			magicalleaf: ["7L21", "7S0"],
			naturepower: ["7M"],
			payback: ["7M"],
			playnice: ["7L5", "7L1"],
			protect: ["7M"],
			rapidspin: ["7L9", "7L1"],
			razorleaf: ["7L13", "7L1"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			splash: ["7L1"],
			stomp: ["7L29"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			sweetscent: ["7L17", "7S0"],
			teeterdance: ["7L25"],
			toxic: ["7M"],
		},
	},
	tsareena: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			aromatherapy: ["7L41"],
			aromaticmist: ["7L33"],
			attract: ["7M"],
			captivate: ["7L37"],
			confide: ["7M"],
			dazzlinggleam: ["7M"],
			doubleslap: ["7L1"],
			doubleteam: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			highjumpkick: ["7L49"],
			leafstorm: ["7L45"],
			lightscreen: ["7M"],
			lowsweep: ["7M"],
			magicalleaf: ["7L21"],
			naturepower: ["7M"],
			payback: ["7M"],
			protect: ["7M"],
			rapidspin: ["7L9", "7L1"],
			razorleaf: ["7L13", "7L1"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			splash: ["7L1"],
			stomp: ["7L29"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M", "7L5", "7L1"],
			sweetscent: ["7L17"],
			teeterdance: ["7L25"],
			toxic: ["7M"],
			tropkick: ["7L1"],
			uturn: ["7M"],
		},
	},
	comfey: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			afteryou: ["7E"],
			amnesia: ["7E"],
			aromatherapy: ["7L43"],
			attract: ["7M"],
			calmmind: ["7M"],
			celebrate: ["7S0"],
			confide: ["7M"],
			dazzlinggleam: ["7M"],
			doubleteam: ["7M"],
			drainingkiss: ["7L7", "7S0"],
			echoedvoice: ["7M"],
			endure: ["7E"],
			energyball: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			floralhealing: ["7L37"],
			flowershield: ["7L1"],
			frustration: ["7M"],
			grassknot: ["7M", "7L34"],
			grassyterrain: ["7L46"],
			growth: ["7L13"],
			helpinghand: ["7L1"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			leechseed: ["7L4", "7S0"],
			lightscreen: ["7M"],
			luckychant: ["7E"],
			magicalleaf: ["7L10", "7S0"],
			naturalgift: ["7L22"],
			naturepower: ["7M"],
			petalblizzard: ["7L25"],
			petaldance: ["7L40"],
			playrough: ["7L49"],
			protect: ["7M"],
			psychup: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			sweetkiss: ["7L19"],
			sweetscent: ["7L31"],
			synthesis: ["7L28"],
			taunt: ["7M"],
			thief: ["7M"],
			toxic: ["7M"],
			trickroom: ["7M"],
			uturn: ["7M"],
			vinewhip: ["7L1"],
			wrap: ["7L16"],
		},
	},
	oranguru: {
		inherit: true,
		learnset: {
			afteryou: ["7L4"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulldoze: ["7M"],
			calmmind: ["7M", "7L39"],
			chargebeam: ["7M"],
			confide: ["7M"],
			confusion: ["7L1"],
			doubleteam: ["7M"],
			dreameater: ["7M"],
			earthquake: ["7M"],
			embargo: ["7M"],
			energyball: ["7M"],
			extrasensory: ["7E"],
			facade: ["7M"],
			feintattack: ["7L22"],
			fling: ["7M"],
			focusblast: ["7M"],
			foulplay: ["7L36"],
			frustration: ["7M"],
			futuresight: ["7L46"],
			gigaimpact: ["7M"],
			hiddenpower: ["7M"],
			instruct: ["7L32", "7S0"],
			lightscreen: ["7M"],
			nastyplot: ["7L25"],
			naturepower: ["7M"],
			payback: ["7M"],
			protect: ["7M"],
			psychic: ["7M", "7L43", "7S0"],
			psychicterrain: ["7E", "7S0"],
			psychup: ["7M", "7L18"],
			psyshock: ["7M"],
			quash: ["7M", "7L11"],
			raindance: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockslide: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			shadowball: ["7M"],
			sleeptalk: ["7M"],
			storedpower: ["7L15"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			taunt: ["7M", "7L8"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			toxic: ["7M"],
			trickroom: ["7M", "7L50"],
			wonderroom: ["7E"],
			workup: ["7M"],
			zenheadbutt: ["7L29"],
		},
	},
	passimian: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			aerialace: ["7M"],
			attract: ["7M"],
			beatup: ["7L15"],
			bestow: ["7L25", "7S0"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulkup: ["7M", "7L32"],
			bulldoze: ["7M"],
			closecombat: ["7L43"],
			confide: ["7M"],
			doubleedge: ["7L36"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			feint: ["7E", "7S0"],
			fling: ["7M", "7L39", "7S0"],
			focusblast: ["7M"],
			focusenergy: ["7L11"],
			frustration: ["7M"],
			gigaimpact: ["7M", "7L50"],
			grassknot: ["7M"],
			gyroball: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			ironhead: ["7E"],
			leer: ["7L4"],
			lowsweep: ["7M"],
			payback: ["7M"],
			protect: ["7M"],
			quickattack: ["7E"],
			quickguard: ["7E"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			reversal: ["7L46"],
			rockslide: ["7M"],
			rocksmash: ["7L8"],
			rocktomb: ["7M"],
			round: ["7M"],
			scaryface: ["7L18"],
			seismictoss: ["7E"],
			shadowball: ["7M"],
			sleeptalk: ["7M"],
			smackdown: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L22"],
			taunt: ["7M"],
			thief: ["7M"],
			thrash: ["7L29"],
			toxic: ["7M"],
			uturn: ["7M"],
			vitalthrow: ["7E"],
			workup: ["7M"],
		},
	},
	wimpod: {
		inherit: true,
		learnset: {
			aquajet: ["7E"],
			attract: ["7M"],
			confide: ["7M"],
			doubleteam: ["7M"],
			facade: ["7M"],
			frustration: ["7M"],
			hail: ["7M"],
			harden: ["7E"],
			hiddenpower: ["7M"],
			leechlife: ["7M"],
			metalclaw: ["7E"],
			protect: ["7M"],
			raindance: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			sandattack: ["7L1"],
			scald: ["7M"],
			sleeptalk: ["7M"],
			spikes: ["7E"],
			strugglebug: ["7L1"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			taunt: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			wideguard: ["7E"],
		},
	},
	golisopod: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			blizzard: ["7M"],
			brickbreak: ["7M"],
			bugbite: ["7L10"],
			bulkup: ["7M"],
			confide: ["7M"],
			darkpulse: ["7M"],
			doubleteam: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			firstimpression: ["7L1"],
			fling: ["7M"],
			focusblast: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			furycutter: ["7L4", "7L1"],
			gigaimpact: ["7M"],
			hail: ["7M"],
			hiddenpower: ["7M"],
			icebeam: ["7M"],
			irondefense: ["7L36"],
			leechlife: ["7M"],
			liquidation: ["7L48"],
			payback: ["7M"],
			pinmissile: ["7L41"],
			poisonjab: ["7M"],
			protect: ["7M"],
			psychup: ["7M"],
			raindance: ["7M"],
			razorshell: ["7L26"],
			rest: ["7M"],
			return: ["7M"],
			rockslide: ["7M"],
			rocksmash: ["7L7", "7L1"],
			rocktomb: ["7M"],
			round: ["7M"],
			sandattack: ["7L1"],
			scald: ["7M"],
			shadowclaw: ["7M"],
			slash: ["7L21"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			snarl: ["7M"],
			spite: ["7L13"],
			strugglebug: ["7L1"],
			substitute: ["7M"],
			suckerpunch: ["7L31"],
			surf: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M", "7L16"],
			taunt: ["7M"],
			toxic: ["7M"],
			venoshock: ["7M"],
			waterfall: ["7M"],
			xscissor: ["7M"],
		},
	},
	sandygast: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			amnesia: ["7E"],
			ancientpower: ["7E"],
			astonish: ["7L5"],
			attract: ["7M"],
			bulldoze: ["7M", "7L23"],
			confide: ["7M"],
			destinybond: ["7E"],
			doubleteam: ["7M"],
			earthpower: ["7L45"],
			earthquake: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			frustration: ["7M"],
			gigadrain: ["7L36"],
			harden: ["7L1"],
			hiddenpower: ["7M"],
			hypnosis: ["7L27"],
			infestation: ["7M"],
			irondefense: ["7L32"],
			megadrain: ["7L18"],
			protect: ["7M"],
			psychic: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockpolish: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			sandattack: ["7L9"],
			sandstorm: ["7M", "7L54"],
			sandtomb: ["7L14"],
			shadowball: ["7M", "7L41"],
			shoreup: ["7L50"],
			sleeptalk: ["7M"],
			spitup: ["7E"],
			stockpile: ["7E"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			swallow: ["7E"],
			toxic: ["7M"],
		},
	},
	palossand: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			astonish: ["7L5", "7L1"],
			attract: ["7M"],
			bulldoze: ["7M", "7L23"],
			confide: ["7M"],
			doubleteam: ["7M"],
			earthpower: ["7L47"],
			earthquake: ["7M"],
			embargo: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			gigadrain: ["7L36"],
			gigaimpact: ["7M"],
			harden: ["7L1"],
			hiddenpower: ["7M"],
			hypnosis: ["7L27"],
			infestation: ["7M"],
			irondefense: ["7L32"],
			megadrain: ["7L18"],
			protect: ["7M"],
			psychic: ["7M"],
			quash: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockpolish: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			sandattack: ["7L9", "7L1"],
			sandstorm: ["7M", "7L60"],
			sandtomb: ["7L14"],
			shadowball: ["7M", "7L41"],
			shoreup: ["7L54"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			toxic: ["7M"],
		},
	},
	pyukumuku: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			batonpass: ["7L1"],
			bestow: ["7E"],
			bide: ["7L1"],
			confide: ["7M"],
			counter: ["7L17"],
			curse: ["7L25"],
			doubleteam: ["7M"],
			endure: ["7E"],
			gastroacid: ["7L29"],
			hail: ["7M"],
			harden: ["7L1"],
			helpinghand: ["7L5"],
			lightscreen: ["7M"],
			memento: ["7L49"],
			mudsport: ["7L1"],
			painsplit: ["7L33"],
			protect: ["7M"],
			psychup: ["7M"],
			purify: ["7L21"],
			quash: ["7M"],
			raindance: ["7M"],
			recover: ["7L37"],
			reflect: ["7M"],
			rest: ["7M"],
			safeguard: ["7M", "7L13"],
			sleeptalk: ["7M"],
			soak: ["7L41"],
			substitute: ["7M"],
			swagger: ["7M"],
			taunt: ["7M", "7L9"],
			tickle: ["7E"],
			toxic: ["7M", "7L45"],
			venomdrench: ["7E"],
			watersport: ["7L1"],
		},
	},
	typenull: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L20"],
			airslash: ["7L60"],
			confide: ["7M"],
			crushclaw: ["7L25", "7S0"],
			doubleedge: ["7L80"],
			doublehit: ["7L55"],
			doubleteam: ["7M"],
			dragonclaw: ["7M"],
			facade: ["7M"],
			flamecharge: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			hail: ["7M"],
			healblock: ["7L85"],
			hiddenpower: ["7M"],
			imprison: ["7L15"],
			ironhead: ["7L50"],
			metalsound: ["7L45"],
			payback: ["7M"],
			protect: ["7M"],
			punishment: ["7L65"],
			pursuit: ["7L10"],
			rage: ["7L5"],
			raindance: ["7M"],
			razorwind: ["7L70"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockslide: ["7M"],
			round: ["7M"],
			sandstorm: ["7M"],
			scaryface: ["7L30", "7S0"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L40", "7S0"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7L75"],
			uturn: ["7M"],
			workup: ["7M"],
			xscissor: ["7M", "7L35", "7S0"],
		},
	},
	silvally: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L20"],
			airslash: ["7L60"],
			bite: ["7L15"],
			confide: ["7M"],
			crunch: ["7L50"],
			crushclaw: ["7L25"],
			doubleedge: ["7L80"],
			doublehit: ["7L55"],
			doubleteam: ["7M"],
			dracometeor: ["7T"],
			dragonclaw: ["7M"],
			explosion: ["7M"],
			facade: ["7M"],
			firefang: ["7L1"],
			flamecharge: ["7M"],
			flamethrower: ["7M"],
			flashcannon: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			hail: ["7M"],
			healblock: ["7L1"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			icefang: ["7L1"],
			imprison: ["7L1"],
			ironhead: ["7L1"],
			metalsound: ["7L45"],
			multiattack: ["7L1", "7S0"],
			partingshot: ["7L85", "7S0"],
			payback: ["7M"],
			poisonfang: ["7L1"],
			protect: ["7M"],
			punishment: ["7L65", "7S0"],
			pursuit: ["7L10"],
			rage: ["7L5"],
			raindance: ["7M"],
			razorwind: ["7L70"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockslide: ["7M"],
			round: ["7M"],
			sandstorm: ["7M"],
			scaryface: ["7L30", "7S0"],
			shadowball: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			snarl: ["7M"],
			steelwing: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tackle: ["7L1"],
			takedown: ["7L40"],
			thunderbolt: ["7M"],
			thunderfang: ["7L1"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			triattack: ["7L75"],
			uturn: ["7M"],
			workup: ["7M"],
			xscissor: ["7M", "7L35"],
		},
	},
	minior: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			ancientpower: ["7L17"],
			attract: ["7M"],
			autotomize: ["7L31"],
			bulldoze: ["7M"],
			calmmind: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			confuseray: ["7L10"],
			cosmicpower: ["7L36"],
			dazzlinggleam: ["7M"],
			defensecurl: ["7L3"],
			doubleedge: ["7L43"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			explosion: ["7M", "7L50"],
			facade: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			gyroball: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			lightscreen: ["7M"],
			powergem: ["7L38"],
			protect: ["7M"],
			psychic: ["7M"],
			psychup: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockpolish: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			rollout: ["7L8"],
			round: ["7M"],
			safeguard: ["7M"],
			sandstorm: ["7M"],
			selfdestruct: ["7L22"],
			shellsmash: ["7L45"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			stealthrock: ["7L24"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			swift: ["7L15"],
			tackle: ["7L1"],
			takedown: ["7L29"],
			toxic: ["7M"],
			uturn: ["7M"],
		},
	},
	komala: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			attract: ["7M"],
			brickbreak: ["7M"],
			bulkup: ["7M"],
			bulldoze: ["7M"],
			calmmind: ["7M"],
			charm: ["7E"],
			confide: ["7M"],
			defensecurl: ["7L1"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			flail: ["7L26"],
			frustration: ["7M"],
			hiddenpower: ["7M"],
			lowsweep: ["7M"],
			payback: ["7M"],
			playrough: ["7E"],
			protect: ["7M"],
			psychup: ["7M", "7L36"],
			quash: ["7M"],
			rapidspin: ["7L11"],
			return: ["7M"],
			rockslide: ["7M"],
			rollout: ["7L1"],
			round: ["7M"],
			shadowclaw: ["7M"],
			sing: ["7E"],
			slam: ["7L21"],
			sleeptalk: ["7M"],
			spitup: ["7L6"],
			stockpile: ["7L6"],
			substitute: ["7M"],
			suckerpunch: ["7L31"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			swallow: ["7L6"],
			swordsdance: ["7M"],
			thrash: ["7L46"],
			toxic: ["7M"],
			uturn: ["7M"],
			wish: ["7E"],
			woodhammer: ["7L41"],
			workup: ["7M"],
			yawn: ["7L16"],
		},
	},
	turtonator: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			bodyslam: ["7L33", "7S0"],
			brutalswing: ["7M"],
			bulkup: ["7M"],
			bulldoze: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			doubleteam: ["7M"],
			dracometeor: ["7T"],
			dragonclaw: ["7M"],
			dragonpulse: ["7L41"],
			dragontail: ["7M", "7S1"],
			earthquake: ["7M"],
			ember: ["7L1"],
			endure: ["7L21"],
			explosion: ["7M", "7L53"],
			facade: ["7M"],
			fireblast: ["7M"],
			firespin: ["7E"],
			flail: ["7L17"],
			flamecharge: ["7M"],
			flamethrower: ["7M", "7L29", "7S0", "7S1"],
			flashcannon: ["7M"],
			fling: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			headsmash: ["7E"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			incinerate: ["7L13"],
			irondefense: ["7L25"],
			overheat: ["7M", "7L49"],
			payback: ["7M"],
			protect: ["7M", "7L9"],
			rest: ["7M"],
			return: ["7M"],
			revenge: ["7E"],
			roar: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			shellsmash: ["7L37"],
			shelltrap: ["7L45", "7S1"],
			sleeptalk: ["7M"],
			smackdown: ["7M"],
			smog: ["7L5"],
			solarbeam: ["7M"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			tackle: ["7L1"],
			taunt: ["7M"],
			toxic: ["7M"],
			venoshock: ["7M"],
			wideguard: ["7E", "7S0"],
			willowisp: ["7M"],
			workup: ["7M"],
		},
	},
	togedemaru: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			charge: ["7L13"],
			chargebeam: ["7M"],
			confide: ["7M"],
			defensecurl: ["7L5"],
			disarmingvoice: ["7E"],
			discharge: ["7L29"],
			doubleteam: ["7M"],
			electricterrain: ["7L37"],
			encore: ["7E"],
			facade: ["7M"],
			fakeout: ["7E"],
			fellstinger: ["7L53"],
			flail: ["7E"],
			fling: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			gyroball: ["7M"],
			hiddenpower: ["7M"],
			magnetrise: ["7L25"],
			nuzzle: ["7L21"],
			payback: ["7M"],
			pinmissile: ["7L45"],
			poisonjab: ["7M"],
			present: ["7E"],
			protect: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			reversal: ["7E"],
			rollout: ["7L9"],
			round: ["7M"],
			sleeptalk: ["7M"],
			spark: ["7L17"],
			spikyshield: ["7L49"],
			substitute: ["7M"],
			swagger: ["7M"],
			tackle: ["7L1"],
			thief: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thundershock: ["7L1"],
			thunderwave: ["7M"],
			tickle: ["7E"],
			toxic: ["7M"],
			twineedle: ["7E"],
			uturn: ["7M"],
			voltswitch: ["7M"],
			wildcharge: ["7M", "7L41"],
			wish: ["7E"],
			workup: ["7M"],
			zingzap: ["7L33"],
		},
	},
	mimikyu: {
		inherit: true,
		learnset: {
			astonish: ["7L1", "7S0", "7S1"],
			attract: ["7M"],
			babydolleyes: ["7L10", "7S0"],
			bulkup: ["7M"],
			chargebeam: ["7M"],
			charm: ["7L28"],
			confide: ["7M"],
			copycat: ["7L1", "7S0", "7S1"],
			curse: ["7E"],
			darkpulse: ["7M"],
			dazzlinggleam: ["7M"],
			destinybond: ["7E"],
			doubleteam: ["7M", "7L5"],
			dreameater: ["7M"],
			embargo: ["7M"],
			facade: ["7M"],
			feintattack: ["7L23"],
			fling: ["7M"],
			frustration: ["7M"],
			grudge: ["7E"],
			hiddenpower: ["7M"],
			honeclaws: ["7L41"],
			hyperbeam: ["7M"],
			infestation: ["7M"],
			leechlife: ["7M"],
			lightscreen: ["7M"],
			mimic: ["7L19"],
			nightmare: ["7E"],
			painsplit: ["7L50"],
			payback: ["7M"],
			playrough: ["7L46", "7S1"],
			protect: ["7M"],
			psychic: ["7M"],
			psychup: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			scratch: ["7L1"],
			shadowball: ["7M"],
			shadowclaw: ["7M", "7L37"],
			shadowsneak: ["7L14"],
			slash: ["7L32"],
			sleeptalk: ["7M"],
			splash: ["7L1", "7S0"],
			substitute: ["7M", "7S1"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			taunt: ["7M"],
			thief: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			trickroom: ["7M"],
			willowisp: ["7M"],
			woodhammer: ["7L1"],
			workup: ["7M"],
			xscissor: ["7M"],
		},
	},
	bruxish: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			aquajet: ["7L17"],
			aquatail: ["7L33"],
			astonish: ["7L4"],
			attract: ["7M"],
			bite: ["7L12"],
			blizzard: ["7M"],
			bulkup: ["7M"],
			calmmind: ["7M"],
			confide: ["7M"],
			confusion: ["7L9"],
			crunch: ["7L28"],
			disable: ["7L20"],
			doubleteam: ["7M"],
			dreameater: ["7M"],
			embargo: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			frostbreath: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			hiddenpower: ["7M"],
			icebeam: ["7M"],
			icefang: ["7E"],
			lightscreen: ["7M"],
			payback: ["7M"],
			poisonfang: ["7E"],
			protect: ["7M"],
			psychic: ["7M"],
			psychicfangs: ["7L41"],
			psywave: ["7L25"],
			rage: ["7E"],
			raindance: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			scald: ["7M"],
			screech: ["7L36"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			synchronoise: ["7L44"],
			taunt: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			trickroom: ["7M"],
			venoshock: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L1"],
			waterpulse: ["7E"],
		},
	},
	drampa: {
		inherit: true,
		learnset: {
			attract: ["7M"],
			blizzard: ["7M"],
			bulldoze: ["7M"],
			calmmind: ["7M"],
			confide: ["7M"],
			doubleteam: ["7M"],
			dracometeor: ["7T"],
			dragonbreath: ["7L29"],
			dragonclaw: ["7M"],
			dragonpulse: ["7L41"],
			dragonrage: ["7L21"],
			dragonrush: ["7E"],
			dragontail: ["7M"],
			earthquake: ["7M"],
			echoedvoice: ["7M", "7L1", "7S0"],
			energyball: ["7M"],
			extrasensory: ["7L37"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			fling: ["7M"],
			fly: ["7M", "7L45"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			glare: ["7L13"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			hurricane: ["7E", "7S0"],
			hyperbeam: ["7M"],
			hypervoice: ["7L49"],
			icebeam: ["7M"],
			lightscreen: ["7M", "7L17"],
			mist: ["7E"],
			naturalgift: ["7L25"],
			naturepower: ["7M"],
			outrage: ["7L53"],
			playnice: ["7L1", "7S0"],
			playrough: ["7E"],
			protect: ["7M", "7L9"],
			psychup: ["7M"],
			raindance: ["7M"],
			razorwind: ["7E"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockslide: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			safeguard: ["7M", "7L33"],
			shadowball: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			snarl: ["7M"],
			solarbeam: ["7M"],
			steelwing: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			surf: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			twister: ["7L5"],
			workup: ["7M"],
		},
	},
	dhelmise: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			aerialace: ["7M"],
			anchorshot: ["7L32"],
			astonish: ["7L1"],
			attract: ["7M"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulldoze: ["7M"],
			confide: ["7M"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			embargo: ["7M"],
			energyball: ["7M", "7L41"],
			facade: ["7M"],
			flashcannon: ["7M"],
			frustration: ["7M"],
			gigadrain: ["7L23"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			growth: ["7L1"],
			gyroball: ["7M", "7L14"],
			heavyslam: ["7L50"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			megadrain: ["7L5"],
			metalsound: ["7L18"],
			payback: ["7M"],
			phantomforce: ["7L54"],
			powerwhip: ["7L59"],
			protect: ["7M"],
			raindance: ["7M"],
			rapidspin: ["7L1"],
			rest: ["7M"],
			return: ["7M"],
			rockslide: ["7M"],
			round: ["7M"],
			shadowball: ["7M", "7L36"],
			shadowclaw: ["7M"],
			slam: ["7L45"],
			sleeptalk: ["7M"],
			sludgewave: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			switcheroo: ["7L1"],
			swordsdance: ["7M"],
			thief: ["7M"],
			toxic: ["7M"],
			whirlpool: ["7L27"],
			wrap: ["7L9"],
		},
	},
	jangmoo: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			bide: ["7L9"],
			brickbreak: ["7M"],
			bulkup: ["7M"],
			bulldoze: ["7M"],
			confide: ["7M"],
			counter: ["7E"],
			doubleteam: ["7M"],
			dracometeor: ["7T"],
			dragonbreath: ["7E"],
			dragonclaw: ["7M", "7L41"],
			dragondance: ["7L49"],
			dragontail: ["7M", "7L17"],
			earthquake: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			headbutt: ["7L25"],
			hiddenpower: ["7M"],
			irondefense: ["7L37"],
			leer: ["7L5"],
			nobleroar: ["7L45"],
			outrage: ["7L53"],
			payback: ["7M"],
			protect: ["7M", "7L13"],
			rest: ["7M"],
			return: ["7M"],
			reversal: ["7E"],
			roar: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sandstorm: ["7M"],
			scaryface: ["7L21"],
			screech: ["7L33"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tackle: ["7L1"],
			taunt: ["7M"],
			toxic: ["7M"],
			workup: ["7M", "7L29"],
			xscissor: ["7M"],
		},
	},
	hakamoo: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			autotomize: ["7L1"],
			bide: ["7L9", "7L1"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulkup: ["7M"],
			bulldoze: ["7M"],
			confide: ["7M"],
			doubleteam: ["7M"],
			dracometeor: ["7T"],
			dragonclaw: ["7M", "7L43"],
			dragondance: ["7L53"],
			dragontail: ["7M", "7L17"],
			earthquake: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			fling: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			headbutt: ["7L25"],
			hiddenpower: ["7M"],
			irondefense: ["7L38"],
			leer: ["7L5", "7L1"],
			nobleroar: ["7L48"],
			outrage: ["7L58"],
			payback: ["7M"],
			protect: ["7M", "7L13", "7L1"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sandstorm: ["7M"],
			scaryface: ["7L21"],
			screech: ["7L33"],
			shadowclaw: ["7M"],
			skyuppercut: ["7L1"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tackle: ["7L1"],
			taunt: ["7M"],
			toxic: ["7M"],
			workup: ["7M", "7L29"],
			xscissor: ["7M"],
		},
	},
	kommoo: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			attract: ["7M"],
			autotomize: ["7L1"],
			bellydrum: ["7L1"],
			bide: ["7L9", "7L1"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulkup: ["7M"],
			bulldoze: ["7M"],
			clangingscales: ["7L1"],
			confide: ["7M"],
			doubleteam: ["7M"],
			dracometeor: ["7T"],
			dragonclaw: ["7M", "7L43"],
			dragondance: ["7L59"],
			dragontail: ["7M", "7L17"],
			earthquake: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			flamethrower: ["7M"],
			flashcannon: ["7M"],
			fling: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			headbutt: ["7L25"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			irondefense: ["7L38"],
			leer: ["7L5", "7L1"],
			nobleroar: ["7L51"],
			outrage: ["7L67"],
			payback: ["7M"],
			poisonjab: ["7M"],
			protect: ["7M", "7L13", "7L1"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockpolish: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sandstorm: ["7M"],
			scaryface: ["7L21"],
			screech: ["7L33"],
			shadowclaw: ["7M"],
			skyuppercut: ["7L1"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			tackle: ["7L1"],
			taunt: ["7M"],
			toxic: ["7M"],
			workup: ["7M", "7L29"],
			xscissor: ["7M"],
		},
	},
	tapukoko: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			aerialace: ["7M"],
			agility: ["7L53", "7S0", "7S1"],
			bravebird: ["7L1"],
			calmmind: ["7M"],
			charge: ["7L26"],
			confide: ["7M"],
			dazzlinggleam: ["7M"],
			discharge: ["7L48", "7S0", "7S1"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			electricterrain: ["7L1"],
			electroball: ["7L58", "7S0", "7S1"],
			facade: ["7M"],
			falseswipe: ["7M", "7L1"],
			fly: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			lightscreen: ["7M"],
			meanlook: ["7L1"],
			mirrormove: ["7L38"],
			naturepower: ["7M"],
			naturesmadness: ["7L43", "7S0", "7S1"],
			powerswap: ["7L1"],
			protect: ["7M"],
			psychup: ["7M"],
			quickattack: ["7L1"],
			raindance: ["7M"],
			reflect: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			screech: ["7L20"],
			shockwave: ["7L14"],
			skydrop: ["7M"],
			sleeptalk: ["7M"],
			spark: ["7L8"],
			steelwing: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			taunt: ["7M"],
			thief: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thundershock: ["7L1"],
			thunderwave: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			uturn: ["7M"],
			voltswitch: ["7M"],
			wildcharge: ["7M", "7L32"],
			withdraw: ["7L1"],
			workup: ["7M"],
		},
	},
	tapulele: {
		inherit: true,
		learnset: {
			aromatherapy: ["7L1"],
			aromaticmist: ["7L1"],
			astonish: ["7L1"],
			calmmind: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			confusion: ["7L1"],
			dazzlinggleam: ["7M"],
			doubleteam: ["7M"],
			drainingkiss: ["7L1"],
			echoedvoice: ["7M"],
			energyball: ["7M"],
			extrasensory: ["7L48", "7S0"],
			facade: ["7M"],
			flatter: ["7L53", "7S0"],
			fling: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			lightscreen: ["7M"],
			meanlook: ["7L1"],
			moonblast: ["7L58", "7S0"],
			naturepower: ["7M"],
			naturesmadness: ["7L43", "7S0"],
			protect: ["7M"],
			psybeam: ["7L14"],
			psychic: ["7M"],
			psychicterrain: ["7L1"],
			psychup: ["7M"],
			psyshock: ["7M", "7L32"],
			psywave: ["7L8"],
			reflect: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			shadowball: ["7M"],
			skillswap: ["7L26"],
			sleeptalk: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			sweetscent: ["7L20"],
			taunt: ["7M"],
			thief: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			tickle: ["7L38"],
			torment: ["7M"],
			toxic: ["7M"],
			withdraw: ["7L1"],
		},
	},
	tapubulu: {
		inherit: true,
		learnset: {
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulkup: ["7M"],
			calmmind: ["7M"],
			confide: ["7M"],
			dazzlinggleam: ["7M"],
			disable: ["7L1"],
			echoedvoice: ["7M"],
			energyball: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			fling: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigadrain: ["7L14"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			grassyterrain: ["7L1"],
			hiddenpower: ["7M"],
			hornattack: ["7L8"],
			hornleech: ["7L32"],
			hyperbeam: ["7M"],
			leafage: ["7L1"],
			leechseed: ["7L26"],
			lightscreen: ["7M"],
			meanlook: ["7L1"],
			megahorn: ["7L53", "7S0"],
			naturepower: ["7M"],
			naturesmadness: ["7L43", "7S0"],
			payback: ["7M"],
			protect: ["7M"],
			psychup: ["7M"],
			reflect: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			rototiller: ["7L38"],
			round: ["7M"],
			safeguard: ["7M"],
			scaryface: ["7L20"],
			skullbash: ["7L58", "7S0"],
			sleeptalk: ["7M"],
			smartstrike: ["7M"],
			snarl: ["7M"],
			solarbeam: ["7M"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			superpower: ["7L1"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			taunt: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			whirlwind: ["7L1"],
			withdraw: ["7L1"],
			woodhammer: ["7L1"],
			workup: ["7M"],
			zenheadbutt: ["7L48", "7S0"],
		},
	},
	tapufini: {
		inherit: true,
		learnset: {
			aquaring: ["7L53", "7S0"],
			blizzard: ["7M"],
			brine: ["7L32"],
			calmmind: ["7M"],
			confide: ["7M"],
			dazzlinggleam: ["7M"],
			defog: ["7L38"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			haze: ["7L1"],
			healpulse: ["7L1"],
			hiddenpower: ["7M"],
			hydropump: ["7L58", "7S0"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			lightscreen: ["7M"],
			meanlook: ["7L1"],
			mist: ["7L1"],
			mistyterrain: ["7L1"],
			moonblast: ["7L1"],
			muddywater: ["7L48", "7S0"],
			naturepower: ["7M"],
			naturesmadness: ["7L43", "7S0"],
			protect: ["7M"],
			psychup: ["7M"],
			raindance: ["7M"],
			reflect: ["7M"],
			refresh: ["7L26"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			scald: ["7M"],
			shadowball: ["7M"],
			sleeptalk: ["7M"],
			smartstrike: ["7M"],
			soak: ["7L20"],
			substitute: ["7M"],
			surf: ["7M"],
			swagger: ["7M"],
			taunt: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			waterfall: ["7M"],
			watergun: ["7L1"],
			waterpulse: ["7L8"],
			whirlpool: ["7L14"],
			withdraw: ["7L1"],
		},
	},
	cosmog: {
		inherit: true,
		learnset: {
			splash: ["7L1", "7S0"],
			teleport: ["7L23"],
		},
	},
	cosmoem: {
		inherit: true,
		learnset: {
			cosmicpower: ["7L1"],
			teleport: ["7L1"],
		},
	},
	solgaleo: {
		inherit: true,
		learnset: {
			bulldoze: ["7M"],
			calmmind: ["7M"],
			confide: ["7M"],
			cosmicpower: ["7L1", "7S0"],
			crunch: ["7L37", "7S0"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamecharge: ["7M"],
			flamethrower: ["7M"],
			flareblitz: ["7L61"],
			flashcannon: ["7M", "7L23"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M", "7L73"],
			gyroball: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			ironhead: ["7L7"],
			lightscreen: ["7M"],
			metalburst: ["7L43"],
			metalclaw: ["7L1"],
			metalsound: ["7L13"],
			morningsun: ["7L31"],
			nobleroar: ["7L59"],
			protect: ["7M"],
			psychic: ["7M"],
			psychup: ["7M"],
			psyshock: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			sleeptalk: ["7M"],
			snarl: ["7M"],
			solarbeam: ["7M", "7L47"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			sunsteelstrike: ["7L1", "7S0"],
			swagger: ["7M"],
			teleport: ["7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			trickroom: ["7M"],
			wakeupslap: ["7L1"],
			wideguard: ["7L67"],
			wildcharge: ["7M"],
			workup: ["7M"],
			zenheadbutt: ["7L19", "7S0"],
		},
	},
	lunala: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			aerialace: ["7M"],
			airslash: ["7L19"],
			blizzard: ["7M"],
			calmmind: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			confuseray: ["7L13"],
			confusion: ["7L1"],
			cosmicpower: ["7L1", "7S0"],
			dazzlinggleam: ["7M"],
			doubleteam: ["7M"],
			dreameater: ["7M", "7L59"],
			facade: ["7M"],
			fly: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M", "7L73"],
			hypnosis: ["7L1"],
			icebeam: ["7M"],
			lightscreen: ["7M"],
			magiccoat: ["7L43"],
			moonblast: ["7L47"],
			moongeistbeam: ["7L1", "7S0"],
			moonlight: ["7L31"],
			nightdaze: ["7L37", "7S0"],
			nightshade: ["7L7"],
			phantomforce: ["7L61"],
			protect: ["7M"],
			psychic: ["7M"],
			psychup: ["7M"],
			psyshock: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			roar: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			safeguard: ["7M"],
			shadowball: ["7M", "7L23", "7S0"],
			shadowclaw: ["7M"],
			skydrop: ["7M"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			teleport: ["7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			trickroom: ["7M"],
			wideguard: ["7L67"],
			willowisp: ["7M"],
			workup: ["7M"],
		},
	},
	nihilego: {
		inherit: true,
		learnset: {
			acid: ["7L1"],
			acidspray: ["7L47", "7S0"],
			brutalswing: ["7M"],
			chargebeam: ["7M"],
			clearsmog: ["7L7"],
			confide: ["7M"],
			constrict: ["7L1"],
			dazzlinggleam: ["7M"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			frustration: ["7M"],
			grassknot: ["7M"],
			guardsplit: ["7L1"],
			headbutt: ["7L19"],
			headsmash: ["7L73"],
			hiddenpower: ["7M"],
			lightscreen: ["7M"],
			mirrorcoat: ["7L43", "7S0"],
			poisonjab: ["7M"],
			pound: ["7L1"],
			powergem: ["7L37", "7S0"],
			powersplit: ["7L1"],
			protect: ["7M"],
			psychic: ["7M"],
			psyshock: ["7M"],
			psywave: ["7L13"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			safeguard: ["7M", "7L31"],
			sandstorm: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			stealthrock: ["7L59"],
			substitute: ["7M"],
			swagger: ["7M"],
			thunder: ["7M"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			tickle: ["7L1"],
			toxic: ["7M"],
			toxicspikes: ["7L29"],
			trickroom: ["7M"],
			venomdrench: ["7L53", "7S0"],
			venoshock: ["7M", "7L23"],
			wonderroom: ["7L67"],
		},
	},
	buzzwole: {
		inherit: true,
		learnset: {
			brickbreak: ["7M"],
			bulkup: ["7M", "7L13"],
			bulldoze: ["7M"],
			cometpunch: ["7L7"],
			confide: ["7M"],
			counter: ["7L43", "7S0"],
			doubleteam: ["7M"],
			dynamicpunch: ["7L59", "7S0"],
			earthquake: ["7M"],
			endure: ["7L23"],
			facade: ["7M"],
			falseswipe: ["7M"],
			fellstinger: ["7L1"],
			fling: ["7M"],
			focusenergy: ["7L1"],
			focuspunch: ["7L73"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			gyroball: ["7M"],
			hammerarm: ["7L47", "7S0"],
			harden: ["7L1"],
			hiddenpower: ["7M"],
			icepunch: ["7L1"],
			leechlife: ["7M", "7L29"],
			lowsweep: ["7M"],
			lunge: ["7L53", "7S0"],
			megapunch: ["7L37"],
			payback: ["7M"],
			poisonjab: ["7M"],
			poweruppunch: ["7L1"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			reversal: ["7L1"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			sleeptalk: ["7M"],
			smackdown: ["7M"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			superpower: ["7L67"],
			swagger: ["7M"],
			taunt: ["7M", "7L31"],
			thunderpunch: ["7L1"],
			toxic: ["7M"],
			vitalthrow: ["7L19"],
			workup: ["7M"],
		},
	},
	pheromosa: {
		inherit: true,
		learnset: {
			agility: ["7L37"],
			blizzard: ["7M"],
			bounce: ["7L29"],
			brickbreak: ["7M"],
			bugbuzz: ["7L53", "7S0"],
			confide: ["7M"],
			doublekick: ["7L1"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			facade: ["7M"],
			falseswipe: ["7M"],
			feint: ["7L19"],
			fling: ["7M"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			hiddenpower: ["7M"],
			highjumpkick: ["7L67"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			jumpkick: ["7L31"],
			leer: ["7L1"],
			lowkick: ["7L1"],
			lowsweep: ["7M"],
			lunge: ["7L47", "7S0"],
			mefirst: ["7L59", "7S0"],
			poisonjab: ["7M"],
			protect: ["7M"],
			quickguard: ["7L1"],
			quiverdance: ["7L1"],
			rapidspin: ["7L1"],
			rest: ["7M"],
			return: ["7M"],
			roost: ["7M"],
			round: ["7M"],
			silverwind: ["7L23"],
			sleeptalk: ["7M"],
			speedswap: ["7L73"],
			stomp: ["7L13"],
			substitute: ["7M"],
			swagger: ["7M"],
			swift: ["7L7"],
			taunt: ["7M"],
			torment: ["7M"],
			toxic: ["7M"],
			triplekick: ["7L43", "7S0"],
			uturn: ["7M"],
		},
	},
	xurkitree: {
		inherit: true,
		learnset: {
			brutalswing: ["7M"],
			calmmind: ["7M"],
			charge: ["7L1"],
			chargebeam: ["7M"],
			confide: ["7M"],
			dazzlinggleam: ["7M"],
			discharge: ["7L47", "7S0"],
			doubleteam: ["7M"],
			eerieimpulse: ["7L29"],
			electricterrain: ["7L53", "7S0"],
			energyball: ["7M"],
			facade: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			hypnosis: ["7L43", "7S0"],
			ingrain: ["7L19"],
			iondeluge: ["7L67"],
			lightscreen: ["7M"],
			naturepower: ["7M"],
			powerwhip: ["7L59", "7S0"],
			protect: ["7M"],
			raindance: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			shockwave: ["7L13"],
			signalbeam: ["7L31"],
			sleeptalk: ["7M"],
			solarbeam: ["7M"],
			spark: ["7L1"],
			substitute: ["7M"],
			sunnyday: ["7M"],
			swagger: ["7M"],
			tailglow: ["7L1"],
			thunder: ["7M"],
			thunderbolt: ["7M", "7L37"],
			thunderpunch: ["7L23"],
			thundershock: ["7L1"],
			thunderwave: ["7M", "7L7"],
			toxic: ["7M"],
			voltswitch: ["7M"],
			wildcharge: ["7M"],
			wrap: ["7L1"],
			zapcannon: ["7L73"],
		},
	},
	celesteela: {
		inherit: true,
		learnset: {
			absorb: ["7L1"],
			acrobatics: ["7M"],
			airslash: ["7L1"],
			autotomize: ["7L43", "7S0"],
			brutalswing: ["7M"],
			bulldoze: ["7M"],
			confide: ["7M"],
			doubleedge: ["7L73"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			energyball: ["7M"],
			explosion: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamecharge: ["7M"],
			flamethrower: ["7M"],
			flashcannon: ["7M", "7L37"],
			fly: ["7M"],
			frustration: ["7M"],
			gigadrain: ["7L31"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			gyroball: ["7M"],
			harden: ["7L1"],
			heavyslam: ["7L67"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			ingrain: ["7L1"],
			irondefense: ["7L59", "7S0"],
			ironhead: ["7L29"],
			leechseed: ["7L19"],
			megadrain: ["7L13"],
			metalsound: ["7L23"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockslide: ["7M"],
			round: ["7M"],
			seedbomb: ["7L47", "7S0"],
			skullbash: ["7L53", "7S0"],
			sleeptalk: ["7M"],
			smackdown: ["7M", "7L7"],
			smartstrike: ["7M"],
			solarbeam: ["7M"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			tackle: ["7L1"],
			toxic: ["7M"],
			wideguard: ["7L1"],
		},
	},
	kartana: {
		inherit: true,
		learnset: {
			aerialace: ["7M", "7L23"],
			aircutter: ["7L1"],
			airslash: ["7L59", "7S0"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			confide: ["7M"],
			cut: ["7L1"],
			defog: ["7L1"],
			detect: ["7L53", "7S0"],
			doubleteam: ["7M"],
			falseswipe: ["7M", "7L7"],
			frustration: ["7M"],
			furycutter: ["7L1"],
			gigaimpact: ["7M"],
			guillotine: ["7L73"],
			hiddenpower: ["7M"],
			laserfocus: ["7L29"],
			leafblade: ["7L43", "7S0"],
			nightslash: ["7L31"],
			protect: ["7M"],
			psychocut: ["7L67"],
			razorleaf: ["7L13"],
			rest: ["7M"],
			return: ["7M"],
			round: ["7M"],
			sacredsword: ["7L1"],
			sleeptalk: ["7M"],
			smartstrike: ["7M"],
			substitute: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M", "7L37"],
			synthesis: ["7L19"],
			toxic: ["7M"],
			vacuumwave: ["7L1"],
			xscissor: ["7M", "7L47", "7S0"],
		},
	},
	guzzlord: {
		inherit: true,
		learnset: {
			belch: ["7L1"],
			bite: ["7L1"],
			brickbreak: ["7M"],
			brutalswing: ["7M", "7L13"],
			bulldoze: ["7M"],
			crunch: ["7L37"],
			darkpulse: ["7M"],
			doubleteam: ["7M"],
			dracometeor: ["7T"],
			dragonclaw: ["7M"],
			dragonrage: ["7L1"],
			dragonrush: ["7L73"],
			dragontail: ["7M", "7L23"],
			earthquake: ["7M"],
			facade: ["7M"],
			fireblast: ["7M"],
			flamethrower: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			gastroacid: ["7L53", "7S0"],
			gigaimpact: ["7M"],
			gyroball: ["7M"],
			hammerarm: ["7L43"],
			heavyslam: ["7L59", "7S0"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			irontail: ["7L29"],
			payback: ["7M"],
			poisonjab: ["7M"],
			protect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			shadowclaw: ["7M"],
			sleeptalk: ["7M"],
			sludgebomb: ["7M"],
			sludgewave: ["7M"],
			smackdown: ["7M"],
			snarl: ["7M"],
			steamroller: ["7L19"],
			stockpile: ["7L1"],
			stomp: ["7L7"],
			stompingtantrum: ["7L31"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			swallow: ["7L1"],
			thief: ["7M"],
			thrash: ["7L47", "7S0"],
			toxic: ["7M"],
			wideguard: ["7L1"],
			wringout: ["7L67", "7S0"],
		},
	},
	necrozma: {
		inherit: true,
		learnset: {
			aerialace: ["7M"],
			autotomize: ["7L47"],
			brickbreak: ["7M"],
			brutalswing: ["7M"],
			bulldoze: ["7M"],
			calmmind: ["7M"],
			chargebeam: ["7M", "7L1"],
			confide: ["7M"],
			confusion: ["7L1"],
			darkpulse: ["7M"],
			doubleteam: ["7M"],
			earthquake: ["7M"],
			embargo: ["7M"],
			facade: ["7M"],
			flashcannon: ["7M"],
			fling: ["7M"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			gravity: ["7L31"],
			gyroball: ["7M"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			irondefense: ["7L59", "7S0"],
			lightscreen: ["7M"],
			metalclaw: ["7L1"],
			mirrorshot: ["7L1"],
			moonlight: ["7L1"],
			morningsun: ["7L1"],
			nightslash: ["7L23"],
			powergem: ["7L43"],
			prismaticlaser: ["7L73", "7S0"],
			protect: ["7M"],
			psychic: ["7M"],
			psychocut: ["7L37"],
			psyshock: ["7M"],
			reflect: ["7M"],
			rest: ["7M"],
			return: ["7M"],
			rockblast: ["7L19"],
			rockpolish: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			round: ["7M"],
			shadowclaw: ["7M"],
			slash: ["7L7"],
			sleeptalk: ["7M"],
			smartstrike: ["7M"],
			solarbeam: ["7M"],
			stealthrock: ["7L53", "7S0"],
			stoneedge: ["7M"],
			storedpower: ["7L13"],
			substitute: ["7M"],
			swagger: ["7M"],
			swordsdance: ["7M"],
			thief: ["7M"],
			thunderwave: ["7M"],
			toxic: ["7M"],
			trickroom: ["7M"],
			wringout: ["7L67", "7S0"],
			xscissor: ["7M"],
		},
	},
	magearna: {
		inherit: true,
		learnset: {
			aurasphere: ["7L81"],
			aurorabeam: ["7L17"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			craftyshield: ["7L1"],
			dazzlinggleam: ["7M"],
			defensecurl: ["7L1"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			embargo: ["7M"],
			energyball: ["7M"],
			explosion: ["7M"],
			falseswipe: ["7M"],
			flashcannon: ["7M", "7L41", "7S0"],
			fleurcannon: ["7L49", "7S0"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gearup: ["7L1"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			gyroball: ["7M"],
			heartswap: ["7L89"],
			helpinghand: ["7L1", "7S0"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			irondefense: ["7L57"],
			ironhead: ["7L1"],
			lightscreen: ["7M"],
			luckychant: ["7L9", "7S0"],
			mindreader: ["7L33"],
			mirrorshot: ["7L25"],
			painsplit: ["7L65"],
			protect: ["7M"],
			psybeam: ["7L1"],
			reflect: ["7M"],
			return: ["7M"],
			round: ["7M"],
			shadowball: ["7M"],
			shiftgear: ["7L1"],
			solarbeam: ["7M"],
			sonicboom: ["7L1"],
			substitute: ["7M"],
			swagger: ["7M"],
			synchronoise: ["7L73"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			trickroom: ["7M"],
			trumpcard: ["7L97"],
			voltswitch: ["7M"],
		},
	},
	magearnaoriginal: {
		inherit: true,
		learnset: {
			aurasphere: ["7L81"],
			aurorabeam: ["7L17"],
			brickbreak: ["7M"],
			calmmind: ["7M"],
			chargebeam: ["7M"],
			confide: ["7M"],
			craftyshield: ["7L1"],
			dazzlinggleam: ["7M"],
			defensecurl: ["7L1"],
			doubleteam: ["7M"],
			echoedvoice: ["7M"],
			embargo: ["7M"],
			energyball: ["7M"],
			explosion: ["7M"],
			falseswipe: ["7M"],
			flashcannon: ["7M", "7L41"],
			fleurcannon: ["7L49"],
			focusblast: ["7M"],
			frustration: ["7M"],
			gearup: ["7L1"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			gyroball: ["7M"],
			heartswap: ["7L89"],
			helpinghand: ["7L1"],
			hiddenpower: ["7M"],
			hyperbeam: ["7M"],
			icebeam: ["7M"],
			irondefense: ["7L57"],
			ironhead: ["7L1"],
			lightscreen: ["7M"],
			luckychant: ["7L9"],
			mindreader: ["7L33"],
			mirrorshot: ["7L25"],
			painsplit: ["7L65"],
			protect: ["7M"],
			psybeam: ["7L1"],
			reflect: ["7M"],
			return: ["7M"],
			round: ["7M"],
			shadowball: ["7M"],
			shiftgear: ["7L1"],
			solarbeam: ["7M"],
			sonicboom: ["7L1"],
			substitute: ["7M"],
			swagger: ["7M"],
			synchronoise: ["7L73"],
			thunderbolt: ["7M"],
			thunderwave: ["7M"],
			trickroom: ["7M"],
			trumpcard: ["7L97"],
			voltswitch: ["7M"],
		},
	},
	marshadow: {
		inherit: true,
		learnset: {
			acrobatics: ["7M"],
			assurance: ["7L1"],
			brickbreak: ["7M"],
			bulkup: ["7M"],
			calmmind: ["7M"],
			closecombat: ["7L50", "7S0"],
			confide: ["7M"],
			copycat: ["7L20"],
			counter: ["7L1"],
			doubleteam: ["7M"],
			drainpunch: ["7L1"],
			echoedvoice: ["7M"],
			endeavor: ["7L60"],
			facade: ["7M"],
			falseswipe: ["7M"],
			feint: ["7L11"],
			firepunch: ["7L1"],
			fling: ["7M"],
			focusblast: ["7M"],
			forcepalm: ["7L5", "7S0"],
			frustration: ["7M"],
			gigaimpact: ["7M"],
			grassknot: ["7M"],
			hiddenpower: ["7M"],
			icepunch: ["7L1"],
			jumpkick: ["7L35"],
			laserfocus: ["7L1"],
			lowsweep: ["7M"],
			payback: ["7M"],
			poisonjab: ["7M"],
			protect: ["7M"],
			psychup: ["7M", "7L41"],
			pursuit: ["7L1"],
			rest: ["7M"],
			return: ["7M"],
			rockslide: ["7M"],
			rocktomb: ["7M"],
			roleplay: ["7L30"],
			rollingkick: ["7L15"],
			round: ["7M"],
			shadowball: ["7M", "7S0"],
			shadowclaw: ["7M"],
			shadowpunch: ["7L26"],
			shadowsneak: ["7L1"],
			sleeptalk: ["7M"],
			smackdown: ["7M"],
			spectralthief: ["7L45", "7S0"],
			stoneedge: ["7M"],
			substitute: ["7M"],
			suckerpunch: ["7L56"],
			swagger: ["7M"],
			thief: ["7M"],
			thunderpunch: ["7L1"],
			toxic: ["7M"],
			willowisp: ["7M"],
			workup: ["7M"],
		},
	},
};
